/* Reconstructed from admin.zip:public/site/build/assets/site-CrkVCFaY.js
 * Original SHA-256: d0d198a70ab45a6be9293f5adcb32f0df300d566100678cb67a546bbbc6e25de
 * Surviving compiled logic, formatted and relinked. Original templates/comments/names are not recovered.
 */
var e = class e extends Error {
    constructor(t, n) {
      var r = `KaTeX parse error: ` + t,
        i,
        a,
        o = n && n.loc;
      if (o && o.start <= o.end) {
        var s = o.lexer.input;
        ((i = o.start),
          (a = o.end),
          i === s.length ? (r += ` at end of input: `) : (r += ` at position ` + (i + 1) + `: `));
        var c = s.slice(i, a).replace(/[^]/g, `$&̲`),
          l = i > 15 ? `…` + s.slice(i - 15, i) : s.slice(0, i),
          u = a + 15 < s.length ? s.slice(a, a + 15) + `…` : s.slice(a);
        r += l + c + u;
      }
      (super(r),
        (this.name = `ParseError`),
        (this.position = void 0),
        (this.length = void 0),
        (this.rawMessage = void 0),
        Object.setPrototypeOf(this, e.prototype),
        (this.position = i),
        i != null && a != null && (this.length = a - i),
        (this.rawMessage = t));
    }
  },
  t = /([A-Z])/g,
  n = (e) => e.replace(t, `-$1`).toLowerCase(),
  r = {
    "&": `&amp;`,
    ">": `&gt;`,
    "<": `&lt;`,
    '"': `&quot;`,
    "'": `&#x27;`,
  },
  i = /[&><"']/g,
  a = (e) => String(e).replace(i, (e) => r[e]),
  o = (e) =>
    e.type === `ordgroup` || e.type === `color`
      ? e.body.length === 1
        ? o(e.body[0])
        : e
      : e.type === `font`
        ? o(e.body)
        : e,
  s = new Set([`mathord`, `textord`, `atom`]),
  c = (e) => s.has(o(e).type),
  l = (e) => {
    var t = /^[\x00-\x20]*([^\\/#?]*?)(:|&#0*58|&#x0*3a|&colon)/i.exec(e);
    return t
      ? t[2] !== `:` || !/^[a-zA-Z][a-zA-Z0-9+\-.]*$/.test(t[1])
        ? null
        : t[1].toLowerCase()
      : `_relative`;
  },
  u = {
    displayMode: {
      type: `boolean`,
      description: `Render math in display mode, which puts the math in display style (so \\int and \\sum are large, for example), and centers the math on the page on its own line.`,
      cli: `-d, --display-mode`,
    },
    output: {
      type: {
        enum: [`htmlAndMathml`, `html`, `mathml`],
      },
      description: `Determines the markup language of the output.`,
      cli: `-F, --format <type>`,
    },
    leqno: {
      type: `boolean`,
      description: `Render display math in leqno style (left-justified tags).`,
    },
    fleqn: {
      type: `boolean`,
      description: `Render display math flush left.`,
    },
    throwOnError: {
      type: `boolean`,
      default: !0,
      cli: `-t, --no-throw-on-error`,
      cliDescription: `Render errors (in the color given by --error-color) instead of throwing a ParseError exception when encountering an error.`,
    },
    errorColor: {
      type: `string`,
      default: `#cc0000`,
      cli: `-c, --error-color <color>`,
      cliDescription: `A color string given in the format 'rgb' or 'rrggbb' (no #). This option determines the color of errors rendered by the -t option.`,
      cliProcessor: (e) => `#` + e,
    },
    macros: {
      type: `object`,
      cli: `-m, --macro <def>`,
      cliDescription: `Define custom macro of the form '\\foo:expansion' (use multiple -m arguments for multiple macros).`,
      cliDefault: [],
      cliProcessor: (e, t) => (t.push(e), t),
    },
    minRuleThickness: {
      type: `number`,
      description:
        "Specifies a minimum thickness, in ems, for fraction lines, `\\sqrt` top lines, `{array}` vertical lines, `\\hline`, `\\hdashline`, `\\underline`, `\\overline`, and the borders of `\\fbox`, `\\boxed`, and `\\fcolorbox`.",
      processor: (e) => Math.max(0, e),
      cli: `--min-rule-thickness <size>`,
      cliProcessor: parseFloat,
    },
    colorIsTextColor: {
      type: `boolean`,
      description: `Makes \\color behave like LaTeX's 2-argument \\textcolor, instead of LaTeX's one-argument \\color mode change.`,
      cli: `-b, --color-is-text-color`,
    },
    strict: {
      type: [
        {
          enum: [`warn`, `ignore`, `error`],
        },
        `boolean`,
        `function`,
      ],
      description: `Turn on strict / LaTeX faithfulness mode, which throws an error if the input uses features that are not supported by LaTeX.`,
      cli: `-S, --strict`,
      cliDefault: !1,
    },
    trust: {
      type: [`boolean`, `function`],
      description: `Trust the input, enabling all HTML features such as \\url.`,
      cli: `-T, --trust`,
    },
    maxSize: {
      type: `number`,
      default: 1 / 0,
      description: `If non-zero, all user-specified sizes, e.g. in \\rule{500em}{500em}, will be capped to maxSize ems. Otherwise, elements and spaces can be arbitrarily large`,
      processor: (e) => Math.max(0, e),
      cli: `-s, --max-size <n>`,
      cliProcessor: parseInt,
    },
    maxExpand: {
      type: `number`,
      default: 1e3,
      description: `Limit the number of macro expansions to the specified number, to prevent e.g. infinite macro loops. If set to Infinity, the macro expander will try to fully expand as in LaTeX.`,
      processor: (e) => Math.max(0, e),
      cli: `-e, --max-expand <n>`,
      cliProcessor: (e) => (e === `Infinity` ? 1 / 0 : parseInt(e)),
    },
    globalGroup: {
      type: `boolean`,
      cli: !1,
    },
  };
function d(e) {
  if (typeof e != `string`) return e.enum[0];
  switch (e) {
    case `boolean`:
      return !1;
    case `string`:
      return ``;
    case `number`:
      return 0;
    case `object`:
      return {};
    default:
      throw Error(`Unexpected schema type; settings must declare an explicit default.`);
  }
}
function f(e) {
  return e.default === void 0 ? d(Array.isArray(e.type) ? e.type[0] : e.type) : e.default;
}
function p(e, t, n, r) {
  var i = n[t];
  e[t] = i === void 0 ? f(r) : r.processor ? r.processor(i) : i;
}
var m = class {
    constructor(e) {
      (e === void 0 && (e = {}),
        (this.displayMode = void 0),
        (this.output = void 0),
        (this.leqno = void 0),
        (this.fleqn = void 0),
        (this.throwOnError = void 0),
        (this.errorColor = void 0),
        (this.macros = void 0),
        (this.minRuleThickness = void 0),
        (this.colorIsTextColor = void 0),
        (this.strict = void 0),
        (this.trust = void 0),
        (this.maxSize = void 0),
        (this.maxExpand = void 0),
        (this.globalGroup = void 0),
        (e ||= {}));
      for (var t of Object.keys(u)) {
        var n = u[t];
        n && p(this, t, e, n);
      }
    }
    reportNonstrict(t, n, r) {
      var i = this.strict;
      if ((typeof i == `function` && (i = i(t, n, r)), !(!i || i === `ignore`))) {
        if (i === !0 || i === `error`)
          throw new e(
            `LaTeX-incompatible input and strict mode is set to 'error': ` + (n + ` [` + t + `]`),
            r,
          );
        i === `warn`
          ? typeof console < `u` &&
            console.warn(
              `LaTeX-incompatible input and strict mode is set to 'warn': ` + (n + ` [` + t + `]`),
            )
          : typeof console < `u` &&
            console.warn(
              `LaTeX-incompatible input and strict mode is set to ` +
                (`unrecognized '` + i + `': ` + n + ` [` + t + `]`),
            );
      }
    }
    useStrictBehavior(e, t, n) {
      var r = this.strict;
      if (typeof r == `function`)
        try {
          r = r(e, t, n);
        } catch {
          r = `error`;
        }
      return !r || r === `ignore`
        ? !1
        : r === !0 || r === `error`
          ? !0
          : r === `warn`
            ? (typeof console < `u` &&
                console.warn(
                  `LaTeX-incompatible input and strict mode is set to 'warn': ` +
                    (t + ` [` + e + `]`),
                ),
              !1)
            : (typeof console < `u` &&
                console.warn(
                  `LaTeX-incompatible input and strict mode is set to ` +
                    (`unrecognized '` + r + `': ` + t + ` [` + e + `]`),
                ),
              !1);
    }
    isTrusted(e) {
      if (`url` in e && e.url && !e.protocol) {
        var t = l(e.url);
        if (t == null) return !1;
        e.protocol = t;
      }
      return !!(typeof this.trust == `function` ? this.trust(e) : this.trust);
    }
  },
  h = class {
    constructor(e, t, n) {
      ((this.id = void 0),
        (this.size = void 0),
        (this.cramped = void 0),
        (this.id = e),
        (this.size = t),
        (this.cramped = n));
    }
    sup() {
      return w[ee[this.id]];
    }
    sub() {
      return w[T[this.id]];
    }
    fracNum() {
      return w[te[this.id]];
    }
    fracDen() {
      return w[ne[this.id]];
    }
    cramp() {
      return w[re[this.id]];
    }
    text() {
      return w[ie[this.id]];
    }
    isTight() {
      return this.size >= 2;
    }
  },
  g = 0,
  _ = 1,
  v = 2,
  y = 3,
  b = 4,
  x = 5,
  S = 6,
  C = 7,
  w = [
    new h(g, 0, !1),
    new h(_, 0, !0),
    new h(v, 1, !1),
    new h(y, 1, !0),
    new h(b, 2, !1),
    new h(x, 2, !0),
    new h(S, 3, !1),
    new h(C, 3, !0),
  ],
  ee = [b, x, b, x, S, C, S, C],
  T = [x, x, x, x, C, C, C, C],
  te = [v, y, b, x, S, C, S, C],
  ne = [y, y, x, x, C, C, C, C],
  re = [_, _, y, y, x, x, C, C],
  ie = [g, _, v, y, v, y, v, y],
  E = {
    DISPLAY: w[g],
    TEXT: w[v],
    SCRIPT: w[b],
    SCRIPTSCRIPT: w[S],
  },
  ae = [
    {
      name: `latin`,
      blocks: [
        [256, 591],
        [768, 879],
      ],
    },
    {
      name: `cyrillic`,
      blocks: [[1024, 1279]],
    },
    {
      name: `armenian`,
      blocks: [[1328, 1423]],
    },
    {
      name: `brahmic`,
      blocks: [[2304, 4255]],
    },
    {
      name: `georgian`,
      blocks: [[4256, 4351]],
    },
    {
      name: `cjk`,
      blocks: [
        [12288, 12543],
        [19968, 40879],
        [65280, 65376],
      ],
    },
    {
      name: `hangul`,
      blocks: [[44032, 55215]],
    },
  ];
function oe(e) {
  for (var t = 0; t < ae.length; t++)
    for (var n = ae[t], r = 0; r < n.blocks.length; r++) {
      var i = n.blocks[r];
      if (e >= i[0] && e <= i[1]) return n.name;
    }
  return null;
}
var se = [];
ae.forEach((e) => e.blocks.forEach((e) => se.push(...e)));
function ce(e) {
  for (var t = 0; t < se.length; t += 2) if (e >= se[t] && e <= se[t + 1]) return !0;
  return !1;
}
var D = (e) => e + ` ` + e,
  le = 80,
  ue = function (e, t) {
    return (
      `M95,` +
      (622 + e + t) +
      `
c-2.7,0,-7.17,-2.7,-13.5,-8c-5.8,-5.3,-9.5,-10,-9.5,-14
c0,-2,0.3,-3.3,1,-4c1.3,-2.7,23.83,-20.7,67.5,-54
c44.2,-33.3,65.8,-50.3,66.5,-51c1.3,-1.3,3,-2,5,-2c4.7,0,8.7,3.3,12,10
s173,378,173,378c0.7,0,35.3,-71,104,-213c68.7,-142,137.5,-285,206.5,-429
c69,-144,104.5,-217.7,106.5,-221
l` +
      e / 2.075 +
      ` -` +
      e +
      `
c5.3,-9.3,12,-14,20,-14
H400000v` +
      (40 + e) +
      `H845.2724
s-225.272,467,-225.272,467s-235,486,-235,486c-2.7,4.7,-9,7,-19,7
c-6,0,-10,-1,-12,-3s-194,-422,-194,-422s-65,47,-65,47z
M` +
      (834 + e) +
      ` ` +
      t +
      `h400000v` +
      (40 + e) +
      `h-400000z`
    );
  },
  de = function (e, t) {
    return (
      `M263,` +
      (601 + e + t) +
      `c0.7,0,18,39.7,52,119
c34,79.3,68.167,158.7,102.5,238c34.3,79.3,51.8,119.3,52.5,120
c340,-704.7,510.7,-1060.3,512,-1067
l` +
      e / 2.084 +
      ` -` +
      e +
      `
c4.7,-7.3,11,-11,19,-11
H40000v` +
      (40 + e) +
      `H1012.3
s-271.3,567,-271.3,567c-38.7,80.7,-84,175,-136,283c-52,108,-89.167,185.3,-111.5,232
c-22.3,46.7,-33.8,70.3,-34.5,71c-4.7,4.7,-12.3,7,-23,7s-12,-1,-12,-1
s-109,-253,-109,-253c-72.7,-168,-109.3,-252,-110,-252c-10.7,8,-22,16.7,-34,26
c-22,17.3,-33.3,26,-34,26s-26,-26,-26,-26s76,-59,76,-59s76,-60,76,-60z
M` +
      (1001 + e) +
      ` ` +
      t +
      `h400000v` +
      (40 + e) +
      `h-400000z`
    );
  },
  fe = function (e, t) {
    return (
      `M983 ` +
      (10 + e + t) +
      `
l` +
      e / 3.13 +
      ` -` +
      e +
      `
c4,-6.7,10,-10,18,-10 H400000v` +
      (40 + e) +
      `
H1013.1s-83.4,268,-264.1,840c-180.7,572,-277,876.3,-289,913c-4.7,4.7,-12.7,7,-24,7
s-12,0,-12,0c-1.3,-3.3,-3.7,-11.7,-7,-25c-35.3,-125.3,-106.7,-373.3,-214,-744
c-10,12,-21,25,-33,39s-32,39,-32,39c-6,-5.3,-15,-14,-27,-26s25,-30,25,-30
c26.7,-32.7,52,-63,76,-91s52,-60,52,-60s208,722,208,722
c56,-175.3,126.3,-397.3,211,-666c84.7,-268.7,153.8,-488.2,207.5,-658.5
c53.7,-170.3,84.5,-266.8,92.5,-289.5z
M` +
      (1001 + e) +
      ` ` +
      t +
      `h400000v` +
      (40 + e) +
      `h-400000z`
    );
  },
  pe = function (e, t) {
    return (
      `M424,` +
      (2398 + e + t) +
      `
c-1.3,-0.7,-38.5,-172,-111.5,-514c-73,-342,-109.8,-513.3,-110.5,-514
c0,-2,-10.7,14.3,-32,49c-4.7,7.3,-9.8,15.7,-15.5,25c-5.7,9.3,-9.8,16,-12.5,20
s-5,7,-5,7c-4,-3.3,-8.3,-7.7,-13,-13s-13,-13,-13,-13s76,-122,76,-122s77,-121,77,-121
s209,968,209,968c0,-2,84.7,-361.7,254,-1079c169.3,-717.3,254.7,-1077.7,256,-1081
l` +
      e / 4.223 +
      ` -` +
      e +
      `c4,-6.7,10,-10,18,-10 H400000
v` +
      (40 + e) +
      `H1014.6
s-87.3,378.7,-272.6,1166c-185.3,787.3,-279.3,1182.3,-282,1185
c-2,6,-10,9,-24,9
c-8,0,-12,-0.7,-12,-2z M` +
      (1001 + e) +
      ` ` +
      t +
      `
h400000v` +
      (40 + e) +
      `h-400000z`
    );
  },
  O = function (e, t) {
    return (
      `M473,` +
      (2713 + e + t) +
      `
c339.3,-1799.3,509.3,-2700,510,-2702 l` +
      e / 5.298 +
      ` -` +
      e +
      `
c3.3,-7.3,9.3,-11,18,-11 H400000v` +
      (40 + e) +
      `H1017.7
s-90.5,478,-276.2,1466c-185.7,988,-279.5,1483,-281.5,1485c-2,6,-10,9,-24,9
c-8,0,-12,-0.7,-12,-2c0,-1.3,-5.3,-32,-16,-92c-50.7,-293.3,-119.7,-693.3,-207,-1200
c0,-1.3,-5.3,8.7,-16,30c-10.7,21.3,-21.3,42.7,-32,64s-16,33,-16,33s-26,-26,-26,-26
s76,-153,76,-153s77,-151,77,-151c0.7,0.7,35.7,202,105,604c67.3,400.7,102,602.7,104,
606zM` +
      (1001 + e) +
      ` ` +
      t +
      `h400000v` +
      (40 + e) +
      `H1017.7z`
    );
  },
  me = function (e) {
    var t = e / 2;
    return `M400000 ` + e + ` H0 L` + t + ` 0 l65 45 L145 ` + (e - 80) + ` H400000z`;
  },
  he = function (e, t, n) {
    var r = n - 54 - t - e;
    return (
      `M702 ` +
      (e + t) +
      `H400000` +
      (40 + e) +
      `
H742v` +
      r +
      `l-4 4-4 4c-.667.7 -2 1.5-4 2.5s-4.167 1.833-6.5 2.5-5.5 1-9.5 1
h-12l-28-84c-16.667-52-96.667 -294.333-240-727l-212 -643 -85 170
c-4-3.333-8.333-7.667-13 -13l-13-13l77-155 77-156c66 199.333 139 419.667
219 661 l218 661zM702 ` +
      t +
      `H400000v` +
      (40 + e) +
      `H742z`
    );
  },
  ge = function (e, t, n) {
    t = 1e3 * t;
    var r = ``;
    switch (e) {
      case `sqrtMain`:
        r = ue(t, le);
        break;
      case `sqrtSize1`:
        r = de(t, le);
        break;
      case `sqrtSize2`:
        r = fe(t, le);
        break;
      case `sqrtSize3`:
        r = pe(t, le);
        break;
      case `sqrtSize4`:
        r = O(t, le);
        break;
      case `sqrtTall`:
        r = he(t, le, n);
    }
    return r;
  },
  _e = function (e, t) {
    switch (e) {
      case `⎜`:
        return D(`M291 0 H417 V` + t + ` H291z`);
      case `∣`:
        return D(`M145 0 H188 V` + t + ` H145z`);
      case `∥`:
        return D(`M145 0 H188 V` + t + ` H145z`) + D(`M367 0 H410 V` + t + ` H367z`);
      case `⎟`:
        return D(`M457 0 H583 V` + t + ` H457z`);
      case `⎢`:
        return D(`M319 0 H403 V` + t + ` H319z`);
      case `⎥`:
        return D(`M263 0 H347 V` + t + ` H263z`);
      case `⎪`:
        return D(`M384 0 H504 V` + t + ` H384z`);
      case `⏐`:
        return D(`M312 0 H355 V` + t + ` H312z`);
      case `‖`:
        return D(`M257 0 H300 V` + t + ` H257z`) + D(`M478 0 H521 V` + t + ` H478z`);
      default:
        return ``;
    }
  },
  ve = {
    doubleleftarrow: `M262 157
l10-10c34-36 62.7-77 86-123 3.3-8 5-13.3 5-16 0-5.3-6.7-8-20-8-7.3
 0-12.2.5-14.5 1.5-2.3 1-4.8 4.5-7.5 10.5-49.3 97.3-121.7 169.3-217 216-28
 14-57.3 25-88 33-6.7 2-11 3.8-13 5.5-2 1.7-3 4.2-3 7.5s1 5.8 3 7.5
c2 1.7 6.3 3.5 13 5.5 68 17.3 128.2 47.8 180.5 91.5 52.3 43.7 93.8 96.2 124.5
 157.5 9.3 8 15.3 12.3 18 13h6c12-.7 18-4 18-10 0-2-1.7-7-5-15-23.3-46-52-87
-86-123l-10-10h399738v-40H218c328 0 0 0 0 0l-10-8c-26.7-20-65.7-43-117-69 2.7
-2 6-3.7 10-5 36.7-16 72.3-37.3 107-64l10-8h399782v-40z
m8 0v40h399730v-40zm0 194v40h399730v-40z`,
    doublerightarrow: `M399738 392l
-10 10c-34 36-62.7 77-86 123-3.3 8-5 13.3-5 16 0 5.3 6.7 8 20 8 7.3 0 12.2-.5
 14.5-1.5 2.3-1 4.8-4.5 7.5-10.5 49.3-97.3 121.7-169.3 217-216 28-14 57.3-25 88
-33 6.7-2 11-3.8 13-5.5 2-1.7 3-4.2 3-7.5s-1-5.8-3-7.5c-2-1.7-6.3-3.5-13-5.5-68
-17.3-128.2-47.8-180.5-91.5-52.3-43.7-93.8-96.2-124.5-157.5-9.3-8-15.3-12.3-18
-13h-6c-12 .7-18 4-18 10 0 2 1.7 7 5 15 23.3 46 52 87 86 123l10 10H0v40h399782
c-328 0 0 0 0 0l10 8c26.7 20 65.7 43 117 69-2.7 2-6 3.7-10 5-36.7 16-72.3 37.3
-107 64l-10 8H0v40zM0 157v40h399730v-40zm0 194v40h399730v-40z`,
    leftarrow: `M400000 241H110l3-3c68.7-52.7 113.7-120
 135-202 4-14.7 6-23 6-25 0-7.3-7-11-21-11-8 0-13.2.8-15.5 2.5-2.3 1.7-4.2 5.8
-5.5 12.5-1.3 4.7-2.7 10.3-4 17-12 48.7-34.8 92-68.5 130S65.3 228.3 18 247
c-10 4-16 7.7-18 11 0 8.7 6 14.3 18 17 47.3 18.7 87.8 47 121.5 85S196 441.3 208
 490c.7 2 1.3 5 2 9s1.2 6.7 1.5 8c.3 1.3 1 3.3 2 6s2.2 4.5 3.5 5.5c1.3 1 3.3
 1.8 6 2.5s6 1 10 1c14 0 21-3.7 21-11 0-2-2-10.3-6-25-20-79.3-65-146.7-135-202
 l-3-3h399890zM100 241v40h399900v-40z`,
    leftbrace: `M6 548l-6-6v-35l6-11c56-104 135.3-181.3 238-232 57.3-28.7 117
-45 179-50h399577v120H403c-43.3 7-81 15-113 26-100.7 33-179.7 91-237 174-2.7
 5-6 9-10 13-.7 1-7.3 1-20 1H6z`,
    leftbraceunder: `M0 6l6-6h17c12.688 0 19.313.3 20 1 4 4 7.313 8.3 10 13
 35.313 51.3 80.813 93.8 136.5 127.5 55.688 33.7 117.188 55.8 184.5 66.5.688
 0 2 .3 4 1 18.688 2.7 76 4.3 172 5h399450v120H429l-6-1c-124.688-8-235-61.7
-331-161C60.687 138.7 32.312 99.3 7 54L0 41V6z`,
    leftgroup: `M400000 80
H435C64 80 168.3 229.4 21 260c-5.9 1.2-18 0-18 0-2 0-3-1-3-3v-38C76 61 257 0
 435 0h399565z`,
    leftgroupunder: `M400000 262
H435C64 262 168.3 112.6 21 82c-5.9-1.2-18 0-18 0-2 0-3 1-3 3v38c76 158 257 219
 435 219h399565z`,
    leftharpoon: `M0 267c.7 5.3 3 10 7 14h399993v-40H93c3.3
-3.3 10.2-9.5 20.5-18.5s17.8-15.8 22.5-20.5c50.7-52 88-110.3 112-175 4-11.3 5
-18.3 3-21-1.3-4-7.3-6-18-6-8 0-13 .7-15 2s-4.7 6.7-8 16c-42 98.7-107.3 174.7
-196 228-6.7 4.7-10.7 8-12 10-1.3 2-2 5.7-2 11zm100-26v40h399900v-40z`,
    leftharpoonplus: `M0 267c.7 5.3 3 10 7 14h399993v-40H93c3.3-3.3 10.2-9.5
 20.5-18.5s17.8-15.8 22.5-20.5c50.7-52 88-110.3 112-175 4-11.3 5-18.3 3-21-1.3
-4-7.3-6-18-6-8 0-13 .7-15 2s-4.7 6.7-8 16c-42 98.7-107.3 174.7-196 228-6.7 4.7
-10.7 8-12 10-1.3 2-2 5.7-2 11zm100-26v40h399900v-40zM0 435v40h400000v-40z
m0 0v40h400000v-40z`,
    leftharpoondown: `M7 241c-4 4-6.333 8.667-7 14 0 5.333.667 9 2 11s5.333
 5.333 12 10c90.667 54 156 130 196 228 3.333 10.667 6.333 16.333 9 17 2 .667 5
 1 9 1h5c10.667 0 16.667-2 18-6 2-2.667 1-9.667-3-21-32-87.333-82.667-157.667
-152-211l-3-3h399907v-40zM93 281 H400000 v-40L7 241z`,
    leftharpoondownplus: `M7 435c-4 4-6.3 8.7-7 14 0 5.3.7 9 2 11s5.3 5.3 12
 10c90.7 54 156 130 196 228 3.3 10.7 6.3 16.3 9 17 2 .7 5 1 9 1h5c10.7 0 16.7
-2 18-6 2-2.7 1-9.7-3-21-32-87.3-82.7-157.7-152-211l-3-3h399907v-40H7zm93 0
v40h399900v-40zM0 241v40h399900v-40zm0 0v40h399900v-40z`,
    lefthook: `M400000 281 H103s-33-11.2-61-33.5S0 197.3 0 164s14.2-61.2 42.5
-83.5C70.8 58.2 104 47 142 47 c16.7 0 25 6.7 25 20 0 12-8.7 18.7-26 20-40 3.3
-68.7 15.7-86 37-10 12-15 25.3-15 40 0 22.7 9.8 40.7 29.5 54 19.7 13.3 43.5 21
 71.5 23h399859zM103 281v-40h399897v40z`,
    leftlinesegment: D(`M40 281 V428 H0 V94 H40 V241 H400000 v40z`),
    leftbracketunder: D(`M0 0 h120 V290 H399995 v120 H0z`),
    leftbracketover: D(`M0 440 h120 V150 H399995 v-120 H0z`),
    leftmapsto: D(`M40 281 V448H0V74H40V241H400000v40z`),
    leftToFrom: `M0 147h400000v40H0zm0 214c68 40 115.7 95.7 143 167h22c15.3 0 23
-.3 23-1 0-1.3-5.3-13.7-16-37-18-35.3-41.3-69-70-101l-7-8h399905v-40H95l7-8
c28.7-32 52-65.7 70-101 10.7-23.3 16-35.7 16-37 0-.7-7.7-1-23-1h-22C115.7 265.3
 68 321 0 361zm0-174v-40h399900v40zm100 154v40h399900v-40z`,
    longequal: D(`M0 50 h400000 v40H0z m0 194h40000v40H0z`),
    midbrace: `M200428 334
c-100.7-8.3-195.3-44-280-108-55.3-42-101.7-93-139-153l-9-14c-2.7 4-5.7 8.7-9 14
-53.3 86.7-123.7 153-211 199-66.7 36-137.3 56.3-212 62H0V214h199568c178.3-11.7
 311.7-78.3 403-201 6-8 9.7-12 11-12 .7-.7 6.7-1 18-1s17.3.3 18 1c1.3 0 5 4 11
 12 44.7 59.3 101.3 106.3 170 141s145.3 54.3 229 60h199572v120z`,
    midbraceunder: `M199572 214
c100.7 8.3 195.3 44 280 108 55.3 42 101.7 93 139 153l9 14c2.7-4 5.7-8.7 9-14
 53.3-86.7 123.7-153 211-199 66.7-36 137.3-56.3 212-62h199568v120H200432c-178.3
 11.7-311.7 78.3-403 201-6 8-9.7 12-11 12-.7.7-6.7 1-18 1s-17.3-.3-18-1c-1.3 0
-5-4-11-12-44.7-59.3-101.3-106.3-170-141s-145.3-54.3-229-60H0V214z`,
    oiintSize1: `M512.6 71.6c272.6 0 320.3 106.8 320.3 178.2 0 70.8-47.7 177.6
-320.3 177.6S193.1 320.6 193.1 249.8c0-71.4 46.9-178.2 319.5-178.2z
m368.1 178.2c0-86.4-60.9-215.4-368.1-215.4-306.4 0-367.3 129-367.3 215.4 0 85.8
60.9 214.8 367.3 214.8 307.2 0 368.1-129 368.1-214.8z`,
    oiintSize2: `M757.8 100.1c384.7 0 451.1 137.6 451.1 230 0 91.3-66.4 228.8
-451.1 228.8-386.3 0-452.7-137.5-452.7-228.8 0-92.4 66.4-230 452.7-230z
m502.4 230c0-111.2-82.4-277.2-502.4-277.2s-504 166-504 277.2
c0 110 84 276 504 276s502.4-166 502.4-276z`,
    oiiintSize1: `M681.4 71.6c408.9 0 480.5 106.8 480.5 178.2 0 70.8-71.6 177.6
-480.5 177.6S202.1 320.6 202.1 249.8c0-71.4 70.5-178.2 479.3-178.2z
m525.8 178.2c0-86.4-86.8-215.4-525.7-215.4-437.9 0-524.7 129-524.7 215.4 0
85.8 86.8 214.8 524.7 214.8 438.9 0 525.7-129 525.7-214.8z`,
    oiiintSize2: `M1021.2 53c603.6 0 707.8 165.8 707.8 277.2 0 110-104.2 275.8
-707.8 275.8-606 0-710.2-165.8-710.2-275.8C311 218.8 415.2 53 1021.2 53z
m770.4 277.1c0-131.2-126.4-327.6-770.5-327.6S248.4 198.9 248.4 330.1
c0 130 128.8 326.4 772.7 326.4s770.5-196.4 770.5-326.4z`,
    rightarrow: `M0 241v40h399891c-47.3 35.3-84 78-110 128
-16.7 32-27.7 63.7-33 95 0 1.3-.2 2.7-.5 4-.3 1.3-.5 2.3-.5 3 0 7.3 6.7 11 20
 11 8 0 13.2-.8 15.5-2.5 2.3-1.7 4.2-5.5 5.5-11.5 2-13.3 5.7-27 11-41 14.7-44.7
 39-84.5 73-119.5s73.7-60.2 119-75.5c6-2 9-5.7 9-11s-3-9-9-11c-45.3-15.3-85
-40.5-119-75.5s-58.3-74.8-73-119.5c-4.7-14-8.3-27.3-11-40-1.3-6.7-3.2-10.8-5.5
-12.5-2.3-1.7-7.5-2.5-15.5-2.5-14 0-21 3.7-21 11 0 2 2 10.3 6 25 20.7 83.3 67
 151.7 139 205zm0 0v40h399900v-40z`,
    rightbrace: `M400000 542l
-6 6h-17c-12.7 0-19.3-.3-20-1-4-4-7.3-8.3-10-13-35.3-51.3-80.8-93.8-136.5-127.5
s-117.2-55.8-184.5-66.5c-.7 0-2-.3-4-1-18.7-2.7-76-4.3-172-5H0V214h399571l6 1
c124.7 8 235 61.7 331 161 31.3 33.3 59.7 72.7 85 118l7 13v35z`,
    rightbraceunder: `M399994 0l6 6v35l-6 11c-56 104-135.3 181.3-238 232-57.3
 28.7-117 45-179 50H-300V214h399897c43.3-7 81-15 113-26 100.7-33 179.7-91 237
-174 2.7-5 6-9 10-13 .7-1 7.3-1 20-1h17z`,
    rightgroup: `M0 80h399565c371 0 266.7 149.4 414 180 5.9 1.2 18 0 18 0 2 0
 3-1 3-3v-38c-76-158-257-219-435-219H0z`,
    rightgroupunder: `M0 262h399565c371 0 266.7-149.4 414-180 5.9-1.2 18 0 18
 0 2 0 3 1 3 3v38c-76 158-257 219-435 219H0z`,
    rightharpoon: `M0 241v40h399993c4.7-4.7 7-9.3 7-14 0-9.3
-3.7-15.3-11-18-92.7-56.7-159-133.7-199-231-3.3-9.3-6-14.7-8-16-2-1.3-7-2-15-2
-10.7 0-16.7 2-18 6-2 2.7-1 9.7 3 21 15.3 42 36.7 81.8 64 119.5 27.3 37.7 58
 69.2 92 94.5zm0 0v40h399900v-40z`,
    rightharpoonplus: `M0 241v40h399993c4.7-4.7 7-9.3 7-14 0-9.3-3.7-15.3-11
-18-92.7-56.7-159-133.7-199-231-3.3-9.3-6-14.7-8-16-2-1.3-7-2-15-2-10.7 0-16.7
 2-18 6-2 2.7-1 9.7 3 21 15.3 42 36.7 81.8 64 119.5 27.3 37.7 58 69.2 92 94.5z
m0 0v40h399900v-40z m100 194v40h399900v-40zm0 0v40h399900v-40z`,
    rightharpoondown: `M399747 511c0 7.3 6.7 11 20 11 8 0 13-.8 15-2.5s4.7-6.8
 8-15.5c40-94 99.3-166.3 178-217 13.3-8 20.3-12.3 21-13 5.3-3.3 8.5-5.8 9.5
-7.5 1-1.7 1.5-5.2 1.5-10.5s-2.3-10.3-7-15H0v40h399908c-34 25.3-64.7 57-92 95
-27.3 38-48.7 77.7-64 119-3.3 8.7-5 14-5 16zM0 241v40h399900v-40z`,
    rightharpoondownplus: `M399747 705c0 7.3 6.7 11 20 11 8 0 13-.8
 15-2.5s4.7-6.8 8-15.5c40-94 99.3-166.3 178-217 13.3-8 20.3-12.3 21-13 5.3-3.3
 8.5-5.8 9.5-7.5 1-1.7 1.5-5.2 1.5-10.5s-2.3-10.3-7-15H0v40h399908c-34 25.3
-64.7 57-92 95-27.3 38-48.7 77.7-64 119-3.3 8.7-5 14-5 16zM0 435v40h399900v-40z
m0-194v40h400000v-40zm0 0v40h400000v-40z`,
    righthook: `M399859 241c-764 0 0 0 0 0 40-3.3 68.7-15.7 86-37 10-12 15-25.3
 15-40 0-22.7-9.8-40.7-29.5-54-19.7-13.3-43.5-21-71.5-23-17.3-1.3-26-8-26-20 0
-13.3 8.7-20 26-20 38 0 71 11.2 99 33.5 0 0 7 5.6 21 16.7 14 11.2 21 33.5 21
 66.8s-14 61.2-42 83.5c-28 22.3-61 33.5-99 33.5L0 241z M0 281v-40h399859v40z`,
    rightlinesegment: D(`M399960 241 V94 h40 V428 h-40 V281 H0 v-40z`),
    rightbracketunder: D(`M399995 0 h-120 V290 H0 v120 H400000z`),
    rightbracketover: D(`M399995 440 h-120 V150 H0 v-120 H399995z`),
    rightToFrom: `M400000 167c-70.7-42-118-97.7-142-167h-23c-15.3 0-23 .3-23
 1 0 1.3 5.3 13.7 16 37 18 35.3 41.3 69 70 101l7 8H0v40h399905l-7 8c-28.7 32
-52 65.7-70 101-10.7 23.3-16 35.7-16 37 0 .7 7.7 1 23 1h23c24-69.3 71.3-125 142
-167z M100 147v40h399900v-40zM0 341v40h399900v-40z`,
    twoheadleftarrow: `M0 167c68 40
 115.7 95.7 143 167h22c15.3 0 23-.3 23-1 0-1.3-5.3-13.7-16-37-18-35.3-41.3-69
-70-101l-7-8h125l9 7c50.7 39.3 85 86 103 140h46c0-4.7-6.3-18.7-19-42-18-35.3
-40-67.3-66-96l-9-9h399716v-40H284l9-9c26-28.7 48-60.7 66-96 12.7-23.333 19
-37.333 19-42h-46c-18 54-52.3 100.7-103 140l-9 7H95l7-8c28.7-32 52-65.7 70-101
 10.7-23.333 16-35.7 16-37 0-.7-7.7-1-23-1h-22C115.7 71.3 68 127 0 167z`,
    twoheadrightarrow: `M400000 167
c-68-40-115.7-95.7-143-167h-22c-15.3 0-23 .3-23 1 0 1.3 5.3 13.7 16 37 18 35.3
 41.3 69 70 101l7 8h-125l-9-7c-50.7-39.3-85-86-103-140h-46c0 4.7 6.3 18.7 19 42
 18 35.3 40 67.3 66 96l9 9H0v40h399716l-9 9c-26 28.7-48 60.7-66 96-12.7 23.333
-19 37.333-19 42h46c18-54 52.3-100.7 103-140l9-7h125l-7 8c-28.7 32-52 65.7-70
 101-10.7 23.333-16 35.7-16 37 0 .7 7.7 1 23 1h22c27.3-71.3 75-127 143-167z`,
    tilde1: `M200 55.538c-77 0-168 73.953-177 73.953-3 0-7
-2.175-9-5.437L2 97c-1-2-2-4-2-6 0-4 2-7 5-9l20-12C116 12 171 0 207 0c86 0
 114 68 191 68 78 0 168-68 177-68 4 0 7 2 9 5l12 19c1 2.175 2 4.35 2 6.525 0
 4.35-2 7.613-5 9.788l-19 13.05c-92 63.077-116.937 75.308-183 76.128
-68.267.847-113-73.952-191-73.952z`,
    tilde2: `M344 55.266c-142 0-300.638 81.316-311.5 86.418
-8.01 3.762-22.5 10.91-23.5 5.562L1 120c-1-2-1-3-1-4 0-5 3-9 8-10l18.4-9C160.9
 31.9 283 0 358 0c148 0 188 122 331 122s314-97 326-97c4 0 8 2 10 7l7 21.114
c1 2.14 1 3.21 1 4.28 0 5.347-3 9.626-7 10.696l-22.3 12.622C852.6 158.372 751
 181.476 676 181.476c-149 0-189-126.21-332-126.21z`,
    tilde3: `M786 59C457 59 32 175.242 13 175.242c-6 0-10-3.457
-11-10.37L.15 138c-1-7 3-12 10-13l19.2-6.4C378.4 40.7 634.3 0 804.3 0c337 0
 411.8 157 746.8 157 328 0 754-112 773-112 5 0 10 3 11 9l1 14.075c1 8.066-.697
 16.595-6.697 17.492l-21.052 7.31c-367.9 98.146-609.15 122.696-778.15 122.696
 -338 0-409-156.573-744-156.573z`,
    tilde4: `M786 58C457 58 32 177.487 13 177.487c-6 0-10-3.345
-11-10.035L.15 143c-1-7 3-12 10-13l22-6.7C381.2 35 637.15 0 807.15 0c337 0 409
 177 744 177 328 0 754-127 773-127 5 0 10 3 11 9l1 14.794c1 7.805-3 13.38-9
 14.495l-20.7 5.574c-366.85 99.79-607.3 139.372-776.3 139.372-338 0-409
 -175.236-744-175.236z`,
    vec: `M377 20c0-5.333 1.833-10 5.5-14S391 0 397 0c4.667 0 8.667 1.667 12 5
3.333 2.667 6.667 9 10 19 6.667 24.667 20.333 43.667 41 57 7.333 4.667 11
10.667 11 18 0 6-1 10-3 12s-6.667 5-14 9c-28.667 14.667-53.667 35.667-75 63
-1.333 1.333-3.167 3.5-5.5 6.5s-4 4.833-5 5.5c-1 .667-2.5 1.333-4.5 2s-4.333 1
-7 1c-4.667 0-9.167-1.833-13.5-5.5S337 184 337 178c0-12.667 15.667-32.333 47-59
H213l-171-1c-8.667-6-13-12.333-13-19 0-4.667 4.333-11.333 13-20h359
c-16-25.333-24-45-24-59z`,
    widehat1: `M529 0h5l519 115c5 1 9 5 9 10 0 1-1 2-1 3l-4 22
c-1 5-5 9-11 9h-2L532 67 19 159h-2c-5 0-9-4-11-9l-5-22c-1-6 2-12 8-13z`,
    widehat2: `M1181 0h2l1171 176c6 0 10 5 10 11l-2 23c-1 6-5 10
-11 10h-1L1182 67 15 220h-1c-6 0-10-4-11-10l-2-23c-1-6 4-11 10-11z`,
    widehat3: `M1181 0h2l1171 236c6 0 10 5 10 11l-2 23c-1 6-5 10
-11 10h-1L1182 67 15 280h-1c-6 0-10-4-11-10l-2-23c-1-6 4-11 10-11z`,
    widehat4: `M1181 0h2l1171 296c6 0 10 5 10 11l-2 23c-1 6-5 10
-11 10h-1L1182 67 15 340h-1c-6 0-10-4-11-10l-2-23c-1-6 4-11 10-11z`,
    widecheck1: `M529,159h5l519,-115c5,-1,9,-5,9,-10c0,-1,-1,-2,-1,-3l-4,-22c-1,
-5,-5,-9,-11,-9h-2l-512,92l-513,-92h-2c-5,0,-9,4,-11,9l-5,22c-1,6,2,12,8,13z`,
    widecheck2: `M1181,220h2l1171,-176c6,0,10,-5,10,-11l-2,-23c-1,-6,-5,-10,
-11,-10h-1l-1168,153l-1167,-153h-1c-6,0,-10,4,-11,10l-2,23c-1,6,4,11,10,11z`,
    widecheck3: `M1181,280h2l1171,-236c6,0,10,-5,10,-11l-2,-23c-1,-6,-5,-10,
-11,-10h-1l-1168,213l-1167,-213h-1c-6,0,-10,4,-11,10l-2,23c-1,6,4,11,10,11z`,
    widecheck4: `M1181,340h2l1171,-296c6,0,10,-5,10,-11l-2,-23c-1,-6,-5,-10,
-11,-10h-1l-1168,273l-1167,-273h-1c-6,0,-10,4,-11,10l-2,23c-1,6,4,11,10,11z`,
    baraboveleftarrow: `M400000 620h-399890l3 -3c68.7 -52.7 113.7 -120 135 -202
c4 -14.7 6 -23 6 -25c0 -7.3 -7 -11 -21 -11c-8 0 -13.2 0.8 -15.5 2.5
c-2.3 1.7 -4.2 5.8 -5.5 12.5c-1.3 4.7 -2.7 10.3 -4 17c-12 48.7 -34.8 92 -68.5 130
s-74.2 66.3 -121.5 85c-10 4 -16 7.7 -18 11c0 8.7 6 14.3 18 17c47.3 18.7 87.8 47
121.5 85s56.5 81.3 68.5 130c0.7 2 1.3 5 2 9s1.2 6.7 1.5 8c0.3 1.3 1 3.3 2 6
s2.2 4.5 3.5 5.5c1.3 1 3.3 1.8 6 2.5s6 1 10 1c14 0 21 -3.7 21 -11
c0 -2 -2 -10.3 -6 -25c-20 -79.3 -65 -146.7 -135 -202l-3 -3h399890z
M100 620v40h399900v-40z M0 241v40h399900v-40zM0 241v40h399900v-40z`,
    rightarrowabovebar: `M0 241v40h399891c-47.3 35.3-84 78-110 128-16.7 32
-27.7 63.7-33 95 0 1.3-.2 2.7-.5 4-.3 1.3-.5 2.3-.5 3 0 7.3 6.7 11 20 11 8 0
13.2-.8 15.5-2.5 2.3-1.7 4.2-5.5 5.5-11.5 2-13.3 5.7-27 11-41 14.7-44.7 39
-84.5 73-119.5s73.7-60.2 119-75.5c6-2 9-5.7 9-11s-3-9-9-11c-45.3-15.3-85-40.5
-119-75.5s-58.3-74.8-73-119.5c-4.7-14-8.3-27.3-11-40-1.3-6.7-3.2-10.8-5.5
-12.5-2.3-1.7-7.5-2.5-15.5-2.5-14 0-21 3.7-21 11 0 2 2 10.3 6 25 20.7 83.3 67
151.7 139 205zm96 379h399894v40H0zm0 0h399904v40H0z`,
    baraboveshortleftharpoon: `M507,435c-4,4,-6.3,8.7,-7,14c0,5.3,0.7,9,2,11
c1.3,2,5.3,5.3,12,10c90.7,54,156,130,196,228c3.3,10.7,6.3,16.3,9,17
c2,0.7,5,1,9,1c0,0,5,0,5,0c10.7,0,16.7,-2,18,-6c2,-2.7,1,-9.7,-3,-21
c-32,-87.3,-82.7,-157.7,-152,-211c0,0,-3,-3,-3,-3l399351,0l0,-40
c-398570,0,-399437,0,-399437,0z M593 435 v40 H399500 v-40z
M0 281 v-40 H399908 v40z M0 281 v-40 H399908 v40z`,
    rightharpoonaboveshortbar: `M0,241 l0,40c399126,0,399993,0,399993,0
c4.7,-4.7,7,-9.3,7,-14c0,-9.3,-3.7,-15.3,-11,-18c-92.7,-56.7,-159,-133.7,-199,
-231c-3.3,-9.3,-6,-14.7,-8,-16c-2,-1.3,-7,-2,-15,-2c-10.7,0,-16.7,2,-18,6
c-2,2.7,-1,9.7,3,21c15.3,42,36.7,81.8,64,119.5c27.3,37.7,58,69.2,92,94.5z
M0 241 v40 H399908 v-40z M0 475 v-40 H399500 v40z M0 475 v-40 H399500 v40z`,
    shortbaraboveleftharpoon: `M7,435c-4,4,-6.3,8.7,-7,14c0,5.3,0.7,9,2,11
c1.3,2,5.3,5.3,12,10c90.7,54,156,130,196,228c3.3,10.7,6.3,16.3,9,17c2,0.7,5,1,9,
1c0,0,5,0,5,0c10.7,0,16.7,-2,18,-6c2,-2.7,1,-9.7,-3,-21c-32,-87.3,-82.7,-157.7,
-152,-211c0,0,-3,-3,-3,-3l399907,0l0,-40c-399126,0,-399993,0,-399993,0z
M93 435 v40 H400000 v-40z M500 241 v40 H400000 v-40z M500 241 v40 H400000 v-40z`,
    shortrightharpoonabovebar: `M53,241l0,40c398570,0,399437,0,399437,0
c4.7,-4.7,7,-9.3,7,-14c0,-9.3,-3.7,-15.3,-11,-18c-92.7,-56.7,-159,-133.7,-199,
-231c-3.3,-9.3,-6,-14.7,-8,-16c-2,-1.3,-7,-2,-15,-2c-10.7,0,-16.7,2,-18,6
c-2,2.7,-1,9.7,3,21c15.3,42,36.7,81.8,64,119.5c27.3,37.7,58,69.2,92,94.5z
M500 241 v40 H399408 v-40z M500 435 v40 H400000 v-40z`,
  },
  ye = function (e, t) {
    switch (e) {
      case `lbrack`:
        return (
          `M403 1759 V84 H666 V0 H319 V1759 v` +
          t +
          ` v1759 v84 h347 v-84
H403z M403 1759 V0 H319 V1759 v` +
          t +
          ` v1759 v84 h84z`
        );
      case `rbrack`:
        return (
          `M347 1759 V0 H0 V84 H263 V1759 v` +
          t +
          ` v1759 H0 v84 H347z
M347 1759 V0 H263 V1759 v` +
          t +
          ` v1759 h84z`
        );
      case `vert`:
        return (
          `M145 15 v585 v` +
          t +
          ` v585 c2.667,10,9.667,15,21,15
c10,0,16.667,-5,20,-15 v-585 v` +
          -t +
          ` v-585 c-2.667,-10,-9.667,-15,-21,-15
c-10,0,-16.667,5,-20,15z M188 15 H145 v585 v` +
          t +
          ` v585 h43z`
        );
      case `doublevert`:
        return (
          `M145 15 v585 v` +
          t +
          ` v585 c2.667,10,9.667,15,21,15
c10,0,16.667,-5,20,-15 v-585 v` +
          -t +
          ` v-585 c-2.667,-10,-9.667,-15,-21,-15
c-10,0,-16.667,5,-20,15z M188 15 H145 v585 v` +
          t +
          ` v585 h43z
M367 15 v585 v` +
          t +
          ` v585 c2.667,10,9.667,15,21,15
c10,0,16.667,-5,20,-15 v-585 v` +
          -t +
          ` v-585 c-2.667,-10,-9.667,-15,-21,-15
c-10,0,-16.667,5,-20,15z M410 15 H367 v585 v` +
          t +
          ` v585 h43z`
        );
      case `lfloor`:
        return (
          `M319 602 V0 H403 V602 v` +
          t +
          ` v1715 h263 v84 H319z
MM319 602 V0 H403 V602 v` +
          t +
          ` v1715 H319z`
        );
      case `rfloor`:
        return (
          `M319 602 V0 H403 V602 v` +
          t +
          ` v1799 H0 v-84 H319z
MM319 602 V0 H403 V602 v` +
          t +
          ` v1715 H319z`
        );
      case `lceil`:
        return (
          `M403 1759 V84 H666 V0 H319 V1759 v` +
          t +
          ` v602 h84z
M403 1759 V0 H319 V1759 v` +
          t +
          ` v602 h84z`
        );
      case `rceil`:
        return (
          `M347 1759 V0 H0 V84 H263 V1759 v` +
          t +
          ` v602 h84z
M347 1759 V0 h-84 V1759 v` +
          t +
          ` v602 h84z`
        );
      case `lparen`:
        return (
          `M863,9c0,-2,-2,-5,-6,-9c0,0,-17,0,-17,0c-12.7,0,-19.3,0.3,-20,1
c-5.3,5.3,-10.3,11,-15,17c-242.7,294.7,-395.3,682,-458,1162c-21.3,163.3,-33.3,349,
-36,557 l0,` +
          (t + 84) +
          `c0.2,6,0,26,0,60c2,159.3,10,310.7,24,454c53.3,528,210,
949.7,470,1265c4.7,6,9.7,11.7,15,17c0.7,0.7,7,1,19,1c0,0,18,0,18,0c4,-4,6,-7,6,-9
c0,-2.7,-3.3,-8.7,-10,-18c-135.3,-192.7,-235.5,-414.3,-300.5,-665c-65,-250.7,-102.5,
-544.7,-112.5,-882c-2,-104,-3,-167,-3,-189
l0,-` +
          (t + 92) +
          `c0,-162.7,5.7,-314,17,-454c20.7,-272,63.7,-513,129,-723c65.3,
-210,155.3,-396.3,270,-559c6.7,-9.3,10,-15.3,10,-18z`
        );
      case `rparen`:
        return (
          `M76,0c-16.7,0,-25,3,-25,9c0,2,2,6.3,6,13c21.3,28.7,42.3,60.3,
63,95c96.7,156.7,172.8,332.5,228.5,527.5c55.7,195,92.8,416.5,111.5,664.5
c11.3,139.3,17,290.7,17,454c0,28,1.7,43,3.3,45l0,` +
          (t + 9) +
          `
c-3,4,-3.3,16.7,-3.3,38c0,162,-5.7,313.7,-17,455c-18.7,248,-55.8,469.3,-111.5,664
c-55.7,194.7,-131.8,370.3,-228.5,527c-20.7,34.7,-41.7,66.3,-63,95c-2,3.3,-4,7,-6,11
c0,7.3,5.7,11,17,11c0,0,11,0,11,0c9.3,0,14.3,-0.3,15,-1c5.3,-5.3,10.3,-11,15,-17
c242.7,-294.7,395.3,-681.7,458,-1161c21.3,-164.7,33.3,-350.7,36,-558
l0,-` +
          (t + 144) +
          `c-2,-159.3,-10,-310.7,-24,-454c-53.3,-528,-210,-949.7,
-470,-1265c-4.7,-6,-9.7,-11.7,-15,-17c-0.7,-0.7,-6.7,-1,-18,-1z`
        );
      default:
        throw Error(`Unknown stretchy delimiter.`);
    }
  };
function be(e) {
  return `toText` in e;
}
var xe = class {
    constructor(e) {
      ((this.children = void 0),
        (this.classes = void 0),
        (this.height = void 0),
        (this.depth = void 0),
        (this.maxFontSize = void 0),
        (this.style = void 0),
        (this.children = e),
        (this.classes = []),
        (this.height = 0),
        (this.depth = 0),
        (this.maxFontSize = 0),
        (this.style = {}));
    }
    hasClass(e) {
      return this.classes.includes(e);
    }
    toNode() {
      for (var e = document.createDocumentFragment(), t = 0; t < this.children.length; t++)
        e.appendChild(this.children[t].toNode());
      return e;
    }
    toMarkup() {
      for (var e = ``, t = 0; t < this.children.length; t++) e += this.children[t].toMarkup();
      return e;
    }
    toText() {
      return this.children
        .map((e) => {
          if (be(e)) return e.toText();
          throw Error(`Expected MathDomNode with toText, got ` + e.constructor.name);
        })
        .join(``);
    }
  },
  Se = {
    pt: 1,
    mm: 7227 / 2540,
    cm: 7227 / 254,
    in: 72.27,
    bp: 803 / 800,
    pc: 12,
    dd: 1238 / 1157,
    cc: 14856 / 1157,
    nd: 685 / 642,
    nc: 1370 / 107,
    sp: 1 / 65536,
    px: 803 / 800,
  },
  Ce = {
    ex: !0,
    em: !0,
    mu: !0,
  },
  we = function (e) {
    return (typeof e != `string` && (e = e.unit), e in Se || e in Ce || e === `ex`);
  },
  k = function (t, n) {
    var r;
    if (t.unit in Se) r = Se[t.unit] / n.fontMetrics().ptPerEm / n.sizeMultiplier;
    else if (t.unit === `mu`) r = n.fontMetrics().cssEmPerMu;
    else {
      var i = n.style.isTight() ? n.havingStyle(n.style.text()) : n;
      if (t.unit === `ex`) r = i.fontMetrics().xHeight;
      else if (t.unit === `em`) r = i.fontMetrics().quad;
      else throw new e(`Invalid unit: '` + t.unit + `'`);
      i !== n && (r *= i.sizeMultiplier / n.sizeMultiplier);
    }
    return Math.min(t.number * r, n.maxSize);
  },
  A = function (e) {
    return +e.toFixed(4) + `em`;
  },
  j = function (e) {
    return e.filter((e) => e).join(` `);
  },
  Te = function (e) {
    var t = ``;
    for (var r of Object.keys(e)) {
      var i = e[r];
      i !== void 0 && (t += n(r) + `:` + i + `;`);
    }
    return t;
  },
  Ee = function (e, t, n) {
    if (
      ((this.classes = e || []),
      (this.attributes = {}),
      (this.height = 0),
      (this.depth = 0),
      (this.maxFontSize = 0),
      (this.style = n || {}),
      t)
    ) {
      t.style.isTight() && this.classes.push(`mtight`);
      var r = t.getColor();
      r && (this.style.color = r);
    }
  },
  De = function (e) {
    var t = document.createElement(e);
    ((t.className = j(this.classes)), Object.assign(t.style, this.style));
    for (var n of Object.keys(this.attributes)) t.setAttribute(n, this.attributes[n]);
    for (var r = 0; r < this.children.length; r++) t.appendChild(this.children[r].toNode());
    return t;
  },
  Oe = /[\s"'>/=\x00-\x1f]/,
  ke = function (t) {
    var n = `<` + t;
    this.classes.length && (n += ` class="` + a(j(this.classes)) + `"`);
    var r = Te(this.style);
    r && (n += ` style="` + a(r) + `"`);
    for (var i of Object.keys(this.attributes)) {
      if (Oe.test(i)) throw new e(`Invalid attribute name '` + i + `'`);
      n += ` ` + i + `="` + a(this.attributes[i]) + `"`;
    }
    n += `>`;
    for (var o = 0; o < this.children.length; o++) n += this.children[o].toMarkup();
    return ((n += `</` + t + `>`), n);
  },
  Ae = class {
    constructor(e, t, n, r) {
      ((this.children = void 0),
        (this.attributes = void 0),
        (this.classes = void 0),
        (this.height = void 0),
        (this.depth = void 0),
        (this.width = void 0),
        (this.maxFontSize = void 0),
        (this.style = void 0),
        (this.italic = void 0),
        Ee.call(this, e, n, r),
        (this.children = t || []));
    }
    setAttribute(e, t) {
      this.attributes[e] = t;
    }
    hasClass(e) {
      return this.classes.includes(e);
    }
    toNode() {
      return De.call(this, `span`);
    }
    toMarkup() {
      return ke.call(this, `span`);
    }
  },
  je = class {
    constructor(e, t, n, r) {
      ((this.children = void 0),
        (this.attributes = void 0),
        (this.classes = void 0),
        (this.height = void 0),
        (this.depth = void 0),
        (this.maxFontSize = void 0),
        (this.style = void 0),
        Ee.call(this, t, r),
        (this.children = n || []),
        this.setAttribute(`href`, e));
    }
    setAttribute(e, t) {
      this.attributes[e] = t;
    }
    hasClass(e) {
      return this.classes.includes(e);
    }
    toNode() {
      return De.call(this, `a`);
    }
    toMarkup() {
      return ke.call(this, `a`);
    }
  },
  Me = class {
    constructor(e, t, n) {
      ((this.src = void 0),
        (this.alt = void 0),
        (this.classes = void 0),
        (this.height = void 0),
        (this.depth = void 0),
        (this.maxFontSize = void 0),
        (this.style = void 0),
        (this.alt = t),
        (this.src = e),
        (this.classes = [`mord`]),
        (this.height = 0),
        (this.depth = 0),
        (this.maxFontSize = 0),
        (this.style = n));
    }
    hasClass(e) {
      return this.classes.includes(e);
    }
    toNode() {
      var e = document.createElement(`img`);
      return (
        (e.src = this.src),
        (e.alt = this.alt),
        (e.className = `mord`),
        Object.assign(e.style, this.style),
        e
      );
    }
    toMarkup() {
      var e = `<img src="` + a(this.src) + `"` + (` alt="` + a(this.alt) + `"`),
        t = Te(this.style);
      return (t && (e += ` style="` + a(t) + `"`), (e += `'/>`), e);
    }
  },
  Ne = {
    î: `ı̂`,
    ï: `ı̈`,
    í: `ı́`,
    ì: `ı̀`,
  },
  Pe = class {
    constructor(e, t, n, r, i, a, o, s) {
      ((this.text = void 0),
        (this.height = void 0),
        (this.depth = void 0),
        (this.italic = void 0),
        (this.skew = void 0),
        (this.width = void 0),
        (this.maxFontSize = void 0),
        (this.classes = void 0),
        (this.style = void 0),
        (this.text = e),
        (this.height = t || 0),
        (this.depth = n || 0),
        (this.italic = r || 0),
        (this.skew = i || 0),
        (this.width = a || 0),
        (this.classes = o || []),
        (this.style = s || {}),
        (this.maxFontSize = 0));
      var c = oe(this.text.charCodeAt(0));
      (c && this.classes.push(c + `_fallback`),
        /[îïíì]/.test(this.text) && (this.text = Ne[this.text]));
    }
    hasClass(e) {
      return this.classes.includes(e);
    }
    toNode() {
      var e = document.createTextNode(this.text),
        t = null;
      return (
        this.italic > 0 &&
          ((t = document.createElement(`span`)), (t.style.marginRight = A(this.italic))),
        this.classes.length > 0 &&
          ((t ||= document.createElement(`span`)), (t.className = j(this.classes))),
        Object.keys(this.style).length > 0 &&
          ((t ||= document.createElement(`span`)), Object.assign(t.style, this.style)),
        t ? (t.appendChild(e), t) : e
      );
    }
    toMarkup() {
      var e = !1,
        t = `<span`;
      this.classes.length && ((e = !0), (t += ` class="`), (t += a(j(this.classes))), (t += `"`));
      var n = ``;
      (this.italic > 0 && (n += `margin-right:` + A(this.italic) + `;`),
        (n += Te(this.style)),
        n && ((e = !0), (t += ` style="` + a(n) + `"`)));
      var r = a(this.text);
      return e ? ((t += `>`), (t += r), (t += `</span>`), t) : r;
    }
  },
  Fe = class {
    constructor(e, t) {
      ((this.children = void 0),
        (this.attributes = void 0),
        (this.children = e || []),
        (this.attributes = t || {}));
    }
    toNode() {
      var e = document.createElementNS(`http://www.w3.org/2000/svg`, `svg`);
      for (var t of Object.keys(this.attributes)) e.setAttribute(t, this.attributes[t]);
      for (var n = 0; n < this.children.length; n++) e.appendChild(this.children[n].toNode());
      return e;
    }
    toMarkup() {
      var e = `<svg xmlns="http://www.w3.org/2000/svg"`;
      for (var t of Object.keys(this.attributes)) e += ` ` + t + `="` + a(this.attributes[t]) + `"`;
      e += `>`;
      for (var n = 0; n < this.children.length; n++) e += this.children[n].toMarkup();
      return ((e += `</svg>`), e);
    }
  },
  Ie = class {
    constructor(e, t) {
      ((this.pathName = void 0),
        (this.alternate = void 0),
        (this.pathName = e),
        (this.alternate = t));
    }
    toNode() {
      var e = document.createElementNS(`http://www.w3.org/2000/svg`, `path`);
      return (
        this.alternate
          ? e.setAttribute(`d`, this.alternate)
          : e.setAttribute(`d`, ve[this.pathName]),
        e
      );
    }
    toMarkup() {
      return this.alternate
        ? `<path d="` + a(this.alternate) + `"/>`
        : `<path d="` + a(ve[this.pathName]) + `"/>`;
    }
  },
  Le = class {
    constructor(e) {
      ((this.attributes = void 0), (this.attributes = e || {}));
    }
    toNode() {
      var e = document.createElementNS(`http://www.w3.org/2000/svg`, `line`);
      for (var t of Object.keys(this.attributes)) e.setAttribute(t, this.attributes[t]);
      return e;
    }
    toMarkup() {
      var e = `<line`;
      for (var t of Object.keys(this.attributes)) e += ` ` + t + `="` + a(this.attributes[t]) + `"`;
      return ((e += `/>`), e);
    }
  };
function Re(e) {
  if (e instanceof Pe) return e;
  throw Error(`Expected symbolNode but got ` + String(e) + `.`);
}
function ze(e) {
  if (e instanceof Ae) return e;
  throw Error(`Expected span<HtmlDomNode> but got ` + String(e) + `.`);
}
var Be = (e) => e instanceof Ae || e instanceof je || e instanceof xe,
  Ve = {
    "AMS-Regular": {
      32: [0, 0, 0, 0, 0.25],
      65: [0, 0.68889, 0, 0, 0.72222],
      66: [0, 0.68889, 0, 0, 0.66667],
      67: [0, 0.68889, 0, 0, 0.72222],
      68: [0, 0.68889, 0, 0, 0.72222],
      69: [0, 0.68889, 0, 0, 0.66667],
      70: [0, 0.68889, 0, 0, 0.61111],
      71: [0, 0.68889, 0, 0, 0.77778],
      72: [0, 0.68889, 0, 0, 0.77778],
      73: [0, 0.68889, 0, 0, 0.38889],
      74: [0.16667, 0.68889, 0, 0, 0.5],
      75: [0, 0.68889, 0, 0, 0.77778],
      76: [0, 0.68889, 0, 0, 0.66667],
      77: [0, 0.68889, 0, 0, 0.94445],
      78: [0, 0.68889, 0, 0, 0.72222],
      79: [0.16667, 0.68889, 0, 0, 0.77778],
      80: [0, 0.68889, 0, 0, 0.61111],
      81: [0.16667, 0.68889, 0, 0, 0.77778],
      82: [0, 0.68889, 0, 0, 0.72222],
      83: [0, 0.68889, 0, 0, 0.55556],
      84: [0, 0.68889, 0, 0, 0.66667],
      85: [0, 0.68889, 0, 0, 0.72222],
      86: [0, 0.68889, 0, 0, 0.72222],
      87: [0, 0.68889, 0, 0, 1],
      88: [0, 0.68889, 0, 0, 0.72222],
      89: [0, 0.68889, 0, 0, 0.72222],
      90: [0, 0.68889, 0, 0, 0.66667],
      107: [0, 0.68889, 0, 0, 0.55556],
      160: [0, 0, 0, 0, 0.25],
      165: [0, 0.675, 0.025, 0, 0.75],
      174: [0.15559, 0.69224, 0, 0, 0.94666],
      240: [0, 0.68889, 0, 0, 0.55556],
      295: [0, 0.68889, 0, 0, 0.54028],
      710: [0, 0.825, 0, 0, 2.33334],
      732: [0, 0.9, 0, 0, 2.33334],
      770: [0, 0.825, 0, 0, 2.33334],
      771: [0, 0.9, 0, 0, 2.33334],
      989: [0.08167, 0.58167, 0, 0, 0.77778],
      1008: [0, 0.43056, 0.04028, 0, 0.66667],
      8245: [0, 0.54986, 0, 0, 0.275],
      8463: [0, 0.68889, 0, 0, 0.54028],
      8487: [0, 0.68889, 0, 0, 0.72222],
      8498: [0, 0.68889, 0, 0, 0.55556],
      8502: [0, 0.68889, 0, 0, 0.66667],
      8503: [0, 0.68889, 0, 0, 0.44445],
      8504: [0, 0.68889, 0, 0, 0.66667],
      8513: [0, 0.68889, 0, 0, 0.63889],
      8592: [-0.03598, 0.46402, 0, 0, 0.5],
      8594: [-0.03598, 0.46402, 0, 0, 0.5],
      8602: [-0.13313, 0.36687, 0, 0, 1],
      8603: [-0.13313, 0.36687, 0, 0, 1],
      8606: [0.01354, 0.52239, 0, 0, 1],
      8608: [0.01354, 0.52239, 0, 0, 1],
      8610: [0.01354, 0.52239, 0, 0, 1.11111],
      8611: [0.01354, 0.52239, 0, 0, 1.11111],
      8619: [0, 0.54986, 0, 0, 1],
      8620: [0, 0.54986, 0, 0, 1],
      8621: [-0.13313, 0.37788, 0, 0, 1.38889],
      8622: [-0.13313, 0.36687, 0, 0, 1],
      8624: [0, 0.69224, 0, 0, 0.5],
      8625: [0, 0.69224, 0, 0, 0.5],
      8630: [0, 0.43056, 0, 0, 1],
      8631: [0, 0.43056, 0, 0, 1],
      8634: [0.08198, 0.58198, 0, 0, 0.77778],
      8635: [0.08198, 0.58198, 0, 0, 0.77778],
      8638: [0.19444, 0.69224, 0, 0, 0.41667],
      8639: [0.19444, 0.69224, 0, 0, 0.41667],
      8642: [0.19444, 0.69224, 0, 0, 0.41667],
      8643: [0.19444, 0.69224, 0, 0, 0.41667],
      8644: [0.1808, 0.675, 0, 0, 1],
      8646: [0.1808, 0.675, 0, 0, 1],
      8647: [0.1808, 0.675, 0, 0, 1],
      8648: [0.19444, 0.69224, 0, 0, 0.83334],
      8649: [0.1808, 0.675, 0, 0, 1],
      8650: [0.19444, 0.69224, 0, 0, 0.83334],
      8651: [0.01354, 0.52239, 0, 0, 1],
      8652: [0.01354, 0.52239, 0, 0, 1],
      8653: [-0.13313, 0.36687, 0, 0, 1],
      8654: [-0.13313, 0.36687, 0, 0, 1],
      8655: [-0.13313, 0.36687, 0, 0, 1],
      8666: [0.13667, 0.63667, 0, 0, 1],
      8667: [0.13667, 0.63667, 0, 0, 1],
      8669: [-0.13313, 0.37788, 0, 0, 1],
      8672: [-0.064, 0.437, 0, 0, 1.334],
      8674: [-0.064, 0.437, 0, 0, 1.334],
      8705: [0, 0.825, 0, 0, 0.5],
      8708: [0, 0.68889, 0, 0, 0.55556],
      8709: [0.08167, 0.58167, 0, 0, 0.77778],
      8717: [0, 0.43056, 0, 0, 0.42917],
      8722: [-0.03598, 0.46402, 0, 0, 0.5],
      8724: [0.08198, 0.69224, 0, 0, 0.77778],
      8726: [0.08167, 0.58167, 0, 0, 0.77778],
      8733: [0, 0.69224, 0, 0, 0.77778],
      8736: [0, 0.69224, 0, 0, 0.72222],
      8737: [0, 0.69224, 0, 0, 0.72222],
      8738: [0.03517, 0.52239, 0, 0, 0.72222],
      8739: [0.08167, 0.58167, 0, 0, 0.22222],
      8740: [0.25142, 0.74111, 0, 0, 0.27778],
      8741: [0.08167, 0.58167, 0, 0, 0.38889],
      8742: [0.25142, 0.74111, 0, 0, 0.5],
      8756: [0, 0.69224, 0, 0, 0.66667],
      8757: [0, 0.69224, 0, 0, 0.66667],
      8764: [-0.13313, 0.36687, 0, 0, 0.77778],
      8765: [-0.13313, 0.37788, 0, 0, 0.77778],
      8769: [-0.13313, 0.36687, 0, 0, 0.77778],
      8770: [-0.03625, 0.46375, 0, 0, 0.77778],
      8774: [0.30274, 0.79383, 0, 0, 0.77778],
      8776: [-0.01688, 0.48312, 0, 0, 0.77778],
      8778: [0.08167, 0.58167, 0, 0, 0.77778],
      8782: [0.06062, 0.54986, 0, 0, 0.77778],
      8783: [0.06062, 0.54986, 0, 0, 0.77778],
      8785: [0.08198, 0.58198, 0, 0, 0.77778],
      8786: [0.08198, 0.58198, 0, 0, 0.77778],
      8787: [0.08198, 0.58198, 0, 0, 0.77778],
      8790: [0, 0.69224, 0, 0, 0.77778],
      8791: [0.22958, 0.72958, 0, 0, 0.77778],
      8796: [0.08198, 0.91667, 0, 0, 0.77778],
      8806: [0.25583, 0.75583, 0, 0, 0.77778],
      8807: [0.25583, 0.75583, 0, 0, 0.77778],
      8808: [0.25142, 0.75726, 0, 0, 0.77778],
      8809: [0.25142, 0.75726, 0, 0, 0.77778],
      8812: [0.25583, 0.75583, 0, 0, 0.5],
      8814: [0.20576, 0.70576, 0, 0, 0.77778],
      8815: [0.20576, 0.70576, 0, 0, 0.77778],
      8816: [0.30274, 0.79383, 0, 0, 0.77778],
      8817: [0.30274, 0.79383, 0, 0, 0.77778],
      8818: [0.22958, 0.72958, 0, 0, 0.77778],
      8819: [0.22958, 0.72958, 0, 0, 0.77778],
      8822: [0.1808, 0.675, 0, 0, 0.77778],
      8823: [0.1808, 0.675, 0, 0, 0.77778],
      8828: [0.13667, 0.63667, 0, 0, 0.77778],
      8829: [0.13667, 0.63667, 0, 0, 0.77778],
      8830: [0.22958, 0.72958, 0, 0, 0.77778],
      8831: [0.22958, 0.72958, 0, 0, 0.77778],
      8832: [0.20576, 0.70576, 0, 0, 0.77778],
      8833: [0.20576, 0.70576, 0, 0, 0.77778],
      8840: [0.30274, 0.79383, 0, 0, 0.77778],
      8841: [0.30274, 0.79383, 0, 0, 0.77778],
      8842: [0.13597, 0.63597, 0, 0, 0.77778],
      8843: [0.13597, 0.63597, 0, 0, 0.77778],
      8847: [0.03517, 0.54986, 0, 0, 0.77778],
      8848: [0.03517, 0.54986, 0, 0, 0.77778],
      8858: [0.08198, 0.58198, 0, 0, 0.77778],
      8859: [0.08198, 0.58198, 0, 0, 0.77778],
      8861: [0.08198, 0.58198, 0, 0, 0.77778],
      8862: [0, 0.675, 0, 0, 0.77778],
      8863: [0, 0.675, 0, 0, 0.77778],
      8864: [0, 0.675, 0, 0, 0.77778],
      8865: [0, 0.675, 0, 0, 0.77778],
      8872: [0, 0.69224, 0, 0, 0.61111],
      8873: [0, 0.69224, 0, 0, 0.72222],
      8874: [0, 0.69224, 0, 0, 0.88889],
      8876: [0, 0.68889, 0, 0, 0.61111],
      8877: [0, 0.68889, 0, 0, 0.61111],
      8878: [0, 0.68889, 0, 0, 0.72222],
      8879: [0, 0.68889, 0, 0, 0.72222],
      8882: [0.03517, 0.54986, 0, 0, 0.77778],
      8883: [0.03517, 0.54986, 0, 0, 0.77778],
      8884: [0.13667, 0.63667, 0, 0, 0.77778],
      8885: [0.13667, 0.63667, 0, 0, 0.77778],
      8888: [0, 0.54986, 0, 0, 1.11111],
      8890: [0.19444, 0.43056, 0, 0, 0.55556],
      8891: [0.19444, 0.69224, 0, 0, 0.61111],
      8892: [0.19444, 0.69224, 0, 0, 0.61111],
      8901: [0, 0.54986, 0, 0, 0.27778],
      8903: [0.08167, 0.58167, 0, 0, 0.77778],
      8905: [0.08167, 0.58167, 0, 0, 0.77778],
      8906: [0.08167, 0.58167, 0, 0, 0.77778],
      8907: [0, 0.69224, 0, 0, 0.77778],
      8908: [0, 0.69224, 0, 0, 0.77778],
      8909: [-0.03598, 0.46402, 0, 0, 0.77778],
      8910: [0, 0.54986, 0, 0, 0.76042],
      8911: [0, 0.54986, 0, 0, 0.76042],
      8912: [0.03517, 0.54986, 0, 0, 0.77778],
      8913: [0.03517, 0.54986, 0, 0, 0.77778],
      8914: [0, 0.54986, 0, 0, 0.66667],
      8915: [0, 0.54986, 0, 0, 0.66667],
      8916: [0, 0.69224, 0, 0, 0.66667],
      8918: [0.0391, 0.5391, 0, 0, 0.77778],
      8919: [0.0391, 0.5391, 0, 0, 0.77778],
      8920: [0.03517, 0.54986, 0, 0, 1.33334],
      8921: [0.03517, 0.54986, 0, 0, 1.33334],
      8922: [0.38569, 0.88569, 0, 0, 0.77778],
      8923: [0.38569, 0.88569, 0, 0, 0.77778],
      8926: [0.13667, 0.63667, 0, 0, 0.77778],
      8927: [0.13667, 0.63667, 0, 0, 0.77778],
      8928: [0.30274, 0.79383, 0, 0, 0.77778],
      8929: [0.30274, 0.79383, 0, 0, 0.77778],
      8934: [0.23222, 0.74111, 0, 0, 0.77778],
      8935: [0.23222, 0.74111, 0, 0, 0.77778],
      8936: [0.23222, 0.74111, 0, 0, 0.77778],
      8937: [0.23222, 0.74111, 0, 0, 0.77778],
      8938: [0.20576, 0.70576, 0, 0, 0.77778],
      8939: [0.20576, 0.70576, 0, 0, 0.77778],
      8940: [0.30274, 0.79383, 0, 0, 0.77778],
      8941: [0.30274, 0.79383, 0, 0, 0.77778],
      8994: [0.19444, 0.69224, 0, 0, 0.77778],
      8995: [0.19444, 0.69224, 0, 0, 0.77778],
      9416: [0.15559, 0.69224, 0, 0, 0.90222],
      9484: [0, 0.69224, 0, 0, 0.5],
      9488: [0, 0.69224, 0, 0, 0.5],
      9492: [0, 0.37788, 0, 0, 0.5],
      9496: [0, 0.37788, 0, 0, 0.5],
      9585: [0.19444, 0.68889, 0, 0, 0.88889],
      9586: [0.19444, 0.74111, 0, 0, 0.88889],
      9632: [0, 0.675, 0, 0, 0.77778],
      9633: [0, 0.675, 0, 0, 0.77778],
      9650: [0, 0.54986, 0, 0, 0.72222],
      9651: [0, 0.54986, 0, 0, 0.72222],
      9654: [0.03517, 0.54986, 0, 0, 0.77778],
      9660: [0, 0.54986, 0, 0, 0.72222],
      9661: [0, 0.54986, 0, 0, 0.72222],
      9664: [0.03517, 0.54986, 0, 0, 0.77778],
      9674: [0.11111, 0.69224, 0, 0, 0.66667],
      9733: [0.19444, 0.69224, 0, 0, 0.94445],
      10003: [0, 0.69224, 0, 0, 0.83334],
      10016: [0, 0.69224, 0, 0, 0.83334],
      10731: [0.11111, 0.69224, 0, 0, 0.66667],
      10846: [0.19444, 0.75583, 0, 0, 0.61111],
      10877: [0.13667, 0.63667, 0, 0, 0.77778],
      10878: [0.13667, 0.63667, 0, 0, 0.77778],
      10885: [0.25583, 0.75583, 0, 0, 0.77778],
      10886: [0.25583, 0.75583, 0, 0, 0.77778],
      10887: [0.13597, 0.63597, 0, 0, 0.77778],
      10888: [0.13597, 0.63597, 0, 0, 0.77778],
      10889: [0.26167, 0.75726, 0, 0, 0.77778],
      10890: [0.26167, 0.75726, 0, 0, 0.77778],
      10891: [0.48256, 0.98256, 0, 0, 0.77778],
      10892: [0.48256, 0.98256, 0, 0, 0.77778],
      10901: [0.13667, 0.63667, 0, 0, 0.77778],
      10902: [0.13667, 0.63667, 0, 0, 0.77778],
      10933: [0.25142, 0.75726, 0, 0, 0.77778],
      10934: [0.25142, 0.75726, 0, 0, 0.77778],
      10935: [0.26167, 0.75726, 0, 0, 0.77778],
      10936: [0.26167, 0.75726, 0, 0, 0.77778],
      10937: [0.26167, 0.75726, 0, 0, 0.77778],
      10938: [0.26167, 0.75726, 0, 0, 0.77778],
      10949: [0.25583, 0.75583, 0, 0, 0.77778],
      10950: [0.25583, 0.75583, 0, 0, 0.77778],
      10955: [0.28481, 0.79383, 0, 0, 0.77778],
      10956: [0.28481, 0.79383, 0, 0, 0.77778],
      57350: [0.08167, 0.58167, 0, 0, 0.22222],
      57351: [0.08167, 0.58167, 0, 0, 0.38889],
      57352: [0.08167, 0.58167, 0, 0, 0.77778],
      57353: [0, 0.43056, 0.04028, 0, 0.66667],
      57356: [0.25142, 0.75726, 0, 0, 0.77778],
      57357: [0.25142, 0.75726, 0, 0, 0.77778],
      57358: [0.41951, 0.91951, 0, 0, 0.77778],
      57359: [0.30274, 0.79383, 0, 0, 0.77778],
      57360: [0.30274, 0.79383, 0, 0, 0.77778],
      57361: [0.41951, 0.91951, 0, 0, 0.77778],
      57366: [0.25142, 0.75726, 0, 0, 0.77778],
      57367: [0.25142, 0.75726, 0, 0, 0.77778],
      57368: [0.25142, 0.75726, 0, 0, 0.77778],
      57369: [0.25142, 0.75726, 0, 0, 0.77778],
      57370: [0.13597, 0.63597, 0, 0, 0.77778],
      57371: [0.13597, 0.63597, 0, 0, 0.77778],
    },
    "Caligraphic-Regular": {
      32: [0, 0, 0, 0, 0.25],
      65: [0, 0.68333, 0, 0.19445, 0.79847],
      66: [0, 0.68333, 0.03041, 0.13889, 0.65681],
      67: [0, 0.68333, 0.05834, 0.13889, 0.52653],
      68: [0, 0.68333, 0.02778, 0.08334, 0.77139],
      69: [0, 0.68333, 0.08944, 0.11111, 0.52778],
      70: [0, 0.68333, 0.09931, 0.11111, 0.71875],
      71: [0.09722, 0.68333, 0.0593, 0.11111, 0.59487],
      72: [0, 0.68333, 0.00965, 0.11111, 0.84452],
      73: [0, 0.68333, 0.07382, 0, 0.54452],
      74: [0.09722, 0.68333, 0.18472, 0.16667, 0.67778],
      75: [0, 0.68333, 0.01445, 0.05556, 0.76195],
      76: [0, 0.68333, 0, 0.13889, 0.68972],
      77: [0, 0.68333, 0, 0.13889, 1.2009],
      78: [0, 0.68333, 0.14736, 0.08334, 0.82049],
      79: [0, 0.68333, 0.02778, 0.11111, 0.79611],
      80: [0, 0.68333, 0.08222, 0.08334, 0.69556],
      81: [0.09722, 0.68333, 0, 0.11111, 0.81667],
      82: [0, 0.68333, 0, 0.08334, 0.8475],
      83: [0, 0.68333, 0.075, 0.13889, 0.60556],
      84: [0, 0.68333, 0.25417, 0, 0.54464],
      85: [0, 0.68333, 0.09931, 0.08334, 0.62583],
      86: [0, 0.68333, 0.08222, 0, 0.61278],
      87: [0, 0.68333, 0.08222, 0.08334, 0.98778],
      88: [0, 0.68333, 0.14643, 0.13889, 0.7133],
      89: [0.09722, 0.68333, 0.08222, 0.08334, 0.66834],
      90: [0, 0.68333, 0.07944, 0.13889, 0.72473],
      160: [0, 0, 0, 0, 0.25],
    },
    "Fraktur-Regular": {
      32: [0, 0, 0, 0, 0.25],
      33: [0, 0.69141, 0, 0, 0.29574],
      34: [0, 0.69141, 0, 0, 0.21471],
      38: [0, 0.69141, 0, 0, 0.73786],
      39: [0, 0.69141, 0, 0, 0.21201],
      40: [0.24982, 0.74947, 0, 0, 0.38865],
      41: [0.24982, 0.74947, 0, 0, 0.38865],
      42: [0, 0.62119, 0, 0, 0.27764],
      43: [0.08319, 0.58283, 0, 0, 0.75623],
      44: [0, 0.10803, 0, 0, 0.27764],
      45: [0.08319, 0.58283, 0, 0, 0.75623],
      46: [0, 0.10803, 0, 0, 0.27764],
      47: [0.24982, 0.74947, 0, 0, 0.50181],
      48: [0, 0.47534, 0, 0, 0.50181],
      49: [0, 0.47534, 0, 0, 0.50181],
      50: [0, 0.47534, 0, 0, 0.50181],
      51: [0.18906, 0.47534, 0, 0, 0.50181],
      52: [0.18906, 0.47534, 0, 0, 0.50181],
      53: [0.18906, 0.47534, 0, 0, 0.50181],
      54: [0, 0.69141, 0, 0, 0.50181],
      55: [0.18906, 0.47534, 0, 0, 0.50181],
      56: [0, 0.69141, 0, 0, 0.50181],
      57: [0.18906, 0.47534, 0, 0, 0.50181],
      58: [0, 0.47534, 0, 0, 0.21606],
      59: [0.12604, 0.47534, 0, 0, 0.21606],
      61: [-0.13099, 0.36866, 0, 0, 0.75623],
      63: [0, 0.69141, 0, 0, 0.36245],
      65: [0, 0.69141, 0, 0, 0.7176],
      66: [0, 0.69141, 0, 0, 0.88397],
      67: [0, 0.69141, 0, 0, 0.61254],
      68: [0, 0.69141, 0, 0, 0.83158],
      69: [0, 0.69141, 0, 0, 0.66278],
      70: [0.12604, 0.69141, 0, 0, 0.61119],
      71: [0, 0.69141, 0, 0, 0.78539],
      72: [0.06302, 0.69141, 0, 0, 0.7203],
      73: [0, 0.69141, 0, 0, 0.55448],
      74: [0.12604, 0.69141, 0, 0, 0.55231],
      75: [0, 0.69141, 0, 0, 0.66845],
      76: [0, 0.69141, 0, 0, 0.66602],
      77: [0, 0.69141, 0, 0, 1.04953],
      78: [0, 0.69141, 0, 0, 0.83212],
      79: [0, 0.69141, 0, 0, 0.82699],
      80: [0.18906, 0.69141, 0, 0, 0.82753],
      81: [0.03781, 0.69141, 0, 0, 0.82699],
      82: [0, 0.69141, 0, 0, 0.82807],
      83: [0, 0.69141, 0, 0, 0.82861],
      84: [0, 0.69141, 0, 0, 0.66899],
      85: [0, 0.69141, 0, 0, 0.64576],
      86: [0, 0.69141, 0, 0, 0.83131],
      87: [0, 0.69141, 0, 0, 1.04602],
      88: [0, 0.69141, 0, 0, 0.71922],
      89: [0.18906, 0.69141, 0, 0, 0.83293],
      90: [0.12604, 0.69141, 0, 0, 0.60201],
      91: [0.24982, 0.74947, 0, 0, 0.27764],
      93: [0.24982, 0.74947, 0, 0, 0.27764],
      94: [0, 0.69141, 0, 0, 0.49965],
      97: [0, 0.47534, 0, 0, 0.50046],
      98: [0, 0.69141, 0, 0, 0.51315],
      99: [0, 0.47534, 0, 0, 0.38946],
      100: [0, 0.62119, 0, 0, 0.49857],
      101: [0, 0.47534, 0, 0, 0.40053],
      102: [0.18906, 0.69141, 0, 0, 0.32626],
      103: [0.18906, 0.47534, 0, 0, 0.5037],
      104: [0.18906, 0.69141, 0, 0, 0.52126],
      105: [0, 0.69141, 0, 0, 0.27899],
      106: [0, 0.69141, 0, 0, 0.28088],
      107: [0, 0.69141, 0, 0, 0.38946],
      108: [0, 0.69141, 0, 0, 0.27953],
      109: [0, 0.47534, 0, 0, 0.76676],
      110: [0, 0.47534, 0, 0, 0.52666],
      111: [0, 0.47534, 0, 0, 0.48885],
      112: [0.18906, 0.52396, 0, 0, 0.50046],
      113: [0.18906, 0.47534, 0, 0, 0.48912],
      114: [0, 0.47534, 0, 0, 0.38919],
      115: [0, 0.47534, 0, 0, 0.44266],
      116: [0, 0.62119, 0, 0, 0.33301],
      117: [0, 0.47534, 0, 0, 0.5172],
      118: [0, 0.52396, 0, 0, 0.5118],
      119: [0, 0.52396, 0, 0, 0.77351],
      120: [0.18906, 0.47534, 0, 0, 0.38865],
      121: [0.18906, 0.47534, 0, 0, 0.49884],
      122: [0.18906, 0.47534, 0, 0, 0.39054],
      160: [0, 0, 0, 0, 0.25],
      8216: [0, 0.69141, 0, 0, 0.21471],
      8217: [0, 0.69141, 0, 0, 0.21471],
      58112: [0, 0.62119, 0, 0, 0.49749],
      58113: [0, 0.62119, 0, 0, 0.4983],
      58114: [0.18906, 0.69141, 0, 0, 0.33328],
      58115: [0.18906, 0.69141, 0, 0, 0.32923],
      58116: [0.18906, 0.47534, 0, 0, 0.50343],
      58117: [0, 0.69141, 0, 0, 0.33301],
      58118: [0, 0.62119, 0, 0, 0.33409],
      58119: [0, 0.47534, 0, 0, 0.50073],
    },
    "Main-Bold": {
      32: [0, 0, 0, 0, 0.25],
      33: [0, 0.69444, 0, 0, 0.35],
      34: [0, 0.69444, 0, 0, 0.60278],
      35: [0.19444, 0.69444, 0, 0, 0.95833],
      36: [0.05556, 0.75, 0, 0, 0.575],
      37: [0.05556, 0.75, 0, 0, 0.95833],
      38: [0, 0.69444, 0, 0, 0.89444],
      39: [0, 0.69444, 0, 0, 0.31944],
      40: [0.25, 0.75, 0, 0, 0.44722],
      41: [0.25, 0.75, 0, 0, 0.44722],
      42: [0, 0.75, 0, 0, 0.575],
      43: [0.13333, 0.63333, 0, 0, 0.89444],
      44: [0.19444, 0.15556, 0, 0, 0.31944],
      45: [0, 0.44444, 0, 0, 0.38333],
      46: [0, 0.15556, 0, 0, 0.31944],
      47: [0.25, 0.75, 0, 0, 0.575],
      48: [0, 0.64444, 0, 0, 0.575],
      49: [0, 0.64444, 0, 0, 0.575],
      50: [0, 0.64444, 0, 0, 0.575],
      51: [0, 0.64444, 0, 0, 0.575],
      52: [0, 0.64444, 0, 0, 0.575],
      53: [0, 0.64444, 0, 0, 0.575],
      54: [0, 0.64444, 0, 0, 0.575],
      55: [0, 0.64444, 0, 0, 0.575],
      56: [0, 0.64444, 0, 0, 0.575],
      57: [0, 0.64444, 0, 0, 0.575],
      58: [0, 0.44444, 0, 0, 0.31944],
      59: [0.19444, 0.44444, 0, 0, 0.31944],
      60: [0.08556, 0.58556, 0, 0, 0.89444],
      61: [-0.10889, 0.39111, 0, 0, 0.89444],
      62: [0.08556, 0.58556, 0, 0, 0.89444],
      63: [0, 0.69444, 0, 0, 0.54305],
      64: [0, 0.69444, 0, 0, 0.89444],
      65: [0, 0.68611, 0, 0, 0.86944],
      66: [0, 0.68611, 0, 0, 0.81805],
      67: [0, 0.68611, 0, 0, 0.83055],
      68: [0, 0.68611, 0, 0, 0.88194],
      69: [0, 0.68611, 0, 0, 0.75555],
      70: [0, 0.68611, 0, 0, 0.72361],
      71: [0, 0.68611, 0, 0, 0.90416],
      72: [0, 0.68611, 0, 0, 0.9],
      73: [0, 0.68611, 0, 0, 0.43611],
      74: [0, 0.68611, 0, 0, 0.59444],
      75: [0, 0.68611, 0, 0, 0.90138],
      76: [0, 0.68611, 0, 0, 0.69166],
      77: [0, 0.68611, 0, 0, 1.09166],
      78: [0, 0.68611, 0, 0, 0.9],
      79: [0, 0.68611, 0, 0, 0.86388],
      80: [0, 0.68611, 0, 0, 0.78611],
      81: [0.19444, 0.68611, 0, 0, 0.86388],
      82: [0, 0.68611, 0, 0, 0.8625],
      83: [0, 0.68611, 0, 0, 0.63889],
      84: [0, 0.68611, 0, 0, 0.8],
      85: [0, 0.68611, 0, 0, 0.88472],
      86: [0, 0.68611, 0.01597, 0, 0.86944],
      87: [0, 0.68611, 0.01597, 0, 1.18888],
      88: [0, 0.68611, 0, 0, 0.86944],
      89: [0, 0.68611, 0.02875, 0, 0.86944],
      90: [0, 0.68611, 0, 0, 0.70277],
      91: [0.25, 0.75, 0, 0, 0.31944],
      92: [0.25, 0.75, 0, 0, 0.575],
      93: [0.25, 0.75, 0, 0, 0.31944],
      94: [0, 0.69444, 0, 0, 0.575],
      95: [0.31, 0.13444, 0.03194, 0, 0.575],
      97: [0, 0.44444, 0, 0, 0.55902],
      98: [0, 0.69444, 0, 0, 0.63889],
      99: [0, 0.44444, 0, 0, 0.51111],
      100: [0, 0.69444, 0, 0, 0.63889],
      101: [0, 0.44444, 0, 0, 0.52708],
      102: [0, 0.69444, 0.10903, 0, 0.35139],
      103: [0.19444, 0.44444, 0.01597, 0, 0.575],
      104: [0, 0.69444, 0, 0, 0.63889],
      105: [0, 0.69444, 0, 0, 0.31944],
      106: [0.19444, 0.69444, 0, 0, 0.35139],
      107: [0, 0.69444, 0, 0, 0.60694],
      108: [0, 0.69444, 0, 0, 0.31944],
      109: [0, 0.44444, 0, 0, 0.95833],
      110: [0, 0.44444, 0, 0, 0.63889],
      111: [0, 0.44444, 0, 0, 0.575],
      112: [0.19444, 0.44444, 0, 0, 0.63889],
      113: [0.19444, 0.44444, 0, 0, 0.60694],
      114: [0, 0.44444, 0, 0, 0.47361],
      115: [0, 0.44444, 0, 0, 0.45361],
      116: [0, 0.63492, 0, 0, 0.44722],
      117: [0, 0.44444, 0, 0, 0.63889],
      118: [0, 0.44444, 0.01597, 0, 0.60694],
      119: [0, 0.44444, 0.01597, 0, 0.83055],
      120: [0, 0.44444, 0, 0, 0.60694],
      121: [0.19444, 0.44444, 0.01597, 0, 0.60694],
      122: [0, 0.44444, 0, 0, 0.51111],
      123: [0.25, 0.75, 0, 0, 0.575],
      124: [0.25, 0.75, 0, 0, 0.31944],
      125: [0.25, 0.75, 0, 0, 0.575],
      126: [0.35, 0.34444, 0, 0, 0.575],
      160: [0, 0, 0, 0, 0.25],
      163: [0, 0.69444, 0, 0, 0.86853],
      168: [0, 0.69444, 0, 0, 0.575],
      172: [0, 0.44444, 0, 0, 0.76666],
      176: [0, 0.69444, 0, 0, 0.86944],
      177: [0.13333, 0.63333, 0, 0, 0.89444],
      184: [0.17014, 0, 0, 0, 0.51111],
      198: [0, 0.68611, 0, 0, 1.04166],
      215: [0.13333, 0.63333, 0, 0, 0.89444],
      216: [0.04861, 0.73472, 0, 0, 0.89444],
      223: [0, 0.69444, 0, 0, 0.59722],
      230: [0, 0.44444, 0, 0, 0.83055],
      247: [0.13333, 0.63333, 0, 0, 0.89444],
      248: [0.09722, 0.54167, 0, 0, 0.575],
      305: [0, 0.44444, 0, 0, 0.31944],
      338: [0, 0.68611, 0, 0, 1.16944],
      339: [0, 0.44444, 0, 0, 0.89444],
      567: [0.19444, 0.44444, 0, 0, 0.35139],
      710: [0, 0.69444, 0, 0, 0.575],
      711: [0, 0.63194, 0, 0, 0.575],
      713: [0, 0.59611, 0, 0, 0.575],
      714: [0, 0.69444, 0, 0, 0.575],
      715: [0, 0.69444, 0, 0, 0.575],
      728: [0, 0.69444, 0, 0, 0.575],
      729: [0, 0.69444, 0, 0, 0.31944],
      730: [0, 0.69444, 0, 0, 0.86944],
      732: [0, 0.69444, 0, 0, 0.575],
      733: [0, 0.69444, 0, 0, 0.575],
      915: [0, 0.68611, 0, 0, 0.69166],
      916: [0, 0.68611, 0, 0, 0.95833],
      920: [0, 0.68611, 0, 0, 0.89444],
      923: [0, 0.68611, 0, 0, 0.80555],
      926: [0, 0.68611, 0, 0, 0.76666],
      928: [0, 0.68611, 0, 0, 0.9],
      931: [0, 0.68611, 0, 0, 0.83055],
      933: [0, 0.68611, 0, 0, 0.89444],
      934: [0, 0.68611, 0, 0, 0.83055],
      936: [0, 0.68611, 0, 0, 0.89444],
      937: [0, 0.68611, 0, 0, 0.83055],
      8211: [0, 0.44444, 0.03194, 0, 0.575],
      8212: [0, 0.44444, 0.03194, 0, 1.14999],
      8216: [0, 0.69444, 0, 0, 0.31944],
      8217: [0, 0.69444, 0, 0, 0.31944],
      8220: [0, 0.69444, 0, 0, 0.60278],
      8221: [0, 0.69444, 0, 0, 0.60278],
      8224: [0.19444, 0.69444, 0, 0, 0.51111],
      8225: [0.19444, 0.69444, 0, 0, 0.51111],
      8242: [0, 0.55556, 0, 0, 0.34444],
      8407: [0, 0.72444, 0.15486, 0, 0.575],
      8463: [0, 0.69444, 0, 0, 0.66759],
      8465: [0, 0.69444, 0, 0, 0.83055],
      8467: [0, 0.69444, 0, 0, 0.47361],
      8472: [0.19444, 0.44444, 0, 0, 0.74027],
      8476: [0, 0.69444, 0, 0, 0.83055],
      8501: [0, 0.69444, 0, 0, 0.70277],
      8592: [-0.10889, 0.39111, 0, 0, 1.14999],
      8593: [0.19444, 0.69444, 0, 0, 0.575],
      8594: [-0.10889, 0.39111, 0, 0, 1.14999],
      8595: [0.19444, 0.69444, 0, 0, 0.575],
      8596: [-0.10889, 0.39111, 0, 0, 1.14999],
      8597: [0.25, 0.75, 0, 0, 0.575],
      8598: [0.19444, 0.69444, 0, 0, 1.14999],
      8599: [0.19444, 0.69444, 0, 0, 1.14999],
      8600: [0.19444, 0.69444, 0, 0, 1.14999],
      8601: [0.19444, 0.69444, 0, 0, 1.14999],
      8636: [-0.10889, 0.39111, 0, 0, 1.14999],
      8637: [-0.10889, 0.39111, 0, 0, 1.14999],
      8640: [-0.10889, 0.39111, 0, 0, 1.14999],
      8641: [-0.10889, 0.39111, 0, 0, 1.14999],
      8656: [-0.10889, 0.39111, 0, 0, 1.14999],
      8657: [0.19444, 0.69444, 0, 0, 0.70277],
      8658: [-0.10889, 0.39111, 0, 0, 1.14999],
      8659: [0.19444, 0.69444, 0, 0, 0.70277],
      8660: [-0.10889, 0.39111, 0, 0, 1.14999],
      8661: [0.25, 0.75, 0, 0, 0.70277],
      8704: [0, 0.69444, 0, 0, 0.63889],
      8706: [0, 0.69444, 0.06389, 0, 0.62847],
      8707: [0, 0.69444, 0, 0, 0.63889],
      8709: [0.05556, 0.75, 0, 0, 0.575],
      8711: [0, 0.68611, 0, 0, 0.95833],
      8712: [0.08556, 0.58556, 0, 0, 0.76666],
      8715: [0.08556, 0.58556, 0, 0, 0.76666],
      8722: [0.13333, 0.63333, 0, 0, 0.89444],
      8723: [0.13333, 0.63333, 0, 0, 0.89444],
      8725: [0.25, 0.75, 0, 0, 0.575],
      8726: [0.25, 0.75, 0, 0, 0.575],
      8727: [-0.02778, 0.47222, 0, 0, 0.575],
      8728: [-0.02639, 0.47361, 0, 0, 0.575],
      8729: [-0.02639, 0.47361, 0, 0, 0.575],
      8730: [0.18, 0.82, 0, 0, 0.95833],
      8733: [0, 0.44444, 0, 0, 0.89444],
      8734: [0, 0.44444, 0, 0, 1.14999],
      8736: [0, 0.69224, 0, 0, 0.72222],
      8739: [0.25, 0.75, 0, 0, 0.31944],
      8741: [0.25, 0.75, 0, 0, 0.575],
      8743: [0, 0.55556, 0, 0, 0.76666],
      8744: [0, 0.55556, 0, 0, 0.76666],
      8745: [0, 0.55556, 0, 0, 0.76666],
      8746: [0, 0.55556, 0, 0, 0.76666],
      8747: [0.19444, 0.69444, 0.12778, 0, 0.56875],
      8764: [-0.10889, 0.39111, 0, 0, 0.89444],
      8768: [0.19444, 0.69444, 0, 0, 0.31944],
      8771: [0.00222, 0.50222, 0, 0, 0.89444],
      8773: [0.027, 0.638, 0, 0, 0.894],
      8776: [0.02444, 0.52444, 0, 0, 0.89444],
      8781: [0.00222, 0.50222, 0, 0, 0.89444],
      8801: [0.00222, 0.50222, 0, 0, 0.89444],
      8804: [0.19667, 0.69667, 0, 0, 0.89444],
      8805: [0.19667, 0.69667, 0, 0, 0.89444],
      8810: [0.08556, 0.58556, 0, 0, 1.14999],
      8811: [0.08556, 0.58556, 0, 0, 1.14999],
      8826: [0.08556, 0.58556, 0, 0, 0.89444],
      8827: [0.08556, 0.58556, 0, 0, 0.89444],
      8834: [0.08556, 0.58556, 0, 0, 0.89444],
      8835: [0.08556, 0.58556, 0, 0, 0.89444],
      8838: [0.19667, 0.69667, 0, 0, 0.89444],
      8839: [0.19667, 0.69667, 0, 0, 0.89444],
      8846: [0, 0.55556, 0, 0, 0.76666],
      8849: [0.19667, 0.69667, 0, 0, 0.89444],
      8850: [0.19667, 0.69667, 0, 0, 0.89444],
      8851: [0, 0.55556, 0, 0, 0.76666],
      8852: [0, 0.55556, 0, 0, 0.76666],
      8853: [0.13333, 0.63333, 0, 0, 0.89444],
      8854: [0.13333, 0.63333, 0, 0, 0.89444],
      8855: [0.13333, 0.63333, 0, 0, 0.89444],
      8856: [0.13333, 0.63333, 0, 0, 0.89444],
      8857: [0.13333, 0.63333, 0, 0, 0.89444],
      8866: [0, 0.69444, 0, 0, 0.70277],
      8867: [0, 0.69444, 0, 0, 0.70277],
      8868: [0, 0.69444, 0, 0, 0.89444],
      8869: [0, 0.69444, 0, 0, 0.89444],
      8900: [-0.02639, 0.47361, 0, 0, 0.575],
      8901: [-0.02639, 0.47361, 0, 0, 0.31944],
      8902: [-0.02778, 0.47222, 0, 0, 0.575],
      8968: [0.25, 0.75, 0, 0, 0.51111],
      8969: [0.25, 0.75, 0, 0, 0.51111],
      8970: [0.25, 0.75, 0, 0, 0.51111],
      8971: [0.25, 0.75, 0, 0, 0.51111],
      8994: [-0.13889, 0.36111, 0, 0, 1.14999],
      8995: [-0.13889, 0.36111, 0, 0, 1.14999],
      9651: [0.19444, 0.69444, 0, 0, 1.02222],
      9657: [-0.02778, 0.47222, 0, 0, 0.575],
      9661: [0.19444, 0.69444, 0, 0, 1.02222],
      9667: [-0.02778, 0.47222, 0, 0, 0.575],
      9711: [0.19444, 0.69444, 0, 0, 1.14999],
      9824: [0.12963, 0.69444, 0, 0, 0.89444],
      9825: [0.12963, 0.69444, 0, 0, 0.89444],
      9826: [0.12963, 0.69444, 0, 0, 0.89444],
      9827: [0.12963, 0.69444, 0, 0, 0.89444],
      9837: [0, 0.75, 0, 0, 0.44722],
      9838: [0.19444, 0.69444, 0, 0, 0.44722],
      9839: [0.19444, 0.69444, 0, 0, 0.44722],
      10216: [0.25, 0.75, 0, 0, 0.44722],
      10217: [0.25, 0.75, 0, 0, 0.44722],
      10815: [0, 0.68611, 0, 0, 0.9],
      10927: [0.19667, 0.69667, 0, 0, 0.89444],
      10928: [0.19667, 0.69667, 0, 0, 0.89444],
      57376: [0.19444, 0.69444, 0, 0, 0],
    },
    "Main-BoldItalic": {
      32: [0, 0, 0, 0, 0.25],
      33: [0, 0.69444, 0.11417, 0, 0.38611],
      34: [0, 0.69444, 0.07939, 0, 0.62055],
      35: [0.19444, 0.69444, 0.06833, 0, 0.94444],
      37: [0.05556, 0.75, 0.12861, 0, 0.94444],
      38: [0, 0.69444, 0.08528, 0, 0.88555],
      39: [0, 0.69444, 0.12945, 0, 0.35555],
      40: [0.25, 0.75, 0.15806, 0, 0.47333],
      41: [0.25, 0.75, 0.03306, 0, 0.47333],
      42: [0, 0.75, 0.14333, 0, 0.59111],
      43: [0.10333, 0.60333, 0.03306, 0, 0.88555],
      44: [0.19444, 0.14722, 0, 0, 0.35555],
      45: [0, 0.44444, 0.02611, 0, 0.41444],
      46: [0, 0.14722, 0, 0, 0.35555],
      47: [0.25, 0.75, 0.15806, 0, 0.59111],
      48: [0, 0.64444, 0.13167, 0, 0.59111],
      49: [0, 0.64444, 0.13167, 0, 0.59111],
      50: [0, 0.64444, 0.13167, 0, 0.59111],
      51: [0, 0.64444, 0.13167, 0, 0.59111],
      52: [0.19444, 0.64444, 0.13167, 0, 0.59111],
      53: [0, 0.64444, 0.13167, 0, 0.59111],
      54: [0, 0.64444, 0.13167, 0, 0.59111],
      55: [0.19444, 0.64444, 0.13167, 0, 0.59111],
      56: [0, 0.64444, 0.13167, 0, 0.59111],
      57: [0, 0.64444, 0.13167, 0, 0.59111],
      58: [0, 0.44444, 0.06695, 0, 0.35555],
      59: [0.19444, 0.44444, 0.06695, 0, 0.35555],
      61: [-0.10889, 0.39111, 0.06833, 0, 0.88555],
      63: [0, 0.69444, 0.11472, 0, 0.59111],
      64: [0, 0.69444, 0.09208, 0, 0.88555],
      65: [0, 0.68611, 0, 0, 0.86555],
      66: [0, 0.68611, 0.0992, 0, 0.81666],
      67: [0, 0.68611, 0.14208, 0, 0.82666],
      68: [0, 0.68611, 0.09062, 0, 0.87555],
      69: [0, 0.68611, 0.11431, 0, 0.75666],
      70: [0, 0.68611, 0.12903, 0, 0.72722],
      71: [0, 0.68611, 0.07347, 0, 0.89527],
      72: [0, 0.68611, 0.17208, 0, 0.8961],
      73: [0, 0.68611, 0.15681, 0, 0.47166],
      74: [0, 0.68611, 0.145, 0, 0.61055],
      75: [0, 0.68611, 0.14208, 0, 0.89499],
      76: [0, 0.68611, 0, 0, 0.69777],
      77: [0, 0.68611, 0.17208, 0, 1.07277],
      78: [0, 0.68611, 0.17208, 0, 0.8961],
      79: [0, 0.68611, 0.09062, 0, 0.85499],
      80: [0, 0.68611, 0.0992, 0, 0.78721],
      81: [0.19444, 0.68611, 0.09062, 0, 0.85499],
      82: [0, 0.68611, 0.02559, 0, 0.85944],
      83: [0, 0.68611, 0.11264, 0, 0.64999],
      84: [0, 0.68611, 0.12903, 0, 0.7961],
      85: [0, 0.68611, 0.17208, 0, 0.88083],
      86: [0, 0.68611, 0.18625, 0, 0.86555],
      87: [0, 0.68611, 0.18625, 0, 1.15999],
      88: [0, 0.68611, 0.15681, 0, 0.86555],
      89: [0, 0.68611, 0.19803, 0, 0.86555],
      90: [0, 0.68611, 0.14208, 0, 0.70888],
      91: [0.25, 0.75, 0.1875, 0, 0.35611],
      93: [0.25, 0.75, 0.09972, 0, 0.35611],
      94: [0, 0.69444, 0.06709, 0, 0.59111],
      95: [0.31, 0.13444, 0.09811, 0, 0.59111],
      97: [0, 0.44444, 0.09426, 0, 0.59111],
      98: [0, 0.69444, 0.07861, 0, 0.53222],
      99: [0, 0.44444, 0.05222, 0, 0.53222],
      100: [0, 0.69444, 0.10861, 0, 0.59111],
      101: [0, 0.44444, 0.085, 0, 0.53222],
      102: [0.19444, 0.69444, 0.21778, 0, 0.4],
      103: [0.19444, 0.44444, 0.105, 0, 0.53222],
      104: [0, 0.69444, 0.09426, 0, 0.59111],
      105: [0, 0.69326, 0.11387, 0, 0.35555],
      106: [0.19444, 0.69326, 0.1672, 0, 0.35555],
      107: [0, 0.69444, 0.11111, 0, 0.53222],
      108: [0, 0.69444, 0.10861, 0, 0.29666],
      109: [0, 0.44444, 0.09426, 0, 0.94444],
      110: [0, 0.44444, 0.09426, 0, 0.64999],
      111: [0, 0.44444, 0.07861, 0, 0.59111],
      112: [0.19444, 0.44444, 0.07861, 0, 0.59111],
      113: [0.19444, 0.44444, 0.105, 0, 0.53222],
      114: [0, 0.44444, 0.11111, 0, 0.50167],
      115: [0, 0.44444, 0.08167, 0, 0.48694],
      116: [0, 0.63492, 0.09639, 0, 0.385],
      117: [0, 0.44444, 0.09426, 0, 0.62055],
      118: [0, 0.44444, 0.11111, 0, 0.53222],
      119: [0, 0.44444, 0.11111, 0, 0.76777],
      120: [0, 0.44444, 0.12583, 0, 0.56055],
      121: [0.19444, 0.44444, 0.105, 0, 0.56166],
      122: [0, 0.44444, 0.13889, 0, 0.49055],
      126: [0.35, 0.34444, 0.11472, 0, 0.59111],
      160: [0, 0, 0, 0, 0.25],
      168: [0, 0.69444, 0.11473, 0, 0.59111],
      176: [0, 0.69444, 0, 0, 0.94888],
      184: [0.17014, 0, 0, 0, 0.53222],
      198: [0, 0.68611, 0.11431, 0, 1.02277],
      216: [0.04861, 0.73472, 0.09062, 0, 0.88555],
      223: [0.19444, 0.69444, 0.09736, 0, 0.665],
      230: [0, 0.44444, 0.085, 0, 0.82666],
      248: [0.09722, 0.54167, 0.09458, 0, 0.59111],
      305: [0, 0.44444, 0.09426, 0, 0.35555],
      338: [0, 0.68611, 0.11431, 0, 1.14054],
      339: [0, 0.44444, 0.085, 0, 0.82666],
      567: [0.19444, 0.44444, 0.04611, 0, 0.385],
      710: [0, 0.69444, 0.06709, 0, 0.59111],
      711: [0, 0.63194, 0.08271, 0, 0.59111],
      713: [0, 0.59444, 0.10444, 0, 0.59111],
      714: [0, 0.69444, 0.08528, 0, 0.59111],
      715: [0, 0.69444, 0, 0, 0.59111],
      728: [0, 0.69444, 0.10333, 0, 0.59111],
      729: [0, 0.69444, 0.12945, 0, 0.35555],
      730: [0, 0.69444, 0, 0, 0.94888],
      732: [0, 0.69444, 0.11472, 0, 0.59111],
      733: [0, 0.69444, 0.11472, 0, 0.59111],
      915: [0, 0.68611, 0.12903, 0, 0.69777],
      916: [0, 0.68611, 0, 0, 0.94444],
      920: [0, 0.68611, 0.09062, 0, 0.88555],
      923: [0, 0.68611, 0, 0, 0.80666],
      926: [0, 0.68611, 0.15092, 0, 0.76777],
      928: [0, 0.68611, 0.17208, 0, 0.8961],
      931: [0, 0.68611, 0.11431, 0, 0.82666],
      933: [0, 0.68611, 0.10778, 0, 0.88555],
      934: [0, 0.68611, 0.05632, 0, 0.82666],
      936: [0, 0.68611, 0.10778, 0, 0.88555],
      937: [0, 0.68611, 0.0992, 0, 0.82666],
      8211: [0, 0.44444, 0.09811, 0, 0.59111],
      8212: [0, 0.44444, 0.09811, 0, 1.18221],
      8216: [0, 0.69444, 0.12945, 0, 0.35555],
      8217: [0, 0.69444, 0.12945, 0, 0.35555],
      8220: [0, 0.69444, 0.16772, 0, 0.62055],
      8221: [0, 0.69444, 0.07939, 0, 0.62055],
    },
    "Main-Italic": {
      32: [0, 0, 0, 0, 0.25],
      33: [0, 0.69444, 0.12417, 0, 0.30667],
      34: [0, 0.69444, 0.06961, 0, 0.51444],
      35: [0.19444, 0.69444, 0.06616, 0, 0.81777],
      37: [0.05556, 0.75, 0.13639, 0, 0.81777],
      38: [0, 0.69444, 0.09694, 0, 0.76666],
      39: [0, 0.69444, 0.12417, 0, 0.30667],
      40: [0.25, 0.75, 0.16194, 0, 0.40889],
      41: [0.25, 0.75, 0.03694, 0, 0.40889],
      42: [0, 0.75, 0.14917, 0, 0.51111],
      43: [0.05667, 0.56167, 0.03694, 0, 0.76666],
      44: [0.19444, 0.10556, 0, 0, 0.30667],
      45: [0, 0.43056, 0.02826, 0, 0.35778],
      46: [0, 0.10556, 0, 0, 0.30667],
      47: [0.25, 0.75, 0.16194, 0, 0.51111],
      48: [0, 0.64444, 0.13556, 0, 0.51111],
      49: [0, 0.64444, 0.13556, 0, 0.51111],
      50: [0, 0.64444, 0.13556, 0, 0.51111],
      51: [0, 0.64444, 0.13556, 0, 0.51111],
      52: [0.19444, 0.64444, 0.13556, 0, 0.51111],
      53: [0, 0.64444, 0.13556, 0, 0.51111],
      54: [0, 0.64444, 0.13556, 0, 0.51111],
      55: [0.19444, 0.64444, 0.13556, 0, 0.51111],
      56: [0, 0.64444, 0.13556, 0, 0.51111],
      57: [0, 0.64444, 0.13556, 0, 0.51111],
      58: [0, 0.43056, 0.0582, 0, 0.30667],
      59: [0.19444, 0.43056, 0.0582, 0, 0.30667],
      61: [-0.13313, 0.36687, 0.06616, 0, 0.76666],
      63: [0, 0.69444, 0.1225, 0, 0.51111],
      64: [0, 0.69444, 0.09597, 0, 0.76666],
      65: [0, 0.68333, 0, 0, 0.74333],
      66: [0, 0.68333, 0.10257, 0, 0.70389],
      67: [0, 0.68333, 0.14528, 0, 0.71555],
      68: [0, 0.68333, 0.09403, 0, 0.755],
      69: [0, 0.68333, 0.12028, 0, 0.67833],
      70: [0, 0.68333, 0.13305, 0, 0.65277],
      71: [0, 0.68333, 0.08722, 0, 0.77361],
      72: [0, 0.68333, 0.16389, 0, 0.74333],
      73: [0, 0.68333, 0.15806, 0, 0.38555],
      74: [0, 0.68333, 0.14028, 0, 0.525],
      75: [0, 0.68333, 0.14528, 0, 0.76888],
      76: [0, 0.68333, 0, 0, 0.62722],
      77: [0, 0.68333, 0.16389, 0, 0.89666],
      78: [0, 0.68333, 0.16389, 0, 0.74333],
      79: [0, 0.68333, 0.09403, 0, 0.76666],
      80: [0, 0.68333, 0.10257, 0, 0.67833],
      81: [0.19444, 0.68333, 0.09403, 0, 0.76666],
      82: [0, 0.68333, 0.03868, 0, 0.72944],
      83: [0, 0.68333, 0.11972, 0, 0.56222],
      84: [0, 0.68333, 0.13305, 0, 0.71555],
      85: [0, 0.68333, 0.16389, 0, 0.74333],
      86: [0, 0.68333, 0.18361, 0, 0.74333],
      87: [0, 0.68333, 0.18361, 0, 0.99888],
      88: [0, 0.68333, 0.15806, 0, 0.74333],
      89: [0, 0.68333, 0.19383, 0, 0.74333],
      90: [0, 0.68333, 0.14528, 0, 0.61333],
      91: [0.25, 0.75, 0.1875, 0, 0.30667],
      93: [0.25, 0.75, 0.10528, 0, 0.30667],
      94: [0, 0.69444, 0.06646, 0, 0.51111],
      95: [0.31, 0.12056, 0.09208, 0, 0.51111],
      97: [0, 0.43056, 0.07671, 0, 0.51111],
      98: [0, 0.69444, 0.06312, 0, 0.46],
      99: [0, 0.43056, 0.05653, 0, 0.46],
      100: [0, 0.69444, 0.10333, 0, 0.51111],
      101: [0, 0.43056, 0.07514, 0, 0.46],
      102: [0.19444, 0.69444, 0.21194, 0, 0.30667],
      103: [0.19444, 0.43056, 0.08847, 0, 0.46],
      104: [0, 0.69444, 0.07671, 0, 0.51111],
      105: [0, 0.65536, 0.1019, 0, 0.30667],
      106: [0.19444, 0.65536, 0.14467, 0, 0.30667],
      107: [0, 0.69444, 0.10764, 0, 0.46],
      108: [0, 0.69444, 0.10333, 0, 0.25555],
      109: [0, 0.43056, 0.07671, 0, 0.81777],
      110: [0, 0.43056, 0.07671, 0, 0.56222],
      111: [0, 0.43056, 0.06312, 0, 0.51111],
      112: [0.19444, 0.43056, 0.06312, 0, 0.51111],
      113: [0.19444, 0.43056, 0.08847, 0, 0.46],
      114: [0, 0.43056, 0.10764, 0, 0.42166],
      115: [0, 0.43056, 0.08208, 0, 0.40889],
      116: [0, 0.61508, 0.09486, 0, 0.33222],
      117: [0, 0.43056, 0.07671, 0, 0.53666],
      118: [0, 0.43056, 0.10764, 0, 0.46],
      119: [0, 0.43056, 0.10764, 0, 0.66444],
      120: [0, 0.43056, 0.12042, 0, 0.46389],
      121: [0.19444, 0.43056, 0.08847, 0, 0.48555],
      122: [0, 0.43056, 0.12292, 0, 0.40889],
      126: [0.35, 0.31786, 0.11585, 0, 0.51111],
      160: [0, 0, 0, 0, 0.25],
      168: [0, 0.66786, 0.10474, 0, 0.51111],
      176: [0, 0.69444, 0, 0, 0.83129],
      184: [0.17014, 0, 0, 0, 0.46],
      198: [0, 0.68333, 0.12028, 0, 0.88277],
      216: [0.04861, 0.73194, 0.09403, 0, 0.76666],
      223: [0.19444, 0.69444, 0.10514, 0, 0.53666],
      230: [0, 0.43056, 0.07514, 0, 0.71555],
      248: [0.09722, 0.52778, 0.09194, 0, 0.51111],
      338: [0, 0.68333, 0.12028, 0, 0.98499],
      339: [0, 0.43056, 0.07514, 0, 0.71555],
      710: [0, 0.69444, 0.06646, 0, 0.51111],
      711: [0, 0.62847, 0.08295, 0, 0.51111],
      713: [0, 0.56167, 0.10333, 0, 0.51111],
      714: [0, 0.69444, 0.09694, 0, 0.51111],
      715: [0, 0.69444, 0, 0, 0.51111],
      728: [0, 0.69444, 0.10806, 0, 0.51111],
      729: [0, 0.66786, 0.11752, 0, 0.30667],
      730: [0, 0.69444, 0, 0, 0.83129],
      732: [0, 0.66786, 0.11585, 0, 0.51111],
      733: [0, 0.69444, 0.1225, 0, 0.51111],
      915: [0, 0.68333, 0.13305, 0, 0.62722],
      916: [0, 0.68333, 0, 0, 0.81777],
      920: [0, 0.68333, 0.09403, 0, 0.76666],
      923: [0, 0.68333, 0, 0, 0.69222],
      926: [0, 0.68333, 0.15294, 0, 0.66444],
      928: [0, 0.68333, 0.16389, 0, 0.74333],
      931: [0, 0.68333, 0.12028, 0, 0.71555],
      933: [0, 0.68333, 0.11111, 0, 0.76666],
      934: [0, 0.68333, 0.05986, 0, 0.71555],
      936: [0, 0.68333, 0.11111, 0, 0.76666],
      937: [0, 0.68333, 0.10257, 0, 0.71555],
      8211: [0, 0.43056, 0.09208, 0, 0.51111],
      8212: [0, 0.43056, 0.09208, 0, 1.02222],
      8216: [0, 0.69444, 0.12417, 0, 0.30667],
      8217: [0, 0.69444, 0.12417, 0, 0.30667],
      8220: [0, 0.69444, 0.1685, 0, 0.51444],
      8221: [0, 0.69444, 0.06961, 0, 0.51444],
      8463: [0, 0.68889, 0, 0, 0.54028],
    },
    "Main-Regular": {
      32: [0, 0, 0, 0, 0.25],
      33: [0, 0.69444, 0, 0, 0.27778],
      34: [0, 0.69444, 0, 0, 0.5],
      35: [0.19444, 0.69444, 0, 0, 0.83334],
      36: [0.05556, 0.75, 0, 0, 0.5],
      37: [0.05556, 0.75, 0, 0, 0.83334],
      38: [0, 0.69444, 0, 0, 0.77778],
      39: [0, 0.69444, 0, 0, 0.27778],
      40: [0.25, 0.75, 0, 0, 0.38889],
      41: [0.25, 0.75, 0, 0, 0.38889],
      42: [0, 0.75, 0, 0, 0.5],
      43: [0.08333, 0.58333, 0, 0, 0.77778],
      44: [0.19444, 0.10556, 0, 0, 0.27778],
      45: [0, 0.43056, 0, 0, 0.33333],
      46: [0, 0.10556, 0, 0, 0.27778],
      47: [0.25, 0.75, 0, 0, 0.5],
      48: [0, 0.64444, 0, 0, 0.5],
      49: [0, 0.64444, 0, 0, 0.5],
      50: [0, 0.64444, 0, 0, 0.5],
      51: [0, 0.64444, 0, 0, 0.5],
      52: [0, 0.64444, 0, 0, 0.5],
      53: [0, 0.64444, 0, 0, 0.5],
      54: [0, 0.64444, 0, 0, 0.5],
      55: [0, 0.64444, 0, 0, 0.5],
      56: [0, 0.64444, 0, 0, 0.5],
      57: [0, 0.64444, 0, 0, 0.5],
      58: [0, 0.43056, 0, 0, 0.27778],
      59: [0.19444, 0.43056, 0, 0, 0.27778],
      60: [0.0391, 0.5391, 0, 0, 0.77778],
      61: [-0.13313, 0.36687, 0, 0, 0.77778],
      62: [0.0391, 0.5391, 0, 0, 0.77778],
      63: [0, 0.69444, 0, 0, 0.47222],
      64: [0, 0.69444, 0, 0, 0.77778],
      65: [0, 0.68333, 0, 0, 0.75],
      66: [0, 0.68333, 0, 0, 0.70834],
      67: [0, 0.68333, 0, 0, 0.72222],
      68: [0, 0.68333, 0, 0, 0.76389],
      69: [0, 0.68333, 0, 0, 0.68056],
      70: [0, 0.68333, 0, 0, 0.65278],
      71: [0, 0.68333, 0, 0, 0.78472],
      72: [0, 0.68333, 0, 0, 0.75],
      73: [0, 0.68333, 0, 0, 0.36111],
      74: [0, 0.68333, 0, 0, 0.51389],
      75: [0, 0.68333, 0, 0, 0.77778],
      76: [0, 0.68333, 0, 0, 0.625],
      77: [0, 0.68333, 0, 0, 0.91667],
      78: [0, 0.68333, 0, 0, 0.75],
      79: [0, 0.68333, 0, 0, 0.77778],
      80: [0, 0.68333, 0, 0, 0.68056],
      81: [0.19444, 0.68333, 0, 0, 0.77778],
      82: [0, 0.68333, 0, 0, 0.73611],
      83: [0, 0.68333, 0, 0, 0.55556],
      84: [0, 0.68333, 0, 0, 0.72222],
      85: [0, 0.68333, 0, 0, 0.75],
      86: [0, 0.68333, 0.01389, 0, 0.75],
      87: [0, 0.68333, 0.01389, 0, 1.02778],
      88: [0, 0.68333, 0, 0, 0.75],
      89: [0, 0.68333, 0.025, 0, 0.75],
      90: [0, 0.68333, 0, 0, 0.61111],
      91: [0.25, 0.75, 0, 0, 0.27778],
      92: [0.25, 0.75, 0, 0, 0.5],
      93: [0.25, 0.75, 0, 0, 0.27778],
      94: [0, 0.69444, 0, 0, 0.5],
      95: [0.31, 0.12056, 0.02778, 0, 0.5],
      97: [0, 0.43056, 0, 0, 0.5],
      98: [0, 0.69444, 0, 0, 0.55556],
      99: [0, 0.43056, 0, 0, 0.44445],
      100: [0, 0.69444, 0, 0, 0.55556],
      101: [0, 0.43056, 0, 0, 0.44445],
      102: [0, 0.69444, 0.07778, 0, 0.30556],
      103: [0.19444, 0.43056, 0.01389, 0, 0.5],
      104: [0, 0.69444, 0, 0, 0.55556],
      105: [0, 0.66786, 0, 0, 0.27778],
      106: [0.19444, 0.66786, 0, 0, 0.30556],
      107: [0, 0.69444, 0, 0, 0.52778],
      108: [0, 0.69444, 0, 0, 0.27778],
      109: [0, 0.43056, 0, 0, 0.83334],
      110: [0, 0.43056, 0, 0, 0.55556],
      111: [0, 0.43056, 0, 0, 0.5],
      112: [0.19444, 0.43056, 0, 0, 0.55556],
      113: [0.19444, 0.43056, 0, 0, 0.52778],
      114: [0, 0.43056, 0, 0, 0.39167],
      115: [0, 0.43056, 0, 0, 0.39445],
      116: [0, 0.61508, 0, 0, 0.38889],
      117: [0, 0.43056, 0, 0, 0.55556],
      118: [0, 0.43056, 0.01389, 0, 0.52778],
      119: [0, 0.43056, 0.01389, 0, 0.72222],
      120: [0, 0.43056, 0, 0, 0.52778],
      121: [0.19444, 0.43056, 0.01389, 0, 0.52778],
      122: [0, 0.43056, 0, 0, 0.44445],
      123: [0.25, 0.75, 0, 0, 0.5],
      124: [0.25, 0.75, 0, 0, 0.27778],
      125: [0.25, 0.75, 0, 0, 0.5],
      126: [0.35, 0.31786, 0, 0, 0.5],
      160: [0, 0, 0, 0, 0.25],
      163: [0, 0.69444, 0, 0, 0.76909],
      167: [0.19444, 0.69444, 0, 0, 0.44445],
      168: [0, 0.66786, 0, 0, 0.5],
      172: [0, 0.43056, 0, 0, 0.66667],
      176: [0, 0.69444, 0, 0, 0.75],
      177: [0.08333, 0.58333, 0, 0, 0.77778],
      182: [0.19444, 0.69444, 0, 0, 0.61111],
      184: [0.17014, 0, 0, 0, 0.44445],
      198: [0, 0.68333, 0, 0, 0.90278],
      215: [0.08333, 0.58333, 0, 0, 0.77778],
      216: [0.04861, 0.73194, 0, 0, 0.77778],
      223: [0, 0.69444, 0, 0, 0.5],
      230: [0, 0.43056, 0, 0, 0.72222],
      247: [0.08333, 0.58333, 0, 0, 0.77778],
      248: [0.09722, 0.52778, 0, 0, 0.5],
      305: [0, 0.43056, 0, 0, 0.27778],
      338: [0, 0.68333, 0, 0, 1.01389],
      339: [0, 0.43056, 0, 0, 0.77778],
      567: [0.19444, 0.43056, 0, 0, 0.30556],
      710: [0, 0.69444, 0, 0, 0.5],
      711: [0, 0.62847, 0, 0, 0.5],
      713: [0, 0.56778, 0, 0, 0.5],
      714: [0, 0.69444, 0, 0, 0.5],
      715: [0, 0.69444, 0, 0, 0.5],
      728: [0, 0.69444, 0, 0, 0.5],
      729: [0, 0.66786, 0, 0, 0.27778],
      730: [0, 0.69444, 0, 0, 0.75],
      732: [0, 0.66786, 0, 0, 0.5],
      733: [0, 0.69444, 0, 0, 0.5],
      915: [0, 0.68333, 0, 0, 0.625],
      916: [0, 0.68333, 0, 0, 0.83334],
      920: [0, 0.68333, 0, 0, 0.77778],
      923: [0, 0.68333, 0, 0, 0.69445],
      926: [0, 0.68333, 0, 0, 0.66667],
      928: [0, 0.68333, 0, 0, 0.75],
      931: [0, 0.68333, 0, 0, 0.72222],
      933: [0, 0.68333, 0, 0, 0.77778],
      934: [0, 0.68333, 0, 0, 0.72222],
      936: [0, 0.68333, 0, 0, 0.77778],
      937: [0, 0.68333, 0, 0, 0.72222],
      8211: [0, 0.43056, 0.02778, 0, 0.5],
      8212: [0, 0.43056, 0.02778, 0, 1],
      8216: [0, 0.69444, 0, 0, 0.27778],
      8217: [0, 0.69444, 0, 0, 0.27778],
      8220: [0, 0.69444, 0, 0, 0.5],
      8221: [0, 0.69444, 0, 0, 0.5],
      8224: [0.19444, 0.69444, 0, 0, 0.44445],
      8225: [0.19444, 0.69444, 0, 0, 0.44445],
      8230: [0, 0.123, 0, 0, 1.172],
      8242: [0, 0.55556, 0, 0, 0.275],
      8407: [0, 0.71444, 0.15382, 0, 0.5],
      8463: [0, 0.68889, 0, 0, 0.54028],
      8465: [0, 0.69444, 0, 0, 0.72222],
      8467: [0, 0.69444, 0, 0.11111, 0.41667],
      8472: [0.19444, 0.43056, 0, 0.11111, 0.63646],
      8476: [0, 0.69444, 0, 0, 0.72222],
      8501: [0, 0.69444, 0, 0, 0.61111],
      8592: [-0.13313, 0.36687, 0, 0, 1],
      8593: [0.19444, 0.69444, 0, 0, 0.5],
      8594: [-0.13313, 0.36687, 0, 0, 1],
      8595: [0.19444, 0.69444, 0, 0, 0.5],
      8596: [-0.13313, 0.36687, 0, 0, 1],
      8597: [0.25, 0.75, 0, 0, 0.5],
      8598: [0.19444, 0.69444, 0, 0, 1],
      8599: [0.19444, 0.69444, 0, 0, 1],
      8600: [0.19444, 0.69444, 0, 0, 1],
      8601: [0.19444, 0.69444, 0, 0, 1],
      8614: [0.011, 0.511, 0, 0, 1],
      8617: [0.011, 0.511, 0, 0, 1.126],
      8618: [0.011, 0.511, 0, 0, 1.126],
      8636: [-0.13313, 0.36687, 0, 0, 1],
      8637: [-0.13313, 0.36687, 0, 0, 1],
      8640: [-0.13313, 0.36687, 0, 0, 1],
      8641: [-0.13313, 0.36687, 0, 0, 1],
      8652: [0.011, 0.671, 0, 0, 1],
      8656: [-0.13313, 0.36687, 0, 0, 1],
      8657: [0.19444, 0.69444, 0, 0, 0.61111],
      8658: [-0.13313, 0.36687, 0, 0, 1],
      8659: [0.19444, 0.69444, 0, 0, 0.61111],
      8660: [-0.13313, 0.36687, 0, 0, 1],
      8661: [0.25, 0.75, 0, 0, 0.61111],
      8704: [0, 0.69444, 0, 0, 0.55556],
      8706: [0, 0.69444, 0.05556, 0.08334, 0.5309],
      8707: [0, 0.69444, 0, 0, 0.55556],
      8709: [0.05556, 0.75, 0, 0, 0.5],
      8711: [0, 0.68333, 0, 0, 0.83334],
      8712: [0.0391, 0.5391, 0, 0, 0.66667],
      8715: [0.0391, 0.5391, 0, 0, 0.66667],
      8722: [0.08333, 0.58333, 0, 0, 0.77778],
      8723: [0.08333, 0.58333, 0, 0, 0.77778],
      8725: [0.25, 0.75, 0, 0, 0.5],
      8726: [0.25, 0.75, 0, 0, 0.5],
      8727: [-0.03472, 0.46528, 0, 0, 0.5],
      8728: [-0.05555, 0.44445, 0, 0, 0.5],
      8729: [-0.05555, 0.44445, 0, 0, 0.5],
      8730: [0.2, 0.8, 0, 0, 0.83334],
      8733: [0, 0.43056, 0, 0, 0.77778],
      8734: [0, 0.43056, 0, 0, 1],
      8736: [0, 0.69224, 0, 0, 0.72222],
      8739: [0.25, 0.75, 0, 0, 0.27778],
      8741: [0.25, 0.75, 0, 0, 0.5],
      8743: [0, 0.55556, 0, 0, 0.66667],
      8744: [0, 0.55556, 0, 0, 0.66667],
      8745: [0, 0.55556, 0, 0, 0.66667],
      8746: [0, 0.55556, 0, 0, 0.66667],
      8747: [0.19444, 0.69444, 0.11111, 0, 0.41667],
      8764: [-0.13313, 0.36687, 0, 0, 0.77778],
      8768: [0.19444, 0.69444, 0, 0, 0.27778],
      8771: [-0.03625, 0.46375, 0, 0, 0.77778],
      8773: [-0.022, 0.589, 0, 0, 0.778],
      8776: [-0.01688, 0.48312, 0, 0, 0.77778],
      8781: [-0.03625, 0.46375, 0, 0, 0.77778],
      8784: [-0.133, 0.673, 0, 0, 0.778],
      8801: [-0.03625, 0.46375, 0, 0, 0.77778],
      8804: [0.13597, 0.63597, 0, 0, 0.77778],
      8805: [0.13597, 0.63597, 0, 0, 0.77778],
      8810: [0.0391, 0.5391, 0, 0, 1],
      8811: [0.0391, 0.5391, 0, 0, 1],
      8826: [0.0391, 0.5391, 0, 0, 0.77778],
      8827: [0.0391, 0.5391, 0, 0, 0.77778],
      8834: [0.0391, 0.5391, 0, 0, 0.77778],
      8835: [0.0391, 0.5391, 0, 0, 0.77778],
      8838: [0.13597, 0.63597, 0, 0, 0.77778],
      8839: [0.13597, 0.63597, 0, 0, 0.77778],
      8846: [0, 0.55556, 0, 0, 0.66667],
      8849: [0.13597, 0.63597, 0, 0, 0.77778],
      8850: [0.13597, 0.63597, 0, 0, 0.77778],
      8851: [0, 0.55556, 0, 0, 0.66667],
      8852: [0, 0.55556, 0, 0, 0.66667],
      8853: [0.08333, 0.58333, 0, 0, 0.77778],
      8854: [0.08333, 0.58333, 0, 0, 0.77778],
      8855: [0.08333, 0.58333, 0, 0, 0.77778],
      8856: [0.08333, 0.58333, 0, 0, 0.77778],
      8857: [0.08333, 0.58333, 0, 0, 0.77778],
      8866: [0, 0.69444, 0, 0, 0.61111],
      8867: [0, 0.69444, 0, 0, 0.61111],
      8868: [0, 0.69444, 0, 0, 0.77778],
      8869: [0, 0.69444, 0, 0, 0.77778],
      8872: [0.249, 0.75, 0, 0, 0.867],
      8900: [-0.05555, 0.44445, 0, 0, 0.5],
      8901: [-0.05555, 0.44445, 0, 0, 0.27778],
      8902: [-0.03472, 0.46528, 0, 0, 0.5],
      8904: [0.005, 0.505, 0, 0, 0.9],
      8942: [0.03, 0.903, 0, 0, 0.278],
      8943: [-0.19, 0.313, 0, 0, 1.172],
      8945: [-0.1, 0.823, 0, 0, 1.282],
      8968: [0.25, 0.75, 0, 0, 0.44445],
      8969: [0.25, 0.75, 0, 0, 0.44445],
      8970: [0.25, 0.75, 0, 0, 0.44445],
      8971: [0.25, 0.75, 0, 0, 0.44445],
      8994: [-0.14236, 0.35764, 0, 0, 1],
      8995: [-0.14236, 0.35764, 0, 0, 1],
      9136: [0.244, 0.744, 0, 0, 0.412],
      9137: [0.244, 0.745, 0, 0, 0.412],
      9651: [0.19444, 0.69444, 0, 0, 0.88889],
      9657: [-0.03472, 0.46528, 0, 0, 0.5],
      9661: [0.19444, 0.69444, 0, 0, 0.88889],
      9667: [-0.03472, 0.46528, 0, 0, 0.5],
      9711: [0.19444, 0.69444, 0, 0, 1],
      9824: [0.12963, 0.69444, 0, 0, 0.77778],
      9825: [0.12963, 0.69444, 0, 0, 0.77778],
      9826: [0.12963, 0.69444, 0, 0, 0.77778],
      9827: [0.12963, 0.69444, 0, 0, 0.77778],
      9837: [0, 0.75, 0, 0, 0.38889],
      9838: [0.19444, 0.69444, 0, 0, 0.38889],
      9839: [0.19444, 0.69444, 0, 0, 0.38889],
      10216: [0.25, 0.75, 0, 0, 0.38889],
      10217: [0.25, 0.75, 0, 0, 0.38889],
      10222: [0.244, 0.744, 0, 0, 0.412],
      10223: [0.244, 0.745, 0, 0, 0.412],
      10229: [0.011, 0.511, 0, 0, 1.609],
      10230: [0.011, 0.511, 0, 0, 1.638],
      10231: [0.011, 0.511, 0, 0, 1.859],
      10232: [0.024, 0.525, 0, 0, 1.609],
      10233: [0.024, 0.525, 0, 0, 1.638],
      10234: [0.024, 0.525, 0, 0, 1.858],
      10236: [0.011, 0.511, 0, 0, 1.638],
      10815: [0, 0.68333, 0, 0, 0.75],
      10927: [0.13597, 0.63597, 0, 0, 0.77778],
      10928: [0.13597, 0.63597, 0, 0, 0.77778],
      57376: [0.19444, 0.69444, 0, 0, 0],
    },
    "Math-BoldItalic": {
      32: [0, 0, 0, 0, 0.25],
      48: [0, 0.44444, 0, 0, 0.575],
      49: [0, 0.44444, 0, 0, 0.575],
      50: [0, 0.44444, 0, 0, 0.575],
      51: [0.19444, 0.44444, 0, 0, 0.575],
      52: [0.19444, 0.44444, 0, 0, 0.575],
      53: [0.19444, 0.44444, 0, 0, 0.575],
      54: [0, 0.64444, 0, 0, 0.575],
      55: [0.19444, 0.44444, 0, 0, 0.575],
      56: [0, 0.64444, 0, 0, 0.575],
      57: [0.19444, 0.44444, 0, 0, 0.575],
      65: [0, 0.68611, 0, 0, 0.86944],
      66: [0, 0.68611, 0.04835, 0, 0.8664],
      67: [0, 0.68611, 0.06979, 0, 0.81694],
      68: [0, 0.68611, 0.03194, 0, 0.93812],
      69: [0, 0.68611, 0.05451, 0, 0.81007],
      70: [0, 0.68611, 0.15972, 0, 0.68889],
      71: [0, 0.68611, 0, 0, 0.88673],
      72: [0, 0.68611, 0.08229, 0, 0.98229],
      73: [0, 0.68611, 0.07778, 0, 0.51111],
      74: [0, 0.68611, 0.10069, 0, 0.63125],
      75: [0, 0.68611, 0.06979, 0, 0.97118],
      76: [0, 0.68611, 0, 0, 0.75555],
      77: [0, 0.68611, 0.11424, 0, 1.14201],
      78: [0, 0.68611, 0.11424, 0, 0.95034],
      79: [0, 0.68611, 0.03194, 0, 0.83666],
      80: [0, 0.68611, 0.15972, 0, 0.72309],
      81: [0.19444, 0.68611, 0, 0, 0.86861],
      82: [0, 0.68611, 0.00421, 0, 0.87235],
      83: [0, 0.68611, 0.05382, 0, 0.69271],
      84: [0, 0.68611, 0.15972, 0, 0.63663],
      85: [0, 0.68611, 0.11424, 0, 0.80027],
      86: [0, 0.68611, 0.25555, 0, 0.67778],
      87: [0, 0.68611, 0.15972, 0, 1.09305],
      88: [0, 0.68611, 0.07778, 0, 0.94722],
      89: [0, 0.68611, 0.25555, 0, 0.67458],
      90: [0, 0.68611, 0.06979, 0, 0.77257],
      97: [0, 0.44444, 0, 0, 0.63287],
      98: [0, 0.69444, 0, 0, 0.52083],
      99: [0, 0.44444, 0, 0, 0.51342],
      100: [0, 0.69444, 0, 0, 0.60972],
      101: [0, 0.44444, 0, 0, 0.55361],
      102: [0.19444, 0.69444, 0.11042, 0, 0.56806],
      103: [0.19444, 0.44444, 0.03704, 0, 0.5449],
      104: [0, 0.69444, 0, 0, 0.66759],
      105: [0, 0.69326, 0, 0, 0.4048],
      106: [0.19444, 0.69326, 0.0622, 0, 0.47083],
      107: [0, 0.69444, 0.01852, 0, 0.6037],
      108: [0, 0.69444, 0.0088, 0, 0.34815],
      109: [0, 0.44444, 0, 0, 1.0324],
      110: [0, 0.44444, 0, 0, 0.71296],
      111: [0, 0.44444, 0, 0, 0.58472],
      112: [0.19444, 0.44444, 0, 0, 0.60092],
      113: [0.19444, 0.44444, 0.03704, 0, 0.54213],
      114: [0, 0.44444, 0.03194, 0, 0.5287],
      115: [0, 0.44444, 0, 0, 0.53125],
      116: [0, 0.63492, 0, 0, 0.41528],
      117: [0, 0.44444, 0, 0, 0.68102],
      118: [0, 0.44444, 0.03704, 0, 0.56666],
      119: [0, 0.44444, 0.02778, 0, 0.83148],
      120: [0, 0.44444, 0, 0, 0.65903],
      121: [0.19444, 0.44444, 0.03704, 0, 0.59028],
      122: [0, 0.44444, 0.04213, 0, 0.55509],
      160: [0, 0, 0, 0, 0.25],
      915: [0, 0.68611, 0.15972, 0, 0.65694],
      916: [0, 0.68611, 0, 0, 0.95833],
      920: [0, 0.68611, 0.03194, 0, 0.86722],
      923: [0, 0.68611, 0, 0, 0.80555],
      926: [0, 0.68611, 0.07458, 0, 0.84125],
      928: [0, 0.68611, 0.08229, 0, 0.98229],
      931: [0, 0.68611, 0.05451, 0, 0.88507],
      933: [0, 0.68611, 0.15972, 0, 0.67083],
      934: [0, 0.68611, 0, 0, 0.76666],
      936: [0, 0.68611, 0.11653, 0, 0.71402],
      937: [0, 0.68611, 0.04835, 0, 0.8789],
      945: [0, 0.44444, 0, 0, 0.76064],
      946: [0.19444, 0.69444, 0.03403, 0, 0.65972],
      947: [0.19444, 0.44444, 0.06389, 0, 0.59003],
      948: [0, 0.69444, 0.03819, 0, 0.52222],
      949: [0, 0.44444, 0, 0, 0.52882],
      950: [0.19444, 0.69444, 0.06215, 0, 0.50833],
      951: [0.19444, 0.44444, 0.03704, 0, 0.6],
      952: [0, 0.69444, 0.03194, 0, 0.5618],
      953: [0, 0.44444, 0, 0, 0.41204],
      954: [0, 0.44444, 0, 0, 0.66759],
      955: [0, 0.69444, 0, 0, 0.67083],
      956: [0.19444, 0.44444, 0, 0, 0.70787],
      957: [0, 0.44444, 0.06898, 0, 0.57685],
      958: [0.19444, 0.69444, 0.03021, 0, 0.50833],
      959: [0, 0.44444, 0, 0, 0.58472],
      960: [0, 0.44444, 0.03704, 0, 0.68241],
      961: [0.19444, 0.44444, 0, 0, 0.6118],
      962: [0.09722, 0.44444, 0.07917, 0, 0.42361],
      963: [0, 0.44444, 0.03704, 0, 0.68588],
      964: [0, 0.44444, 0.13472, 0, 0.52083],
      965: [0, 0.44444, 0.03704, 0, 0.63055],
      966: [0.19444, 0.44444, 0, 0, 0.74722],
      967: [0.19444, 0.44444, 0, 0, 0.71805],
      968: [0.19444, 0.69444, 0.03704, 0, 0.75833],
      969: [0, 0.44444, 0.03704, 0, 0.71782],
      977: [0, 0.69444, 0, 0, 0.69155],
      981: [0.19444, 0.69444, 0, 0, 0.7125],
      982: [0, 0.44444, 0.03194, 0, 0.975],
      1009: [0.19444, 0.44444, 0, 0, 0.6118],
      1013: [0, 0.44444, 0, 0, 0.48333],
      57649: [0, 0.44444, 0, 0, 0.39352],
      57911: [0.19444, 0.44444, 0, 0, 0.43889],
    },
    "Math-Italic": {
      32: [0, 0, 0, 0, 0.25],
      48: [0, 0.43056, 0, 0, 0.5],
      49: [0, 0.43056, 0, 0, 0.5],
      50: [0, 0.43056, 0, 0, 0.5],
      51: [0.19444, 0.43056, 0, 0, 0.5],
      52: [0.19444, 0.43056, 0, 0, 0.5],
      53: [0.19444, 0.43056, 0, 0, 0.5],
      54: [0, 0.64444, 0, 0, 0.5],
      55: [0.19444, 0.43056, 0, 0, 0.5],
      56: [0, 0.64444, 0, 0, 0.5],
      57: [0.19444, 0.43056, 0, 0, 0.5],
      65: [0, 0.68333, 0, 0.13889, 0.75],
      66: [0, 0.68333, 0.05017, 0.08334, 0.75851],
      67: [0, 0.68333, 0.07153, 0.08334, 0.71472],
      68: [0, 0.68333, 0.02778, 0.05556, 0.82792],
      69: [0, 0.68333, 0.05764, 0.08334, 0.7382],
      70: [0, 0.68333, 0.13889, 0.08334, 0.64306],
      71: [0, 0.68333, 0, 0.08334, 0.78625],
      72: [0, 0.68333, 0.08125, 0.05556, 0.83125],
      73: [0, 0.68333, 0.07847, 0.11111, 0.43958],
      74: [0, 0.68333, 0.09618, 0.16667, 0.55451],
      75: [0, 0.68333, 0.07153, 0.05556, 0.84931],
      76: [0, 0.68333, 0, 0.02778, 0.68056],
      77: [0, 0.68333, 0.10903, 0.08334, 0.97014],
      78: [0, 0.68333, 0.10903, 0.08334, 0.80347],
      79: [0, 0.68333, 0.02778, 0.08334, 0.76278],
      80: [0, 0.68333, 0.13889, 0.08334, 0.64201],
      81: [0.19444, 0.68333, 0, 0.08334, 0.79056],
      82: [0, 0.68333, 0.00773, 0.08334, 0.75929],
      83: [0, 0.68333, 0.05764, 0.08334, 0.6132],
      84: [0, 0.68333, 0.13889, 0.08334, 0.58438],
      85: [0, 0.68333, 0.10903, 0.02778, 0.68278],
      86: [0, 0.68333, 0.22222, 0, 0.58333],
      87: [0, 0.68333, 0.13889, 0, 0.94445],
      88: [0, 0.68333, 0.07847, 0.08334, 0.82847],
      89: [0, 0.68333, 0.22222, 0, 0.58056],
      90: [0, 0.68333, 0.07153, 0.08334, 0.68264],
      97: [0, 0.43056, 0, 0, 0.52859],
      98: [0, 0.69444, 0, 0, 0.42917],
      99: [0, 0.43056, 0, 0.05556, 0.43276],
      100: [0, 0.69444, 0, 0.16667, 0.52049],
      101: [0, 0.43056, 0, 0.05556, 0.46563],
      102: [0.19444, 0.69444, 0.10764, 0.16667, 0.48959],
      103: [0.19444, 0.43056, 0.03588, 0.02778, 0.47697],
      104: [0, 0.69444, 0, 0, 0.57616],
      105: [0, 0.65952, 0, 0, 0.34451],
      106: [0.19444, 0.65952, 0.05724, 0, 0.41181],
      107: [0, 0.69444, 0.03148, 0, 0.5206],
      108: [0, 0.69444, 0.01968, 0.08334, 0.29838],
      109: [0, 0.43056, 0, 0, 0.87801],
      110: [0, 0.43056, 0, 0, 0.60023],
      111: [0, 0.43056, 0, 0.05556, 0.48472],
      112: [0.19444, 0.43056, 0, 0.08334, 0.50313],
      113: [0.19444, 0.43056, 0.03588, 0.08334, 0.44641],
      114: [0, 0.43056, 0.02778, 0.05556, 0.45116],
      115: [0, 0.43056, 0, 0.05556, 0.46875],
      116: [0, 0.61508, 0, 0.08334, 0.36111],
      117: [0, 0.43056, 0, 0.02778, 0.57246],
      118: [0, 0.43056, 0.03588, 0.02778, 0.48472],
      119: [0, 0.43056, 0.02691, 0.08334, 0.71592],
      120: [0, 0.43056, 0, 0.02778, 0.57153],
      121: [0.19444, 0.43056, 0.03588, 0.05556, 0.49028],
      122: [0, 0.43056, 0.04398, 0.05556, 0.46505],
      160: [0, 0, 0, 0, 0.25],
      915: [0, 0.68333, 0.13889, 0.08334, 0.61528],
      916: [0, 0.68333, 0, 0.16667, 0.83334],
      920: [0, 0.68333, 0.02778, 0.08334, 0.76278],
      923: [0, 0.68333, 0, 0.16667, 0.69445],
      926: [0, 0.68333, 0.07569, 0.08334, 0.74236],
      928: [0, 0.68333, 0.08125, 0.05556, 0.83125],
      931: [0, 0.68333, 0.05764, 0.08334, 0.77986],
      933: [0, 0.68333, 0.13889, 0.05556, 0.58333],
      934: [0, 0.68333, 0, 0.08334, 0.66667],
      936: [0, 0.68333, 0.11, 0.05556, 0.61222],
      937: [0, 0.68333, 0.05017, 0.08334, 0.7724],
      945: [0, 0.43056, 0.0037, 0.02778, 0.6397],
      946: [0.19444, 0.69444, 0.05278, 0.08334, 0.56563],
      947: [0.19444, 0.43056, 0.05556, 0, 0.51773],
      948: [0, 0.69444, 0.03785, 0.05556, 0.44444],
      949: [0, 0.43056, 0, 0.08334, 0.46632],
      950: [0.19444, 0.69444, 0.07378, 0.08334, 0.4375],
      951: [0.19444, 0.43056, 0.03588, 0.05556, 0.49653],
      952: [0, 0.69444, 0.02778, 0.08334, 0.46944],
      953: [0, 0.43056, 0, 0.05556, 0.35394],
      954: [0, 0.43056, 0, 0, 0.57616],
      955: [0, 0.69444, 0, 0, 0.58334],
      956: [0.19444, 0.43056, 0, 0.02778, 0.60255],
      957: [0, 0.43056, 0.06366, 0.02778, 0.49398],
      958: [0.19444, 0.69444, 0.04601, 0.11111, 0.4375],
      959: [0, 0.43056, 0, 0.05556, 0.48472],
      960: [0, 0.43056, 0.03588, 0, 0.57003],
      961: [0.19444, 0.43056, 0, 0.08334, 0.51702],
      962: [0.09722, 0.43056, 0.07986, 0.08334, 0.36285],
      963: [0, 0.43056, 0.03588, 0, 0.57141],
      964: [0, 0.43056, 0.1132, 0.02778, 0.43715],
      965: [0, 0.43056, 0.03588, 0.02778, 0.54028],
      966: [0.19444, 0.43056, 0, 0.08334, 0.65417],
      967: [0.19444, 0.43056, 0, 0.05556, 0.62569],
      968: [0.19444, 0.69444, 0.03588, 0.11111, 0.65139],
      969: [0, 0.43056, 0.03588, 0, 0.62245],
      977: [0, 0.69444, 0, 0.08334, 0.59144],
      981: [0.19444, 0.69444, 0, 0.08334, 0.59583],
      982: [0, 0.43056, 0.02778, 0, 0.82813],
      1009: [0.19444, 0.43056, 0, 0.08334, 0.51702],
      1013: [0, 0.43056, 0, 0.05556, 0.4059],
      57649: [0, 0.43056, 0, 0.02778, 0.32246],
      57911: [0.19444, 0.43056, 0, 0.08334, 0.38403],
    },
    "SansSerif-Bold": {
      32: [0, 0, 0, 0, 0.25],
      33: [0, 0.69444, 0, 0, 0.36667],
      34: [0, 0.69444, 0, 0, 0.55834],
      35: [0.19444, 0.69444, 0, 0, 0.91667],
      36: [0.05556, 0.75, 0, 0, 0.55],
      37: [0.05556, 0.75, 0, 0, 1.02912],
      38: [0, 0.69444, 0, 0, 0.83056],
      39: [0, 0.69444, 0, 0, 0.30556],
      40: [0.25, 0.75, 0, 0, 0.42778],
      41: [0.25, 0.75, 0, 0, 0.42778],
      42: [0, 0.75, 0, 0, 0.55],
      43: [0.11667, 0.61667, 0, 0, 0.85556],
      44: [0.10556, 0.13056, 0, 0, 0.30556],
      45: [0, 0.45833, 0, 0, 0.36667],
      46: [0, 0.13056, 0, 0, 0.30556],
      47: [0.25, 0.75, 0, 0, 0.55],
      48: [0, 0.69444, 0, 0, 0.55],
      49: [0, 0.69444, 0, 0, 0.55],
      50: [0, 0.69444, 0, 0, 0.55],
      51: [0, 0.69444, 0, 0, 0.55],
      52: [0, 0.69444, 0, 0, 0.55],
      53: [0, 0.69444, 0, 0, 0.55],
      54: [0, 0.69444, 0, 0, 0.55],
      55: [0, 0.69444, 0, 0, 0.55],
      56: [0, 0.69444, 0, 0, 0.55],
      57: [0, 0.69444, 0, 0, 0.55],
      58: [0, 0.45833, 0, 0, 0.30556],
      59: [0.10556, 0.45833, 0, 0, 0.30556],
      61: [-0.09375, 0.40625, 0, 0, 0.85556],
      63: [0, 0.69444, 0, 0, 0.51945],
      64: [0, 0.69444, 0, 0, 0.73334],
      65: [0, 0.69444, 0, 0, 0.73334],
      66: [0, 0.69444, 0, 0, 0.73334],
      67: [0, 0.69444, 0, 0, 0.70278],
      68: [0, 0.69444, 0, 0, 0.79445],
      69: [0, 0.69444, 0, 0, 0.64167],
      70: [0, 0.69444, 0, 0, 0.61111],
      71: [0, 0.69444, 0, 0, 0.73334],
      72: [0, 0.69444, 0, 0, 0.79445],
      73: [0, 0.69444, 0, 0, 0.33056],
      74: [0, 0.69444, 0, 0, 0.51945],
      75: [0, 0.69444, 0, 0, 0.76389],
      76: [0, 0.69444, 0, 0, 0.58056],
      77: [0, 0.69444, 0, 0, 0.97778],
      78: [0, 0.69444, 0, 0, 0.79445],
      79: [0, 0.69444, 0, 0, 0.79445],
      80: [0, 0.69444, 0, 0, 0.70278],
      81: [0.10556, 0.69444, 0, 0, 0.79445],
      82: [0, 0.69444, 0, 0, 0.70278],
      83: [0, 0.69444, 0, 0, 0.61111],
      84: [0, 0.69444, 0, 0, 0.73334],
      85: [0, 0.69444, 0, 0, 0.76389],
      86: [0, 0.69444, 0.01528, 0, 0.73334],
      87: [0, 0.69444, 0.01528, 0, 1.03889],
      88: [0, 0.69444, 0, 0, 0.73334],
      89: [0, 0.69444, 0.0275, 0, 0.73334],
      90: [0, 0.69444, 0, 0, 0.67223],
      91: [0.25, 0.75, 0, 0, 0.34306],
      93: [0.25, 0.75, 0, 0, 0.34306],
      94: [0, 0.69444, 0, 0, 0.55],
      95: [0.35, 0.10833, 0.03056, 0, 0.55],
      97: [0, 0.45833, 0, 0, 0.525],
      98: [0, 0.69444, 0, 0, 0.56111],
      99: [0, 0.45833, 0, 0, 0.48889],
      100: [0, 0.69444, 0, 0, 0.56111],
      101: [0, 0.45833, 0, 0, 0.51111],
      102: [0, 0.69444, 0.07639, 0, 0.33611],
      103: [0.19444, 0.45833, 0.01528, 0, 0.55],
      104: [0, 0.69444, 0, 0, 0.56111],
      105: [0, 0.69444, 0, 0, 0.25556],
      106: [0.19444, 0.69444, 0, 0, 0.28611],
      107: [0, 0.69444, 0, 0, 0.53056],
      108: [0, 0.69444, 0, 0, 0.25556],
      109: [0, 0.45833, 0, 0, 0.86667],
      110: [0, 0.45833, 0, 0, 0.56111],
      111: [0, 0.45833, 0, 0, 0.55],
      112: [0.19444, 0.45833, 0, 0, 0.56111],
      113: [0.19444, 0.45833, 0, 0, 0.56111],
      114: [0, 0.45833, 0.01528, 0, 0.37222],
      115: [0, 0.45833, 0, 0, 0.42167],
      116: [0, 0.58929, 0, 0, 0.40417],
      117: [0, 0.45833, 0, 0, 0.56111],
      118: [0, 0.45833, 0.01528, 0, 0.5],
      119: [0, 0.45833, 0.01528, 0, 0.74445],
      120: [0, 0.45833, 0, 0, 0.5],
      121: [0.19444, 0.45833, 0.01528, 0, 0.5],
      122: [0, 0.45833, 0, 0, 0.47639],
      126: [0.35, 0.34444, 0, 0, 0.55],
      160: [0, 0, 0, 0, 0.25],
      168: [0, 0.69444, 0, 0, 0.55],
      176: [0, 0.69444, 0, 0, 0.73334],
      180: [0, 0.69444, 0, 0, 0.55],
      184: [0.17014, 0, 0, 0, 0.48889],
      305: [0, 0.45833, 0, 0, 0.25556],
      567: [0.19444, 0.45833, 0, 0, 0.28611],
      710: [0, 0.69444, 0, 0, 0.55],
      711: [0, 0.63542, 0, 0, 0.55],
      713: [0, 0.63778, 0, 0, 0.55],
      728: [0, 0.69444, 0, 0, 0.55],
      729: [0, 0.69444, 0, 0, 0.30556],
      730: [0, 0.69444, 0, 0, 0.73334],
      732: [0, 0.69444, 0, 0, 0.55],
      733: [0, 0.69444, 0, 0, 0.55],
      915: [0, 0.69444, 0, 0, 0.58056],
      916: [0, 0.69444, 0, 0, 0.91667],
      920: [0, 0.69444, 0, 0, 0.85556],
      923: [0, 0.69444, 0, 0, 0.67223],
      926: [0, 0.69444, 0, 0, 0.73334],
      928: [0, 0.69444, 0, 0, 0.79445],
      931: [0, 0.69444, 0, 0, 0.79445],
      933: [0, 0.69444, 0, 0, 0.85556],
      934: [0, 0.69444, 0, 0, 0.79445],
      936: [0, 0.69444, 0, 0, 0.85556],
      937: [0, 0.69444, 0, 0, 0.79445],
      8211: [0, 0.45833, 0.03056, 0, 0.55],
      8212: [0, 0.45833, 0.03056, 0, 1.10001],
      8216: [0, 0.69444, 0, 0, 0.30556],
      8217: [0, 0.69444, 0, 0, 0.30556],
      8220: [0, 0.69444, 0, 0, 0.55834],
      8221: [0, 0.69444, 0, 0, 0.55834],
    },
    "SansSerif-Italic": {
      32: [0, 0, 0, 0, 0.25],
      33: [0, 0.69444, 0.05733, 0, 0.31945],
      34: [0, 0.69444, 0.00316, 0, 0.5],
      35: [0.19444, 0.69444, 0.05087, 0, 0.83334],
      36: [0.05556, 0.75, 0.11156, 0, 0.5],
      37: [0.05556, 0.75, 0.03126, 0, 0.83334],
      38: [0, 0.69444, 0.03058, 0, 0.75834],
      39: [0, 0.69444, 0.07816, 0, 0.27778],
      40: [0.25, 0.75, 0.13164, 0, 0.38889],
      41: [0.25, 0.75, 0.02536, 0, 0.38889],
      42: [0, 0.75, 0.11775, 0, 0.5],
      43: [0.08333, 0.58333, 0.02536, 0, 0.77778],
      44: [0.125, 0.08333, 0, 0, 0.27778],
      45: [0, 0.44444, 0.01946, 0, 0.33333],
      46: [0, 0.08333, 0, 0, 0.27778],
      47: [0.25, 0.75, 0.13164, 0, 0.5],
      48: [0, 0.65556, 0.11156, 0, 0.5],
      49: [0, 0.65556, 0.11156, 0, 0.5],
      50: [0, 0.65556, 0.11156, 0, 0.5],
      51: [0, 0.65556, 0.11156, 0, 0.5],
      52: [0, 0.65556, 0.11156, 0, 0.5],
      53: [0, 0.65556, 0.11156, 0, 0.5],
      54: [0, 0.65556, 0.11156, 0, 0.5],
      55: [0, 0.65556, 0.11156, 0, 0.5],
      56: [0, 0.65556, 0.11156, 0, 0.5],
      57: [0, 0.65556, 0.11156, 0, 0.5],
      58: [0, 0.44444, 0.02502, 0, 0.27778],
      59: [0.125, 0.44444, 0.02502, 0, 0.27778],
      61: [-0.13, 0.37, 0.05087, 0, 0.77778],
      63: [0, 0.69444, 0.11809, 0, 0.47222],
      64: [0, 0.69444, 0.07555, 0, 0.66667],
      65: [0, 0.69444, 0, 0, 0.66667],
      66: [0, 0.69444, 0.08293, 0, 0.66667],
      67: [0, 0.69444, 0.11983, 0, 0.63889],
      68: [0, 0.69444, 0.07555, 0, 0.72223],
      69: [0, 0.69444, 0.11983, 0, 0.59722],
      70: [0, 0.69444, 0.13372, 0, 0.56945],
      71: [0, 0.69444, 0.11983, 0, 0.66667],
      72: [0, 0.69444, 0.08094, 0, 0.70834],
      73: [0, 0.69444, 0.13372, 0, 0.27778],
      74: [0, 0.69444, 0.08094, 0, 0.47222],
      75: [0, 0.69444, 0.11983, 0, 0.69445],
      76: [0, 0.69444, 0, 0, 0.54167],
      77: [0, 0.69444, 0.08094, 0, 0.875],
      78: [0, 0.69444, 0.08094, 0, 0.70834],
      79: [0, 0.69444, 0.07555, 0, 0.73611],
      80: [0, 0.69444, 0.08293, 0, 0.63889],
      81: [0.125, 0.69444, 0.07555, 0, 0.73611],
      82: [0, 0.69444, 0.08293, 0, 0.64584],
      83: [0, 0.69444, 0.09205, 0, 0.55556],
      84: [0, 0.69444, 0.13372, 0, 0.68056],
      85: [0, 0.69444, 0.08094, 0, 0.6875],
      86: [0, 0.69444, 0.1615, 0, 0.66667],
      87: [0, 0.69444, 0.1615, 0, 0.94445],
      88: [0, 0.69444, 0.13372, 0, 0.66667],
      89: [0, 0.69444, 0.17261, 0, 0.66667],
      90: [0, 0.69444, 0.11983, 0, 0.61111],
      91: [0.25, 0.75, 0.15942, 0, 0.28889],
      93: [0.25, 0.75, 0.08719, 0, 0.28889],
      94: [0, 0.69444, 0.0799, 0, 0.5],
      95: [0.35, 0.09444, 0.08616, 0, 0.5],
      97: [0, 0.44444, 0.00981, 0, 0.48056],
      98: [0, 0.69444, 0.03057, 0, 0.51667],
      99: [0, 0.44444, 0.08336, 0, 0.44445],
      100: [0, 0.69444, 0.09483, 0, 0.51667],
      101: [0, 0.44444, 0.06778, 0, 0.44445],
      102: [0, 0.69444, 0.21705, 0, 0.30556],
      103: [0.19444, 0.44444, 0.10836, 0, 0.5],
      104: [0, 0.69444, 0.01778, 0, 0.51667],
      105: [0, 0.67937, 0.09718, 0, 0.23889],
      106: [0.19444, 0.67937, 0.09162, 0, 0.26667],
      107: [0, 0.69444, 0.08336, 0, 0.48889],
      108: [0, 0.69444, 0.09483, 0, 0.23889],
      109: [0, 0.44444, 0.01778, 0, 0.79445],
      110: [0, 0.44444, 0.01778, 0, 0.51667],
      111: [0, 0.44444, 0.06613, 0, 0.5],
      112: [0.19444, 0.44444, 0.0389, 0, 0.51667],
      113: [0.19444, 0.44444, 0.04169, 0, 0.51667],
      114: [0, 0.44444, 0.10836, 0, 0.34167],
      115: [0, 0.44444, 0.0778, 0, 0.38333],
      116: [0, 0.57143, 0.07225, 0, 0.36111],
      117: [0, 0.44444, 0.04169, 0, 0.51667],
      118: [0, 0.44444, 0.10836, 0, 0.46111],
      119: [0, 0.44444, 0.10836, 0, 0.68334],
      120: [0, 0.44444, 0.09169, 0, 0.46111],
      121: [0.19444, 0.44444, 0.10836, 0, 0.46111],
      122: [0, 0.44444, 0.08752, 0, 0.43472],
      126: [0.35, 0.32659, 0.08826, 0, 0.5],
      160: [0, 0, 0, 0, 0.25],
      168: [0, 0.67937, 0.06385, 0, 0.5],
      176: [0, 0.69444, 0, 0, 0.73752],
      184: [0.17014, 0, 0, 0, 0.44445],
      305: [0, 0.44444, 0.04169, 0, 0.23889],
      567: [0.19444, 0.44444, 0.04169, 0, 0.26667],
      710: [0, 0.69444, 0.0799, 0, 0.5],
      711: [0, 0.63194, 0.08432, 0, 0.5],
      713: [0, 0.60889, 0.08776, 0, 0.5],
      714: [0, 0.69444, 0.09205, 0, 0.5],
      715: [0, 0.69444, 0, 0, 0.5],
      728: [0, 0.69444, 0.09483, 0, 0.5],
      729: [0, 0.67937, 0.07774, 0, 0.27778],
      730: [0, 0.69444, 0, 0, 0.73752],
      732: [0, 0.67659, 0.08826, 0, 0.5],
      733: [0, 0.69444, 0.09205, 0, 0.5],
      915: [0, 0.69444, 0.13372, 0, 0.54167],
      916: [0, 0.69444, 0, 0, 0.83334],
      920: [0, 0.69444, 0.07555, 0, 0.77778],
      923: [0, 0.69444, 0, 0, 0.61111],
      926: [0, 0.69444, 0.12816, 0, 0.66667],
      928: [0, 0.69444, 0.08094, 0, 0.70834],
      931: [0, 0.69444, 0.11983, 0, 0.72222],
      933: [0, 0.69444, 0.09031, 0, 0.77778],
      934: [0, 0.69444, 0.04603, 0, 0.72222],
      936: [0, 0.69444, 0.09031, 0, 0.77778],
      937: [0, 0.69444, 0.08293, 0, 0.72222],
      8211: [0, 0.44444, 0.08616, 0, 0.5],
      8212: [0, 0.44444, 0.08616, 0, 1],
      8216: [0, 0.69444, 0.07816, 0, 0.27778],
      8217: [0, 0.69444, 0.07816, 0, 0.27778],
      8220: [0, 0.69444, 0.14205, 0, 0.5],
      8221: [0, 0.69444, 0.00316, 0, 0.5],
    },
    "SansSerif-Regular": {
      32: [0, 0, 0, 0, 0.25],
      33: [0, 0.69444, 0, 0, 0.31945],
      34: [0, 0.69444, 0, 0, 0.5],
      35: [0.19444, 0.69444, 0, 0, 0.83334],
      36: [0.05556, 0.75, 0, 0, 0.5],
      37: [0.05556, 0.75, 0, 0, 0.83334],
      38: [0, 0.69444, 0, 0, 0.75834],
      39: [0, 0.69444, 0, 0, 0.27778],
      40: [0.25, 0.75, 0, 0, 0.38889],
      41: [0.25, 0.75, 0, 0, 0.38889],
      42: [0, 0.75, 0, 0, 0.5],
      43: [0.08333, 0.58333, 0, 0, 0.77778],
      44: [0.125, 0.08333, 0, 0, 0.27778],
      45: [0, 0.44444, 0, 0, 0.33333],
      46: [0, 0.08333, 0, 0, 0.27778],
      47: [0.25, 0.75, 0, 0, 0.5],
      48: [0, 0.65556, 0, 0, 0.5],
      49: [0, 0.65556, 0, 0, 0.5],
      50: [0, 0.65556, 0, 0, 0.5],
      51: [0, 0.65556, 0, 0, 0.5],
      52: [0, 0.65556, 0, 0, 0.5],
      53: [0, 0.65556, 0, 0, 0.5],
      54: [0, 0.65556, 0, 0, 0.5],
      55: [0, 0.65556, 0, 0, 0.5],
      56: [0, 0.65556, 0, 0, 0.5],
      57: [0, 0.65556, 0, 0, 0.5],
      58: [0, 0.44444, 0, 0, 0.27778],
      59: [0.125, 0.44444, 0, 0, 0.27778],
      61: [-0.13, 0.37, 0, 0, 0.77778],
      63: [0, 0.69444, 0, 0, 0.47222],
      64: [0, 0.69444, 0, 0, 0.66667],
      65: [0, 0.69444, 0, 0, 0.66667],
      66: [0, 0.69444, 0, 0, 0.66667],
      67: [0, 0.69444, 0, 0, 0.63889],
      68: [0, 0.69444, 0, 0, 0.72223],
      69: [0, 0.69444, 0, 0, 0.59722],
      70: [0, 0.69444, 0, 0, 0.56945],
      71: [0, 0.69444, 0, 0, 0.66667],
      72: [0, 0.69444, 0, 0, 0.70834],
      73: [0, 0.69444, 0, 0, 0.27778],
      74: [0, 0.69444, 0, 0, 0.47222],
      75: [0, 0.69444, 0, 0, 0.69445],
      76: [0, 0.69444, 0, 0, 0.54167],
      77: [0, 0.69444, 0, 0, 0.875],
      78: [0, 0.69444, 0, 0, 0.70834],
      79: [0, 0.69444, 0, 0, 0.73611],
      80: [0, 0.69444, 0, 0, 0.63889],
      81: [0.125, 0.69444, 0, 0, 0.73611],
      82: [0, 0.69444, 0, 0, 0.64584],
      83: [0, 0.69444, 0, 0, 0.55556],
      84: [0, 0.69444, 0, 0, 0.68056],
      85: [0, 0.69444, 0, 0, 0.6875],
      86: [0, 0.69444, 0.01389, 0, 0.66667],
      87: [0, 0.69444, 0.01389, 0, 0.94445],
      88: [0, 0.69444, 0, 0, 0.66667],
      89: [0, 0.69444, 0.025, 0, 0.66667],
      90: [0, 0.69444, 0, 0, 0.61111],
      91: [0.25, 0.75, 0, 0, 0.28889],
      93: [0.25, 0.75, 0, 0, 0.28889],
      94: [0, 0.69444, 0, 0, 0.5],
      95: [0.35, 0.09444, 0.02778, 0, 0.5],
      97: [0, 0.44444, 0, 0, 0.48056],
      98: [0, 0.69444, 0, 0, 0.51667],
      99: [0, 0.44444, 0, 0, 0.44445],
      100: [0, 0.69444, 0, 0, 0.51667],
      101: [0, 0.44444, 0, 0, 0.44445],
      102: [0, 0.69444, 0.06944, 0, 0.30556],
      103: [0.19444, 0.44444, 0.01389, 0, 0.5],
      104: [0, 0.69444, 0, 0, 0.51667],
      105: [0, 0.67937, 0, 0, 0.23889],
      106: [0.19444, 0.67937, 0, 0, 0.26667],
      107: [0, 0.69444, 0, 0, 0.48889],
      108: [0, 0.69444, 0, 0, 0.23889],
      109: [0, 0.44444, 0, 0, 0.79445],
      110: [0, 0.44444, 0, 0, 0.51667],
      111: [0, 0.44444, 0, 0, 0.5],
      112: [0.19444, 0.44444, 0, 0, 0.51667],
      113: [0.19444, 0.44444, 0, 0, 0.51667],
      114: [0, 0.44444, 0.01389, 0, 0.34167],
      115: [0, 0.44444, 0, 0, 0.38333],
      116: [0, 0.57143, 0, 0, 0.36111],
      117: [0, 0.44444, 0, 0, 0.51667],
      118: [0, 0.44444, 0.01389, 0, 0.46111],
      119: [0, 0.44444, 0.01389, 0, 0.68334],
      120: [0, 0.44444, 0, 0, 0.46111],
      121: [0.19444, 0.44444, 0.01389, 0, 0.46111],
      122: [0, 0.44444, 0, 0, 0.43472],
      126: [0.35, 0.32659, 0, 0, 0.5],
      160: [0, 0, 0, 0, 0.25],
      168: [0, 0.67937, 0, 0, 0.5],
      176: [0, 0.69444, 0, 0, 0.66667],
      184: [0.17014, 0, 0, 0, 0.44445],
      305: [0, 0.44444, 0, 0, 0.23889],
      567: [0.19444, 0.44444, 0, 0, 0.26667],
      710: [0, 0.69444, 0, 0, 0.5],
      711: [0, 0.63194, 0, 0, 0.5],
      713: [0, 0.60889, 0, 0, 0.5],
      714: [0, 0.69444, 0, 0, 0.5],
      715: [0, 0.69444, 0, 0, 0.5],
      728: [0, 0.69444, 0, 0, 0.5],
      729: [0, 0.67937, 0, 0, 0.27778],
      730: [0, 0.69444, 0, 0, 0.66667],
      732: [0, 0.67659, 0, 0, 0.5],
      733: [0, 0.69444, 0, 0, 0.5],
      915: [0, 0.69444, 0, 0, 0.54167],
      916: [0, 0.69444, 0, 0, 0.83334],
      920: [0, 0.69444, 0, 0, 0.77778],
      923: [0, 0.69444, 0, 0, 0.61111],
      926: [0, 0.69444, 0, 0, 0.66667],
      928: [0, 0.69444, 0, 0, 0.70834],
      931: [0, 0.69444, 0, 0, 0.72222],
      933: [0, 0.69444, 0, 0, 0.77778],
      934: [0, 0.69444, 0, 0, 0.72222],
      936: [0, 0.69444, 0, 0, 0.77778],
      937: [0, 0.69444, 0, 0, 0.72222],
      8211: [0, 0.44444, 0.02778, 0, 0.5],
      8212: [0, 0.44444, 0.02778, 0, 1],
      8216: [0, 0.69444, 0, 0, 0.27778],
      8217: [0, 0.69444, 0, 0, 0.27778],
      8220: [0, 0.69444, 0, 0, 0.5],
      8221: [0, 0.69444, 0, 0, 0.5],
    },
    "Script-Regular": {
      32: [0, 0, 0, 0, 0.25],
      65: [0, 0.7, 0.22925, 0, 0.80253],
      66: [0, 0.7, 0.04087, 0, 0.90757],
      67: [0, 0.7, 0.1689, 0, 0.66619],
      68: [0, 0.7, 0.09371, 0, 0.77443],
      69: [0, 0.7, 0.18583, 0, 0.56162],
      70: [0, 0.7, 0.13634, 0, 0.89544],
      71: [0, 0.7, 0.17322, 0, 0.60961],
      72: [0, 0.7, 0.29694, 0, 0.96919],
      73: [0, 0.7, 0.19189, 0, 0.80907],
      74: [0.27778, 0.7, 0.19189, 0, 1.05159],
      75: [0, 0.7, 0.31259, 0, 0.91364],
      76: [0, 0.7, 0.19189, 0, 0.87373],
      77: [0, 0.7, 0.15981, 0, 1.08031],
      78: [0, 0.7, 0.3525, 0, 0.9015],
      79: [0, 0.7, 0.08078, 0, 0.73787],
      80: [0, 0.7, 0.08078, 0, 1.01262],
      81: [0, 0.7, 0.03305, 0, 0.88282],
      82: [0, 0.7, 0.06259, 0, 0.85],
      83: [0, 0.7, 0.19189, 0, 0.86767],
      84: [0, 0.7, 0.29087, 0, 0.74697],
      85: [0, 0.7, 0.25815, 0, 0.79996],
      86: [0, 0.7, 0.27523, 0, 0.62204],
      87: [0, 0.7, 0.27523, 0, 0.80532],
      88: [0, 0.7, 0.26006, 0, 0.94445],
      89: [0, 0.7, 0.2939, 0, 0.70961],
      90: [0, 0.7, 0.24037, 0, 0.8212],
      160: [0, 0, 0, 0, 0.25],
    },
    "Size1-Regular": {
      32: [0, 0, 0, 0, 0.25],
      40: [0.35001, 0.85, 0, 0, 0.45834],
      41: [0.35001, 0.85, 0, 0, 0.45834],
      47: [0.35001, 0.85, 0, 0, 0.57778],
      91: [0.35001, 0.85, 0, 0, 0.41667],
      92: [0.35001, 0.85, 0, 0, 0.57778],
      93: [0.35001, 0.85, 0, 0, 0.41667],
      123: [0.35001, 0.85, 0, 0, 0.58334],
      125: [0.35001, 0.85, 0, 0, 0.58334],
      160: [0, 0, 0, 0, 0.25],
      710: [0, 0.72222, 0, 0, 0.55556],
      732: [0, 0.72222, 0, 0, 0.55556],
      770: [0, 0.72222, 0, 0, 0.55556],
      771: [0, 0.72222, 0, 0, 0.55556],
      8214: [-99e-5, 0.601, 0, 0, 0.77778],
      8593: [1e-5, 0.6, 0, 0, 0.66667],
      8595: [1e-5, 0.6, 0, 0, 0.66667],
      8657: [1e-5, 0.6, 0, 0, 0.77778],
      8659: [1e-5, 0.6, 0, 0, 0.77778],
      8719: [0.25001, 0.75, 0, 0, 0.94445],
      8720: [0.25001, 0.75, 0, 0, 0.94445],
      8721: [0.25001, 0.75, 0, 0, 1.05556],
      8730: [0.35001, 0.85, 0, 0, 1],
      8739: [-0.00599, 0.606, 0, 0, 0.33333],
      8741: [-0.00599, 0.606, 0, 0, 0.55556],
      8747: [0.30612, 0.805, 0.19445, 0, 0.47222],
      8748: [0.306, 0.805, 0.19445, 0, 0.47222],
      8749: [0.306, 0.805, 0.19445, 0, 0.47222],
      8750: [0.30612, 0.805, 0.19445, 0, 0.47222],
      8896: [0.25001, 0.75, 0, 0, 0.83334],
      8897: [0.25001, 0.75, 0, 0, 0.83334],
      8898: [0.25001, 0.75, 0, 0, 0.83334],
      8899: [0.25001, 0.75, 0, 0, 0.83334],
      8968: [0.35001, 0.85, 0, 0, 0.47222],
      8969: [0.35001, 0.85, 0, 0, 0.47222],
      8970: [0.35001, 0.85, 0, 0, 0.47222],
      8971: [0.35001, 0.85, 0, 0, 0.47222],
      9168: [-99e-5, 0.601, 0, 0, 0.66667],
      10216: [0.35001, 0.85, 0, 0, 0.47222],
      10217: [0.35001, 0.85, 0, 0, 0.47222],
      10752: [0.25001, 0.75, 0, 0, 1.11111],
      10753: [0.25001, 0.75, 0, 0, 1.11111],
      10754: [0.25001, 0.75, 0, 0, 1.11111],
      10756: [0.25001, 0.75, 0, 0, 0.83334],
      10758: [0.25001, 0.75, 0, 0, 0.83334],
    },
    "Size2-Regular": {
      32: [0, 0, 0, 0, 0.25],
      40: [0.65002, 1.15, 0, 0, 0.59722],
      41: [0.65002, 1.15, 0, 0, 0.59722],
      47: [0.65002, 1.15, 0, 0, 0.81111],
      91: [0.65002, 1.15, 0, 0, 0.47222],
      92: [0.65002, 1.15, 0, 0, 0.81111],
      93: [0.65002, 1.15, 0, 0, 0.47222],
      123: [0.65002, 1.15, 0, 0, 0.66667],
      125: [0.65002, 1.15, 0, 0, 0.66667],
      160: [0, 0, 0, 0, 0.25],
      710: [0, 0.75, 0, 0, 1],
      732: [0, 0.75, 0, 0, 1],
      770: [0, 0.75, 0, 0, 1],
      771: [0, 0.75, 0, 0, 1],
      8719: [0.55001, 1.05, 0, 0, 1.27778],
      8720: [0.55001, 1.05, 0, 0, 1.27778],
      8721: [0.55001, 1.05, 0, 0, 1.44445],
      8730: [0.65002, 1.15, 0, 0, 1],
      8747: [0.86225, 1.36, 0.44445, 0, 0.55556],
      8748: [0.862, 1.36, 0.44445, 0, 0.55556],
      8749: [0.862, 1.36, 0.44445, 0, 0.55556],
      8750: [0.86225, 1.36, 0.44445, 0, 0.55556],
      8896: [0.55001, 1.05, 0, 0, 1.11111],
      8897: [0.55001, 1.05, 0, 0, 1.11111],
      8898: [0.55001, 1.05, 0, 0, 1.11111],
      8899: [0.55001, 1.05, 0, 0, 1.11111],
      8968: [0.65002, 1.15, 0, 0, 0.52778],
      8969: [0.65002, 1.15, 0, 0, 0.52778],
      8970: [0.65002, 1.15, 0, 0, 0.52778],
      8971: [0.65002, 1.15, 0, 0, 0.52778],
      10216: [0.65002, 1.15, 0, 0, 0.61111],
      10217: [0.65002, 1.15, 0, 0, 0.61111],
      10752: [0.55001, 1.05, 0, 0, 1.51112],
      10753: [0.55001, 1.05, 0, 0, 1.51112],
      10754: [0.55001, 1.05, 0, 0, 1.51112],
      10756: [0.55001, 1.05, 0, 0, 1.11111],
      10758: [0.55001, 1.05, 0, 0, 1.11111],
    },
    "Size3-Regular": {
      32: [0, 0, 0, 0, 0.25],
      40: [0.95003, 1.45, 0, 0, 0.73611],
      41: [0.95003, 1.45, 0, 0, 0.73611],
      47: [0.95003, 1.45, 0, 0, 1.04445],
      91: [0.95003, 1.45, 0, 0, 0.52778],
      92: [0.95003, 1.45, 0, 0, 1.04445],
      93: [0.95003, 1.45, 0, 0, 0.52778],
      123: [0.95003, 1.45, 0, 0, 0.75],
      125: [0.95003, 1.45, 0, 0, 0.75],
      160: [0, 0, 0, 0, 0.25],
      710: [0, 0.75, 0, 0, 1.44445],
      732: [0, 0.75, 0, 0, 1.44445],
      770: [0, 0.75, 0, 0, 1.44445],
      771: [0, 0.75, 0, 0, 1.44445],
      8730: [0.95003, 1.45, 0, 0, 1],
      8968: [0.95003, 1.45, 0, 0, 0.58334],
      8969: [0.95003, 1.45, 0, 0, 0.58334],
      8970: [0.95003, 1.45, 0, 0, 0.58334],
      8971: [0.95003, 1.45, 0, 0, 0.58334],
      10216: [0.95003, 1.45, 0, 0, 0.75],
      10217: [0.95003, 1.45, 0, 0, 0.75],
    },
    "Size4-Regular": {
      32: [0, 0, 0, 0, 0.25],
      40: [1.25003, 1.75, 0, 0, 0.79167],
      41: [1.25003, 1.75, 0, 0, 0.79167],
      47: [1.25003, 1.75, 0, 0, 1.27778],
      91: [1.25003, 1.75, 0, 0, 0.58334],
      92: [1.25003, 1.75, 0, 0, 1.27778],
      93: [1.25003, 1.75, 0, 0, 0.58334],
      123: [1.25003, 1.75, 0, 0, 0.80556],
      125: [1.25003, 1.75, 0, 0, 0.80556],
      160: [0, 0, 0, 0, 0.25],
      710: [0, 0.825, 0, 0, 1.8889],
      732: [0, 0.825, 0, 0, 1.8889],
      770: [0, 0.825, 0, 0, 1.8889],
      771: [0, 0.825, 0, 0, 1.8889],
      8730: [1.25003, 1.75, 0, 0, 1],
      8968: [1.25003, 1.75, 0, 0, 0.63889],
      8969: [1.25003, 1.75, 0, 0, 0.63889],
      8970: [1.25003, 1.75, 0, 0, 0.63889],
      8971: [1.25003, 1.75, 0, 0, 0.63889],
      9115: [0.64502, 1.155, 0, 0, 0.875],
      9116: [1e-5, 0.6, 0, 0, 0.875],
      9117: [0.64502, 1.155, 0, 0, 0.875],
      9118: [0.64502, 1.155, 0, 0, 0.875],
      9119: [1e-5, 0.6, 0, 0, 0.875],
      9120: [0.64502, 1.155, 0, 0, 0.875],
      9121: [0.64502, 1.155, 0, 0, 0.66667],
      9122: [-99e-5, 0.601, 0, 0, 0.66667],
      9123: [0.64502, 1.155, 0, 0, 0.66667],
      9124: [0.64502, 1.155, 0, 0, 0.66667],
      9125: [-99e-5, 0.601, 0, 0, 0.66667],
      9126: [0.64502, 1.155, 0, 0, 0.66667],
      9127: [1e-5, 0.9, 0, 0, 0.88889],
      9128: [0.65002, 1.15, 0, 0, 0.88889],
      9129: [0.90001, 0, 0, 0, 0.88889],
      9130: [0, 0.3, 0, 0, 0.88889],
      9131: [1e-5, 0.9, 0, 0, 0.88889],
      9132: [0.65002, 1.15, 0, 0, 0.88889],
      9133: [0.90001, 0, 0, 0, 0.88889],
      9143: [0.88502, 0.915, 0, 0, 1.05556],
      10216: [1.25003, 1.75, 0, 0, 0.80556],
      10217: [1.25003, 1.75, 0, 0, 0.80556],
      57344: [-0.00499, 0.605, 0, 0, 1.05556],
      57345: [-0.00499, 0.605, 0, 0, 1.05556],
      57680: [0, 0.12, 0, 0, 0.45],
      57681: [0, 0.12, 0, 0, 0.45],
      57682: [0, 0.12, 0, 0, 0.45],
      57683: [0, 0.12, 0, 0, 0.45],
    },
    "Typewriter-Regular": {
      32: [0, 0, 0, 0, 0.525],
      33: [0, 0.61111, 0, 0, 0.525],
      34: [0, 0.61111, 0, 0, 0.525],
      35: [0, 0.61111, 0, 0, 0.525],
      36: [0.08333, 0.69444, 0, 0, 0.525],
      37: [0.08333, 0.69444, 0, 0, 0.525],
      38: [0, 0.61111, 0, 0, 0.525],
      39: [0, 0.61111, 0, 0, 0.525],
      40: [0.08333, 0.69444, 0, 0, 0.525],
      41: [0.08333, 0.69444, 0, 0, 0.525],
      42: [0, 0.52083, 0, 0, 0.525],
      43: [-0.08056, 0.53055, 0, 0, 0.525],
      44: [0.13889, 0.125, 0, 0, 0.525],
      45: [-0.08056, 0.53055, 0, 0, 0.525],
      46: [0, 0.125, 0, 0, 0.525],
      47: [0.08333, 0.69444, 0, 0, 0.525],
      48: [0, 0.61111, 0, 0, 0.525],
      49: [0, 0.61111, 0, 0, 0.525],
      50: [0, 0.61111, 0, 0, 0.525],
      51: [0, 0.61111, 0, 0, 0.525],
      52: [0, 0.61111, 0, 0, 0.525],
      53: [0, 0.61111, 0, 0, 0.525],
      54: [0, 0.61111, 0, 0, 0.525],
      55: [0, 0.61111, 0, 0, 0.525],
      56: [0, 0.61111, 0, 0, 0.525],
      57: [0, 0.61111, 0, 0, 0.525],
      58: [0, 0.43056, 0, 0, 0.525],
      59: [0.13889, 0.43056, 0, 0, 0.525],
      60: [-0.05556, 0.55556, 0, 0, 0.525],
      61: [-0.19549, 0.41562, 0, 0, 0.525],
      62: [-0.05556, 0.55556, 0, 0, 0.525],
      63: [0, 0.61111, 0, 0, 0.525],
      64: [0, 0.61111, 0, 0, 0.525],
      65: [0, 0.61111, 0, 0, 0.525],
      66: [0, 0.61111, 0, 0, 0.525],
      67: [0, 0.61111, 0, 0, 0.525],
      68: [0, 0.61111, 0, 0, 0.525],
      69: [0, 0.61111, 0, 0, 0.525],
      70: [0, 0.61111, 0, 0, 0.525],
      71: [0, 0.61111, 0, 0, 0.525],
      72: [0, 0.61111, 0, 0, 0.525],
      73: [0, 0.61111, 0, 0, 0.525],
      74: [0, 0.61111, 0, 0, 0.525],
      75: [0, 0.61111, 0, 0, 0.525],
      76: [0, 0.61111, 0, 0, 0.525],
      77: [0, 0.61111, 0, 0, 0.525],
      78: [0, 0.61111, 0, 0, 0.525],
      79: [0, 0.61111, 0, 0, 0.525],
      80: [0, 0.61111, 0, 0, 0.525],
      81: [0.13889, 0.61111, 0, 0, 0.525],
      82: [0, 0.61111, 0, 0, 0.525],
      83: [0, 0.61111, 0, 0, 0.525],
      84: [0, 0.61111, 0, 0, 0.525],
      85: [0, 0.61111, 0, 0, 0.525],
      86: [0, 0.61111, 0, 0, 0.525],
      87: [0, 0.61111, 0, 0, 0.525],
      88: [0, 0.61111, 0, 0, 0.525],
      89: [0, 0.61111, 0, 0, 0.525],
      90: [0, 0.61111, 0, 0, 0.525],
      91: [0.08333, 0.69444, 0, 0, 0.525],
      92: [0.08333, 0.69444, 0, 0, 0.525],
      93: [0.08333, 0.69444, 0, 0, 0.525],
      94: [0, 0.61111, 0, 0, 0.525],
      95: [0.09514, 0, 0, 0, 0.525],
      96: [0, 0.61111, 0, 0, 0.525],
      97: [0, 0.43056, 0, 0, 0.525],
      98: [0, 0.61111, 0, 0, 0.525],
      99: [0, 0.43056, 0, 0, 0.525],
      100: [0, 0.61111, 0, 0, 0.525],
      101: [0, 0.43056, 0, 0, 0.525],
      102: [0, 0.61111, 0, 0, 0.525],
      103: [0.22222, 0.43056, 0, 0, 0.525],
      104: [0, 0.61111, 0, 0, 0.525],
      105: [0, 0.61111, 0, 0, 0.525],
      106: [0.22222, 0.61111, 0, 0, 0.525],
      107: [0, 0.61111, 0, 0, 0.525],
      108: [0, 0.61111, 0, 0, 0.525],
      109: [0, 0.43056, 0, 0, 0.525],
      110: [0, 0.43056, 0, 0, 0.525],
      111: [0, 0.43056, 0, 0, 0.525],
      112: [0.22222, 0.43056, 0, 0, 0.525],
      113: [0.22222, 0.43056, 0, 0, 0.525],
      114: [0, 0.43056, 0, 0, 0.525],
      115: [0, 0.43056, 0, 0, 0.525],
      116: [0, 0.55358, 0, 0, 0.525],
      117: [0, 0.43056, 0, 0, 0.525],
      118: [0, 0.43056, 0, 0, 0.525],
      119: [0, 0.43056, 0, 0, 0.525],
      120: [0, 0.43056, 0, 0, 0.525],
      121: [0.22222, 0.43056, 0, 0, 0.525],
      122: [0, 0.43056, 0, 0, 0.525],
      123: [0.08333, 0.69444, 0, 0, 0.525],
      124: [0.08333, 0.69444, 0, 0, 0.525],
      125: [0.08333, 0.69444, 0, 0, 0.525],
      126: [0, 0.61111, 0, 0, 0.525],
      127: [0, 0.61111, 0, 0, 0.525],
      160: [0, 0, 0, 0, 0.525],
      176: [0, 0.61111, 0, 0, 0.525],
      184: [0.19445, 0, 0, 0, 0.525],
      305: [0, 0.43056, 0, 0, 0.525],
      567: [0.22222, 0.43056, 0, 0, 0.525],
      711: [0, 0.56597, 0, 0, 0.525],
      713: [0, 0.56555, 0, 0, 0.525],
      714: [0, 0.61111, 0, 0, 0.525],
      715: [0, 0.61111, 0, 0, 0.525],
      728: [0, 0.61111, 0, 0, 0.525],
      730: [0, 0.61111, 0, 0, 0.525],
      770: [0, 0.61111, 0, 0, 0.525],
      771: [0, 0.61111, 0, 0, 0.525],
      776: [0, 0.61111, 0, 0, 0.525],
      915: [0, 0.61111, 0, 0, 0.525],
      916: [0, 0.61111, 0, 0, 0.525],
      920: [0, 0.61111, 0, 0, 0.525],
      923: [0, 0.61111, 0, 0, 0.525],
      926: [0, 0.61111, 0, 0, 0.525],
      928: [0, 0.61111, 0, 0, 0.525],
      931: [0, 0.61111, 0, 0, 0.525],
      933: [0, 0.61111, 0, 0, 0.525],
      934: [0, 0.61111, 0, 0, 0.525],
      936: [0, 0.61111, 0, 0, 0.525],
      937: [0, 0.61111, 0, 0, 0.525],
      8216: [0, 0.61111, 0, 0, 0.525],
      8217: [0, 0.61111, 0, 0, 0.525],
      8242: [0, 0.61111, 0, 0, 0.525],
      9251: [0.11111, 0.21944, 0, 0, 0.525],
    },
  },
  He = {
    slant: [0.25, 0.25, 0.25],
    space: [0, 0, 0],
    stretch: [0, 0, 0],
    shrink: [0, 0, 0],
    xHeight: [0.431, 0.431, 0.431],
    quad: [1, 1.171, 1.472],
    extraSpace: [0, 0, 0],
    num1: [0.677, 0.732, 0.925],
    num2: [0.394, 0.384, 0.387],
    num3: [0.444, 0.471, 0.504],
    denom1: [0.686, 0.752, 1.025],
    denom2: [0.345, 0.344, 0.532],
    sup1: [0.413, 0.503, 0.504],
    sup2: [0.363, 0.431, 0.404],
    sup3: [0.289, 0.286, 0.294],
    sub1: [0.15, 0.143, 0.2],
    sub2: [0.247, 0.286, 0.4],
    supDrop: [0.386, 0.353, 0.494],
    subDrop: [0.05, 0.071, 0.1],
    delim1: [2.39, 1.7, 1.98],
    delim2: [1.01, 1.157, 1.42],
    axisHeight: [0.25, 0.25, 0.25],
    defaultRuleThickness: [0.04, 0.049, 0.049],
    bigOpSpacing1: [0.111, 0.111, 0.111],
    bigOpSpacing2: [0.166, 0.166, 0.166],
    bigOpSpacing3: [0.2, 0.2, 0.2],
    bigOpSpacing4: [0.6, 0.611, 0.611],
    bigOpSpacing5: [0.1, 0.143, 0.143],
    sqrtRuleThickness: [0.04, 0.04, 0.04],
    ptPerEm: [10, 10, 10],
    doubleRuleSep: [0.2, 0.2, 0.2],
    arrayRuleWidth: [0.04, 0.04, 0.04],
    fboxsep: [0.3, 0.3, 0.3],
    fboxrule: [0.04, 0.04, 0.04],
  },
  Ue = {
    Å: `A`,
    Ð: `D`,
    Þ: `o`,
    å: `a`,
    ð: `d`,
    þ: `o`,
    А: `A`,
    Б: `B`,
    В: `B`,
    Г: `F`,
    Д: `A`,
    Е: `E`,
    Ж: `K`,
    З: `3`,
    И: `N`,
    Й: `N`,
    К: `K`,
    Л: `N`,
    М: `M`,
    Н: `H`,
    О: `O`,
    П: `N`,
    Р: `P`,
    С: `C`,
    Т: `T`,
    У: `y`,
    Ф: `O`,
    Х: `X`,
    Ц: `U`,
    Ч: `h`,
    Ш: `W`,
    Щ: `W`,
    Ъ: `B`,
    Ы: `X`,
    Ь: `B`,
    Э: `3`,
    Ю: `X`,
    Я: `R`,
    а: `a`,
    б: `b`,
    в: `a`,
    г: `r`,
    д: `y`,
    е: `e`,
    ж: `m`,
    з: `e`,
    и: `n`,
    й: `n`,
    к: `n`,
    л: `n`,
    м: `m`,
    н: `n`,
    о: `o`,
    п: `n`,
    р: `p`,
    с: `c`,
    т: `o`,
    у: `y`,
    ф: `b`,
    х: `x`,
    ц: `n`,
    ч: `n`,
    ш: `w`,
    щ: `w`,
    ъ: `a`,
    ы: `m`,
    ь: `a`,
    э: `e`,
    ю: `m`,
    я: `r`,
  };
function We(e, t) {
  Ve[e] = t;
}
function Ge(e, t, n) {
  if (!Ve[t]) throw Error(`Font metrics not found for font: ` + t + `.`);
  var r = e.charCodeAt(0),
    i = Ve[t][r];
  if (
    (!i && e[0] in Ue && ((r = Ue[e[0]].charCodeAt(0)), (i = Ve[t][r])),
    !i && n === `text` && ce(r) && (i = Ve[t][77]),
    i)
  )
    return {
      depth: i[0],
      height: i[1],
      italic: i[2],
      skew: i[3],
      width: i[4],
    };
}
var Ke = {};
function M(e) {
  var t = e >= 5 ? 0 : e >= 3 ? 1 : 2;
  if (!Ke[t]) {
    var n = (Ke[t] = {
      cssEmPerMu: He.quad[t] / 18,
    });
    for (var r in He) He.hasOwnProperty(r) && (n[r] = He[r][t]);
  }
  return Ke[t];
}
var qe = {
  math: {},
  text: {},
};
function N(e, t, n, r, i, a) {
  ((qe[e][i] = {
    font: t,
    group: n,
    replace: r,
  }),
    a && r && (qe[e][r] = qe[e][i]));
}
var P = `math`,
  F = `text`,
  I = `main`,
  L = `ams`,
  R = `accent-token`,
  z = `bin`,
  Je = `close`,
  Ye = `inner`,
  B = `mathord`,
  Xe = `op-token`,
  Ze = `open`,
  Qe = `punct`,
  V = `rel`,
  $e = `spacing`,
  H = `textord`;
(N(P, I, V, `≡`, `\\equiv`, !0),
  N(P, I, V, `≺`, `\\prec`, !0),
  N(P, I, V, `≻`, `\\succ`, !0),
  N(P, I, V, `∼`, `\\sim`, !0),
  N(P, I, V, `⊥`, `\\perp`),
  N(P, I, V, `⪯`, `\\preceq`, !0),
  N(P, I, V, `⪰`, `\\succeq`, !0),
  N(P, I, V, `≃`, `\\simeq`, !0),
  N(P, I, V, `∣`, `\\mid`, !0),
  N(P, I, V, `≪`, `\\ll`, !0),
  N(P, I, V, `≫`, `\\gg`, !0),
  N(P, I, V, `≍`, `\\asymp`, !0),
  N(P, I, V, `∥`, `\\parallel`),
  N(P, I, V, `⋈`, `\\bowtie`, !0),
  N(P, I, V, `⌣`, `\\smile`, !0),
  N(P, I, V, `⊑`, `\\sqsubseteq`, !0),
  N(P, I, V, `⊒`, `\\sqsupseteq`, !0),
  N(P, I, V, `≐`, `\\doteq`, !0),
  N(P, I, V, `⌢`, `\\frown`, !0),
  N(P, I, V, `∋`, `\\ni`, !0),
  N(P, I, V, `∝`, `\\propto`, !0),
  N(P, I, V, `⊢`, `\\vdash`, !0),
  N(P, I, V, `⊣`, `\\dashv`, !0),
  N(P, I, V, `∋`, `\\owns`),
  N(P, I, Qe, `.`, `\\ldotp`),
  N(P, I, Qe, `⋅`, `\\cdotp`),
  N(P, I, Qe, `⋅`, `·`),
  N(F, I, H, `⋅`, `·`),
  N(P, I, H, `#`, `\\#`),
  N(F, I, H, `#`, `\\#`),
  N(P, I, H, `&`, `\\&`),
  N(F, I, H, `&`, `\\&`),
  N(P, I, H, `ℵ`, `\\aleph`, !0),
  N(P, I, H, `∀`, `\\forall`, !0),
  N(P, I, H, `ℏ`, `\\hbar`, !0),
  N(P, I, H, `∃`, `\\exists`, !0),
  N(P, I, H, `∇`, `\\nabla`, !0),
  N(P, I, H, `♭`, `\\flat`, !0),
  N(P, I, H, `ℓ`, `\\ell`, !0),
  N(P, I, H, `♮`, `\\natural`, !0),
  N(P, I, H, `♣`, `\\clubsuit`, !0),
  N(P, I, H, `℘`, `\\wp`, !0),
  N(P, I, H, `♯`, `\\sharp`, !0),
  N(P, I, H, `♢`, `\\diamondsuit`, !0),
  N(P, I, H, `ℜ`, `\\Re`, !0),
  N(P, I, H, `♡`, `\\heartsuit`, !0),
  N(P, I, H, `ℑ`, `\\Im`, !0),
  N(P, I, H, `♠`, `\\spadesuit`, !0),
  N(P, I, H, `§`, `\\S`, !0),
  N(F, I, H, `§`, `\\S`),
  N(P, I, H, `¶`, `\\P`, !0),
  N(F, I, H, `¶`, `\\P`),
  N(P, I, H, `†`, `\\dag`),
  N(F, I, H, `†`, `\\dag`),
  N(F, I, H, `†`, `\\textdagger`),
  N(P, I, H, `‡`, `\\ddag`),
  N(F, I, H, `‡`, `\\ddag`),
  N(F, I, H, `‡`, `\\textdaggerdbl`),
  N(P, I, Je, `⎱`, `\\rmoustache`, !0),
  N(P, I, Ze, `⎰`, `\\lmoustache`, !0),
  N(P, I, Je, `⟯`, `\\rgroup`, !0),
  N(P, I, Ze, `⟮`, `\\lgroup`, !0),
  N(P, I, z, `∓`, `\\mp`, !0),
  N(P, I, z, `⊖`, `\\ominus`, !0),
  N(P, I, z, `⊎`, `\\uplus`, !0),
  N(P, I, z, `⊓`, `\\sqcap`, !0),
  N(P, I, z, `∗`, `\\ast`),
  N(P, I, z, `⊔`, `\\sqcup`, !0),
  N(P, I, z, `◯`, `\\bigcirc`, !0),
  N(P, I, z, `∙`, `\\bullet`, !0),
  N(P, I, z, `‡`, `\\ddagger`),
  N(P, I, z, `≀`, `\\wr`, !0),
  N(P, I, z, `⨿`, `\\amalg`),
  N(P, I, z, `&`, `\\And`),
  N(P, I, V, `⟵`, `\\longleftarrow`, !0),
  N(P, I, V, `⇐`, `\\Leftarrow`, !0),
  N(P, I, V, `⟸`, `\\Longleftarrow`, !0),
  N(P, I, V, `⟶`, `\\longrightarrow`, !0),
  N(P, I, V, `⇒`, `\\Rightarrow`, !0),
  N(P, I, V, `⟹`, `\\Longrightarrow`, !0),
  N(P, I, V, `↔`, `\\leftrightarrow`, !0),
  N(P, I, V, `⟷`, `\\longleftrightarrow`, !0),
  N(P, I, V, `⇔`, `\\Leftrightarrow`, !0),
  N(P, I, V, `⟺`, `\\Longleftrightarrow`, !0),
  N(P, I, V, `↦`, `\\mapsto`, !0),
  N(P, I, V, `⟼`, `\\longmapsto`, !0),
  N(P, I, V, `↗`, `\\nearrow`, !0),
  N(P, I, V, `↩`, `\\hookleftarrow`, !0),
  N(P, I, V, `↪`, `\\hookrightarrow`, !0),
  N(P, I, V, `↘`, `\\searrow`, !0),
  N(P, I, V, `↼`, `\\leftharpoonup`, !0),
  N(P, I, V, `⇀`, `\\rightharpoonup`, !0),
  N(P, I, V, `↙`, `\\swarrow`, !0),
  N(P, I, V, `↽`, `\\leftharpoondown`, !0),
  N(P, I, V, `⇁`, `\\rightharpoondown`, !0),
  N(P, I, V, `↖`, `\\nwarrow`, !0),
  N(P, I, V, `⇌`, `\\rightleftharpoons`, !0),
  N(P, L, V, `≮`, `\\nless`, !0),
  N(P, L, V, ``, `\\@nleqslant`),
  N(P, L, V, ``, `\\@nleqq`),
  N(P, L, V, `⪇`, `\\lneq`, !0),
  N(P, L, V, `≨`, `\\lneqq`, !0),
  N(P, L, V, ``, `\\@lvertneqq`),
  N(P, L, V, `⋦`, `\\lnsim`, !0),
  N(P, L, V, `⪉`, `\\lnapprox`, !0),
  N(P, L, V, `⊀`, `\\nprec`, !0),
  N(P, L, V, `⋠`, `\\npreceq`, !0),
  N(P, L, V, `⋨`, `\\precnsim`, !0),
  N(P, L, V, `⪹`, `\\precnapprox`, !0),
  N(P, L, V, `≁`, `\\nsim`, !0),
  N(P, L, V, ``, `\\@nshortmid`),
  N(P, L, V, `∤`, `\\nmid`, !0),
  N(P, L, V, `⊬`, `\\nvdash`, !0),
  N(P, L, V, `⊭`, `\\nvDash`, !0),
  N(P, L, V, `⋪`, `\\ntriangleleft`),
  N(P, L, V, `⋬`, `\\ntrianglelefteq`, !0),
  N(P, L, V, `⊊`, `\\subsetneq`, !0),
  N(P, L, V, ``, `\\@varsubsetneq`),
  N(P, L, V, `⫋`, `\\subsetneqq`, !0),
  N(P, L, V, ``, `\\@varsubsetneqq`),
  N(P, L, V, `≯`, `\\ngtr`, !0),
  N(P, L, V, ``, `\\@ngeqslant`),
  N(P, L, V, ``, `\\@ngeqq`),
  N(P, L, V, `⪈`, `\\gneq`, !0),
  N(P, L, V, `≩`, `\\gneqq`, !0),
  N(P, L, V, ``, `\\@gvertneqq`),
  N(P, L, V, `⋧`, `\\gnsim`, !0),
  N(P, L, V, `⪊`, `\\gnapprox`, !0),
  N(P, L, V, `⊁`, `\\nsucc`, !0),
  N(P, L, V, `⋡`, `\\nsucceq`, !0),
  N(P, L, V, `⋩`, `\\succnsim`, !0),
  N(P, L, V, `⪺`, `\\succnapprox`, !0),
  N(P, L, V, `≆`, `\\ncong`, !0),
  N(P, L, V, ``, `\\@nshortparallel`),
  N(P, L, V, `∦`, `\\nparallel`, !0),
  N(P, L, V, `⊯`, `\\nVDash`, !0),
  N(P, L, V, `⋫`, `\\ntriangleright`),
  N(P, L, V, `⋭`, `\\ntrianglerighteq`, !0),
  N(P, L, V, ``, `\\@nsupseteqq`),
  N(P, L, V, `⊋`, `\\supsetneq`, !0),
  N(P, L, V, ``, `\\@varsupsetneq`),
  N(P, L, V, `⫌`, `\\supsetneqq`, !0),
  N(P, L, V, ``, `\\@varsupsetneqq`),
  N(P, L, V, `⊮`, `\\nVdash`, !0),
  N(P, L, V, `⪵`, `\\precneqq`, !0),
  N(P, L, V, `⪶`, `\\succneqq`, !0),
  N(P, L, V, ``, `\\@nsubseteqq`),
  N(P, L, z, `⊴`, `\\unlhd`),
  N(P, L, z, `⊵`, `\\unrhd`),
  N(P, L, V, `↚`, `\\nleftarrow`, !0),
  N(P, L, V, `↛`, `\\nrightarrow`, !0),
  N(P, L, V, `⇍`, `\\nLeftarrow`, !0),
  N(P, L, V, `⇏`, `\\nRightarrow`, !0),
  N(P, L, V, `↮`, `\\nleftrightarrow`, !0),
  N(P, L, V, `⇎`, `\\nLeftrightarrow`, !0),
  N(P, L, V, `△`, `\\vartriangle`),
  N(P, L, H, `ℏ`, `\\hslash`),
  N(P, L, H, `▽`, `\\triangledown`),
  N(P, L, H, `◊`, `\\lozenge`),
  N(P, L, H, `Ⓢ`, `\\circledS`),
  N(P, L, H, `®`, `\\circledR`),
  N(F, L, H, `®`, `\\circledR`),
  N(P, L, H, `∡`, `\\measuredangle`, !0),
  N(P, L, H, `∄`, `\\nexists`),
  N(P, L, H, `℧`, `\\mho`),
  N(P, L, H, `Ⅎ`, `\\Finv`, !0),
  N(P, L, H, `⅁`, `\\Game`, !0),
  N(P, L, H, `‵`, `\\backprime`),
  N(P, L, H, `▲`, `\\blacktriangle`),
  N(P, L, H, `▼`, `\\blacktriangledown`),
  N(P, L, H, `■`, `\\blacksquare`),
  N(P, L, H, `⧫`, `\\blacklozenge`),
  N(P, L, H, `★`, `\\bigstar`),
  N(P, L, H, `∢`, `\\sphericalangle`, !0),
  N(P, L, H, `∁`, `\\complement`, !0),
  N(P, L, H, `ð`, `\\eth`, !0),
  N(F, I, H, `ð`, `ð`),
  N(P, L, H, `╱`, `\\diagup`),
  N(P, L, H, `╲`, `\\diagdown`),
  N(P, L, H, `□`, `\\square`),
  N(P, L, H, `□`, `\\Box`),
  N(P, L, H, `◊`, `\\Diamond`),
  N(P, L, H, `¥`, `\\yen`, !0),
  N(F, L, H, `¥`, `\\yen`, !0),
  N(P, L, H, `✓`, `\\checkmark`, !0),
  N(F, L, H, `✓`, `\\checkmark`),
  N(P, L, H, `ℶ`, `\\beth`, !0),
  N(P, L, H, `ℸ`, `\\daleth`, !0),
  N(P, L, H, `ℷ`, `\\gimel`, !0),
  N(P, L, H, `ϝ`, `\\digamma`, !0),
  N(P, L, H, `ϰ`, `\\varkappa`),
  N(P, L, Ze, `┌`, `\\@ulcorner`, !0),
  N(P, L, Je, `┐`, `\\@urcorner`, !0),
  N(P, L, Ze, `└`, `\\@llcorner`, !0),
  N(P, L, Je, `┘`, `\\@lrcorner`, !0),
  N(P, L, V, `≦`, `\\leqq`, !0),
  N(P, L, V, `⩽`, `\\leqslant`, !0),
  N(P, L, V, `⪕`, `\\eqslantless`, !0),
  N(P, L, V, `≲`, `\\lesssim`, !0),
  N(P, L, V, `⪅`, `\\lessapprox`, !0),
  N(P, L, V, `≊`, `\\approxeq`, !0),
  N(P, L, z, `⋖`, `\\lessdot`),
  N(P, L, V, `⋘`, `\\lll`, !0),
  N(P, L, V, `≶`, `\\lessgtr`, !0),
  N(P, L, V, `⋚`, `\\lesseqgtr`, !0),
  N(P, L, V, `⪋`, `\\lesseqqgtr`, !0),
  N(P, L, V, `≑`, `\\doteqdot`),
  N(P, L, V, `≓`, `\\risingdotseq`, !0),
  N(P, L, V, `≒`, `\\fallingdotseq`, !0),
  N(P, L, V, `∽`, `\\backsim`, !0),
  N(P, L, V, `⋍`, `\\backsimeq`, !0),
  N(P, L, V, `⫅`, `\\subseteqq`, !0),
  N(P, L, V, `⋐`, `\\Subset`, !0),
  N(P, L, V, `⊏`, `\\sqsubset`, !0),
  N(P, L, V, `≼`, `\\preccurlyeq`, !0),
  N(P, L, V, `⋞`, `\\curlyeqprec`, !0),
  N(P, L, V, `≾`, `\\precsim`, !0),
  N(P, L, V, `⪷`, `\\precapprox`, !0),
  N(P, L, V, `⊲`, `\\vartriangleleft`),
  N(P, L, V, `⊴`, `\\trianglelefteq`),
  N(P, L, V, `⊨`, `\\vDash`, !0),
  N(P, L, V, `⊪`, `\\Vvdash`, !0),
  N(P, L, V, `⌣`, `\\smallsmile`),
  N(P, L, V, `⌢`, `\\smallfrown`),
  N(P, L, V, `≏`, `\\bumpeq`, !0),
  N(P, L, V, `≎`, `\\Bumpeq`, !0),
  N(P, L, V, `≧`, `\\geqq`, !0),
  N(P, L, V, `⩾`, `\\geqslant`, !0),
  N(P, L, V, `⪖`, `\\eqslantgtr`, !0),
  N(P, L, V, `≳`, `\\gtrsim`, !0),
  N(P, L, V, `⪆`, `\\gtrapprox`, !0),
  N(P, L, z, `⋗`, `\\gtrdot`),
  N(P, L, V, `⋙`, `\\ggg`, !0),
  N(P, L, V, `≷`, `\\gtrless`, !0),
  N(P, L, V, `⋛`, `\\gtreqless`, !0),
  N(P, L, V, `⪌`, `\\gtreqqless`, !0),
  N(P, L, V, `≖`, `\\eqcirc`, !0),
  N(P, L, V, `≗`, `\\circeq`, !0),
  N(P, L, V, `≜`, `\\triangleq`, !0),
  N(P, L, V, `∼`, `\\thicksim`),
  N(P, L, V, `≈`, `\\thickapprox`),
  N(P, L, V, `⫆`, `\\supseteqq`, !0),
  N(P, L, V, `⋑`, `\\Supset`, !0),
  N(P, L, V, `⊐`, `\\sqsupset`, !0),
  N(P, L, V, `≽`, `\\succcurlyeq`, !0),
  N(P, L, V, `⋟`, `\\curlyeqsucc`, !0),
  N(P, L, V, `≿`, `\\succsim`, !0),
  N(P, L, V, `⪸`, `\\succapprox`, !0),
  N(P, L, V, `⊳`, `\\vartriangleright`),
  N(P, L, V, `⊵`, `\\trianglerighteq`),
  N(P, L, V, `⊩`, `\\Vdash`, !0),
  N(P, L, V, `∣`, `\\shortmid`),
  N(P, L, V, `∥`, `\\shortparallel`),
  N(P, L, V, `≬`, `\\between`, !0),
  N(P, L, V, `⋔`, `\\pitchfork`, !0),
  N(P, L, V, `∝`, `\\varpropto`),
  N(P, L, V, `◀`, `\\blacktriangleleft`),
  N(P, L, V, `∴`, `\\therefore`, !0),
  N(P, L, V, `∍`, `\\backepsilon`),
  N(P, L, V, `▶`, `\\blacktriangleright`),
  N(P, L, V, `∵`, `\\because`, !0),
  N(P, L, V, `⋘`, `\\llless`),
  N(P, L, V, `⋙`, `\\gggtr`),
  N(P, L, z, `⊲`, `\\lhd`),
  N(P, L, z, `⊳`, `\\rhd`),
  N(P, L, V, `≂`, `\\eqsim`, !0),
  N(P, I, V, `⋈`, `\\Join`),
  N(P, L, V, `≑`, `\\Doteq`, !0),
  N(P, L, z, `∔`, `\\dotplus`, !0),
  N(P, L, z, `∖`, `\\smallsetminus`),
  N(P, L, z, `⋒`, `\\Cap`, !0),
  N(P, L, z, `⋓`, `\\Cup`, !0),
  N(P, L, z, `⩞`, `\\doublebarwedge`, !0),
  N(P, L, z, `⊟`, `\\boxminus`, !0),
  N(P, L, z, `⊞`, `\\boxplus`, !0),
  N(P, L, z, `⋇`, `\\divideontimes`, !0),
  N(P, L, z, `⋉`, `\\ltimes`, !0),
  N(P, L, z, `⋊`, `\\rtimes`, !0),
  N(P, L, z, `⋋`, `\\leftthreetimes`, !0),
  N(P, L, z, `⋌`, `\\rightthreetimes`, !0),
  N(P, L, z, `⋏`, `\\curlywedge`, !0),
  N(P, L, z, `⋎`, `\\curlyvee`, !0),
  N(P, L, z, `⊝`, `\\circleddash`, !0),
  N(P, L, z, `⊛`, `\\circledast`, !0),
  N(P, L, z, `⋅`, `\\centerdot`),
  N(P, L, z, `⊺`, `\\intercal`, !0),
  N(P, L, z, `⋒`, `\\doublecap`),
  N(P, L, z, `⋓`, `\\doublecup`),
  N(P, L, z, `⊠`, `\\boxtimes`, !0),
  N(P, L, V, `⇢`, `\\dashrightarrow`, !0),
  N(P, L, V, `⇠`, `\\dashleftarrow`, !0),
  N(P, L, V, `⇇`, `\\leftleftarrows`, !0),
  N(P, L, V, `⇆`, `\\leftrightarrows`, !0),
  N(P, L, V, `⇚`, `\\Lleftarrow`, !0),
  N(P, L, V, `↞`, `\\twoheadleftarrow`, !0),
  N(P, L, V, `↢`, `\\leftarrowtail`, !0),
  N(P, L, V, `↫`, `\\looparrowleft`, !0),
  N(P, L, V, `⇋`, `\\leftrightharpoons`, !0),
  N(P, L, V, `↶`, `\\curvearrowleft`, !0),
  N(P, L, V, `↺`, `\\circlearrowleft`, !0),
  N(P, L, V, `↰`, `\\Lsh`, !0),
  N(P, L, V, `⇈`, `\\upuparrows`, !0),
  N(P, L, V, `↿`, `\\upharpoonleft`, !0),
  N(P, L, V, `⇃`, `\\downharpoonleft`, !0),
  N(P, I, V, `⊶`, `\\origof`, !0),
  N(P, I, V, `⊷`, `\\imageof`, !0),
  N(P, L, V, `⊸`, `\\multimap`, !0),
  N(P, L, V, `↭`, `\\leftrightsquigarrow`, !0),
  N(P, L, V, `⇉`, `\\rightrightarrows`, !0),
  N(P, L, V, `⇄`, `\\rightleftarrows`, !0),
  N(P, L, V, `↠`, `\\twoheadrightarrow`, !0),
  N(P, L, V, `↣`, `\\rightarrowtail`, !0),
  N(P, L, V, `↬`, `\\looparrowright`, !0),
  N(P, L, V, `↷`, `\\curvearrowright`, !0),
  N(P, L, V, `↻`, `\\circlearrowright`, !0),
  N(P, L, V, `↱`, `\\Rsh`, !0),
  N(P, L, V, `⇊`, `\\downdownarrows`, !0),
  N(P, L, V, `↾`, `\\upharpoonright`, !0),
  N(P, L, V, `⇂`, `\\downharpoonright`, !0),
  N(P, L, V, `⇝`, `\\rightsquigarrow`, !0),
  N(P, L, V, `⇝`, `\\leadsto`),
  N(P, L, V, `⇛`, `\\Rrightarrow`, !0),
  N(P, L, V, `↾`, `\\restriction`),
  N(P, I, H, `‘`, "`"),
  N(P, I, H, `$`, `\\$`),
  N(F, I, H, `$`, `\\$`),
  N(F, I, H, `$`, `\\textdollar`),
  N(P, I, H, `%`, `\\%`),
  N(F, I, H, `%`, `\\%`),
  N(P, I, H, `_`, `\\_`),
  N(F, I, H, `_`, `\\_`),
  N(F, I, H, `_`, `\\textunderscore`),
  N(P, I, H, `∠`, `\\angle`, !0),
  N(P, I, H, `∞`, `\\infty`, !0),
  N(P, I, H, `′`, `\\prime`),
  N(P, I, H, `△`, `\\triangle`),
  N(P, I, H, `Γ`, `\\Gamma`, !0),
  N(P, I, H, `Δ`, `\\Delta`, !0),
  N(P, I, H, `Θ`, `\\Theta`, !0),
  N(P, I, H, `Λ`, `\\Lambda`, !0),
  N(P, I, H, `Ξ`, `\\Xi`, !0),
  N(P, I, H, `Π`, `\\Pi`, !0),
  N(P, I, H, `Σ`, `\\Sigma`, !0),
  N(P, I, H, `Υ`, `\\Upsilon`, !0),
  N(P, I, H, `Φ`, `\\Phi`, !0),
  N(P, I, H, `Ψ`, `\\Psi`, !0),
  N(P, I, H, `Ω`, `\\Omega`, !0),
  N(P, I, H, `A`, `Α`),
  N(P, I, H, `B`, `Β`),
  N(P, I, H, `E`, `Ε`),
  N(P, I, H, `Z`, `Ζ`),
  N(P, I, H, `H`, `Η`),
  N(P, I, H, `I`, `Ι`),
  N(P, I, H, `K`, `Κ`),
  N(P, I, H, `M`, `Μ`),
  N(P, I, H, `N`, `Ν`),
  N(P, I, H, `O`, `Ο`),
  N(P, I, H, `P`, `Ρ`),
  N(P, I, H, `T`, `Τ`),
  N(P, I, H, `X`, `Χ`),
  N(P, I, H, `¬`, `\\neg`, !0),
  N(P, I, H, `¬`, `\\lnot`),
  N(P, I, H, `⊤`, `\\top`),
  N(P, I, H, `⊥`, `\\bot`),
  N(P, I, H, `∅`, `\\emptyset`),
  N(P, L, H, `∅`, `\\varnothing`),
  N(P, I, B, `α`, `\\alpha`, !0),
  N(P, I, B, `β`, `\\beta`, !0),
  N(P, I, B, `γ`, `\\gamma`, !0),
  N(P, I, B, `δ`, `\\delta`, !0),
  N(P, I, B, `ϵ`, `\\epsilon`, !0),
  N(P, I, B, `ζ`, `\\zeta`, !0),
  N(P, I, B, `η`, `\\eta`, !0),
  N(P, I, B, `θ`, `\\theta`, !0),
  N(P, I, B, `ι`, `\\iota`, !0),
  N(P, I, B, `κ`, `\\kappa`, !0),
  N(P, I, B, `λ`, `\\lambda`, !0),
  N(P, I, B, `μ`, `\\mu`, !0),
  N(P, I, B, `ν`, `\\nu`, !0),
  N(P, I, B, `ξ`, `\\xi`, !0),
  N(P, I, B, `ο`, `\\omicron`, !0),
  N(P, I, B, `π`, `\\pi`, !0),
  N(P, I, B, `ρ`, `\\rho`, !0),
  N(P, I, B, `σ`, `\\sigma`, !0),
  N(P, I, B, `τ`, `\\tau`, !0),
  N(P, I, B, `υ`, `\\upsilon`, !0),
  N(P, I, B, `ϕ`, `\\phi`, !0),
  N(P, I, B, `χ`, `\\chi`, !0),
  N(P, I, B, `ψ`, `\\psi`, !0),
  N(P, I, B, `ω`, `\\omega`, !0),
  N(P, I, B, `ε`, `\\varepsilon`, !0),
  N(P, I, B, `ϑ`, `\\vartheta`, !0),
  N(P, I, B, `ϖ`, `\\varpi`, !0),
  N(P, I, B, `ϱ`, `\\varrho`, !0),
  N(P, I, B, `ς`, `\\varsigma`, !0),
  N(P, I, B, `φ`, `\\varphi`, !0),
  N(P, I, z, `∗`, `*`, !0),
  N(P, I, z, `+`, `+`),
  N(P, I, z, `−`, `-`, !0),
  N(P, I, z, `⋅`, `\\cdot`, !0),
  N(P, I, z, `∘`, `\\circ`, !0),
  N(P, I, z, `÷`, `\\div`, !0),
  N(P, I, z, `±`, `\\pm`, !0),
  N(P, I, z, `×`, `\\times`, !0),
  N(P, I, z, `∩`, `\\cap`, !0),
  N(P, I, z, `∪`, `\\cup`, !0),
  N(P, I, z, `∖`, `\\setminus`, !0),
  N(P, I, z, `∧`, `\\land`),
  N(P, I, z, `∨`, `\\lor`),
  N(P, I, z, `∧`, `\\wedge`, !0),
  N(P, I, z, `∨`, `\\vee`, !0),
  N(P, I, H, `√`, `\\surd`),
  N(P, I, Ze, `⟨`, `\\langle`, !0),
  N(P, I, Ze, `∣`, `\\lvert`),
  N(P, I, Ze, `∥`, `\\lVert`),
  N(P, I, Je, `?`, `?`),
  N(P, I, Je, `!`, `!`),
  N(P, I, Je, `⟩`, `\\rangle`, !0),
  N(P, I, Je, `∣`, `\\rvert`),
  N(P, I, Je, `∥`, `\\rVert`),
  N(P, I, V, `=`, `=`),
  N(P, I, V, `:`, `:`),
  N(P, I, V, `≈`, `\\approx`, !0),
  N(P, I, V, `≅`, `\\cong`, !0),
  N(P, I, V, `≥`, `\\ge`),
  N(P, I, V, `≥`, `\\geq`, !0),
  N(P, I, V, `←`, `\\gets`),
  N(P, I, V, `>`, `\\gt`, !0),
  N(P, I, V, `∈`, `\\in`, !0),
  N(P, I, V, ``, `\\@not`),
  N(P, I, V, `⊂`, `\\subset`, !0),
  N(P, I, V, `⊃`, `\\supset`, !0),
  N(P, I, V, `⊆`, `\\subseteq`, !0),
  N(P, I, V, `⊇`, `\\supseteq`, !0),
  N(P, L, V, `⊈`, `\\nsubseteq`, !0),
  N(P, L, V, `⊉`, `\\nsupseteq`, !0),
  N(P, I, V, `⊨`, `\\models`),
  N(P, I, V, `←`, `\\leftarrow`, !0),
  N(P, I, V, `≤`, `\\le`),
  N(P, I, V, `≤`, `\\leq`, !0),
  N(P, I, V, `<`, `\\lt`, !0),
  N(P, I, V, `→`, `\\rightarrow`, !0),
  N(P, I, V, `→`, `\\to`),
  N(P, L, V, `≱`, `\\ngeq`, !0),
  N(P, L, V, `≰`, `\\nleq`, !0),
  N(P, I, $e, `\xA0`, `\\ `),
  N(P, I, $e, `\xA0`, `\\space`),
  N(P, I, $e, `\xA0`, `\\nobreakspace`),
  N(F, I, $e, `\xA0`, `\\ `),
  N(F, I, $e, `\xA0`, ` `),
  N(F, I, $e, `\xA0`, `\\space`),
  N(F, I, $e, `\xA0`, `\\nobreakspace`),
  N(P, I, $e, ``, `\\nobreak`),
  N(P, I, $e, ``, `\\allowbreak`),
  N(P, I, Qe, `,`, `,`),
  N(P, I, Qe, `;`, `;`),
  N(P, L, z, `⊼`, `\\barwedge`, !0),
  N(P, L, z, `⊻`, `\\veebar`, !0),
  N(P, I, z, `⊙`, `\\odot`, !0),
  N(P, I, z, `⊕`, `\\oplus`, !0),
  N(P, I, z, `⊗`, `\\otimes`, !0),
  N(P, I, H, `∂`, `\\partial`, !0),
  N(P, I, z, `⊘`, `\\oslash`, !0),
  N(P, L, z, `⊚`, `\\circledcirc`, !0),
  N(P, L, z, `⊡`, `\\boxdot`, !0),
  N(P, I, z, `△`, `\\bigtriangleup`),
  N(P, I, z, `▽`, `\\bigtriangledown`),
  N(P, I, z, `†`, `\\dagger`),
  N(P, I, z, `⋄`, `\\diamond`),
  N(P, I, z, `⋆`, `\\star`),
  N(P, I, z, `◃`, `\\triangleleft`),
  N(P, I, z, `▹`, `\\triangleright`),
  N(P, I, Ze, `{`, `\\{`),
  N(F, I, H, `{`, `\\{`),
  N(F, I, H, `{`, `\\textbraceleft`),
  N(P, I, Je, `}`, `\\}`),
  N(F, I, H, `}`, `\\}`),
  N(F, I, H, `}`, `\\textbraceright`),
  N(P, I, Ze, `{`, `\\lbrace`),
  N(P, I, Je, `}`, `\\rbrace`),
  N(P, I, Ze, `[`, `\\lbrack`, !0),
  N(F, I, H, `[`, `\\lbrack`, !0),
  N(P, I, Je, `]`, `\\rbrack`, !0),
  N(F, I, H, `]`, `\\rbrack`, !0),
  N(P, I, Ze, `(`, `\\lparen`, !0),
  N(P, I, Je, `)`, `\\rparen`, !0),
  N(F, I, H, `<`, `\\textless`, !0),
  N(F, I, H, `>`, `\\textgreater`, !0),
  N(P, I, Ze, `⌊`, `\\lfloor`, !0),
  N(P, I, Je, `⌋`, `\\rfloor`, !0),
  N(P, I, Ze, `⌈`, `\\lceil`, !0),
  N(P, I, Je, `⌉`, `\\rceil`, !0),
  N(P, I, H, `\\`, `\\backslash`),
  N(P, I, H, `∣`, `|`),
  N(P, I, H, `∣`, `\\vert`),
  N(F, I, H, `|`, `\\textbar`, !0),
  N(P, I, H, `∥`, `\\|`),
  N(P, I, H, `∥`, `\\Vert`),
  N(F, I, H, `∥`, `\\textbardbl`),
  N(F, I, H, `~`, `\\textasciitilde`),
  N(F, I, H, `\\`, `\\textbackslash`),
  N(F, I, H, `^`, `\\textasciicircum`),
  N(P, I, V, `↑`, `\\uparrow`, !0),
  N(P, I, V, `⇑`, `\\Uparrow`, !0),
  N(P, I, V, `↓`, `\\downarrow`, !0),
  N(P, I, V, `⇓`, `\\Downarrow`, !0),
  N(P, I, V, `↕`, `\\updownarrow`, !0),
  N(P, I, V, `⇕`, `\\Updownarrow`, !0),
  N(P, I, Xe, `∐`, `\\coprod`),
  N(P, I, Xe, `⋁`, `\\bigvee`),
  N(P, I, Xe, `⋀`, `\\bigwedge`),
  N(P, I, Xe, `⨄`, `\\biguplus`),
  N(P, I, Xe, `⋂`, `\\bigcap`),
  N(P, I, Xe, `⋃`, `\\bigcup`),
  N(P, I, Xe, `∫`, `\\int`),
  N(P, I, Xe, `∫`, `\\intop`),
  N(P, I, Xe, `∬`, `\\iint`),
  N(P, I, Xe, `∭`, `\\iiint`),
  N(P, I, Xe, `∏`, `\\prod`),
  N(P, I, Xe, `∑`, `\\sum`),
  N(P, I, Xe, `⨂`, `\\bigotimes`),
  N(P, I, Xe, `⨁`, `\\bigoplus`),
  N(P, I, Xe, `⨀`, `\\bigodot`),
  N(P, I, Xe, `∮`, `\\oint`),
  N(P, I, Xe, `∯`, `\\oiint`),
  N(P, I, Xe, `∰`, `\\oiiint`),
  N(P, I, Xe, `⨆`, `\\bigsqcup`),
  N(P, I, Xe, `∫`, `\\smallint`),
  N(F, I, Ye, `…`, `\\textellipsis`),
  N(P, I, Ye, `…`, `\\mathellipsis`),
  N(F, I, Ye, `…`, `\\ldots`, !0),
  N(P, I, Ye, `…`, `\\ldots`, !0),
  N(P, I, Ye, `⋯`, `\\@cdots`, !0),
  N(P, I, Ye, `⋱`, `\\ddots`, !0),
  N(P, I, H, `⋮`, `\\varvdots`),
  N(F, I, H, `⋮`, `\\varvdots`),
  N(P, I, R, `ˊ`, `\\acute`),
  N(P, I, R, `ˋ`, `\\grave`),
  N(P, I, R, `¨`, `\\ddot`),
  N(P, I, R, `~`, `\\tilde`),
  N(P, I, R, `ˉ`, `\\bar`),
  N(P, I, R, `˘`, `\\breve`),
  N(P, I, R, `ˇ`, `\\check`),
  N(P, I, R, `^`, `\\hat`),
  N(P, I, R, `⃗`, `\\vec`),
  N(P, I, R, `˙`, `\\dot`),
  N(P, I, R, `˚`, `\\mathring`),
  N(P, I, B, ``, `\\@imath`),
  N(P, I, B, ``, `\\@jmath`),
  N(P, I, H, `ı`, `ı`),
  N(P, I, H, `ȷ`, `ȷ`),
  N(F, I, H, `ı`, `\\i`, !0),
  N(F, I, H, `ȷ`, `\\j`, !0),
  N(F, I, H, `ß`, `\\ss`, !0),
  N(F, I, H, `æ`, `\\ae`, !0),
  N(F, I, H, `œ`, `\\oe`, !0),
  N(F, I, H, `ø`, `\\o`, !0),
  N(F, I, H, `Æ`, `\\AE`, !0),
  N(F, I, H, `Œ`, `\\OE`, !0),
  N(F, I, H, `Ø`, `\\O`, !0),
  N(F, I, R, `ˊ`, `\\'`),
  N(F, I, R, `ˋ`, "\\`"),
  N(F, I, R, `ˆ`, `\\^`),
  N(F, I, R, `˜`, `\\~`),
  N(F, I, R, `ˉ`, `\\=`),
  N(F, I, R, `˘`, `\\u`),
  N(F, I, R, `˙`, `\\.`),
  N(F, I, R, `¸`, `\\c`),
  N(F, I, R, `˚`, `\\r`),
  N(F, I, R, `ˇ`, `\\v`),
  N(F, I, R, `¨`, `\\"`),
  N(F, I, R, `˝`, `\\H`),
  N(F, I, R, `◯`, `\\textcircled`));
var et = {
  "--": !0,
  "---": !0,
  "``": !0,
  "''": !0,
};
(N(F, I, H, `–`, `--`, !0),
  N(F, I, H, `–`, `\\textendash`),
  N(F, I, H, `—`, `---`, !0),
  N(F, I, H, `—`, `\\textemdash`),
  N(F, I, H, `‘`, "`", !0),
  N(F, I, H, `‘`, `\\textquoteleft`),
  N(F, I, H, `’`, `'`, !0),
  N(F, I, H, `’`, `\\textquoteright`),
  N(F, I, H, `“`, "``", !0),
  N(F, I, H, `“`, `\\textquotedblleft`),
  N(F, I, H, `”`, `''`, !0),
  N(F, I, H, `”`, `\\textquotedblright`),
  N(P, I, H, `°`, `\\degree`, !0),
  N(F, I, H, `°`, `\\degree`),
  N(F, I, H, `°`, `\\textdegree`, !0),
  N(P, I, H, `£`, `\\pounds`),
  N(P, I, H, `£`, `\\mathsterling`, !0),
  N(F, I, H, `£`, `\\pounds`),
  N(F, I, H, `£`, `\\textsterling`, !0),
  N(P, L, H, `✠`, `\\maltese`),
  N(F, L, H, `✠`, `\\maltese`));
for (var tt = `0123456789/@."`, nt = 0; nt < tt.length; nt++) {
  var rt = tt.charAt(nt);
  N(P, I, H, rt, rt);
}
for (var it = `0123456789!@*()-=+";:?/.,`, at = 0; at < it.length; at++) {
  var ot = it.charAt(at);
  N(F, I, H, ot, ot);
}
for (
  var st = `ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz`, ct = 0;
  ct < st.length;
  ct++
) {
  var lt = st.charAt(ct);
  (N(P, I, B, lt, lt), N(F, I, H, lt, lt));
}
(N(P, L, H, `C`, `ℂ`),
  N(F, L, H, `C`, `ℂ`),
  N(P, L, H, `H`, `ℍ`),
  N(F, L, H, `H`, `ℍ`),
  N(P, L, H, `N`, `ℕ`),
  N(F, L, H, `N`, `ℕ`),
  N(P, L, H, `P`, `ℙ`),
  N(F, L, H, `P`, `ℙ`),
  N(P, L, H, `Q`, `ℚ`),
  N(F, L, H, `Q`, `ℚ`),
  N(P, L, H, `R`, `ℝ`),
  N(F, L, H, `R`, `ℝ`),
  N(P, L, H, `Z`, `ℤ`),
  N(F, L, H, `Z`, `ℤ`),
  N(P, I, B, `h`, `ℎ`),
  N(F, I, B, `h`, `ℎ`));
for (var U, ut = 0; ut < st.length; ut++) {
  var dt = st.charAt(ut);
  ((U = String.fromCharCode(55349, 56320 + ut)),
    N(P, I, B, dt, U),
    N(F, I, H, dt, U),
    (U = String.fromCharCode(55349, 56372 + ut)),
    N(P, I, B, dt, U),
    N(F, I, H, dt, U),
    (U = String.fromCharCode(55349, 56424 + ut)),
    N(P, I, B, dt, U),
    N(F, I, H, dt, U),
    (U = String.fromCharCode(55349, 56580 + ut)),
    N(P, I, B, dt, U),
    N(F, I, H, dt, U),
    (U = String.fromCharCode(55349, 56684 + ut)),
    N(P, I, B, dt, U),
    N(F, I, H, dt, U),
    (U = String.fromCharCode(55349, 56736 + ut)),
    N(P, I, B, dt, U),
    N(F, I, H, dt, U),
    (U = String.fromCharCode(55349, 56788 + ut)),
    N(P, I, B, dt, U),
    N(F, I, H, dt, U),
    (U = String.fromCharCode(55349, 56840 + ut)),
    N(P, I, B, dt, U),
    N(F, I, H, dt, U),
    (U = String.fromCharCode(55349, 56944 + ut)),
    N(P, I, B, dt, U),
    N(F, I, H, dt, U),
    ut < 26 &&
      ((U = String.fromCharCode(55349, 56632 + ut)),
      N(P, I, B, dt, U),
      N(F, I, H, dt, U),
      (U = String.fromCharCode(55349, 56476 + ut)),
      N(P, I, B, dt, U),
      N(F, I, H, dt, U)));
}
((U = String.fromCharCode(55349, 56668)), N(P, I, B, `k`, U), N(F, I, H, `k`, U));
for (var ft = 0; ft < 10; ft++) {
  var pt = ft.toString();
  ((U = String.fromCharCode(55349, 57294 + ft)),
    N(P, I, B, pt, U),
    N(F, I, H, pt, U),
    (U = String.fromCharCode(55349, 57314 + ft)),
    N(P, I, B, pt, U),
    N(F, I, H, pt, U),
    (U = String.fromCharCode(55349, 57324 + ft)),
    N(P, I, B, pt, U),
    N(F, I, H, pt, U),
    (U = String.fromCharCode(55349, 57334 + ft)),
    N(P, I, B, pt, U),
    N(F, I, H, pt, U));
}
for (var mt = `ÐÞþ`, ht = 0; ht < mt.length; ht++) {
  var gt = mt.charAt(ht);
  (N(P, I, B, gt, gt), N(F, I, H, gt, gt));
}
var _t = {
    mathClass: `mathbf`,
    textClass: `textbf`,
    font: `Main-Bold`,
  },
  vt = {
    mathClass: `mathnormal`,
    textClass: `textit`,
    font: `Math-Italic`,
  },
  yt = {
    mathClass: `boldsymbol`,
    textClass: `boldsymbol`,
    font: `Main-BoldItalic`,
  },
  bt = {
    mathClass: `mathscr`,
    textClass: `textscr`,
    font: `Script-Regular`,
  },
  xt = {
    mathClass: ``,
    textClass: ``,
    font: ``,
  },
  St = {
    mathClass: `mathfrak`,
    textClass: `textfrak`,
    font: `Fraktur-Regular`,
  },
  Ct = {
    mathClass: `mathbb`,
    textClass: `textbb`,
    font: `AMS-Regular`,
  },
  wt = {
    mathClass: `mathboldfrak`,
    textClass: `textboldfrak`,
    font: `Fraktur-Regular`,
  },
  Tt = {
    mathClass: `mathsf`,
    textClass: `textsf`,
    font: `SansSerif-Regular`,
  },
  Et = {
    mathClass: `mathboldsf`,
    textClass: `textboldsf`,
    font: `SansSerif-Bold`,
  },
  Dt = {
    mathClass: `mathitsf`,
    textClass: `textitsf`,
    font: `SansSerif-Italic`,
  },
  Ot = {
    mathClass: `mathtt`,
    textClass: `texttt`,
    font: `Typewriter-Regular`,
  },
  kt = [
    _t,
    _t,
    vt,
    vt,
    yt,
    yt,
    bt,
    xt,
    xt,
    xt,
    St,
    St,
    Ct,
    Ct,
    wt,
    wt,
    Tt,
    Tt,
    Et,
    Et,
    Dt,
    Dt,
    xt,
    xt,
    Ot,
    Ot,
  ],
  At = [_t, xt, Tt, Et, Ot],
  jt = (t) => {
    var n = t.charCodeAt(0),
      r = t.charCodeAt(1),
      i = (n - 55296) * 1024 + (r - 56320) + 65536;
    if (119808 <= i && i < 120484) return kt[Math.floor((i - 119808) / 26)];
    if (120782 <= i && i <= 120831) return At[Math.floor((i - 120782) / 10)];
    if (i === 120485 || i === 120486) return kt[0];
    if (120486 < i && i < 120782) return xt;
    throw new e(`Unsupported character: ` + t);
  },
  Mt = function (e, t, n) {
    if (qe[n][e]) {
      var r = qe[n][e].replace;
      r && (e = r);
    }
    return {
      value: e,
      metrics: Ge(e, t, n),
    };
  },
  Nt = function (e, t, n, r, i) {
    var a = Mt(e, t, n),
      o = a.metrics;
    e = a.value;
    var s;
    if (o) {
      var c = o.italic;
      ((n === `text` || (r && r.font === `mathit`)) && (c = 0),
        (s = new Pe(e, o.height, o.depth, c, o.skew, o.width, i)));
    } else
      (typeof console < `u` &&
        console.warn(
          `No character metrics ` + (`for '` + e + `' in style '` + t + `' and mode '` + n + `'`),
        ),
        (s = new Pe(e, 0, 0, 0, 0, 0, i)));
    if (r) {
      ((s.maxFontSize = r.sizeMultiplier), r.style.isTight() && s.classes.push(`mtight`));
      var l = r.getColor();
      l && (s.style.color = l);
    }
    return s;
  },
  Pt = function (e, t, n, r) {
    return (
      r === void 0 && (r = []),
      n.font === `boldsymbol` && Mt(e, `Main-Bold`, t).metrics
        ? Nt(e, `Main-Bold`, t, n, r.concat([`mathbf`]))
        : e === `\\` || qe[t][e].font === `main`
          ? Nt(e, `Main-Regular`, t, n, r)
          : Nt(e, `AMS-Regular`, t, n, r.concat([`amsrm`]))
    );
  },
  Ft = function (e, t, n) {
    return n !== `textord` && Mt(e, `Math-BoldItalic`, t).metrics
      ? {
          fontName: `Math-BoldItalic`,
          fontClass: `boldsymbol`,
        }
      : {
          fontName: `Main-Bold`,
          fontClass: `mathbf`,
        };
  },
  It = function (e, t) {
    var n = e.type === `mathord` ? `mathord` : `textord`,
      r = e.mode,
      i = e.text,
      a = [`mord`],
      { font: o, fontFamily: s, fontWeight: c, fontShape: l } = t,
      u = r === `math` || (r === `text` && !!o),
      d = u ? o : s,
      f = ``,
      p = ``;
    if (i.charCodeAt(0) === 55349) {
      var m = jt(i);
      ((f = m.font), (p = m[r + `Class`]));
    }
    if (f) return Nt(i, f, r, t, a.concat(p));
    if (d) {
      var h, g;
      if (d === `boldsymbol`) {
        var _ = Ft(i, r, n);
        ((h = _.fontName), (g = [_.fontClass]));
      } else u ? ((h = Jt[o].fontName), (g = [o])) : ((h = qt(s, c, l)), (g = [s, c, l]));
      if (Mt(i, h, r).metrics) return Nt(i, h, r, t, a.concat(g));
      if (et.hasOwnProperty(i) && h.slice(0, 10) === `Typewriter`) {
        for (var v = [], y = 0; y < i.length; y++) v.push(Nt(i[y], h, r, t, a.concat(g)));
        return Ut(v);
      }
    }
    if (n === `mathord`) return Nt(i, `Math-Italic`, r, t, a.concat([`mathnormal`]));
    if (n === `textord`) {
      var b = qe[r][i] && qe[r][i].font;
      if (b === `ams`) return Nt(i, qt(`amsrm`, c, l), r, t, a.concat(`amsrm`, c, l));
      if (b === `main` || !b) return Nt(i, qt(`textrm`, c, l), r, t, a.concat(c, l));
      var x = qt(b, c, l);
      return Nt(i, x, r, t, a.concat(x, c, l));
    } else throw Error(`unexpected type: ` + n + ` in makeOrd`);
  },
  Lt = (e, t) => {
    if (
      j(e.classes) !== j(t.classes) ||
      e.skew !== t.skew ||
      e.maxFontSize !== t.maxFontSize ||
      (e.italic !== 0 && e.hasClass(`mathnormal`))
    )
      return !1;
    if (e.classes.length === 1) {
      var n = e.classes[0];
      if (n === `mbin` || n === `mord`) return !1;
    }
    for (var r of Object.keys(e.style)) if (e.style[r] !== t.style[r]) return !1;
    for (var i of Object.keys(t.style)) if (e.style[i] !== t.style[i]) return !1;
    return !0;
  },
  Rt = (e) => {
    for (var t = 0; t < e.length - 1; t++) {
      var n = e[t],
        r = e[t + 1];
      n instanceof Pe &&
        r instanceof Pe &&
        Lt(n, r) &&
        ((n.text += r.text),
        (n.height = Math.max(n.height, r.height)),
        (n.depth = Math.max(n.depth, r.depth)),
        (n.italic = r.italic),
        e.splice(t + 1, 1),
        t--);
    }
    return e;
  },
  zt = function (e) {
    for (var t = 0, n = 0, r = 0, i = 0; i < e.children.length; i++) {
      var a = e.children[i];
      (a.height > t && (t = a.height),
        a.depth > n && (n = a.depth),
        a.maxFontSize > r && (r = a.maxFontSize));
    }
    ((e.height = t), (e.depth = n), (e.maxFontSize = r));
  },
  W = function (e, t, n, r) {
    var i = new Ae(e, t, n, r);
    return (zt(i), i);
  },
  Bt = (e, t, n, r) => new Ae(e, t, n, r),
  Vt = function (e, t, n) {
    var r = W([e], [], t);
    return (
      (r.height = Math.max(n || t.fontMetrics().defaultRuleThickness, t.minRuleThickness)),
      (r.style.borderBottomWidth = A(r.height)),
      (r.maxFontSize = 1),
      r
    );
  },
  Ht = function (e, t, n, r) {
    var i = new je(e, t, n, r);
    return (zt(i), i);
  },
  Ut = function (e) {
    var t = new xe(e);
    return (zt(t), t);
  },
  Wt = function (e, t) {
    return e instanceof xe ? W([], [e], t) : e;
  },
  Gt = function (e) {
    if (e.positionType === `individualShift`) {
      for (
        var t = e.children, n = [t[0]], r = -t[0].shift - t[0].elem.depth, i = r, a = 1;
        a < t.length;
        a++
      ) {
        var o = -t[a].shift - i - t[a].elem.depth,
          s = o - (t[a - 1].elem.height + t[a - 1].elem.depth);
        ((i += o),
          n.push({
            type: `kern`,
            size: s,
          }),
          n.push(t[a]));
      }
      return {
        children: n,
        depth: r,
      };
    }
    var c;
    if (e.positionType === `top`) {
      for (var l = e.positionData, u = 0; u < e.children.length; u++) {
        var d = e.children[u];
        l -= d.type === `kern` ? d.size : d.elem.height + d.elem.depth;
      }
      c = l;
    } else if (e.positionType === `bottom`) c = -e.positionData;
    else {
      var f = e.children[0];
      if (f.type !== `elem`) throw Error(`First child must have type "elem".`);
      if (e.positionType === `shift`) c = -f.elem.depth - e.positionData;
      else if (e.positionType === `firstBaseline`) c = -f.elem.depth;
      else throw Error(`Invalid positionType ` + e.positionType + `.`);
    }
    return {
      children: e.children,
      depth: c,
    };
  },
  G = function (e, t) {
    for (var { children: n, depth: r } = Gt(e), i = 0, a = 0; a < n.length; a++) {
      var o = n[a];
      if (o.type === `elem`) {
        var s = o.elem;
        i = Math.max(i, s.maxFontSize, s.height);
      }
    }
    i += 2;
    var c = W([`pstrut`], []);
    c.style.height = A(i);
    for (var l = [], u = r, d = r, f = r, p = 0; p < n.length; p++) {
      var m = n[p];
      if (m.type === `kern`) f += m.size;
      else {
        var h = m.elem,
          g = m.wrapperClasses || [],
          _ = m.wrapperStyle || {},
          v = W(g, [c, h], void 0, _);
        ((v.style.top = A(-i - f - h.depth)),
          m.marginLeft && (v.style.marginLeft = m.marginLeft),
          m.marginRight && (v.style.marginRight = m.marginRight),
          l.push(v),
          (f += h.height + h.depth));
      }
      ((u = Math.min(u, f)), (d = Math.max(d, f)));
    }
    var y = W([`vlist`], l);
    y.style.height = A(d);
    var b;
    if (u < 0) {
      var x = W([`vlist`], [W([], [])]);
      ((x.style.height = A(-u)),
        (b = [W([`vlist-r`], [y, W([`vlist-s`], [new Pe(`​`)])]), W([`vlist-r`], [x])]));
    } else b = [W([`vlist-r`], [y])];
    var S = W([`vlist-t`], b);
    return (b.length === 2 && S.classes.push(`vlist-t2`), (S.height = d), (S.depth = -u), S);
  },
  Kt = (e, t) => {
    var n = W([`mspace`], [], t),
      r = k(e, t);
    return ((n.style.marginRight = A(r)), n);
  },
  qt = (e, t, n) => {
    var r, i;
    switch (e) {
      case `amsrm`:
        r = `AMS`;
        break;
      case `textrm`:
        r = `Main`;
        break;
      case `textsf`:
        r = `SansSerif`;
        break;
      case `texttt`:
        r = `Typewriter`;
        break;
      default:
        r = e;
    }
    return (
      (i =
        t === `textbf` && n === `textit`
          ? `BoldItalic`
          : t === `textbf`
            ? `Bold`
            : n === `textit`
              ? `Italic`
              : `Regular`),
      r + `-` + i
    );
  },
  Jt = {
    mathbf: {
      variant: `bold`,
      fontName: `Main-Bold`,
    },
    mathrm: {
      variant: `normal`,
      fontName: `Main-Regular`,
    },
    textit: {
      variant: `italic`,
      fontName: `Main-Italic`,
    },
    mathit: {
      variant: `italic`,
      fontName: `Main-Italic`,
    },
    mathnormal: {
      variant: `italic`,
      fontName: `Math-Italic`,
    },
    mathsfit: {
      variant: `sans-serif-italic`,
      fontName: `SansSerif-Italic`,
    },
    mathbb: {
      variant: `double-struck`,
      fontName: `AMS-Regular`,
    },
    mathcal: {
      variant: `script`,
      fontName: `Caligraphic-Regular`,
    },
    mathfrak: {
      variant: `fraktur`,
      fontName: `Fraktur-Regular`,
    },
    mathscr: {
      variant: `script`,
      fontName: `Script-Regular`,
    },
    mathsf: {
      variant: `sans-serif`,
      fontName: `SansSerif-Regular`,
    },
    mathtt: {
      variant: `monospace`,
      fontName: `Typewriter-Regular`,
    },
  },
  Yt = {
    vec: [`vec`, 0.471, 0.714],
    oiintSize1: [`oiintSize1`, 0.957, 0.499],
    oiintSize2: [`oiintSize2`, 1.472, 0.659],
    oiiintSize1: [`oiiintSize1`, 1.304, 0.499],
    oiiintSize2: [`oiiintSize2`, 1.98, 0.659],
  },
  Xt = function (e, t) {
    var [n, r, i] = Yt[e],
      a = Bt(
        [`overlay`],
        [
          new Fe([new Ie(n)], {
            width: A(r),
            height: A(i),
            style: `width:` + A(r),
            viewBox: `0 0 ` + 1e3 * r + ` ` + 1e3 * i,
            preserveAspectRatio: `xMinYMin`,
          }),
        ],
        t,
      );
    return ((a.height = i), (a.style.height = A(i)), (a.style.width = A(r)), a);
  },
  Zt = {
    number: 3,
    unit: `mu`,
  },
  Qt = {
    number: 4,
    unit: `mu`,
  },
  $t = {
    number: 5,
    unit: `mu`,
  },
  en = {
    mord: {
      mop: Zt,
      mbin: Qt,
      mrel: $t,
      minner: Zt,
    },
    mop: {
      mord: Zt,
      mop: Zt,
      mrel: $t,
      minner: Zt,
    },
    mbin: {
      mord: Qt,
      mop: Qt,
      mopen: Qt,
      minner: Qt,
    },
    mrel: {
      mord: $t,
      mop: $t,
      mopen: $t,
      minner: $t,
    },
    mopen: {},
    mclose: {
      mop: Zt,
      mbin: Qt,
      mrel: $t,
      minner: Zt,
    },
    mpunct: {
      mord: Zt,
      mop: Zt,
      mrel: $t,
      mopen: Zt,
      mclose: Zt,
      mpunct: Zt,
      minner: Zt,
    },
    minner: {
      mord: Zt,
      mop: Zt,
      mbin: Qt,
      mrel: $t,
      mopen: Zt,
      mpunct: Zt,
      minner: Zt,
    },
  },
  tn = {
    mord: {
      mop: Zt,
    },
    mop: {
      mord: Zt,
      mop: Zt,
    },
    mbin: {},
    mrel: {},
    mopen: {},
    mclose: {
      mop: Zt,
    },
    mpunct: {},
    minner: {
      mop: Zt,
    },
  },
  nn = {},
  rn = {},
  an = {};
function K(e) {
  for (var { type: t, names: n, htmlBuilder: r, mathmlBuilder: i } = e, a = 0; a < n.length; ++a)
    nn[n[a]] = e;
  t && (r && (rn[t] = r), i && (an[t] = i));
}
function on(e) {
  var { type: t, htmlBuilder: n, mathmlBuilder: r } = e;
  (n && (rn[t] = n), r && (an[t] = r));
}
var sn = function (e) {
    return e.type === `ordgroup` && e.body.length === 1 ? e.body[0] : e;
  },
  cn = function (e) {
    return e.type === `ordgroup` ? e.body : [e];
  },
  ln = new Set([`leftmost`, `mbin`, `mopen`, `mrel`, `mop`, `mpunct`]),
  un = new Set([`rightmost`, `mrel`, `mclose`, `mpunct`]),
  dn = {
    display: E.DISPLAY,
    text: E.TEXT,
    script: E.SCRIPT,
    scriptscript: E.SCRIPTSCRIPT,
  },
  fn = {
    mord: `mord`,
    mop: `mop`,
    mbin: `mbin`,
    mrel: `mrel`,
    mopen: `mopen`,
    mclose: `mclose`,
    mpunct: `mpunct`,
    minner: `minner`,
  },
  pn = function (e, t, n, r) {
    r === void 0 && (r = [null, null]);
    for (var i = [], a = 0; a < e.length; a++) {
      var o = q(e[a], t);
      if (o instanceof xe) {
        var s = o.children;
        i.push(...s);
      } else i.push(o);
    }
    if ((Rt(i), !n)) return i;
    var c = t;
    if (e.length === 1) {
      var l = e[0];
      l.type === `sizing`
        ? (c = t.havingSize(l.size))
        : l.type === `styling` && (c = t.havingStyle(dn[l.style]));
    }
    var u = W([r[0] || `leftmost`], [], t),
      d = W([r[1] || `rightmost`], [], t),
      f = n === `root`;
    return (
      mn(
        i,
        (e, t) => {
          var n = t.classes[0],
            r = e.classes[0];
          n === `mbin` && un.has(r)
            ? (t.classes[0] = `mord`)
            : r === `mbin` && ln.has(n) && (e.classes[0] = `mord`);
        },
        {
          node: u,
        },
        d,
        f,
      ),
      mn(
        i,
        (e, t) => {
          var n = _n(t),
            r = _n(e),
            i = n && r ? (e.hasClass(`mtight`) ? tn[n]?.[r] : en[n]?.[r]) : null;
          if (i) return Kt(i, c);
        },
        {
          node: u,
        },
        d,
        f,
      ),
      i
    );
  },
  mn = function (e, t, n, r, i) {
    r && e.push(r);
    for (var a = 0; a < e.length; a++) {
      var o = e[a],
        s = hn(o);
      if (s) {
        mn(s.children, t, n, null, i);
        continue;
      }
      var c = !o.hasClass(`mspace`);
      if (c) {
        var l = t(o, n.node);
        l && (n.insertAfter ? n.insertAfter(l) : (e.unshift(l), a++));
      }
      (c ? (n.node = o) : i && o.hasClass(`newline`) && (n.node = W([`leftmost`])),
        (n.insertAfter = ((t) => (n) => {
          (e.splice(t + 1, 0, n), a++);
        })(a)));
    }
    r && e.pop();
  },
  hn = function (e) {
    return e instanceof xe || e instanceof je || (e instanceof Ae && e.hasClass(`enclosing`))
      ? e
      : null;
  },
  gn = function (e, t) {
    var n = hn(e);
    if (n) {
      var r = n.children;
      if (r.length) {
        if (t === `right`) return gn(r[r.length - 1], `right`);
        if (t === `left`) return gn(r[0], `left`);
      }
    }
    return e;
  },
  _n = function (e, t) {
    return e ? (t && (e = gn(e, t)), fn[e.classes[0]] || null) : null;
  },
  vn = function (e, t) {
    var n = [`nulldelimiter`].concat(e.baseSizingClasses());
    return W(t.concat(n));
  },
  q = function (t, n, r) {
    if (!t) return W();
    if (rn[t.type]) {
      var i = rn[t.type](t, n);
      if (r && n.size !== r.size) {
        i = W(n.sizingClasses(r), [i], n);
        var a = n.sizeMultiplier / r.sizeMultiplier;
        ((i.height *= a), (i.depth *= a));
      }
      return i;
    } else throw new e(`Got group of unknown type: '` + t.type + `'`);
  };
function yn(e, t) {
  var n = W([`base`], e, t),
    r = W([`strut`]);
  return (
    (r.style.height = A(n.height + n.depth)),
    n.depth && (r.style.verticalAlign = A(-n.depth)),
    n.children.unshift(r),
    n
  );
}
function bn(e, t) {
  var n = null;
  e.length === 1 && e[0].type === `tag` && ((n = e[0].tag), (e = e[0].body));
  var r = pn(e, t, `root`),
    i;
  r.length === 2 && r[1].hasClass(`tag`) && (i = r.pop());
  for (var a = [], o = [], s = 0; s < r.length; s++)
    if (
      (o.push(r[s]), r[s].hasClass(`mbin`) || r[s].hasClass(`mrel`) || r[s].hasClass(`allowbreak`))
    ) {
      for (
        var c = !1;
        s < r.length - 1 && r[s + 1].hasClass(`mspace`) && !r[s + 1].hasClass(`newline`);
      )
        (s++, o.push(r[s]), r[s].hasClass(`nobreak`) && (c = !0));
      c || (a.push(yn(o, t)), (o = []));
    } else
      r[s].hasClass(`newline`) &&
        (o.pop(), o.length > 0 && (a.push(yn(o, t)), (o = [])), a.push(r[s]));
  o.length > 0 && a.push(yn(o, t));
  var l;
  n ? ((l = yn(pn(n, t, !0), t)), (l.classes = [`tag`]), a.push(l)) : i && a.push(i);
  var u = W([`katex-html`], a);
  if ((u.setAttribute(`aria-hidden`, `true`), l)) {
    var d = l.children[0];
    ((d.style.height = A(u.height + u.depth)), u.depth && (d.style.verticalAlign = A(-u.depth)));
  }
  return u;
}
function xn(e) {
  return new xe(e);
}
var J = class {
    constructor(e, t, n) {
      ((this.type = void 0),
        (this.attributes = void 0),
        (this.children = void 0),
        (this.classes = void 0),
        (this.type = e),
        (this.attributes = {}),
        (this.children = t || []),
        (this.classes = n || []));
    }
    setAttribute(e, t) {
      this.attributes[e] = t;
    }
    getAttribute(e) {
      return this.attributes[e];
    }
    toNode() {
      var e = document.createElementNS(`http://www.w3.org/1998/Math/MathML`, this.type);
      for (var t in this.attributes)
        Object.prototype.hasOwnProperty.call(this.attributes, t) &&
          e.setAttribute(t, this.attributes[t]);
      this.classes.length > 0 && (e.className = j(this.classes));
      for (var n = 0; n < this.children.length; n++)
        if (this.children[n] instanceof Sn && this.children[n + 1] instanceof Sn) {
          for (
            var r = this.children[n].toText() + this.children[++n].toText();
            this.children[n + 1] instanceof Sn;
          )
            r += this.children[++n].toText();
          e.appendChild(new Sn(r).toNode());
        } else e.appendChild(this.children[n].toNode());
      return e;
    }
    toMarkup() {
      var e = `<` + this.type;
      for (var t in this.attributes)
        Object.prototype.hasOwnProperty.call(this.attributes, t) &&
          ((e += ` ` + t + `="`), (e += a(this.attributes[t])), (e += `"`));
      (this.classes.length > 0 && (e += ` class ="` + a(j(this.classes)) + `"`), (e += `>`));
      for (var n = 0; n < this.children.length; n++) e += this.children[n].toMarkup();
      return ((e += `</` + this.type + `>`), e);
    }
    toText() {
      return this.children.map((e) => e.toText()).join(``);
    }
  },
  Sn = class {
    constructor(e) {
      ((this.text = void 0), (this.text = e));
    }
    toNode() {
      return document.createTextNode(this.text);
    }
    toMarkup() {
      return a(this.toText());
    }
    toText() {
      return this.text;
    }
  },
  Cn = class {
    constructor(e) {
      ((this.width = void 0),
        (this.character = void 0),
        (this.width = e),
        e >= 0.05555 && e <= 0.05556
          ? (this.character = ` `)
          : e >= 0.1666 && e <= 0.1667
            ? (this.character = ` `)
            : e >= 0.2222 && e <= 0.2223
              ? (this.character = ` `)
              : e >= 0.2777 && e <= 0.2778
                ? (this.character = `  `)
                : e >= -0.05556 && e <= -0.05555
                  ? (this.character = ` ⁣`)
                  : e >= -0.1667 && e <= -0.1666
                    ? (this.character = ` ⁣`)
                    : e >= -0.2223 && e <= -0.2222
                      ? (this.character = ` ⁣`)
                      : e >= -0.2778 && e <= -0.2777
                        ? (this.character = ` ⁣`)
                        : (this.character = null));
    }
    toNode() {
      if (this.character) return document.createTextNode(this.character);
      var e = document.createElementNS(`http://www.w3.org/1998/Math/MathML`, `mspace`);
      return (e.setAttribute(`width`, A(this.width)), e);
    }
    toMarkup() {
      return this.character
        ? `<mtext>` + this.character + `</mtext>`
        : `<mspace width="` + A(this.width) + `"/>`;
    }
    toText() {
      return this.character ? this.character : ` `;
    }
  },
  wn = new Set([`\\imath`, `\\jmath`]),
  Tn = new Set([`mrow`, `mtable`]),
  En = function (e, t, n) {
    return (
      qe[t][e] &&
        qe[t][e].replace &&
        e.charCodeAt(0) !== 55349 &&
        !(
          et.hasOwnProperty(e) &&
          n &&
          ((n.fontFamily && n.fontFamily.slice(4, 6) === `tt`) ||
            (n.font && n.font.slice(4, 6) === `tt`))
        ) &&
        (e = qe[t][e].replace),
      new Sn(e)
    );
  },
  Dn = function (e) {
    return e.length === 1 ? e[0] : new J(`mrow`, e);
  },
  On = {
    mathit: `italic`,
    boldsymbol: (e) => (e.type === `textord` ? `bold` : `bold-italic`),
    mathbf: `bold`,
    mathbb: `double-struck`,
    mathsfit: `sans-serif-italic`,
    mathfrak: `fraktur`,
    mathscr: `script`,
    mathcal: `script`,
    mathsf: `sans-serif`,
    mathtt: `monospace`,
  },
  kn = (e, t) => {
    if (e.mode === `text`) {
      if (t.fontFamily === `texttt`) return `monospace`;
      if (t.fontFamily === `textsf`)
        return t.fontShape === `textit` && t.fontWeight === `textbf`
          ? `sans-serif-bold-italic`
          : t.fontShape === `textit`
            ? `sans-serif-italic`
            : t.fontWeight === `textbf`
              ? `bold-sans-serif`
              : `sans-serif`;
      if (t.fontShape === `textit` && t.fontWeight === `textbf`) return `bold-italic`;
      if (t.fontShape === `textit`) return `italic`;
      if (t.fontWeight === `textbf`) return `bold`;
    }
    var n = t.font;
    if (!n || n === `mathnormal`) return null;
    var r = e.mode,
      i = On[n];
    if (i) return typeof i == `function` ? i(e) : i;
    var a = e.text;
    if (wn.has(a)) return null;
    if (qe[r][a]) {
      var o = qe[r][a].replace;
      o && (a = o);
    }
    var s = Jt[n].fontName;
    return Ge(a, s, r) ? Jt[n].variant : null;
  };
function An(e) {
  if (!e) return !1;
  if (e.type === `mi` && e.children.length === 1) {
    var t = e.children[0];
    return t instanceof Sn && t.text === `.`;
  } else if (
    e.type === `mo` &&
    e.children.length === 1 &&
    e.getAttribute(`separator`) === `true` &&
    e.getAttribute(`lspace`) === `0em` &&
    e.getAttribute(`rspace`) === `0em`
  ) {
    var n = e.children[0];
    return n instanceof Sn && n.text === `,`;
  } else return !1;
}
var jn = function (e, t, n) {
    if (e.length === 1) {
      var r = Y(e[0], t);
      return (
        n &&
          r instanceof J &&
          r.type === `mo` &&
          (r.setAttribute(`lspace`, `0em`), r.setAttribute(`rspace`, `0em`)),
        [r]
      );
    }
    for (var i = [], a, o = 0; o < e.length; o++) {
      var s = Y(e[o], t);
      if (s instanceof J && a instanceof J) {
        if (
          s.type === `mtext` &&
          a.type === `mtext` &&
          s.getAttribute(`mathvariant`) === a.getAttribute(`mathvariant`)
        ) {
          a.children.push(...s.children);
          continue;
        } else if (s.type === `mn` && a.type === `mn`) {
          a.children.push(...s.children);
          continue;
        } else if (An(s) && a.type === `mn`) {
          a.children.push(...s.children);
          continue;
        } else if (s.type === `mn` && An(a))
          ((s.children = [...a.children, ...s.children]), i.pop());
        else if (
          (s.type === `msup` || s.type === `msub`) &&
          s.children.length >= 1 &&
          (a.type === `mn` || An(a))
        ) {
          var c = s.children[0];
          c instanceof J &&
            c.type === `mn` &&
            ((c.children = [...a.children, ...c.children]), i.pop());
        } else if (a.type === `mi` && a.children.length === 1) {
          var l = a.children[0];
          if (
            l instanceof Sn &&
            l.text === `̸` &&
            (s.type === `mo` || s.type === `mi` || s.type === `mn`)
          ) {
            var u = s.children[0];
            u instanceof Sn &&
              u.text.length > 0 &&
              ((u.text = u.text.slice(0, 1) + `̸` + u.text.slice(1)), i.pop());
          }
        }
      }
      (i.push(s), (a = s));
    }
    return i;
  },
  Mn = function (e, t, n) {
    return Dn(jn(e, t, n));
  },
  Y = function (t, n) {
    if (!t) return new J(`mrow`);
    if (an[t.type]) return an[t.type](t, n);
    throw new e(`Got group of unknown type: '` + t.type + `'`);
  };
function Nn(e, t, n, r, i) {
  var a = jn(e, n),
    o = a.length === 1 && a[0] instanceof J && Tn.has(a[0].type) ? a[0] : new J(`mrow`, a),
    s = new J(`annotation`, [new Sn(t)]);
  s.setAttribute(`encoding`, `application/x-tex`);
  var c = new J(`math`, [new J(`semantics`, [o, s])]);
  return (
    c.setAttribute(`xmlns`, `http://www.w3.org/1998/Math/MathML`),
    r && c.setAttribute(`display`, `block`),
    W([i ? `katex` : `katex-mathml`], [c])
  );
}
var Pn = [
    [1, 1, 1],
    [2, 1, 1],
    [3, 1, 1],
    [4, 2, 1],
    [5, 2, 1],
    [6, 3, 1],
    [7, 4, 2],
    [8, 6, 3],
    [9, 7, 6],
    [10, 8, 7],
    [11, 10, 9],
  ],
  Fn = [0.5, 0.6, 0.7, 0.8, 0.9, 1, 1.2, 1.44, 1.728, 2.074, 2.488],
  In = function (e, t) {
    return t.size < 2 ? e : Pn[e - 1][t.size - 1];
  },
  Ln = class e {
    constructor(t) {
      ((this.style = void 0),
        (this.color = void 0),
        (this.size = void 0),
        (this.textSize = void 0),
        (this.phantom = void 0),
        (this.font = void 0),
        (this.fontFamily = void 0),
        (this.fontWeight = void 0),
        (this.fontShape = void 0),
        (this.sizeMultiplier = void 0),
        (this.maxSize = void 0),
        (this.minRuleThickness = void 0),
        (this._fontMetrics = void 0),
        (this.style = t.style),
        (this.color = t.color),
        (this.size = t.size || e.BASESIZE),
        (this.textSize = t.textSize || this.size),
        (this.phantom = !!t.phantom),
        (this.font = t.font || ``),
        (this.fontFamily = t.fontFamily || ``),
        (this.fontWeight = t.fontWeight || ``),
        (this.fontShape = t.fontShape || ``),
        (this.sizeMultiplier = Fn[this.size - 1]),
        (this.maxSize = t.maxSize),
        (this.minRuleThickness = t.minRuleThickness),
        (this._fontMetrics = void 0));
    }
    extend(t) {
      var n = {
        style: this.style,
        size: this.size,
        textSize: this.textSize,
        color: this.color,
        phantom: this.phantom,
        font: this.font,
        fontFamily: this.fontFamily,
        fontWeight: this.fontWeight,
        fontShape: this.fontShape,
        maxSize: this.maxSize,
        minRuleThickness: this.minRuleThickness,
      };
      return (Object.assign(n, t), new e(n));
    }
    havingStyle(e) {
      return this.style === e
        ? this
        : this.extend({
            style: e,
            size: In(this.textSize, e),
          });
    }
    havingCrampedStyle() {
      return this.havingStyle(this.style.cramp());
    }
    havingSize(e) {
      return this.size === e && this.textSize === e
        ? this
        : this.extend({
            style: this.style.text(),
            size: e,
            textSize: e,
            sizeMultiplier: Fn[e - 1],
          });
    }
    havingBaseStyle(t) {
      t ||= this.style.text();
      var n = In(e.BASESIZE, t);
      return this.size === n && this.textSize === e.BASESIZE && this.style === t
        ? this
        : this.extend({
            style: t,
            size: n,
          });
    }
    havingBaseSizing() {
      var e;
      switch (this.style.id) {
        case 4:
        case 5:
          e = 3;
          break;
        case 6:
        case 7:
          e = 1;
          break;
        default:
          e = 6;
      }
      return this.extend({
        style: this.style.text(),
        size: e,
      });
    }
    withColor(e) {
      return this.extend({
        color: e,
      });
    }
    withPhantom() {
      return this.extend({
        phantom: !0,
      });
    }
    withFont(e) {
      return this.extend({
        font: e,
      });
    }
    withTextFontFamily(e) {
      return this.extend({
        fontFamily: e,
        font: ``,
      });
    }
    withTextFontWeight(e) {
      return this.extend({
        fontWeight: e,
        font: ``,
      });
    }
    withTextFontShape(e) {
      return this.extend({
        fontShape: e,
        font: ``,
      });
    }
    sizingClasses(e) {
      return e.size === this.size ? [] : [`sizing`, `reset-size` + e.size, `size` + this.size];
    }
    baseSizingClasses() {
      return this.size === e.BASESIZE
        ? []
        : [`sizing`, `reset-size` + this.size, `size` + e.BASESIZE];
    }
    fontMetrics() {
      return ((this._fontMetrics ||= M(this.size)), this._fontMetrics);
    }
    getColor() {
      return this.phantom ? `transparent` : this.color;
    }
  };
Ln.BASESIZE = 6;
var Rn = function (e) {
    return new Ln({
      style: e.displayMode ? E.DISPLAY : E.TEXT,
      maxSize: e.maxSize,
      minRuleThickness: e.minRuleThickness,
    });
  },
  zn = function (e, t) {
    if (t.displayMode) {
      var n = [`katex-display`];
      (t.leqno && n.push(`leqno`), t.fleqn && n.push(`fleqn`), (e = W(n, [e])));
    }
    return e;
  },
  Bn = function (e, t, n) {
    var r = Rn(n),
      i;
    return n.output === `mathml`
      ? Nn(e, t, r, n.displayMode, !0)
      : ((i =
          n.output === `html`
            ? W([`katex`], [bn(e, r)])
            : W([`katex`], [Nn(e, t, r, n.displayMode, !1), bn(e, r)])),
        zn(i, n));
  },
  Vn = function (e, t, n) {
    return zn(W([`katex`], [bn(e, Rn(n))]), n);
  },
  Hn = {
    widehat: `^`,
    widecheck: `ˇ`,
    widetilde: `~`,
    utilde: `~`,
    overleftarrow: `←`,
    underleftarrow: `←`,
    xleftarrow: `←`,
    overrightarrow: `→`,
    underrightarrow: `→`,
    xrightarrow: `→`,
    underbrace: `⏟`,
    overbrace: `⏞`,
    underbracket: `⎵`,
    overbracket: `⎴`,
    overgroup: `⏠`,
    undergroup: `⏡`,
    overleftrightarrow: `↔`,
    underleftrightarrow: `↔`,
    xleftrightarrow: `↔`,
    Overrightarrow: `⇒`,
    xRightarrow: `⇒`,
    overleftharpoon: `↼`,
    xleftharpoonup: `↼`,
    overrightharpoon: `⇀`,
    xrightharpoonup: `⇀`,
    xLeftarrow: `⇐`,
    xLeftrightarrow: `⇔`,
    xhookleftarrow: `↩`,
    xhookrightarrow: `↪`,
    xmapsto: `↦`,
    xrightharpoondown: `⇁`,
    xleftharpoondown: `↽`,
    xrightleftharpoons: `⇌`,
    xleftrightharpoons: `⇋`,
    xtwoheadleftarrow: `↞`,
    xtwoheadrightarrow: `↠`,
    xlongequal: `=`,
    xtofrom: `⇄`,
    xrightleftarrows: `⇄`,
    xrightequilibrium: `⇌`,
    xleftequilibrium: `⇋`,
    "\\cdrightarrow": `→`,
    "\\cdleftarrow": `←`,
    "\\cdlongequal": `=`,
  },
  Un = function (e) {
    var t = new J(`mo`, [new Sn(Hn[e.replace(/^\\/, ``)])]);
    return (t.setAttribute(`stretchy`, `true`), t);
  },
  Wn = {
    overrightarrow: [[`rightarrow`], 0.888, 522, `xMaxYMin`],
    overleftarrow: [[`leftarrow`], 0.888, 522, `xMinYMin`],
    underrightarrow: [[`rightarrow`], 0.888, 522, `xMaxYMin`],
    underleftarrow: [[`leftarrow`], 0.888, 522, `xMinYMin`],
    xrightarrow: [[`rightarrow`], 1.469, 522, `xMaxYMin`],
    "\\cdrightarrow": [[`rightarrow`], 3, 522, `xMaxYMin`],
    xleftarrow: [[`leftarrow`], 1.469, 522, `xMinYMin`],
    "\\cdleftarrow": [[`leftarrow`], 3, 522, `xMinYMin`],
    Overrightarrow: [[`doublerightarrow`], 0.888, 560, `xMaxYMin`],
    xRightarrow: [[`doublerightarrow`], 1.526, 560, `xMaxYMin`],
    xLeftarrow: [[`doubleleftarrow`], 1.526, 560, `xMinYMin`],
    overleftharpoon: [[`leftharpoon`], 0.888, 522, `xMinYMin`],
    xleftharpoonup: [[`leftharpoon`], 0.888, 522, `xMinYMin`],
    xleftharpoondown: [[`leftharpoondown`], 0.888, 522, `xMinYMin`],
    overrightharpoon: [[`rightharpoon`], 0.888, 522, `xMaxYMin`],
    xrightharpoonup: [[`rightharpoon`], 0.888, 522, `xMaxYMin`],
    xrightharpoondown: [[`rightharpoondown`], 0.888, 522, `xMaxYMin`],
    xlongequal: [[`longequal`], 0.888, 334, `xMinYMin`],
    "\\cdlongequal": [[`longequal`], 3, 334, `xMinYMin`],
    xtwoheadleftarrow: [[`twoheadleftarrow`], 0.888, 334, `xMinYMin`],
    xtwoheadrightarrow: [[`twoheadrightarrow`], 0.888, 334, `xMaxYMin`],
    overleftrightarrow: [[`leftarrow`, `rightarrow`], 0.888, 522],
    overbrace: [[`leftbrace`, `midbrace`, `rightbrace`], 1.6, 548],
    underbrace: [[`leftbraceunder`, `midbraceunder`, `rightbraceunder`], 1.6, 548],
    underleftrightarrow: [[`leftarrow`, `rightarrow`], 0.888, 522],
    xleftrightarrow: [[`leftarrow`, `rightarrow`], 1.75, 522],
    xLeftrightarrow: [[`doubleleftarrow`, `doublerightarrow`], 1.75, 560],
    xrightleftharpoons: [[`leftharpoondownplus`, `rightharpoonplus`], 1.75, 716],
    xleftrightharpoons: [[`leftharpoonplus`, `rightharpoondownplus`], 1.75, 716],
    xhookleftarrow: [[`leftarrow`, `righthook`], 1.08, 522],
    xhookrightarrow: [[`lefthook`, `rightarrow`], 1.08, 522],
    overlinesegment: [[`leftlinesegment`, `rightlinesegment`], 0.888, 522],
    underlinesegment: [[`leftlinesegment`, `rightlinesegment`], 0.888, 522],
    overbracket: [[`leftbracketover`, `rightbracketover`], 1.6, 440],
    underbracket: [[`leftbracketunder`, `rightbracketunder`], 1.6, 410],
    overgroup: [[`leftgroup`, `rightgroup`], 0.888, 342],
    undergroup: [[`leftgroupunder`, `rightgroupunder`], 0.888, 342],
    xmapsto: [[`leftmapsto`, `rightarrow`], 1.5, 522],
    xtofrom: [[`leftToFrom`, `rightToFrom`], 1.75, 528],
    xrightleftarrows: [[`baraboveleftarrow`, `rightarrowabovebar`], 1.75, 901],
    xrightequilibrium: [[`baraboveshortleftharpoon`, `rightharpoonaboveshortbar`], 1.75, 716],
    xleftequilibrium: [[`shortbaraboveleftharpoon`, `shortrightharpoonabovebar`], 1.75, 716],
  },
  Gn = new Set([`widehat`, `widecheck`, `widetilde`, `utilde`]),
  Kn = function (e, t) {
    function n() {
      var n = 4e5,
        r = e.label.slice(1);
      if (Gn.has(r) && `base` in e) {
        var i = e.base.type === `ordgroup` ? e.base.body.length : 1,
          a,
          o,
          s;
        if (i > 5)
          r === `widehat` || r === `widecheck`
            ? ((a = 420), (n = 2364), (s = 0.42), (o = r + `4`))
            : ((a = 312), (n = 2340), (s = 0.34), (o = `tilde4`));
        else {
          var c = [1, 1, 2, 2, 3, 3][i];
          r === `widehat` || r === `widecheck`
            ? ((n = [0, 1062, 2364, 2364, 2364][c]),
              (a = [0, 239, 300, 360, 420][c]),
              (s = [0, 0.24, 0.3, 0.3, 0.36, 0.42][c]),
              (o = r + c))
            : ((n = [0, 600, 1033, 2339, 2340][c]),
              (a = [0, 260, 286, 306, 312][c]),
              (s = [0, 0.26, 0.286, 0.3, 0.306, 0.34][c]),
              (o = `tilde` + c));
        }
        return {
          span: Bt(
            [],
            [
              new Fe([new Ie(o)], {
                width: `100%`,
                height: A(s),
                viewBox: `0 0 ` + n + ` ` + a,
                preserveAspectRatio: `none`,
              }),
            ],
            t,
          ),
          minWidth: 0,
          height: s,
        };
      } else {
        var l = [],
          u = Wn[r];
        if (!u) throw Error(`No SVG data for "` + r + `".`);
        var [d, f, p] = u,
          m = p / 1e3,
          h = d.length,
          g,
          _;
        if (h === 1) {
          if (u.length !== 4) throw Error(`Expected 4-tuple for single-path SVG data "` + r + `".`);
          ((g = [`hide-tail`]), (_ = [u[3]]));
        } else if (h === 2)
          ((g = [`halfarrow-left`, `halfarrow-right`]), (_ = [`xMinYMin`, `xMaxYMin`]));
        else if (h === 3)
          ((g = [`brace-left`, `brace-center`, `brace-right`]),
            (_ = [`xMinYMin`, `xMidYMin`, `xMaxYMin`]));
        else
          throw Error(
            `Correct katexImagesData or update code here to support
                    ` +
              h +
              ` children.`,
          );
        for (var v = 0; v < h; v++) {
          var y = new Fe([new Ie(d[v])], {
              width: `400em`,
              height: A(m),
              viewBox: `0 0 ` + n + ` ` + p,
              preserveAspectRatio: _[v] + ` slice`,
            }),
            b = Bt([g[v]], [y], t);
          if (h === 1)
            return {
              span: b,
              minWidth: f,
              height: m,
            };
          ((b.style.height = A(m)), l.push(b));
        }
        return {
          span: W([`stretchy`], l, t),
          minWidth: f,
          height: m,
        };
      }
    }
    var { span: r, minWidth: i, height: a } = n();
    return ((r.height = a), (r.style.height = A(a)), i > 0 && (r.style.minWidth = A(i)), r);
  },
  qn = function (e, t, n, r, i) {
    var a,
      o = e.height + e.depth + n + r;
    if (/fbox|color|angl/.test(t)) {
      if (((a = W([`stretchy`, t], [], i)), t === `fbox`)) {
        var s = i.color && i.getColor();
        s && (a.style.borderColor = s);
      }
    } else {
      var c = [];
      (/^[bx]cancel$/.test(t) &&
        c.push(
          new Le({
            x1: `0`,
            y1: `0`,
            x2: `100%`,
            y2: `100%`,
            "stroke-width": `0.046em`,
          }),
        ),
        /^x?cancel$/.test(t) &&
          c.push(
            new Le({
              x1: `0`,
              y1: `100%`,
              x2: `100%`,
              y2: `0`,
              "stroke-width": `0.046em`,
            }),
          ),
        (a = Bt(
          [],
          [
            new Fe(c, {
              width: `100%`,
              height: A(o),
            }),
          ],
          i,
        )));
    }
    return ((a.height = o), (a.style.height = A(o)), a);
  },
  Jn = {
    bin: 1,
    close: 1,
    inner: 1,
    open: 1,
    punct: 1,
    rel: 1,
  },
  Yn = {
    "accent-token": 1,
    mathord: 1,
    "op-token": 1,
    spacing: 1,
    textord: 1,
  };
function Xn(e) {
  return e in Jn;
}
function X(e, t) {
  if (!e || e.type !== t)
    throw Error(
      `Expected node of type ` + t + `, but got ` + (e ? `node of type ` + e.type : String(e)),
    );
  return e;
}
function Zn(e) {
  var t = Qn(e);
  if (!t)
    throw Error(
      `Expected node of symbol group type, but got ` + (e ? `node of type ` + e.type : String(e)),
    );
  return t;
}
function Qn(e) {
  return e && (e.type === `atom` || Yn.hasOwnProperty(e.type)) ? e : null;
}
var $n = (e) => {
    if (e instanceof Pe) return e;
    if (Be(e) && e.children.length === 1) return $n(e.children[0]);
  },
  er = (e, t) => {
    var n, r, i;
    e && e.type === `supsub`
      ? ((r = X(e.base, `accent`)), (n = r.base), (e.base = n), (i = ze(q(e, t))), (e.base = r))
      : ((r = X(e, `accent`)), (n = r.base));
    var a = q(n, t.havingCrampedStyle()),
      o = r.isShifty && c(n),
      s = 0;
    o && (s = $n(a)?.skew ?? 0);
    var l = r.label === `\\c`,
      u = l ? a.height + a.depth : Math.min(a.height, t.fontMetrics().xHeight),
      d;
    if (r.isStretchy)
      ((d = Kn(r, t)),
        (d = G({
          positionType: `firstBaseline`,
          children: [
            {
              type: `elem`,
              elem: a,
            },
            {
              type: `elem`,
              elem: d,
              wrapperClasses: [`svg-align`],
              wrapperStyle:
                s > 0
                  ? {
                      width: `calc(100% - ` + A(2 * s) + `)`,
                      marginLeft: A(2 * s),
                    }
                  : void 0,
            },
          ],
        })));
    else {
      var f, p;
      (r.label === `\\vec`
        ? ((f = Xt(`vec`, t)), (p = Yt.vec[1]))
        : ((f = It(
            {
              type: `textord`,
              mode: r.mode,
              text: r.label,
            },
            t,
          )),
          (f = Re(f)),
          (f.italic = 0),
          (p = f.width),
          l && (u += f.depth)),
        (d = W([`accent-body`], [f])));
      var m = r.label === `\\textcircled`;
      m && (d.classes.push(`accent-full`), (u = a.height));
      var h = s;
      (m || (h -= p / 2),
        (d.style.left = A(h)),
        r.label === `\\textcircled` && (d.style.top = `.2em`),
        (d = G({
          positionType: `firstBaseline`,
          children: [
            {
              type: `elem`,
              elem: a,
            },
            {
              type: `kern`,
              size: -u,
            },
            {
              type: `elem`,
              elem: d,
            },
          ],
        })));
    }
    var g = W([`mord`, `accent`], [d], t);
    return i
      ? ((i.children[0] = g), (i.height = Math.max(g.height, i.height)), (i.classes[0] = `mord`), i)
      : g;
  },
  tr = (e, t) => {
    var n = e.isStretchy ? Un(e.label) : new J(`mo`, [En(e.label, e.mode)]),
      r = new J(`mover`, [Y(e.base, t), n]);
    return (r.setAttribute(`accent`, `true`), r);
  },
  nr = new RegExp(
    [
      `\\acute`,
      `\\grave`,
      `\\ddot`,
      `\\tilde`,
      `\\bar`,
      `\\breve`,
      `\\check`,
      `\\hat`,
      `\\vec`,
      `\\dot`,
      `\\mathring`,
    ]
      .map((e) => `\\` + e)
      .join(`|`),
  );
(K({
  type: `accent`,
  names: [
    `\\acute`,
    `\\grave`,
    `\\ddot`,
    `\\tilde`,
    `\\bar`,
    `\\breve`,
    `\\check`,
    `\\hat`,
    `\\vec`,
    `\\dot`,
    `\\mathring`,
    `\\widecheck`,
    `\\widehat`,
    `\\widetilde`,
    `\\overrightarrow`,
    `\\overleftarrow`,
    `\\Overrightarrow`,
    `\\overleftrightarrow`,
    `\\overgroup`,
    `\\overlinesegment`,
    `\\overleftharpoon`,
    `\\overrightharpoon`,
  ],
  numArgs: 1,
  handler: (e, t) => {
    var n = sn(t[0]),
      r = !nr.test(e.funcName),
      i =
        !r ||
        e.funcName === `\\widehat` ||
        e.funcName === `\\widetilde` ||
        e.funcName === `\\widecheck`;
    return {
      type: `accent`,
      mode: e.parser.mode,
      label: e.funcName,
      isStretchy: r,
      isShifty: i,
      base: n,
    };
  },
  htmlBuilder: er,
  mathmlBuilder: tr,
}),
  K({
    type: `accent`,
    names: [
      `\\'`,
      "\\`",
      `\\^`,
      `\\~`,
      `\\=`,
      `\\u`,
      `\\.`,
      `\\"`,
      `\\c`,
      `\\r`,
      `\\H`,
      `\\v`,
      `\\textcircled`,
    ],
    numArgs: 1,
    allowedInText: !0,
    allowedInMath: !0,
    argTypes: [`primitive`],
    handler: (e, t) => {
      var n = t[0],
        r = e.parser.mode;
      return (
        r === `math` &&
          (e.parser.settings.reportNonstrict(
            `mathVsTextAccents`,
            `LaTeX's accent ` + e.funcName + ` works only in text mode`,
          ),
          (r = `text`)),
        {
          type: `accent`,
          mode: r,
          label: e.funcName,
          isStretchy: !1,
          isShifty: !0,
          base: n,
        }
      );
    },
  }),
  K({
    type: `accentUnder`,
    names: [
      `\\underleftarrow`,
      `\\underrightarrow`,
      `\\underleftrightarrow`,
      `\\undergroup`,
      `\\underlinesegment`,
      `\\utilde`,
    ],
    numArgs: 1,
    handler: (e, t) => {
      var { parser: n, funcName: r } = e,
        i = t[0];
      return {
        type: `accentUnder`,
        mode: n.mode,
        label: r,
        base: i,
      };
    },
    htmlBuilder: (e, t) => {
      var n = q(e.base, t),
        r = Kn(e, t),
        i = e.label === `\\utilde` ? 0.12 : 0;
      return W(
        [`mord`, `accentunder`],
        [
          G({
            positionType: `top`,
            positionData: n.height,
            children: [
              {
                type: `elem`,
                elem: r,
                wrapperClasses: [`svg-align`],
              },
              {
                type: `kern`,
                size: i,
              },
              {
                type: `elem`,
                elem: n,
              },
            ],
          }),
        ],
        t,
      );
    },
    mathmlBuilder: (e, t) => {
      var n = Un(e.label),
        r = new J(`munder`, [Y(e.base, t), n]);
      return (r.setAttribute(`accentunder`, `true`), r);
    },
  }));
var rr = (e) => {
  var t = new J(`mpadded`, e ? [e] : []);
  return (t.setAttribute(`width`, `+0.6em`), t.setAttribute(`lspace`, `0.3em`), t);
};
K({
  type: `xArrow`,
  names: [
    `\\xleftarrow`,
    `\\xrightarrow`,
    `\\xLeftarrow`,
    `\\xRightarrow`,
    `\\xleftrightarrow`,
    `\\xLeftrightarrow`,
    `\\xhookleftarrow`,
    `\\xhookrightarrow`,
    `\\xmapsto`,
    `\\xrightharpoondown`,
    `\\xrightharpoonup`,
    `\\xleftharpoondown`,
    `\\xleftharpoonup`,
    `\\xrightleftharpoons`,
    `\\xleftrightharpoons`,
    `\\xlongequal`,
    `\\xtwoheadrightarrow`,
    `\\xtwoheadleftarrow`,
    `\\xtofrom`,
    `\\xrightleftarrows`,
    `\\xrightequilibrium`,
    `\\xleftequilibrium`,
    `\\\\cdrightarrow`,
    `\\\\cdleftarrow`,
    `\\\\cdlongequal`,
  ],
  numArgs: 1,
  numOptionalArgs: 1,
  handler(e, t, n) {
    var { parser: r, funcName: i } = e;
    return {
      type: `xArrow`,
      mode: r.mode,
      label: i,
      body: t[0],
      below: n[0],
    };
  },
  htmlBuilder(e, t) {
    var n = t.style,
      r = t.havingStyle(n.sup()),
      i = Wt(q(e.body, r, t), t),
      a = e.label.slice(0, 2) === `\\x` ? `x` : `cd`;
    i.classes.push(a + `-arrow-pad`);
    var o;
    e.below &&
      ((r = t.havingStyle(n.sub())),
      (o = Wt(q(e.below, r, t), t)),
      o.classes.push(a + `-arrow-pad`));
    var s = Kn(e, t),
      c = -t.fontMetrics().axisHeight + 0.5 * s.height,
      l = -t.fontMetrics().axisHeight - 0.5 * s.height - 0.111;
    (i.depth > 0.25 || e.label === `\\xleftequilibrium`) && (l -= i.depth);
    var u;
    if (o) {
      var d = -t.fontMetrics().axisHeight + o.height + 0.5 * s.height + 0.111;
      u = G({
        positionType: `individualShift`,
        children: [
          {
            type: `elem`,
            elem: i,
            shift: l,
          },
          {
            type: `elem`,
            elem: s,
            shift: c,
            wrapperClasses: [`svg-align`],
          },
          {
            type: `elem`,
            elem: o,
            shift: d,
          },
        ],
      });
    } else
      u = G({
        positionType: `individualShift`,
        children: [
          {
            type: `elem`,
            elem: i,
            shift: l,
          },
          {
            type: `elem`,
            elem: s,
            shift: c,
            wrapperClasses: [`svg-align`],
          },
        ],
      });
    return W([`mrel`, `x-arrow`], [u], t);
  },
  mathmlBuilder(e, t) {
    var n = Un(e.label);
    n.setAttribute(`minsize`, e.label.charAt(0) === `x` ? `1.75em` : `3.0em`);
    var r;
    if (e.body) {
      var i = rr(Y(e.body, t));
      r = e.below ? new J(`munderover`, [n, rr(Y(e.below, t)), i]) : new J(`mover`, [n, i]);
    } else
      e.below
        ? (r = new J(`munder`, [n, rr(Y(e.below, t))]))
        : ((r = rr()), (r = new J(`mover`, [n, r])));
    return r;
  },
});
function ir(e, t) {
  var n = pn(e.body, t, !0);
  return W([e.mclass], n, t);
}
function ar(e, t) {
  var n,
    r = jn(e.body, t);
  return (
    e.mclass === `minner`
      ? (n = new J(`mpadded`, r))
      : e.mclass === `mord`
        ? e.isCharacterBox
          ? ((n = r[0]), (n.type = `mi`))
          : (n = new J(`mi`, r))
        : (e.isCharacterBox ? ((n = r[0]), (n.type = `mo`)) : (n = new J(`mo`, r)),
          e.mclass === `mbin`
            ? ((n.attributes.lspace = `0.22em`), (n.attributes.rspace = `0.22em`))
            : e.mclass === `mpunct`
              ? ((n.attributes.lspace = `0em`), (n.attributes.rspace = `0.17em`))
              : (e.mclass === `mopen` || e.mclass === `mclose`) &&
                ((n.attributes.lspace = `0em`), (n.attributes.rspace = `0em`))),
    n
  );
}
K({
  type: `mclass`,
  names: [
    `\\mathord`,
    `\\mathbin`,
    `\\mathrel`,
    `\\mathopen`,
    `\\mathclose`,
    `\\mathpunct`,
    `\\mathinner`,
  ],
  numArgs: 1,
  primitive: !0,
  handler(e, t) {
    var { parser: n, funcName: r } = e,
      i = t[0];
    return {
      type: `mclass`,
      mode: n.mode,
      mclass: `m` + r.slice(5),
      body: cn(i),
      isCharacterBox: c(i),
    };
  },
  htmlBuilder: ir,
  mathmlBuilder: ar,
});
var or = (e) => {
  var t = e.type === `ordgroup` && e.body.length ? e.body[0] : e;
  return t.type === `atom` && (t.family === `bin` || t.family === `rel`) ? `m` + t.family : `mord`;
};
(K({
  type: `mclass`,
  names: [`\\@binrel`],
  numArgs: 2,
  handler(e, t) {
    var { parser: n } = e;
    return {
      type: `mclass`,
      mode: n.mode,
      mclass: or(t[0]),
      body: cn(t[1]),
      isCharacterBox: c(t[1]),
    };
  },
}),
  K({
    type: `mclass`,
    names: [`\\stackrel`, `\\overset`, `\\underset`],
    numArgs: 2,
    handler(e, t) {
      var { parser: n, funcName: r } = e,
        i = t[1],
        a = t[0],
        o = r === `\\stackrel` ? `mrel` : or(i),
        s = {
          type: `op`,
          mode: i.mode,
          limits: !0,
          alwaysHandleSupSub: !0,
          parentIsSupSub: !1,
          symbol: !1,
          suppressBaseShift: r !== `\\stackrel`,
          body: cn(i),
        },
        l =
          r === `\\underset`
            ? {
                type: `supsub`,
                mode: a.mode,
                base: s,
                sub: a,
              }
            : {
                type: `supsub`,
                mode: a.mode,
                base: s,
                sup: a,
              };
      return {
        type: `mclass`,
        mode: n.mode,
        mclass: o,
        body: [l],
        isCharacterBox: c(l),
      };
    },
  }),
  K({
    type: `pmb`,
    names: [`\\pmb`],
    numArgs: 1,
    allowedInText: !0,
    handler(e, t) {
      var { parser: n } = e;
      return {
        type: `pmb`,
        mode: n.mode,
        mclass: or(t[0]),
        body: cn(t[0]),
      };
    },
    htmlBuilder(e, t) {
      var n = pn(e.body, t, !0),
        r = W([e.mclass], n, t);
      return ((r.style.textShadow = `0.02em 0.01em 0.04px`), r);
    },
    mathmlBuilder(e, t) {
      var n = new J(`mstyle`, jn(e.body, t));
      return (n.setAttribute(`style`, `text-shadow: 0.02em 0.01em 0.04px`), n);
    },
  }));
var sr = {
    ">": `\\\\cdrightarrow`,
    "<": `\\\\cdleftarrow`,
    "=": `\\\\cdlongequal`,
    A: `\\uparrow`,
    V: `\\downarrow`,
    "|": `\\Vert`,
    ".": `no arrow`,
  },
  cr = () => ({
    type: `styling`,
    body: [],
    mode: `math`,
    style: `display`,
    resetFont: !0,
  }),
  lr = (e) => e.type === `textord` && e.text === `@`,
  ur = (e, t) => (e.type === `mathord` || e.type === `atom`) && e.text === t;
function dr(e, t, n) {
  var r = sr[e];
  switch (r) {
    case `\\\\cdrightarrow`:
    case `\\\\cdleftarrow`:
      return n.callFunction(r, [t[0]], [t[1]]);
    case `\\uparrow`:
    case `\\downarrow`:
      var i = n.callFunction(`\\\\cdleft`, [t[0]], []),
        a = {
          type: `atom`,
          text: r,
          mode: `math`,
          family: `rel`,
        },
        o = {
          type: `ordgroup`,
          mode: `math`,
          body: [i, n.callFunction(`\\Big`, [a], []), n.callFunction(`\\\\cdright`, [t[1]], [])],
        };
      return n.callFunction(`\\\\cdparent`, [o], []);
    case `\\\\cdlongequal`:
      return n.callFunction(`\\\\cdlongequal`, [], []);
    case `\\Vert`:
      return n.callFunction(
        `\\Big`,
        [
          {
            type: `textord`,
            text: `\\Vert`,
            mode: `math`,
          },
        ],
        [],
      );
    default:
      return {
        type: `textord`,
        text: ` `,
        mode: `math`,
      };
  }
}
function fr(t) {
  var n = [];
  for (
    t.gullet.beginGroup(), t.gullet.macros.set(`\\cr`, `\\\\\\relax`), t.gullet.beginGroup();
    ;
  ) {
    (n.push(t.parseExpression(!1, `\\\\`)), t.gullet.endGroup(), t.gullet.beginGroup());
    var r = t.fetch().text;
    if (r === `&` || r === `\\\\`) t.consume();
    else if (r === `\\end`) {
      n[n.length - 1].length === 0 && n.pop();
      break;
    } else throw new e(`Expected \\\\ or \\cr or \\end`, t.nextToken);
  }
  for (var i = [], a = [i], o = 0; o < n.length; o++) {
    for (var s = n[o], c = cr(), l = 0; l < s.length; l++)
      if (!lr(s[l])) c.body.push(s[l]);
      else {
        (i.push(c), (l += 1));
        var u = Zn(s[l]).text,
          d = [, ,];
        if (
          ((d[0] = {
            type: `ordgroup`,
            mode: `math`,
            body: [],
          }),
          (d[1] = {
            type: `ordgroup`,
            mode: `math`,
            body: [],
          }),
          !`=|.`.includes(u))
        )
          if (`<>AV`.includes(u))
            for (var f = 0; f < 2; f++) {
              for (var p = !0, m = l + 1; m < s.length; m++) {
                if (ur(s[m], u)) {
                  ((p = !1), (l = m));
                  break;
                }
                if (lr(s[m]))
                  throw new e(`Missing a ` + u + ` character to complete a CD arrow.`, s[m]);
                d[f].body.push(s[m]);
              }
              if (p) throw new e(`Missing a ` + u + ` character to complete a CD arrow.`, s[l]);
            }
          else throw new e(`Expected one of "<>AV=|." after @`, s[l]);
        var h = {
          type: `styling`,
          body: [dr(u, d, t)],
          mode: `math`,
          style: `display`,
          resetFont: !0,
        };
        (i.push(h), (c = cr()));
      }
    (o % 2 == 0 ? i.push(c) : i.shift(), (i = []), a.push(i));
  }
  return (
    t.gullet.endGroup(),
    t.gullet.endGroup(),
    {
      type: `array`,
      mode: `math`,
      body: a,
      arraystretch: 1,
      addJot: !0,
      rowGaps: [null],
      cols: Array(a[0].length).fill({
        type: `align`,
        align: `c`,
        pregap: 0.25,
        postgap: 0.25,
      }),
      colSeparationType: `CD`,
      hLinesBeforeRow: Array(a.length + 1).fill([]),
    }
  );
}
(K({
  type: `cdlabel`,
  names: [`\\\\cdleft`, `\\\\cdright`],
  numArgs: 1,
  handler(e, t) {
    var { parser: n, funcName: r } = e;
    return {
      type: `cdlabel`,
      mode: n.mode,
      side: r.slice(4),
      label: t[0],
    };
  },
  htmlBuilder(e, t) {
    var n = t.havingStyle(t.style.sup()),
      r = Wt(q(e.label, n, t), t);
    return (
      r.classes.push(`cd-label-` + e.side),
      (r.style.bottom = A(0.8 - r.depth)),
      (r.height = 0),
      (r.depth = 0),
      r
    );
  },
  mathmlBuilder(e, t) {
    var n = new J(`mrow`, [Y(e.label, t)]);
    return (
      (n = new J(`mpadded`, [n])),
      n.setAttribute(`width`, `0`),
      e.side === `left` && n.setAttribute(`lspace`, `-1width`),
      n.setAttribute(`voffset`, `0.7em`),
      (n = new J(`mstyle`, [n])),
      n.setAttribute(`displaystyle`, `false`),
      n.setAttribute(`scriptlevel`, `1`),
      n
    );
  },
}),
  K({
    type: `cdlabelparent`,
    names: [`\\\\cdparent`],
    numArgs: 1,
    handler(e, t) {
      var { parser: n } = e;
      return {
        type: `cdlabelparent`,
        mode: n.mode,
        fragment: t[0],
      };
    },
    htmlBuilder(e, t) {
      var n = Wt(q(e.fragment, t), t);
      return (n.classes.push(`cd-vert-arrow`), n);
    },
    mathmlBuilder(e, t) {
      return new J(`mrow`, [Y(e.fragment, t)]);
    },
  }),
  K({
    type: `textord`,
    names: [`\\@char`],
    numArgs: 1,
    allowedInText: !0,
    handler(t, n) {
      for (var { parser: r } = t, i = X(n[0], `ordgroup`).body, a = ``, o = 0; o < i.length; o++) {
        var s = X(i[o], `textord`);
        a += s.text;
      }
      var c = parseInt(a),
        l;
      if (isNaN(c)) throw new e(`\\@char has non-numeric argument ` + a);
      if (c < 0 || c >= 1114111) throw new e(`\\@char with invalid code point ` + a);
      return (
        c <= 65535
          ? (l = String.fromCharCode(c))
          : ((c -= 65536), (l = String.fromCharCode((c >> 10) + 55296, (c & 1023) + 56320))),
        {
          type: `textord`,
          mode: r.mode,
          text: l,
        }
      );
    },
  }),
  K({
    type: `color`,
    names: [`\\textcolor`],
    numArgs: 2,
    allowedInText: !0,
    argTypes: [`color`, `original`],
    handler(e, t) {
      var { parser: n } = e,
        r = X(t[0], `color-token`).color,
        i = t[1];
      return {
        type: `color`,
        mode: n.mode,
        color: r,
        body: cn(i),
      };
    },
    htmlBuilder: (e, t) => Ut(pn(e.body, t.withColor(e.color), !1)),
    mathmlBuilder: (e, t) => {
      var n = new J(`mstyle`, jn(e.body, t.withColor(e.color)));
      return (n.setAttribute(`mathcolor`, e.color), n);
    },
  }),
  K({
    type: `color`,
    names: [`\\color`],
    numArgs: 1,
    allowedInText: !0,
    argTypes: [`color`],
    handler(e, t) {
      var { parser: n, breakOnTokenText: r } = e,
        i = X(t[0], `color-token`).color;
      n.gullet.macros.set(`\\current@color`, i);
      var a = n.parseExpression(!0, r);
      return {
        type: `color`,
        mode: n.mode,
        color: i,
        body: a,
      };
    },
  }),
  K({
    type: `cr`,
    names: [`\\\\`],
    numArgs: 0,
    numOptionalArgs: 0,
    allowedInText: !0,
    handler(e, t, n) {
      var { parser: r } = e,
        i = r.gullet.future().text === `[` ? r.parseSizeGroup(!0) : null,
        a =
          !r.settings.displayMode ||
          !r.settings.useStrictBehavior(
            `newLineInDisplayMode`,
            `In LaTeX, \\\\ or \\newline does nothing in display mode`,
          );
      return {
        type: `cr`,
        mode: r.mode,
        newLine: a,
        size: i && X(i, `size`).value,
      };
    },
    htmlBuilder(e, t) {
      var n = W([`mspace`], [], t);
      return (
        e.newLine && (n.classes.push(`newline`), e.size && (n.style.marginTop = A(k(e.size, t)))),
        n
      );
    },
    mathmlBuilder(e, t) {
      var n = new J(`mspace`);
      return (
        e.newLine &&
          (n.setAttribute(`linebreak`, `newline`),
          e.size && n.setAttribute(`height`, A(k(e.size, t)))),
        n
      );
    },
  }));
var pr = {
    "\\global": `\\global`,
    "\\long": `\\\\globallong`,
    "\\\\globallong": `\\\\globallong`,
    "\\def": `\\gdef`,
    "\\gdef": `\\gdef`,
    "\\edef": `\\xdef`,
    "\\xdef": `\\xdef`,
    "\\let": `\\\\globallet`,
    "\\futurelet": `\\\\globalfuture`,
  },
  mr = (t) => {
    var n = t.text;
    if (/^(?:[\\{}$&#^_]|EOF)$/.test(n)) throw new e(`Expected a control sequence`, t);
    return n;
  },
  hr = (e) => {
    var t = e.gullet.popToken();
    return (
      t.text === `=` && ((t = e.gullet.popToken()), t.text === ` ` && (t = e.gullet.popToken())),
      t
    );
  },
  gr = (e, t, n, r) => {
    var i = e.gullet.macros.get(n.text);
    ((i ??=
      ((n.noexpand = !0),
      {
        tokens: [n],
        numArgs: 0,
        unexpandable: !e.gullet.isExpandable(n.text),
      })),
      e.gullet.macros.set(t, i, r));
  };
(K({
  type: `internal`,
  names: [`\\global`, `\\long`, `\\\\globallong`],
  numArgs: 0,
  allowedInText: !0,
  handler(t) {
    var { parser: n, funcName: r } = t;
    n.consumeSpaces();
    var i = n.fetch();
    if (pr[i.text])
      return (
        (r === `\\global` || r === `\\\\globallong`) && (i.text = pr[i.text]),
        X(n.parseFunction(), `internal`)
      );
    throw new e(`Invalid token after macro prefix`, i);
  },
}),
  K({
    type: `internal`,
    names: [`\\def`, `\\gdef`, `\\edef`, `\\xdef`],
    numArgs: 0,
    allowedInText: !0,
    primitive: !0,
    handler(t) {
      var { parser: n, funcName: r } = t,
        i = n.gullet.popToken(),
        a = i.text;
      if (/^(?:[\\{}$&#^_]|EOF)$/.test(a)) throw new e(`Expected a control sequence`, i);
      for (var o = 0, s, c = [[]]; n.gullet.future().text !== `{`;)
        if (((i = n.gullet.popToken()), i.text === `#`)) {
          if (n.gullet.future().text === `{`) {
            ((s = n.gullet.future()), c[o].push(`{`));
            break;
          }
          if (((i = n.gullet.popToken()), !/^[1-9]$/.test(i.text)))
            throw new e(`Invalid argument number "` + i.text + `"`);
          if (parseInt(i.text) !== o + 1)
            throw new e(`Argument number "` + i.text + `" out of order`);
          (o++, c.push([]));
        } else if (i.text === `EOF`) throw new e(`Expected a macro definition`);
        else c[o].push(i.text);
      var { tokens: l } = n.gullet.consumeArg();
      return (
        s && l.unshift(s),
        (r === `\\edef` || r === `\\xdef`) && ((l = n.gullet.expandTokens(l)), l.reverse()),
        n.gullet.macros.set(
          a,
          {
            tokens: l,
            numArgs: o,
            delimiters: c,
          },
          r === pr[r],
        ),
        {
          type: `internal`,
          mode: n.mode,
        }
      );
    },
  }),
  K({
    type: `internal`,
    names: [`\\let`, `\\\\globallet`],
    numArgs: 0,
    allowedInText: !0,
    primitive: !0,
    handler(e) {
      var { parser: t, funcName: n } = e,
        r = mr(t.gullet.popToken());
      return (
        t.gullet.consumeSpaces(),
        gr(t, r, hr(t), n === `\\\\globallet`),
        {
          type: `internal`,
          mode: t.mode,
        }
      );
    },
  }),
  K({
    type: `internal`,
    names: [`\\futurelet`, `\\\\globalfuture`],
    numArgs: 0,
    allowedInText: !0,
    primitive: !0,
    handler(e) {
      var { parser: t, funcName: n } = e,
        r = mr(t.gullet.popToken()),
        i = t.gullet.popToken(),
        a = t.gullet.popToken();
      return (
        gr(t, r, a, n === `\\\\globalfuture`),
        t.gullet.pushToken(a),
        t.gullet.pushToken(i),
        {
          type: `internal`,
          mode: t.mode,
        }
      );
    },
  }));
var _r = function (e, t, n) {
    var r = Ge((qe.math[e] && qe.math[e].replace) || e, t, n);
    if (!r) throw Error(`Unsupported symbol ` + e + ` and font size ` + t + `.`);
    return r;
  },
  vr = function (e, t, n, r) {
    var i = n.havingBaseStyle(t),
      a = W(r.concat(i.sizingClasses(n)), [e], n),
      o = i.sizeMultiplier / n.sizeMultiplier;
    return ((a.height *= o), (a.depth *= o), (a.maxFontSize = i.sizeMultiplier), a);
  },
  yr = function (e, t, n) {
    var r = t.havingBaseStyle(n),
      i = (1 - t.sizeMultiplier / r.sizeMultiplier) * t.fontMetrics().axisHeight;
    (e.classes.push(`delimcenter`), (e.style.top = A(i)), (e.height -= i), (e.depth += i));
  },
  br = function (e, t, n, r, i, a) {
    var o = vr(Nt(e, `Main-Regular`, i, r), t, r, a);
    return (n && yr(o, r, t), o);
  },
  xr = function (e, t, n, r) {
    return Nt(e, `Size` + t + `-Regular`, n, r);
  },
  Sr = function (e, t, n, r, i, a) {
    var o = xr(e, t, i, r),
      s = vr(W([`delimsizing`, `size` + t], [o], r), E.TEXT, r, a);
    return (n && yr(s, r, E.TEXT), s);
  },
  Cr = function (e, t, n) {
    return {
      type: `elem`,
      elem: W(
        [`delimsizinginner`, t === `Size1-Regular` ? `delim-size1` : `delim-size4`],
        [W([], [Nt(e, t, n)])],
      ),
    };
  },
  wr = function (e, t, n) {
    var r = Ve[`Size4-Regular`][e.charCodeAt(0)]
        ? Ve[`Size4-Regular`][e.charCodeAt(0)][4]
        : Ve[`Size1-Regular`][e.charCodeAt(0)][4],
      i = Bt(
        [],
        [
          new Fe([new Ie(`inner`, _e(e, Math.round(1e3 * t)))], {
            width: A(r),
            height: A(t),
            style: `width:` + A(r),
            viewBox: `0 0 ` + 1e3 * r + ` ` + Math.round(1e3 * t),
            preserveAspectRatio: `xMinYMin`,
          }),
        ],
        n,
      );
    return (
      (i.height = t),
      (i.style.height = A(t)),
      (i.style.width = A(r)),
      {
        type: `elem`,
        elem: i,
      }
    );
  },
  Tr = 0.008,
  Er = {
    type: `kern`,
    size: -1 * Tr,
  },
  Dr = new Set([`|`, `\\lvert`, `\\rvert`, `\\vert`]),
  Or = new Set([`\\|`, `\\lVert`, `\\rVert`, `\\Vert`]),
  kr = function (e, t, n, r, i, a) {
    var o,
      s,
      c,
      l,
      u = ``,
      d = 0;
    ((o = c = l = e), (s = null));
    var f = `Size1-Regular`;
    e === `\\uparrow`
      ? (c = l = `⏐`)
      : e === `\\Uparrow`
        ? (c = l = `‖`)
        : e === `\\downarrow`
          ? (o = c = `⏐`)
          : e === `\\Downarrow`
            ? (o = c = `‖`)
            : e === `\\updownarrow`
              ? ((o = `\\uparrow`), (c = `⏐`), (l = `\\downarrow`))
              : e === `\\Updownarrow`
                ? ((o = `\\Uparrow`), (c = `‖`), (l = `\\Downarrow`))
                : Dr.has(e)
                  ? ((c = `∣`), (u = `vert`), (d = 333))
                  : Or.has(e)
                    ? ((c = `∥`), (u = `doublevert`), (d = 556))
                    : e === `[` || e === `\\lbrack`
                      ? ((o = `⎡`),
                        (c = `⎢`),
                        (l = `⎣`),
                        (f = `Size4-Regular`),
                        (u = `lbrack`),
                        (d = 667))
                      : e === `]` || e === `\\rbrack`
                        ? ((o = `⎤`),
                          (c = `⎥`),
                          (l = `⎦`),
                          (f = `Size4-Regular`),
                          (u = `rbrack`),
                          (d = 667))
                        : e === `\\lfloor` || e === `⌊`
                          ? ((c = o = `⎢`),
                            (l = `⎣`),
                            (f = `Size4-Regular`),
                            (u = `lfloor`),
                            (d = 667))
                          : e === `\\lceil` || e === `⌈`
                            ? ((o = `⎡`),
                              (c = l = `⎢`),
                              (f = `Size4-Regular`),
                              (u = `lceil`),
                              (d = 667))
                            : e === `\\rfloor` || e === `⌋`
                              ? ((c = o = `⎥`),
                                (l = `⎦`),
                                (f = `Size4-Regular`),
                                (u = `rfloor`),
                                (d = 667))
                              : e === `\\rceil` || e === `⌉`
                                ? ((o = `⎤`),
                                  (c = l = `⎥`),
                                  (f = `Size4-Regular`),
                                  (u = `rceil`),
                                  (d = 667))
                                : e === `(` || e === `\\lparen`
                                  ? ((o = `⎛`),
                                    (c = `⎜`),
                                    (l = `⎝`),
                                    (f = `Size4-Regular`),
                                    (u = `lparen`),
                                    (d = 875))
                                  : e === `)` || e === `\\rparen`
                                    ? ((o = `⎞`),
                                      (c = `⎟`),
                                      (l = `⎠`),
                                      (f = `Size4-Regular`),
                                      (u = `rparen`),
                                      (d = 875))
                                    : e === `\\{` || e === `\\lbrace`
                                      ? ((o = `⎧`),
                                        (s = `⎨`),
                                        (l = `⎩`),
                                        (c = `⎪`),
                                        (f = `Size4-Regular`))
                                      : e === `\\}` || e === `\\rbrace`
                                        ? ((o = `⎫`),
                                          (s = `⎬`),
                                          (l = `⎭`),
                                          (c = `⎪`),
                                          (f = `Size4-Regular`))
                                        : e === `\\lgroup` || e === `⟮`
                                          ? ((o = `⎧`), (l = `⎩`), (c = `⎪`), (f = `Size4-Regular`))
                                          : e === `\\rgroup` || e === `⟯`
                                            ? ((o = `⎫`),
                                              (l = `⎭`),
                                              (c = `⎪`),
                                              (f = `Size4-Regular`))
                                            : e === `\\lmoustache` || e === `⎰`
                                              ? ((o = `⎧`),
                                                (l = `⎭`),
                                                (c = `⎪`),
                                                (f = `Size4-Regular`))
                                              : (e === `\\rmoustache` || e === `⎱`) &&
                                                ((o = `⎫`),
                                                (l = `⎩`),
                                                (c = `⎪`),
                                                (f = `Size4-Regular`));
    var p = _r(o, f, i),
      m = p.height + p.depth,
      h = _r(c, f, i),
      g = h.height + h.depth,
      _ = _r(l, f, i),
      v = _.height + _.depth,
      y = 0,
      b = 1;
    if (s !== null) {
      var x = _r(s, f, i);
      ((y = x.height + x.depth), (b = 2));
    }
    var S = m + v + y,
      C = S + Math.max(0, Math.ceil((t - S) / (b * g))) * b * g,
      w = r.fontMetrics().axisHeight;
    n && (w *= r.sizeMultiplier);
    var ee = C / 2 - w,
      T = [];
    if (u.length > 0) {
      var te = C - m - v,
        ne = Math.round(C * 1e3),
        re = ye(u, Math.round(te * 1e3)),
        ie = new Ie(u, re),
        ae = A(d / 1e3),
        oe = A(ne / 1e3),
        se = Bt(
          [],
          [
            new Fe([ie], {
              width: ae,
              height: oe,
              viewBox: `0 0 ` + d + ` ` + ne,
            }),
          ],
          r,
        );
      ((se.height = ne / 1e3),
        (se.style.width = ae),
        (se.style.height = oe),
        T.push({
          type: `elem`,
          elem: se,
        }));
    } else {
      if ((T.push(Cr(l, f, i)), T.push(Er), s === null)) {
        var ce = C - m - v + 2 * Tr;
        T.push(wr(c, ce, r));
      } else {
        var D = (C - m - v - y) / 2 + 2 * Tr;
        (T.push(wr(c, D, r)), T.push(Er), T.push(Cr(s, f, i)), T.push(Er), T.push(wr(c, D, r)));
      }
      (T.push(Er), T.push(Cr(o, f, i)));
    }
    var le = r.havingBaseStyle(E.TEXT);
    return vr(
      W(
        [`delimsizing`, `mult`],
        [
          G({
            positionType: `bottom`,
            positionData: ee,
            children: T,
          }),
        ],
        le,
      ),
      E.TEXT,
      r,
      a,
    );
  },
  Ar = 80,
  jr = 0.08,
  Mr = function (e, t, n, r, i) {
    return Bt(
      [`hide-tail`],
      [
        new Fe([new Ie(e, ge(e, r, n))], {
          width: `400em`,
          height: A(t),
          viewBox: `0 0 400000 ` + n,
          preserveAspectRatio: `xMinYMin slice`,
        }),
      ],
      i,
    );
  },
  Nr = function (e, t) {
    var n = t.havingBaseSizing(),
      r = Ur(`\\surd`, e * n.sizeMultiplier, Vr, n),
      i = n.sizeMultiplier,
      a = Math.max(0, t.minRuleThickness - t.fontMetrics().sqrtRuleThickness),
      o,
      s,
      c,
      l,
      u;
    return (
      r.type === `small`
        ? ((l = 1e3 + 1e3 * a + Ar),
          e < 1 ? (i = 1) : e < 1.4 && (i = 0.7),
          (s = (1 + a + jr) / i),
          (c = (1 + a) / i),
          (o = Mr(`sqrtMain`, s, l, a, t)),
          (o.style.minWidth = `0.853em`),
          (u = 0.833 / i))
        : r.type === `large`
          ? ((l = (1e3 + Ar) * Lr[r.size]),
            (c = (Lr[r.size] + a) / i),
            (s = (Lr[r.size] + a + jr) / i),
            (o = Mr(`sqrtSize` + r.size, s, l, a, t)),
            (o.style.minWidth = `1.02em`),
            (u = 1 / i))
          : ((s = e + a + jr),
            (c = e + a),
            (l = Math.floor(1e3 * e + a) + Ar),
            (o = Mr(`sqrtTall`, s, l, a, t)),
            (o.style.minWidth = `0.742em`),
            (u = 1.056)),
      (o.height = c),
      (o.style.height = A(s)),
      {
        span: o,
        advanceWidth: u,
        ruleWidth: (t.fontMetrics().sqrtRuleThickness + a) * i,
      }
    );
  },
  Pr = new Set([
    `(`,
    `\\lparen`,
    `)`,
    `\\rparen`,
    `[`,
    `\\lbrack`,
    `]`,
    `\\rbrack`,
    `\\{`,
    `\\lbrace`,
    `\\}`,
    `\\rbrace`,
    `\\lfloor`,
    `\\rfloor`,
    `⌊`,
    `⌋`,
    `\\lceil`,
    `\\rceil`,
    `⌈`,
    `⌉`,
    `\\surd`,
  ]),
  Fr = new Set([
    `\\uparrow`,
    `\\downarrow`,
    `\\updownarrow`,
    `\\Uparrow`,
    `\\Downarrow`,
    `\\Updownarrow`,
    `|`,
    `\\|`,
    `\\vert`,
    `\\Vert`,
    `\\lvert`,
    `\\rvert`,
    `\\lVert`,
    `\\rVert`,
    `\\lgroup`,
    `\\rgroup`,
    `⟮`,
    `⟯`,
    `\\lmoustache`,
    `\\rmoustache`,
    `⎰`,
    `⎱`,
  ]),
  Ir = new Set([`<`, `>`, `\\langle`, `\\rangle`, `/`, `\\backslash`, `\\lt`, `\\gt`]),
  Lr = [0, 1.2, 1.8, 2.4, 3],
  Rr = function (t, n, r, i, a) {
    if (
      (t === `<` || t === `\\lt` || t === `⟨`
        ? (t = `\\langle`)
        : (t === `>` || t === `\\gt` || t === `⟩`) && (t = `\\rangle`),
      Pr.has(t) || Ir.has(t))
    )
      return Sr(t, n, !1, r, i, a);
    if (Fr.has(t)) return kr(t, Lr[n], !1, r, i, a);
    throw new e(`Illegal delimiter: '` + t + `'`);
  },
  zr = [
    {
      type: `small`,
      style: E.SCRIPTSCRIPT,
    },
    {
      type: `small`,
      style: E.SCRIPT,
    },
    {
      type: `small`,
      style: E.TEXT,
    },
    {
      type: `large`,
      size: 1,
    },
    {
      type: `large`,
      size: 2,
    },
    {
      type: `large`,
      size: 3,
    },
    {
      type: `large`,
      size: 4,
    },
  ],
  Br = [
    {
      type: `small`,
      style: E.SCRIPTSCRIPT,
    },
    {
      type: `small`,
      style: E.SCRIPT,
    },
    {
      type: `small`,
      style: E.TEXT,
    },
    {
      type: `stack`,
    },
  ],
  Vr = [
    {
      type: `small`,
      style: E.SCRIPTSCRIPT,
    },
    {
      type: `small`,
      style: E.SCRIPT,
    },
    {
      type: `small`,
      style: E.TEXT,
    },
    {
      type: `large`,
      size: 1,
    },
    {
      type: `large`,
      size: 2,
    },
    {
      type: `large`,
      size: 3,
    },
    {
      type: `large`,
      size: 4,
    },
    {
      type: `stack`,
    },
  ],
  Hr = function (e) {
    if (e.type === `small`) return `Main-Regular`;
    if (e.type === `large`) return `Size` + e.size + `-Regular`;
    if (e.type === `stack`) return `Size4-Regular`;
    var t = e.type;
    throw Error(`Add support for delim type '` + t + `' here.`);
  },
  Ur = function (e, t, n, r) {
    for (var i = Math.min(2, 3 - r.style.size); i < n.length; i++) {
      var a = n[i];
      if (a.type === `stack`) break;
      var o = _r(e, Hr(a), `math`),
        s = o.height + o.depth;
      if (a.type === `small`) {
        var c = r.havingBaseStyle(a.style);
        s *= c.sizeMultiplier;
      }
      if (s > t) return a;
    }
    return n[n.length - 1];
  },
  Wr = function (e, t, n, r, i, a) {
    e === `<` || e === `\\lt` || e === `⟨`
      ? (e = `\\langle`)
      : (e === `>` || e === `\\gt` || e === `⟩`) && (e = `\\rangle`);
    var o = Ir.has(e) ? zr : Pr.has(e) ? Vr : Br,
      s = Ur(e, t, o, r);
    return s.type === `small`
      ? br(e, s.style, n, r, i, a)
      : s.type === `large`
        ? Sr(e, s.size, n, r, i, a)
        : kr(e, t, n, r, i, a);
  },
  Gr = function (e, t, n, r, i, a) {
    var o = r.fontMetrics().axisHeight * r.sizeMultiplier,
      s = 901,
      c = 5 / r.fontMetrics().ptPerEm,
      l = Math.max(t - o, n + o);
    return Wr(e, Math.max((l / 500) * s, 2 * l - c), !0, r, i, a);
  },
  Kr = {
    "\\bigl": {
      mclass: `mopen`,
      size: 1,
    },
    "\\Bigl": {
      mclass: `mopen`,
      size: 2,
    },
    "\\biggl": {
      mclass: `mopen`,
      size: 3,
    },
    "\\Biggl": {
      mclass: `mopen`,
      size: 4,
    },
    "\\bigr": {
      mclass: `mclose`,
      size: 1,
    },
    "\\Bigr": {
      mclass: `mclose`,
      size: 2,
    },
    "\\biggr": {
      mclass: `mclose`,
      size: 3,
    },
    "\\Biggr": {
      mclass: `mclose`,
      size: 4,
    },
    "\\bigm": {
      mclass: `mrel`,
      size: 1,
    },
    "\\Bigm": {
      mclass: `mrel`,
      size: 2,
    },
    "\\biggm": {
      mclass: `mrel`,
      size: 3,
    },
    "\\Biggm": {
      mclass: `mrel`,
      size: 4,
    },
    "\\big": {
      mclass: `mord`,
      size: 1,
    },
    "\\Big": {
      mclass: `mord`,
      size: 2,
    },
    "\\bigg": {
      mclass: `mord`,
      size: 3,
    },
    "\\Bigg": {
      mclass: `mord`,
      size: 4,
    },
  },
  qr = new Set(
    `(,\\lparen,),\\rparen,[,\\lbrack,],\\rbrack,\\{,\\lbrace,\\},\\rbrace,\\lfloor,\\rfloor,⌊,⌋,\\lceil,\\rceil,⌈,⌉,<,>,\\langle,⟨,\\rangle,⟩,\\lt,\\gt,\\lvert,\\rvert,\\lVert,\\rVert,\\lgroup,\\rgroup,⟮,⟯,\\lmoustache,\\rmoustache,⎰,⎱,/,\\backslash,|,\\vert,\\|,\\Vert,\\uparrow,\\Uparrow,\\downarrow,\\Downarrow,\\updownarrow,\\Updownarrow,.`.split(
      `,`,
    ),
  );
function Jr(e) {
  return `isMiddle` in e;
}
function Yr(t, n) {
  var r = Qn(t);
  if (r && qr.has(r.text)) return r;
  throw r
    ? new e(`Invalid delimiter '` + r.text + `' after '` + n.funcName + `'`, t)
    : new e(`Invalid delimiter type '` + t.type + `'`, t);
}
K({
  type: `delimsizing`,
  names: [
    `\\bigl`,
    `\\Bigl`,
    `\\biggl`,
    `\\Biggl`,
    `\\bigr`,
    `\\Bigr`,
    `\\biggr`,
    `\\Biggr`,
    `\\bigm`,
    `\\Bigm`,
    `\\biggm`,
    `\\Biggm`,
    `\\big`,
    `\\Big`,
    `\\bigg`,
    `\\Bigg`,
  ],
  numArgs: 1,
  argTypes: [`primitive`],
  handler: (e, t) => {
    var n = Yr(t[0], e);
    return {
      type: `delimsizing`,
      mode: e.parser.mode,
      size: Kr[e.funcName].size,
      mclass: Kr[e.funcName].mclass,
      delim: n.text,
    };
  },
  htmlBuilder: (e, t) =>
    e.delim === `.` ? W([e.mclass]) : Rr(e.delim, e.size, t, e.mode, [e.mclass]),
  mathmlBuilder: (e) => {
    var t = [];
    e.delim !== `.` && t.push(En(e.delim, e.mode));
    var n = new J(`mo`, t);
    (e.mclass === `mopen` || e.mclass === `mclose`
      ? n.setAttribute(`fence`, `true`)
      : n.setAttribute(`fence`, `false`),
      n.setAttribute(`stretchy`, `true`));
    var r = A(Lr[e.size]);
    return (n.setAttribute(`minsize`, r), n.setAttribute(`maxsize`, r), n);
  },
});
function Xr(e) {
  if (!e.body) throw Error(`Bug: The leftright ParseNode wasn't fully parsed.`);
}
(K({
  type: `leftright-right`,
  names: [`\\right`],
  numArgs: 1,
  primitive: !0,
  handler: (t, n) => {
    var r = t.parser.gullet.macros.get(`\\current@color`);
    if (r && typeof r != `string`) throw new e(`\\current@color set to non-string in \\right`);
    return {
      type: `leftright-right`,
      mode: t.parser.mode,
      delim: Yr(n[0], t).text,
      color: r,
    };
  },
}),
  K({
    type: `leftright`,
    names: [`\\left`],
    numArgs: 1,
    primitive: !0,
    handler: (e, t) => {
      var n = Yr(t[0], e),
        r = e.parser;
      ++r.leftrightDepth;
      var i = r.parseExpression(!1);
      (--r.leftrightDepth, r.expect(`\\right`, !1));
      var a = X(r.parseFunction(), `leftright-right`);
      return {
        type: `leftright`,
        mode: r.mode,
        body: i,
        left: n.text,
        right: a.delim,
        rightColor: a.color,
      };
    },
    htmlBuilder: (e, t) => {
      Xr(e);
      for (
        var n = pn(e.body, t, !0, [`mopen`, `mclose`]), r = 0, i = 0, a = !1, o = 0;
        o < n.length;
        o++
      ) {
        var s = n[o];
        Jr(s) ? (a = !0) : ((r = Math.max(n[o].height, r)), (i = Math.max(n[o].depth, i)));
      }
      ((r *= t.sizeMultiplier), (i *= t.sizeMultiplier));
      var c = e.left === `.` ? vn(t, [`mopen`]) : Gr(e.left, r, i, t, e.mode, [`mopen`]);
      if ((n.unshift(c), a))
        for (var l = 1; l < n.length; l++) {
          var u = n[l];
          if (Jr(u)) {
            var d = u.isMiddle;
            n[l] = Gr(d.delim, r, i, d.options, e.mode, []);
          }
        }
      var f;
      if (e.right === `.`) f = vn(t, [`mclose`]);
      else {
        var p = e.rightColor ? t.withColor(e.rightColor) : t;
        f = Gr(e.right, r, i, p, e.mode, [`mclose`]);
      }
      return (n.push(f), W([`minner`], n, t));
    },
    mathmlBuilder: (e, t) => {
      Xr(e);
      var n = jn(e.body, t);
      if (e.left !== `.`) {
        var r = new J(`mo`, [En(e.left, e.mode)]);
        (r.setAttribute(`fence`, `true`), n.unshift(r));
      }
      if (e.right !== `.`) {
        var i = new J(`mo`, [En(e.right, e.mode)]);
        (i.setAttribute(`fence`, `true`),
          e.rightColor && i.setAttribute(`mathcolor`, e.rightColor),
          n.push(i));
      }
      return Dn(n);
    },
  }),
  K({
    type: `middle`,
    names: [`\\middle`],
    numArgs: 1,
    primitive: !0,
    handler: (t, n) => {
      var r = Yr(n[0], t);
      if (!t.parser.leftrightDepth) throw new e(`\\middle without preceding \\left`, r);
      return {
        type: `middle`,
        mode: t.parser.mode,
        delim: r.text,
      };
    },
    htmlBuilder: (e, t) => {
      var n;
      return (
        e.delim === `.`
          ? (n = vn(t, []))
          : ((n = Rr(e.delim, 1, t, e.mode, [])),
            (n.isMiddle = {
              delim: e.delim,
              options: t,
            })),
        n
      );
    },
    mathmlBuilder: (e, t) => {
      var n = new J(`mo`, [
        e.delim === `\\vert` || e.delim === `|` ? En(`|`, `text`) : En(e.delim, e.mode),
      ]);
      return (
        n.setAttribute(`fence`, `true`),
        n.setAttribute(`lspace`, `0.05em`),
        n.setAttribute(`rspace`, `0.05em`),
        n
      );
    },
  }),
  K({
    type: `enclose`,
    names: [`\\colorbox`],
    numArgs: 2,
    allowedInText: !0,
    argTypes: [`color`, `hbox`],
    handler(e, t, n) {
      var { parser: r, funcName: i } = e,
        a = X(t[0], `color-token`).color,
        o = t[1];
      return {
        type: `enclose`,
        mode: r.mode,
        label: i,
        backgroundColor: a,
        body: o,
      };
    },
    htmlBuilder: (e, t) => {
      var n = Wt(q(e.body, t), t),
        r = e.label.slice(1),
        i = t.sizeMultiplier,
        a,
        o,
        s = c(e.body);
      if (r === `sout`)
        ((a = W([`stretchy`, `sout`])),
          (a.height = t.fontMetrics().defaultRuleThickness / i),
          (o = -0.5 * t.fontMetrics().xHeight));
      else if (r === `phase`) {
        var l = k(
            {
              number: 0.6,
              unit: `pt`,
            },
            t,
          ),
          u = k(
            {
              number: 0.35,
              unit: `ex`,
            },
            t,
          ),
          d = t.havingBaseSizing();
        i /= d.sizeMultiplier;
        var f = n.height + n.depth + l + u;
        n.style.paddingLeft = A(f / 2 + l);
        var p = Math.floor(1e3 * f * i);
        ((a = Bt(
          [`hide-tail`],
          [
            new Fe([new Ie(`phase`, me(p))], {
              width: `400em`,
              height: A(p / 1e3),
              viewBox: `0 0 400000 ` + p,
              preserveAspectRatio: `xMinYMin slice`,
            }),
          ],
          t,
        )),
          (a.style.height = A(f)),
          (o = n.depth + l + u));
      } else {
        /cancel/.test(r)
          ? s || n.classes.push(`cancel-pad`)
          : r === `angl`
            ? n.classes.push(`anglpad`)
            : n.classes.push(`boxpad`);
        var m,
          h,
          g = 0;
        (/box/.test(r)
          ? ((g = Math.max(t.fontMetrics().fboxrule, t.minRuleThickness)),
            (m = t.fontMetrics().fboxsep + (r === `colorbox` ? 0 : g)),
            (h = m))
          : r === `angl`
            ? ((g = Math.max(t.fontMetrics().defaultRuleThickness, t.minRuleThickness)),
              (m = 4 * g),
              (h = Math.max(0, 0.25 - n.depth)))
            : ((m = s ? 0.2 : 0), (h = m)),
          (a = qn(n, r, m, h, t)),
          /fbox|boxed|fcolorbox/.test(r)
            ? ((a.style.borderStyle = `solid`), (a.style.borderWidth = A(g)))
            : r === `angl` &&
              g !== 0.049 &&
              ((a.style.borderTopWidth = A(g)), (a.style.borderRightWidth = A(g))),
          (o = n.depth + h),
          e.backgroundColor &&
            ((a.style.backgroundColor = e.backgroundColor),
            e.borderColor && (a.style.borderColor = e.borderColor)));
      }
      var _;
      if (e.backgroundColor)
        _ = G({
          positionType: `individualShift`,
          children: [
            {
              type: `elem`,
              elem: a,
              shift: o,
            },
            {
              type: `elem`,
              elem: n,
              shift: 0,
            },
          ],
        });
      else {
        var v = /cancel|phase/.test(r) ? [`svg-align`] : [];
        _ = G({
          positionType: `individualShift`,
          children: [
            {
              type: `elem`,
              elem: n,
              shift: 0,
            },
            {
              type: `elem`,
              elem: a,
              shift: o,
              wrapperClasses: v,
            },
          ],
        });
      }
      return (
        /cancel/.test(r) && ((_.height = n.height), (_.depth = n.depth)),
        /cancel/.test(r) && !s ? W([`mord`, `cancel-lap`], [_], t) : W([`mord`], [_], t)
      );
    },
    mathmlBuilder: (e, t) => {
      var n,
        r = new J(e.label.includes(`colorbox`) ? `mpadded` : `menclose`, [Y(e.body, t)]);
      switch (e.label) {
        case `\\cancel`:
          r.setAttribute(`notation`, `updiagonalstrike`);
          break;
        case `\\bcancel`:
          r.setAttribute(`notation`, `downdiagonalstrike`);
          break;
        case `\\phase`:
          r.setAttribute(`notation`, `phasorangle`);
          break;
        case `\\sout`:
          r.setAttribute(`notation`, `horizontalstrike`);
          break;
        case `\\fbox`:
          r.setAttribute(`notation`, `box`);
          break;
        case `\\angl`:
          r.setAttribute(`notation`, `actuarial`);
          break;
        case `\\fcolorbox`:
        case `\\colorbox`:
          if (
            ((n = t.fontMetrics().fboxsep * t.fontMetrics().ptPerEm),
            r.setAttribute(`width`, `+` + 2 * n + `pt`),
            r.setAttribute(`height`, `+` + 2 * n + `pt`),
            r.setAttribute(`lspace`, n + `pt`),
            r.setAttribute(`voffset`, n + `pt`),
            e.label === `\\fcolorbox`)
          ) {
            var i = Math.max(t.fontMetrics().fboxrule, t.minRuleThickness);
            r.setAttribute(`style`, `border: ` + A(i) + ` solid ` + e.borderColor);
          }
          break;
        case `\\xcancel`:
          r.setAttribute(`notation`, `updiagonalstrike downdiagonalstrike`);
          break;
      }
      return (e.backgroundColor && r.setAttribute(`mathbackground`, e.backgroundColor), r);
    },
  }),
  K({
    type: `enclose`,
    names: [`\\fcolorbox`],
    numArgs: 3,
    allowedInText: !0,
    argTypes: [`color`, `color`, `hbox`],
    handler(e, t, n) {
      var { parser: r, funcName: i } = e,
        a = X(t[0], `color-token`).color,
        o = X(t[1], `color-token`).color,
        s = t[2];
      return {
        type: `enclose`,
        mode: r.mode,
        label: i,
        backgroundColor: o,
        borderColor: a,
        body: s,
      };
    },
  }),
  K({
    type: `enclose`,
    names: [`\\fbox`],
    numArgs: 1,
    argTypes: [`hbox`],
    allowedInText: !0,
    handler(e, t) {
      var { parser: n } = e;
      return {
        type: `enclose`,
        mode: n.mode,
        label: `\\fbox`,
        body: t[0],
      };
    },
  }),
  K({
    type: `enclose`,
    names: [`\\cancel`, `\\bcancel`, `\\xcancel`, `\\phase`],
    numArgs: 1,
    handler(e, t) {
      var { parser: n, funcName: r } = e,
        i = t[0];
      return {
        type: `enclose`,
        mode: n.mode,
        label: r,
        body: i,
      };
    },
  }),
  K({
    type: `enclose`,
    names: [`\\sout`],
    numArgs: 1,
    allowedInText: !0,
    handler(e, t) {
      var { parser: n, funcName: r } = e;
      n.mode === `math` &&
        n.settings.reportNonstrict(`mathVsSout`, `LaTeX's \\sout works only in text mode`);
      var i = t[0];
      return {
        type: `enclose`,
        mode: n.mode,
        label: r,
        body: i,
      };
    },
  }),
  K({
    type: `enclose`,
    names: [`\\angl`],
    numArgs: 1,
    argTypes: [`hbox`],
    allowedInText: !1,
    handler(e, t) {
      var { parser: n } = e;
      return {
        type: `enclose`,
        mode: n.mode,
        label: `\\angl`,
        body: t[0],
      };
    },
  }));
var Zr = {};
function Qr(e) {
  for (
    var { type: t, names: n, props: r, handler: i, htmlBuilder: a, mathmlBuilder: o } = e,
      s = {
        type: t,
        numArgs: r.numArgs || 0,
        allowedInText: !1,
        numOptionalArgs: 0,
        handler: i,
      },
      c = 0;
    c < n.length;
    ++c
  )
    Zr[n[c]] = s;
  (a && (rn[t] = a), o && (an[t] = o));
}
var $r = {};
function Z(e, t) {
  $r[e] = t;
}
var ei = class e {
    constructor(e, t, n) {
      ((this.lexer = void 0),
        (this.start = void 0),
        (this.end = void 0),
        (this.lexer = e),
        (this.start = t),
        (this.end = n));
    }
    static range(t, n) {
      return n
        ? !t || !t.loc || !n.loc || t.loc.lexer !== n.loc.lexer
          ? null
          : new e(t.loc.lexer, t.loc.start, n.loc.end)
        : t && t.loc;
    }
  },
  ti = class e {
    constructor(e, t) {
      ((this.text = void 0),
        (this.loc = void 0),
        (this.noexpand = void 0),
        (this.treatAsRelax = void 0),
        (this.text = e),
        (this.loc = t));
    }
    range(t, n) {
      return new e(n, ei.range(this, t));
    }
  };
function ni(e) {
  var t = [];
  e.consumeSpaces();
  var n = e.fetch().text;
  for (
    n === `\\relax` && (e.consume(), e.consumeSpaces(), (n = e.fetch().text));
    n === `\\hline` || n === `\\hdashline`;
  )
    (e.consume(), t.push(n === `\\hdashline`), e.consumeSpaces(), (n = e.fetch().text));
  return t;
}
var ri = (t) => {
    if (!t.parser.settings.displayMode)
      throw new e(`{` + t.envName + `} can be used only in display mode.`);
  },
  ii = new Set([`gather`, `gather*`]);
function ai(e) {
  if (!e.includes(`ed`)) return !e.includes(`*`);
}
function oi(t, n, r) {
  var {
    hskipBeforeAndAfter: i,
    addJot: a,
    cols: o,
    arraystretch: s,
    colSeparationType: c,
    autoTag: l,
    singleRow: u,
    emptySingleRow: d,
    maxNumCols: f,
    leqno: p,
  } = n;
  if ((t.gullet.beginGroup(), u || t.gullet.macros.set(`\\cr`, `\\\\\\relax`), !s)) {
    var m = t.gullet.expandMacroAsText(`\\arraystretch`);
    if (m == null) s = 1;
    else if (((s = parseFloat(m)), !s || s < 0)) throw new e(`Invalid \\arraystretch: ` + m);
  }
  t.gullet.beginGroup();
  var h = [],
    g = [h],
    _ = [],
    v = [],
    y = l == null ? void 0 : [];
  function b() {
    l && t.gullet.macros.set(`\\@eqnsw`, `1`, !0);
  }
  function x() {
    y &&
      (t.gullet.macros.get(`\\df@tag`)
        ? (y.push(t.subparse([new ti(`\\df@tag`)])), t.gullet.macros.set(`\\df@tag`, void 0, !0))
        : y.push(!!l && t.gullet.macros.get(`\\@eqnsw`) === `1`));
  }
  for (b(), v.push(ni(t)); ;) {
    var S = t.parseExpression(!1, u ? `\\end` : `\\\\`);
    (t.gullet.endGroup(), t.gullet.beginGroup());
    var C = {
      type: `ordgroup`,
      mode: t.mode,
      body: S,
    };
    (r &&
      (C = {
        type: `styling`,
        mode: t.mode,
        style: r,
        resetFont: !0,
        body: [C],
      }),
      h.push(C));
    var w = t.fetch().text;
    if (w === `&`) {
      if (f && h.length === f) {
        if (u || c) throw new e(`Too many tab characters: &`, t.nextToken);
        t.settings.reportNonstrict(
          `textEnv`,
          `Too few columns specified in the {array} column argument.`,
        );
      }
      t.consume();
    } else if (w === `\\end`) {
      (x(),
        h.length === 1 &&
          C.type === `styling` &&
          C.body.length === 1 &&
          C.body[0].type === `ordgroup` &&
          C.body[0].body.length === 0 &&
          (g.length > 1 || !d) &&
          g.pop(),
        v.length < g.length + 1 && v.push([]));
      break;
    } else if (w === `\\\\`) {
      t.consume();
      var ee = void 0;
      (t.gullet.future().text !== ` ` && (ee = t.parseSizeGroup(!0)),
        _.push(ee ? ee.value : null),
        x(),
        v.push(ni(t)),
        (h = []),
        g.push(h),
        b());
    } else throw new e(`Expected & or \\\\ or \\cr or \\end`, t.nextToken);
  }
  return (
    t.gullet.endGroup(),
    t.gullet.endGroup(),
    {
      type: `array`,
      mode: t.mode,
      addJot: a,
      arraystretch: s,
      body: g,
      cols: o,
      rowGaps: _,
      hskipBeforeAndAfter: i,
      hLinesBeforeRow: v,
      colSeparationType: c,
      tags: y,
      leqno: p,
    }
  );
}
function si(e) {
  return e.slice(0, 1) === `d` ? `display` : `text`;
}
var ci = function (t, n) {
    var r,
      i,
      a = t.body.length,
      o = t.hLinesBeforeRow,
      s = 0,
      c = Array(a),
      l = [],
      u = Math.max(n.fontMetrics().arrayRuleWidth, n.minRuleThickness),
      d = 1 / n.fontMetrics().ptPerEm,
      f = 5 * d;
    t.colSeparationType &&
      t.colSeparationType === `small` &&
      (f = 0.2778 * (n.havingStyle(E.SCRIPT).sizeMultiplier / n.sizeMultiplier));
    var p =
        t.colSeparationType === `CD`
          ? k(
              {
                number: 3,
                unit: `ex`,
              },
              n,
            )
          : 12 * d,
      m = 3 * d,
      h = t.arraystretch * p,
      g = 0.7 * h,
      _ = 0.3 * h,
      v = 0;
    function y(e) {
      for (var t = 0; t < e.length; ++t)
        (t > 0 && (v += 0.25),
          l.push({
            pos: v,
            isDashed: e[t],
          }));
    }
    for (y(o[0]), r = 0; r < t.body.length; ++r) {
      var b = t.body[r],
        x = g,
        S = _;
      s < b.length && (s = b.length);
      var C = {
        cells: Array(b.length),
        height: 0,
        depth: 0,
        pos: 0,
      };
      for (i = 0; i < b.length; ++i) {
        var w = q(b[i], n);
        (S < w.depth && (S = w.depth), x < w.height && (x = w.height), (C.cells[i] = w));
      }
      var ee = t.rowGaps[r],
        T = 0;
      (ee && ((T = k(ee, n)), T > 0 && ((T += _), S < T && (S = T), (T = 0))),
        t.addJot && r < t.body.length - 1 && (S += m),
        (C.height = x),
        (C.depth = S),
        (v += x),
        (C.pos = v),
        (v += S + T),
        (c[r] = C),
        y(o[r + 1]));
    }
    var te = v / 2 + n.fontMetrics().axisHeight,
      ne = t.cols || [],
      re = [],
      ie,
      ae,
      oe = [];
    if (t.tags && t.tags.some((e) => e))
      for (r = 0; r < a; ++r) {
        var se = c[r],
          ce = se.pos - te,
          D = t.tags[r],
          le = void 0;
        ((le = D === !0 ? W([`eqn-num`], [], n) : D === !1 ? W([], [], n) : W([], pn(D, n, !0), n)),
          (le.depth = se.depth),
          (le.height = se.height),
          oe.push({
            type: `elem`,
            elem: le,
            shift: ce,
          }));
      }
    for (i = 0, ae = 0; i < s || ae < ne.length; ++i, ++ae) {
      for (var ue = ne[ae], de = !0; (fe = ue)?.type === `separator`;) {
        var fe;
        if (
          (de ||
            ((ie = W([`arraycolsep`], [])),
            (ie.style.width = A(n.fontMetrics().doubleRuleSep)),
            re.push(ie)),
          ue.separator === `|` || ue.separator === `:`)
        ) {
          var pe = ue.separator === `|` ? `solid` : `dashed`,
            O = W([`vertical-separator`], [], n);
          ((O.style.height = A(v)),
            (O.style.borderRightWidth = A(u)),
            (O.style.borderRightStyle = pe),
            (O.style.margin = `0 ` + A(-u / 2)));
          var me = v - te;
          (me && (O.style.verticalAlign = A(-me)), re.push(O));
        } else throw new e(`Invalid separator type: ` + ue.separator);
        (ae++, (ue = ne[ae]), (de = !1));
      }
      if (!(i >= s)) {
        var he = void 0;
        (i > 0 || t.hskipBeforeAndAfter) &&
          ((he = ue?.pregap ?? f),
          he !== 0 && ((ie = W([`arraycolsep`], [])), (ie.style.width = A(he)), re.push(ie)));
        var ge = [];
        for (r = 0; r < a; ++r) {
          var _e = c[r],
            ve = _e.cells[i];
          if (ve) {
            var ye = _e.pos - te;
            ((ve.depth = _e.depth),
              (ve.height = _e.height),
              ge.push({
                type: `elem`,
                elem: ve,
                shift: ye,
              }));
          }
        }
        var be = G({
            positionType: `individualShift`,
            children: ge,
          }),
          xe = W([`col-align-` + (ue?.align || `c`)], [be]);
        (re.push(xe),
          (i < s - 1 || t.hskipBeforeAndAfter) &&
            ((he = ue?.postgap ?? f),
            he !== 0 && ((ie = W([`arraycolsep`], [])), (ie.style.width = A(he)), re.push(ie))));
      }
    }
    var Se = W([`mtable`], re);
    if (l.length > 0) {
      for (
        var Ce = Vt(`hline`, n, u),
          we = Vt(`hdashline`, n, u),
          j = [
            {
              type: `elem`,
              elem: Se,
              shift: 0,
            },
          ];
        l.length > 0;
      ) {
        var Te = l.pop(),
          Ee = Te.pos - te;
        Te.isDashed
          ? j.push({
              type: `elem`,
              elem: we,
              shift: Ee,
            })
          : j.push({
              type: `elem`,
              elem: Ce,
              shift: Ee,
            });
      }
      Se = G({
        positionType: `individualShift`,
        children: j,
      });
    }
    if (oe.length === 0) return W([`mord`], [Se], n);
    var De = W(
      [`tag`],
      [
        G({
          positionType: `individualShift`,
          children: oe,
        }),
      ],
      n,
    );
    return Ut([Se, De]);
  },
  li = {
    c: `center `,
    l: `left `,
    r: `right `,
  },
  ui = function (e, t) {
    for (
      var n = [], r = new J(`mtd`, [], [`mtr-glue`]), i = new J(`mtd`, [], [`mml-eqn-num`]), a = 0;
      a < e.body.length;
      a++
    ) {
      for (var o = e.body[a], s = [], c = 0; c < o.length; c++) s.push(new J(`mtd`, [Y(o[c], t)]));
      (e.tags && e.tags[a] && (s.unshift(r), s.push(r), e.leqno ? s.unshift(i) : s.push(i)),
        n.push(new J(`mtr`, s)));
    }
    var l = new J(`mtable`, n),
      u = e.arraystretch === 0.5 ? 0.1 : 0.16 + e.arraystretch - 1 + (e.addJot ? 0.09 : 0);
    l.setAttribute(`rowspacing`, A(u));
    var d = ``,
      f = ``;
    if (e.cols && e.cols.length > 0) {
      var p = e.cols,
        m = ``,
        h = !1,
        g = 0,
        _ = p.length;
      (p[0].type === `separator` && ((d += `top `), (g = 1)),
        p[p.length - 1].type === `separator` && ((d += `bottom `), --_));
      for (var v = g; v < _; v++) {
        var y = p[v];
        y.type === `align`
          ? ((f += li[y.align]), h && (m += `none `), (h = !0))
          : y.type === `separator` &&
            (h &&= ((m += y.separator === `|` ? `solid ` : `dashed `), !1));
      }
      (l.setAttribute(`columnalign`, f.trim()),
        /[sd]/.test(m) && l.setAttribute(`columnlines`, m.trim()));
    }
    if (e.colSeparationType === `align`) {
      for (var b = e.cols || [], x = ``, S = 1; S < b.length; S++) x += S % 2 ? `0em ` : `1em `;
      l.setAttribute(`columnspacing`, x.trim());
    } else
      e.colSeparationType === `alignat` || e.colSeparationType === `gather`
        ? l.setAttribute(`columnspacing`, `0em`)
        : e.colSeparationType === `small`
          ? l.setAttribute(`columnspacing`, `0.2778em`)
          : e.colSeparationType === `CD`
            ? l.setAttribute(`columnspacing`, `0.5em`)
            : l.setAttribute(`columnspacing`, `1em`);
    var C = ``,
      w = e.hLinesBeforeRow;
    ((d += w[0].length > 0 ? `left ` : ``), (d += w[w.length - 1].length > 0 ? `right ` : ``));
    for (var ee = 1; ee < w.length - 1; ee++)
      C += w[ee].length === 0 ? `none ` : w[ee][0] ? `dashed ` : `solid `;
    return (
      /[sd]/.test(C) && l.setAttribute(`rowlines`, C.trim()),
      d !== `` && ((l = new J(`menclose`, [l])), l.setAttribute(`notation`, d.trim())),
      e.arraystretch &&
        e.arraystretch < 1 &&
        ((l = new J(`mstyle`, [l])), l.setAttribute(`scriptlevel`, `1`)),
      l
    );
  },
  di = function (t, n) {
    t.envName.includes(`ed`) || ri(t);
    var r = [],
      i = t.envName === `split`,
      a = oi(
        t.parser,
        {
          cols: r,
          addJot: !0,
          autoTag: i ? void 0 : ai(t.envName),
          emptySingleRow: !0,
          colSeparationType: t.envName.includes(`at`) ? `alignat` : `align`,
          maxNumCols: i ? 2 : void 0,
          leqno: t.parser.settings.leqno,
        },
        `display`,
      ),
      o = 0,
      s = 0,
      c = {
        type: `ordgroup`,
        mode: t.mode,
        body: [],
      };
    if (n[0] && n[0].type === `ordgroup`) {
      for (var l = ``, u = 0; u < n[0].body.length; u++) {
        var d = X(n[0].body[u], `textord`);
        l += d.text;
      }
      ((o = Number(l)), (s = o * 2));
    }
    var f = !s;
    a.body.forEach(function (t) {
      for (var n = 1; n < t.length; n += 2)
        X(X(t[n], `styling`).body[0], `ordgroup`).body.unshift(c);
      if (f) s < t.length && (s = t.length);
      else {
        var r = t.length / 2;
        if (o < r)
          throw new e(`Too many math in a row: ` + (`expected ` + o + `, but got ` + r), t[0]);
      }
    });
    for (var p = 0; p < s; ++p) {
      var m = `r`,
        h = 0;
      (p % 2 == 1 ? (m = `l`) : p > 0 && f && (h = 1),
        (r[p] = {
          type: `align`,
          align: m,
          pregap: h,
          postgap: 0,
        }));
    }
    return ((a.colSeparationType = f ? `align` : `alignat`), a);
  };
(Qr({
  type: `array`,
  names: [`array`, `darray`],
  props: {
    numArgs: 1,
  },
  handler(t, n) {
    var r = (Qn(n[0]) ? [n[0]] : X(n[0], `ordgroup`).body).map(function (t) {
        var n = Zn(t).text;
        if (`lcr`.includes(n))
          return {
            type: `align`,
            align: n,
          };
        if (n === `|`)
          return {
            type: `separator`,
            separator: `|`,
          };
        if (n === `:`)
          return {
            type: `separator`,
            separator: `:`,
          };
        throw new e(`Unknown column alignment: ` + n, t);
      }),
      i = {
        cols: r,
        hskipBeforeAndAfter: !0,
        maxNumCols: r.length,
      };
    return oi(t.parser, i, si(t.envName));
  },
  htmlBuilder: ci,
  mathmlBuilder: ui,
}),
  Qr({
    type: `array`,
    names: [
      `matrix`,
      `pmatrix`,
      `bmatrix`,
      `Bmatrix`,
      `vmatrix`,
      `Vmatrix`,
      `matrix*`,
      `pmatrix*`,
      `bmatrix*`,
      `Bmatrix*`,
      `vmatrix*`,
      `Vmatrix*`,
    ],
    props: {
      numArgs: 0,
    },
    handler(t) {
      var n = {
          matrix: null,
          pmatrix: [`(`, `)`],
          bmatrix: [`[`, `]`],
          Bmatrix: [`\\{`, `\\}`],
          vmatrix: [`|`, `|`],
          Vmatrix: [`\\Vert`, `\\Vert`],
        }[t.envName.replace(`*`, ``)],
        r = `c`,
        i = {
          hskipBeforeAndAfter: !1,
          cols: [
            {
              type: `align`,
              align: r,
            },
          ],
        };
      if (t.envName.charAt(t.envName.length - 1) === `*`) {
        var a = t.parser;
        if ((a.consumeSpaces(), a.fetch().text === `[`)) {
          if ((a.consume(), a.consumeSpaces(), (r = a.fetch().text), !`lcr`.includes(r)))
            throw new e(`Expected l or c or r`, a.nextToken);
          (a.consume(),
            a.consumeSpaces(),
            a.expect(`]`),
            a.consume(),
            (i.cols = [
              {
                type: `align`,
                align: r,
              },
            ]));
        }
      }
      var o = oi(t.parser, i, si(t.envName)),
        s = Math.max(0, ...o.body.map((e) => e.length));
      return (
        (o.cols = Array(s).fill({
          type: `align`,
          align: r,
        })),
        n
          ? {
              type: `leftright`,
              mode: t.mode,
              body: [o],
              left: n[0],
              right: n[1],
              rightColor: void 0,
            }
          : o
      );
    },
    htmlBuilder: ci,
    mathmlBuilder: ui,
  }),
  Qr({
    type: `array`,
    names: [`smallmatrix`],
    props: {
      numArgs: 0,
    },
    handler(e) {
      var t = oi(
        e.parser,
        {
          arraystretch: 0.5,
        },
        `script`,
      );
      return ((t.colSeparationType = `small`), t);
    },
    htmlBuilder: ci,
    mathmlBuilder: ui,
  }),
  Qr({
    type: `array`,
    names: [`subarray`],
    props: {
      numArgs: 1,
    },
    handler(t, n) {
      var r = (Qn(n[0]) ? [n[0]] : X(n[0], `ordgroup`).body).map(function (t) {
        var n = Zn(t).text;
        if (`lc`.includes(n))
          return {
            type: `align`,
            align: n,
          };
        throw new e(`Unknown column alignment: ` + n, t);
      });
      if (r.length > 1) throw new e(`{subarray} can contain only one column`);
      var i = {
          cols: r,
          hskipBeforeAndAfter: !1,
          arraystretch: 0.5,
        },
        a = oi(t.parser, i, `script`);
      if (a.body.length > 0 && a.body[0].length > 1)
        throw new e(`{subarray} can contain only one column`);
      return a;
    },
    htmlBuilder: ci,
    mathmlBuilder: ui,
  }),
  Qr({
    type: `array`,
    names: [`cases`, `dcases`, `rcases`, `drcases`],
    props: {
      numArgs: 0,
    },
    handler(e) {
      var t = oi(
        e.parser,
        {
          arraystretch: 1.2,
          cols: [
            {
              type: `align`,
              align: `l`,
              pregap: 0,
              postgap: 1,
            },
            {
              type: `align`,
              align: `l`,
              pregap: 0,
              postgap: 0,
            },
          ],
        },
        si(e.envName),
      );
      return {
        type: `leftright`,
        mode: e.mode,
        body: [t],
        left: e.envName.includes(`r`) ? `.` : `\\{`,
        right: e.envName.includes(`r`) ? `\\}` : `.`,
        rightColor: void 0,
      };
    },
    htmlBuilder: ci,
    mathmlBuilder: ui,
  }),
  Qr({
    type: `array`,
    names: [`align`, `align*`, `aligned`, `split`],
    props: {
      numArgs: 0,
    },
    handler: di,
    htmlBuilder: ci,
    mathmlBuilder: ui,
  }),
  Qr({
    type: `array`,
    names: [`gathered`, `gather`, `gather*`],
    props: {
      numArgs: 0,
    },
    handler(e) {
      ii.has(e.envName) && ri(e);
      var t = {
        cols: [
          {
            type: `align`,
            align: `c`,
          },
        ],
        addJot: !0,
        colSeparationType: `gather`,
        autoTag: ai(e.envName),
        emptySingleRow: !0,
        leqno: e.parser.settings.leqno,
      };
      return oi(e.parser, t, `display`);
    },
    htmlBuilder: ci,
    mathmlBuilder: ui,
  }),
  Qr({
    type: `array`,
    names: [`alignat`, `alignat*`, `alignedat`],
    props: {
      numArgs: 1,
    },
    handler: di,
    htmlBuilder: ci,
    mathmlBuilder: ui,
  }),
  Qr({
    type: `array`,
    names: [`equation`, `equation*`],
    props: {
      numArgs: 0,
    },
    handler(e) {
      ri(e);
      var t = {
        autoTag: ai(e.envName),
        emptySingleRow: !0,
        singleRow: !0,
        maxNumCols: 1,
        leqno: e.parser.settings.leqno,
      };
      return oi(e.parser, t, `display`);
    },
    htmlBuilder: ci,
    mathmlBuilder: ui,
  }),
  Qr({
    type: `array`,
    names: [`CD`],
    props: {
      numArgs: 0,
    },
    handler(e) {
      return (ri(e), fr(e.parser));
    },
    htmlBuilder: ci,
    mathmlBuilder: ui,
  }),
  Z(`\\nonumber`, `\\gdef\\@eqnsw{0}`),
  Z(`\\notag`, `\\nonumber`),
  K({
    type: `text`,
    names: [`\\hline`, `\\hdashline`],
    numArgs: 0,
    allowedInText: !0,
    allowedInMath: !0,
    handler(t, n) {
      throw new e(t.funcName + ` valid only within array environment`);
    },
  }));
var fi = Zr;
K({
  type: `environment`,
  names: [`\\begin`, `\\end`],
  numArgs: 1,
  argTypes: [`text`],
  handler(t, n) {
    var { parser: r, funcName: i } = t,
      a = n[0];
    if (a.type !== `ordgroup`) throw new e(`Invalid environment name`, a);
    for (var o = ``, s = 0; s < a.body.length; ++s) o += X(a.body[s], `textord`).text;
    if (i === `\\begin`) {
      if (!fi.hasOwnProperty(o)) throw new e(`No such environment: ` + o, a);
      var c = fi[o],
        { args: l, optArgs: u } = r.parseArguments(`\\begin{` + o + `}`, c),
        d = {
          mode: r.mode,
          envName: o,
          parser: r,
        },
        f = c.handler(d, l, u);
      r.expect(`\\end`, !1);
      var p = r.nextToken,
        m = X(r.parseFunction(), `environment`);
      if (m.name !== o)
        throw new e(`Mismatch: \\begin{` + o + `} matched by \\end{` + m.name + `}`, p);
      return f;
    }
    return {
      type: `environment`,
      mode: r.mode,
      name: o,
      nameGroup: a,
    };
  },
});
var pi = (e, t) => {
    var n = e.font,
      r = t.withFont(n);
    return q(e.body, r);
  },
  mi = (e, t) => {
    var n = e.font,
      r = t.withFont(n);
    return Y(e.body, r);
  },
  hi = {
    "\\Bbb": `\\mathbb`,
    "\\bold": `\\mathbf`,
    "\\frak": `\\mathfrak`,
  };
(K({
  type: `font`,
  names: [
    `\\mathrm`,
    `\\mathit`,
    `\\mathbf`,
    `\\mathnormal`,
    `\\mathsfit`,
    `\\mathbb`,
    `\\mathcal`,
    `\\mathfrak`,
    `\\mathscr`,
    `\\mathsf`,
    `\\mathtt`,
    `\\Bbb`,
    `\\bold`,
    `\\frak`,
  ],
  numArgs: 1,
  allowedInArgument: !0,
  handler: (e, t) => {
    var { parser: n, funcName: r } = e,
      i = sn(t[0]),
      a = r in hi ? hi[r] : r;
    return {
      type: `font`,
      mode: n.mode,
      font: a.slice(1),
      body: i,
    };
  },
  htmlBuilder: pi,
  mathmlBuilder: mi,
}),
  K({
    type: `mclass`,
    names: [`\\boldsymbol`, `\\bm`],
    numArgs: 1,
    handler: (e, t) => {
      var { parser: n } = e,
        r = t[0];
      return {
        type: `mclass`,
        mode: n.mode,
        mclass: or(r),
        body: [
          {
            type: `font`,
            mode: n.mode,
            font: `boldsymbol`,
            body: r,
          },
        ],
        isCharacterBox: c(r),
      };
    },
  }),
  K({
    type: `font`,
    names: [`\\rm`, `\\sf`, `\\tt`, `\\bf`, `\\it`, `\\cal`],
    numArgs: 0,
    allowedInText: !0,
    handler: (e, t) => {
      var { parser: n, funcName: r, breakOnTokenText: i } = e,
        { mode: a } = n,
        o = n.parseExpression(!0, i);
      return {
        type: `font`,
        mode: a,
        font: `math` + r.slice(1),
        body: {
          type: `ordgroup`,
          mode: n.mode,
          body: o,
        },
      };
    },
  }));
var gi = (e, t) => {
    var n = t.style,
      r = n.fracNum(),
      i = n.fracDen(),
      a = t.havingStyle(r),
      o = q(e.numer, a, t);
    if (e.continued) {
      var s = 8.5 / t.fontMetrics().ptPerEm,
        c = 3.5 / t.fontMetrics().ptPerEm;
      ((o.height = o.height < s ? s : o.height), (o.depth = o.depth < c ? c : o.depth));
    }
    a = t.havingStyle(i);
    var l = q(e.denom, a, t),
      u,
      d,
      f;
    e.hasBarLine
      ? (e.barSize
          ? ((d = k(e.barSize, t)), (u = Vt(`frac-line`, t, d)))
          : (u = Vt(`frac-line`, t)),
        (d = u.height),
        (f = u.height))
      : ((u = null), (d = 0), (f = t.fontMetrics().defaultRuleThickness));
    var p, m, h;
    n.size === E.DISPLAY.size
      ? ((p = t.fontMetrics().num1), (m = d > 0 ? 3 * f : 7 * f), (h = t.fontMetrics().denom1))
      : (d > 0 ? ((p = t.fontMetrics().num2), (m = f)) : ((p = t.fontMetrics().num3), (m = 3 * f)),
        (h = t.fontMetrics().denom2));
    var g;
    if (u) {
      var _ = t.fontMetrics().axisHeight;
      (p - o.depth - (_ + 0.5 * d) < m && (p += m - (p - o.depth - (_ + 0.5 * d))),
        _ - 0.5 * d - (l.height - h) < m && (h += m - (_ - 0.5 * d - (l.height - h))));
      var v = -(_ - 0.5 * d);
      g = G({
        positionType: `individualShift`,
        children: [
          {
            type: `elem`,
            elem: l,
            shift: h,
          },
          {
            type: `elem`,
            elem: u,
            shift: v,
          },
          {
            type: `elem`,
            elem: o,
            shift: -p,
          },
        ],
      });
    } else {
      var y = p - o.depth - (l.height - h);
      (y < m && ((p += 0.5 * (m - y)), (h += 0.5 * (m - y))),
        (g = G({
          positionType: `individualShift`,
          children: [
            {
              type: `elem`,
              elem: l,
              shift: h,
            },
            {
              type: `elem`,
              elem: o,
              shift: -p,
            },
          ],
        })));
    }
    ((a = t.havingStyle(n)),
      (g.height *= a.sizeMultiplier / t.sizeMultiplier),
      (g.depth *= a.sizeMultiplier / t.sizeMultiplier));
    var b =
        n.size === E.DISPLAY.size
          ? t.fontMetrics().delim1
          : n.size === E.SCRIPTSCRIPT.size
            ? t.havingStyle(E.SCRIPT).fontMetrics().delim2
            : t.fontMetrics().delim2,
      x =
        e.leftDelim == null
          ? vn(t, [`mopen`])
          : Wr(e.leftDelim, b, !0, t.havingStyle(n), e.mode, [`mopen`]),
      S = e.continued
        ? W([])
        : e.rightDelim == null
          ? vn(t, [`mclose`])
          : Wr(e.rightDelim, b, !0, t.havingStyle(n), e.mode, [`mclose`]);
    return W([`mord`].concat(a.sizingClasses(t)), [x, W([`mfrac`], [g]), S], t);
  },
  _i = (e, t) => {
    var n = new J(`mfrac`, [Y(e.numer, t), Y(e.denom, t)]);
    if (!e.hasBarLine) n.setAttribute(`linethickness`, `0px`);
    else if (e.barSize) {
      var r = k(e.barSize, t);
      n.setAttribute(`linethickness`, A(r));
    }
    if (e.leftDelim != null || e.rightDelim != null) {
      var i = [];
      if (e.leftDelim != null) {
        var a = new J(`mo`, [new Sn(e.leftDelim.replace(`\\`, ``))]);
        (a.setAttribute(`fence`, `true`), i.push(a));
      }
      if ((i.push(n), e.rightDelim != null)) {
        var o = new J(`mo`, [new Sn(e.rightDelim.replace(`\\`, ``))]);
        (o.setAttribute(`fence`, `true`), i.push(o));
      }
      return Dn(i);
    }
    return n;
  },
  vi = (e, t) =>
    t
      ? {
          type: `styling`,
          mode: e.mode,
          style: t,
          body: [e],
        }
      : e;
(K({
  type: `genfrac`,
  names: [
    `\\cfrac`,
    `\\dfrac`,
    `\\frac`,
    `\\tfrac`,
    `\\dbinom`,
    `\\binom`,
    `\\tbinom`,
    `\\\\atopfrac`,
    `\\\\bracefrac`,
    `\\\\brackfrac`,
  ],
  numArgs: 2,
  allowedInArgument: !0,
  handler: (e, t) => {
    var { parser: n, funcName: r } = e,
      i = t[0],
      a = t[1],
      o,
      s = null,
      c = null;
    switch (r) {
      case `\\cfrac`:
      case `\\dfrac`:
      case `\\frac`:
      case `\\tfrac`:
        o = !0;
        break;
      case `\\\\atopfrac`:
        o = !1;
        break;
      case `\\dbinom`:
      case `\\binom`:
      case `\\tbinom`:
        ((o = !1), (s = `(`), (c = `)`));
        break;
      case `\\\\bracefrac`:
        ((o = !1), (s = `\\{`), (c = `\\}`));
        break;
      case `\\\\brackfrac`:
        ((o = !1), (s = `[`), (c = `]`));
        break;
      default:
        throw Error(`Unrecognized genfrac command`);
    }
    var l = r === `\\cfrac`,
      u = null;
    return (
      l || r.startsWith(`\\d`) ? (u = `display`) : r.startsWith(`\\t`) && (u = `text`),
      vi(
        {
          type: `genfrac`,
          mode: n.mode,
          numer: i,
          denom: a,
          continued: l,
          hasBarLine: o,
          leftDelim: s,
          rightDelim: c,
          barSize: null,
        },
        u,
      )
    );
  },
  htmlBuilder: gi,
  mathmlBuilder: _i,
}),
  K({
    type: `infix`,
    names: [`\\over`, `\\choose`, `\\atop`, `\\brace`, `\\brack`],
    numArgs: 0,
    infix: !0,
    handler(e) {
      var { parser: t, funcName: n, token: r } = e,
        i;
      switch (n) {
        case `\\over`:
          i = `\\frac`;
          break;
        case `\\choose`:
          i = `\\binom`;
          break;
        case `\\atop`:
          i = `\\\\atopfrac`;
          break;
        case `\\brace`:
          i = `\\\\bracefrac`;
          break;
        case `\\brack`:
          i = `\\\\brackfrac`;
          break;
        default:
          throw Error(`Unrecognized infix genfrac command`);
      }
      return {
        type: `infix`,
        mode: t.mode,
        replaceWith: i,
        token: r,
      };
    },
  }));
var yi = [`display`, `text`, `script`, `scriptscript`],
  bi = function (e) {
    var t = null;
    return (e.length > 0 && ((t = e), (t = t === `.` ? null : t)), t);
  };
(K({
  type: `genfrac`,
  names: [`\\genfrac`],
  numArgs: 6,
  allowedInArgument: !0,
  argTypes: [`math`, `math`, `size`, `text`, `math`, `math`],
  handler(e, t) {
    var { parser: n } = e,
      r = t[4],
      i = t[5],
      a = sn(t[0]),
      o = a.type === `atom` && a.family === `open` ? bi(a.text) : null,
      s = sn(t[1]),
      c = s.type === `atom` && s.family === `close` ? bi(s.text) : null,
      l = X(t[2], `size`),
      u,
      d = null;
    l.isBlank ? (u = !0) : ((d = l.value), (u = d.number > 0));
    var f = null,
      p = t[3];
    if (p.type === `ordgroup`) {
      if (p.body.length > 0) {
        var m = X(p.body[0], `textord`);
        f = yi[Number(m.text)];
      }
    } else ((p = X(p, `textord`)), (f = yi[Number(p.text)]));
    return vi(
      {
        type: `genfrac`,
        mode: n.mode,
        numer: r,
        denom: i,
        continued: !1,
        hasBarLine: u,
        barSize: d,
        leftDelim: o,
        rightDelim: c,
      },
      f,
    );
  },
}),
  K({
    type: `infix`,
    names: [`\\above`],
    numArgs: 1,
    argTypes: [`size`],
    infix: !0,
    handler(e, t) {
      var { parser: n, funcName: r, token: i } = e;
      return {
        type: `infix`,
        mode: n.mode,
        replaceWith: `\\\\abovefrac`,
        size: X(t[0], `size`).value,
        token: i,
      };
    },
  }),
  K({
    type: `genfrac`,
    names: [`\\\\abovefrac`],
    numArgs: 3,
    argTypes: [`math`, `size`, `math`],
    handler: (e, t) => {
      var { parser: n, funcName: r } = e,
        i = t[0],
        a = X(t[1], `infix`).size;
      if (!a) throw Error(`\\\\abovefrac expected size, but got ` + String(a));
      var o = t[2],
        s = a.number > 0;
      return {
        type: `genfrac`,
        mode: n.mode,
        numer: i,
        denom: o,
        continued: !1,
        hasBarLine: s,
        barSize: a,
        leftDelim: null,
        rightDelim: null,
      };
    },
  }));
var xi = (e, t) => {
  var n = t.style,
    r,
    i;
  e.type === `supsub`
    ? ((r = e.sup ? q(e.sup, t.havingStyle(n.sup()), t) : q(e.sub, t.havingStyle(n.sub()), t)),
      (i = X(e.base, `horizBrace`)))
    : (i = X(e, `horizBrace`));
  var a = q(i.base, t.havingBaseStyle(E.DISPLAY)),
    o = Kn(i, t),
    s = i.isOver
      ? G({
          positionType: `firstBaseline`,
          children: [
            {
              type: `elem`,
              elem: a,
            },
            {
              type: `kern`,
              size: 0.1,
            },
            {
              type: `elem`,
              elem: o,
              wrapperClasses: [`svg-align`],
            },
          ],
        })
      : G({
          positionType: `bottom`,
          positionData: a.depth + 0.1 + o.height,
          children: [
            {
              type: `elem`,
              elem: o,
              wrapperClasses: [`svg-align`],
            },
            {
              type: `kern`,
              size: 0.1,
            },
            {
              type: `elem`,
              elem: a,
            },
          ],
        });
  if (r) {
    var c = W([`minner`, i.isOver ? `mover` : `munder`], [s], t);
    s = i.isOver
      ? G({
          positionType: `firstBaseline`,
          children: [
            {
              type: `elem`,
              elem: c,
            },
            {
              type: `kern`,
              size: 0.2,
            },
            {
              type: `elem`,
              elem: r,
            },
          ],
        })
      : G({
          positionType: `bottom`,
          positionData: c.depth + 0.2 + r.height + r.depth,
          children: [
            {
              type: `elem`,
              elem: r,
            },
            {
              type: `kern`,
              size: 0.2,
            },
            {
              type: `elem`,
              elem: c,
            },
          ],
        });
  }
  return W([`minner`, i.isOver ? `mover` : `munder`], [s], t);
};
(K({
  type: `horizBrace`,
  names: [`\\overbrace`, `\\underbrace`, `\\overbracket`, `\\underbracket`],
  numArgs: 1,
  handler(e, t) {
    var { parser: n, funcName: r } = e;
    return {
      type: `horizBrace`,
      mode: n.mode,
      label: r,
      isOver: r.includes(`\\over`),
      base: t[0],
    };
  },
  htmlBuilder: xi,
  mathmlBuilder: (e, t) => {
    var n = Un(e.label);
    return new J(e.isOver ? `mover` : `munder`, [Y(e.base, t), n]);
  },
}),
  K({
    type: `href`,
    names: [`\\href`],
    numArgs: 2,
    argTypes: [`url`, `original`],
    allowedInText: !0,
    handler: (e, t) => {
      var { parser: n } = e,
        r = t[1],
        i = X(t[0], `url`).url;
      return n.settings.isTrusted({
        command: `\\href`,
        url: i,
      })
        ? {
            type: `href`,
            mode: n.mode,
            href: i,
            body: cn(r),
          }
        : n.formatUnsupportedCmd(`\\href`);
    },
    htmlBuilder: (e, t) => {
      var n = pn(e.body, t, !1);
      return Ht(e.href, [], n, t);
    },
    mathmlBuilder: (e, t) => {
      var n = Mn(e.body, t);
      return (n instanceof J || (n = new J(`mrow`, [n])), n.setAttribute(`href`, e.href), n);
    },
  }),
  K({
    type: `href`,
    names: [`\\url`],
    numArgs: 1,
    argTypes: [`url`],
    allowedInText: !0,
    handler: (e, t) => {
      var { parser: n } = e,
        r = X(t[0], `url`).url;
      if (
        !n.settings.isTrusted({
          command: `\\url`,
          url: r,
        })
      )
        return n.formatUnsupportedCmd(`\\url`);
      for (var i = [], a = 0; a < r.length; a++) {
        var o = r[a];
        (o === `~` && (o = `\\textasciitilde`),
          i.push({
            type: `textord`,
            mode: `text`,
            text: o,
          }));
      }
      var s = {
        type: `text`,
        mode: n.mode,
        font: `\\texttt`,
        body: i,
      };
      return {
        type: `href`,
        mode: n.mode,
        href: r,
        body: cn(s),
      };
    },
  }),
  K({
    type: `hbox`,
    names: [`\\hbox`],
    numArgs: 1,
    argTypes: [`text`],
    allowedInText: !0,
    primitive: !0,
    handler(e, t) {
      var { parser: n } = e;
      return {
        type: `hbox`,
        mode: n.mode,
        body: cn(t[0]),
      };
    },
    htmlBuilder(e, t) {
      return Ut(pn(e.body, t.withFont(``), !1));
    },
    mathmlBuilder(e, t) {
      return new J(`mrow`, jn(e.body, t.withFont(``)));
    },
  }),
  K({
    type: `html`,
    names: [`\\htmlClass`, `\\htmlId`, `\\htmlStyle`, `\\htmlData`],
    numArgs: 2,
    argTypes: [`raw`, `original`],
    allowedInText: !0,
    handler: (t, n) => {
      var { parser: r, funcName: i, token: a } = t,
        o = X(n[0], `raw`).string,
        s = n[1];
      r.settings.strict &&
        r.settings.reportNonstrict(`htmlExtension`, `HTML extension is disabled on strict mode`);
      var c,
        l = {};
      switch (i) {
        case `\\htmlClass`:
          ((l.class = o),
            (c = {
              command: `\\htmlClass`,
              class: o,
            }));
          break;
        case `\\htmlId`:
          ((l.id = o),
            (c = {
              command: `\\htmlId`,
              id: o,
            }));
          break;
        case `\\htmlStyle`:
          ((l.style = o),
            (c = {
              command: `\\htmlStyle`,
              style: o,
            }));
          break;
        case `\\htmlData`:
          for (var u = o.split(`,`), d = 0; d < u.length; d++) {
            var f = u[d],
              p = f.indexOf(`=`);
            if (p < 0) throw new e(`\\htmlData key/value '` + f + `' missing equals sign`);
            var m = f.slice(0, p),
              h = f.slice(p + 1);
            l[`data-` + m.trim()] = h;
          }
          c = {
            command: `\\htmlData`,
            attributes: l,
          };
          break;
        default:
          throw Error(`Unrecognized html command`);
      }
      return r.settings.isTrusted(c)
        ? {
            type: `html`,
            mode: r.mode,
            attributes: l,
            body: cn(s),
          }
        : r.formatUnsupportedCmd(i);
    },
    htmlBuilder: (e, t) => {
      var n = pn(e.body, t, !1),
        r = [`enclosing`];
      e.attributes.class && r.push(...e.attributes.class.trim().split(/\s+/));
      var i = W(r, n, t);
      for (var a in e.attributes)
        a !== `class` && e.attributes.hasOwnProperty(a) && i.setAttribute(a, e.attributes[a]);
      return i;
    },
    mathmlBuilder: (e, t) => Mn(e.body, t),
  }),
  K({
    type: `htmlmathml`,
    names: [`\\html@mathml`],
    numArgs: 2,
    allowedInArgument: !0,
    allowedInText: !0,
    handler: (e, t) => {
      var { parser: n } = e;
      return {
        type: `htmlmathml`,
        mode: n.mode,
        html: cn(t[0]),
        mathml: cn(t[1]),
      };
    },
    htmlBuilder: (e, t) => Ut(pn(e.html, t, !1)),
    mathmlBuilder: (e, t) => Mn(e.mathml, t),
  }));
var Si = function (t) {
  if (/^[-+]? *(\d+(\.\d*)?|\.\d+)$/.test(t))
    return {
      number: +t,
      unit: `bp`,
    };
  var n = /([-+]?) *(\d+(?:\.\d*)?|\.\d+) *([a-z]{2})/.exec(t);
  if (!n) throw new e(`Invalid size: '` + t + `' in \\includegraphics`);
  var r = {
    number: +(n[1] + n[2]),
    unit: n[3],
  };
  if (!we(r)) throw new e(`Invalid unit: '` + r.unit + `' in \\includegraphics.`);
  return r;
};
(K({
  type: `includegraphics`,
  names: [`\\includegraphics`],
  numArgs: 1,
  numOptionalArgs: 1,
  argTypes: [`raw`, `url`],
  allowedInText: !1,
  handler: (t, n, r) => {
    var { parser: i } = t,
      a = {
        number: 0,
        unit: `em`,
      },
      o = {
        number: 0.9,
        unit: `em`,
      },
      s = {
        number: 0,
        unit: `em`,
      },
      c = ``;
    if (r[0])
      for (var l = X(r[0], `raw`).string.split(`,`), u = 0; u < l.length; u++) {
        var d = l[u].split(`=`);
        if (d.length === 2) {
          var f = d[1].trim();
          switch (d[0].trim()) {
            case `alt`:
              c = f;
              break;
            case `width`:
              a = Si(f);
              break;
            case `height`:
              o = Si(f);
              break;
            case `totalheight`:
              s = Si(f);
              break;
            default:
              throw new e(`Invalid key: '` + d[0] + `' in \\includegraphics.`);
          }
        }
      }
    var p = X(n[0], `url`).url;
    return (
      c === `` &&
        ((c = p), (c = c.replace(/^.*[\\/]/, ``)), (c = c.substring(0, c.lastIndexOf(`.`)))),
      i.settings.isTrusted({
        command: `\\includegraphics`,
        url: p,
      })
        ? {
            type: `includegraphics`,
            mode: i.mode,
            alt: c,
            width: a,
            height: o,
            totalheight: s,
            src: p,
          }
        : i.formatUnsupportedCmd(`\\includegraphics`)
    );
  },
  htmlBuilder: (e, t) => {
    var n = k(e.height, t),
      r = 0;
    e.totalheight.number > 0 && (r = k(e.totalheight, t) - n);
    var i = 0;
    e.width.number > 0 && (i = k(e.width, t));
    var a = {
      height: A(n + r),
    };
    (i > 0 && (a.width = A(i)), r > 0 && (a.verticalAlign = A(-r)));
    var o = new Me(e.src, e.alt, a);
    return ((o.height = n), (o.depth = r), o);
  },
  mathmlBuilder: (e, t) => {
    var n = new J(`mglyph`, []);
    n.setAttribute(`alt`, e.alt);
    var r = k(e.height, t),
      i = 0;
    if (
      (e.totalheight.number > 0 && ((i = k(e.totalheight, t) - r), n.setAttribute(`valign`, A(-i))),
      n.setAttribute(`height`, A(r + i)),
      e.width.number > 0)
    ) {
      var a = k(e.width, t);
      n.setAttribute(`width`, A(a));
    }
    return (n.setAttribute(`src`, e.src), n);
  },
}),
  K({
    type: `kern`,
    names: [`\\kern`, `\\mkern`, `\\hskip`, `\\mskip`],
    numArgs: 1,
    argTypes: [`size`],
    primitive: !0,
    allowedInText: !0,
    handler(e, t) {
      var { parser: n, funcName: r } = e,
        i = X(t[0], `size`);
      if (n.settings.strict) {
        var a = r[1] === `m`,
          o = i.value.unit === `mu`;
        a
          ? (o ||
              n.settings.reportNonstrict(
                `mathVsTextUnits`,
                `LaTeX's ` + r + ` supports only mu units, ` + (`not ` + i.value.unit + ` units`),
              ),
            n.mode !== `math` &&
              n.settings.reportNonstrict(
                `mathVsTextUnits`,
                `LaTeX's ` + r + ` works only in math mode`,
              ))
          : o &&
            n.settings.reportNonstrict(
              `mathVsTextUnits`,
              `LaTeX's ` + r + ` doesn't support mu units`,
            );
      }
      return {
        type: `kern`,
        mode: n.mode,
        dimension: i.value,
      };
    },
    htmlBuilder(e, t) {
      return Kt(e.dimension, t);
    },
    mathmlBuilder(e, t) {
      return new Cn(k(e.dimension, t));
    },
  }),
  K({
    type: `lap`,
    names: [`\\mathllap`, `\\mathrlap`, `\\mathclap`],
    numArgs: 1,
    allowedInText: !0,
    handler: (e, t) => {
      var { parser: n, funcName: r } = e,
        i = t[0];
      return {
        type: `lap`,
        mode: n.mode,
        alignment: r.slice(5),
        body: i,
      };
    },
    htmlBuilder: (e, t) => {
      var n;
      e.alignment === `clap`
        ? ((n = W([], [q(e.body, t)])), (n = W([`inner`], [n], t)))
        : (n = W([`inner`], [q(e.body, t)]));
      var r = W([`fix`], []),
        i = W([e.alignment], [n, r], t),
        a = W([`strut`]);
      return (
        (a.style.height = A(i.height + i.depth)),
        i.depth && (a.style.verticalAlign = A(-i.depth)),
        i.children.unshift(a),
        (i = W([`thinbox`], [i], t)),
        W([`mord`, `vbox`], [i], t)
      );
    },
    mathmlBuilder: (e, t) => {
      var n = new J(`mpadded`, [Y(e.body, t)]);
      if (e.alignment !== `rlap`) {
        var r = e.alignment === `llap` ? `-1` : `-0.5`;
        n.setAttribute(`lspace`, r + `width`);
      }
      return (n.setAttribute(`width`, `0px`), n);
    },
  }),
  K({
    type: `styling`,
    names: [`\\(`, `$`],
    numArgs: 0,
    allowedInText: !0,
    allowedInMath: !1,
    handler(e, t) {
      var { funcName: n, parser: r } = e,
        i = r.mode;
      r.switchMode(`math`);
      var a = n === `\\(` ? `\\)` : `$`,
        o = r.parseExpression(!1, a);
      return (
        r.expect(a),
        r.switchMode(i),
        {
          type: `styling`,
          mode: r.mode,
          style: `text`,
          resetFont: !0,
          body: o,
        }
      );
    },
  }),
  K({
    type: `text`,
    names: [`\\)`, `\\]`],
    numArgs: 0,
    allowedInText: !0,
    allowedInMath: !1,
    handler(t, n) {
      throw new e(`Mismatched ` + t.funcName);
    },
  }));
var Ci = (e, t) => {
  switch (t.style.size) {
    case E.DISPLAY.size:
      return e.display;
    case E.TEXT.size:
      return e.text;
    case E.SCRIPT.size:
      return e.script;
    case E.SCRIPTSCRIPT.size:
      return e.scriptscript;
    default:
      return e.text;
  }
};
K({
  type: `mathchoice`,
  names: [`\\mathchoice`],
  numArgs: 4,
  primitive: !0,
  handler: (e, t) => {
    var { parser: n } = e;
    return {
      type: `mathchoice`,
      mode: n.mode,
      display: cn(t[0]),
      text: cn(t[1]),
      script: cn(t[2]),
      scriptscript: cn(t[3]),
    };
  },
  htmlBuilder: (e, t) => Ut(pn(Ci(e, t), t, !1)),
  mathmlBuilder: (e, t) => Mn(Ci(e, t), t),
});
var wi = (e, t, n, r, i, a, o) => {
    e = W([], [e]);
    var s = n && c(n),
      l,
      u;
    if (t) {
      var d = q(t, r.havingStyle(i.sup()), r);
      u = {
        elem: d,
        kern: Math.max(r.fontMetrics().bigOpSpacing1, r.fontMetrics().bigOpSpacing3 - d.depth),
      };
    }
    if (n) {
      var f = q(n, r.havingStyle(i.sub()), r);
      l = {
        elem: f,
        kern: Math.max(r.fontMetrics().bigOpSpacing2, r.fontMetrics().bigOpSpacing4 - f.height),
      };
    }
    var p;
    if (u && l)
      p = G({
        positionType: `bottom`,
        positionData:
          r.fontMetrics().bigOpSpacing5 + l.elem.height + l.elem.depth + l.kern + e.depth + o,
        children: [
          {
            type: `kern`,
            size: r.fontMetrics().bigOpSpacing5,
          },
          {
            type: `elem`,
            elem: l.elem,
            marginLeft: A(-a),
          },
          {
            type: `kern`,
            size: l.kern,
          },
          {
            type: `elem`,
            elem: e,
          },
          {
            type: `kern`,
            size: u.kern,
          },
          {
            type: `elem`,
            elem: u.elem,
            marginLeft: A(a),
          },
          {
            type: `kern`,
            size: r.fontMetrics().bigOpSpacing5,
          },
        ],
      });
    else if (l)
      p = G({
        positionType: `top`,
        positionData: e.height - o,
        children: [
          {
            type: `kern`,
            size: r.fontMetrics().bigOpSpacing5,
          },
          {
            type: `elem`,
            elem: l.elem,
            marginLeft: A(-a),
          },
          {
            type: `kern`,
            size: l.kern,
          },
          {
            type: `elem`,
            elem: e,
          },
        ],
      });
    else if (u)
      p = G({
        positionType: `bottom`,
        positionData: e.depth + o,
        children: [
          {
            type: `elem`,
            elem: e,
          },
          {
            type: `kern`,
            size: u.kern,
          },
          {
            type: `elem`,
            elem: u.elem,
            marginLeft: A(a),
          },
          {
            type: `kern`,
            size: r.fontMetrics().bigOpSpacing5,
          },
        ],
      });
    else return e;
    var m = [p];
    if (l && a !== 0 && !s) {
      var h = W([`mspace`], [], r);
      ((h.style.marginRight = A(a)), m.unshift(h));
    }
    return W([`mop`, `op-limits`], m, r);
  },
  Ti = new Set([`\\smallint`]),
  Ei = (e, t) => {
    var n,
      r,
      i = !1,
      a;
    e.type === `supsub`
      ? ((n = e.sup), (r = e.sub), (a = X(e.base, `op`)), (i = !0))
      : (a = X(e, `op`));
    var o = t.style,
      s = !1;
    o.size === E.DISPLAY.size && a.symbol && !Ti.has(a.name) && (s = !0);
    var c, l;
    if (a.symbol) {
      var u = s ? `Size2-Regular` : `Size1-Regular`,
        d = ``;
      if (
        ((a.name === `\\oiint` || a.name === `\\oiiint`) &&
          ((d = a.name.slice(1)), (a.name = d === `oiint` ? `\\iint` : `\\iiint`)),
        (c = Nt(a.name, u, `math`, t, [`mop`, `op-symbol`, s ? `large-op` : `small-op`])),
        (l = c.italic),
        d.length > 0)
      ) {
        var f = Xt(d + `Size` + (s ? `2` : `1`), t);
        ((c = G({
          positionType: `individualShift`,
          children: [
            {
              type: `elem`,
              elem: c,
              shift: 0,
            },
            {
              type: `elem`,
              elem: f,
              shift: s ? 0.08 : 0,
            },
          ],
        })),
          (a.name = `\\` + d),
          c.classes.unshift(`mop`),
          (c.italic = l));
      }
    } else if (a.body) {
      var p = pn(a.body, t, !0);
      p.length === 1 && p[0] instanceof Pe
        ? ((c = p[0]), (c.classes[0] = `mop`))
        : (c = W([`mop`], p, t));
    } else {
      for (var m = [], h = 1; h < a.name.length; h++) m.push(Pt(a.name[h], a.mode, t));
      c = W([`mop`], m, t);
    }
    var g = 0,
      _ = 0;
    return (
      (c instanceof Pe || a.name === `\\oiint` || a.name === `\\oiiint`) &&
        !a.suppressBaseShift &&
        ((g = (c.height - c.depth) / 2 - t.fontMetrics().axisHeight), (_ = c.italic ?? 0)),
      i
        ? wi(c, n, r, t, o, _, g)
        : (g && ((c.style.position = `relative`), (c.style.top = A(g))), c)
    );
  },
  Di = (e, t) => {
    var n;
    if (e.symbol)
      ((n = new J(`mo`, [En(e.name, e.mode)])),
        Ti.has(e.name) && n.setAttribute(`largeop`, `false`));
    else if (e.body) n = new J(`mo`, jn(e.body, t));
    else {
      n = new J(`mi`, [new Sn(e.name.slice(1))]);
      var r = new J(`mo`, [En(`⁡`, `text`)]);
      n = e.parentIsSupSub ? new J(`mrow`, [n, r]) : xn([n, r]);
    }
    return n;
  },
  Oi = {
    "∏": `\\prod`,
    "∐": `\\coprod`,
    "∑": `\\sum`,
    "⋀": `\\bigwedge`,
    "⋁": `\\bigvee`,
    "⋂": `\\bigcap`,
    "⋃": `\\bigcup`,
    "⨀": `\\bigodot`,
    "⨁": `\\bigoplus`,
    "⨂": `\\bigotimes`,
    "⨄": `\\biguplus`,
    "⨆": `\\bigsqcup`,
  };
(K({
  type: `op`,
  names:
    `\\coprod.\\bigvee.\\bigwedge.\\biguplus.\\bigcap.\\bigcup.\\intop.\\prod.\\sum.\\bigotimes.\\bigoplus.\\bigodot.\\bigsqcup.\\smallint.∏.∐.∑.⋀.⋁.⋂.⋃.⨀.⨁.⨂.⨄.⨆`.split(
      `.`,
    ),
  numArgs: 0,
  handler: (e, t) => {
    var { parser: n, funcName: r } = e,
      i = r;
    return (
      i.length === 1 && (i = Oi[i]),
      {
        type: `op`,
        mode: n.mode,
        limits: !0,
        parentIsSupSub: !1,
        symbol: !0,
        name: i,
      }
    );
  },
  htmlBuilder: Ei,
  mathmlBuilder: Di,
}),
  K({
    type: `op`,
    names: [`\\mathop`],
    numArgs: 1,
    primitive: !0,
    handler: (e, t) => {
      var { parser: n } = e,
        r = t[0];
      return {
        type: `op`,
        mode: n.mode,
        limits: !1,
        parentIsSupSub: !1,
        symbol: !1,
        body: cn(r),
      };
    },
  }));
var ki = {
  "∫": `\\int`,
  "∬": `\\iint`,
  "∭": `\\iiint`,
  "∮": `\\oint`,
  "∯": `\\oiint`,
  "∰": `\\oiiint`,
};
(K({
  type: `op`,
  names:
    `\\arcsin.\\arccos.\\arctan.\\arctg.\\arcctg.\\arg.\\ch.\\cos.\\cosec.\\cosh.\\cot.\\cotg.\\coth.\\csc.\\ctg.\\cth.\\deg.\\dim.\\exp.\\hom.\\ker.\\lg.\\ln.\\log.\\sec.\\sin.\\sinh.\\sh.\\tan.\\tanh.\\tg.\\th`.split(
      `.`,
    ),
  numArgs: 0,
  handler(e) {
    var { parser: t, funcName: n } = e;
    return {
      type: `op`,
      mode: t.mode,
      limits: !1,
      parentIsSupSub: !1,
      symbol: !1,
      name: n,
    };
  },
}),
  K({
    type: `op`,
    names: [`\\det`, `\\gcd`, `\\inf`, `\\lim`, `\\max`, `\\min`, `\\Pr`, `\\sup`],
    numArgs: 0,
    handler(e) {
      var { parser: t, funcName: n } = e;
      return {
        type: `op`,
        mode: t.mode,
        limits: !0,
        parentIsSupSub: !1,
        symbol: !1,
        name: n,
      };
    },
  }),
  K({
    type: `op`,
    names: [
      `\\int`,
      `\\iint`,
      `\\iiint`,
      `\\oint`,
      `\\oiint`,
      `\\oiiint`,
      `∫`,
      `∬`,
      `∭`,
      `∮`,
      `∯`,
      `∰`,
    ],
    numArgs: 0,
    allowedInArgument: !0,
    handler(e) {
      var { parser: t, funcName: n } = e,
        r = n;
      return (
        r.length === 1 && (r = ki[r]),
        {
          type: `op`,
          mode: t.mode,
          limits: !1,
          parentIsSupSub: !1,
          symbol: !0,
          name: r,
        }
      );
    },
  }));
var Ai = (e, t) => {
  var n,
    r,
    i = !1,
    a;
  e.type === `supsub`
    ? ((n = e.sup), (r = e.sub), (a = X(e.base, `operatorname`)), (i = !0))
    : (a = X(e, `operatorname`));
  var o;
  if (a.body.length > 0) {
    for (
      var s = pn(
          a.body.map((e) => {
            var t = (`text` in e) ? e.text : void 0;
            return typeof t == `string`
              ? {
                  type: `textord`,
                  mode: e.mode,
                  text: t,
                }
              : e;
          }),
          t.withFont(`mathrm`),
          !0,
        ),
        c = 0;
      c < s.length;
      c++
    ) {
      var l = s[c];
      l instanceof Pe && (l.text = l.text.replace(/\u2212/, `-`).replace(/\u2217/, `*`));
    }
    o = W([`mop`], s, t);
  } else o = W([`mop`], [], t);
  return i ? wi(o, n, r, t, t.style, 0, 0) : o;
};
(K({
  type: `operatorname`,
  names: [`\\operatorname@`, `\\operatornamewithlimits`],
  numArgs: 1,
  handler: (e, t) => {
    var { parser: n, funcName: r } = e,
      i = t[0];
    return {
      type: `operatorname`,
      mode: n.mode,
      body: cn(i),
      alwaysHandleSupSub: r === `\\operatornamewithlimits`,
      limits: !1,
      parentIsSupSub: !1,
    };
  },
  htmlBuilder: Ai,
  mathmlBuilder: (e, t) => {
    for (var n = jn(e.body, t.withFont(`mathrm`)), r = !0, i = 0; i < n.length; i++) {
      var a = n[i];
      if (!(a instanceof Cn))
        if (a instanceof J)
          switch (a.type) {
            case `mi`:
            case `mn`:
            case `mspace`:
            case `mtext`:
              break;
            case `mo`:
              var o = a.children[0];
              a.children.length === 1 && o instanceof Sn
                ? (o.text = o.text.replace(/\u2212/, `-`).replace(/\u2217/, `*`))
                : (r = !1);
              break;
            default:
              r = !1;
          }
        else r = !1;
    }
    r && (n = [new Sn(n.map((e) => e.toText()).join(``))]);
    var s = new J(`mi`, n);
    s.setAttribute(`mathvariant`, `normal`);
    var c = new J(`mo`, [En(`⁡`, `text`)]);
    return e.parentIsSupSub ? new J(`mrow`, [s, c]) : xn([s, c]);
  },
}),
  Z(`\\operatorname`, `\\@ifstar\\operatornamewithlimits\\operatorname@`),
  on({
    type: `ordgroup`,
    htmlBuilder(e, t) {
      return e.semisimple ? Ut(pn(e.body, t, !1)) : W([`mord`], pn(e.body, t, !0), t);
    },
    mathmlBuilder(e, t) {
      return Mn(e.body, t, !0);
    },
  }),
  K({
    type: `overline`,
    names: [`\\overline`],
    numArgs: 1,
    handler(e, t) {
      var { parser: n } = e,
        r = t[0];
      return {
        type: `overline`,
        mode: n.mode,
        body: r,
      };
    },
    htmlBuilder(e, t) {
      var n = q(e.body, t.havingCrampedStyle()),
        r = Vt(`overline-line`, t),
        i = t.fontMetrics().defaultRuleThickness;
      return W(
        [`mord`, `overline`],
        [
          G({
            positionType: `firstBaseline`,
            children: [
              {
                type: `elem`,
                elem: n,
              },
              {
                type: `kern`,
                size: 3 * i,
              },
              {
                type: `elem`,
                elem: r,
              },
              {
                type: `kern`,
                size: i,
              },
            ],
          }),
        ],
        t,
      );
    },
    mathmlBuilder(e, t) {
      var n = new J(`mo`, [new Sn(`‾`)]);
      n.setAttribute(`stretchy`, `true`);
      var r = new J(`mover`, [Y(e.body, t), n]);
      return (r.setAttribute(`accent`, `true`), r);
    },
  }),
  K({
    type: `phantom`,
    names: [`\\phantom`],
    numArgs: 1,
    allowedInText: !0,
    handler: (e, t) => {
      var { parser: n } = e,
        r = t[0];
      return {
        type: `phantom`,
        mode: n.mode,
        body: cn(r),
      };
    },
    htmlBuilder: (e, t) => Ut(pn(e.body, t.withPhantom(), !1)),
    mathmlBuilder: (e, t) => new J(`mphantom`, jn(e.body, t)),
  }),
  Z(`\\hphantom`, `\\smash{\\phantom{#1}}`),
  K({
    type: `vphantom`,
    names: [`\\vphantom`],
    numArgs: 1,
    allowedInText: !0,
    handler: (e, t) => {
      var { parser: n } = e,
        r = t[0];
      return {
        type: `vphantom`,
        mode: n.mode,
        body: r,
      };
    },
    htmlBuilder: (e, t) =>
      W([`mord`, `rlap`], [W([`inner`], [q(e.body, t.withPhantom())]), W([`fix`], [])], t),
    mathmlBuilder: (e, t) => {
      var n = new J(`mpadded`, [new J(`mphantom`, jn(cn(e.body), t))]);
      return (n.setAttribute(`width`, `0px`), n);
    },
  }),
  K({
    type: `raisebox`,
    names: [`\\raisebox`],
    numArgs: 2,
    argTypes: [`size`, `hbox`],
    allowedInText: !0,
    handler(e, t) {
      var { parser: n } = e,
        r = X(t[0], `size`).value,
        i = t[1];
      return {
        type: `raisebox`,
        mode: n.mode,
        dy: r,
        body: i,
      };
    },
    htmlBuilder(e, t) {
      var n = q(e.body, t);
      return G({
        positionType: `shift`,
        positionData: -k(e.dy, t),
        children: [
          {
            type: `elem`,
            elem: n,
          },
        ],
      });
    },
    mathmlBuilder(e, t) {
      var n = new J(`mpadded`, [Y(e.body, t)]),
        r = e.dy.number + e.dy.unit;
      return (n.setAttribute(`voffset`, r), n);
    },
  }),
  K({
    type: `internal`,
    names: [`\\relax`],
    numArgs: 0,
    allowedInText: !0,
    allowedInArgument: !0,
    handler(e) {
      var { parser: t } = e;
      return {
        type: `internal`,
        mode: t.mode,
      };
    },
  }),
  K({
    type: `rule`,
    names: [`\\rule`],
    numArgs: 2,
    numOptionalArgs: 1,
    allowedInText: !0,
    allowedInMath: !0,
    argTypes: [`size`, `size`, `size`],
    handler(e, t, n) {
      var { parser: r } = e,
        i = n[0],
        a = X(t[0], `size`),
        o = X(t[1], `size`);
      return {
        type: `rule`,
        mode: r.mode,
        shift: i && X(i, `size`).value,
        width: a.value,
        height: o.value,
      };
    },
    htmlBuilder(e, t) {
      var n = W([`mord`, `rule`], [], t),
        r = k(e.width, t),
        i = k(e.height, t),
        a = e.shift ? k(e.shift, t) : 0;
      return (
        (n.style.borderRightWidth = A(r)),
        (n.style.borderTopWidth = A(i)),
        (n.style.bottom = A(a)),
        (n.width = r),
        (n.height = i + a),
        (n.depth = -a),
        (n.maxFontSize = i * 1.125 * t.sizeMultiplier),
        n
      );
    },
    mathmlBuilder(e, t) {
      var n = k(e.width, t),
        r = k(e.height, t),
        i = e.shift ? k(e.shift, t) : 0,
        a = (t.color && t.getColor()) || `black`,
        o = new J(`mspace`);
      (o.setAttribute(`mathbackground`, a),
        o.setAttribute(`width`, A(n)),
        o.setAttribute(`height`, A(r)));
      var s = new J(`mpadded`, [o]);
      return (
        i >= 0
          ? s.setAttribute(`height`, A(i))
          : (s.setAttribute(`height`, A(i)), s.setAttribute(`depth`, A(-i))),
        s.setAttribute(`voffset`, A(i)),
        s
      );
    },
  }));
function ji(e, t, n) {
  for (var r = pn(e, t, !1), i = t.sizeMultiplier / n.sizeMultiplier, a = 0; a < r.length; a++) {
    var o = r[a].classes.indexOf(`sizing`);
    (o < 0
      ? Array.prototype.push.apply(r[a].classes, t.sizingClasses(n))
      : r[a].classes[o + 1] === `reset-size` + t.size &&
        (r[a].classes[o + 1] = `reset-size` + n.size),
      (r[a].height *= i),
      (r[a].depth *= i));
  }
  return Ut(r);
}
var Mi = [
  `\\tiny`,
  `\\sixptsize`,
  `\\scriptsize`,
  `\\footnotesize`,
  `\\small`,
  `\\normalsize`,
  `\\large`,
  `\\Large`,
  `\\LARGE`,
  `\\huge`,
  `\\Huge`,
];
(K({
  type: `sizing`,
  names: Mi,
  numArgs: 0,
  allowedInText: !0,
  handler: (e, t) => {
    var { breakOnTokenText: n, funcName: r, parser: i } = e,
      a = i.parseExpression(!1, n);
    return {
      type: `sizing`,
      mode: i.mode,
      size: Mi.indexOf(r) + 1,
      body: a,
    };
  },
  htmlBuilder: (e, t) => {
    var n = t.havingSize(e.size);
    return ji(e.body, n, t);
  },
  mathmlBuilder: (e, t) => {
    var n = t.havingSize(e.size),
      r = new J(`mstyle`, jn(e.body, n));
    return (r.setAttribute(`mathsize`, A(n.sizeMultiplier)), r);
  },
}),
  K({
    type: `smash`,
    names: [`\\smash`],
    numArgs: 1,
    numOptionalArgs: 1,
    allowedInText: !0,
    handler: (e, t, n) => {
      var { parser: r } = e,
        i = !1,
        a = !1,
        o = n[0] && X(n[0], `ordgroup`);
      if (o)
        for (var s, c = 0; c < o.body.length; ++c) {
          var l = o.body[c];
          if (((s = Zn(l).text), s === `t`)) i = !0;
          else if (s === `b`) a = !0;
          else {
            ((i = !1), (a = !1));
            break;
          }
        }
      else ((i = !0), (a = !0));
      var u = t[0];
      return {
        type: `smash`,
        mode: r.mode,
        body: u,
        smashHeight: i,
        smashDepth: a,
      };
    },
    htmlBuilder: (e, t) => {
      var n = W([], [q(e.body, t)]);
      if (!e.smashHeight && !e.smashDepth) return n;
      if (
        (e.smashHeight && (n.height = 0),
        e.smashDepth && (n.depth = 0),
        e.smashHeight && e.smashDepth)
      )
        return W([`mord`, `smash`], [n], t);
      if (n.children)
        for (var r = 0; r < n.children.length; r++)
          (e.smashHeight && (n.children[r].height = 0), e.smashDepth && (n.children[r].depth = 0));
      return W(
        [`mord`],
        [
          G({
            positionType: `firstBaseline`,
            children: [
              {
                type: `elem`,
                elem: n,
              },
            ],
          }),
        ],
        t,
      );
    },
    mathmlBuilder: (e, t) => {
      var n = new J(`mpadded`, [Y(e.body, t)]);
      return (
        e.smashHeight && n.setAttribute(`height`, `0px`),
        e.smashDepth && n.setAttribute(`depth`, `0px`),
        n
      );
    },
  }),
  K({
    type: `sqrt`,
    names: [`\\sqrt`],
    numArgs: 1,
    numOptionalArgs: 1,
    handler(e, t, n) {
      var { parser: r } = e,
        i = n[0],
        a = t[0];
      return {
        type: `sqrt`,
        mode: r.mode,
        body: a,
        index: i,
      };
    },
    htmlBuilder(e, t) {
      var n = q(e.body, t.havingCrampedStyle());
      (n.height === 0 && (n.height = t.fontMetrics().xHeight), (n = Wt(n, t)));
      var r = t.fontMetrics().defaultRuleThickness,
        i = r;
      t.style.id < E.TEXT.id && (i = t.fontMetrics().xHeight);
      var a = r + i / 4,
        { span: o, ruleWidth: s, advanceWidth: c } = Nr(n.height + n.depth + a + r, t),
        l = o.height - s;
      l > n.height + n.depth + a && (a = (a + l - n.height - n.depth) / 2);
      var u = o.height - n.height - a - s;
      n.style.paddingLeft = A(c);
      var d = G({
        positionType: `firstBaseline`,
        children: [
          {
            type: `elem`,
            elem: n,
            wrapperClasses: [`svg-align`],
          },
          {
            type: `kern`,
            size: -(n.height + u),
          },
          {
            type: `elem`,
            elem: o,
          },
          {
            type: `kern`,
            size: s,
          },
        ],
      });
      if (e.index) {
        var f = t.havingStyle(E.SCRIPTSCRIPT),
          p = q(e.index, f, t);
        return W(
          [`mord`, `sqrt`],
          [
            W(
              [`root`],
              [
                G({
                  positionType: `shift`,
                  positionData: -(0.6 * (d.height - d.depth)),
                  children: [
                    {
                      type: `elem`,
                      elem: p,
                    },
                  ],
                }),
              ],
            ),
            d,
          ],
          t,
        );
      } else return W([`mord`, `sqrt`], [d], t);
    },
    mathmlBuilder(e, t) {
      var { body: n, index: r } = e;
      return r ? new J(`mroot`, [Y(n, t), Y(r, t)]) : new J(`msqrt`, [Y(n, t)]);
    },
  }));
var Ni = {
  display: E.DISPLAY,
  text: E.TEXT,
  script: E.SCRIPT,
  scriptscript: E.SCRIPTSCRIPT,
};
function Pi(e) {
  return e in Ni;
}
K({
  type: `styling`,
  names: [`\\displaystyle`, `\\textstyle`, `\\scriptstyle`, `\\scriptscriptstyle`],
  numArgs: 0,
  allowedInText: !0,
  primitive: !0,
  handler(e, t) {
    var { breakOnTokenText: n, funcName: r, parser: i } = e,
      a = i.parseExpression(!0, n),
      o = r.slice(1, r.length - 5);
    if (!Pi(o)) throw Error(`Unknown style: ` + o);
    return {
      type: `styling`,
      mode: i.mode,
      style: o,
      body: a,
    };
  },
  htmlBuilder(e, t) {
    var n = Ni[e.style],
      r = t.havingStyle(n);
    return (e.resetFont && (r = r.withFont(``)), ji(e.body, r, t));
  },
  mathmlBuilder(e, t) {
    var n = Ni[e.style],
      r = t.havingStyle(n);
    e.resetFont && (r = r.withFont(``));
    var i = new J(`mstyle`, jn(e.body, r)),
      a = {
        display: [`0`, `true`],
        text: [`0`, `false`],
        script: [`1`, `false`],
        scriptscript: [`2`, `false`],
      }[e.style];
    return (i.setAttribute(`scriptlevel`, a[0]), i.setAttribute(`displaystyle`, a[1]), i);
  },
});
var Fi = function (e, t) {
  var n = e.base;
  return n
    ? n.type === `op`
      ? n.limits && (t.style.size === E.DISPLAY.size || n.alwaysHandleSupSub)
        ? Ei
        : null
      : n.type === `operatorname`
        ? n.alwaysHandleSupSub && (t.style.size === E.DISPLAY.size || n.limits)
          ? Ai
          : null
        : n.type === `accent`
          ? c(n.base)
            ? er
            : null
          : n.type === `horizBrace` && !e.sub === n.isOver
            ? xi
            : null
    : null;
};
(on({
  type: `supsub`,
  htmlBuilder(e, t) {
    var n = Fi(e, t);
    if (n) return n(e, t);
    var { base: r, sup: i, sub: a } = e,
      o = q(r, t),
      s,
      l,
      u = t.fontMetrics(),
      d = 0,
      f = 0,
      p = r && c(r);
    if (i) {
      var m = t.havingStyle(t.style.sup());
      ((s = q(i, m, t)),
        p || (d = o.height - (m.fontMetrics().supDrop * m.sizeMultiplier) / t.sizeMultiplier));
    }
    if (a) {
      var h = t.havingStyle(t.style.sub());
      ((l = q(a, h, t)),
        p || (f = o.depth + (h.fontMetrics().subDrop * h.sizeMultiplier) / t.sizeMultiplier));
    }
    var g = t.style === E.DISPLAY ? u.sup1 : t.style.cramped ? u.sup3 : u.sup2,
      _ = t.sizeMultiplier,
      v = A(0.5 / u.ptPerEm / _),
      y = null;
    if (l) {
      var b =
        e.base &&
        e.base.type === `op` &&
        e.base.name &&
        (e.base.name === `\\oiint` || e.base.name === `\\oiiint`);
      (o instanceof Pe || b) && (y = A(-(o.italic ?? 0)));
    }
    var x;
    if (s && l) {
      ((d = Math.max(d, g, s.depth + 0.25 * u.xHeight)), (f = Math.max(f, u.sub2)));
      var S = 4 * u.defaultRuleThickness;
      if (d - s.depth - (l.height - f) < S) {
        f = S - (d - s.depth) + l.height;
        var C = 0.8 * u.xHeight - (d - s.depth);
        C > 0 && ((d += C), (f -= C));
      }
      x = G({
        positionType: `individualShift`,
        children: [
          {
            type: `elem`,
            elem: l,
            shift: f,
            marginRight: v,
            marginLeft: y,
          },
          {
            type: `elem`,
            elem: s,
            shift: -d,
            marginRight: v,
          },
        ],
      });
    } else if (l)
      ((f = Math.max(f, u.sub1, l.height - 0.8 * u.xHeight)),
        (x = G({
          positionType: `shift`,
          positionData: f,
          children: [
            {
              type: `elem`,
              elem: l,
              marginLeft: y,
              marginRight: v,
            },
          ],
        })));
    else if (s)
      ((d = Math.max(d, g, s.depth + 0.25 * u.xHeight)),
        (x = G({
          positionType: `shift`,
          positionData: -d,
          children: [
            {
              type: `elem`,
              elem: s,
              marginRight: v,
            },
          ],
        })));
    else throw Error(`supsub must have either sup or sub.`);
    return W([_n(o, `right`) || `mord`], [o, W([`msupsub`], [x])], t);
  },
  mathmlBuilder(e, t) {
    var n = !1,
      r,
      i;
    (e.base &&
      e.base.type === `horizBrace` &&
      ((i = !!e.sup), i === e.base.isOver && ((n = !0), (r = e.base.isOver))),
      e.base &&
        (e.base.type === `op` || e.base.type === `operatorname`) &&
        (e.base.parentIsSupSub = !0));
    var a = [Y(e.base, t)];
    (e.sub && a.push(Y(e.sub, t)), e.sup && a.push(Y(e.sup, t)));
    var o;
    if (n) o = r ? `mover` : `munder`;
    else if (!e.sub) {
      var s = e.base;
      o =
        (s && s.type === `op` && s.limits && (t.style === E.DISPLAY || s.alwaysHandleSupSub)) ||
        (s &&
          s.type === `operatorname` &&
          s.alwaysHandleSupSub &&
          (s.limits || t.style === E.DISPLAY))
          ? `mover`
          : `msup`;
    } else if (e.sup) {
      var c = e.base;
      o =
        (c && c.type === `op` && c.limits && t.style === E.DISPLAY) ||
        (c &&
          c.type === `operatorname` &&
          c.alwaysHandleSupSub &&
          (t.style === E.DISPLAY || c.limits))
          ? `munderover`
          : `msubsup`;
    } else {
      var l = e.base;
      o =
        (l && l.type === `op` && l.limits && (t.style === E.DISPLAY || l.alwaysHandleSupSub)) ||
        (l &&
          l.type === `operatorname` &&
          l.alwaysHandleSupSub &&
          (l.limits || t.style === E.DISPLAY))
          ? `munder`
          : `msub`;
    }
    return new J(o, a);
  },
}),
  on({
    type: `atom`,
    htmlBuilder(e, t) {
      return Pt(e.text, e.mode, t, [`m` + e.family]);
    },
    mathmlBuilder(e, t) {
      var n = new J(`mo`, [En(e.text, e.mode)]);
      if (e.family === `bin`) {
        var r = kn(e, t);
        r === `bold-italic` && n.setAttribute(`mathvariant`, r);
      } else
        e.family === `punct`
          ? n.setAttribute(`separator`, `true`)
          : (e.family === `open` || e.family === `close`) && n.setAttribute(`stretchy`, `false`);
      return n;
    },
  }));
var Ii = {
  mi: `italic`,
  mn: `normal`,
  mtext: `normal`,
};
(on({
  type: `mathord`,
  htmlBuilder(e, t) {
    return It(e, t);
  },
  mathmlBuilder(e, t) {
    var n = new J(`mi`, [En(e.text, e.mode, t)]),
      r = kn(e, t) || `italic`;
    return (r !== Ii[n.type] && n.setAttribute(`mathvariant`, r), n);
  },
}),
  on({
    type: `textord`,
    htmlBuilder(e, t) {
      return It(e, t);
    },
    mathmlBuilder(e, t) {
      var n = En(e.text, e.mode, t),
        r = kn(e, t) || `normal`,
        i =
          e.mode === `text`
            ? new J(`mtext`, [n])
            : /[0-9]/.test(e.text)
              ? new J(`mn`, [n])
              : e.text === `\\prime`
                ? new J(`mo`, [n])
                : new J(`mi`, [n]);
      return (r !== Ii[i.type] && i.setAttribute(`mathvariant`, r), i);
    },
  }));
var Li = {
    "\\nobreak": `nobreak`,
    "\\allowbreak": `allowbreak`,
  },
  Ri = {
    " ": {},
    "\\ ": {},
    "~": {
      className: `nobreak`,
    },
    "\\space": {},
    "\\nobreakspace": {
      className: `nobreak`,
    },
  };
on({
  type: `spacing`,
  htmlBuilder(t, n) {
    if (Ri.hasOwnProperty(t.text)) {
      var r = Ri[t.text].className || ``;
      if (t.mode === `text`) {
        var i = It(t, n);
        return (i.classes.push(r), i);
      } else return W([`mspace`, r], [Pt(t.text, t.mode, n)], n);
    } else if (Li.hasOwnProperty(t.text)) return W([`mspace`, Li[t.text]], [], n);
    else throw new e(`Unknown type of space "` + t.text + `"`);
  },
  mathmlBuilder(t, n) {
    var r;
    if (Ri.hasOwnProperty(t.text)) r = new J(`mtext`, [new Sn(`\xA0`)]);
    else if (Li.hasOwnProperty(t.text)) return new J(`mspace`);
    else throw new e(`Unknown type of space "` + t.text + `"`);
    return r;
  },
});
var zi = () => {
  var e = new J(`mtd`, []);
  return (e.setAttribute(`width`, `50%`), e);
};
on({
  type: `tag`,
  mathmlBuilder(e, t) {
    var n = new J(`mtable`, [
      new J(`mtr`, [zi(), new J(`mtd`, [Mn(e.body, t)]), zi(), new J(`mtd`, [Mn(e.tag, t)])]),
    ]);
    return (n.setAttribute(`width`, `100%`), n);
  },
});
var Bi = {
    "\\text": void 0,
    "\\textrm": `textrm`,
    "\\textsf": `textsf`,
    "\\texttt": `texttt`,
    "\\textnormal": `textrm`,
  },
  Vi = {
    "\\textbf": `textbf`,
    "\\textmd": `textmd`,
  },
  Hi = {
    "\\textit": `textit`,
    "\\textup": `textup`,
  },
  Ui = (e, t) => {
    var n = e.font;
    return n
      ? Bi[n]
        ? t.withTextFontFamily(Bi[n])
        : Vi[n]
          ? t.withTextFontWeight(Vi[n])
          : n === `\\emph`
            ? t.fontShape === `textit`
              ? t.withTextFontShape(`textup`)
              : t.withTextFontShape(`textit`)
            : t.withTextFontShape(Hi[n])
      : t;
  };
(K({
  type: `text`,
  names: [
    `\\text`,
    `\\textrm`,
    `\\textsf`,
    `\\texttt`,
    `\\textnormal`,
    `\\textbf`,
    `\\textmd`,
    `\\textit`,
    `\\textup`,
    `\\emph`,
  ],
  numArgs: 1,
  argTypes: [`text`],
  allowedInArgument: !0,
  allowedInText: !0,
  handler(e, t) {
    var { parser: n, funcName: r } = e,
      i = t[0];
    return {
      type: `text`,
      mode: n.mode,
      body: cn(i),
      font: r,
    };
  },
  htmlBuilder(e, t) {
    var n = Ui(e, t);
    return W([`mord`, `text`], pn(e.body, n, !0), n);
  },
  mathmlBuilder(e, t) {
    var n = Ui(e, t);
    return Mn(e.body, n);
  },
}),
  K({
    type: `underline`,
    names: [`\\underline`],
    numArgs: 1,
    allowedInText: !0,
    handler(e, t) {
      var { parser: n } = e;
      return {
        type: `underline`,
        mode: n.mode,
        body: t[0],
      };
    },
    htmlBuilder(e, t) {
      var n = q(e.body, t),
        r = Vt(`underline-line`, t),
        i = t.fontMetrics().defaultRuleThickness;
      return W(
        [`mord`, `underline`],
        [
          G({
            positionType: `top`,
            positionData: n.height,
            children: [
              {
                type: `kern`,
                size: i,
              },
              {
                type: `elem`,
                elem: r,
              },
              {
                type: `kern`,
                size: 3 * i,
              },
              {
                type: `elem`,
                elem: n,
              },
            ],
          }),
        ],
        t,
      );
    },
    mathmlBuilder(e, t) {
      var n = new J(`mo`, [new Sn(`‾`)]);
      n.setAttribute(`stretchy`, `true`);
      var r = new J(`munder`, [Y(e.body, t), n]);
      return (r.setAttribute(`accentunder`, `true`), r);
    },
  }),
  K({
    type: `vcenter`,
    names: [`\\vcenter`],
    numArgs: 1,
    argTypes: [`original`],
    allowedInText: !1,
    handler(e, t) {
      var { parser: n } = e;
      return {
        type: `vcenter`,
        mode: n.mode,
        body: t[0],
      };
    },
    htmlBuilder(e, t) {
      var n = q(e.body, t),
        r = t.fontMetrics().axisHeight;
      return G({
        positionType: `shift`,
        positionData: 0.5 * (n.height - r - (n.depth + r)),
        children: [
          {
            type: `elem`,
            elem: n,
          },
        ],
      });
    },
    mathmlBuilder(e, t) {
      return new J(`mrow`, [new J(`mpadded`, [Y(e.body, t)], [`vcenter`])]);
    },
  }),
  K({
    type: `verb`,
    names: [`\\verb`],
    numArgs: 0,
    allowedInText: !0,
    handler(t, n, r) {
      throw new e(`\\verb ended by end of line instead of matching delimiter`);
    },
    htmlBuilder(e, t) {
      for (var n = Wi(e), r = [], i = t.havingStyle(t.style.text()), a = 0; a < n.length; a++) {
        var o = n[a];
        (o === `~` && (o = `\\textasciitilde`),
          r.push(Nt(o, `Typewriter-Regular`, e.mode, i, [`mord`, `texttt`])));
      }
      return W([`mord`, `text`].concat(i.sizingClasses(t)), Rt(r), i);
    },
    mathmlBuilder(e, t) {
      var n = new J(`mtext`, [new Sn(Wi(e))]);
      return (n.setAttribute(`mathvariant`, `monospace`), n);
    },
  }));
var Wi = (e) => e.body.replace(/ /g, e.star ? `␣` : `\xA0`),
  Gi = nn,
  Ki = `[ \r
	]`,
  qi = `\\\\[a-zA-Z@]+`,
  Ji = `\\\\[^\ud800-\udfff]`,
  Yi = `(` + qi + `)` + Ki + `*`,
  Xi = `\\\\(
|[ \r	]+
?)[ \r	]*`,
  Zi = `[̀-ͯ]`,
  Qi = RegExp(Zi + `+$`),
  $i =
    `(` +
    Ki +
    `+)|` +
    (Xi + `|`) +
    `([!-\\[\\]-‧‪-퟿豈-￿]` +
    (Zi + `*`) +
    `|[\ud800-\udbff][\udc00-\udfff]` +
    (Zi + `*`) +
    `|\\\\verb\\*([^]).*?\\4|\\\\verb([^*a-zA-Z]).*?\\5` +
    (`|` + Yi) +
    (`|` + Ji + `)`),
  ea = class {
    constructor(e, t) {
      ((this.input = void 0),
        (this.settings = void 0),
        (this.tokenRegex = void 0),
        (this.catcodes = void 0),
        (this.input = e),
        (this.settings = t),
        (this.tokenRegex = new RegExp($i, `g`)),
        (this.catcodes = {
          "%": 14,
          "~": 13,
        }));
    }
    setCatcode(e, t) {
      this.catcodes[e] = t;
    }
    lex() {
      var t = this.input,
        n = this.tokenRegex.lastIndex;
      if (n === t.length) return new ti(`EOF`, new ei(this, n, n));
      var r = this.tokenRegex.exec(t);
      if (r === null || r.index !== n)
        throw new e(`Unexpected character: '` + t[n] + `'`, new ti(t[n], new ei(this, n, n + 1)));
      var i = r[6] || r[3] || (r[2] ? `\\ ` : ` `);
      if (this.catcodes[i] === 14) {
        var a = t.indexOf(
          `
`,
          this.tokenRegex.lastIndex,
        );
        return (
          a === -1
            ? ((this.tokenRegex.lastIndex = t.length),
              this.settings.reportNonstrict(
                `commentAtEnd`,
                `% comment has no terminating newline; LaTeX would fail because of commenting the end of math mode (e.g. $)`,
              ))
            : (this.tokenRegex.lastIndex = a + 1),
          this.lex()
        );
      }
      return new ti(i, new ei(this, n, this.tokenRegex.lastIndex));
    }
  },
  ta = class {
    constructor(e, t) {
      (e === void 0 && (e = {}),
        t === void 0 && (t = {}),
        (this.current = void 0),
        (this.builtins = void 0),
        (this.undefStack = void 0),
        (this.current = t),
        (this.builtins = e),
        (this.undefStack = []));
    }
    beginGroup() {
      this.undefStack.push({});
    }
    endGroup() {
      if (this.undefStack.length === 0)
        throw new e(
          `Unbalanced namespace destruction: attempt to pop global namespace; please report this as a bug`,
        );
      var t = this.undefStack.pop();
      for (var n in t)
        t.hasOwnProperty(n) && (t[n] == null ? delete this.current[n] : (this.current[n] = t[n]));
    }
    endGroups() {
      for (; this.undefStack.length > 0;) this.endGroup();
    }
    has(e) {
      return this.current.hasOwnProperty(e) || this.builtins.hasOwnProperty(e);
    }
    get(e) {
      return this.current.hasOwnProperty(e) ? this.current[e] : this.builtins[e];
    }
    set(e, t, n) {
      if ((n === void 0 && (n = !1), n)) {
        for (var r = 0; r < this.undefStack.length; r++) delete this.undefStack[r][e];
        this.undefStack.length > 0 && (this.undefStack[this.undefStack.length - 1][e] = t);
      } else {
        var i = this.undefStack[this.undefStack.length - 1];
        i && !i.hasOwnProperty(e) && (i[e] = this.current[e]);
      }
      t == null ? delete this.current[e] : (this.current[e] = t);
    }
  },
  na = $r;
(Z(`\\noexpand`, function (e) {
  var t = e.popToken();
  return (
    e.isExpandable(t.text) && ((t.noexpand = !0), (t.treatAsRelax = !0)),
    {
      tokens: [t],
      numArgs: 0,
    }
  );
}),
  Z(`\\expandafter`, function (e) {
    var t = e.popToken();
    return (
      e.expandOnce(!0),
      {
        tokens: [t],
        numArgs: 0,
      }
    );
  }),
  Z(`\\@firstoftwo`, function (e) {
    return {
      tokens: e.consumeArgs(2)[0],
      numArgs: 0,
    };
  }),
  Z(`\\@secondoftwo`, function (e) {
    return {
      tokens: e.consumeArgs(2)[1],
      numArgs: 0,
    };
  }),
  Z(`\\@ifnextchar`, function (e) {
    var t = e.consumeArgs(3);
    e.consumeSpaces();
    var n = e.future();
    return t[0].length === 1 && t[0][0].text === n.text
      ? {
          tokens: t[1],
          numArgs: 0,
        }
      : {
          tokens: t[2],
          numArgs: 0,
        };
  }),
  Z(`\\@ifstar`, `\\@ifnextchar *{\\@firstoftwo{#1}}`),
  Z(`\\TextOrMath`, function (e) {
    var t = e.consumeArgs(2);
    return e.mode === `text`
      ? {
          tokens: t[0],
          numArgs: 0,
        }
      : {
          tokens: t[1],
          numArgs: 0,
        };
  }));
var ra = {
  0: 0,
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
  6: 6,
  7: 7,
  8: 8,
  9: 9,
  a: 10,
  A: 10,
  b: 11,
  B: 11,
  c: 12,
  C: 12,
  d: 13,
  D: 13,
  e: 14,
  E: 14,
  f: 15,
  F: 15,
};
Z(`\\char`, function (t) {
  var n = t.popToken(),
    r,
    i = 0;
  if (n.text === `'`) ((r = 8), (n = t.popToken()));
  else if (n.text === `"`) ((r = 16), (n = t.popToken()));
  else if (n.text === "`") {
    if (((n = t.popToken()), n.text[0] === `\\`)) i = n.text.charCodeAt(1);
    else if (n.text === `EOF`) throw new e("\\char` missing argument");
    else i = n.text.charCodeAt(0);
  } else r = 10;
  if (r) {
    if (((i = ra[n.text]), i == null || i >= r))
      throw new e(`Invalid base-` + r + ` digit ` + n.text);
    for (var a; (a = ra[t.future().text]) != null && a < r;) ((i *= r), (i += a), t.popToken());
  }
  return `\\@char{` + i + `}`;
});
var ia = (t, n, r, i) => {
  var a = t.consumeArg().tokens;
  if (a.length !== 1) throw new e(`\\newcommand's first argument must be a macro name`);
  var o = a[0].text,
    s = t.isDefined(o);
  if (s && !n)
    throw new e(`\\newcommand{` + o + `} attempting to redefine ` + (o + `; use \\renewcommand`));
  if (!s && !r)
    throw new e(
      `\\renewcommand{` + o + `} when command ` + o + ` does not yet exist; use \\newcommand`,
    );
  var c = 0;
  if (((a = t.consumeArg().tokens), a.length === 1 && a[0].text === `[`)) {
    for (var l = ``, u = t.expandNextToken(); u.text !== `]` && u.text !== `EOF`;)
      ((l += u.text), (u = t.expandNextToken()));
    if (!l.match(/^\s*[0-9]+\s*$/)) throw new e(`Invalid number of arguments: ` + l);
    ((c = parseInt(l)), (a = t.consumeArg().tokens));
  }
  return (
    (s && i) ||
      t.macros.set(o, {
        tokens: a,
        numArgs: c,
      }),
    ``
  );
};
(Z(`\\newcommand`, (e) => ia(e, !1, !0, !1)),
  Z(`\\renewcommand`, (e) => ia(e, !0, !1, !1)),
  Z(`\\providecommand`, (e) => ia(e, !0, !0, !0)),
  Z(`\\message`, (e) => {
    var t = e.consumeArgs(1)[0];
    return (
      console.log(
        t
          .reverse()
          .map((e) => e.text)
          .join(``),
      ),
      ``
    );
  }),
  Z(`\\errmessage`, (e) => {
    var t = e.consumeArgs(1)[0];
    return (
      console.error(
        t
          .reverse()
          .map((e) => e.text)
          .join(``),
      ),
      ``
    );
  }),
  Z(`\\show`, (e) => {
    var t = e.popToken(),
      n = t.text;
    return (console.log(t, e.macros.get(n), Gi[n], qe.math[n], qe.text[n]), ``);
  }),
  Z(`\\bgroup`, `{`),
  Z(`\\egroup`, `}`),
  Z(`~`, `\\nobreakspace`),
  Z(`\\lq`, "`"),
  Z(`\\rq`, `'`),
  Z(`\\aa`, `\\r a`),
  Z(`\\AA`, `\\r A`),
  Z(`\\textcopyright`, "\\html@mathml{\\textcircled{c}}{\\char`©}"),
  Z(`\\copyright`, `\\TextOrMath{\\textcopyright}{\\text{\\textcopyright}}`),
  Z(`\\textregistered`, "\\html@mathml{\\textcircled{\\scriptsize R}}{\\char`®}"),
  Z(`ℬ`, `\\mathscr{B}`),
  Z(`ℰ`, `\\mathscr{E}`),
  Z(`ℱ`, `\\mathscr{F}`),
  Z(`ℋ`, `\\mathscr{H}`),
  Z(`ℐ`, `\\mathscr{I}`),
  Z(`ℒ`, `\\mathscr{L}`),
  Z(`ℳ`, `\\mathscr{M}`),
  Z(`ℛ`, `\\mathscr{R}`),
  Z(`ℭ`, `\\mathfrak{C}`),
  Z(`ℌ`, `\\mathfrak{H}`),
  Z(`ℨ`, `\\mathfrak{Z}`),
  Z(`\\Bbbk`, `\\Bbb{k}`),
  Z(`\\llap`, `\\mathllap{\\textrm{#1}}`),
  Z(`\\rlap`, `\\mathrlap{\\textrm{#1}}`),
  Z(`\\clap`, `\\mathclap{\\textrm{#1}}`),
  Z(`\\mathstrut`, `\\vphantom{(}`),
  Z(`\\underbar`, `\\underline{\\text{#1}}`),
  Z(`\\not`, `\\html@mathml{\\mathrel{\\mathrlap\\@not}\\nobreak}{\\char"338}`),
  Z(`\\neq`, "\\html@mathml{\\mathrel{\\not=}}{\\mathrel{\\char`≠}}"),
  Z(`\\ne`, `\\neq`),
  Z(`≠`, `\\neq`),
  Z(`\\notin`, "\\html@mathml{\\mathrel{{\\in}\\mathllap{/\\mskip1mu}}}{\\mathrel{\\char`∉}}"),
  Z(`∉`, `\\notin`),
  Z(
    `≘`,
    "\\html@mathml{\\mathrel{=\\kern{-1em}\\raisebox{0.4em}{$\\scriptsize\\frown$}}}{\\mathrel{\\char`≘}}",
  ),
  Z(`≙`, "\\html@mathml{\\stackrel{\\tiny\\wedge}{=}}{\\mathrel{\\char`≘}}"),
  Z(`≚`, "\\html@mathml{\\stackrel{\\tiny\\vee}{=}}{\\mathrel{\\char`≚}}"),
  Z(`≛`, "\\html@mathml{\\stackrel{\\scriptsize\\star}{=}}{\\mathrel{\\char`≛}}"),
  Z(`≝`, "\\html@mathml{\\stackrel{\\tiny\\mathrm{def}}{=}}{\\mathrel{\\char`≝}}"),
  Z(`≞`, "\\html@mathml{\\stackrel{\\tiny\\mathrm{m}}{=}}{\\mathrel{\\char`≞}}"),
  Z(`≟`, "\\html@mathml{\\stackrel{\\tiny?}{=}}{\\mathrel{\\char`≟}}"),
  Z(`⟂`, `\\perp`),
  Z(`‼`, `\\mathclose{!\\mkern-0.8mu!}`),
  Z(`∌`, `\\notni`),
  Z(`⌜`, `\\ulcorner`),
  Z(`⌝`, `\\urcorner`),
  Z(`⌞`, `\\llcorner`),
  Z(`⌟`, `\\lrcorner`),
  Z(`©`, `\\copyright`),
  Z(`®`, `\\textregistered`),
  Z(`\\ulcorner`, `\\html@mathml{\\@ulcorner}{\\mathop{\\char"231c}}`),
  Z(`\\urcorner`, `\\html@mathml{\\@urcorner}{\\mathop{\\char"231d}}`),
  Z(`\\llcorner`, `\\html@mathml{\\@llcorner}{\\mathop{\\char"231e}}`),
  Z(`\\lrcorner`, `\\html@mathml{\\@lrcorner}{\\mathop{\\char"231f}}`),
  Z(`\\vdots`, `{\\varvdots\\rule{0pt}{15pt}}`),
  Z(`⋮`, `\\vdots`),
  Z(`\\varGamma`, `\\mathit{\\Gamma}`),
  Z(`\\varDelta`, `\\mathit{\\Delta}`),
  Z(`\\varTheta`, `\\mathit{\\Theta}`),
  Z(`\\varLambda`, `\\mathit{\\Lambda}`),
  Z(`\\varXi`, `\\mathit{\\Xi}`),
  Z(`\\varPi`, `\\mathit{\\Pi}`),
  Z(`\\varSigma`, `\\mathit{\\Sigma}`),
  Z(`\\varUpsilon`, `\\mathit{\\Upsilon}`),
  Z(`\\varPhi`, `\\mathit{\\Phi}`),
  Z(`\\varPsi`, `\\mathit{\\Psi}`),
  Z(`\\varOmega`, `\\mathit{\\Omega}`),
  Z(`\\substack`, `\\begin{subarray}{c}#1\\end{subarray}`),
  Z(
    `\\colon`,
    `\\nobreak\\mskip2mu\\mathpunct{}\\mathchoice{\\mkern-3mu}{\\mkern-3mu}{}{}{:}\\mskip6mu\\relax`,
  ),
  Z(`\\boxed`, `\\fbox{$\\displaystyle{#1}$}`),
  Z(`\\iff`, `\\DOTSB\\;\\Longleftrightarrow\\;`),
  Z(`\\implies`, `\\DOTSB\\;\\Longrightarrow\\;`),
  Z(`\\impliedby`, `\\DOTSB\\;\\Longleftarrow\\;`),
  Z(`\\dddot`, `{\\overset{\\raisebox{-0.1ex}{\\normalsize ...}}{#1}}`),
  Z(`\\ddddot`, `{\\overset{\\raisebox{-0.1ex}{\\normalsize ....}}{#1}}`));
var aa = {
    ",": `\\dotsc`,
    "\\not": `\\dotsb`,
    "+": `\\dotsb`,
    "=": `\\dotsb`,
    "<": `\\dotsb`,
    ">": `\\dotsb`,
    "-": `\\dotsb`,
    "*": `\\dotsb`,
    ":": `\\dotsb`,
    "\\DOTSB": `\\dotsb`,
    "\\coprod": `\\dotsb`,
    "\\bigvee": `\\dotsb`,
    "\\bigwedge": `\\dotsb`,
    "\\biguplus": `\\dotsb`,
    "\\bigcap": `\\dotsb`,
    "\\bigcup": `\\dotsb`,
    "\\prod": `\\dotsb`,
    "\\sum": `\\dotsb`,
    "\\bigotimes": `\\dotsb`,
    "\\bigoplus": `\\dotsb`,
    "\\bigodot": `\\dotsb`,
    "\\bigsqcup": `\\dotsb`,
    "\\And": `\\dotsb`,
    "\\longrightarrow": `\\dotsb`,
    "\\Longrightarrow": `\\dotsb`,
    "\\longleftarrow": `\\dotsb`,
    "\\Longleftarrow": `\\dotsb`,
    "\\longleftrightarrow": `\\dotsb`,
    "\\Longleftrightarrow": `\\dotsb`,
    "\\mapsto": `\\dotsb`,
    "\\longmapsto": `\\dotsb`,
    "\\hookrightarrow": `\\dotsb`,
    "\\doteq": `\\dotsb`,
    "\\mathbin": `\\dotsb`,
    "\\mathrel": `\\dotsb`,
    "\\relbar": `\\dotsb`,
    "\\Relbar": `\\dotsb`,
    "\\xrightarrow": `\\dotsb`,
    "\\xleftarrow": `\\dotsb`,
    "\\DOTSI": `\\dotsi`,
    "\\int": `\\dotsi`,
    "\\oint": `\\dotsi`,
    "\\iint": `\\dotsi`,
    "\\iiint": `\\dotsi`,
    "\\iiiint": `\\dotsi`,
    "\\idotsint": `\\dotsi`,
    "\\DOTSX": `\\dotsx`,
  },
  oa = new Set([`bin`, `rel`]);
Z(`\\dots`, function (e) {
  var t = `\\dotso`,
    n = e.expandAfterFuture().text;
  return (
    n in aa
      ? (t = aa[n])
      : (n.slice(0, 4) === `\\not` || (n in qe.math && oa.has(qe.math[n].group))) &&
        (t = `\\dotsb`),
    t
  );
});
var sa = {
  ")": !0,
  "]": !0,
  "\\rbrack": !0,
  "\\}": !0,
  "\\rbrace": !0,
  "\\rangle": !0,
  "\\rceil": !0,
  "\\rfloor": !0,
  "\\rgroup": !0,
  "\\rmoustache": !0,
  "\\right": !0,
  "\\bigr": !0,
  "\\biggr": !0,
  "\\Bigr": !0,
  "\\Biggr": !0,
  $: !0,
  ";": !0,
  ".": !0,
  ",": !0,
};
(Z(`\\dotso`, function (e) {
  return e.future().text in sa ? `\\ldots\\,` : `\\ldots`;
}),
  Z(`\\dotsc`, function (e) {
    var t = e.future().text;
    return t in sa && t !== `,` ? `\\ldots\\,` : `\\ldots`;
  }),
  Z(`\\cdots`, function (e) {
    return e.future().text in sa ? `\\@cdots\\,` : `\\@cdots`;
  }),
  Z(`\\dotsb`, `\\cdots`),
  Z(`\\dotsm`, `\\cdots`),
  Z(`\\dotsi`, `\\!\\cdots`),
  Z(`\\dotsx`, `\\ldots\\,`),
  Z(`\\DOTSI`, `\\relax`),
  Z(`\\DOTSB`, `\\relax`),
  Z(`\\DOTSX`, `\\relax`),
  Z(`\\tmspace`, `\\TextOrMath{\\kern#1#3}{\\mskip#1#2}\\relax`),
  Z(`\\,`, `\\tmspace+{3mu}{.1667em}`),
  Z(`\\thinspace`, `\\,`),
  Z(`\\>`, `\\mskip{4mu}`),
  Z(`\\:`, `\\tmspace+{4mu}{.2222em}`),
  Z(`\\medspace`, `\\:`),
  Z(`\\;`, `\\tmspace+{5mu}{.2777em}`),
  Z(`\\thickspace`, `\\;`),
  Z(`\\!`, `\\tmspace-{3mu}{.1667em}`),
  Z(`\\negthinspace`, `\\!`),
  Z(`\\negmedspace`, `\\tmspace-{4mu}{.2222em}`),
  Z(`\\negthickspace`, `\\tmspace-{5mu}{.277em}`),
  Z(`\\enspace`, `\\kern.5em `),
  Z(`\\enskip`, `\\hskip.5em\\relax`),
  Z(`\\quad`, `\\hskip1em\\relax`),
  Z(`\\qquad`, `\\hskip2em\\relax`),
  Z(`\\tag`, `\\@ifstar\\tag@literal\\tag@paren`),
  Z(`\\tag@paren`, `\\tag@literal{({#1})}`),
  Z(`\\tag@literal`, (t) => {
    if (t.macros.get(`\\df@tag`)) throw new e(`Multiple \\tag`);
    return `\\gdef\\df@tag{\\text{#1}}`;
  }),
  Z(
    `\\bmod`,
    `\\mathchoice{\\mskip1mu}{\\mskip1mu}{\\mskip5mu}{\\mskip5mu}\\mathbin{\\rm mod}\\mathchoice{\\mskip1mu}{\\mskip1mu}{\\mskip5mu}{\\mskip5mu}`,
  ),
  Z(`\\pod`, `\\allowbreak\\mathchoice{\\mkern18mu}{\\mkern8mu}{\\mkern8mu}{\\mkern8mu}(#1)`),
  Z(`\\pmod`, `\\pod{{\\rm mod}\\mkern6mu#1}`),
  Z(
    `\\mod`,
    `\\allowbreak\\mathchoice{\\mkern18mu}{\\mkern12mu}{\\mkern12mu}{\\mkern12mu}{\\rm mod}\\,\\,#1`,
  ),
  Z(`\\newline`, `\\\\\\relax`),
  Z(`\\TeX`, `\\textrm{\\html@mathml{T\\kern-.1667em\\raisebox{-.5ex}{E}\\kern-.125emX}{TeX}}`));
var ca = A(Ve[`Main-Regular`][84][1] - 0.7 * Ve[`Main-Regular`][65][1]);
(Z(
  `\\LaTeX`,
  `\\textrm{\\html@mathml{` +
    (`L\\kern-.36em\\raisebox{` + ca + `}{\\scriptstyle A}`) +
    `\\kern-.15em\\TeX}{LaTeX}}`,
),
  Z(
    `\\KaTeX`,
    `\\textrm{\\html@mathml{` +
      (`K\\kern-.17em\\raisebox{` + ca + `}{\\scriptstyle A}`) +
      `\\kern-.15em\\TeX}{KaTeX}}`,
  ),
  Z(`\\hspace`, `\\@ifstar\\@hspacer\\@hspace`),
  Z(`\\@hspace`, `\\hskip #1\\relax`),
  Z(`\\@hspacer`, `\\rule{0pt}{0pt}\\hskip #1\\relax`),
  Z(`\\ordinarycolon`, `:`),
  Z(`\\vcentcolon`, `\\mathrel{\\mathop\\ordinarycolon}`),
  Z(
    `\\dblcolon`,
    `\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-.9mu}\\vcentcolon}}{\\mathop{\\char"2237}}`,
  ),
  Z(
    `\\coloneqq`,
    `\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-1.2mu}=}}{\\mathop{\\char"2254}}`,
  ),
  Z(
    `\\Coloneqq`,
    `\\html@mathml{\\mathrel{\\dblcolon\\mathrel{\\mkern-1.2mu}=}}{\\mathop{\\char"2237\\char"3d}}`,
  ),
  Z(
    `\\coloneq`,
    `\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-1.2mu}\\mathrel{-}}}{\\mathop{\\char"3a\\char"2212}}`,
  ),
  Z(
    `\\Coloneq`,
    `\\html@mathml{\\mathrel{\\dblcolon\\mathrel{\\mkern-1.2mu}\\mathrel{-}}}{\\mathop{\\char"2237\\char"2212}}`,
  ),
  Z(
    `\\eqqcolon`,
    `\\html@mathml{\\mathrel{=\\mathrel{\\mkern-1.2mu}\\vcentcolon}}{\\mathop{\\char"2255}}`,
  ),
  Z(
    `\\Eqqcolon`,
    `\\html@mathml{\\mathrel{=\\mathrel{\\mkern-1.2mu}\\dblcolon}}{\\mathop{\\char"3d\\char"2237}}`,
  ),
  Z(
    `\\eqcolon`,
    `\\html@mathml{\\mathrel{\\mathrel{-}\\mathrel{\\mkern-1.2mu}\\vcentcolon}}{\\mathop{\\char"2239}}`,
  ),
  Z(
    `\\Eqcolon`,
    `\\html@mathml{\\mathrel{\\mathrel{-}\\mathrel{\\mkern-1.2mu}\\dblcolon}}{\\mathop{\\char"2212\\char"2237}}`,
  ),
  Z(
    `\\colonapprox`,
    `\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-1.2mu}\\approx}}{\\mathop{\\char"3a\\char"2248}}`,
  ),
  Z(
    `\\Colonapprox`,
    `\\html@mathml{\\mathrel{\\dblcolon\\mathrel{\\mkern-1.2mu}\\approx}}{\\mathop{\\char"2237\\char"2248}}`,
  ),
  Z(
    `\\colonsim`,
    `\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-1.2mu}\\sim}}{\\mathop{\\char"3a\\char"223c}}`,
  ),
  Z(
    `\\Colonsim`,
    `\\html@mathml{\\mathrel{\\dblcolon\\mathrel{\\mkern-1.2mu}\\sim}}{\\mathop{\\char"2237\\char"223c}}`,
  ),
  Z(`∷`, `\\dblcolon`),
  Z(`∹`, `\\eqcolon`),
  Z(`≔`, `\\coloneqq`),
  Z(`≕`, `\\eqqcolon`),
  Z(`⩴`, `\\Coloneqq`),
  Z(`\\ratio`, `\\vcentcolon`),
  Z(`\\coloncolon`, `\\dblcolon`),
  Z(`\\colonequals`, `\\coloneqq`),
  Z(`\\coloncolonequals`, `\\Coloneqq`),
  Z(`\\equalscolon`, `\\eqqcolon`),
  Z(`\\equalscoloncolon`, `\\Eqqcolon`),
  Z(`\\colonminus`, `\\coloneq`),
  Z(`\\coloncolonminus`, `\\Coloneq`),
  Z(`\\minuscolon`, `\\eqcolon`),
  Z(`\\minuscoloncolon`, `\\Eqcolon`),
  Z(`\\coloncolonapprox`, `\\Colonapprox`),
  Z(`\\coloncolonsim`, `\\Colonsim`),
  Z(`\\simcolon`, `\\mathrel{\\sim\\mathrel{\\mkern-1.2mu}\\vcentcolon}`),
  Z(`\\simcoloncolon`, `\\mathrel{\\sim\\mathrel{\\mkern-1.2mu}\\dblcolon}`),
  Z(`\\approxcolon`, `\\mathrel{\\approx\\mathrel{\\mkern-1.2mu}\\vcentcolon}`),
  Z(`\\approxcoloncolon`, `\\mathrel{\\approx\\mathrel{\\mkern-1.2mu}\\dblcolon}`),
  Z(`\\notni`, "\\html@mathml{\\not\\ni}{\\mathrel{\\char`∌}}"),
  Z(`\\limsup`, `\\DOTSB\\operatorname*{lim\\,sup}`),
  Z(`\\liminf`, `\\DOTSB\\operatorname*{lim\\,inf}`),
  Z(`\\injlim`, `\\DOTSB\\operatorname*{inj\\,lim}`),
  Z(`\\projlim`, `\\DOTSB\\operatorname*{proj\\,lim}`),
  Z(`\\varlimsup`, `\\DOTSB\\operatorname*{\\overline{lim}}`),
  Z(`\\varliminf`, `\\DOTSB\\operatorname*{\\underline{lim}}`),
  Z(`\\varinjlim`, `\\DOTSB\\operatorname*{\\underrightarrow{lim}}`),
  Z(`\\varprojlim`, `\\DOTSB\\operatorname*{\\underleftarrow{lim}}`),
  Z(`\\gvertneqq`, `\\html@mathml{\\@gvertneqq}{≩}`),
  Z(`\\lvertneqq`, `\\html@mathml{\\@lvertneqq}{≨}`),
  Z(`\\ngeqq`, `\\html@mathml{\\@ngeqq}{≱}`),
  Z(`\\ngeqslant`, `\\html@mathml{\\@ngeqslant}{≱}`),
  Z(`\\nleqq`, `\\html@mathml{\\@nleqq}{≰}`),
  Z(`\\nleqslant`, `\\html@mathml{\\@nleqslant}{≰}`),
  Z(`\\nshortmid`, `\\html@mathml{\\@nshortmid}{∤}`),
  Z(`\\nshortparallel`, `\\html@mathml{\\@nshortparallel}{∦}`),
  Z(`\\nsubseteqq`, `\\html@mathml{\\@nsubseteqq}{⊈}`),
  Z(`\\nsupseteqq`, `\\html@mathml{\\@nsupseteqq}{⊉}`),
  Z(`\\varsubsetneq`, `\\html@mathml{\\@varsubsetneq}{⊊}`),
  Z(`\\varsubsetneqq`, `\\html@mathml{\\@varsubsetneqq}{⫋}`),
  Z(`\\varsupsetneq`, `\\html@mathml{\\@varsupsetneq}{⊋}`),
  Z(`\\varsupsetneqq`, `\\html@mathml{\\@varsupsetneqq}{⫌}`),
  Z(`\\imath`, `\\html@mathml{\\@imath}{ı}`),
  Z(`\\jmath`, `\\html@mathml{\\@jmath}{ȷ}`),
  Z(`\\llbracket`, "\\html@mathml{\\mathopen{[\\mkern-3.2mu[}}{\\mathopen{\\char`⟦}}"),
  Z(`\\rrbracket`, "\\html@mathml{\\mathclose{]\\mkern-3.2mu]}}{\\mathclose{\\char`⟧}}"),
  Z(`⟦`, `\\llbracket`),
  Z(`⟧`, `\\rrbracket`),
  Z(`\\lBrace`, "\\html@mathml{\\mathopen{\\{\\mkern-3.2mu[}}{\\mathopen{\\char`⦃}}"),
  Z(`\\rBrace`, "\\html@mathml{\\mathclose{]\\mkern-3.2mu\\}}}{\\mathclose{\\char`⦄}}"),
  Z(`⦃`, `\\lBrace`),
  Z(`⦄`, `\\rBrace`),
  Z(
    `\\minuso`,
    "\\mathbin{\\html@mathml{{\\mathrlap{\\mathchoice{\\kern{0.145em}}{\\kern{0.145em}}{\\kern{0.1015em}}{\\kern{0.0725em}}\\circ}{-}}}{\\char`⦵}}",
  ),
  Z(`⦵`, `\\minuso`),
  Z(`\\darr`, `\\downarrow`),
  Z(`\\dArr`, `\\Downarrow`),
  Z(`\\Darr`, `\\Downarrow`),
  Z(`\\lang`, `\\langle`),
  Z(`\\rang`, `\\rangle`),
  Z(`\\uarr`, `\\uparrow`),
  Z(`\\uArr`, `\\Uparrow`),
  Z(`\\Uarr`, `\\Uparrow`),
  Z(`\\N`, `\\mathbb{N}`),
  Z(`\\R`, `\\mathbb{R}`),
  Z(`\\Z`, `\\mathbb{Z}`),
  Z(`\\alef`, `\\aleph`),
  Z(`\\alefsym`, `\\aleph`),
  Z(`\\Alpha`, `\\mathrm{A}`),
  Z(`\\Beta`, `\\mathrm{B}`),
  Z(`\\bull`, `\\bullet`),
  Z(`\\Chi`, `\\mathrm{X}`),
  Z(`\\clubs`, `\\clubsuit`),
  Z(`\\cnums`, `\\mathbb{C}`),
  Z(`\\Complex`, `\\mathbb{C}`),
  Z(`\\Dagger`, `\\ddagger`),
  Z(`\\diamonds`, `\\diamondsuit`),
  Z(`\\empty`, `\\emptyset`),
  Z(`\\Epsilon`, `\\mathrm{E}`),
  Z(`\\Eta`, `\\mathrm{H}`),
  Z(`\\exist`, `\\exists`),
  Z(`\\harr`, `\\leftrightarrow`),
  Z(`\\hArr`, `\\Leftrightarrow`),
  Z(`\\Harr`, `\\Leftrightarrow`),
  Z(`\\hearts`, `\\heartsuit`),
  Z(`\\image`, `\\Im`),
  Z(`\\infin`, `\\infty`),
  Z(`\\Iota`, `\\mathrm{I}`),
  Z(`\\isin`, `\\in`),
  Z(`\\Kappa`, `\\mathrm{K}`),
  Z(`\\larr`, `\\leftarrow`),
  Z(`\\lArr`, `\\Leftarrow`),
  Z(`\\Larr`, `\\Leftarrow`),
  Z(`\\lrarr`, `\\leftrightarrow`),
  Z(`\\lrArr`, `\\Leftrightarrow`),
  Z(`\\Lrarr`, `\\Leftrightarrow`),
  Z(`\\Mu`, `\\mathrm{M}`),
  Z(`\\natnums`, `\\mathbb{N}`),
  Z(`\\Nu`, `\\mathrm{N}`),
  Z(`\\Omicron`, `\\mathrm{O}`),
  Z(`\\plusmn`, `\\pm`),
  Z(`\\rarr`, `\\rightarrow`),
  Z(`\\rArr`, `\\Rightarrow`),
  Z(`\\Rarr`, `\\Rightarrow`),
  Z(`\\real`, `\\Re`),
  Z(`\\reals`, `\\mathbb{R}`),
  Z(`\\Reals`, `\\mathbb{R}`),
  Z(`\\Rho`, `\\mathrm{P}`),
  Z(`\\sdot`, `\\cdot`),
  Z(`\\sect`, `\\S`),
  Z(`\\spades`, `\\spadesuit`),
  Z(`\\sub`, `\\subset`),
  Z(`\\sube`, `\\subseteq`),
  Z(`\\supe`, `\\supseteq`),
  Z(`\\Tau`, `\\mathrm{T}`),
  Z(`\\thetasym`, `\\vartheta`),
  Z(`\\weierp`, `\\wp`),
  Z(`\\Zeta`, `\\mathrm{Z}`),
  Z(`\\argmin`, `\\DOTSB\\operatorname*{arg\\,min}`),
  Z(`\\argmax`, `\\DOTSB\\operatorname*{arg\\,max}`),
  Z(`\\plim`, `\\DOTSB\\mathop{\\operatorname{plim}}\\limits`),
  Z(`\\bra`, `\\mathinner{\\langle{#1}|}`),
  Z(`\\ket`, `\\mathinner{|{#1}\\rangle}`),
  Z(`\\braket`, `\\mathinner{\\langle{#1}\\rangle}`),
  Z(`\\Bra`, `\\left\\langle#1\\right|`),
  Z(`\\Ket`, `\\left|#1\\right\\rangle`));
var la = (e) => (t) => {
  var n = t.consumeArg().tokens,
    r = t.consumeArg().tokens,
    i = t.consumeArg().tokens,
    a = t.consumeArg().tokens,
    o = t.macros.get(`|`),
    s = t.macros.get(`\\|`);
  t.macros.beginGroup();
  var c = (t) => (n) => {
    e && (n.macros.set(`|`, o), i.length && n.macros.set(`\\|`, s));
    var a = t;
    return (
      !t && i.length && n.future().text === `|` && (n.popToken(), (a = !0)),
      {
        tokens: a ? i : r,
        numArgs: 0,
      }
    );
  };
  (t.macros.set(`|`, c(!1)), i.length && t.macros.set(`\\|`, c(!0)));
  var l = t.consumeArg().tokens,
    u = t.expandTokens([...a, ...l, ...n]);
  return (
    t.macros.endGroup(),
    {
      tokens: u.reverse(),
      numArgs: 0,
    }
  );
};
(Z(`\\bra@ket`, la(!1)),
  Z(`\\bra@set`, la(!0)),
  Z(
    `\\Braket`,
    `\\bra@ket{\\left\\langle}{\\,\\middle\\vert\\,}{\\,\\middle\\vert\\,}{\\right\\rangle}`,
  ),
  Z(`\\Set`, `\\bra@set{\\left\\{\\:}{\\;\\middle\\vert\\;}{\\;\\middle\\Vert\\;}{\\:\\right\\}}`),
  Z(`\\set`, `\\bra@set{\\{\\,}{\\mid}{}{\\,\\}}`),
  Z(`\\angln`, `{\\angl n}`),
  Z(`\\blue`, `\\textcolor{##6495ed}{#1}`),
  Z(`\\orange`, `\\textcolor{##ffa500}{#1}`),
  Z(`\\pink`, `\\textcolor{##ff00af}{#1}`),
  Z(`\\red`, `\\textcolor{##df0030}{#1}`),
  Z(`\\green`, `\\textcolor{##28ae7b}{#1}`),
  Z(`\\gray`, `\\textcolor{gray}{#1}`),
  Z(`\\purple`, `\\textcolor{##9d38bd}{#1}`),
  Z(`\\blueA`, `\\textcolor{##ccfaff}{#1}`),
  Z(`\\blueB`, `\\textcolor{##80f6ff}{#1}`),
  Z(`\\blueC`, `\\textcolor{##63d9ea}{#1}`),
  Z(`\\blueD`, `\\textcolor{##11accd}{#1}`),
  Z(`\\blueE`, `\\textcolor{##0c7f99}{#1}`),
  Z(`\\tealA`, `\\textcolor{##94fff5}{#1}`),
  Z(`\\tealB`, `\\textcolor{##26edd5}{#1}`),
  Z(`\\tealC`, `\\textcolor{##01d1c1}{#1}`),
  Z(`\\tealD`, `\\textcolor{##01a995}{#1}`),
  Z(`\\tealE`, `\\textcolor{##208170}{#1}`),
  Z(`\\greenA`, `\\textcolor{##b6ffb0}{#1}`),
  Z(`\\greenB`, `\\textcolor{##8af281}{#1}`),
  Z(`\\greenC`, `\\textcolor{##74cf70}{#1}`),
  Z(`\\greenD`, `\\textcolor{##1fab54}{#1}`),
  Z(`\\greenE`, `\\textcolor{##0d923f}{#1}`),
  Z(`\\goldA`, `\\textcolor{##ffd0a9}{#1}`),
  Z(`\\goldB`, `\\textcolor{##ffbb71}{#1}`),
  Z(`\\goldC`, `\\textcolor{##ff9c39}{#1}`),
  Z(`\\goldD`, `\\textcolor{##e07d10}{#1}`),
  Z(`\\goldE`, `\\textcolor{##a75a05}{#1}`),
  Z(`\\redA`, `\\textcolor{##fca9a9}{#1}`),
  Z(`\\redB`, `\\textcolor{##ff8482}{#1}`),
  Z(`\\redC`, `\\textcolor{##f9685d}{#1}`),
  Z(`\\redD`, `\\textcolor{##e84d39}{#1}`),
  Z(`\\redE`, `\\textcolor{##bc2612}{#1}`),
  Z(`\\maroonA`, `\\textcolor{##ffbde0}{#1}`),
  Z(`\\maroonB`, `\\textcolor{##ff92c6}{#1}`),
  Z(`\\maroonC`, `\\textcolor{##ed5fa6}{#1}`),
  Z(`\\maroonD`, `\\textcolor{##ca337c}{#1}`),
  Z(`\\maroonE`, `\\textcolor{##9e034e}{#1}`),
  Z(`\\purpleA`, `\\textcolor{##ddd7ff}{#1}`),
  Z(`\\purpleB`, `\\textcolor{##c6b9fc}{#1}`),
  Z(`\\purpleC`, `\\textcolor{##aa87ff}{#1}`),
  Z(`\\purpleD`, `\\textcolor{##7854ab}{#1}`),
  Z(`\\purpleE`, `\\textcolor{##543b78}{#1}`),
  Z(`\\mintA`, `\\textcolor{##f5f9e8}{#1}`),
  Z(`\\mintB`, `\\textcolor{##edf2df}{#1}`),
  Z(`\\mintC`, `\\textcolor{##e0e5cc}{#1}`),
  Z(`\\grayA`, `\\textcolor{##f6f7f7}{#1}`),
  Z(`\\grayB`, `\\textcolor{##f0f1f2}{#1}`),
  Z(`\\grayC`, `\\textcolor{##e3e5e6}{#1}`),
  Z(`\\grayD`, `\\textcolor{##d6d8da}{#1}`),
  Z(`\\grayE`, `\\textcolor{##babec2}{#1}`),
  Z(`\\grayF`, `\\textcolor{##888d93}{#1}`),
  Z(`\\grayG`, `\\textcolor{##626569}{#1}`),
  Z(`\\grayH`, `\\textcolor{##3b3e40}{#1}`),
  Z(`\\grayI`, `\\textcolor{##21242c}{#1}`),
  Z(`\\kaBlue`, `\\textcolor{##314453}{#1}`),
  Z(`\\kaGreen`, `\\textcolor{##71B307}{#1}`));
var ua = {
    "^": !0,
    _: !0,
    "\\limits": !0,
    "\\nolimits": !0,
  },
  da = class {
    constructor(e, t, n) {
      ((this.settings = void 0),
        (this.expansionCount = void 0),
        (this.lexer = void 0),
        (this.macros = void 0),
        (this.stack = void 0),
        (this.mode = void 0),
        (this.settings = t),
        (this.expansionCount = 0),
        this.feed(e),
        (this.macros = new ta(na, t.macros)),
        (this.mode = n),
        (this.stack = []));
    }
    feed(e) {
      this.lexer = new ea(e, this.settings);
    }
    switchMode(e) {
      this.mode = e;
    }
    beginGroup() {
      this.macros.beginGroup();
    }
    endGroup() {
      this.macros.endGroup();
    }
    endGroups() {
      this.macros.endGroups();
    }
    future() {
      return (
        this.stack.length === 0 && this.pushToken(this.lexer.lex()),
        this.stack[this.stack.length - 1]
      );
    }
    popToken() {
      return (this.future(), this.stack.pop());
    }
    pushToken(e) {
      this.stack.push(e);
    }
    pushTokens(e) {
      this.stack.push(...e);
    }
    scanArgument(e) {
      var t, n, r;
      if (e) {
        if ((this.consumeSpaces(), this.future().text !== `[`)) return null;
        ((t = this.popToken()), ({ tokens: r, end: n } = this.consumeArg([`]`])));
      } else ({ tokens: r, start: t, end: n } = this.consumeArg());
      return (this.pushToken(new ti(`EOF`, n.loc)), this.pushTokens(r), new ti(``, ei.range(t, n)));
    }
    consumeSpaces() {
      for (; this.future().text === ` `;) this.stack.pop();
    }
    consumeArg(t) {
      var n = [],
        r = t && t.length > 0;
      r || this.consumeSpaces();
      var i = this.future(),
        a,
        o = 0,
        s = 0;
      do {
        if (((a = this.popToken()), n.push(a), a.text === `{`)) ++o;
        else if (a.text === `}`) {
          if ((--o, o === -1)) throw new e(`Extra }`, a);
        } else if (a.text === `EOF`)
          throw new e(
            `Unexpected end of input in a macro argument, expected '` + (t && r ? t[s] : `}`) + `'`,
            a,
          );
        if (t && r)
          if ((o === 0 || (o === 1 && t[s] === `{`)) && a.text === t[s]) {
            if ((++s, s === t.length)) {
              n.splice(-s, s);
              break;
            }
          } else s = 0;
      } while (o !== 0 || r);
      return (
        i.text === `{` && n[n.length - 1].text === `}` && (n.pop(), n.shift()),
        n.reverse(),
        {
          tokens: n,
          start: i,
          end: a,
        }
      );
    }
    consumeArgs(t, n) {
      if (n) {
        if (n.length !== t + 1)
          throw new e(`The length of delimiters doesn't match the number of args!`);
        for (var r = n[0], i = 0; i < r.length; i++) {
          var a = this.popToken();
          if (r[i] !== a.text) throw new e(`Use of the macro doesn't match its definition`, a);
        }
      }
      for (var o = [], s = 0; s < t; s++) o.push(this.consumeArg(n && n[s + 1]).tokens);
      return o;
    }
    countExpansion(t) {
      if (((this.expansionCount += t), this.expansionCount > this.settings.maxExpand))
        throw new e(`Too many expansions: infinite loop or need to increase maxExpand setting`);
    }
    expandOnce(t) {
      var n = this.popToken(),
        r = n.text,
        i = n.noexpand ? null : this._getExpansion(r);
      if (i == null || (t && i.unexpandable)) {
        if (t && i == null && r[0] === `\\` && !this.isDefined(r))
          throw new e(`Undefined control sequence: ` + r);
        return (this.pushToken(n), !1);
      }
      this.countExpansion(1);
      var a = i.tokens,
        o = this.consumeArgs(i.numArgs, i.delimiters);
      if (i.numArgs) {
        a = a.slice();
        for (var s = a.length - 1; s >= 0; --s) {
          var c = a[s];
          if (c.text === `#`) {
            if (s === 0) throw new e(`Incomplete placeholder at end of macro body`, c);
            if (((c = a[--s]), c.text === `#`)) a.splice(s + 1, 1);
            else if (/^[1-9]$/.test(c.text)) a.splice(s, 2, ...o[c.text - 1]);
            else throw new e(`Not a valid argument number`, c);
          }
        }
      }
      return (this.pushTokens(a), a.length);
    }
    expandAfterFuture() {
      return (this.expandOnce(), this.future());
    }
    expandNextToken() {
      for (;;)
        if (this.expandOnce() === !1) {
          var e = this.stack.pop();
          return (e.treatAsRelax && (e.text = `\\relax`), e);
        }
    }
    expandMacro(e) {
      return this.macros.has(e) ? this.expandTokens([new ti(e)]) : void 0;
    }
    expandTokens(e) {
      var t = [],
        n = this.stack.length;
      for (this.pushTokens(e); this.stack.length > n;)
        if (this.expandOnce(!0) === !1) {
          var r = this.stack.pop();
          ((r.treatAsRelax &&= ((r.noexpand = !1), !1)), t.push(r));
        }
      return (this.countExpansion(t.length), t);
    }
    expandMacroAsText(e) {
      var t = this.expandMacro(e);
      return t && t.map((e) => e.text).join(``);
    }
    _getExpansion(e) {
      var t = this.macros.get(e);
      if (t == null) return t;
      if (e.length === 1) {
        var n = this.lexer.catcodes[e];
        if (n != null && n !== 13) return;
      }
      var r = typeof t == `function` ? t(this) : t;
      if (typeof r == `string`) {
        var i = 0;
        if (r.includes(`#`)) for (var a = r.replace(/##/g, ``); a.includes(`#` + (i + 1));) ++i;
        for (var o = new ea(r, this.settings), s = [], c = o.lex(); c.text !== `EOF`;)
          (s.push(c), (c = o.lex()));
        return (
          s.reverse(),
          {
            tokens: s,
            numArgs: i,
          }
        );
      }
      return r;
    }
    isDefined(e) {
      return (
        this.macros.has(e) ||
        Gi.hasOwnProperty(e) ||
        qe.math.hasOwnProperty(e) ||
        qe.text.hasOwnProperty(e) ||
        ua.hasOwnProperty(e)
      );
    }
    isExpandable(e) {
      var t = this.macros.get(e);
      return t == null
        ? Gi.hasOwnProperty(e) && !Gi[e].primitive
        : typeof t == `string` || typeof t == `function` || !t.unexpandable;
    }
  },
  fa = /^[₊₋₌₍₎₀₁₂₃₄₅₆₇₈₉ₐₑₕᵢⱼₖₗₘₙₒₚᵣₛₜᵤᵥₓᵦᵧᵨᵩᵪ]/,
  pa = Object.freeze({
    "₊": `+`,
    "₋": `-`,
    "₌": `=`,
    "₍": `(`,
    "₎": `)`,
    "₀": `0`,
    "₁": `1`,
    "₂": `2`,
    "₃": `3`,
    "₄": `4`,
    "₅": `5`,
    "₆": `6`,
    "₇": `7`,
    "₈": `8`,
    "₉": `9`,
    ₐ: `a`,
    ₑ: `e`,
    ₕ: `h`,
    ᵢ: `i`,
    ⱼ: `j`,
    ₖ: `k`,
    ₗ: `l`,
    ₘ: `m`,
    ₙ: `n`,
    ₒ: `o`,
    ₚ: `p`,
    ᵣ: `r`,
    ₛ: `s`,
    ₜ: `t`,
    ᵤ: `u`,
    ᵥ: `v`,
    ₓ: `x`,
    ᵦ: `β`,
    ᵧ: `γ`,
    ᵨ: `ρ`,
    ᵩ: `ϕ`,
    ᵪ: `χ`,
    "⁺": `+`,
    "⁻": `-`,
    "⁼": `=`,
    "⁽": `(`,
    "⁾": `)`,
    "⁰": `0`,
    "¹": `1`,
    "²": `2`,
    "³": `3`,
    "⁴": `4`,
    "⁵": `5`,
    "⁶": `6`,
    "⁷": `7`,
    "⁸": `8`,
    "⁹": `9`,
    ᴬ: `A`,
    ᴮ: `B`,
    ᴰ: `D`,
    ᴱ: `E`,
    ᴳ: `G`,
    ᴴ: `H`,
    ᴵ: `I`,
    ᴶ: `J`,
    ᴷ: `K`,
    ᴸ: `L`,
    ᴹ: `M`,
    ᴺ: `N`,
    ᴼ: `O`,
    ᴾ: `P`,
    ᴿ: `R`,
    ᵀ: `T`,
    ᵁ: `U`,
    ⱽ: `V`,
    ᵂ: `W`,
    ᵃ: `a`,
    ᵇ: `b`,
    ᶜ: `c`,
    ᵈ: `d`,
    ᵉ: `e`,
    ᶠ: `f`,
    ᵍ: `g`,
    ʰ: `h`,
    ⁱ: `i`,
    ʲ: `j`,
    ᵏ: `k`,
    ˡ: `l`,
    ᵐ: `m`,
    ⁿ: `n`,
    ᵒ: `o`,
    ᵖ: `p`,
    ʳ: `r`,
    ˢ: `s`,
    ᵗ: `t`,
    ᵘ: `u`,
    ᵛ: `v`,
    ʷ: `w`,
    ˣ: `x`,
    ʸ: `y`,
    ᶻ: `z`,
    ᵝ: `β`,
    ᵞ: `γ`,
    ᵟ: `δ`,
    ᵠ: `ϕ`,
    ᵡ: `χ`,
    ᶿ: `θ`,
  }),
  ma = {
    "́": {
      text: `\\'`,
      math: `\\acute`,
    },
    "̀": {
      text: "\\`",
      math: `\\grave`,
    },
    "̈": {
      text: `\\"`,
      math: `\\ddot`,
    },
    "̃": {
      text: `\\~`,
      math: `\\tilde`,
    },
    "̄": {
      text: `\\=`,
      math: `\\bar`,
    },
    "̆": {
      text: `\\u`,
      math: `\\breve`,
    },
    "̌": {
      text: `\\v`,
      math: `\\check`,
    },
    "̂": {
      text: `\\^`,
      math: `\\hat`,
    },
    "̇": {
      text: `\\.`,
      math: `\\dot`,
    },
    "̊": {
      text: `\\r`,
      math: `\\mathring`,
    },
    "̋": {
      text: `\\H`,
    },
    "̧": {
      text: `\\c`,
    },
  },
  ha = {
    á: `á`,
    à: `à`,
    ä: `ä`,
    ǟ: `ǟ`,
    ã: `ã`,
    ā: `ā`,
    ă: `ă`,
    ắ: `ắ`,
    ằ: `ằ`,
    ẵ: `ẵ`,
    ǎ: `ǎ`,
    â: `â`,
    ấ: `ấ`,
    ầ: `ầ`,
    ẫ: `ẫ`,
    ȧ: `ȧ`,
    ǡ: `ǡ`,
    å: `å`,
    ǻ: `ǻ`,
    ḃ: `ḃ`,
    ć: `ć`,
    ḉ: `ḉ`,
    č: `č`,
    ĉ: `ĉ`,
    ċ: `ċ`,
    ç: `ç`,
    ď: `ď`,
    ḋ: `ḋ`,
    ḑ: `ḑ`,
    é: `é`,
    è: `è`,
    ë: `ë`,
    ẽ: `ẽ`,
    ē: `ē`,
    ḗ: `ḗ`,
    ḕ: `ḕ`,
    ĕ: `ĕ`,
    ḝ: `ḝ`,
    ě: `ě`,
    ê: `ê`,
    ế: `ế`,
    ề: `ề`,
    ễ: `ễ`,
    ė: `ė`,
    ȩ: `ȩ`,
    ḟ: `ḟ`,
    ǵ: `ǵ`,
    ḡ: `ḡ`,
    ğ: `ğ`,
    ǧ: `ǧ`,
    ĝ: `ĝ`,
    ġ: `ġ`,
    ģ: `ģ`,
    ḧ: `ḧ`,
    ȟ: `ȟ`,
    ĥ: `ĥ`,
    ḣ: `ḣ`,
    ḩ: `ḩ`,
    í: `í`,
    ì: `ì`,
    ï: `ï`,
    ḯ: `ḯ`,
    ĩ: `ĩ`,
    ī: `ī`,
    ĭ: `ĭ`,
    ǐ: `ǐ`,
    î: `î`,
    ǰ: `ǰ`,
    ĵ: `ĵ`,
    ḱ: `ḱ`,
    ǩ: `ǩ`,
    ķ: `ķ`,
    ĺ: `ĺ`,
    ľ: `ľ`,
    ļ: `ļ`,
    ḿ: `ḿ`,
    ṁ: `ṁ`,
    ń: `ń`,
    ǹ: `ǹ`,
    ñ: `ñ`,
    ň: `ň`,
    ṅ: `ṅ`,
    ņ: `ņ`,
    ó: `ó`,
    ò: `ò`,
    ö: `ö`,
    ȫ: `ȫ`,
    õ: `õ`,
    ṍ: `ṍ`,
    ṏ: `ṏ`,
    ȭ: `ȭ`,
    ō: `ō`,
    ṓ: `ṓ`,
    ṑ: `ṑ`,
    ŏ: `ŏ`,
    ǒ: `ǒ`,
    ô: `ô`,
    ố: `ố`,
    ồ: `ồ`,
    ỗ: `ỗ`,
    ȯ: `ȯ`,
    ȱ: `ȱ`,
    ő: `ő`,
    ṕ: `ṕ`,
    ṗ: `ṗ`,
    ŕ: `ŕ`,
    ř: `ř`,
    ṙ: `ṙ`,
    ŗ: `ŗ`,
    ś: `ś`,
    ṥ: `ṥ`,
    š: `š`,
    ṧ: `ṧ`,
    ŝ: `ŝ`,
    ṡ: `ṡ`,
    ş: `ş`,
    ẗ: `ẗ`,
    ť: `ť`,
    ṫ: `ṫ`,
    ţ: `ţ`,
    ú: `ú`,
    ù: `ù`,
    ü: `ü`,
    ǘ: `ǘ`,
    ǜ: `ǜ`,
    ǖ: `ǖ`,
    ǚ: `ǚ`,
    ũ: `ũ`,
    ṹ: `ṹ`,
    ū: `ū`,
    ṻ: `ṻ`,
    ŭ: `ŭ`,
    ǔ: `ǔ`,
    û: `û`,
    ů: `ů`,
    ű: `ű`,
    ṽ: `ṽ`,
    ẃ: `ẃ`,
    ẁ: `ẁ`,
    ẅ: `ẅ`,
    ŵ: `ŵ`,
    ẇ: `ẇ`,
    ẘ: `ẘ`,
    ẍ: `ẍ`,
    ẋ: `ẋ`,
    ý: `ý`,
    ỳ: `ỳ`,
    ÿ: `ÿ`,
    ỹ: `ỹ`,
    ȳ: `ȳ`,
    ŷ: `ŷ`,
    ẏ: `ẏ`,
    ẙ: `ẙ`,
    ź: `ź`,
    ž: `ž`,
    ẑ: `ẑ`,
    ż: `ż`,
    Á: `Á`,
    À: `À`,
    Ä: `Ä`,
    Ǟ: `Ǟ`,
    Ã: `Ã`,
    Ā: `Ā`,
    Ă: `Ă`,
    Ắ: `Ắ`,
    Ằ: `Ằ`,
    Ẵ: `Ẵ`,
    Ǎ: `Ǎ`,
    Â: `Â`,
    Ấ: `Ấ`,
    Ầ: `Ầ`,
    Ẫ: `Ẫ`,
    Ȧ: `Ȧ`,
    Ǡ: `Ǡ`,
    Å: `Å`,
    Ǻ: `Ǻ`,
    Ḃ: `Ḃ`,
    Ć: `Ć`,
    Ḉ: `Ḉ`,
    Č: `Č`,
    Ĉ: `Ĉ`,
    Ċ: `Ċ`,
    Ç: `Ç`,
    Ď: `Ď`,
    Ḋ: `Ḋ`,
    Ḑ: `Ḑ`,
    É: `É`,
    È: `È`,
    Ë: `Ë`,
    Ẽ: `Ẽ`,
    Ē: `Ē`,
    Ḗ: `Ḗ`,
    Ḕ: `Ḕ`,
    Ĕ: `Ĕ`,
    Ḝ: `Ḝ`,
    Ě: `Ě`,
    Ê: `Ê`,
    Ế: `Ế`,
    Ề: `Ề`,
    Ễ: `Ễ`,
    Ė: `Ė`,
    Ȩ: `Ȩ`,
    Ḟ: `Ḟ`,
    Ǵ: `Ǵ`,
    Ḡ: `Ḡ`,
    Ğ: `Ğ`,
    Ǧ: `Ǧ`,
    Ĝ: `Ĝ`,
    Ġ: `Ġ`,
    Ģ: `Ģ`,
    Ḧ: `Ḧ`,
    Ȟ: `Ȟ`,
    Ĥ: `Ĥ`,
    Ḣ: `Ḣ`,
    Ḩ: `Ḩ`,
    Í: `Í`,
    Ì: `Ì`,
    Ï: `Ï`,
    Ḯ: `Ḯ`,
    Ĩ: `Ĩ`,
    Ī: `Ī`,
    Ĭ: `Ĭ`,
    Ǐ: `Ǐ`,
    Î: `Î`,
    İ: `İ`,
    Ĵ: `Ĵ`,
    Ḱ: `Ḱ`,
    Ǩ: `Ǩ`,
    Ķ: `Ķ`,
    Ĺ: `Ĺ`,
    Ľ: `Ľ`,
    Ļ: `Ļ`,
    Ḿ: `Ḿ`,
    Ṁ: `Ṁ`,
    Ń: `Ń`,
    Ǹ: `Ǹ`,
    Ñ: `Ñ`,
    Ň: `Ň`,
    Ṅ: `Ṅ`,
    Ņ: `Ņ`,
    Ó: `Ó`,
    Ò: `Ò`,
    Ö: `Ö`,
    Ȫ: `Ȫ`,
    Õ: `Õ`,
    Ṍ: `Ṍ`,
    Ṏ: `Ṏ`,
    Ȭ: `Ȭ`,
    Ō: `Ō`,
    Ṓ: `Ṓ`,
    Ṑ: `Ṑ`,
    Ŏ: `Ŏ`,
    Ǒ: `Ǒ`,
    Ô: `Ô`,
    Ố: `Ố`,
    Ồ: `Ồ`,
    Ỗ: `Ỗ`,
    Ȯ: `Ȯ`,
    Ȱ: `Ȱ`,
    Ő: `Ő`,
    Ṕ: `Ṕ`,
    Ṗ: `Ṗ`,
    Ŕ: `Ŕ`,
    Ř: `Ř`,
    Ṙ: `Ṙ`,
    Ŗ: `Ŗ`,
    Ś: `Ś`,
    Ṥ: `Ṥ`,
    Š: `Š`,
    Ṧ: `Ṧ`,
    Ŝ: `Ŝ`,
    Ṡ: `Ṡ`,
    Ş: `Ş`,
    Ť: `Ť`,
    Ṫ: `Ṫ`,
    Ţ: `Ţ`,
    Ú: `Ú`,
    Ù: `Ù`,
    Ü: `Ü`,
    Ǘ: `Ǘ`,
    Ǜ: `Ǜ`,
    Ǖ: `Ǖ`,
    Ǚ: `Ǚ`,
    Ũ: `Ũ`,
    Ṹ: `Ṹ`,
    Ū: `Ū`,
    Ṻ: `Ṻ`,
    Ŭ: `Ŭ`,
    Ǔ: `Ǔ`,
    Û: `Û`,
    Ů: `Ů`,
    Ű: `Ű`,
    Ṽ: `Ṽ`,
    Ẃ: `Ẃ`,
    Ẁ: `Ẁ`,
    Ẅ: `Ẅ`,
    Ŵ: `Ŵ`,
    Ẇ: `Ẇ`,
    Ẍ: `Ẍ`,
    Ẋ: `Ẋ`,
    Ý: `Ý`,
    Ỳ: `Ỳ`,
    Ÿ: `Ÿ`,
    Ỹ: `Ỹ`,
    Ȳ: `Ȳ`,
    Ŷ: `Ŷ`,
    Ẏ: `Ẏ`,
    Ź: `Ź`,
    Ž: `Ž`,
    Ẑ: `Ẑ`,
    Ż: `Ż`,
    ά: `ά`,
    ὰ: `ὰ`,
    ᾱ: `ᾱ`,
    ᾰ: `ᾰ`,
    έ: `έ`,
    ὲ: `ὲ`,
    ή: `ή`,
    ὴ: `ὴ`,
    ί: `ί`,
    ὶ: `ὶ`,
    ϊ: `ϊ`,
    ΐ: `ΐ`,
    ῒ: `ῒ`,
    ῑ: `ῑ`,
    ῐ: `ῐ`,
    ό: `ό`,
    ὸ: `ὸ`,
    ύ: `ύ`,
    ὺ: `ὺ`,
    ϋ: `ϋ`,
    ΰ: `ΰ`,
    ῢ: `ῢ`,
    ῡ: `ῡ`,
    ῠ: `ῠ`,
    ώ: `ώ`,
    ὼ: `ὼ`,
    Ύ: `Ύ`,
    Ὺ: `Ὺ`,
    Ϋ: `Ϋ`,
    Ῡ: `Ῡ`,
    Ῠ: `Ῠ`,
    Ώ: `Ώ`,
    Ὼ: `Ὼ`,
  },
  ga = class t {
    constructor(e, t) {
      ((this.mode = void 0),
        (this.gullet = void 0),
        (this.settings = void 0),
        (this.leftrightDepth = void 0),
        (this.nextToken = void 0),
        (this.mode = `math`),
        (this.gullet = new da(e, t, this.mode)),
        (this.settings = t),
        (this.leftrightDepth = 0),
        (this.nextToken = null));
    }
    expect(t, n) {
      if ((n === void 0 && (n = !0), this.fetch().text !== t))
        throw new e(`Expected '` + t + `', got '` + this.fetch().text + `'`, this.fetch());
      n && this.consume();
    }
    consume() {
      this.nextToken = null;
    }
    fetch() {
      return ((this.nextToken ??= this.gullet.expandNextToken()), this.nextToken);
    }
    switchMode(e) {
      ((this.mode = e), this.gullet.switchMode(e));
    }
    parse() {
      (this.settings.globalGroup || this.gullet.beginGroup(),
        this.settings.colorIsTextColor && this.gullet.macros.set(`\\color`, `\\textcolor`));
      try {
        var e = this.parseExpression(!1);
        return (this.expect(`EOF`), this.settings.globalGroup || this.gullet.endGroup(), e);
      } finally {
        this.gullet.endGroups();
      }
    }
    subparse(e) {
      var t = this.nextToken;
      (this.consume(), this.gullet.pushToken(new ti(`}`)), this.gullet.pushTokens(e));
      var n = this.parseExpression(!1);
      return (this.expect(`}`), (this.nextToken = t), n);
    }
    parseExpression(e, n) {
      for (var r = []; ;) {
        this.mode === `math` && this.consumeSpaces();
        var i = this.fetch();
        if (
          t.endOfExpression.has(i.text) ||
          (n && i.text === n) ||
          (e && Gi[i.text] && Gi[i.text].infix)
        )
          break;
        var a = this.parseAtom(n);
        if (!a) break;
        a.type !== `internal` && r.push(a);
      }
      return (this.mode === `text` && this.formLigatures(r), this.handleInfixNodes(r));
    }
    handleInfixNodes(t) {
      for (var n = -1, r, i = 0; i < t.length; i++) {
        var a = t[i];
        if (a.type === `infix`) {
          if (n !== -1) throw new e(`only one infix operator per group`, a.token);
          ((n = i), (r = a.replaceWith));
        }
      }
      if (n !== -1 && r) {
        var o,
          s,
          c = t.slice(0, n),
          l = t.slice(n + 1);
        return (
          (o =
            c.length === 1 && c[0].type === `ordgroup`
              ? c[0]
              : {
                  type: `ordgroup`,
                  mode: this.mode,
                  body: c,
                }),
          (s =
            l.length === 1 && l[0].type === `ordgroup`
              ? l[0]
              : {
                  type: `ordgroup`,
                  mode: this.mode,
                  body: l,
                }),
          [
            r === `\\\\abovefrac`
              ? this.callFunction(r, [o, t[n], s], [])
              : this.callFunction(r, [o, s], []),
          ]
        );
      } else return t;
    }
    handleSupSubscript(t) {
      var n = this.fetch(),
        r = n.text;
      (this.consume(), this.consumeSpaces());
      var i;
      do i = this.parseGroup(t);
      while (i?.type === `internal`);
      if (!i) throw new e(`Expected group after '` + r + `'`, n);
      return i;
    }
    formatUnsupportedCmd(e) {
      for (var t = [], n = 0; n < e.length; n++)
        t.push({
          type: `textord`,
          mode: `text`,
          text: e[n],
        });
      var r = {
        type: `text`,
        mode: this.mode,
        body: t,
      };
      return {
        type: `color`,
        mode: this.mode,
        color: this.settings.errorColor,
        body: [r],
      };
    }
    parseAtom(t) {
      var n = this.parseGroup(`atom`, t);
      if (n?.type === `internal` || this.mode === `text`) return n;
      for (var r, i; ;) {
        this.consumeSpaces();
        var a = this.fetch();
        if (a.text === `\\limits` || a.text === `\\nolimits`) {
          if (n && n.type === `op`)
            ((n.limits = a.text === `\\limits`), (n.alwaysHandleSupSub = !0));
          else if (n && n.type === `operatorname`)
            n.alwaysHandleSupSub && (n.limits = a.text === `\\limits`);
          else throw new e(`Limit controls must follow a math operator`, a);
          this.consume();
        } else if (a.text === `^`) {
          if (r) throw new e(`Double superscript`, a);
          r = this.handleSupSubscript(`superscript`);
        } else if (a.text === `_`) {
          if (i) throw new e(`Double subscript`, a);
          i = this.handleSupSubscript(`subscript`);
        } else if (a.text === `'`) {
          if (r) throw new e(`Double superscript`, a);
          var o = {
              type: `textord`,
              mode: this.mode,
              text: `\\prime`,
            },
            s = [o];
          for (this.consume(); this.fetch().text === `'`;) (s.push(o), this.consume());
          (this.fetch().text === `^` && s.push(this.handleSupSubscript(`superscript`)),
            (r = {
              type: `ordgroup`,
              mode: this.mode,
              body: s,
            }));
        } else if (pa[a.text]) {
          var c = fa.test(a.text),
            l = [];
          for (l.push(new ti(pa[a.text])), this.consume(); ;) {
            var u = this.fetch().text;
            if (!pa[u] || fa.test(u) !== c) break;
            (l.unshift(new ti(pa[u])), this.consume());
          }
          var d = this.subparse(l);
          c
            ? (i = {
                type: `ordgroup`,
                mode: `math`,
                body: d,
              })
            : (r = {
                type: `ordgroup`,
                mode: `math`,
                body: d,
              });
        } else break;
      }
      return r && i
        ? {
            type: `supsub`,
            mode: this.mode,
            base: n,
            sup: r,
            sub: i,
          }
        : r
          ? {
              type: `supsub`,
              mode: this.mode,
              base: n,
              sup: r,
            }
          : i
            ? {
                type: `supsub`,
                mode: this.mode,
                base: n,
                sub: i,
              }
            : n;
    }
    parseFunction(t, n) {
      var r = this.fetch(),
        i = r.text,
        a = Gi[i];
      if (!a) return null;
      if ((this.consume(), n && n !== `atom` && !a.allowedInArgument))
        throw new e(`Got function '` + i + `' with no arguments` + (n ? ` as ` + n : ``), r);
      if (this.mode === `text` && !a.allowedInText)
        throw new e(`Can't use function '` + i + `' in text mode`, r);
      if (this.mode === `math` && a.allowedInMath === !1)
        throw new e(`Can't use function '` + i + `' in math mode`, r);
      var { args: o, optArgs: s } = this.parseArguments(i, a);
      return this.callFunction(i, o, s, r, t);
    }
    callFunction(t, n, r, i, a) {
      var o = {
          funcName: t,
          parser: this,
          token: i,
          breakOnTokenText: a,
        },
        s = Gi[t];
      if (s && s.handler) return s.handler(o, n, r);
      throw new e(`No function handler for ` + t);
    }
    parseArguments(t, n) {
      var r = n.numOptionalArgs ?? 0,
        i = n.numArgs + r;
      if (i === 0)
        return {
          args: [],
          optArgs: [],
        };
      for (var a = [], o = [], s = 0; s < i; s++) {
        var c = n.argTypes?.[s],
          l = s < r;
        ((`primitive` in n && n.primitive && c == null) ||
          (n.type === `sqrt` && s === 1 && o[0] == null)) &&
          (c = `primitive`);
        var u = this.parseGroupOfType(`argument to '` + t + `'`, c, l);
        if (l) o.push(u);
        else if (u != null) a.push(u);
        else throw new e(`Null argument, please report this as a bug`);
      }
      return {
        args: a,
        optArgs: o,
      };
    }
    parseGroupOfType(t, n, r) {
      switch (n) {
        case `color`:
          return this.parseColorGroup(r);
        case `size`:
          return this.parseSizeGroup(r);
        case `url`:
          return this.parseUrlGroup(r);
        case `math`:
        case `text`:
          return this.parseArgumentGroup(r, n);
        case `hbox`:
          var i = this.parseArgumentGroup(r, `text`);
          return i == null
            ? null
            : {
                type: `styling`,
                mode: i.mode,
                body: [i],
                style: `text`,
                resetFont: !0,
              };
        case `raw`:
          var a = this.parseStringGroup(r);
          return a == null
            ? null
            : {
                type: `raw`,
                mode: `text`,
                string: a.text,
              };
        case `primitive`:
          if (r) throw new e(`A primitive argument cannot be optional`);
          var o = this.parseGroup(t);
          if (o == null) throw new e(`Expected group as ` + t, this.fetch());
          return o;
        case `original`:
        case void 0:
          return this.parseArgumentGroup(r);
        default:
          throw new e(`Unknown group type as ` + t, this.fetch());
      }
    }
    consumeSpaces() {
      for (; this.fetch().text === ` `;) this.consume();
    }
    parseStringGroup(e) {
      var t = this.gullet.scanArgument(e);
      if (t == null) return null;
      for (var n = ``, r; (r = this.fetch()).text !== `EOF`;) ((n += r.text), this.consume());
      return (this.consume(), (t.text = n), t);
    }
    parseRegexGroup(t, n) {
      for (
        var r = this.fetch(), i = r, a = ``, o;
        (o = this.fetch()).text !== `EOF` && t.test(a + o.text);
      )
        ((i = o), (a += i.text), this.consume());
      if (a === ``) throw new e(`Invalid ` + n + `: '` + r.text + `'`, r);
      return r.range(i, a);
    }
    parseColorGroup(t) {
      var n = this.parseStringGroup(t);
      if (n == null) return null;
      var r = /^(#[a-f0-9]{3,4}|#[a-f0-9]{6}|#[a-f0-9]{8}|[a-f0-9]{6}|[a-z]+)$/i.exec(n.text);
      if (!r) throw new e(`Invalid color: '` + n.text + `'`, n);
      var i = r[0];
      return (
        /^[0-9a-f]{6}$/i.test(i) && (i = `#` + i),
        {
          type: `color-token`,
          mode: this.mode,
          color: i,
        }
      );
    }
    parseSizeGroup(t) {
      var n,
        r = !1;
      if (
        (this.gullet.consumeSpaces(),
        (n =
          !t && this.gullet.future().text !== `{`
            ? this.parseRegexGroup(/^[-+]? *(?:$|\d+|\d+\.\d*|\.\d*) *[a-z]{0,2} *$/, `size`)
            : this.parseStringGroup(t)),
        !n)
      )
        return null;
      !t && n.text.length === 0 && ((n.text = `0pt`), (r = !0));
      var i = /([-+]?) *(\d+(?:\.\d*)?|\.\d+) *([a-z]{2})/.exec(n.text);
      if (!i) throw new e(`Invalid size: '` + n.text + `'`, n);
      var a = {
        number: +(i[1] + i[2]),
        unit: i[3],
      };
      if (!we(a)) throw new e(`Invalid unit: '` + a.unit + `'`, n);
      return {
        type: `size`,
        mode: this.mode,
        value: a,
        isBlank: r,
      };
    }
    parseUrlGroup(e) {
      (this.gullet.lexer.setCatcode(`%`, 13), this.gullet.lexer.setCatcode(`~`, 12));
      var t = this.parseStringGroup(e);
      if ((this.gullet.lexer.setCatcode(`%`, 14), this.gullet.lexer.setCatcode(`~`, 13), t == null))
        return null;
      var n = t.text.replace(/\\([#$%&~_^{}])/g, `$1`);
      return {
        type: `url`,
        mode: this.mode,
        url: n,
      };
    }
    parseArgumentGroup(e, t) {
      var n = this.gullet.scanArgument(e);
      if (n == null) return null;
      var r = this.mode;
      (t && this.switchMode(t), this.gullet.beginGroup());
      var i = this.parseExpression(!1, `EOF`);
      (this.expect(`EOF`), this.gullet.endGroup());
      var a = {
        type: `ordgroup`,
        mode: this.mode,
        loc: n.loc,
        body: i,
      };
      return (t && this.switchMode(r), a);
    }
    parseGroup(t, n) {
      var r = this.fetch(),
        i = r.text,
        a;
      if (i === `{` || i === `\\begingroup`) {
        this.consume();
        var o = i === `{` ? `}` : `\\endgroup`;
        this.gullet.beginGroup();
        var s = this.parseExpression(!1, o),
          c = this.fetch();
        (this.expect(o),
          this.gullet.endGroup(),
          (a = {
            type: `ordgroup`,
            mode: this.mode,
            loc: ei.range(r, c),
            body: s,
            semisimple: i === `\\begingroup` || void 0,
          }));
      } else if (
        ((a = this.parseFunction(n, t) || this.parseSymbol()),
        a == null && i[0] === `\\` && !ua.hasOwnProperty(i))
      ) {
        if (this.settings.throwOnError) throw new e(`Undefined control sequence: ` + i, r);
        ((a = this.formatUnsupportedCmd(i)), this.consume());
      }
      return a;
    }
    formLigatures(e) {
      for (var t = e.length - 1, n = 0; n < t; ++n) {
        var r = e[n];
        if (r.type === `textord`) {
          var i = r.text,
            a = e[n + 1];
          if (!(!a || a.type !== `textord`)) {
            if (i === `-` && a.text === `-`) {
              var o = e[n + 2];
              n + 1 < t && o && o.type === `textord` && o.text === `-`
                ? (e.splice(n, 3, {
                    type: `textord`,
                    mode: `text`,
                    loc: ei.range(r, o),
                    text: `---`,
                  }),
                  (t -= 2))
                : (e.splice(n, 2, {
                    type: `textord`,
                    mode: `text`,
                    loc: ei.range(r, a),
                    text: `--`,
                  }),
                  --t);
            }
            (i === `'` || i === "`") &&
              a.text === i &&
              (e.splice(n, 2, {
                type: `textord`,
                mode: `text`,
                loc: ei.range(r, a),
                text: i + i,
              }),
              --t);
          }
        }
      }
    }
    parseSymbol() {
      var t = this.fetch(),
        n = t.text;
      if (/^\\verb[^a-zA-Z]/.test(n)) {
        this.consume();
        var r = n.slice(5),
          i = r.charAt(0) === `*`;
        if ((i && (r = r.slice(1)), r.length < 2 || r.charAt(0) !== r.slice(-1)))
          throw new e(`\\verb assertion failed --
                    please report what input caused this bug`);
        return (
          (r = r.slice(1, -1)),
          {
            type: `verb`,
            mode: `text`,
            body: r,
            star: i,
          }
        );
      }
      ha.hasOwnProperty(n[0]) &&
        !qe[this.mode][n[0]] &&
        (this.settings.strict &&
          this.mode === `math` &&
          this.settings.reportNonstrict(
            `unicodeTextInMathMode`,
            `Accented Unicode text character "` + n[0] + `" used in math mode`,
            t,
          ),
        (n = ha[n[0]] + n.slice(1)));
      var a = Qi.exec(n);
      a && ((n = n.substring(0, a.index)), n === `i` ? (n = `ı`) : n === `j` && (n = `ȷ`));
      var o;
      if (qe[this.mode][n]) {
        this.settings.strict &&
          this.mode === `math` &&
          mt.includes(n) &&
          this.settings.reportNonstrict(
            `unicodeTextInMathMode`,
            `Latin-1/Unicode text character "` + n[0] + `" used in math mode`,
            t,
          );
        var s = qe[this.mode][n].group,
          c = ei.range(t);
        o = Xn(s)
          ? {
              type: `atom`,
              mode: this.mode,
              family: s,
              loc: c,
              text: n,
            }
          : {
              type: s,
              mode: this.mode,
              loc: c,
              text: n,
            };
      } else if (n.charCodeAt(0) >= 128)
        (this.settings.strict &&
          (ce(n.charCodeAt(0))
            ? this.mode === `math` &&
              this.settings.reportNonstrict(
                `unicodeTextInMathMode`,
                `Unicode text character "` + n[0] + `" used in math mode`,
                t,
              )
            : this.settings.reportNonstrict(
                `unknownSymbol`,
                `Unrecognized Unicode character "` + n[0] + `"` + (` (` + n.charCodeAt(0) + `)`),
                t,
              )),
          (o = {
            type: `textord`,
            mode: `text`,
            loc: ei.range(t),
            text: n,
          }));
      else return null;
      if ((this.consume(), a))
        for (var l = 0; l < a[0].length; l++) {
          var u = a[0][l];
          if (!ma[u]) throw new e(`Unknown accent ' ` + u + `'`, t);
          var d = ma[u][this.mode] || ma[u].text;
          if (!d) throw new e(`Accent ` + u + ` unsupported in ` + this.mode + ` mode`, t);
          o = {
            type: `accent`,
            mode: this.mode,
            loc: ei.range(t),
            label: d,
            isStretchy: !1,
            isShifty: !0,
            base: o,
          };
        }
      return o;
    }
  };
ga.endOfExpression = new Set([`}`, `\\endgroup`, `\\end`, `\\right`, `&`]);
var _a = function (t, n) {
    if (!(typeof t == `string` || t instanceof String))
      throw TypeError(`KaTeX can only parse string typed expression`);
    var r = new ga(t, n);
    delete r.gullet.macros.current[`\\df@tag`];
    var i = r.parse();
    if (
      (delete r.gullet.macros.current[`\\current@color`],
      delete r.gullet.macros.current[`\\color`],
      r.gullet.macros.get(`\\df@tag`))
    ) {
      if (!n.displayMode) throw new e(`\\tag works only in display equations`);
      i = [
        {
          type: `tag`,
          mode: `text`,
          body: i,
          tag: r.subparse([new ti(`\\df@tag`)]),
        },
      ];
    }
    return i;
  },
  va = function (e, t, n) {
    t.textContent = ``;
    var r = Sa(e, n).toNode();
    t.appendChild(r);
  };
typeof document < `u` &&
  document.compatMode !== `CSS1Compat` &&
  (typeof console < `u` &&
    console.warn(
      `Warning: KaTeX doesn't work in quirks mode. Make sure your website has a suitable doctype.`,
    ),
  (va = function () {
    throw new e(`KaTeX doesn't work in quirks mode.`);
  }));
var ya = function (e, t) {
    return Sa(e, t).toMarkup();
  },
  ba = function (e, t) {
    return _a(e, new m(t));
  },
  xa = function (t, n, r) {
    if (r.throwOnError || !(t instanceof e)) throw t;
    var i = W([`katex-error`], [new Pe(n)]);
    return (
      i.setAttribute(`title`, t.toString()),
      i.setAttribute(`style`, `color:` + r.errorColor),
      i
    );
  },
  Sa = function (e, t) {
    var n = new m(t);
    try {
      return Bn(_a(e, n), e, n);
    } catch (t) {
      return xa(t, e, n);
    }
  };
((window.katex = {
  version: `0.17.0`,
  render: va,
  renderToString: ya,
  ParseError: e,
  SETTINGS_SCHEMA: u,
  __parse: ba,
  __renderToDomTree: Sa,
  __renderToHTMLTree: function (e, t) {
    var n = new m(t);
    try {
      return Vn(_a(e, n), e, n);
    } catch (t) {
      return xa(t, e, n);
    }
  },
  __setFontMetrics: We,
  __defineSymbol: N,
  __defineFunction: K,
  __defineMacro: Z,
  __domTree: {
    Span: Ae,
    Anchor: je,
    SymbolNode: Pe,
    SvgNode: Fe,
    PathNode: Ie,
    LineNode: Le,
  },
}),
  document.addEventListener(`DOMContentLoaded`, () => {
    window.katex &&
      document.querySelectorAll(`.math`).forEach((e) => {
        window.katex.render(e.dataset.katex, e, {
          throwOnError: !1,
        });
      });
  }));
var Ca = Object.create,
  wa = Object.defineProperty,
  Ta = Object.getOwnPropertyDescriptor,
  Ea = Object.getOwnPropertyNames,
  Da = Object.getPrototypeOf,
  Oa = Object.prototype.hasOwnProperty,
  ka = (e, t) =>
    function () {
      return (
        t ||
          (0, e[Ea(e)[0]])(
            (t = {
              exports: {},
            }).exports,
            t,
          ),
        t.exports
      );
    },
  Aa = (e, t, n, r) => {
    if ((t && typeof t == `object`) || typeof t == `function`)
      for (let i of Ea(t))
        !Oa.call(e, i) &&
          i !== n &&
          wa(e, i, {
            get: () => t[i],
            enumerable: !(r = Ta(t, i)) || r.enumerable,
          });
    return e;
  },
  Q = (e, t, n) => (
    (n = e == null ? {} : Ca(Da(e))),
    Aa(
      t || !e || !e.__esModule
        ? wa(n, `default`, {
            value: e,
            enumerable: !0,
          })
        : n,
      e,
    )
  ),
  ja = ka({
    "node_modules/alpinejs/dist/module.cjs.js"(e, t) {
      var n = Object.create,
        r = Object.defineProperty,
        i = Object.getOwnPropertyDescriptor,
        a = Object.getOwnPropertyNames,
        o = Object.getPrototypeOf,
        s = Object.prototype.hasOwnProperty,
        c = (e, t) =>
          function () {
            return (
              t ||
                (0, e[a(e)[0]])(
                  (t = {
                    exports: {},
                  }).exports,
                  t,
                ),
              t.exports
            );
          },
        l = (e, t) => {
          for (var n in t)
            r(e, n, {
              get: t[n],
              enumerable: !0,
            });
        },
        u = (e, t, n, o) => {
          if ((t && typeof t == `object`) || typeof t == `function`)
            for (let c of a(t))
              !s.call(e, c) &&
                c !== n &&
                r(e, c, {
                  get: () => t[c],
                  enumerable: !(o = i(t, c)) || o.enumerable,
                });
          return e;
        },
        d = (e, t, i) => (
          (i = e == null ? {} : n(o(e))),
          u(
            t || !e || !e.__esModule
              ? r(i, `default`, {
                  value: e,
                  enumerable: !0,
                })
              : i,
            e,
          )
        ),
        f = (e) =>
          u(
            r({}, `__esModule`, {
              value: !0,
            }),
            e,
          ),
        p = c({
          "node_modules/@vue/shared/dist/shared.cjs.js"(e) {
            Object.defineProperty(e, "__esModule", {
              value: !0,
            });
            function t(e, t) {
              let n = Object.create(null),
                r = e.split(`,`);
              for (let e = 0; e < r.length; e++) n[r[e]] = !0;
              return t ? (e) => !!n[e.toLowerCase()] : (e) => !!n[e];
            }
            var n = {
                1: `TEXT`,
                2: `CLASS`,
                4: `STYLE`,
                8: `PROPS`,
                16: `FULL_PROPS`,
                32: `HYDRATE_EVENTS`,
                64: `STABLE_FRAGMENT`,
                128: `KEYED_FRAGMENT`,
                256: `UNKEYED_FRAGMENT`,
                512: `NEED_PATCH`,
                1024: `DYNAMIC_SLOTS`,
                2048: `DEV_ROOT_FRAGMENT`,
                [-1]: `HOISTED`,
                [-2]: `BAIL`,
              },
              r = {
                1: `STABLE`,
                2: `DYNAMIC`,
                3: `FORWARDED`,
              },
              i = t(
                `Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt`,
              ),
              a = 2;
            function o(e, t = 0, n = e.length) {
              let r = e.split(/(\r?\n)/),
                i = r.filter((e, t) => t % 2 == 1);
              r = r.filter((e, t) => t % 2 == 0);
              let o = 0,
                s = [];
              for (let e = 0; e < r.length; e++)
                if (((o += r[e].length + ((i[e] && i[e].length) || 0)), o >= t)) {
                  for (let c = e - a; c <= e + a || n > o; c++) {
                    if (c < 0 || c >= r.length) continue;
                    let a = c + 1;
                    s.push(`${a}${` `.repeat(Math.max(3 - String(a).length, 0))}|  ${r[c]}`);
                    let l = r[c].length,
                      u = (i[c] && i[c].length) || 0;
                    if (c === e) {
                      let e = t - (o - (l + u)),
                        r = Math.max(1, n > o ? l - e : n - t);
                      s.push(`   |  ` + ` `.repeat(e) + `^`.repeat(r));
                    } else if (c > e) {
                      if (n > o) {
                        let e = Math.max(Math.min(n - o, l), 1);
                        s.push(`   |  ` + `^`.repeat(e));
                      }
                      o += l + u;
                    }
                  }
                  break;
                }
              return s.join(`
`);
            }
            var s = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`,
              c = t(s),
              l = t(
                s +
                  `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`,
              ),
              u = /[>/="'\u0009\u000a\u000c\u0020]/,
              d = {};
            function f(e) {
              if (d.hasOwnProperty(e)) return d[e];
              let t = u.test(e);
              return (t && console.error(`unsafe attribute name: ${e}`), (d[e] = !t));
            }
            var p = {
                acceptCharset: `accept-charset`,
                className: `class`,
                htmlFor: `for`,
                httpEquiv: `http-equiv`,
              },
              m = t(
                `animation-iteration-count,border-image-outset,border-image-slice,border-image-width,box-flex,box-flex-group,box-ordinal-group,column-count,columns,flex,flex-grow,flex-positive,flex-shrink,flex-negative,flex-order,grid-row,grid-row-end,grid-row-span,grid-row-start,grid-column,grid-column-end,grid-column-span,grid-column-start,font-weight,line-clamp,line-height,opacity,order,orphans,tab-size,widows,z-index,zoom,fill-opacity,flood-opacity,stop-opacity,stroke-dasharray,stroke-dashoffset,stroke-miterlimit,stroke-opacity,stroke-width`,
              ),
              h = t(
                `accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap`,
              );
            function g(e) {
              if (be(e)) {
                let t = {};
                for (let n = 0; n < e.length; n++) {
                  let r = e[n],
                    i = g(k(r) ? y(r) : r);
                  if (i) for (let e in i) t[e] = i[e];
                }
                return t;
              } else if (j(e)) return e;
            }
            var _ = /;(?![^(]*\))/g,
              v = /:(.+)/;
            function y(e) {
              let t = {};
              return (
                e.split(_).forEach((e) => {
                  if (e) {
                    let n = e.split(v);
                    n.length > 1 && (t[n[0].trim()] = n[1].trim());
                  }
                }),
                t
              );
            }
            function b(e) {
              let t = ``;
              if (!e) return t;
              for (let n in e) {
                let r = e[n],
                  i = n.startsWith(`--`) ? n : Ie(n);
                (k(r) || (typeof r == `number` && m(i))) && (t += `${i}:${r};`);
              }
              return t;
            }
            function x(e) {
              let t = ``;
              if (k(e)) t = e;
              else if (be(e))
                for (let n = 0; n < e.length; n++) {
                  let r = x(e[n]);
                  r && (t += r + ` `);
                }
              else if (j(e)) for (let n in e) e[n] && (t += n + ` `);
              return t.trim();
            }
            var S = `html,body,base,head,link,meta,style,title,address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot`,
              C = `svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistanceLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view`,
              w = `area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr`,
              ee = t(S),
              T = t(C),
              te = t(w),
              ne = /["'&<>]/;
            function re(e) {
              let t = `` + e,
                n = ne.exec(t);
              if (!n) return t;
              let r = ``,
                i,
                a,
                o = 0;
              for (a = n.index; a < t.length; a++) {
                switch (t.charCodeAt(a)) {
                  case 34:
                    i = `&quot;`;
                    break;
                  case 38:
                    i = `&amp;`;
                    break;
                  case 39:
                    i = `&#39;`;
                    break;
                  case 60:
                    i = `&lt;`;
                    break;
                  case 62:
                    i = `&gt;`;
                    break;
                  default:
                    continue;
                }
                (o !== a && (r += t.substring(o, a)), (o = a + 1), (r += i));
              }
              return o === a ? r : r + t.substring(o, a);
            }
            var ie = /^-?>|<!--|-->|--!>|<!-$/g;
            function E(e) {
              return e.replace(ie, ``);
            }
            function ae(e, t) {
              if (e.length !== t.length) return !1;
              let n = !0;
              for (let r = 0; n && r < e.length; r++) n = oe(e[r], t[r]);
              return n;
            }
            function oe(e, t) {
              if (e === t) return !0;
              let n = Ce(e),
                r = Ce(t);
              if (n || r) return n && r ? e.getTime() === t.getTime() : !1;
              if (((n = be(e)), (r = be(t)), n || r)) return n && r ? ae(e, t) : !1;
              if (((n = j(e)), (r = j(t)), n || r)) {
                if (!n || !r || Object.keys(e).length !== Object.keys(t).length) return !1;
                for (let n in e) {
                  let r = e.hasOwnProperty(n),
                    i = t.hasOwnProperty(n);
                  if ((r && !i) || (!r && i) || !oe(e[n], t[n])) return !1;
                }
              }
              return String(e) === String(t);
            }
            function se(e, t) {
              return e.findIndex((e) => oe(e, t));
            }
            var ce = (e) => (e == null ? `` : j(e) ? JSON.stringify(e, D, 2) : String(e)),
              D = (e, t) =>
                xe(t)
                  ? {
                      [`Map(${t.size})`]: [...t.entries()].reduce(
                        (e, [t, n]) => ((e[`${t} =>`] = n), e),
                        {},
                      ),
                    }
                  : Se(t)
                    ? {
                        [`Set(${t.size})`]: [...t.values()],
                      }
                    : j(t) && !be(t) && !ke(t)
                      ? String(t)
                      : t,
              le = [`bigInt`, `optionalChaining`, `nullishCoalescingOperator`],
              ue = Object.freeze({}),
              de = Object.freeze([]),
              fe = () => {},
              pe = () => !1,
              O = /^on[^a-z]/,
              me = (e) => O.test(e),
              he = (e) => e.startsWith(`onUpdate:`),
              ge = Object.assign,
              _e = (e, t) => {
                let n = e.indexOf(t);
                n > -1 && e.splice(n, 1);
              },
              ve = Object.prototype.hasOwnProperty,
              ye = (e, t) => ve.call(e, t),
              be = Array.isArray,
              xe = (e) => De(e) === `[object Map]`,
              Se = (e) => De(e) === `[object Set]`,
              Ce = (e) => e instanceof Date,
              we = (e) => typeof e == `function`,
              k = (e) => typeof e == `string`,
              A = (e) => typeof e == `symbol`,
              j = (e) => typeof e == `object` && !!e,
              Te = (e) => j(e) && we(e.then) && we(e.catch),
              Ee = Object.prototype.toString,
              De = (e) => Ee.call(e),
              Oe = (e) => De(e).slice(8, -1),
              ke = (e) => De(e) === `[object Object]`,
              Ae = (e) => k(e) && e !== `NaN` && e[0] !== `-` && `` + parseInt(e, 10) === e,
              je = t(
                `,key,ref,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted`,
              ),
              Me = (e) => {
                let t = Object.create(null);
                return (n) => t[n] || (t[n] = e(n));
              },
              Ne = /-(\w)/g,
              Pe = Me((e) => e.replace(Ne, (e, t) => (t ? t.toUpperCase() : ``))),
              Fe = /\B([A-Z])/g,
              Ie = Me((e) => e.replace(Fe, `-$1`).toLowerCase()),
              Le = Me((e) => e.charAt(0).toUpperCase() + e.slice(1)),
              Re = Me((e) => (e ? `on${Le(e)}` : ``)),
              ze = (e, t) => e !== t && (e === e || t === t),
              Be = (e, t) => {
                for (let n = 0; n < e.length; n++) e[n](t);
              },
              Ve = (e, t, n) => {
                Object.defineProperty(e, t, {
                  configurable: !0,
                  enumerable: !1,
                  value: n,
                });
              },
              He = (e) => {
                let t = parseFloat(e);
                return isNaN(t) ? e : t;
              },
              Ue;
            ((e.EMPTY_ARR = de),
              (e.EMPTY_OBJ = ue),
              (e.NO = pe),
              (e.NOOP = fe),
              (e.PatchFlagNames = n),
              (e.babelParserDefaultPlugins = le),
              (e.camelize = Pe),
              (e.capitalize = Le),
              (e.def = Ve),
              (e.escapeHtml = re),
              (e.escapeHtmlComment = E),
              (e.extend = ge),
              (e.generateCodeFrame = o),
              (e.getGlobalThis = () =>
                (Ue ||=
                  typeof globalThis < `u`
                    ? globalThis
                    : typeof self < `u`
                      ? self
                      : typeof window < `u`
                        ? window
                        : typeof global < `u`
                          ? global
                          : {})),
              (e.hasChanged = ze),
              (e.hasOwn = ye),
              (e.hyphenate = Ie),
              (e.invokeArrayFns = Be),
              (e.isArray = be),
              (e.isBooleanAttr = l),
              (e.isDate = Ce),
              (e.isFunction = we),
              (e.isGloballyWhitelisted = i),
              (e.isHTMLTag = ee),
              (e.isIntegerKey = Ae),
              (e.isKnownAttr = h),
              (e.isMap = xe),
              (e.isModelListener = he),
              (e.isNoUnitNumericStyleProp = m),
              (e.isObject = j),
              (e.isOn = me),
              (e.isPlainObject = ke),
              (e.isPromise = Te),
              (e.isReservedProp = je),
              (e.isSSRSafeAttrName = f),
              (e.isSVGTag = T),
              (e.isSet = Se),
              (e.isSpecialBooleanAttr = c),
              (e.isString = k),
              (e.isSymbol = A),
              (e.isVoidTag = te),
              (e.looseEqual = oe),
              (e.looseIndexOf = se),
              (e.makeMap = t),
              (e.normalizeClass = x),
              (e.normalizeStyle = g),
              (e.objectToString = Ee),
              (e.parseStringStyle = y),
              (e.propsToAttrMap = p),
              (e.remove = _e),
              (e.slotFlagsText = r),
              (e.stringifyStyle = b),
              (e.toDisplayString = ce),
              (e.toHandlerKey = Re),
              (e.toNumber = He),
              (e.toRawType = Oe),
              (e.toTypeString = De));
          },
        }),
        m = c({
          "node_modules/@vue/shared/index.js"(e, t) {
            t.exports = p();
          },
        }),
        h = c({
          "node_modules/@vue/reactivity/dist/reactivity.cjs.js"(e) {
            Object.defineProperty(e, "__esModule", {
              value: !0,
            });
            var t = m(),
              n = new WeakMap(),
              r = [],
              i,
              a = Symbol(`iterate`),
              o = Symbol(`Map key iterate`);
            function s(e) {
              return e && e._isEffect === !0;
            }
            function c(e, n = t.EMPTY_OBJ) {
              s(e) && (e = e.raw);
              let r = d(e, n);
              return (n.lazy || r(), r);
            }
            function l(e) {
              e.active &&= (f(e), e.options.onStop && e.options.onStop(), !1);
            }
            var u = 0;
            function d(e, t) {
              let n = function () {
                if (!n.active) return e();
                if (!r.includes(n)) {
                  f(n);
                  try {
                    return (_(), r.push(n), (i = n), e());
                  } finally {
                    (r.pop(), v(), (i = r[r.length - 1]));
                  }
                }
              };
              return (
                (n.id = u++),
                (n.allowRecurse = !!t.allowRecurse),
                (n._isEffect = !0),
                (n.active = !0),
                (n.raw = e),
                (n.deps = []),
                (n.options = t),
                n
              );
            }
            function f(e) {
              let { deps: t } = e;
              if (t.length) {
                for (let n = 0; n < t.length; n++) t[n].delete(e);
                t.length = 0;
              }
            }
            var p = !0,
              h = [];
            function g() {
              (h.push(p), (p = !1));
            }
            function _() {
              (h.push(p), (p = !0));
            }
            function v() {
              let e = h.pop();
              p = e === void 0 ? !0 : e;
            }
            function y(e, t, r) {
              if (!p || i === void 0) return;
              let a = n.get(e);
              a || n.set(e, (a = new Map()));
              let o = a.get(r);
              (o || a.set(r, (o = new Set())),
                o.has(i) ||
                  (o.add(i),
                  i.deps.push(o),
                  i.options.onTrack &&
                    i.options.onTrack({
                      effect: i,
                      target: e,
                      type: t,
                      key: r,
                    })));
            }
            function b(e, r, s, c, l, u) {
              let d = n.get(e);
              if (!d) return;
              let f = new Set(),
                p = (e) => {
                  e &&
                    e.forEach((e) => {
                      (e !== i || e.allowRecurse) && f.add(e);
                    });
                };
              if (r === `clear`) d.forEach(p);
              else if (s === `length` && t.isArray(e))
                d.forEach((e, t) => {
                  (t === `length` || t >= c) && p(e);
                });
              else
                switch ((s !== void 0 && p(d.get(s)), r)) {
                  case `add`:
                    t.isArray(e)
                      ? t.isIntegerKey(s) && p(d.get(`length`))
                      : (p(d.get(a)), t.isMap(e) && p(d.get(o)));
                    break;
                  case `delete`:
                    t.isArray(e) || (p(d.get(a)), t.isMap(e) && p(d.get(o)));
                    break;
                  case `set`:
                    t.isMap(e) && p(d.get(a));
                    break;
                }
              f.forEach((t) => {
                (t.options.onTrigger &&
                  t.options.onTrigger({
                    effect: t,
                    target: e,
                    key: s,
                    type: r,
                    newValue: c,
                    oldValue: l,
                    oldTarget: u,
                  }),
                  t.options.scheduler ? t.options.scheduler(t) : t());
              });
            }
            var x = t.makeMap(`__proto__,__v_isRef,__isVue`),
              S = new Set(
                Object.getOwnPropertyNames(Symbol)
                  .map((e) => Symbol[e])
                  .filter(t.isSymbol),
              ),
              C = re(),
              w = re(!1, !0),
              ee = re(!0),
              T = re(!0, !0),
              te = ne();
            function ne() {
              let e = {};
              return (
                [`includes`, `indexOf`, `lastIndexOf`].forEach((t) => {
                  e[t] = function (...e) {
                    let n = M(this);
                    for (let e = 0, t = this.length; e < t; e++) y(n, `get`, e + ``);
                    let r = n[t](...e);
                    return r === -1 || r === !1 ? n[t](...e.map(M)) : r;
                  };
                }),
                [`push`, `pop`, `shift`, `unshift`, `splice`].forEach((t) => {
                  e[t] = function (...e) {
                    g();
                    let n = M(this)[t].apply(this, e);
                    return (v(), n);
                  };
                }),
                e
              );
            }
            function re(e = !1, n = !1) {
              return function (r, i, a) {
                if (i === `__v_isReactive`) return !e;
                if (i === `__v_isReadonly`) return e;
                if (i === `__v_raw` && a === (e ? (n ? Ie : Fe) : n ? Pe : Ne).get(r)) return r;
                let o = t.isArray(r);
                if (!e && o && t.hasOwn(te, i)) return Reflect.get(te, i, a);
                let s = Reflect.get(r, i, a);
                return (t.isSymbol(i) ? S.has(i) : x(i)) || (e || y(r, `get`, i), n)
                  ? s
                  : P(s)
                    ? !o || !t.isIntegerKey(i)
                      ? s.value
                      : s
                    : t.isObject(s)
                      ? e
                        ? Ve(s)
                        : ze(s)
                      : s;
              };
            }
            var ie = ae(),
              E = ae(!0);
            function ae(e = !1) {
              return function (n, r, i, a) {
                let o = n[r];
                if (!e && ((i = M(i)), (o = M(o)), !t.isArray(n) && P(o) && !P(i)))
                  return ((o.value = i), !0);
                let s = t.isArray(n) && t.isIntegerKey(r) ? Number(r) < n.length : t.hasOwn(n, r),
                  c = Reflect.set(n, r, i, a);
                return (
                  n === M(a) &&
                    (s ? t.hasChanged(i, o) && b(n, `set`, r, i, o) : b(n, `add`, r, i)),
                  c
                );
              };
            }
            function oe(e, n) {
              let r = t.hasOwn(e, n),
                i = e[n],
                a = Reflect.deleteProperty(e, n);
              return (a && r && b(e, `delete`, n, void 0, i), a);
            }
            function se(e, n) {
              let r = Reflect.has(e, n);
              return ((!t.isSymbol(n) || !S.has(n)) && y(e, `has`, n), r);
            }
            function ce(e) {
              return (y(e, `iterate`, t.isArray(e) ? `length` : a), Reflect.ownKeys(e));
            }
            var D = {
                get: C,
                set: ie,
                deleteProperty: oe,
                has: se,
                ownKeys: ce,
              },
              le = {
                get: ee,
                set(e, t) {
                  return (
                    console.warn(
                      `Set operation on key "${String(t)}" failed: target is readonly.`,
                      e,
                    ),
                    !0
                  );
                },
                deleteProperty(e, t) {
                  return (
                    console.warn(
                      `Delete operation on key "${String(t)}" failed: target is readonly.`,
                      e,
                    ),
                    !0
                  );
                },
              },
              ue = t.extend({}, D, {
                get: w,
                set: E,
              }),
              de = t.extend({}, le, {
                get: T,
              }),
              fe = (e) => (t.isObject(e) ? ze(e) : e),
              pe = (e) => (t.isObject(e) ? Ve(e) : e),
              O = (e) => e,
              me = (e) => Reflect.getPrototypeOf(e);
            function he(e, t, n = !1, r = !1) {
              e = e.__v_raw;
              let i = M(e),
                a = M(t);
              (t !== a && !n && y(i, `get`, t), !n && y(i, `get`, a));
              let { has: o } = me(i),
                s = r ? O : n ? pe : fe;
              if (o.call(i, t)) return s(e.get(t));
              if (o.call(i, a)) return s(e.get(a));
              e !== i && e.get(t);
            }
            function ge(e, t = !1) {
              let n = this.__v_raw,
                r = M(n),
                i = M(e);
              return (
                e !== i && !t && y(r, `has`, e),
                !t && y(r, `has`, i),
                e === i ? n.has(e) : n.has(e) || n.has(i)
              );
            }
            function _e(e, t = !1) {
              return ((e = e.__v_raw), !t && y(M(e), `iterate`, a), Reflect.get(e, `size`, e));
            }
            function ve(e) {
              e = M(e);
              let t = M(this);
              return (me(t).has.call(t, e) || (t.add(e), b(t, `add`, e, e)), this);
            }
            function ye(e, n) {
              n = M(n);
              let r = M(this),
                { has: i, get: a } = me(r),
                o = i.call(r, e);
              o ? Me(r, i, e) : ((e = M(e)), (o = i.call(r, e)));
              let s = a.call(r, e);
              return (
                r.set(e, n),
                o ? t.hasChanged(n, s) && b(r, `set`, e, n, s) : b(r, `add`, e, n),
                this
              );
            }
            function be(e) {
              let t = M(this),
                { has: n, get: r } = me(t),
                i = n.call(t, e);
              i ? Me(t, n, e) : ((e = M(e)), (i = n.call(t, e)));
              let a = r ? r.call(t, e) : void 0,
                o = t.delete(e);
              return (i && b(t, `delete`, e, void 0, a), o);
            }
            function xe() {
              let e = M(this),
                n = e.size !== 0,
                r = t.isMap(e) ? new Map(e) : new Set(e),
                i = e.clear();
              return (n && b(e, `clear`, void 0, void 0, r), i);
            }
            function Se(e, t) {
              return function (n, r) {
                let i = this,
                  o = i.__v_raw,
                  s = M(o),
                  c = t ? O : e ? pe : fe;
                return (!e && y(s, `iterate`, a), o.forEach((e, t) => n.call(r, c(e), c(t), i)));
              };
            }
            function Ce(e, n, r) {
              return function (...i) {
                let s = this.__v_raw,
                  c = M(s),
                  l = t.isMap(c),
                  u = e === `entries` || (e === Symbol.iterator && l),
                  d = e === `keys` && l,
                  f = s[e](...i),
                  p = r ? O : n ? pe : fe;
                return (
                  !n && y(c, `iterate`, d ? o : a),
                  {
                    next() {
                      let { value: e, done: t } = f.next();
                      return t
                        ? {
                            value: e,
                            done: t,
                          }
                        : {
                            value: u ? [p(e[0]), p(e[1])] : p(e),
                            done: t,
                          };
                    },
                    [Symbol.iterator]() {
                      return this;
                    },
                  }
                );
              };
            }
            function we(e) {
              return function (...n) {
                {
                  let r = n[0] ? `on key "${n[0]}" ` : ``;
                  console.warn(
                    `${t.capitalize(e)} operation ${r}failed: target is readonly.`,
                    M(this),
                  );
                }
                return e === `delete` ? !1 : this;
              };
            }
            function k() {
              let e = {
                  get(e) {
                    return he(this, e);
                  },
                  get size() {
                    return _e(this);
                  },
                  has: ge,
                  add: ve,
                  set: ye,
                  delete: be,
                  clear: xe,
                  forEach: Se(!1, !1),
                },
                t = {
                  get(e) {
                    return he(this, e, !1, !0);
                  },
                  get size() {
                    return _e(this);
                  },
                  has: ge,
                  add: ve,
                  set: ye,
                  delete: be,
                  clear: xe,
                  forEach: Se(!1, !0),
                },
                n = {
                  get(e) {
                    return he(this, e, !0);
                  },
                  get size() {
                    return _e(this, !0);
                  },
                  has(e) {
                    return ge.call(this, e, !0);
                  },
                  add: we(`add`),
                  set: we(`set`),
                  delete: we(`delete`),
                  clear: we(`clear`),
                  forEach: Se(!0, !1),
                },
                r = {
                  get(e) {
                    return he(this, e, !0, !0);
                  },
                  get size() {
                    return _e(this, !0);
                  },
                  has(e) {
                    return ge.call(this, e, !0);
                  },
                  add: we(`add`),
                  set: we(`set`),
                  delete: we(`delete`),
                  clear: we(`clear`),
                  forEach: Se(!0, !0),
                };
              return (
                [`keys`, `values`, `entries`, Symbol.iterator].forEach((i) => {
                  ((e[i] = Ce(i, !1, !1)),
                    (n[i] = Ce(i, !0, !1)),
                    (t[i] = Ce(i, !1, !0)),
                    (r[i] = Ce(i, !0, !0)));
                }),
                [e, n, t, r]
              );
            }
            var [A, j, Te, Ee] = k();
            function De(e, n) {
              let r = n ? (e ? Ee : Te) : e ? j : A;
              return (n, i, a) =>
                i === `__v_isReactive`
                  ? !e
                  : i === `__v_isReadonly`
                    ? e
                    : i === `__v_raw`
                      ? n
                      : Reflect.get(t.hasOwn(r, i) && i in n ? r : n, i, a);
            }
            var Oe = {
                get: De(!1, !1),
              },
              ke = {
                get: De(!1, !0),
              },
              Ae = {
                get: De(!0, !1),
              },
              je = {
                get: De(!0, !0),
              };
            function Me(e, n, r) {
              let i = M(r);
              if (i !== r && n.call(e, i)) {
                let n = t.toRawType(e);
                console.warn(
                  `Reactive ${n} contains both the raw and reactive versions of the same object${n === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`,
                );
              }
            }
            var Ne = new WeakMap(),
              Pe = new WeakMap(),
              Fe = new WeakMap(),
              Ie = new WeakMap();
            function Le(e) {
              switch (e) {
                case `Object`:
                case `Array`:
                  return 1;
                case `Map`:
                case `Set`:
                case `WeakMap`:
                case `WeakSet`:
                  return 2;
                default:
                  return 0;
              }
            }
            function Re(e) {
              return e.__v_skip || !Object.isExtensible(e) ? 0 : Le(t.toRawType(e));
            }
            function ze(e) {
              return e && e.__v_isReadonly ? e : Ue(e, !1, D, Oe, Ne);
            }
            function Be(e) {
              return Ue(e, !1, ue, ke, Pe);
            }
            function Ve(e) {
              return Ue(e, !0, le, Ae, Fe);
            }
            function He(e) {
              return Ue(e, !0, de, je, Ie);
            }
            function Ue(e, n, r, i, a) {
              if (!t.isObject(e))
                return (console.warn(`value cannot be made reactive: ${String(e)}`), e);
              if (e.__v_raw && !(n && e.__v_isReactive)) return e;
              let o = a.get(e);
              if (o) return o;
              let s = Re(e);
              if (s === 0) return e;
              let c = new Proxy(e, s === 2 ? i : r);
              return (a.set(e, c), c);
            }
            function We(e) {
              return Ge(e) ? We(e.__v_raw) : !!(e && e.__v_isReactive);
            }
            function Ge(e) {
              return !!(e && e.__v_isReadonly);
            }
            function Ke(e) {
              return We(e) || Ge(e);
            }
            function M(e) {
              return (e && M(e.__v_raw)) || e;
            }
            function qe(e) {
              return (t.def(e, `__v_skip`, !0), e);
            }
            var N = (e) => (t.isObject(e) ? ze(e) : e);
            function P(e) {
              return !!(e && e.__v_isRef === !0);
            }
            function F(e) {
              return R(e);
            }
            function I(e) {
              return R(e, !0);
            }
            var L = class {
              constructor(e, t = !1) {
                ((this._shallow = t),
                  (this.__v_isRef = !0),
                  (this._rawValue = t ? e : M(e)),
                  (this._value = t ? e : N(e)));
              }
              get value() {
                return (y(M(this), `get`, `value`), this._value);
              }
              set value(e) {
                ((e = this._shallow ? e : M(e)),
                  t.hasChanged(e, this._rawValue) &&
                    ((this._rawValue = e),
                    (this._value = this._shallow ? e : N(e)),
                    b(M(this), `set`, `value`, e)));
              }
            };
            function R(e, t = !1) {
              return P(e) ? e : new L(e, t);
            }
            function z(e) {
              b(M(e), `set`, `value`, e.value);
            }
            function Je(e) {
              return P(e) ? e.value : e;
            }
            var Ye = {
              get: (e, t, n) => Je(Reflect.get(e, t, n)),
              set: (e, t, n, r) => {
                let i = e[t];
                return P(i) && !P(n) ? ((i.value = n), !0) : Reflect.set(e, t, n, r);
              },
            };
            function B(e) {
              return We(e) ? e : new Proxy(e, Ye);
            }
            var Xe = class {
              constructor(e) {
                this.__v_isRef = !0;
                let { get: t, set: n } = e(
                  () => y(this, `get`, `value`),
                  () => b(this, `set`, `value`),
                );
                ((this._get = t), (this._set = n));
              }
              get value() {
                return this._get();
              }
              set value(e) {
                this._set(e);
              }
            };
            function Ze(e) {
              return new Xe(e);
            }
            function Qe(e) {
              Ke(e) || console.warn(`toRefs() expects a reactive object but received a plain one.`);
              let n = t.isArray(e) ? Array(e.length) : {};
              for (let t in e) n[t] = $e(e, t);
              return n;
            }
            var V = class {
              constructor(e, t) {
                ((this._object = e), (this._key = t), (this.__v_isRef = !0));
              }
              get value() {
                return this._object[this._key];
              }
              set value(e) {
                this._object[this._key] = e;
              }
            };
            function $e(e, t) {
              return P(e[t]) ? e[t] : new V(e, t);
            }
            var H = class {
              constructor(e, t, n) {
                ((this._setter = t),
                  (this._dirty = !0),
                  (this.__v_isRef = !0),
                  (this.effect = c(e, {
                    lazy: !0,
                    scheduler: () => {
                      this._dirty || ((this._dirty = !0), b(M(this), `set`, `value`));
                    },
                  })),
                  (this.__v_isReadonly = n));
              }
              get value() {
                let e = M(this);
                return (
                  (e._dirty &&= ((e._value = this.effect()), !1)),
                  y(e, `get`, `value`),
                  e._value
                );
              }
              set value(e) {
                this._setter(e);
              }
            };
            function et(e) {
              let n, r;
              return (
                t.isFunction(e)
                  ? ((n = e),
                    (r = () => {
                      console.warn(`Write operation failed: computed value is readonly`);
                    }))
                  : ((n = e.get), (r = e.set)),
                new H(n, r, t.isFunction(e) || !e.set)
              );
            }
            ((e.ITERATE_KEY = a),
              (e.computed = et),
              (e.customRef = Ze),
              (e.effect = c),
              (e.enableTracking = _),
              (e.isProxy = Ke),
              (e.isReactive = We),
              (e.isReadonly = Ge),
              (e.isRef = P),
              (e.markRaw = qe),
              (e.pauseTracking = g),
              (e.proxyRefs = B),
              (e.reactive = ze),
              (e.readonly = Ve),
              (e.ref = F),
              (e.resetTracking = v),
              (e.shallowReactive = Be),
              (e.shallowReadonly = He),
              (e.shallowRef = I),
              (e.stop = l),
              (e.toRaw = M),
              (e.toRef = $e),
              (e.toRefs = Qe),
              (e.track = y),
              (e.trigger = b),
              (e.triggerRef = z),
              (e.unref = Je));
          },
        }),
        g = c({
          "node_modules/@vue/reactivity/index.js"(e, t) {
            t.exports = h();
          },
        }),
        _ = {};
      (l(_, {
        Alpine: () => Ir,
        default: () => Lr,
      }),
        (t.exports = f(_)));
      var v = !1,
        y = !1,
        b = [],
        x = -1,
        S = !1;
      function C(e) {
        T(e);
      }
      function w() {
        S = !0;
      }
      function ee() {
        ((S = !1), ne());
      }
      function T(e) {
        (b.includes(e) || b.push(e), ne());
      }
      function te(e) {
        let t = b.indexOf(e);
        t !== -1 && t > x && b.splice(t, 1);
      }
      function ne() {
        if (!y && !v) {
          if (S) return;
          ((v = !0), queueMicrotask(re));
        }
      }
      function re() {
        ((v = !1), (y = !0));
        for (let e = 0; e < b.length; e++) (b[e](), (x = e));
        ((b.length = 0), (x = -1), (y = !1));
      }
      var ie,
        E,
        ae,
        oe,
        se = !0;
      function ce(e) {
        ((se = !1), e(), (se = !0));
      }
      function D(e) {
        ((ie = e.reactive),
          (ae = e.release),
          (E = (t) =>
            e.effect(t, {
              scheduler: (e) => {
                se ? C(e) : e();
              },
            })),
          (oe = e.raw));
      }
      function le(e) {
        E = e;
      }
      function ue(e) {
        let t = () => {};
        return [
          (n) => {
            let r = E(n);
            return (
              e._x_effects ||
                ((e._x_effects = new Set()),
                (e._x_runEffects = () => {
                  e._x_effects.forEach((e) => e());
                })),
              e._x_effects.add(r),
              (t = () => {
                r !== void 0 && (e._x_effects.delete(r), ae(r));
              }),
              r
            );
          },
          () => {
            t();
          },
        ];
      }
      function de(e, t) {
        let n = !0,
          r,
          i,
          a = E(() => {
            let a = e(),
              o = JSON.stringify(a);
            if (!n && (typeof a == `object` || a !== r)) {
              let e = typeof r == `object` ? JSON.parse(i) : r;
              queueMicrotask(() => {
                t(a, e);
              });
            }
            ((r = a), (i = o), (n = !1));
          });
        return () => ae(a);
      }
      async function fe(e) {
        w();
        try {
          (await e(), await Promise.resolve());
        } finally {
          ee();
        }
      }
      var pe = [],
        O = [],
        me = [];
      function he(e) {
        me.push(e);
      }
      function ge(e, t) {
        typeof t == `function`
          ? ((e._x_cleanups ||= []), e._x_cleanups.push(t))
          : ((t = e), O.push(t));
      }
      function _e(e) {
        pe.push(e);
      }
      function ve(e, t, n) {
        ((e._x_attributeCleanups ||= {}),
          e._x_attributeCleanups[t] || (e._x_attributeCleanups[t] = []),
          e._x_attributeCleanups[t].push(n));
      }
      function ye(e, t) {
        e._x_attributeCleanups &&
          Object.entries(e._x_attributeCleanups).forEach(([n, r]) => {
            (t === void 0 || t.includes(n)) &&
              (r.forEach((e) => e()), delete e._x_attributeCleanups[n]);
          });
      }
      function be(e) {
        var t;
        for ((t = e._x_effects) == null || t.forEach(te); e._x_cleanups?.length;)
          e._x_cleanups.pop()();
      }
      var xe = new MutationObserver(ke),
        Se = !1;
      function Ce() {
        (xe.observe(document, {
          subtree: !0,
          childList: !0,
          attributes: !0,
          attributeOldValue: !0,
        }),
          (Se = !0));
      }
      function we() {
        (A(), xe.disconnect(), (Se = !1));
      }
      var k = [];
      function A() {
        let e = xe.takeRecords();
        k.push(() => e.length > 0 && ke(e));
        let t = k.length;
        queueMicrotask(() => {
          if (k.length === t) for (; k.length > 0;) k.shift()();
        });
      }
      function j(e) {
        if (!Se) return e();
        we();
        let t = e();
        return (Ce(), t);
      }
      var Te = !1,
        Ee = [];
      function De() {
        Te = !0;
      }
      function Oe() {
        ((Te = !1), ke(Ee), (Ee = []));
      }
      function ke(e) {
        if (Te) {
          Ee = Ee.concat(e);
          return;
        }
        let t = [],
          n = new Set(),
          r = new Map(),
          i = new Map();
        for (let a = 0; a < e.length; a++)
          if (
            !e[a].target._x_ignoreMutationObserver &&
            (e[a].type === `childList` &&
              (e[a].removedNodes.forEach((e) => {
                e.nodeType === 1 && e._x_marker && n.add(e);
              }),
              e[a].addedNodes.forEach((e) => {
                if (e.nodeType === 1) {
                  if (n.has(e)) {
                    n.delete(e);
                    return;
                  }
                  e._x_marker || t.push(e);
                }
              })),
            e[a].type === `attributes`)
          ) {
            let t = e[a].target,
              n = e[a].attributeName,
              o = e[a].oldValue,
              s = () => {
                (r.has(t) || r.set(t, []),
                  r.get(t).push({
                    name: n,
                    value: t.getAttribute(n),
                  }));
              },
              c = () => {
                (i.has(t) || i.set(t, []), i.get(t).push(n));
              };
            t.hasAttribute(n) && o === null ? s() : t.hasAttribute(n) ? (c(), s()) : c();
          }
        (i.forEach((e, t) => {
          ye(t, e);
        }),
          r.forEach((e, t) => {
            pe.forEach((n) => n(t, e));
          }));
        for (let e of n) t.some((t) => t.contains(e)) || O.forEach((t) => t(e));
        for (let e of t) e.isConnected && me.forEach((t) => t(e));
        ((t = null), (n = null), (r = null), (i = null));
      }
      function Ae(e) {
        return Ne(Me(e));
      }
      function je(e, t, n) {
        return (
          (e._x_dataStack = [t, ...Me(n || e)]),
          () => {
            e._x_dataStack = e._x_dataStack.filter((e) => e !== t);
          }
        );
      }
      function Me(e) {
        return e._x_dataStack
          ? e._x_dataStack
          : typeof ShadowRoot == `function` && e instanceof ShadowRoot
            ? Me(e.host)
            : e.parentNode
              ? Me(e.parentNode)
              : [];
      }
      function Ne(e) {
        return new Proxy(
          {
            objects: e,
          },
          Fe,
        );
      }
      function Pe(e, t) {
        return e === null || e === Object.prototype
          ? null
          : Object.prototype.hasOwnProperty.call(e, t)
            ? e
            : Pe(Object.getPrototypeOf(e), t);
      }
      var Fe = {
        ownKeys({ objects: e }) {
          return Array.from(new Set(e.flatMap((e) => Object.keys(e))));
        },
        has({ objects: e }, t) {
          return t == Symbol.unscopables
            ? !1
            : e.some((e) => Object.prototype.hasOwnProperty.call(e, t) || Reflect.has(e, t));
        },
        get({ objects: e }, t, n) {
          return t == `toJSON` ? Ie : Reflect.get(e.find((e) => Reflect.has(e, t)) || {}, t, n);
        },
        set({ objects: e }, t, n, r) {
          let i;
          for (let n of e) if (((i = Pe(n, t)), i)) break;
          i ||= e[e.length - 1];
          let a = Object.getOwnPropertyDescriptor(i, t);
          return a?.set && a?.get ? a.set.call(r, n) || !0 : Reflect.set(i, t, n);
        },
      };
      function Ie() {
        return Reflect.ownKeys(this).reduce((e, t) => ((e[t] = Reflect.get(this, t)), e), {});
      }
      function Le(e) {
        let t = (e) => typeof e == `object` && !Array.isArray(e) && e !== null,
          n = (r, i = ``) => {
            Object.entries(Object.getOwnPropertyDescriptors(r)).forEach(
              ([a, { value: o, enumerable: s }]) => {
                if (s === !1 || o === void 0 || (typeof o == `object` && o && o.__v_skip)) return;
                let c = i === `` ? a : `${i}.${a}`;
                typeof o == `object` && o && o._x_interceptor
                  ? (r[a] = o.initialize(e, c, a))
                  : t(o) && o !== r && !(o instanceof Element) && n(o, c);
              },
            );
          };
        return n(e);
      }
      function Re(e, t = () => {}) {
        let n = {
          initialValue: void 0,
          _x_interceptor: !0,
          initialize(t, n, r) {
            return e(
              this.initialValue,
              () => ze(t, n),
              (e) => Be(t, n, e),
              n,
              r,
            );
          },
        };
        return (
          t(n),
          (e) => {
            if (typeof e == `object` && e && e._x_interceptor) {
              let t = n.initialize.bind(n);
              n.initialize = (r, i, a) => ((n.initialValue = e.initialize(r, i, a)), t(r, i, a));
            } else n.initialValue = e;
            return n;
          }
        );
      }
      function ze(e, t) {
        return t.split(`.`).reduce((e, t) => e[t], e);
      }
      function Be(e, t, n) {
        if ((typeof t == `string` && (t = t.split(`.`)), t.length === 1)) e[t[0]] = n;
        else if (t.length === 0) throw error;
        else if (e[t[0]]) return Be(e[t[0]], t.slice(1), n);
        else return ((e[t[0]] = {}), Be(e[t[0]], t.slice(1), n));
      }
      var Ve = {};
      function He(e, t) {
        Ve[e] = t;
      }
      function Ue(e, t) {
        let n = We(t);
        return (
          Object.entries(Ve).forEach(([r, i]) => {
            Object.defineProperty(e, `$${r}`, {
              get() {
                return i(t, n);
              },
              enumerable: !1,
            });
          }),
          e
        );
      }
      function We(e) {
        let [t, n] = ft(e),
          r = {
            interceptor: Re,
            ...t,
          };
        return (ge(e, n), r);
      }
      function Ge(e, t, n, ...r) {
        try {
          return n(...r);
        } catch (n) {
          Ke(n, e, t);
        }
      }
      function Ke(...e) {
        return M(...e);
      }
      var M = N;
      function qe(e) {
        M = e;
      }
      function N(e, t, n = void 0) {
        ((e = Object.assign(
          e ?? {
            message: `No error message given.`,
          },
          {
            el: t,
            expression: n,
          },
        )),
          console.warn(
            `Alpine Expression Error: ${e.message}

${
  n
    ? `Expression: "` +
      n +
      `"

`
    : ``
}`,
            t,
          ),
          setTimeout(() => {
            throw e;
          }, 0));
      }
      var P = !0;
      function F(e) {
        let t = P;
        P = !1;
        let n = e();
        return ((P = t), n);
      }
      function I(e, t, n = {}) {
        let r;
        return (L(e, t)((e) => (r = e), n), r);
      }
      function L(...e) {
        return R(...e);
      }
      var R = () => {};
      function z(e) {
        R = e;
      }
      var Je;
      function Ye(e) {
        Je = e;
      }
      function B(e, t) {
        let n = {};
        Ue(n, e);
        let r = [n, ...Me(e)],
          i = typeof t == `function` ? Xe(r, t) : V(r, t, e);
        return Ge.bind(null, e, t, i);
      }
      function Xe(e, t) {
        return (n = () => {}, { scope: r = {}, params: i = [], context: a } = {}) => {
          if (!P) {
            $e(n, t, Ne([r, ...e]), i);
            return;
          }
          $e(n, t.apply(Ne([r, ...e]), i));
        };
      }
      var Ze = {};
      function Qe(e, t) {
        if (Ze[e]) return Ze[e];
        let n = Object.getPrototypeOf(async function () {}).constructor,
          r =
            /^[\n\s]*if.*\(.*\)/.test(e.trim()) || /^(let|const)\s/.test(e.trim())
              ? `(async()=>{ ${e} })()`
              : e,
          i = (() => {
            try {
              let t = new n(
                [`__self`, `scope`],
                `with (scope) { __self.result = ${r} }; __self.finished = true; return __self.result;`,
              );
              return (
                Object.defineProperty(t, "name", {
                  value: `[Alpine] ${e}`,
                }),
                t
              );
            } catch (n) {
              return (Ke(n, t, e), Promise.resolve());
            }
          })();
        return ((Ze[e] = i), i);
      }
      function V(e, t, n) {
        let r = Qe(t, n);
        return (i = () => {}, { scope: a = {}, params: o = [], context: s } = {}) => {
          ((r.result = void 0), (r.finished = !1));
          let c = Ne([a, ...e]);
          if (typeof r == `function`) {
            let e = r.call(s, r, c).catch((e) => Ke(e, n, t));
            r.finished
              ? ($e(i, r.result, c, o, n), (r.result = void 0))
              : e
                  .then((e) => {
                    $e(i, e, c, o, n);
                  })
                  .catch((e) => Ke(e, n, t))
                  .finally(() => (r.result = void 0));
          }
        };
      }
      function $e(e, t, n, r, i) {
        if (P && typeof t == `function`) {
          let a = t.apply(n, r);
          a instanceof Promise ? a.then((t) => $e(e, t, n, r)).catch((e) => Ke(e, i, t)) : e(a);
        } else typeof t == `object` && t instanceof Promise ? t.then((t) => e(t)) : e(t);
      }
      function H(...e) {
        return Je(...e);
      }
      function et(e, t, n = {}) {
        let r = {};
        Ue(r, e);
        let i = [r, ...Me(e)],
          a = Ne([n.scope ?? {}, ...i]),
          o = n.params ?? [];
        if (t.includes(`await`)) {
          let e = Object.getPrototypeOf(async function () {}).constructor;
          return new e(
            [`scope`],
            `with (scope) { let __result = ${/^[\n\s]*if.*\(.*\)/.test(t.trim()) || /^(let|const)\s/.test(t.trim()) ? `(async()=>{ ${t} })()` : t}; return __result }`,
          ).call(n.context, a);
        } else {
          let e =
              /^[\n\s]*if.*\(.*\)/.test(t.trim()) || /^(let|const)\s/.test(t.trim())
                ? `(()=>{ ${t} })()`
                : t,
            r = Function([`scope`], `with (scope) { let __result = ${e}; return __result }`).call(
              n.context,
              a,
            );
          return typeof r == `function` && P ? r.apply(a, o) : r;
        }
      }
      var tt = `x-`;
      function nt(e = ``) {
        return tt + e;
      }
      function rt(e) {
        tt = e;
      }
      var it = {};
      function at(e, t) {
        return (
          (it[e] = t),
          {
            before(t) {
              if (!it[t]) {
                console.warn(
                  String.raw`Cannot find directive \`${t}\`. \`${e}\` will use the default order of execution`,
                );
                return;
              }
              let n = Ct.indexOf(t);
              Ct.splice(n >= 0 ? n : Ct.indexOf(`DEFAULT`), 0, e);
            },
          }
        );
      }
      function ot(e) {
        return Object.keys(it).includes(e);
      }
      function st(e, t, n) {
        if (((t = Array.from(t)), e._x_virtualDirectives)) {
          let n = Object.entries(e._x_virtualDirectives).map(([e, t]) => ({
              name: e,
              value: t,
            })),
            r = ct(n);
          ((n = n.map((e) =>
            r.find((t) => t.name === e.name)
              ? {
                  name: `x-bind:${e.name}`,
                  value: `"${e.value}"`,
                }
              : e,
          )),
            (t = t.concat(n)));
        }
        let r = {};
        return t
          .map(gt((e, t) => (r[e] = t)))
          .filter(yt)
          .map(xt(r, n))
          .sort(wt)
          .map((t) => pt(e, t));
      }
      function ct(e) {
        return Array.from(e)
          .map(gt())
          .filter((e) => !yt(e));
      }
      var lt = !1,
        U = new Map(),
        ut = Symbol();
      function dt(e) {
        lt = !0;
        let t = Symbol();
        ((ut = t), U.set(t, []));
        let n = () => {
          for (; U.get(t).length;) U.get(t).shift()();
          U.delete(t);
        };
        (e(n), (lt = !1), n());
      }
      function ft(e) {
        let t = [],
          n = (e) => t.push(e),
          [r, i] = ue(e);
        return (
          t.push(i),
          [
            {
              Alpine: Qn,
              effect: r,
              cleanup: n,
              evaluateLater: L.bind(L, e),
              evaluate: I.bind(I, e),
            },
            () => t.forEach((e) => e()),
          ]
        );
      }
      function pt(e, t) {
        let n = it[t.type] || (() => {}),
          [r, i] = ft(e);
        ve(e, t.original, i);
        let a = () => {
          e._x_ignore ||
            e._x_ignoreSelf ||
            (n.inline && n.inline(e, t, r), (n = n.bind(n, e, t, r)), lt ? U.get(ut).push(n) : n());
        };
        return ((a.runCleanups = i), a);
      }
      var mt =
          (e, t) =>
          ({ name: n, value: r }) => (
            n.startsWith(e) && (n = n.replace(e, t)),
            {
              name: n,
              value: r,
            }
          ),
        ht = (e) => e;
      function gt(e = () => {}) {
        return ({ name: t, value: n }) => {
          let { name: r, value: i } = _t.reduce((e, t) => t(e), {
            name: t,
            value: n,
          });
          return (
            r !== t && e(r, t),
            {
              name: r,
              value: i,
            }
          );
        };
      }
      var _t = [];
      function vt(e) {
        _t.push(e);
      }
      function yt({ name: e }) {
        return bt().test(e);
      }
      var bt = () => RegExp(`^${tt}([^:^.]+)\\b`);
      function xt(e, t) {
        return ({ name: n, value: r }) => {
          n === r && (r = ``);
          let i = n.match(bt()),
            a = n.match(/:([a-zA-Z0-9\-_:]+)/),
            o = n.match(/\.[^.\]]+(?=[^\]]*$)/g) || [],
            s = t || e[n] || n;
          return {
            type: i ? i[1] : null,
            value: a ? a[1] : null,
            modifiers: o.map((e) => e.replace(`.`, ``)),
            expression: r,
            original: s,
          };
        };
      }
      var St = `DEFAULT`,
        Ct = [
          `ignore`,
          `ref`,
          `id`,
          `data`,
          `anchor`,
          `bind`,
          `init`,
          `for`,
          `model`,
          `modelable`,
          `transition`,
          `show`,
          `if`,
          St,
          `teleport`,
        ];
      function wt(e, t) {
        let n = Ct.indexOf(e.type) === -1 ? St : e.type,
          r = Ct.indexOf(t.type) === -1 ? St : t.type;
        return Ct.indexOf(n) - Ct.indexOf(r);
      }
      function Tt(e, t, n = {}, r = {}) {
        return e.dispatchEvent(
          new CustomEvent(t, {
            detail: n,
            bubbles: !0,
            composed: !0,
            cancelable: !0,
            ...r,
          }),
        );
      }
      function Et(e, t) {
        if (typeof ShadowRoot == `function` && e instanceof ShadowRoot) {
          Array.from(e.children).forEach((e) => Et(e, t));
          return;
        }
        let n = !1;
        if ((t(e, () => (n = !0)), n)) return;
        let r = e.firstElementChild;
        for (; r;) (Et(r, t, !1), (r = r.nextElementSibling));
      }
      function Dt(e, ...t) {
        console.warn(`Alpine Warning: ${e}`, ...t);
      }
      var Ot = !1;
      function kt() {
        (Ot &&
          Dt(
            `Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.`,
          ),
          (Ot = !0),
          document.body ||
            Dt(
              "Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?",
            ),
          Tt(document, `alpine:init`),
          Tt(document, `alpine:initializing`),
          Ce(),
          he((e) => Vt(e, Et)),
          ge((e) => Ht(e)),
          _e((e, t) => {
            st(e, t).forEach((e) => e());
          }),
          Array.from(document.querySelectorAll(Nt().join(`,`)))
            .filter((e) => !It(e.parentElement, !0))
            .forEach((e) => {
              Vt(e);
            }),
          Tt(document, `alpine:initialized`),
          setTimeout(() => {
            Ut();
          }));
      }
      var At = [],
        jt = [];
      function Mt() {
        return At.map((e) => e());
      }
      function Nt() {
        return At.concat(jt).map((e) => e());
      }
      function Pt(e) {
        At.push(e);
      }
      function Ft(e) {
        jt.push(e);
      }
      function It(e, t = !1) {
        return Lt(e, (e) => {
          if ((t ? Nt() : Mt()).some((t) => e.matches(t))) return !0;
        });
      }
      function Lt(e, t) {
        if (e) {
          if (t(e)) return e;
          if (e._x_teleportBack) return Lt(e._x_teleportBack, t);
          if (e.parentNode instanceof ShadowRoot) return Lt(e.parentNode.host, t);
          if (e.parentElement) return Lt(e.parentElement, t);
        }
      }
      function Rt(e) {
        return Mt().some((t) => e.matches(t));
      }
      var zt = [];
      function W(e) {
        zt.push(e);
      }
      var Bt = 1;
      function Vt(e, t = Et, n = () => {}) {
        Lt(e, (e) => e._x_ignore) ||
          dt(() => {
            t(e, (e, t) => {
              e._x_marker ||
                (n(e, t),
                zt.forEach((n) => n(e, t)),
                st(e, e.attributes).forEach((e) => e()),
                e._x_ignore || (e._x_marker = Bt++),
                e._x_ignore && t());
            });
          });
      }
      function Ht(e, t = Et) {
        t(e, (e) => {
          (be(e), ye(e), delete e._x_marker);
        });
      }
      function Ut() {
        [
          [`ui`, `dialog`, [`[x-dialog], [x-popover]`]],
          [`anchor`, `anchor`, [`[x-anchor]`]],
          [`sort`, `sort`, [`[x-sort]`]],
        ].forEach(([e, t, n]) => {
          ot(t) ||
            n.some((t) => {
              if (document.querySelector(t))
                return (Dt(`found "${t}", but missing ${e} plugin`), !0);
            });
        });
      }
      var Wt = [],
        Gt = !1;
      function G(e = () => {}) {
        return (
          queueMicrotask(() => {
            Gt ||
              setTimeout(() => {
                Kt();
              });
          }),
          new Promise((t) => {
            Wt.push(() => {
              (e(), t());
            });
          })
        );
      }
      function Kt() {
        for (Gt = !1; Wt.length;) Wt.shift()();
      }
      function qt() {
        Gt = !0;
      }
      function Jt(e, t) {
        return Array.isArray(t)
          ? Xt(e, t.join(` `))
          : typeof t == `object` && t
            ? Zt(e, t)
            : typeof t == `function`
              ? Jt(e, t())
              : Xt(e, t);
      }
      function Yt(e) {
        return e.split(/\s/).filter(Boolean);
      }
      function Xt(e, t) {
        return (
          (t = t === !0 ? (t = ``) : t || ``),
          ((t) => (
            e.classList.add(...t),
            () => {
              e.classList.remove(...t);
            }
          ))(
            ((t) =>
              Yt(t)
                .filter((t) => !e.classList.contains(t))
                .filter(Boolean))(t),
          )
        );
      }
      function Zt(e, t) {
        let n = Object.entries(t)
            .flatMap(([e, t]) => (t ? Yt(e) : !1))
            .filter(Boolean),
          r = Object.entries(t)
            .flatMap(([e, t]) => (t ? !1 : Yt(e)))
            .filter(Boolean),
          i = [],
          a = [];
        return (
          r.forEach((t) => {
            e.classList.contains(t) && (e.classList.remove(t), a.push(t));
          }),
          n.forEach((t) => {
            e.classList.contains(t) || (e.classList.add(t), i.push(t));
          }),
          () => {
            (a.forEach((t) => e.classList.add(t)), i.forEach((t) => e.classList.remove(t)));
          }
        );
      }
      function Qt(e, t) {
        return typeof t == `object` && t ? $t(e, t) : en(e, t);
      }
      function $t(e, t) {
        let n = {};
        return (
          Object.entries(t).forEach(([t, r]) => {
            ((n[t] = e.style[t]), t.startsWith(`--`) || (t = tn(t)), e.style.setProperty(t, r));
          }),
          setTimeout(() => {
            e.style.length === 0 && e.removeAttribute(`style`);
          }),
          () => {
            Qt(e, n);
          }
        );
      }
      function en(e, t) {
        let n = e.getAttribute(`style`, t);
        return (
          e.setAttribute(`style`, t),
          () => {
            e.setAttribute(`style`, n || ``);
          }
        );
      }
      function tn(e) {
        return e.replace(/([a-z])([A-Z])/g, `$1-$2`).toLowerCase();
      }
      function nn(e, t = () => {}) {
        let n = !1;
        return function () {
          n ? t.apply(this, arguments) : ((n = !0), e.apply(this, arguments));
        };
      }
      at(`transition`, (e, { value: t, modifiers: n, expression: r }, { evaluate: i }) => {
        (typeof r == `function` && (r = i(r)),
          r !== !1 && (!r || typeof r == `boolean` ? an(e, n, t) : rn(e, r, t)));
      });
      function rn(e, t, n) {
        (K(e, Jt, ``),
          {
            enter: (t) => {
              e._x_transition.enter.during = t;
            },
            "enter-start": (t) => {
              e._x_transition.enter.start = t;
            },
            "enter-end": (t) => {
              e._x_transition.enter.end = t;
            },
            leave: (t) => {
              e._x_transition.leave.during = t;
            },
            "leave-start": (t) => {
              e._x_transition.leave.start = t;
            },
            "leave-end": (t) => {
              e._x_transition.leave.end = t;
            },
          }[n](t));
      }
      function an(e, t, n) {
        K(e, Qt);
        let r = !t.includes(`in`) && !t.includes(`out`) && !n,
          i = r || t.includes(`in`) || [`enter`].includes(n),
          a = r || t.includes(`out`) || [`leave`].includes(n);
        (t.includes(`in`) && !r && (t = t.filter((e, n) => n < t.indexOf(`out`))),
          t.includes(`out`) && !r && (t = t.filter((e, n) => n > t.indexOf(`out`))));
        let o = !t.includes(`opacity`) && !t.includes(`scale`),
          s = o || t.includes(`opacity`),
          c = o || t.includes(`scale`),
          l = +!s,
          u = c ? ln(t, `scale`, 95) / 100 : 1,
          d = ln(t, `delay`, 0) / 1e3,
          f = ln(t, `origin`, `center`),
          p = `opacity, transform`,
          m = ln(t, `duration`, 150) / 1e3,
          h = ln(t, `duration`, 75) / 1e3,
          g = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
        (i &&
          ((e._x_transition.enter.during = {
            transformOrigin: f,
            transitionDelay: `${d}s`,
            transitionProperty: p,
            transitionDuration: `${m}s`,
            transitionTimingFunction: g,
          }),
          (e._x_transition.enter.start = {
            opacity: l,
            transform: `scale(${u})`,
          }),
          (e._x_transition.enter.end = {
            opacity: 1,
            transform: `scale(1)`,
          })),
          a &&
            ((e._x_transition.leave.during = {
              transformOrigin: f,
              transitionDelay: `${d}s`,
              transitionProperty: p,
              transitionDuration: `${h}s`,
              transitionTimingFunction: g,
            }),
            (e._x_transition.leave.start = {
              opacity: 1,
              transform: `scale(1)`,
            }),
            (e._x_transition.leave.end = {
              opacity: l,
              transform: `scale(${u})`,
            })));
      }
      function K(e, t, n = {}) {
        e._x_transition ||= {
          enter: {
            during: n,
            start: n,
            end: n,
          },
          leave: {
            during: n,
            start: n,
            end: n,
          },
          in(n = () => {}, r = () => {}) {
            sn(
              e,
              t,
              {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end,
              },
              n,
              r,
            );
          },
          out(n = () => {}, r = () => {}) {
            sn(
              e,
              t,
              {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end,
              },
              n,
              r,
            );
          },
        };
      }
      window.Element.prototype._x_toggleAndCascadeWithTransitions = function (e, t, n, r) {
        let i = document.visibilityState === `visible` ? requestAnimationFrame : setTimeout,
          a = () => i(n);
        if (t) {
          e._x_transition && (e._x_transition.enter || e._x_transition.leave)
            ? e._x_transition.enter &&
              (Object.entries(e._x_transition.enter.during).length ||
                Object.entries(e._x_transition.enter.start).length ||
                Object.entries(e._x_transition.enter.end).length)
              ? e._x_transition.in(n)
              : a()
            : e._x_transition
              ? e._x_transition.in(n)
              : a();
          return;
        }
        ((e._x_hidePromise = e._x_transition
          ? new Promise((t, n) => {
              (e._x_transition.out(
                () => {},
                () => t(r),
              ),
                e._x_transitioning &&
                  e._x_transitioning.beforeCancel(() =>
                    n({
                      isFromCancelledTransition: !0,
                    }),
                  ));
            })
          : Promise.resolve(r)),
          queueMicrotask(() => {
            let t = on(e);
            t
              ? ((t._x_hideChildren ||= []), t._x_hideChildren.push(e))
              : i(() => {
                  let t = (e) => {
                    let n = Promise.all([
                      e._x_hidePromise,
                      ...(e._x_hideChildren || []).map(t),
                    ]).then(([e]) => e?.());
                    return (delete e._x_hidePromise, delete e._x_hideChildren, n);
                  };
                  t(e).catch((e) => {
                    if (!e.isFromCancelledTransition) throw e;
                  });
                });
          }));
      };
      function on(e) {
        let t = e.parentNode;
        if (t) return t._x_hidePromise ? t : on(t);
      }
      function sn(e, t, { during: n, start: r, end: i } = {}, a = () => {}, o = () => {}) {
        if (
          (e._x_transitioning && e._x_transitioning.cancel(),
          Object.keys(n).length === 0 && Object.keys(r).length === 0 && Object.keys(i).length === 0)
        ) {
          (a(), o());
          return;
        }
        let s, c, l;
        cn(e, {
          start() {
            s = t(e, r);
          },
          during() {
            c = t(e, n);
          },
          before: a,
          end() {
            (s(), (l = t(e, i)));
          },
          after: o,
          cleanup() {
            (c(), l());
          },
        });
      }
      function cn(e, t) {
        let n,
          r,
          i,
          a = nn(() => {
            j(() => {
              ((n = !0),
                r || t.before(),
                i || (t.end(), Kt()),
                t.after(),
                e.isConnected && t.cleanup(),
                delete e._x_transitioning);
            });
          });
        ((e._x_transitioning = {
          beforeCancels: [],
          beforeCancel(e) {
            this.beforeCancels.push(e);
          },
          cancel: nn(function () {
            for (; this.beforeCancels.length;) this.beforeCancels.shift()();
            a();
          }),
          finish: a,
        }),
          j(() => {
            (t.start(), t.during());
          }),
          qt(),
          requestAnimationFrame(() => {
            if (n) return;
            let a =
                Number(getComputedStyle(e).transitionDuration.replace(/,.*/, ``).replace(`s`, ``)) *
                1e3,
              o =
                Number(getComputedStyle(e).transitionDelay.replace(/,.*/, ``).replace(`s`, ``)) *
                1e3;
            (a === 0 && (a = Number(getComputedStyle(e).animationDuration.replace(`s`, ``)) * 1e3),
              j(() => {
                t.before();
              }),
              (r = !0),
              requestAnimationFrame(() => {
                n ||
                  (j(() => {
                    t.end();
                  }),
                  Kt(),
                  setTimeout(e._x_transitioning.finish, a + o),
                  (i = !0));
              }));
          }));
      }
      function ln(e, t, n) {
        if (e.indexOf(t) === -1) return n;
        let r = e[e.indexOf(t) + 1];
        if (!r || (t === `scale` && isNaN(r))) return n;
        if (t === `duration` || t === `delay`) {
          let e = r.match(/([0-9]+)ms/);
          if (e) return e[1];
        }
        return t === `origin` &&
          [`top`, `right`, `left`, `center`, `bottom`].includes(e[e.indexOf(t) + 2])
          ? [r, e[e.indexOf(t) + 2]].join(` `)
          : r;
      }
      var un = !1;
      function dn(e, t = () => {}) {
        return (...n) => (un ? t(...n) : e(...n));
      }
      function fn(e) {
        return (...t) => un && e(...t);
      }
      var pn = [];
      function mn(e) {
        pn.push(e);
      }
      function hn(e, t) {
        (pn.forEach((n) => n(e, t)),
          (un = !0),
          q(() => {
            Vt(t, (e, t) => {
              t(e, () => {});
            });
          }),
          (un = !1));
      }
      var gn = !1;
      function _n(e, t) {
        ((t._x_dataStack ||= e._x_dataStack),
          (un = !0),
          (gn = !0),
          q(() => {
            vn(t);
          }),
          (un = !1),
          (gn = !1));
      }
      function vn(e) {
        let t = !1;
        Vt(e, (e, n) => {
          Et(e, (e, r) => {
            if (t && Rt(e)) return r();
            ((t = !0), n(e, r));
          });
        });
      }
      function q(e) {
        let t = E;
        (le((e, n) => {
          let r = t(e);
          return (ae(r), () => {});
        }),
          e(),
          le(t));
      }
      function yn(e, t, n, r = []) {
        switch (
          ((e._x_bindings ||= ie({})),
          (e._x_bindings[t] = n),
          (t = r.includes(`camel`) ? Dn(t) : t),
          t)
        ) {
          case `value`:
            bn(e, n);
            break;
          case `style`:
            J(e, n);
            break;
          case `class`:
            xn(e, n);
            break;
          case `selected`:
          case `checked`:
            Sn(e, t, n);
            break;
          default:
            Cn(e, t, n);
            break;
        }
      }
      function bn(e, t) {
        if (In(e)) e.attributes.value === void 0 && (e.value = t);
        else if (Fn(e))
          Number.isInteger(t)
            ? (e.value = t)
            : !Array.isArray(t) && typeof t != `boolean` && ![null, void 0].includes(t)
              ? (e.value = String(t))
              : Array.isArray(t)
                ? (e.checked = t.some((t) => On(t, e.value)))
                : (e.checked = !!t);
        else if (e.tagName === `SELECT`) En(e, t);
        else {
          if (e.value === t) return;
          e.value = t === void 0 ? `` : t;
        }
      }
      function xn(e, t) {
        (e._x_undoAddedClasses && e._x_undoAddedClasses(), (e._x_undoAddedClasses = Jt(e, t)));
      }
      function J(e, t) {
        (e._x_undoAddedStyles && e._x_undoAddedStyles(), (e._x_undoAddedStyles = Qt(e, t)));
      }
      function Sn(e, t, n) {
        (Cn(e, t, n), Tn(e, t, n));
      }
      function Cn(e, t, n) {
        [null, void 0, !1].includes(n) && Mn(t)
          ? e.removeAttribute(t)
          : (jn(t) && (n = t), wn(e, t, n));
      }
      function wn(e, t, n) {
        e.getAttribute(t) != n && e.setAttribute(t, n);
      }
      function Tn(e, t, n) {
        e[t] !== n && (e[t] = n);
      }
      function En(e, t) {
        let n = [].concat(t).map((e) => e + ``);
        Array.from(e.options).forEach((e) => {
          e.selected = n.includes(e.value);
        });
      }
      function Dn(e) {
        return e.toLowerCase().replace(/-(\w)/g, (e, t) => t.toUpperCase());
      }
      function On(e, t) {
        return e == t;
      }
      function kn(e) {
        return [1, `1`, `true`, `on`, `yes`, !0].includes(e)
          ? !0
          : [0, `0`, `false`, `off`, `no`, !1].includes(e)
            ? !1
            : e
              ? !!e
              : null;
      }
      var An = new Set(
        `allowfullscreen.async.autofocus.autoplay.checked.controls.default.defer.disabled.formnovalidate.inert.ismap.itemscope.loop.multiple.muted.nomodule.novalidate.open.playsinline.readonly.required.reversed.selected.shadowrootclonable.shadowrootdelegatesfocus.shadowrootserializable`.split(
          `.`,
        ),
      );
      function jn(e) {
        return An.has(e);
      }
      function Mn(e) {
        return ![`aria-pressed`, `aria-checked`, `aria-expanded`, `aria-selected`].includes(e);
      }
      function Y(e, t, n) {
        return e._x_bindings && e._x_bindings[t] !== void 0 ? e._x_bindings[t] : Pn(e, t, n);
      }
      function Nn(e, t, n, r = !0) {
        if (e._x_bindings && e._x_bindings[t] !== void 0) return e._x_bindings[t];
        if (e._x_inlineBindings && e._x_inlineBindings[t] !== void 0) {
          let n = e._x_inlineBindings[t];
          return ((n.extract = r), F(() => I(e, n.expression)));
        }
        return Pn(e, t, n);
      }
      function Pn(e, t, n) {
        let r = e.getAttribute(t);
        return r === null
          ? typeof n == `function`
            ? n()
            : n
          : r === ``
            ? !0
            : jn(t)
              ? !![t, `true`].includes(r)
              : r;
      }
      function Fn(e) {
        return (
          e.type === `checkbox` || e.localName === `ui-checkbox` || e.localName === `ui-switch`
        );
      }
      function In(e) {
        return e.type === `radio` || e.localName === `ui-radio`;
      }
      function Ln(e, t) {
        let n;
        return function () {
          let r = this,
            i = arguments;
          (clearTimeout(n),
            (n = setTimeout(function () {
              ((n = null), e.apply(r, i));
            }, t)));
        };
      }
      function Rn(e, t) {
        let n;
        return function () {
          let r = this,
            i = arguments;
          n || (e.apply(r, i), (n = !0), setTimeout(() => (n = !1), t));
        };
      }
      function zn({ get: e, set: t }, { get: n, set: r }) {
        let i = !0,
          a,
          o = E(() => {
            let o = e(),
              s = n();
            if (i) (r(Bn(o)), (i = !1));
            else {
              let e = JSON.stringify(o),
                n = JSON.stringify(s);
              e === a ? e !== n && t(Bn(s)) : r(Bn(o));
            }
            ((a = JSON.stringify(e())), JSON.stringify(n()));
          });
        return () => {
          ae(o);
        };
      }
      function Bn(e) {
        return typeof e == `object` ? JSON.parse(JSON.stringify(e)) : e;
      }
      function Vn(e) {
        (Array.isArray(e) ? e : [e]).forEach((e) => e(Qn));
      }
      var Hn = {},
        Un = !1;
      function Wn(e, t) {
        if (((Un ||= ((Hn = ie(Hn)), !0)), t === void 0)) return Hn[e];
        ((Hn[e] = t),
          Le(Hn[e]),
          typeof t == `object` &&
            t &&
            t.hasOwnProperty(`init`) &&
            typeof t.init == `function` &&
            Hn[e].init());
      }
      function Gn() {
        return Hn;
      }
      var Kn = {};
      function qn(e, t) {
        let n = typeof t == `function` ? t : () => t;
        return e instanceof Element ? Yn(e, n()) : ((Kn[e] = n), () => {});
      }
      function Jn(e) {
        return (
          Object.entries(Kn).forEach(([t, n]) => {
            Object.defineProperty(e, t, {
              get() {
                return (...e) => n(...e);
              },
            });
          }),
          e
        );
      }
      function Yn(e, t, n) {
        let r = [];
        for (; r.length;) r.pop()();
        let i = Object.entries(t).map(([e, t]) => ({
            name: e,
            value: t,
          })),
          a = ct(i);
        return (
          (i = i.map((e) =>
            a.find((t) => t.name === e.name)
              ? {
                  name: `x-bind:${e.name}`,
                  value: `"${e.value}"`,
                }
              : e,
          )),
          st(e, i, n).map((e) => {
            (r.push(e.runCleanups), e());
          }),
          () => {
            for (; r.length;) r.pop()();
          }
        );
      }
      var Xn = {};
      function X(e, t) {
        Xn[e] = t;
      }
      function Zn(e, t) {
        return (
          Object.entries(Xn).forEach(([n, r]) => {
            Object.defineProperty(e, n, {
              get() {
                return (...e) => r.bind(t)(...e);
              },
              enumerable: !1,
            });
          }),
          e
        );
      }
      var Qn = {
          get reactive() {
            return ie;
          },
          get release() {
            return ae;
          },
          get effect() {
            return E;
          },
          get raw() {
            return oe;
          },
          get transaction() {
            return fe;
          },
          version: `3.15.12`,
          flushAndStopDeferringMutations: Oe,
          dontAutoEvaluateFunctions: F,
          disableEffectScheduling: ce,
          startObservingMutations: Ce,
          stopObservingMutations: we,
          setReactivityEngine: D,
          onAttributeRemoved: ve,
          onAttributesAdded: _e,
          closestDataStack: Me,
          skipDuringClone: dn,
          onlyDuringClone: fn,
          addRootSelector: Pt,
          addInitSelector: Ft,
          setErrorHandler: qe,
          interceptClone: mn,
          addScopeToNode: je,
          deferMutations: De,
          mapAttributes: vt,
          evaluateLater: L,
          interceptInit: W,
          initInterceptors: Le,
          injectMagics: Ue,
          setEvaluator: z,
          setRawEvaluator: Ye,
          mergeProxies: Ne,
          extractProp: Nn,
          findClosest: Lt,
          onElRemoved: ge,
          closestRoot: It,
          destroyTree: Ht,
          interceptor: Re,
          transition: sn,
          setStyles: Qt,
          mutateDom: j,
          directive: at,
          entangle: zn,
          throttle: Rn,
          debounce: Ln,
          evaluate: I,
          evaluateRaw: H,
          initTree: Vt,
          nextTick: G,
          prefixed: nt,
          prefix: rt,
          plugin: Vn,
          magic: He,
          store: Wn,
          start: kt,
          clone: _n,
          cloneNode: hn,
          bound: Y,
          $data: Ae,
          watch: de,
          walk: Et,
          data: X,
          bind: qn,
        },
        $n = d(g());
      (He(`nextTick`, () => G),
        He(`dispatch`, (e) => Tt.bind(Tt, e)),
        He(`watch`, (e, { evaluateLater: t, cleanup: n }) => (e, r) => {
          let i = t(e);
          n(
            de(() => {
              let e;
              return (i((t) => (e = t)), e);
            }, r),
          );
        }),
        He(`store`, Gn),
        He(`data`, (e) => Ae(e)),
        He(`root`, (e) => It(e)),
        He(`refs`, (e) => ((e._x_refs_proxy ||= Ne(er(e))), e._x_refs_proxy)));
      function er(e) {
        let t = [];
        return (
          Lt(e, (e) => {
            e._x_refs && t.push(e._x_refs);
          }),
          t
        );
      }
      var tr = {};
      function nr(e) {
        return (tr[e] || (tr[e] = 0), ++tr[e]);
      }
      function rr(e, t) {
        return Lt(e, (e) => {
          if (e._x_ids && e._x_ids[t]) return !0;
        });
      }
      function ir(e, t) {
        ((e._x_ids ||= {}), e._x_ids[t] || (e._x_ids[t] = nr(t)));
      }
      (He(
        `id`,
        (e, { cleanup: t }) =>
          (n, r = null) =>
            ar(e, `${n}${r ? `-${r}` : ``}`, t, () => {
              let t = rr(e, n),
                i = t ? t._x_ids[n] : nr(n);
              return r ? `${n}-${i}-${r}` : `${n}-${i}`;
            }),
      ),
        mn((e, t) => {
          e._x_id && (t._x_id = e._x_id);
        }));
      function ar(e, t, n, r) {
        if (((e._x_id ||= {}), e._x_id[t])) return e._x_id[t];
        let i = r();
        return (
          (e._x_id[t] = i),
          n(() => {
            delete e._x_id[t];
          }),
          i
        );
      }
      (He(`el`, (e) => e), or(`Focus`, `focus`, `focus`), or(`Persist`, `persist`, `persist`));
      function or(e, t, n) {
        He(t, (r) =>
          Dt(
            `You can't use [$${t}] without first installing the "${e}" plugin here: https://alpinejs.dev/plugins/${n}`,
            r,
          ),
        );
      }
      (at(`modelable`, (e, { expression: t }, { effect: n, evaluateLater: r, cleanup: i }) => {
        let a = r(t),
          o = () => {
            let e;
            return (a((t) => (e = t)), e);
          },
          s = r(`${t} = __placeholder`),
          c = (e) =>
            s(() => {}, {
              scope: {
                __placeholder: e,
              },
            });
        (c(o()),
          queueMicrotask(() => {
            if (!e._x_model) return;
            e._x_removeModelListeners.default();
            let t = e._x_model.get,
              n = e._x_model.setWithModifiers;
            i(
              zn(
                {
                  get() {
                    return t();
                  },
                  set(e) {
                    n(e);
                  },
                },
                {
                  get() {
                    return o();
                  },
                  set(e) {
                    c(e);
                  },
                },
              ),
            );
          }));
      }),
        at(`teleport`, (e, { modifiers: t, expression: n }, { cleanup: r }) => {
          e.tagName.toLowerCase() !== `template` &&
            Dt(`x-teleport can only be used on a <template> tag`, e);
          let i = cr(n),
            a = e.content.cloneNode(!0).firstElementChild;
          ((e._x_teleport = a),
            (a._x_teleportBack = e),
            e.setAttribute(`data-teleport-template`, !0),
            a.setAttribute(`data-teleport-target`, !0),
            e._x_forwardEvents &&
              e._x_forwardEvents.forEach((t) => {
                a.addEventListener(t, (t) => {
                  (t.stopPropagation(), e.dispatchEvent(new t.constructor(t.type, t)));
                });
              }),
            je(a, {}, e));
          let o = (e, t, n) => {
            n.includes(`prepend`)
              ? t.parentNode.insertBefore(e, t)
              : n.includes(`append`)
                ? t.parentNode.insertBefore(e, t.nextSibling)
                : t.appendChild(e);
          };
          (j(() => {
            dn(() => {
              (o(a, i, t), Vt(a));
            })();
          }),
            (e._x_teleportPutBack = () => {
              let r = cr(n);
              j(() => {
                o(e._x_teleport, r, t);
              });
            }),
            r(() =>
              j(() => {
                (a.remove(), Ht(a));
              }),
            ));
        }));
      var sr = document.createElement(`div`);
      function cr(e) {
        let t = dn(
          () => document.querySelector(e),
          () => sr,
        )();
        return (t || Dt(`Cannot find x-teleport element for selector: "${e}"`), t);
      }
      var lr = () => {};
      ((lr.inline = (e, { modifiers: t }, { cleanup: n }) => {
        (t.includes(`self`) ? (e._x_ignoreSelf = !0) : (e._x_ignore = !0),
          n(() => {
            t.includes(`self`) ? delete e._x_ignoreSelf : delete e._x_ignore;
          }));
      }),
        at(`ignore`, lr),
        at(
          `effect`,
          dn((e, { expression: t }, { effect: n }) => {
            n(L(e, t));
          }),
        ));
      function ur(e, t, n, r) {
        let i = e,
          a = (e) => r(e),
          o = {},
          s = (e, t) => (n) => t(e, n);
        return (
          n.includes(`dot`) && (t = fr(t)),
          n.includes(`camel`) && (t = pr(t)),
          n.includes(`capture`) && (o.capture = !0),
          n.includes(`window`) && (i = window),
          n.includes(`document`) && (i = document),
          n.includes(`passive`) && (o.passive = n[n.indexOf(`passive`) + 1] !== `false`),
          (a = dr(n, a)),
          n.includes(`prevent`) &&
            (a = s(a, (e, t) => {
              (t.preventDefault(), e(t));
            })),
          n.includes(`stop`) &&
            (a = s(a, (e, t) => {
              (t.stopPropagation(), e(t));
            })),
          n.includes(`once`) &&
            (a = s(a, (e, n) => {
              (e(n), i.removeEventListener(t, a, o));
            })),
          (n.includes(`away`) || n.includes(`outside`)) &&
            ((i = document),
            (a = s(a, (t, n) => {
              e.contains(n.target) ||
                (n.target.isConnected !== !1 &&
                  ((e.offsetWidth < 1 && e.offsetHeight < 1) || (e._x_isShown !== !1 && t(n))));
            }))),
          n.includes(`self`) &&
            (a = s(a, (t, n) => {
              n.target === e && t(n);
            })),
          t === `submit` &&
            (a = s(a, (e, t) => {
              (t.target._x_pendingModelUpdates &&
                t.target._x_pendingModelUpdates.forEach((e) => e()),
                e(t));
            })),
          (gr(t) || _r(t)) &&
            (a = s(a, (e, t) => {
              vr(t, n) || e(t);
            })),
          i.addEventListener(t, a, o),
          () => {
            i.removeEventListener(t, a, o);
          }
        );
      }
      function dr(e, t) {
        if (e.includes(`debounce`)) {
          let n = e[e.indexOf(`debounce`) + 1] || `invalid-wait`,
            r = mr(n.split(`ms`)[0]) ? Number(n.split(`ms`)[0]) : 250;
          t = Ln(t, r);
        }
        if (e.includes(`throttle`)) {
          let n = e[e.indexOf(`throttle`) + 1] || `invalid-wait`,
            r = mr(n.split(`ms`)[0]) ? Number(n.split(`ms`)[0]) : 250;
          t = Rn(t, r);
        }
        return t;
      }
      function fr(e) {
        return e.replace(/-/g, `.`);
      }
      function pr(e) {
        return e.toLowerCase().replace(/-(\w)/g, (e, t) => t.toUpperCase());
      }
      function mr(e) {
        return !Array.isArray(e) && !isNaN(e);
      }
      function hr(e) {
        return [` `, `_`].includes(e)
          ? e
          : e
              .replace(/([a-z])([A-Z])/g, `$1-$2`)
              .replace(/[_\s]/, `-`)
              .toLowerCase();
      }
      function gr(e) {
        return [`keydown`, `keyup`].includes(e);
      }
      function _r(e) {
        return [`contextmenu`, `click`, `mouse`].some((t) => e.includes(t));
      }
      function vr(e, t) {
        let n = t.filter(
          (e) =>
            ![
              `window`,
              `document`,
              `prevent`,
              `stop`,
              `once`,
              `capture`,
              `self`,
              `away`,
              `outside`,
              `passive`,
              `preserve-scroll`,
              `blur`,
              `change`,
              `lazy`,
            ].includes(e),
        );
        if (n.includes(`debounce`)) {
          let e = n.indexOf(`debounce`);
          n.splice(e, mr((n[e + 1] || `invalid-wait`).split(`ms`)[0]) ? 2 : 1);
        }
        if (n.includes(`throttle`)) {
          let e = n.indexOf(`throttle`);
          n.splice(e, mr((n[e + 1] || `invalid-wait`).split(`ms`)[0]) ? 2 : 1);
        }
        if (n.length === 0 || (n.length === 1 && yr(e.key).includes(n[0]))) return !1;
        let r = [`ctrl`, `shift`, `alt`, `meta`, `cmd`, `super`].filter((e) => n.includes(e));
        return (
          (n = n.filter((e) => !r.includes(e))),
          !(
            r.length > 0 &&
            r.filter((t) => ((t === `cmd` || t === `super`) && (t = `meta`), e[`${t}Key`]))
              .length === r.length &&
            (_r(e.type) || yr(e.key).includes(n[0]))
          )
        );
      }
      function yr(e) {
        if (!e) return [];
        e = hr(e);
        let t = {
          ctrl: `control`,
          slash: `/`,
          space: ` `,
          spacebar: ` `,
          cmd: `meta`,
          esc: `escape`,
          up: `arrow-up`,
          down: `arrow-down`,
          left: `arrow-left`,
          right: `arrow-right`,
          period: `.`,
          comma: `,`,
          equal: `=`,
          minus: `-`,
          underscore: `_`,
        };
        return (
          (t[e] = e),
          Object.keys(t)
            .map((n) => {
              if (t[n] === e) return n;
            })
            .filter((e) => e)
        );
      }
      at(`model`, (e, { modifiers: t, expression: n }, { effect: r, cleanup: i }) => {
        let a = e;
        t.includes(`parent`) && (a = Lt(e, (t) => t !== e));
        let o = L(a, n),
          s;
        s =
          typeof n == `string`
            ? L(a, `${n} = __placeholder`)
            : typeof n == `function` && typeof n() == `string`
              ? L(a, `${n()} = __placeholder`)
              : () => {};
        let c = () => {
            let e;
            return (o((t) => (e = t)), wr(e) ? e.get() : e);
          },
          l = (e) => {
            let t;
            (o((e) => (t = e)),
              wr(t)
                ? t.set(e)
                : s(() => {}, {
                    scope: {
                      __placeholder: e,
                    },
                  }));
          };
        typeof n == `string` &&
          e.type === `radio` &&
          j(() => {
            e.hasAttribute(`name`) || e.setAttribute(`name`, n);
          });
        let u = t.includes(`change`) || t.includes(`lazy`),
          d = t.includes(`blur`),
          f = t.includes(`enter`),
          p = u || d || f,
          m;
        if (un) m = () => {};
        else if (p) {
          let n = [],
            r = (n) => l(br(e, t, n, c()));
          if ((u && n.push(ur(e, `change`, t, r)), d && (n.push(ur(e, `blur`, t, r)), e.form))) {
            let t = e.form,
              n = () =>
                r({
                  target: e,
                });
            ((t._x_pendingModelUpdates ||= []),
              t._x_pendingModelUpdates.push(n),
              i(() => {
                t._x_pendingModelUpdates &&
                  t._x_pendingModelUpdates.splice(t._x_pendingModelUpdates.indexOf(n), 1);
              }));
          }
          (f &&
            n.push(
              ur(e, `keydown`, t, (e) => {
                e.key === `Enter` && r(e);
              }),
            ),
            (m = () => n.forEach((e) => e())));
        } else
          m = ur(
            e,
            e.tagName.toLowerCase() === `select` || [`checkbox`, `radio`].includes(e.type)
              ? `change`
              : `input`,
            t,
            (n) => {
              l(br(e, t, n, c()));
            },
          );
        if (
          (t.includes(`fill`) &&
            ([void 0, null, ``].includes(c()) ||
              (Fn(e) && Array.isArray(c())) ||
              (e.tagName.toLowerCase() === `select` && e.multiple)) &&
            l(
              br(
                e,
                t,
                {
                  target: e,
                },
                c(),
              ),
            ),
          (e._x_removeModelListeners ||= {}),
          (e._x_removeModelListeners.default = m),
          i(() => e._x_removeModelListeners.default()),
          e.form)
        ) {
          let n = ur(e.form, `reset`, [], (n) => {
            G(
              () =>
                e._x_model &&
                e._x_model.set(
                  br(
                    e,
                    t,
                    {
                      target: e,
                    },
                    c(),
                  ),
                ),
            );
          });
          i(() => n());
        }
        ((e._x_model = {
          get() {
            return c();
          },
          set(e) {
            l(e);
          },
          setWithModifiers: dr(t, l),
        }),
          (e._x_forceModelUpdate = (t) => {
            (t === void 0 && typeof n == `string` && n.match(/\./) && (t = ``),
              j(() => {
                Fn(e)
                  ? Array.isArray(t)
                    ? (e.checked = t.some((t) => t == e.value))
                    : (e.checked = !!t)
                  : In(e)
                    ? typeof t == `boolean`
                      ? (e.checked = kn(e.value) === t)
                      : (e.checked = e.value == t)
                    : yn(e, `value`, t);
              }));
          }),
          r(() => {
            let n = c();
            (t.includes(`unintrusive`) && document.activeElement.isSameNode(e)) ||
              e._x_forceModelUpdate(n);
          }));
      });
      function br(e, t, n, r) {
        return j(() => {
          if (n instanceof CustomEvent && n.detail !== void 0)
            return n.detail !== null && n.detail !== void 0 ? n.detail : n.target.value;
          if (Fn(e)) {
            if (Array.isArray(r)) {
              let e = null;
              return (
                (e = t.includes(`number`)
                  ? xr(n.target.value)
                  : t.includes(`boolean`)
                    ? kn(n.target.value)
                    : n.target.value),
                n.target.checked ? (r.includes(e) ? r : r.concat([e])) : r.filter((t) => !Sr(t, e))
              );
            } else return n.target.checked;
          } else if (e.tagName.toLowerCase() === `select` && e.multiple)
            return t.includes(`number`)
              ? Array.from(n.target.selectedOptions).map((e) => xr(e.value || e.text))
              : t.includes(`boolean`)
                ? Array.from(n.target.selectedOptions).map((e) => kn(e.value || e.text))
                : Array.from(n.target.selectedOptions).map((e) => e.value || e.text);
          else {
            let i;
            return (
              (i = In(e) ? (n.target.checked ? n.target.value : r) : n.target.value),
              t.includes(`number`)
                ? xr(i)
                : t.includes(`boolean`)
                  ? kn(i)
                  : t.includes(`trim`)
                    ? i.trim()
                    : i
            );
          }
        });
      }
      function xr(e) {
        let t = e ? parseFloat(e) : null;
        return Cr(t) ? t : e;
      }
      function Sr(e, t) {
        return e == t;
      }
      function Cr(e) {
        return !Array.isArray(e) && !isNaN(e);
      }
      function wr(e) {
        return (
          typeof e == `object` && !!e && typeof e.get == `function` && typeof e.set == `function`
        );
      }
      (at(`cloak`, (e) => queueMicrotask(() => j(() => e.removeAttribute(nt(`cloak`))))),
        Ft(() => `[${nt(`init`)}]`),
        at(
          `init`,
          dn((e, { expression: t }, { evaluate: n }) =>
            typeof t == `string` ? !!t.trim() && n(t, {}, !1) : n(t, {}, !1),
          ),
        ),
        at(`text`, (e, { expression: t }, { effect: n, evaluateLater: r }) => {
          let i = r(t);
          n(() => {
            i((t) => {
              j(() => {
                e.textContent = t;
              });
            });
          });
        }),
        at(`html`, (e, { expression: t }, { effect: n, evaluateLater: r }) => {
          let i = r(t);
          n(() => {
            i((t) => {
              j(() => {
                ((e.innerHTML = t ?? ``), (e._x_ignoreSelf = !0), Vt(e), delete e._x_ignoreSelf);
              });
            });
          });
        }),
        vt(mt(`:`, ht(nt(`bind:`)))));
      var Tr = (
        e,
        { value: t, modifiers: n, expression: r, original: i },
        { effect: a, cleanup: o },
      ) => {
        if (!t) {
          let t = {};
          (Jn(t),
            L(e, r)(
              (t) => {
                Yn(e, t, i);
              },
              {
                scope: t,
              },
            ));
          return;
        }
        if (t === `key`) return Er(e, r);
        if (e._x_inlineBindings && e._x_inlineBindings[t] && e._x_inlineBindings[t].extract) return;
        let s = L(e, r);
        (a(() =>
          s((i) => {
            (i === void 0 && typeof r == `string` && r.match(/\./) && (i = ``),
              j(() => yn(e, t, i, n)));
          }),
        ),
          o(() => {
            (e._x_undoAddedClasses && e._x_undoAddedClasses(),
              e._x_undoAddedStyles && e._x_undoAddedStyles());
          }));
      };
      ((Tr.inline = (e, { value: t, modifiers: n, expression: r }) => {
        t &&
          ((e._x_inlineBindings ||= {}),
          (e._x_inlineBindings[t] = {
            expression: r,
            extract: !1,
          }));
      }),
        at(`bind`, Tr));
      function Er(e, t) {
        e._x_keyExpression = t;
      }
      (Pt(() => `[${nt(`data`)}]`),
        at(`data`, (e, { expression: t }, { cleanup: n }) => {
          if (Dr(e)) return;
          t = t === `` ? `{}` : t;
          let r = {};
          Ue(r, e);
          let i = {};
          Zn(i, r);
          let a = I(e, t, {
            scope: i,
          });
          ((a === void 0 || a === !0) && (a = {}), Ue(a, e));
          let o = ie(a);
          Le(o);
          let s = je(e, o);
          (o.init && I(e, o.init),
            n(() => {
              (o.destroy && I(e, o.destroy), s());
            }));
        }),
        mn((e, t) => {
          e._x_dataStack &&
            ((t._x_dataStack = e._x_dataStack), t.setAttribute(`data-has-alpine-state`, !0));
        }));
      function Dr(e) {
        return un ? (gn ? !0 : e.hasAttribute(`data-has-alpine-state`)) : !1;
      }
      (at(`show`, (e, { modifiers: t, expression: n }, { effect: r }) => {
        let i = L(e, n);
        ((e._x_doHide ||= () => {
          j(() => {
            e.style.setProperty(`display`, `none`, t.includes(`important`) ? `important` : void 0);
          });
        }),
          (e._x_doShow ||= () => {
            j(() => {
              e.style.length === 1 && e.style.display === `none`
                ? e.removeAttribute(`style`)
                : e.style.removeProperty(`display`);
            });
          }));
        let a = () => {
            (e._x_doHide(), (e._x_isShown = !1));
          },
          o = () => {
            (e._x_doShow(), (e._x_isShown = !0));
          },
          s = () => setTimeout(o),
          c = nn(
            (e) => (e ? o() : a()),
            (t) => {
              typeof e._x_toggleAndCascadeWithTransitions == `function`
                ? e._x_toggleAndCascadeWithTransitions(e, t, o, a)
                : t
                  ? s()
                  : a();
            },
          ),
          l,
          u = !0;
        r(() =>
          i((e) => {
            (!u && e === l) ||
              (t.includes(`immediate`) && (e ? s() : a()), c(e), (l = e), (u = !1));
          }),
        );
      }),
        at(`for`, (e, { expression: t }, { effect: n, cleanup: r }) => {
          let i = Ar(t),
            a = L(e, i.items),
            o = L(e, e._x_keyExpression || `index`);
          ((e._x_lookup = new Map()),
            n(() => kr(e, i, a, o)),
            r(() => {
              (e._x_lookup.forEach((e) =>
                j(() => {
                  (Ht(e), e.remove());
                }),
              ),
                delete e._x_lookup);
            }));
        }));
      function Or(e) {
        return (t) => {
          Object.entries(t).forEach(([t, n]) => {
            e[t] = n;
          });
        };
      }
      function kr(e, t, n, r) {
        n((n) => {
          (Mr(n) &&
            (n = Array.from(
              {
                length: n,
              },
              (e, t) => t + 1,
            )),
            (n ??= []),
            n instanceof Set && (n = Array.from(n)),
            n instanceof Map && (n = Array.from(n)));
          let i = e._x_lookup,
            a = new Map();
          e._x_lookup = a;
          let o = Nr(n),
            s = Object.entries(n).map(([s, c]) => {
              o || (s = parseInt(s));
              let l = jr(t, c, s, n),
                u;
              return (
                r(
                  (t) => {
                    (typeof t == `object` &&
                      Dt(`x-for key cannot be an object, it must be a string or an integer`, e),
                      i.has(t) && (a.set(t, i.get(t)), i.delete(t)),
                      (u = t));
                  },
                  {
                    scope: {
                      index: s,
                      ...l,
                    },
                  },
                ),
                [u, l]
              );
            });
          j(() => {
            i.forEach((e) => {
              (Ht(e), e.remove());
            });
            let t = new Set(),
              n = e;
            (s.forEach(([r, i]) => {
              if (a.has(r)) {
                let e = a.get(r);
                (e._x_refreshXForScope(i),
                  n.nextElementSibling !== e &&
                    (n.nextElementSibling && e.replaceWith(n.nextElementSibling), n.after(e)),
                  (n = e),
                  e._x_currentIfEl &&
                    (e.nextElementSibling !== e._x_currentIfEl && n.after(e._x_currentIfEl),
                    (n = e._x_currentIfEl)));
                return;
              }
              e.content.children.length > 1 &&
                Dt(
                  `x-for templates require a single root element, additional elements will be ignored.`,
                  e,
                );
              let o = document.importNode(e.content, !0).firstElementChild,
                s = ie(i);
              (je(o, s, e),
                (o._x_refreshXForScope = Or(s)),
                a.set(r, o),
                t.add(o),
                n.after(o),
                (n = o));
            }),
              dn(() => t.forEach((e) => Vt(e)))());
          });
        });
      }
      function Ar(e) {
        let t = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/,
          n = /^\s*\(|\)\s*$/g,
          r = e.match(/([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/);
        if (!r) return;
        let i = {};
        i.items = r[2].trim();
        let a = r[1].replace(n, ``).trim(),
          o = a.match(t);
        return (
          o
            ? ((i.item = a.replace(t, ``).trim()),
              (i.index = o[1].trim()),
              o[2] && (i.collection = o[2].trim()))
            : (i.item = a),
          i
        );
      }
      function jr(e, t, n, r) {
        let i = {};
        return (
          /^\[.*\]$/.test(e.item) && Array.isArray(t)
            ? e.item
                .replace(`[`, ``)
                .replace(`]`, ``)
                .split(`,`)
                .map((e) => e.trim())
                .forEach((e, n) => {
                  i[e] = t[n];
                })
            : /^\{.*\}$/.test(e.item) && !Array.isArray(t) && typeof t == `object`
              ? e.item
                  .replace(`{`, ``)
                  .replace(`}`, ``)
                  .split(`,`)
                  .map((e) => e.trim())
                  .forEach((e) => {
                    i[e] = t[e];
                  })
              : (i[e.item] = t),
          e.index && (i[e.index] = n),
          e.collection && (i[e.collection] = r),
          i
        );
      }
      function Mr(e) {
        return typeof e != `object` && !isNaN(e);
      }
      function Nr(e) {
        return typeof e == `object` && !Array.isArray(e);
      }
      function Pr() {}
      ((Pr.inline = (e, { expression: t }, { cleanup: n }) => {
        let r = It(e);
        r && ((r._x_refs ||= {}), (r._x_refs[t] = e), n(() => delete r._x_refs[t]));
      }),
        at(`ref`, Pr),
        at(`if`, (e, { expression: t }, { effect: n, cleanup: r }) => {
          e.tagName.toLowerCase() !== `template` &&
            Dt(`x-if can only be used on a <template> tag`, e);
          let i = L(e, t),
            a = () => {
              if (e._x_currentIfEl) return e._x_currentIfEl;
              let t = e.content.cloneNode(!0).firstElementChild;
              return (
                je(t, {}, e),
                j(() => {
                  (e.after(t), dn(() => Vt(t))());
                }),
                (e._x_currentIfEl = t),
                (e._x_undoIf = () => {
                  (j(() => {
                    (Ht(t), t.remove());
                  }),
                    delete e._x_currentIfEl);
                }),
                t
              );
            },
            o = () => {
              e._x_undoIf && (e._x_undoIf(), delete e._x_undoIf);
            };
          (n(() =>
            i((e) => {
              e ? a() : o();
            }),
          ),
            r(() => e._x_undoIf && e._x_undoIf()));
        }),
        at(`id`, (e, { expression: t }, { evaluate: n }) => {
          n(t).forEach((t) => ir(e, t));
        }),
        mn((e, t) => {
          e._x_ids && (t._x_ids = e._x_ids);
        }),
        vt(mt(`@`, ht(nt(`on:`)))),
        at(
          `on`,
          dn((e, { value: t, modifiers: n, expression: r }, { cleanup: i }) => {
            let a = r ? L(e, r) : () => {};
            e.tagName.toLowerCase() === `template` &&
              ((e._x_forwardEvents ||= []),
              e._x_forwardEvents.includes(t) || e._x_forwardEvents.push(t));
            let o = ur(e, t, n, (e) => {
              a(() => {}, {
                scope: {
                  $event: e,
                },
                params: [e],
              });
            });
            i(() => o());
          }),
        ),
        Fr(`Collapse`, `collapse`, `collapse`),
        Fr(`Intersect`, `intersect`, `intersect`),
        Fr(`Focus`, `trap`, `focus`),
        Fr(`Mask`, `mask`, `mask`));
      function Fr(e, t, n) {
        at(t, (r) =>
          Dt(
            `You can't use [x-${t}] without first installing the "${e}" plugin here: https://alpinejs.dev/plugins/${n}`,
            r,
          ),
        );
      }
      (Qn.setEvaluator(B),
        Qn.setRawEvaluator(et),
        Qn.setReactivityEngine({
          reactive: $n.reactive,
          effect: $n.effect,
          release: $n.stop,
          raw: $n.toRaw,
        }));
      var Ir = Qn,
        Lr = Ir;
    },
  }),
  Ma = ka({
    "node_modules/@alpinejs/collapse/dist/module.cjs.js"(e, t) {
      var n = Object.defineProperty,
        r = Object.getOwnPropertyDescriptor,
        i = Object.getOwnPropertyNames,
        a = Object.prototype.hasOwnProperty,
        o = (e, t) => {
          for (var r in t)
            n(e, r, {
              get: t[r],
              enumerable: !0,
            });
        },
        s = (e, t, o, s) => {
          if ((t && typeof t == `object`) || typeof t == `function`)
            for (let c of i(t))
              !a.call(e, c) &&
                c !== o &&
                n(e, c, {
                  get: () => t[c],
                  enumerable: !(s = r(t, c)) || s.enumerable,
                });
          return e;
        },
        c = (e) =>
          s(
            n({}, `__esModule`, {
              value: !0,
            }),
            e,
          ),
        l = {};
      (o(l, {
        collapse: () => u,
        default: () => f,
      }),
        (t.exports = c(l)));
      function u(e) {
        (e.directive(`collapse`, t),
          (t.inline = (e, { modifiers: t }) => {
            t.includes(`min`) && ((e._x_doShow = () => {}), (e._x_doHide = () => {}));
          }));
        function t(t, { modifiers: n }) {
          let r = d(n, `duration`, 250) / 1e3,
            i = d(n, `min`, 0),
            a = !n.includes(`min`);
          (t._x_isShown || (t.style.height = `${i}px`),
            !t._x_isShown && a && (t.hidden = !0),
            t._x_isShown || (t.style.overflow = `hidden`));
          let o = (t, n) => {
              let r = e.setStyles(t, n);
              return n.height ? () => {} : r;
            },
            s = {
              transitionProperty: `height`,
              transitionDuration: `${r}s`,
              transitionTimingFunction: `cubic-bezier(0.4, 0.0, 0.2, 1)`,
            };
          t._x_transition = {
            in(n = () => {}, r = () => {}) {
              (a && (t.hidden = !1), a && (t.style.display = null));
              let o = t.getBoundingClientRect().height;
              t.style.height = `auto`;
              let c = t.getBoundingClientRect().height;
              (o === c && (o = i),
                e.transition(
                  t,
                  e.setStyles,
                  {
                    during: s,
                    start: {
                      height: o + `px`,
                    },
                    end: {
                      height: c + `px`,
                    },
                  },
                  () => (t._x_isShown = !0),
                  () => {
                    Math.abs(t.getBoundingClientRect().height - c) < 1 && (t.style.overflow = null);
                  },
                ));
            },
            out(n = () => {}, r = () => {}) {
              let c = t.getBoundingClientRect().height;
              e.transition(
                t,
                o,
                {
                  during: s,
                  start: {
                    height: c + `px`,
                  },
                  end: {
                    height: i + `px`,
                  },
                },
                () => (t.style.overflow = `hidden`),
                () => {
                  ((t._x_isShown = !1),
                    t.style.height == `${i}px` &&
                      a &&
                      ((t.style.display = `none`), (t.hidden = !0)));
                },
              );
            },
          };
        }
      }
      function d(e, t, n) {
        if (e.indexOf(t) === -1) return n;
        let r = e[e.indexOf(t) + 1];
        if (!r) return n;
        if (t === `duration`) {
          let e = r.match(/([0-9]+)ms/);
          if (e) return e[1];
        }
        if (t === `min`) {
          let e = r.match(/([0-9]+)px/);
          if (e) return e[1];
        }
        return r;
      }
      var f = u;
    },
  }),
  Na = ka({
    "node_modules/@alpinejs/focus/dist/module.cjs.js"(e, t) {
      var n = Object.create,
        r = Object.defineProperty,
        i = Object.getOwnPropertyDescriptor,
        a = Object.getOwnPropertyNames,
        o = Object.getPrototypeOf,
        s = Object.prototype.hasOwnProperty,
        c = (e, t) =>
          function () {
            return (
              t ||
                (0, e[a(e)[0]])(
                  (t = {
                    exports: {},
                  }).exports,
                  t,
                ),
              t.exports
            );
          },
        l = (e, t) => {
          for (var n in t)
            r(e, n, {
              get: t[n],
              enumerable: !0,
            });
        },
        u = (e, t, n, o) => {
          if ((t && typeof t == `object`) || typeof t == `function`)
            for (let c of a(t))
              !s.call(e, c) &&
                c !== n &&
                r(e, c, {
                  get: () => t[c],
                  enumerable: !(o = i(t, c)) || o.enumerable,
                });
          return e;
        },
        d = (e, t, i) => (
          (i = e == null ? {} : n(o(e))),
          u(
            t || !e || !e.__esModule
              ? r(i, `default`, {
                  value: e,
                  enumerable: !0,
                })
              : i,
            e,
          )
        ),
        f = (e) =>
          u(
            r({}, `__esModule`, {
              value: !0,
            }),
            e,
          ),
        p = c({
          "node_modules/tabbable/dist/index.js"(e) {
            var t = [
                `input:not([inert]):not([inert] *)`,
                `select:not([inert]):not([inert] *)`,
                `textarea:not([inert]):not([inert] *)`,
                `a[href]:not([inert]):not([inert] *)`,
                `button:not([inert]):not([inert] *)`,
                `[tabindex]:not(slot):not([inert]):not([inert] *)`,
                `audio[controls]:not([inert]):not([inert] *)`,
                `video[controls]:not([inert]):not([inert] *)`,
                `[contenteditable]:not([contenteditable="false"]):not([inert]):not([inert] *)`,
                `details>summary:first-of-type:not([inert]):not([inert] *)`,
                `details:not([inert]):not([inert] *)`,
              ],
              n = t.join(`,`),
              r = typeof Element > `u`,
              i = r
                ? function () {}
                : Element.prototype.matches ||
                  Element.prototype.msMatchesSelector ||
                  Element.prototype.webkitMatchesSelector,
              a =
                !r && Element.prototype.getRootNode
                  ? function (e) {
                      return e?.getRootNode?.call(e);
                    }
                  : function (e) {
                      return e?.ownerDocument;
                    },
              o = function (e, t) {
                t === void 0 && (t = !0);
                var n = e?.getAttribute?.call(e, `inert`);
                return (
                  n === `` ||
                  n === `true` ||
                  (t &&
                    e &&
                    (typeof e.closest == `function` ? e.closest(`[inert]`) : o(e.parentNode)))
                );
              },
              s = function (e) {
                var t = e?.getAttribute?.call(e, `contenteditable`);
                return t === `` || t === `true`;
              },
              c = function (e, t, r) {
                if (o(e)) return [];
                var a = Array.prototype.slice.apply(e.querySelectorAll(n));
                return (t && i.call(e, n) && a.unshift(e), (a = a.filter(r)), a);
              },
              l = function (e, t, r) {
                for (var a = [], s = Array.from(e); s.length;) {
                  var c = s.shift();
                  if (!o(c, !1))
                    if (c.tagName === `SLOT`) {
                      var u = c.assignedElements(),
                        d = l(u.length ? u : c.children, !0, r);
                      r.flatten
                        ? a.push.apply(a, d)
                        : a.push({
                            scopeParent: c,
                            candidates: d,
                          });
                    } else {
                      i.call(c, n) && r.filter(c) && (t || !e.includes(c)) && a.push(c);
                      var f =
                          c.shadowRoot ||
                          (typeof r.getShadowRoot == `function` && r.getShadowRoot(c)),
                        p = !o(f, !1) && (!r.shadowRootFilter || r.shadowRootFilter(c));
                      if (f && p) {
                        var m = l(f === !0 ? c.children : f.children, !0, r);
                        r.flatten
                          ? a.push.apply(a, m)
                          : a.push({
                              scopeParent: c,
                              candidates: m,
                            });
                      } else s.unshift.apply(s, c.children);
                    }
                }
                return a;
              },
              u = function (e) {
                return !isNaN(parseInt(e.getAttribute(`tabindex`), 10));
              },
              d = function (e) {
                if (!e) throw Error(`No node provided`);
                return e.tabIndex < 0 &&
                  (/^(AUDIO|VIDEO|DETAILS)$/.test(e.tagName) || s(e)) &&
                  !u(e)
                  ? 0
                  : e.tabIndex;
              },
              f = function (e, t) {
                var n = d(e);
                return n < 0 && t && !u(e) ? 0 : n;
              },
              p = function (e, t) {
                return e.tabIndex === t.tabIndex
                  ? e.documentOrder - t.documentOrder
                  : e.tabIndex - t.tabIndex;
              },
              m = function (e) {
                return e.tagName === `INPUT`;
              },
              h = function (e) {
                return m(e) && e.type === `hidden`;
              },
              g = function (e) {
                return (
                  e.tagName === `DETAILS` &&
                  Array.prototype.slice.apply(e.children).some(function (e) {
                    return e.tagName === `SUMMARY`;
                  })
                );
              },
              _ = function (e, t) {
                for (var n = 0; n < e.length; n++) if (e[n].checked && e[n].form === t) return e[n];
              },
              v = function (e) {
                if (!e.name) return !0;
                var t = e.form || a(e),
                  n = function (e) {
                    return t.querySelectorAll(`input[type="radio"][name="` + e + `"]`);
                  },
                  r;
                if (
                  typeof window < `u` &&
                  window.CSS !== void 0 &&
                  typeof window.CSS.escape == `function`
                )
                  r = n(window.CSS.escape(e.name));
                else
                  try {
                    r = n(e.name);
                  } catch (e) {
                    return (
                      console.error(
                        `Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s`,
                        e.message,
                      ),
                      !1
                    );
                  }
                var i = _(r, e.form);
                return !i || i === e;
              },
              y = function (e) {
                return m(e) && e.type === `radio`;
              },
              b = function (e) {
                return y(e) && !v(e);
              },
              x = function (e) {
                var t = e && a(e),
                  n = t?.host,
                  r = !1;
                if (t && t !== e) {
                  var i, o, s;
                  for (
                    r = !!(
                      ((i = n) != null && (o = i.ownerDocument) != null && o.contains(n)) ||
                      (e != null && (s = e.ownerDocument) != null && s.contains(e))
                    );
                    !r && n;
                  ) {
                    var c, l;
                    ((t = a(n)),
                      (n = t?.host),
                      (r = !!((c = n) != null && (l = c.ownerDocument) != null && l.contains(n))));
                  }
                }
                return r;
              },
              S = function (e) {
                var t = e.getBoundingClientRect(),
                  n = t.width,
                  r = t.height;
                return n === 0 && r === 0;
              },
              C = function (e, t) {
                var n = t.displayCheck,
                  r = t.getShadowRoot;
                if (n === `full-native` && `checkVisibility` in e)
                  return !e.checkVisibility({
                    checkOpacity: !1,
                    opacityProperty: !1,
                    contentVisibilityAuto: !0,
                    visibilityProperty: !0,
                    checkVisibilityCSS: !0,
                  });
                if (getComputedStyle(e).visibility === `hidden`) return !0;
                var o = i.call(e, `details>summary:first-of-type`) ? e.parentElement : e;
                if (i.call(o, `details:not([open]) *`)) return !0;
                if (!n || n === `full` || n === `full-native` || n === `legacy-full`) {
                  if (typeof r == `function`) {
                    for (var s = e; e;) {
                      var c = e.parentElement,
                        l = a(e);
                      if (c && !c.shadowRoot && r(c) === !0) return S(e);
                      e = e.assignedSlot
                        ? e.assignedSlot
                        : !c && l !== e.ownerDocument
                          ? l.host
                          : c;
                    }
                    e = s;
                  }
                  if (x(e)) return !e.getClientRects().length;
                  if (n !== `legacy-full`) return !0;
                } else if (n === `non-zero-area`) return S(e);
                return !1;
              },
              w = function (e) {
                if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(e.tagName))
                  for (var t = e.parentElement; t;) {
                    if (t.tagName === `FIELDSET` && t.disabled) {
                      for (var n = 0; n < t.children.length; n++) {
                        var r = t.children.item(n);
                        if (r.tagName === `LEGEND`)
                          return i.call(t, `fieldset[disabled] *`) ? !0 : !r.contains(e);
                      }
                      return !0;
                    }
                    t = t.parentElement;
                  }
                return !1;
              },
              ee = function (e, t) {
                return !(t.disabled || h(t) || C(t, e) || g(t) || w(t));
              },
              T = function (e, t) {
                return !(b(t) || d(t) < 0 || !ee(e, t));
              },
              te = function (e) {
                var t = parseInt(e.getAttribute(`tabindex`), 10);
                return !!(isNaN(t) || t >= 0);
              },
              ne = function (e) {
                var t = [],
                  n = [];
                return (
                  e.forEach(function (e, r) {
                    var i = !!e.scopeParent,
                      a = i ? e.scopeParent : e,
                      o = f(a, i),
                      s = i ? ne(e.candidates) : a;
                    o === 0
                      ? i
                        ? t.push.apply(t, s)
                        : t.push(a)
                      : n.push({
                          documentOrder: r,
                          tabIndex: o,
                          item: e,
                          isScope: i,
                          content: s,
                        });
                  }),
                  n
                    .sort(p)
                    .reduce(function (e, t) {
                      return (t.isScope ? e.push.apply(e, t.content) : e.push(t.content), e);
                    }, [])
                    .concat(t)
                );
              },
              re = function (e, t) {
                return (
                  (t ||= {}),
                  ne(
                    t.getShadowRoot
                      ? l([e], t.includeContainer, {
                          filter: T.bind(null, t),
                          flatten: !1,
                          getShadowRoot: t.getShadowRoot,
                          shadowRootFilter: te,
                        })
                      : c(e, t.includeContainer, T.bind(null, t)),
                  )
                );
              },
              ie = function (e, t) {
                return (
                  (t ||= {}),
                  t.getShadowRoot
                    ? l([e], t.includeContainer, {
                        filter: ee.bind(null, t),
                        flatten: !0,
                        getShadowRoot: t.getShadowRoot,
                      })
                    : c(e, t.includeContainer, ee.bind(null, t))
                );
              },
              E = function (e, t) {
                if (((t ||= {}), !e)) throw Error(`No node provided`);
                return i.call(e, n) === !1 ? !1 : T(t, e);
              },
              ae = t.concat(`iframe:not([inert]):not([inert] *)`).join(`,`);
            ((e.focusable = ie),
              (e.getTabIndex = d),
              (e.isFocusable = function (e, t) {
                if (((t ||= {}), !e)) throw Error(`No node provided`);
                return i.call(e, ae) === !1 ? !1 : ee(t, e);
              }),
              (e.isTabbable = E),
              (e.tabbable = re));
          },
        }),
        m = c({
          "node_modules/focus-trap/dist/focus-trap.js"(e) {
            var t = p();
            function n(e, t) {
              (t == null || t > e.length) && (t = e.length);
              for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
              return r;
            }
            function r(e) {
              if (Array.isArray(e)) return n(e);
            }
            function i(e, t, n, r, i, a, o) {
              try {
                var s = e[a](o),
                  c = s.value;
              } catch (e) {
                n(e);
                return;
              }
              s.done ? t(c) : Promise.resolve(c).then(r, i);
            }
            function a(e) {
              return function () {
                var t = this,
                  n = arguments;
                return new Promise(function (r, a) {
                  var o = e.apply(t, n);
                  function s(e) {
                    i(o, r, a, s, c, `next`, e);
                  }
                  function c(e) {
                    i(o, r, a, s, c, `throw`, e);
                  }
                  s(void 0);
                });
              };
            }
            function o(e, t) {
              var n = (typeof Symbol < `u` && e[Symbol.iterator]) || e[`@@iterator`];
              if (!n) {
                if (Array.isArray(e) || (n = v(e)) || t) {
                  n && (e = n);
                  var r = 0,
                    i = function () {};
                  return {
                    s: i,
                    n: function () {
                      return r >= e.length
                        ? {
                            done: !0,
                          }
                        : {
                            done: !1,
                            value: e[r++],
                          };
                    },
                    e: function (e) {
                      throw e;
                    },
                    f: i,
                  };
                }
                throw TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
              }
              var a,
                o = !0,
                s = !1;
              return {
                s: function () {
                  n = n.call(e);
                },
                n: function () {
                  var e = n.next();
                  return ((o = e.done), e);
                },
                e: function (e) {
                  ((s = !0), (a = e));
                },
                f: function () {
                  try {
                    o || n.return == null || n.return();
                  } finally {
                    if (s) throw a;
                  }
                },
              };
            }
            function s(e, t, n) {
              return (
                (t = _(t)) in e
                  ? Object.defineProperty(e, t, {
                      value: n,
                      enumerable: !0,
                      configurable: !0,
                      writable: !0,
                    })
                  : (e[t] = n),
                e
              );
            }
            function c(e) {
              if ((typeof Symbol < `u` && e[Symbol.iterator] != null) || e[`@@iterator`] != null)
                return Array.from(e);
            }
            function l() {
              throw TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
            }
            function u(e, t) {
              var n = Object.keys(e);
              if (Object.getOwnPropertySymbols) {
                var r = Object.getOwnPropertySymbols(e);
                (t &&
                  (r = r.filter(function (t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable;
                  })),
                  n.push.apply(n, r));
              }
              return n;
            }
            function d(e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t] == null ? {} : arguments[t];
                t % 2
                  ? u(Object(n), !0).forEach(function (t) {
                      s(e, t, n[t]);
                    })
                  : Object.getOwnPropertyDescriptors
                    ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
                    : u(Object(n)).forEach(function (t) {
                        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                      });
              }
              return e;
            }
            function f() {
              var e,
                t,
                n = typeof Symbol == `function` ? Symbol : {},
                r = n.iterator || `@@iterator`,
                i = n.toStringTag || `@@toStringTag`;
              function a(n, r, i, a) {
                var c = r && r.prototype instanceof s ? r : s,
                  l = Object.create(c.prototype);
                return (
                  m(
                    l,
                    `_invoke`,
                    (function (n, r, i) {
                      var a,
                        s,
                        c,
                        l = 0,
                        u = i || [],
                        d = !1,
                        f = {
                          p: 0,
                          n: 0,
                          v: e,
                          a: p,
                          f: p.bind(e, 4),
                          d: function (t, n) {
                            return ((a = t), (s = 0), (c = e), (f.n = n), o);
                          },
                        };
                      function p(n, r) {
                        for (s = n, c = r, t = 0; !d && l && !i && t < u.length; t++) {
                          var i,
                            a = u[t],
                            p = f.p,
                            m = a[2];
                          n > 3
                            ? (i = m === r) &&
                              ((c = a[(s = a[4]) ? 5 : ((s = 3), 3)]), (a[4] = a[5] = e))
                            : a[0] <= p &&
                              ((i = n < 2 && p < a[1])
                                ? ((s = 0), (f.v = r), (f.n = a[1]))
                                : p < m &&
                                  (i = n < 3 || a[0] > r || r > m) &&
                                  ((a[4] = n), (a[5] = r), (f.n = m), (s = 0)));
                        }
                        if (i || n > 1) return o;
                        throw ((d = !0), r);
                      }
                      return function (i, u, m) {
                        if (l > 1) throw TypeError(`Generator is already running`);
                        for (d && u === 1 && p(u, m), s = u, c = m; (t = s < 2 ? e : c) || !d;) {
                          a ||
                            (s ? (s < 3 ? (s > 1 && (f.n = -1), p(s, c)) : (f.n = c)) : (f.v = c));
                          try {
                            if (((l = 2), a)) {
                              if ((s || (i = `next`), (t = a[i]))) {
                                if (!(t = t.call(a, c)))
                                  throw TypeError(`iterator result is not an object`);
                                if (!t.done) return t;
                                ((c = t.value), s < 2 && (s = 0));
                              } else
                                (s === 1 && (t = a.return) && t.call(a),
                                  s < 2 &&
                                    ((c = TypeError(
                                      `The iterator does not provide a '` + i + `' method`,
                                    )),
                                    (s = 1)));
                              a = e;
                            } else if ((t = (d = f.n < 0) ? c : n.call(r, f)) !== o) break;
                          } catch (t) {
                            ((a = e), (s = 1), (c = t));
                          } finally {
                            l = 1;
                          }
                        }
                        return {
                          value: t,
                          done: d,
                        };
                      };
                    })(n, i, a),
                    !0,
                  ),
                  l
                );
              }
              var o = {};
              function s() {}
              function c() {}
              function l() {}
              t = Object.getPrototypeOf;
              var u = [][r]
                  ? t(t([][r]()))
                  : (m((t = {}), r, function () {
                      return this;
                    }),
                    t),
                d = (l.prototype = s.prototype = Object.create(u));
              function p(e) {
                return (
                  Object.setPrototypeOf
                    ? Object.setPrototypeOf(e, l)
                    : ((e.__proto__ = l), m(e, i, `GeneratorFunction`)),
                  (e.prototype = Object.create(d)),
                  e
                );
              }
              return (
                (c.prototype = l),
                m(d, `constructor`, l),
                m(l, `constructor`, c),
                (c.displayName = `GeneratorFunction`),
                m(l, i, `GeneratorFunction`),
                m(d),
                m(d, i, `Generator`),
                m(d, r, function () {
                  return this;
                }),
                m(d, `toString`, function () {
                  return `[object Generator]`;
                }),
                (f = function () {
                  return {
                    w: a,
                    m: p,
                  };
                })()
              );
            }
            function m(e, t, n, r) {
              var i = Object.defineProperty;
              try {
                i({}, ``, {});
              } catch {
                i = 0;
              }
              ((m = function (e, t, n, r) {
                function a(t, n) {
                  m(e, t, function (e) {
                    return this._invoke(t, n, e);
                  });
                }
                t
                  ? i
                    ? i(e, t, {
                        value: n,
                        enumerable: !r,
                        configurable: !r,
                        writable: !r,
                      })
                    : (e[t] = n)
                  : (a(`next`, 0), a(`throw`, 1), a(`return`, 2));
              }),
                m(e, t, n, r));
            }
            function h(e) {
              return r(e) || c(e) || v(e) || l();
            }
            function g(e, t) {
              if (typeof e != `object` || !e) return e;
              var n = e[Symbol.toPrimitive];
              if (n !== void 0) {
                var r = n.call(e, t);
                if (typeof r != `object`) return r;
                throw TypeError(`@@toPrimitive must return a primitive value.`);
              }
              return (t === `string` ? String : Number)(e);
            }
            function _(e) {
              var t = g(e, `string`);
              return typeof t == `symbol` ? t : t + ``;
            }
            function v(e, t) {
              if (e) {
                if (typeof e == `string`) return n(e, t);
                var r = {}.toString.call(e).slice(8, -1);
                return (
                  r === `Object` && e.constructor && (r = e.constructor.name),
                  r === `Map` || r === `Set`
                    ? Array.from(e)
                    : r === `Arguments` || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
                      ? n(e, t)
                      : void 0
                );
              }
            }
            var y = {
                getActiveTrap: function (e) {
                  return e?.length > 0 ? e[e.length - 1] : null;
                },
                activateTrap: function (e, t) {
                  t !== y.getActiveTrap(e) && y.pauseTrap(e);
                  var n = e.indexOf(t);
                  (n === -1 || e.splice(n, 1), e.push(t));
                },
                deactivateTrap: function (e, t) {
                  var n = e.indexOf(t);
                  (n !== -1 && e.splice(n, 1), y.unpauseTrap(e));
                },
                pauseTrap: function (e) {
                  y.getActiveTrap(e)?._setPausedState(!0);
                },
                unpauseTrap: function (e) {
                  var t = y.getActiveTrap(e);
                  t && !t._isManuallyPaused() && t._setPausedState(!1);
                },
              },
              b = function (e) {
                return (
                  e.tagName && e.tagName.toLowerCase() === `input` && typeof e.select == `function`
                );
              },
              x = function (e) {
                return e?.key === `Escape` || e?.key === `Esc` || e?.keyCode === 27;
              },
              S = function (e) {
                return e?.key === `Tab` || e?.keyCode === 9;
              },
              C = function (e) {
                return S(e) && !e.shiftKey;
              },
              w = function (e) {
                return S(e) && e.shiftKey;
              },
              ee = function (e) {
                return setTimeout(e, 0);
              },
              T = function (e) {
                var t = [...arguments].slice(1);
                return typeof e == `function` ? e.apply(void 0, t) : e;
              },
              te = function (e) {
                return e.target.shadowRoot && typeof e.composedPath == `function`
                  ? e.composedPath()[0]
                  : e.target;
              },
              ne = [];
            e.createFocusTrap = function (e, n) {
              var r = n?.document || document,
                i = n?.trapStack || ne,
                s = d(
                  {
                    returnFocusOnDeactivate: !0,
                    escapeDeactivates: !0,
                    delayInitialFocus: !0,
                    isolateSubtrees: !1,
                    isKeyForward: C,
                    isKeyBackward: w,
                  },
                  n,
                ),
                c = {
                  containers: [],
                  containerGroups: [],
                  tabbableGroups: [],
                  adjacentElements: new Set(),
                  alreadySilent: new Set(),
                  nodeFocusedBeforeActivation: null,
                  mostRecentlyFocusedNode: null,
                  active: !1,
                  paused: !1,
                  manuallyPaused: !1,
                  delayInitialFocusTimer: void 0,
                  recentNavEvent: void 0,
                },
                l,
                u = function (e, t, n) {
                  return e && e[t] !== void 0 ? e[t] : s[n || t];
                },
                p = function (e, t) {
                  var n = typeof t?.composedPath == `function` ? t.composedPath() : void 0;
                  return c.containerGroups.findIndex(function (t) {
                    var r = t.container,
                      i = t.tabbableNodes;
                    return (
                      r.contains(e) ||
                      n?.includes(r) ||
                      i.find(function (t) {
                        return t === e;
                      })
                    );
                  });
                },
                m = function (e) {
                  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {},
                    n = t.hasFallback,
                    i = n === void 0 ? !1 : n,
                    a = t.params,
                    o = a === void 0 ? [] : a,
                    c = s[e];
                  if (
                    (typeof c == `function` && (c = c.apply(void 0, h(o))),
                    c === !0 && (c = void 0),
                    !c)
                  ) {
                    if (c === void 0 || c === !1) return c;
                    throw Error(
                      `\`${e}\` was specified but was not a node, or did not return a node`,
                    );
                  }
                  var l = c;
                  if (typeof c == `string`) {
                    try {
                      l = r.querySelector(c);
                    } catch (t) {
                      throw Error(
                        `\`${e}\` appears to be an invalid selector; error="${t.message}"`,
                      );
                    }
                    if (!l && !i) throw Error(`\`${e}\` as selector refers to no known node`);
                  }
                  return l;
                },
                g = function () {
                  var e = m(`initialFocus`, {
                    hasFallback: !0,
                  });
                  if (e === !1) return !1;
                  if (e === void 0 || (e && !t.isFocusable(e, s.tabbableOptions))) {
                    if (p(r.activeElement) >= 0) e = r.activeElement;
                    else {
                      var n = c.tabbableGroups[0];
                      e = (n && n.firstTabbableNode) || m(`fallbackFocus`);
                    }
                  } else e === null && (e = m(`fallbackFocus`));
                  if (!e)
                    throw Error(`Your focus-trap needs to have at least one focusable element`);
                  return e;
                },
                _ = function () {
                  if (
                    ((c.containerGroups = c.containers.map(function (e) {
                      var n = t.tabbable(e, s.tabbableOptions),
                        r = t.focusable(e, s.tabbableOptions),
                        i = n.length > 0 ? n[0] : void 0,
                        a = n.length > 0 ? n[n.length - 1] : void 0,
                        o = r.find(function (e) {
                          return t.isTabbable(e);
                        }),
                        c = r
                          .slice()
                          .reverse()
                          .find(function (e) {
                            return t.isTabbable(e);
                          });
                      return {
                        container: e,
                        tabbableNodes: n,
                        focusableNodes: r,
                        posTabIndexesFound: !!n.find(function (e) {
                          return t.getTabIndex(e) > 0;
                        }),
                        firstTabbableNode: i,
                        lastTabbableNode: a,
                        firstDomTabbableNode: o,
                        lastDomTabbableNode: c,
                        nextTabbableNode: function (e) {
                          var i =
                              arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0,
                            a = n.indexOf(e);
                          return a < 0
                            ? i
                              ? r.slice(r.indexOf(e) + 1).find(function (e) {
                                  return t.isTabbable(e);
                                })
                              : r
                                  .slice(0, r.indexOf(e))
                                  .reverse()
                                  .find(function (e) {
                                    return t.isTabbable(e);
                                  })
                            : n[a + (i ? 1 : -1)];
                        },
                      };
                    })),
                    (c.tabbableGroups = c.containerGroups.filter(function (e) {
                      return e.tabbableNodes.length > 0;
                    })),
                    c.tabbableGroups.length <= 0 && !m(`fallbackFocus`))
                  )
                    throw Error(
                      `Your focus-trap must have at least one container with at least one tabbable node in it at all times`,
                    );
                  if (
                    c.containerGroups.find(function (e) {
                      return e.posTabIndexesFound;
                    }) &&
                    c.containerGroups.length > 1
                  )
                    throw Error(
                      `At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.`,
                    );
                },
                v = function (e) {
                  var t = e.activeElement;
                  if (t)
                    return t.shadowRoot && t.shadowRoot.activeElement !== null
                      ? v(t.shadowRoot)
                      : t;
                },
                re = function (e) {
                  if (e !== !1 && e !== v(document)) {
                    if (!e || !e.focus) {
                      re(g());
                      return;
                    }
                    (e.focus({
                      preventScroll: !!s.preventScroll,
                    }),
                      (c.mostRecentlyFocusedNode = e),
                      b(e) && e.select());
                  }
                },
                ie = function (e) {
                  var t = m(`setReturnFocus`, {
                    params: [e],
                  });
                  return t || (t === !1 ? !1 : e);
                },
                E = function (e) {
                  var n = e.target,
                    r = e.event,
                    i = e.isBackward,
                    a = i === void 0 ? !1 : i;
                  ((n ||= te(r)), _());
                  var o = null;
                  if (c.tabbableGroups.length > 0) {
                    var l = p(n, r),
                      u = l >= 0 ? c.containerGroups[l] : void 0;
                    if (l < 0)
                      o = a
                        ? c.tabbableGroups[c.tabbableGroups.length - 1].lastTabbableNode
                        : c.tabbableGroups[0].firstTabbableNode;
                    else if (a) {
                      var d = c.tabbableGroups.findIndex(function (e) {
                        var t = e.firstTabbableNode;
                        return n === t;
                      });
                      if (
                        (d < 0 &&
                          (u.container === n ||
                            (t.isFocusable(n, s.tabbableOptions) &&
                              !t.isTabbable(n, s.tabbableOptions) &&
                              !u.nextTabbableNode(n, !1))) &&
                          (d = l),
                        d >= 0)
                      ) {
                        var f = d === 0 ? c.tabbableGroups.length - 1 : d - 1,
                          h = c.tabbableGroups[f];
                        o = t.getTabIndex(n) >= 0 ? h.lastTabbableNode : h.lastDomTabbableNode;
                      } else S(r) || (o = u.nextTabbableNode(n, !1));
                    } else {
                      var g = c.tabbableGroups.findIndex(function (e) {
                        var t = e.lastTabbableNode;
                        return n === t;
                      });
                      if (
                        (g < 0 &&
                          (u.container === n ||
                            (t.isFocusable(n, s.tabbableOptions) &&
                              !t.isTabbable(n, s.tabbableOptions) &&
                              !u.nextTabbableNode(n))) &&
                          (g = l),
                        g >= 0)
                      ) {
                        var v = g === c.tabbableGroups.length - 1 ? 0 : g + 1,
                          y = c.tabbableGroups[v];
                        o = t.getTabIndex(n) >= 0 ? y.firstTabbableNode : y.firstDomTabbableNode;
                      } else S(r) || (o = u.nextTabbableNode(n));
                    }
                  } else o = m(`fallbackFocus`);
                  return o;
                },
                ae = function (e) {
                  if (!(p(te(e), e) >= 0)) {
                    if (T(s.clickOutsideDeactivates, e)) {
                      l.deactivate({
                        returnFocus: s.returnFocusOnDeactivate,
                      });
                      return;
                    }
                    T(s.allowOutsideClick, e) || e.preventDefault();
                  }
                },
                oe = function (e) {
                  var n = te(e),
                    r = p(n, e) >= 0;
                  if (r || n instanceof Document) r && (c.mostRecentlyFocusedNode = n);
                  else {
                    e.stopImmediatePropagation();
                    var i,
                      a = !0;
                    if (c.mostRecentlyFocusedNode) {
                      if (t.getTabIndex(c.mostRecentlyFocusedNode) > 0) {
                        var o = p(c.mostRecentlyFocusedNode),
                          l = c.containerGroups[o].tabbableNodes;
                        if (l.length > 0) {
                          var u = l.findIndex(function (e) {
                            return e === c.mostRecentlyFocusedNode;
                          });
                          u >= 0 &&
                            (s.isKeyForward(c.recentNavEvent)
                              ? u + 1 < l.length && ((i = l[u + 1]), (a = !1))
                              : u - 1 >= 0 && ((i = l[u - 1]), (a = !1)));
                        }
                      } else
                        c.containerGroups.some(function (e) {
                          return e.tabbableNodes.some(function (e) {
                            return t.getTabIndex(e) > 0;
                          });
                        }) || (a = !1);
                    } else a = !1;
                    (a &&
                      (i = E({
                        target: c.mostRecentlyFocusedNode,
                        isBackward: s.isKeyBackward(c.recentNavEvent),
                      })),
                      re(i || c.mostRecentlyFocusedNode || g()));
                  }
                  c.recentNavEvent = void 0;
                },
                se = function (e) {
                  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
                  c.recentNavEvent = e;
                  var n = E({
                    event: e,
                    isBackward: t,
                  });
                  n && (S(e) && e.preventDefault(), re(n));
                },
                ce = function (e) {
                  (s.isKeyForward(e) || s.isKeyBackward(e)) && se(e, s.isKeyBackward(e));
                },
                D = function (e) {
                  x(e) && T(s.escapeDeactivates, e) !== !1 && (e.preventDefault(), l.deactivate());
                },
                le = function (e) {
                  p(te(e), e) >= 0 ||
                    T(s.clickOutsideDeactivates, e) ||
                    T(s.allowOutsideClick, e) ||
                    (e.preventDefault(), e.stopImmediatePropagation());
                },
                ue = function () {
                  if (!c.active) return Promise.resolve();
                  y.activateTrap(i, l);
                  var e;
                  return (
                    s.delayInitialFocus
                      ? (e = new Promise(function (e) {
                          c.delayInitialFocusTimer = ee(function () {
                            (re(g()), e());
                          });
                        }))
                      : ((e = Promise.resolve()), re(g())),
                    r.addEventListener(`focusin`, oe, !0),
                    r.addEventListener(`mousedown`, ae, {
                      capture: !0,
                      passive: !1,
                    }),
                    r.addEventListener(`touchstart`, ae, {
                      capture: !0,
                      passive: !1,
                    }),
                    r.addEventListener(`click`, le, {
                      capture: !0,
                      passive: !1,
                    }),
                    r.addEventListener(`keydown`, ce, {
                      capture: !0,
                      passive: !1,
                    }),
                    r.addEventListener(`keydown`, D),
                    e
                  );
                },
                de = function (e) {
                  (c.active && !c.paused && l._setSubtreeIsolation(!1),
                    c.adjacentElements.clear(),
                    c.alreadySilent.clear());
                  var t = new Set(),
                    n = new Set(),
                    r = o(e),
                    i;
                  try {
                    for (r.s(); !(i = r.n()).done;) {
                      var a = i.value;
                      t.add(a);
                      for (
                        var s = typeof ShadowRoot < `u` && a.getRootNode() instanceof ShadowRoot,
                          u = a;
                        u;
                      ) {
                        t.add(u);
                        var d = u.parentElement,
                          f = [];
                        d
                          ? (f = d.children)
                          : !d &&
                            s &&
                            ((f = u.getRootNode().children),
                            (d = u.getRootNode().host),
                            (s = typeof ShadowRoot < `u` && d.getRootNode() instanceof ShadowRoot));
                        var p = o(f),
                          m;
                        try {
                          for (p.s(); !(m = p.n()).done;) {
                            var h = m.value;
                            n.add(h);
                          }
                        } catch (e) {
                          p.e(e);
                        } finally {
                          p.f();
                        }
                        u = d;
                      }
                    }
                  } catch (e) {
                    r.e(e);
                  } finally {
                    r.f();
                  }
                  (t.forEach(function (e) {
                    n.delete(e);
                  }),
                    (c.adjacentElements = n));
                },
                fe = function () {
                  if (c.active)
                    return (
                      r.removeEventListener(`focusin`, oe, !0),
                      r.removeEventListener(`mousedown`, ae, !0),
                      r.removeEventListener(`touchstart`, ae, !0),
                      r.removeEventListener(`click`, le, !0),
                      r.removeEventListener(`keydown`, ce, !0),
                      r.removeEventListener(`keydown`, D),
                      l
                    );
                },
                pe =
                  typeof window < `u` && `MutationObserver` in window
                    ? new MutationObserver(function (e) {
                        e.some(function (e) {
                          return Array.from(e.removedNodes).some(function (e) {
                            return e === c.mostRecentlyFocusedNode;
                          });
                        }) && re(g());
                      })
                    : void 0,
                O = function () {
                  pe &&
                    (pe.disconnect(),
                    c.active &&
                      !c.paused &&
                      c.containers.map(function (e) {
                        pe.observe(e, {
                          subtree: !0,
                          childList: !0,
                        });
                      }));
                };
              return (
                (l = {
                  get active() {
                    return c.active;
                  },
                  get paused() {
                    return c.paused;
                  },
                  activate: function (e) {
                    if (c.active) return this;
                    var t = u(e, `onActivate`),
                      n = u(e, `onPostActivate`),
                      o = u(e, `checkCanFocusTrap`),
                      s = y.getActiveTrap(i),
                      d = !1;
                    if (s && !s.paused) {
                      var p;
                      ((p = s._setSubtreeIsolation) == null || p.call(s, !1), (d = !0));
                    }
                    try {
                      (o || _(),
                        (c.active = !0),
                        (c.paused = !1),
                        (c.nodeFocusedBeforeActivation = v(r)),
                        t?.());
                      var m = (function () {
                        var e = a(
                          f().m(function e() {
                            return f().w(function (e) {
                              for (;;)
                                switch (e.n) {
                                  case 0:
                                    return (o && _(), (e.n = 1), ue());
                                  case 1:
                                    (l._setSubtreeIsolation(!0), O(), n?.());
                                  case 2:
                                    return e.a(2);
                                }
                            }, e);
                          }),
                        );
                        return function () {
                          return e.apply(this, arguments);
                        };
                      })();
                      if (o) return (o(c.containers.concat()).then(m, m), this);
                      m();
                    } catch (e) {
                      if (s === y.getActiveTrap(i) && d) {
                        var h;
                        (h = s._setSubtreeIsolation) == null || h.call(s, !0);
                      }
                      throw e;
                    }
                    return this;
                  },
                  deactivate: function (e) {
                    if (!c.active) return this;
                    var t = d(
                      {
                        onDeactivate: s.onDeactivate,
                        onPostDeactivate: s.onPostDeactivate,
                        checkCanReturnFocus: s.checkCanReturnFocus,
                      },
                      e,
                    );
                    (clearTimeout(c.delayInitialFocusTimer),
                      (c.delayInitialFocusTimer = void 0),
                      c.paused || l._setSubtreeIsolation(!1),
                      c.alreadySilent.clear(),
                      fe(),
                      (c.active = !1),
                      (c.paused = !1),
                      O(),
                      y.deactivateTrap(i, l));
                    var n = u(t, `onDeactivate`),
                      r = u(t, `onPostDeactivate`),
                      a = u(t, `checkCanReturnFocus`),
                      o = u(t, `returnFocus`, `returnFocusOnDeactivate`);
                    n?.();
                    var f = function () {
                      ee(function () {
                        (o && re(ie(c.nodeFocusedBeforeActivation)), r?.());
                      });
                    };
                    return o && a
                      ? (a(ie(c.nodeFocusedBeforeActivation)).then(f, f), this)
                      : (f(), this);
                  },
                  pause: function (e) {
                    return c.active ? ((c.manuallyPaused = !0), this._setPausedState(!0, e)) : this;
                  },
                  unpause: function (e) {
                    return !c.active || ((c.manuallyPaused = !1), i[i.length - 1] !== this)
                      ? this
                      : this._setPausedState(!1, e);
                  },
                  updateContainerElements: function (e) {
                    return (
                      (c.containers = []
                        .concat(e)
                        .filter(Boolean)
                        .map(function (e) {
                          return typeof e == `string` ? r.querySelector(e) : e;
                        })),
                      s.isolateSubtrees && de(c.containers),
                      c.active && (_(), c.paused || l._setSubtreeIsolation(!0)),
                      O(),
                      this
                    );
                  },
                }),
                Object.defineProperties(l, {
                  _isManuallyPaused: {
                    value: function () {
                      return c.manuallyPaused;
                    },
                  },
                  _setPausedState: {
                    value: function (e, t) {
                      if (c.paused === e) return this;
                      if (((c.paused = e), e)) {
                        var n = u(t, `onPause`),
                          r = u(t, `onPostPause`);
                        (n?.(), fe(), l._setSubtreeIsolation(!1), O(), r?.());
                      } else {
                        var i = u(t, `onUnpause`),
                          o = u(t, `onPostUnpause`);
                        (i?.(),
                          (function () {
                            var e = a(
                              f().m(function e() {
                                return f().w(function (e) {
                                  for (;;)
                                    switch (e.n) {
                                      case 0:
                                        return (_(), (e.n = 1), ue());
                                      case 1:
                                        (l._setSubtreeIsolation(!0), O(), o?.());
                                      case 2:
                                        return e.a(2);
                                    }
                                }, e);
                              }),
                            );
                            return function () {
                              return e.apply(this, arguments);
                            };
                          })()());
                      }
                      return this;
                    },
                  },
                  _setSubtreeIsolation: {
                    value: function (e) {
                      s.isolateSubtrees &&
                        c.adjacentElements.forEach(function (t) {
                          if (e)
                            switch (s.isolateSubtrees) {
                              case `aria-hidden`:
                                ((t.ariaHidden === `true` ||
                                  t.getAttribute(`aria-hidden`)?.toLowerCase() === `true`) &&
                                  c.alreadySilent.add(t),
                                  t.setAttribute(`aria-hidden`, `true`));
                                break;
                              default:
                                ((t.inert || t.hasAttribute(`inert`)) && c.alreadySilent.add(t),
                                  t.setAttribute(`inert`, !0));
                                break;
                            }
                          else if (!c.alreadySilent.has(t))
                            switch (s.isolateSubtrees) {
                              case `aria-hidden`:
                                t.removeAttribute(`aria-hidden`);
                                break;
                              default:
                                t.removeAttribute(`inert`);
                                break;
                            }
                        });
                    },
                  },
                }),
                l.updateContainerElements(e),
                l
              );
            };
          },
        }),
        h = {};
      (l(h, {
        default: () => S,
        focus: () => v,
      }),
        (t.exports = f(h)));
      var g = d(m()),
        _ = d(p());
      function v(e) {
        let t, n;
        (window.addEventListener(`focusin`, () => {
          ((t = n), (n = document.activeElement));
        }),
          e.magic(`focus`, (e) => {
            let r = e;
            return {
              __noscroll: !1,
              __wrapAround: !1,
              within(e) {
                return ((r = e), this);
              },
              withoutScrolling() {
                return ((this.__noscroll = !0), this);
              },
              noscroll() {
                return ((this.__noscroll = !0), this);
              },
              withWrapAround() {
                return ((this.__wrapAround = !0), this);
              },
              wrap() {
                return this.withWrapAround();
              },
              focusable(e) {
                return (0, _.isFocusable)(e);
              },
              previouslyFocused() {
                return t;
              },
              lastFocused() {
                return t;
              },
              focused() {
                return n;
              },
              focusables() {
                return Array.isArray(r)
                  ? r
                  : (0, _.focusable)(r, {
                      displayCheck: `none`,
                    });
              },
              all() {
                return this.focusables();
              },
              isFirst(e) {
                let t = this.all();
                return t[0] && t[0].isSameNode(e);
              },
              isLast(e) {
                let t = this.all();
                return t.length && t.slice(-1)[0].isSameNode(e);
              },
              getFirst() {
                return this.all()[0];
              },
              getLast() {
                return this.all().slice(-1)[0];
              },
              getNext() {
                let e = this.all(),
                  t = document.activeElement;
                if (e.indexOf(t) !== -1)
                  return this.__wrapAround && e.indexOf(t) === e.length - 1
                    ? e[0]
                    : e[e.indexOf(t) + 1];
              },
              getPrevious() {
                let e = this.all(),
                  t = document.activeElement;
                if (e.indexOf(t) !== -1)
                  return this.__wrapAround && e.indexOf(t) === 0
                    ? e.slice(-1)[0]
                    : e[e.indexOf(t) - 1];
              },
              first() {
                this.focus(this.getFirst());
              },
              last() {
                this.focus(this.getLast());
              },
              next() {
                this.focus(this.getNext());
              },
              previous() {
                this.focus(this.getPrevious());
              },
              prev() {
                return this.previous();
              },
              focus(e) {
                e &&
                  setTimeout(() => {
                    (e.hasAttribute(`tabindex`) || e.setAttribute(`tabindex`, `0`),
                      e.focus({
                        preventScroll: this.__noscroll,
                      }));
                  });
              },
            };
          }),
          e.directive(
            `trap`,
            e.skipDuringClone(
              (t, { expression: n, modifiers: r }, { effect: i, evaluateLater: a, cleanup: o }) => {
                let s = a(n),
                  c = !1,
                  l = {
                    escapeDeactivates: !1,
                    allowOutsideClick: !0,
                    fallbackFocus: () => t,
                  },
                  u = () => {};
                if (r.includes(`noautofocus`)) l.initialFocus = !1;
                else {
                  let e = t.querySelector(`[autofocus]`);
                  e && (l.initialFocus = e);
                }
                r.includes(`inert`) &&
                  (l.onPostActivate = () => {
                    e.nextTick(() => {
                      u = y(t);
                    });
                  });
                let d = (0, g.createFocusTrap)(t, l),
                  f = () => {},
                  p = () => {
                    (u(),
                      (u = () => {}),
                      f(),
                      (f = () => {}),
                      d.deactivate({
                        returnFocus: !r.includes(`noreturn`),
                      }));
                  };
                (i(() =>
                  s((e) => {
                    c !== e &&
                      (e &&
                        !c &&
                        (r.includes(`noscroll`) && (f = x()),
                        setTimeout(() => {
                          d.activate();
                        }, 15)),
                      !e && c && p(),
                      (c = !!e));
                  }),
                ),
                  o(p));
              },
              (e, { expression: t, modifiers: n }, { evaluate: r }) => {
                n.includes(`inert`) && r(t) && y(e);
              },
            ),
          ));
      }
      function y(e) {
        let t = [];
        return (
          b(e, (e) => {
            let n = e.hasAttribute(`aria-hidden`);
            (e.setAttribute(`aria-hidden`, `true`),
              t.push(() => n || e.removeAttribute(`aria-hidden`)));
          }),
          () => {
            for (; t.length;) t.pop()();
          }
        );
      }
      function b(e, t) {
        e.isSameNode(document.body) ||
          !e.parentNode ||
          Array.from(e.parentNode.children).forEach((n) => {
            n.isSameNode(e) ? b(e.parentNode, t) : t(n);
          });
      }
      function x() {
        let e = document.documentElement.style.overflow,
          t = document.documentElement.style.paddingRight,
          n = window.innerWidth - document.documentElement.clientWidth,
          r = window.getComputedStyle(document.documentElement).scrollbarGutter;
        return (
          (document.documentElement.style.overflow = `hidden`),
          r && r !== `auto`
            ? () => {
                document.documentElement.style.overflow = e;
              }
            : ((document.documentElement.style.paddingRight = `${n}px`),
              () => {
                ((document.documentElement.style.overflow = e),
                  (document.documentElement.style.paddingRight = t));
              })
        );
      }
      var S = v;
    },
  }),
  Pa = ka({
    "node_modules/@alpinejs/intersect/dist/module.cjs.js"(e, t) {
      var n = Object.defineProperty,
        r = Object.getOwnPropertyDescriptor,
        i = Object.getOwnPropertyNames,
        a = Object.prototype.hasOwnProperty,
        o = (e, t) => {
          for (var r in t)
            n(e, r, {
              get: t[r],
              enumerable: !0,
            });
        },
        s = (e, t, o, s) => {
          if ((t && typeof t == `object`) || typeof t == `function`)
            for (let c of i(t))
              !a.call(e, c) &&
                c !== o &&
                n(e, c, {
                  get: () => t[c],
                  enumerable: !(s = r(t, c)) || s.enumerable,
                });
          return e;
        },
        c = (e) =>
          s(
            n({}, `__esModule`, {
              value: !0,
            }),
            e,
          ),
        l = {};
      (o(l, {
        default: () => m,
        intersect: () => u,
      }),
        (t.exports = c(l)));
      function u(e) {
        e.directive(
          `intersect`,
          e.skipDuringClone(
            (e, { value: t, expression: n, modifiers: r }, { evaluateLater: i, cleanup: a }) => {
              let o = i(n),
                s = {
                  rootMargin: p(r),
                  threshold: d(r),
                },
                c = new IntersectionObserver((e) => {
                  e.forEach((e) => {
                    e.isIntersecting !== (t === `leave`) &&
                      (o(), r.includes(`once`) && c.disconnect());
                  });
                }, s);
              (c.observe(e),
                a(() => {
                  c.disconnect();
                }));
            },
          ),
        );
      }
      function d(e) {
        if (e.includes(`full`)) return 0.99;
        if (e.includes(`half`)) return 0.5;
        if (!e.includes(`threshold`)) return 0;
        let t = e[e.indexOf(`threshold`) + 1];
        return t === `100` ? 1 : t === `0` ? 0 : Number(`.${t}`);
      }
      function f(e) {
        let t = e.match(/^(-?[0-9]+)(px|%)?$/);
        return t ? t[1] + (t[2] || `px`) : void 0;
      }
      function p(e) {
        let t = `0px 0px 0px 0px`,
          n = e.indexOf(`margin`);
        if (n === -1) return t;
        let r = [];
        for (let t = 1; t < 5; t++) r.push(f(e[n + t] || ``));
        return ((r = r.filter((e) => e !== void 0)), r.length ? r.join(` `).trim() : t);
      }
      var m = u;
    },
  }),
  Fa = ka({
    "node_modules/@alpinejs/resize/dist/module.cjs.js"(e, t) {
      var n = Object.defineProperty,
        r = Object.getOwnPropertyDescriptor,
        i = Object.getOwnPropertyNames,
        a = Object.prototype.hasOwnProperty,
        o = (e, t) => {
          for (var r in t)
            n(e, r, {
              get: t[r],
              enumerable: !0,
            });
        },
        s = (e, t, o, s) => {
          if ((t && typeof t == `object`) || typeof t == `function`)
            for (let c of i(t))
              !a.call(e, c) &&
                c !== o &&
                n(e, c, {
                  get: () => t[c],
                  enumerable: !(s = r(t, c)) || s.enumerable,
                });
          return e;
        },
        c = (e) =>
          s(
            n({}, `__esModule`, {
              value: !0,
            }),
            e,
          ),
        l = {};
      (o(l, {
        default: () => g,
        resize: () => u,
      }),
        (t.exports = c(l)));
      function u(e) {
        e.directive(
          `resize`,
          e.skipDuringClone(
            (e, { value: t, expression: n, modifiers: r }, { evaluateLater: i, cleanup: a }) => {
              let o = i(n),
                s = (e, t) => {
                  o(() => {}, {
                    scope: {
                      $width: e,
                      $height: t,
                    },
                  });
                },
                c = r.includes(`document`) ? m(s) : d(e, s);
              a(() => c());
            },
          ),
        );
      }
      function d(e, t) {
        let n = new ResizeObserver((e) => {
          let [n, r] = h(e);
          t(n, r);
        });
        return (n.observe(e), () => n.disconnect());
      }
      var f,
        p = new Set();
      function m(e) {
        return (
          p.add(e),
          f ||
            ((f = new ResizeObserver((e) => {
              let [t, n] = h(e);
              p.forEach((e) => e(t, n));
            })),
            f.observe(document.documentElement)),
          () => {
            p.delete(e);
          }
        );
      }
      function h(e) {
        let t, n;
        for (let r of e) ((t = r.borderBoxSize[0].inlineSize), (n = r.borderBoxSize[0].blockSize));
        return [t, n];
      }
      var g = u;
    },
  }),
  Ia = ka({
    "node_modules/@alpinejs/anchor/dist/module.cjs.js"(e, t) {
      var n = Object.defineProperty,
        r = Object.getOwnPropertyDescriptor,
        i = Object.getOwnPropertyNames,
        a = Object.prototype.hasOwnProperty,
        o = (e, t) => {
          for (var r in t)
            n(e, r, {
              get: t[r],
              enumerable: !0,
            });
        },
        s = (e, t, o, s) => {
          if ((t && typeof t == `object`) || typeof t == `function`)
            for (let c of i(t))
              !a.call(e, c) &&
                c !== o &&
                n(e, c, {
                  get: () => t[c],
                  enumerable: !(s = r(t, c)) || s.enumerable,
                });
          return e;
        },
        c = (e) =>
          s(
            n({}, `__esModule`, {
              value: !0,
            }),
            e,
          ),
        l = {};
      (o(l, {
        anchor: () => R,
        default: () => Ye,
      }),
        (t.exports = c(l)));
      var u = Math.min,
        d = Math.max,
        f = Math.round,
        p = Math.floor,
        m = (e) => ({
          x: e,
          y: e,
        }),
        h = {
          left: `right`,
          right: `left`,
          bottom: `top`,
          top: `bottom`,
        },
        g = {
          start: `end`,
          end: `start`,
        };
      function _(e, t, n) {
        return d(e, u(t, n));
      }
      function v(e, t) {
        return typeof e == `function` ? e(t) : e;
      }
      function y(e) {
        return e.split(`-`)[0];
      }
      function b(e) {
        return e.split(`-`)[1];
      }
      function x(e) {
        return e === `x` ? `y` : `x`;
      }
      function S(e) {
        return e === `y` ? `height` : `width`;
      }
      function C(e) {
        return [`top`, `bottom`].includes(y(e)) ? `y` : `x`;
      }
      function w(e) {
        return x(C(e));
      }
      function ee(e, t, n) {
        n === void 0 && (n = !1);
        let r = b(e),
          i = w(e),
          a = S(i),
          o =
            i === `x`
              ? r === (n ? `end` : `start`)
                ? `right`
                : `left`
              : r === `start`
                ? `bottom`
                : `top`;
        return (t.reference[a] > t.floating[a] && (o = ie(o)), [o, ie(o)]);
      }
      function T(e) {
        let t = ie(e);
        return [te(e), t, te(t)];
      }
      function te(e) {
        return e.replace(/start|end/g, (e) => g[e]);
      }
      function ne(e, t, n) {
        let r = [`left`, `right`],
          i = [`right`, `left`],
          a = [`top`, `bottom`],
          o = [`bottom`, `top`];
        switch (e) {
          case `top`:
          case `bottom`:
            return n ? (t ? i : r) : t ? r : i;
          case `left`:
          case `right`:
            return t ? a : o;
          default:
            return [];
        }
      }
      function re(e, t, n, r) {
        let i = b(e),
          a = ne(y(e), n === `start`, r);
        return (i && ((a = a.map((e) => e + `-` + i)), t && (a = a.concat(a.map(te)))), a);
      }
      function ie(e) {
        return e.replace(/left|right|bottom|top/g, (e) => h[e]);
      }
      function E(e) {
        return {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          ...e,
        };
      }
      function ae(e) {
        return typeof e == `number`
          ? {
              top: e,
              right: e,
              bottom: e,
              left: e,
            }
          : E(e);
      }
      function oe(e) {
        return {
          ...e,
          top: e.y,
          left: e.x,
          right: e.x + e.width,
          bottom: e.y + e.height,
        };
      }
      function se(e, t, n) {
        let { reference: r, floating: i } = e,
          a = C(t),
          o = w(t),
          s = S(o),
          c = y(t),
          l = a === `y`,
          u = r.x + r.width / 2 - i.width / 2,
          d = r.y + r.height / 2 - i.height / 2,
          f = r[s] / 2 - i[s] / 2,
          p;
        switch (c) {
          case `top`:
            p = {
              x: u,
              y: r.y - i.height,
            };
            break;
          case `bottom`:
            p = {
              x: u,
              y: r.y + r.height,
            };
            break;
          case `right`:
            p = {
              x: r.x + r.width,
              y: d,
            };
            break;
          case `left`:
            p = {
              x: r.x - i.width,
              y: d,
            };
            break;
          default:
            p = {
              x: r.x,
              y: r.y,
            };
        }
        switch (b(t)) {
          case `start`:
            p[o] -= f * (n && l ? -1 : 1);
            break;
          case `end`:
            p[o] += f * (n && l ? -1 : 1);
            break;
        }
        return p;
      }
      var ce = async (e, t, n) => {
        let {
            placement: r = `bottom`,
            strategy: i = `absolute`,
            middleware: a = [],
            platform: o,
          } = n,
          s = a.filter(Boolean),
          c = await (o.isRTL == null ? void 0 : o.isRTL(t)),
          l = await o.getElementRects({
            reference: e,
            floating: t,
            strategy: i,
          }),
          { x: u, y: d } = se(l, r, c),
          f = r,
          p = {},
          m = 0;
        for (let n = 0; n < s.length; n++) {
          let { name: a, fn: h } = s[n],
            {
              x: g,
              y: _,
              data: v,
              reset: y,
            } = await h({
              x: u,
              y: d,
              initialPlacement: r,
              placement: f,
              strategy: i,
              middlewareData: p,
              rects: l,
              platform: o,
              elements: {
                reference: e,
                floating: t,
              },
            });
          if (
            ((u = g ?? u),
            (d = _ ?? d),
            (p = {
              ...p,
              [a]: {
                ...p[a],
                ...v,
              },
            }),
            y && m <= 50)
          ) {
            (m++,
              typeof y == `object` &&
                (y.placement && (f = y.placement),
                y.rects &&
                  (l =
                    y.rects === !0
                      ? await o.getElementRects({
                          reference: e,
                          floating: t,
                          strategy: i,
                        })
                      : y.rects),
                ({ x: u, y: d } = se(l, f, c))),
              (n = -1));
            continue;
          }
        }
        return {
          x: u,
          y: d,
          placement: f,
          strategy: i,
          middlewareData: p,
        };
      };
      async function D(e, t) {
        t === void 0 && (t = {});
        let { x: n, y: r, platform: i, rects: a, elements: o, strategy: s } = e,
          {
            boundary: c = `clippingAncestors`,
            rootBoundary: l = `viewport`,
            elementContext: u = `floating`,
            altBoundary: d = !1,
            padding: f = 0,
          } = v(t, e),
          p = ae(f),
          m = o[d ? (u === `floating` ? `reference` : `floating`) : u],
          h = oe(
            await i.getClippingRect({
              element:
                ((await (i.isElement == null ? void 0 : i.isElement(m))) ?? !0)
                  ? m
                  : m.contextElement ||
                    (await (i.getDocumentElement == null
                      ? void 0
                      : i.getDocumentElement(o.floating))),
              boundary: c,
              rootBoundary: l,
              strategy: s,
            }),
          ),
          g =
            u === `floating`
              ? {
                  ...a.floating,
                  x: n,
                  y: r,
                }
              : a.reference,
          _ = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(o.floating)),
          y = ((await (i.isElement == null ? void 0 : i.isElement(_))) &&
            (await (i.getScale == null ? void 0 : i.getScale(_)))) || {
            x: 1,
            y: 1,
          },
          b = oe(
            i.convertOffsetParentRelativeRectToViewportRelativeRect
              ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
                  rect: g,
                  offsetParent: _,
                  strategy: s,
                })
              : g,
          );
        return {
          top: (h.top - b.top + p.top) / y.y,
          bottom: (b.bottom - h.bottom + p.bottom) / y.y,
          left: (h.left - b.left + p.left) / y.x,
          right: (b.right - h.right + p.right) / y.x,
        };
      }
      var le = function (e) {
        return (
          e === void 0 && (e = {}),
          {
            name: `flip`,
            options: e,
            async fn(t) {
              var n;
              let {
                  placement: r,
                  middlewareData: i,
                  rects: a,
                  initialPlacement: o,
                  platform: s,
                  elements: c,
                } = t,
                {
                  mainAxis: l = !0,
                  crossAxis: u = !0,
                  fallbackPlacements: d,
                  fallbackStrategy: f = `bestFit`,
                  fallbackAxisSideDirection: p = `none`,
                  flipAlignment: m = !0,
                  ...h
                } = v(e, t);
              if ((n = i.arrow) != null && n.alignmentOffset) return {};
              let g = y(r),
                _ = y(o) === o,
                b = await (s.isRTL == null ? void 0 : s.isRTL(c.floating)),
                x = d || (_ || !m ? [ie(o)] : T(o));
              !d && p !== `none` && x.push(...re(o, m, p, b));
              let S = [o, ...x],
                C = await D(t, h),
                w = [],
                te = i.flip?.overflows || [];
              if ((l && w.push(C[g]), u)) {
                let e = ee(r, a, b);
                w.push(C[e[0]], C[e[1]]);
              }
              if (
                ((te = [
                  ...te,
                  {
                    placement: r,
                    overflows: w,
                  },
                ]),
                !w.every((e) => e <= 0))
              ) {
                let e = (i.flip?.index || 0) + 1,
                  t = S[e];
                if (t)
                  return {
                    data: {
                      index: e,
                      overflows: te,
                    },
                    reset: {
                      placement: t,
                    },
                  };
                let n = te
                  .filter((e) => e.overflows[0] <= 0)
                  .sort((e, t) => e.overflows[1] - t.overflows[1])[0]?.placement;
                if (!n)
                  switch (f) {
                    case `bestFit`: {
                      let e = te
                        .map((e) => [
                          e.placement,
                          e.overflows.filter((e) => e > 0).reduce((e, t) => e + t, 0),
                        ])
                        .sort((e, t) => e[1] - t[1])[0]?.[0];
                      e && (n = e);
                      break;
                    }
                    case `initialPlacement`:
                      n = o;
                      break;
                  }
                if (r !== n)
                  return {
                    reset: {
                      placement: n,
                    },
                  };
              }
              return {};
            },
          }
        );
      };
      async function ue(e, t) {
        let { placement: n, platform: r, elements: i } = e,
          a = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)),
          o = y(n),
          s = b(n),
          c = C(n) === `y`,
          l = [`left`, `top`].includes(o) ? -1 : 1,
          u = a && c ? -1 : 1,
          d = v(t, e),
          {
            mainAxis: f,
            crossAxis: p,
            alignmentAxis: m,
          } = typeof d == `number`
            ? {
                mainAxis: d,
                crossAxis: 0,
                alignmentAxis: null,
              }
            : {
                mainAxis: 0,
                crossAxis: 0,
                alignmentAxis: null,
                ...d,
              };
        return (
          s && typeof m == `number` && (p = s === `end` ? m * -1 : m),
          c
            ? {
                x: p * u,
                y: f * l,
              }
            : {
                x: f * l,
                y: p * u,
              }
        );
      }
      var de = function (e) {
          return (
            e === void 0 && (e = 0),
            {
              name: `offset`,
              options: e,
              async fn(t) {
                let { x: n, y: r } = t,
                  i = await ue(t, e);
                return {
                  x: n + i.x,
                  y: r + i.y,
                  data: i,
                };
              },
            }
          );
        },
        fe = function (e) {
          return (
            e === void 0 && (e = {}),
            {
              name: `shift`,
              options: e,
              async fn(t) {
                let { x: n, y: r, placement: i } = t,
                  {
                    mainAxis: a = !0,
                    crossAxis: o = !1,
                    limiter: s = {
                      fn: (e) => {
                        let { x: t, y: n } = e;
                        return {
                          x: t,
                          y: n,
                        };
                      },
                    },
                    ...c
                  } = v(e, t),
                  l = {
                    x: n,
                    y: r,
                  },
                  u = await D(t, c),
                  d = C(y(i)),
                  f = x(d),
                  p = l[f],
                  m = l[d];
                if (a) {
                  let e = f === `y` ? `top` : `left`,
                    t = f === `y` ? `bottom` : `right`,
                    n = p + u[e],
                    r = p - u[t];
                  p = _(n, p, r);
                }
                if (o) {
                  let e = d === `y` ? `top` : `left`,
                    t = d === `y` ? `bottom` : `right`,
                    n = m + u[e],
                    r = m - u[t];
                  m = _(n, m, r);
                }
                let h = s.fn({
                  ...t,
                  [f]: p,
                  [d]: m,
                });
                return {
                  ...h,
                  data: {
                    x: h.x - n,
                    y: h.y - r,
                  },
                };
              },
            }
          );
        };
      function pe(e) {
        return he(e) ? (e.nodeName || ``).toLowerCase() : `#document`;
      }
      function O(e) {
        return e?.ownerDocument?.defaultView || window;
      }
      function me(e) {
        return ((he(e) ? e.ownerDocument : e.document) || window.document)?.documentElement;
      }
      function he(e) {
        return e instanceof Node || e instanceof O(e).Node;
      }
      function ge(e) {
        return e instanceof Element || e instanceof O(e).Element;
      }
      function _e(e) {
        return e instanceof HTMLElement || e instanceof O(e).HTMLElement;
      }
      function ve(e) {
        return typeof ShadowRoot > `u`
          ? !1
          : e instanceof ShadowRoot || e instanceof O(e).ShadowRoot;
      }
      function ye(e) {
        let { overflow: t, overflowX: n, overflowY: r, display: i } = k(e);
        return (
          /auto|scroll|overlay|hidden|clip/.test(t + r + n) && ![`inline`, `contents`].includes(i)
        );
      }
      function be(e) {
        return [`table`, `td`, `th`].includes(pe(e));
      }
      function xe(e) {
        let t = Ce(),
          n = k(e);
        return (
          n.transform !== `none` ||
          n.perspective !== `none` ||
          (n.containerType ? n.containerType !== `normal` : !1) ||
          (!t && (n.backdropFilter ? n.backdropFilter !== `none` : !1)) ||
          (!t && (n.filter ? n.filter !== `none` : !1)) ||
          [`transform`, `perspective`, `filter`].some((e) => (n.willChange || ``).includes(e)) ||
          [`paint`, `layout`, `strict`, `content`].some((e) => (n.contain || ``).includes(e))
        );
      }
      function Se(e) {
        let t = j(e);
        for (; _e(t) && !we(t);)
          if (xe(t)) return t;
          else t = j(t);
        return null;
      }
      function Ce() {
        return typeof CSS > `u` || !CSS.supports
          ? !1
          : CSS.supports(`-webkit-backdrop-filter`, `none`);
      }
      function we(e) {
        return [`html`, `body`, `#document`].includes(pe(e));
      }
      function k(e) {
        return O(e).getComputedStyle(e);
      }
      function A(e) {
        return ge(e)
          ? {
              scrollLeft: e.scrollLeft,
              scrollTop: e.scrollTop,
            }
          : {
              scrollLeft: e.pageXOffset,
              scrollTop: e.pageYOffset,
            };
      }
      function j(e) {
        if (pe(e) === `html`) return e;
        let t = e.assignedSlot || e.parentNode || (ve(e) && e.host) || me(e);
        return ve(t) ? t.host : t;
      }
      function Te(e) {
        let t = j(e);
        return we(t)
          ? e.ownerDocument
            ? e.ownerDocument.body
            : e.body
          : _e(t) && ye(t)
            ? t
            : Te(t);
      }
      function Ee(e, t, n) {
        (t === void 0 && (t = []), n === void 0 && (n = !0));
        let r = Te(e),
          i = r === e.ownerDocument?.body,
          a = O(r);
        return i
          ? t.concat(
              a,
              a.visualViewport || [],
              ye(r) ? r : [],
              a.frameElement && n ? Ee(a.frameElement) : [],
            )
          : t.concat(r, Ee(r, [], n));
      }
      function De(e) {
        let t = k(e),
          n = parseFloat(t.width) || 0,
          r = parseFloat(t.height) || 0,
          i = _e(e),
          a = i ? e.offsetWidth : n,
          o = i ? e.offsetHeight : r,
          s = f(n) !== a || f(r) !== o;
        return (
          s && ((n = a), (r = o)),
          {
            width: n,
            height: r,
            $: s,
          }
        );
      }
      function Oe(e) {
        return ge(e) ? e : e.contextElement;
      }
      function ke(e) {
        let t = Oe(e);
        if (!_e(t)) return m(1);
        let n = t.getBoundingClientRect(),
          { width: r, height: i, $: a } = De(t),
          o = (a ? f(n.width) : n.width) / r,
          s = (a ? f(n.height) : n.height) / i;
        return (
          (!o || !Number.isFinite(o)) && (o = 1),
          (!s || !Number.isFinite(s)) && (s = 1),
          {
            x: o,
            y: s,
          }
        );
      }
      var Ae = m(0);
      function je(e) {
        let t = O(e);
        return !Ce() || !t.visualViewport
          ? Ae
          : {
              x: t.visualViewport.offsetLeft,
              y: t.visualViewport.offsetTop,
            };
      }
      function Me(e, t, n) {
        return (t === void 0 && (t = !1), !n || (t && n !== O(e)) ? !1 : t);
      }
      function Ne(e, t, n, r) {
        (t === void 0 && (t = !1), n === void 0 && (n = !1));
        let i = e.getBoundingClientRect(),
          a = Oe(e),
          o = m(1);
        t && (r ? ge(r) && (o = ke(r)) : (o = ke(e)));
        let s = Me(a, n, r) ? je(a) : m(0),
          c = (i.left + s.x) / o.x,
          l = (i.top + s.y) / o.y,
          u = i.width / o.x,
          d = i.height / o.y;
        if (a) {
          let e = O(a),
            t = r && ge(r) ? O(r) : r,
            n = e.frameElement;
          for (; n && r && t !== e;) {
            let e = ke(n),
              t = n.getBoundingClientRect(),
              r = k(n),
              i = t.left + (n.clientLeft + parseFloat(r.paddingLeft)) * e.x,
              a = t.top + (n.clientTop + parseFloat(r.paddingTop)) * e.y;
            ((c *= e.x),
              (l *= e.y),
              (u *= e.x),
              (d *= e.y),
              (c += i),
              (l += a),
              (n = O(n).frameElement));
          }
        }
        return oe({
          width: u,
          height: d,
          x: c,
          y: l,
        });
      }
      function Pe(e) {
        let { rect: t, offsetParent: n, strategy: r } = e,
          i = _e(n),
          a = me(n);
        if (n === a) return t;
        let o = {
            scrollLeft: 0,
            scrollTop: 0,
          },
          s = m(1),
          c = m(0);
        if ((i || (!i && r !== `fixed`)) && ((pe(n) !== `body` || ye(a)) && (o = A(n)), _e(n))) {
          let e = Ne(n);
          ((s = ke(n)), (c.x = e.x + n.clientLeft), (c.y = e.y + n.clientTop));
        }
        return {
          width: t.width * s.x,
          height: t.height * s.y,
          x: t.x * s.x - o.scrollLeft * s.x + c.x,
          y: t.y * s.y - o.scrollTop * s.y + c.y,
        };
      }
      function Fe(e) {
        return Array.from(e.getClientRects());
      }
      function Ie(e) {
        return Ne(me(e)).left + A(e).scrollLeft;
      }
      function Le(e) {
        let t = me(e),
          n = A(e),
          r = e.ownerDocument.body,
          i = d(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth),
          a = d(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight),
          o = -n.scrollLeft + Ie(e),
          s = -n.scrollTop;
        return (
          k(r).direction === `rtl` && (o += d(t.clientWidth, r.clientWidth) - i),
          {
            width: i,
            height: a,
            x: o,
            y: s,
          }
        );
      }
      function Re(e, t) {
        let n = O(e),
          r = me(e),
          i = n.visualViewport,
          a = r.clientWidth,
          o = r.clientHeight,
          s = 0,
          c = 0;
        if (i) {
          ((a = i.width), (o = i.height));
          let e = Ce();
          (!e || (e && t === `fixed`)) && ((s = i.offsetLeft), (c = i.offsetTop));
        }
        return {
          width: a,
          height: o,
          x: s,
          y: c,
        };
      }
      function ze(e, t) {
        let n = Ne(e, !0, t === `fixed`),
          r = n.top + e.clientTop,
          i = n.left + e.clientLeft,
          a = _e(e) ? ke(e) : m(1);
        return {
          width: e.clientWidth * a.x,
          height: e.clientHeight * a.y,
          x: i * a.x,
          y: r * a.y,
        };
      }
      function Be(e, t, n) {
        let r;
        if (t === `viewport`) r = Re(e, n);
        else if (t === `document`) r = Le(me(e));
        else if (ge(t)) r = ze(t, n);
        else {
          let n = je(e);
          r = {
            ...t,
            x: t.x - n.x,
            y: t.y - n.y,
          };
        }
        return oe(r);
      }
      function Ve(e, t) {
        let n = j(e);
        return n === t || !ge(n) || we(n) ? !1 : k(n).position === `fixed` || Ve(n, t);
      }
      function He(e, t) {
        let n = t.get(e);
        if (n) return n;
        let r = Ee(e, [], !1).filter((e) => ge(e) && pe(e) !== `body`),
          i = null,
          a = k(e).position === `fixed`,
          o = a ? j(e) : e;
        for (; ge(o) && !we(o);) {
          let t = k(o),
            n = xe(o);
          (!n && t.position === `fixed` && (i = null),
            (
              a
                ? !n && !i
                : (!n &&
                    t.position === `static` &&
                    i &&
                    [`absolute`, `fixed`].includes(i.position)) ||
                  (ye(o) && !n && Ve(e, o))
            )
              ? (r = r.filter((e) => e !== o))
              : (i = t),
            (o = j(o)));
        }
        return (t.set(e, r), r);
      }
      function Ue(e) {
        let { element: t, boundary: n, rootBoundary: r, strategy: i } = e,
          a = [...(n === `clippingAncestors` ? He(t, this._c) : [].concat(n)), r],
          o = a[0],
          s = a.reduce(
            (e, n) => {
              let r = Be(t, n, i);
              return (
                (e.top = d(r.top, e.top)),
                (e.right = u(r.right, e.right)),
                (e.bottom = u(r.bottom, e.bottom)),
                (e.left = d(r.left, e.left)),
                e
              );
            },
            Be(t, o, i),
          );
        return {
          width: s.right - s.left,
          height: s.bottom - s.top,
          x: s.left,
          y: s.top,
        };
      }
      function We(e) {
        return De(e);
      }
      function Ge(e, t, n) {
        let r = _e(t),
          i = me(t),
          a = n === `fixed`,
          o = Ne(e, !0, a, t),
          s = {
            scrollLeft: 0,
            scrollTop: 0,
          },
          c = m(0);
        if (r || (!r && !a))
          if (((pe(t) !== `body` || ye(i)) && (s = A(t)), r)) {
            let e = Ne(t, !0, a, t);
            ((c.x = e.x + t.clientLeft), (c.y = e.y + t.clientTop));
          } else i && (c.x = Ie(i));
        return {
          x: o.left + s.scrollLeft - c.x,
          y: o.top + s.scrollTop - c.y,
          width: o.width,
          height: o.height,
        };
      }
      function Ke(e, t) {
        return !_e(e) || k(e).position === `fixed` ? null : t ? t(e) : e.offsetParent;
      }
      function M(e, t) {
        let n = O(e);
        if (!_e(e)) return n;
        let r = Ke(e, t);
        for (; r && be(r) && k(r).position === `static`;) r = Ke(r, t);
        return r && (pe(r) === `html` || (pe(r) === `body` && k(r).position === `static` && !xe(r)))
          ? n
          : r || Se(e) || n;
      }
      var qe = async function (e) {
        let { reference: t, floating: n, strategy: r } = e,
          i = this.getOffsetParent || M,
          a = this.getDimensions;
        return {
          reference: Ge(t, await i(n), r),
          floating: {
            x: 0,
            y: 0,
            ...(await a(n)),
          },
        };
      };
      function N(e) {
        return k(e).direction === `rtl`;
      }
      var P = {
        convertOffsetParentRelativeRectToViewportRelativeRect: Pe,
        getDocumentElement: me,
        getClippingRect: Ue,
        getOffsetParent: M,
        getElementRects: qe,
        getClientRects: Fe,
        getDimensions: We,
        getScale: ke,
        isElement: ge,
        isRTL: N,
      };
      function F(e, t) {
        let n = null,
          r,
          i = me(e);
        function a() {
          (clearTimeout(r), n && n.disconnect(), (n = null));
        }
        function o(s, c) {
          (s === void 0 && (s = !1), c === void 0 && (c = 1), a());
          let { left: l, top: f, width: m, height: h } = e.getBoundingClientRect();
          if ((s || t(), !m || !h)) return;
          let g = p(f),
            _ = p(i.clientWidth - (l + m)),
            v = p(i.clientHeight - (f + h)),
            y = p(l),
            b = {
              rootMargin: -g + `px ` + -_ + `px ` + -v + `px ` + -y + `px`,
              threshold: d(0, u(1, c)) || 1,
            },
            x = !0;
          function S(e) {
            let t = e[0].intersectionRatio;
            if (t !== c) {
              if (!x) return o();
              t
                ? o(!1, t)
                : (r = setTimeout(() => {
                    o(!1, 1e-7);
                  }, 100));
            }
            x = !1;
          }
          try {
            n = new IntersectionObserver(S, {
              ...b,
              root: i.ownerDocument,
            });
          } catch {
            n = new IntersectionObserver(S, b);
          }
          n.observe(e);
        }
        return (o(!0), a);
      }
      function I(e, t, n, r) {
        r === void 0 && (r = {});
        let {
            ancestorScroll: i = !0,
            ancestorResize: a = !0,
            elementResize: o = typeof ResizeObserver == `function`,
            layoutShift: s = typeof IntersectionObserver == `function`,
            animationFrame: c = !1,
          } = r,
          l = Oe(e),
          u = i || a ? [...(l ? Ee(l) : []), ...Ee(t)] : [];
        u.forEach((e) => {
          (i &&
            e.addEventListener(`scroll`, n, {
              passive: !0,
            }),
            a && e.addEventListener(`resize`, n));
        });
        let d = l && s ? F(l, n) : null,
          f = -1,
          p = null;
        o &&
          ((p = new ResizeObserver((e) => {
            let [r] = e;
            (r &&
              r.target === l &&
              p &&
              (p.unobserve(t),
              cancelAnimationFrame(f),
              (f = requestAnimationFrame(() => {
                p && p.observe(t);
              }))),
              n());
          })),
          l && !c && p.observe(l),
          p.observe(t));
        let m,
          h = c ? Ne(e) : null;
        c && g();
        function g() {
          let t = Ne(e);
          (h && (t.x !== h.x || t.y !== h.y || t.width !== h.width || t.height !== h.height) && n(),
            (h = t),
            (m = requestAnimationFrame(g)));
        }
        return (
          n(),
          () => {
            (u.forEach((e) => {
              (i && e.removeEventListener(`scroll`, n), a && e.removeEventListener(`resize`, n));
            }),
              d && d(),
              p && p.disconnect(),
              (p = null),
              c && cancelAnimationFrame(m));
          }
        );
      }
      var L = (e, t, n) => {
        let r = new Map(),
          i = {
            platform: P,
            ...n,
          },
          a = {
            ...i.platform,
            _c: r,
          };
        return ce(e, t, {
          ...i,
          platform: a,
        });
      };
      function R(e) {
        (e.magic(`anchor`, (e) => {
          if (!e._x_anchor) throw `Alpine: No x-anchor directive found on element using $anchor...`;
          return e._x_anchor;
        }),
          e.interceptClone((e, t) => {
            e && e._x_anchor && !t._x_anchor && (t._x_anchor = e._x_anchor);
          }),
          e.directive(
            `anchor`,
            e.skipDuringClone(
              (
                t,
                { expression: n, modifiers: r, value: i },
                { evaluate: a, effect: o, cleanup: s },
              ) => {
                let {
                  placement: c,
                  offsetValue: l,
                  unstyled: u,
                  strategy: d,
                  allowFlip: f,
                } = Je(r);
                t._x_anchor = e.reactive({
                  x: 0,
                  y: 0,
                });
                let p = null,
                  m = null;
                (o(() => {
                  let e = a(n);
                  if (e && p !== e) {
                    (m && m(), (p = e));
                    let n = () => {
                      let n;
                      L(e, t, {
                        placement: c,
                        strategy: d,
                        middleware: [
                          f && le(),
                          fe({
                            padding: 5,
                          }),
                          de(l),
                        ],
                      }).then(({ x: e, y: r }) => {
                        (u || z(t, e, r, d),
                          JSON.stringify({
                            x: e,
                            y: r,
                          }) !== n && ((t._x_anchor.x = e), (t._x_anchor.y = r)),
                          (n = JSON.stringify({
                            x: e,
                            y: r,
                          })));
                      });
                    };
                    m = I(e, t, () => n());
                  }
                }),
                  s(() => {
                    m && m();
                  }));
              },
              (e, { expression: t, modifiers: n, value: r }, { cleanup: i, evaluate: a }) => {
                let { placement: o, offsetValue: s, unstyled: c, strategy: l } = Je(n);
                e._x_anchor && (c || z(e, e._x_anchor.x, e._x_anchor.y, l));
              },
            ),
          ));
      }
      function z(e, t, n, r = `absolute`) {
        Object.assign(e.style, {
          left: t + `px`,
          top: n + `px`,
          position: r,
        });
      }
      function Je(e) {
        let t = [
            `top`,
            `top-start`,
            `top-end`,
            `right`,
            `right-start`,
            `right-end`,
            `bottom`,
            `bottom-start`,
            `bottom-end`,
            `left`,
            `left-start`,
            `left-end`,
          ].find((t) => e.includes(t)),
          n = 0;
        if (e.includes(`offset`)) {
          let t = e.findIndex((e) => e === `offset`);
          n = e[t + 1] === void 0 ? n : Number(e[t + 1]);
        }
        let r = e.includes(`no-style`),
          i = !e.includes(`noflip`),
          a = e.includes(`fixed`) ? `fixed` : `absolute`;
        return {
          placement: t,
          offsetValue: n,
          unstyled: r,
          strategy: a,
          allowFlip: i,
        };
      }
      var Ye = R;
    },
  }),
  La = ka({
    "node_modules/nprogress/nprogress.js"(e, t) {
      (function (n, r) {
        typeof define == `function` && define.amd
          ? define(r)
          : typeof e == `object`
            ? (t.exports = r())
            : (n.NProgress = r());
      })(e, function () {
        var e = {};
        e.version = `0.2.0`;
        var t = (e.settings = {
          minimum: 0.08,
          easing: `ease`,
          positionUsing: ``,
          speed: 200,
          trickle: !0,
          trickleRate: 0.02,
          trickleSpeed: 800,
          showSpinner: !0,
          barSelector: `[role="bar"]`,
          spinnerSelector: `[role="spinner"]`,
          parent: `body`,
          template: `<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>`,
        });
        ((e.configure = function (e) {
          var n, r;
          for (n in e) ((r = e[n]), r !== void 0 && e.hasOwnProperty(n) && (t[n] = r));
          return this;
        }),
          (e.status = null),
          (e.set = function (r) {
            var s = e.isStarted();
            ((r = n(r, t.minimum, 1)), (e.status = r === 1 ? null : r));
            var c = e.render(!s),
              l = c.querySelector(t.barSelector),
              u = t.speed,
              d = t.easing;
            return (
              c.offsetWidth,
              a(function (n) {
                (t.positionUsing === `` && (t.positionUsing = e.getPositioningCSS()),
                  o(l, i(r, u, d)),
                  r === 1
                    ? (o(c, {
                        transition: `none`,
                        opacity: 1,
                      }),
                      c.offsetWidth,
                      setTimeout(function () {
                        (o(c, {
                          transition: `all ` + u + `ms linear`,
                          opacity: 0,
                        }),
                          setTimeout(function () {
                            (e.remove(), n());
                          }, u));
                      }, u))
                    : setTimeout(n, u));
              }),
              this
            );
          }),
          (e.isStarted = function () {
            return typeof e.status == `number`;
          }),
          (e.start = function () {
            e.status || e.set(0);
            var n = function () {
              setTimeout(function () {
                e.status && (e.trickle(), n());
              }, t.trickleSpeed);
            };
            return (t.trickle && n(), this);
          }),
          (e.done = function (t) {
            return !t && !e.status ? this : e.inc(0.3 + 0.5 * Math.random()).set(1);
          }),
          (e.inc = function (t) {
            var r = e.status;
            return r
              ? (typeof t != `number` && (t = (1 - r) * n(Math.random() * r, 0.1, 0.95)),
                (r = n(r + t, 0, 0.994)),
                e.set(r))
              : e.start();
          }),
          (e.trickle = function () {
            return e.inc(Math.random() * t.trickleRate);
          }),
          (function () {
            var t = 0,
              n = 0;
            e.promise = function (r) {
              return !r || r.state() === `resolved`
                ? this
                : (n === 0 && e.start(),
                  t++,
                  n++,
                  r.always(function () {
                    (n--, n === 0 ? ((t = 0), e.done()) : e.set((t - n) / t));
                  }),
                  this);
            };
          })(),
          (e.render = function (n) {
            if (e.isRendered()) return document.getElementById(`nprogress`);
            c(document.documentElement, `nprogress-busy`);
            var i = document.createElement(`div`);
            ((i.id = `nprogress`), (i.innerHTML = t.template));
            var a = i.querySelector(t.barSelector),
              s = n ? `-100` : r(e.status || 0),
              l = document.querySelector(t.parent),
              u;
            return (
              o(a, {
                transition: `all 0 linear`,
                transform: `translate3d(` + s + `%,0,0)`,
              }),
              t.showSpinner || ((u = i.querySelector(t.spinnerSelector)), u && d(u)),
              l != document.body && c(l, `nprogress-custom-parent`),
              l.appendChild(i),
              i
            );
          }),
          (e.remove = function () {
            (l(document.documentElement, `nprogress-busy`),
              l(document.querySelector(t.parent), `nprogress-custom-parent`));
            var e = document.getElementById(`nprogress`);
            e && d(e);
          }),
          (e.isRendered = function () {
            return !!document.getElementById(`nprogress`);
          }),
          (e.getPositioningCSS = function () {
            var e = document.body.style,
              t =
                `WebkitTransform` in e
                  ? `Webkit`
                  : `MozTransform` in e
                    ? `Moz`
                    : `msTransform` in e
                      ? `ms`
                      : `OTransform` in e
                        ? `O`
                        : ``;
            return t + `Perspective` in e
              ? `translate3d`
              : t + `Transform` in e
                ? `translate`
                : `margin`;
          }));
        function n(e, t, n) {
          return e < t ? t : e > n ? n : e;
        }
        function r(e) {
          return (-1 + e) * 100;
        }
        function i(e, n, i) {
          var a =
            t.positionUsing === `translate3d`
              ? {
                  transform: `translate3d(` + r(e) + `%,0,0)`,
                }
              : t.positionUsing === `translate`
                ? {
                    transform: `translate(` + r(e) + `%,0)`,
                  }
                : {
                    "margin-left": r(e) + `%`,
                  };
          return ((a.transition = `all ` + n + `ms ` + i), a);
        }
        var a = (function () {
            var e = [];
            function t() {
              var n = e.shift();
              n && n(t);
            }
            return function (n) {
              (e.push(n), e.length == 1 && t());
            };
          })(),
          o = (function () {
            var e = [`Webkit`, `O`, `Moz`, `ms`],
              t = {};
            function n(e) {
              return e.replace(/^-ms-/, `ms-`).replace(/-([\da-z])/gi, function (e, t) {
                return t.toUpperCase();
              });
            }
            function r(t) {
              var n = document.body.style;
              if (t in n) return t;
              for (var r = e.length, i = t.charAt(0).toUpperCase() + t.slice(1), a; r--;)
                if (((a = e[r] + i), a in n)) return a;
              return t;
            }
            function i(e) {
              return ((e = n(e)), t[e] || (t[e] = r(e)));
            }
            function a(e, t, n) {
              ((t = i(t)), (e.style[t] = n));
            }
            return function (e, t) {
              var n = arguments,
                r,
                i;
              if (n.length == 2)
                for (r in t) ((i = t[r]), i !== void 0 && t.hasOwnProperty(r) && a(e, r, i));
              else a(e, n[1], n[2]);
            };
          })();
        function s(e, t) {
          return (typeof e == `string` ? e : u(e)).indexOf(` ` + t + ` `) >= 0;
        }
        function c(e, t) {
          var n = u(e),
            r = n + t;
          s(n, t) || (e.className = r.substring(1));
        }
        function l(e, t) {
          var n = u(e),
            r;
          s(e, t) &&
            ((r = n.replace(` ` + t + ` `, ` `)), (e.className = r.substring(1, r.length - 1)));
        }
        function u(e) {
          return (` ` + (e.className || ``) + ` `).replace(/\s+/gi, ` `);
        }
        function d(e) {
          e && e.parentNode && e.parentNode.removeChild(e);
        }
        return e;
      });
    },
  }),
  Ra = ka({
    "node_modules/@alpinejs/morph/dist/module.cjs.js"(e, t) {
      var n = Object.defineProperty,
        r = Object.getOwnPropertyDescriptor,
        i = Object.getOwnPropertyNames,
        a = Object.prototype.hasOwnProperty,
        o = (e, t) => {
          for (var r in t)
            n(e, r, {
              get: t[r],
              enumerable: !0,
            });
        },
        s = (e, t, o, s) => {
          if ((t && typeof t == `object`) || typeof t == `function`)
            for (let c of i(t))
              !a.call(e, c) &&
                c !== o &&
                n(e, c, {
                  get: () => t[c],
                  enumerable: !(s = r(t, c)) || s.enumerable,
                });
          return e;
        },
        c = (e) =>
          s(
            n({}, `__esModule`, {
              value: !0,
            }),
            e,
          ),
        l = {};
      (o(l, {
        default: () => w,
        morph: () => C,
      }),
        (t.exports = c(l)));
      function u(e, t, n) {
        x();
        let r = f(n),
          i = typeof t == `string` ? g(t) : t;
        return (
          window.Alpine &&
            window.Alpine.closestDataStack &&
            !e._x_dataStack &&
            ((i._x_dataStack = window.Alpine.closestDataStack(e)),
            i._x_dataStack && window.Alpine.cloneNode(e, i)),
          r.patch(e, i),
          e
        );
      }
      function d(e, t, n, r = {}) {
        x();
        let i = f(r),
          a = e.parentNode,
          o = new v(e, t),
          s =
            typeof n == `string`
              ? (() => {
                  let e = document.createElement(`div`);
                  return (e.insertAdjacentHTML(`beforeend`, n), e);
                })()
              : n,
          c = document.createComment(`[morph-start]`),
          l = document.createComment(`[morph-end]`);
        (s.insertBefore(c, s.firstChild), s.appendChild(l));
        let u = new v(c, l);
        (window.Alpine &&
          window.Alpine.closestDataStack &&
          ((s._x_dataStack = window.Alpine.closestDataStack(a)),
          s._x_dataStack && window.Alpine.cloneNode(a, s)),
          i.patchChildren(o, u));
      }
      function f(e = {}) {
        let t = (e) => e.getAttribute(`key`),
          n = () => {},
          r = {
            key: e.key || t,
            lookahead: e.lookahead || !1,
            updating: e.updating || n,
            updated: e.updated || n,
            removing: e.removing || n,
            removed: e.removed || n,
            adding: e.adding || n,
            added: e.added || n,
          };
        return (
          (r.patch = function (e, t) {
            if (r.differentElementNamesTypesOrKeys(e, t)) return r.swapElements(e, t);
            let n = !1,
              i = !1;
            if (
              !m(
                r.updating,
                () => (i = !0),
                (e) => (r.skipUntilCondition = e),
                e,
                t,
                () => (n = !0),
              )
            ) {
              if (
                (e.nodeType === 1 &&
                  window.Alpine &&
                  (window.Alpine.cloneNode(e, t),
                  e._x_teleport && t._x_teleport && r.patch(e._x_teleport, t._x_teleport)),
                _(t))
              ) {
                (r.patchNodeValue(e, t), r.updated(e, t));
                return;
              }
              (n || r.patchAttributes(e, t), r.updated(e, t), i || r.patchChildren(e, t));
            }
          }),
          (r.differentElementNamesTypesOrKeys = function (e, t) {
            return (
              e.nodeType != t.nodeType || e.nodeName != t.nodeName || r.getKey(e) != r.getKey(t)
            );
          }),
          (r.swapElements = function (e, t) {
            if (p(r.removing, e)) return;
            let n = t.cloneNode(!0);
            p(r.adding, n) || (e.replaceWith(n), r.removed(e), r.added(n));
          }),
          (r.patchNodeValue = function (e, t) {
            let n = t.nodeValue;
            e.nodeValue !== n && (e.nodeValue = n);
          }),
          (r.patchAttributes = function (e, t) {
            if (
              e._x_transitioning ||
              (e._x_isShown && !t._x_isShown) ||
              (!e._x_isShown && t._x_isShown)
            )
              return;
            let n = Array.from(e.attributes),
              r = Array.from(t.attributes);
            for (let r = n.length - 1; r >= 0; r--) {
              let i = n[r].name;
              t.hasAttribute(i) ||
                (i === `open` && e.nodeName === `DIALOG` && e.open
                  ? e.close()
                  : e.removeAttribute(i));
            }
            for (let t = r.length - 1; t >= 0; t--) {
              let n = r[t].name,
                i = r[t].value;
              e.getAttribute(n) !== i && e.setAttribute(n, i);
            }
          }),
          (r.patchChildren = function (e, t) {
            let n = r.keyToMap(e.children),
              i = {},
              a = y(t),
              o = y(e);
            for (; a;) {
              S(a, o);
              let s = r.getKey(a),
                c = r.getKey(o);
              if (r.skipUntilCondition) {
                let n = !o || r.skipUntilCondition(o),
                  i = !a || r.skipUntilCondition(a);
                if (n && i) r.skipUntilCondition = null;
                else {
                  (n || (o &&= b(e, o)), i || (a &&= b(t, a)));
                  continue;
                }
              }
              if (!o)
                if (s && i[s]) {
                  let t = i[s];
                  (e.appendChild(t), (o = t), (c = r.getKey(o)));
                } else {
                  if (!p(r.adding, a)) {
                    let t = a.cloneNode(!0);
                    (e.appendChild(t), r.added(t));
                  }
                  a = b(t, a);
                  continue;
                }
              let l = (e) => e && e.nodeType === 8 && e.textContent === `[if BLOCK]><![endif]`,
                u = (e) => e && e.nodeType === 8 && e.textContent === `[if ENDBLOCK]><![endif]`;
              if (l(a) && l(o)) {
                let n = 0,
                  i = o;
                for (; o;) {
                  let t = b(e, o);
                  if (l(t)) n++;
                  else if (u(t) && n > 0) n--;
                  else if (u(t) && n === 0) {
                    o = t;
                    break;
                  }
                  o = t;
                }
                let s = o;
                n = 0;
                let c = a;
                for (; a;) {
                  let e = b(t, a);
                  if (l(e)) n++;
                  else if (u(e) && n > 0) n--;
                  else if (u(e) && n === 0) {
                    a = e;
                    break;
                  }
                  a = e;
                }
                let d = a,
                  f = new v(i, s),
                  p = new v(c, d);
                r.patchChildren(f, p);
                continue;
              }
              if (o.nodeType === 1 && r.lookahead && !o.isEqualNode(a)) {
                let n = b(t, a),
                  i = !1;
                for (; !i && n;)
                  (n.nodeType === 1 &&
                    o.isEqualNode(n) &&
                    ((i = !0), (o = r.addNodeBefore(e, a, o)), (c = r.getKey(o))),
                    (n = b(t, n)));
              }
              if (s !== c) {
                if (!s && c) {
                  ((i[c] = o),
                    (o = r.addNodeBefore(e, a, o)),
                    i[c].remove(),
                    (o = b(e, o)),
                    (a = b(t, a)));
                  continue;
                }
                if (
                  (s && !c && n[s] && (o.replaceWith(n[s]), (o = n[s]), (c = r.getKey(o))), s && c)
                ) {
                  let l = n[s];
                  if (l) ((i[c] = o), o.replaceWith(l), (o = l), (c = r.getKey(o)));
                  else {
                    ((i[c] = o),
                      (o = r.addNodeBefore(e, a, o)),
                      i[c].remove(),
                      (o = b(e, o)),
                      (a = b(t, a)));
                    continue;
                  }
                }
              }
              let d = o && b(e, o);
              (r.patch(o, a), (a &&= b(t, a)), (o = d));
            }
            let s = [];
            for (; o;) (p(r.removing, o) || s.push(o), (o = b(e, o)));
            for (; s.length;) {
              let e = s.shift();
              (e.remove(), r.removed(e));
            }
          }),
          (r.getKey = function (e) {
            return e && e.nodeType === 1 && r.key(e);
          }),
          (r.keyToMap = function (e) {
            let t = {};
            for (let n of e) {
              let e = r.getKey(n);
              e && (t[e] = n);
            }
            return t;
          }),
          (r.addNodeBefore = function (e, t, n) {
            if (!p(r.adding, t)) {
              let i = t.cloneNode(!0);
              return (e.insertBefore(i, n), r.added(i), i);
            }
            return t;
          }),
          r
        );
      }
      ((u.step = () => {}), (u.log = () => {}));
      function p(e, ...t) {
        let n = !1;
        return (e(...t, () => (n = !0)), n);
      }
      function m(e, t, n, ...r) {
        let i = !1;
        return (e(...r, () => (i = !0), t, n), i);
      }
      var h = !1;
      function g(e) {
        let t = document.createElement(`template`);
        return ((t.innerHTML = e), t.content.firstElementChild);
      }
      function _(e) {
        return e.nodeType === 3 || e.nodeType === 8;
      }
      var v = class {
        constructor(e, t) {
          ((this.startComment = e), (this.endComment = t));
        }
        get children() {
          let e = [],
            t = this.startComment.nextSibling;
          for (; t && t !== this.endComment;) (e.push(t), (t = t.nextSibling));
          return e;
        }
        appendChild(e) {
          this.endComment.before(e);
        }
        get firstChild() {
          let e = this.startComment.nextSibling;
          if (e !== this.endComment) return e;
        }
        nextNode(e) {
          let t = e.nextSibling;
          if (t !== this.endComment) return t;
        }
        insertBefore(e, t) {
          return (t.before(e), e);
        }
      };
      function y(e) {
        return e.firstChild;
      }
      function b(e, t) {
        let n;
        return ((n = e instanceof v ? e.nextNode(t) : t.nextSibling), n);
      }
      function x() {
        if (h) return;
        h = !0;
        let e = Element.prototype.setAttribute,
          t = document.createElement(`div`);
        Element.prototype.setAttribute = function (n, r) {
          if (!n.includes(`@`)) return e.call(this, n, r);
          t.innerHTML = `<span ${n}="${r.replace(/&/g, `&amp;`).replace(/"/g, `&quot;`)}"></span>`;
          let i = t.firstElementChild.getAttributeNode(n);
          (t.firstElementChild.removeAttributeNode(i), this.setAttributeNode(i));
        };
      }
      function S(e, t) {
        let n = t && t._x_bindings && t._x_bindings.id;
        n && e.setAttribute && (e.setAttribute(`id`, n), (e.id = n));
      }
      function C(e) {
        ((e.morph = u), (e.morphBetween = d));
      }
      var w = C;
    },
  }),
  za = ka({
    "node_modules/@alpinejs/mask/dist/module.cjs.js"(e, t) {
      var n = Object.defineProperty,
        r = Object.getOwnPropertyDescriptor,
        i = Object.getOwnPropertyNames,
        a = Object.prototype.hasOwnProperty,
        o = (e, t) => {
          for (var r in t)
            n(e, r, {
              get: t[r],
              enumerable: !0,
            });
        },
        s = (e, t, o, s) => {
          if ((t && typeof t == `object`) || typeof t == `function`)
            for (let c of i(t))
              !a.call(e, c) &&
                c !== o &&
                n(e, c, {
                  get: () => t[c],
                  enumerable: !(s = r(t, c)) || s.enumerable,
                });
          return e;
        },
        c = (e) =>
          s(
            n({}, `__esModule`, {
              value: !0,
            }),
            e,
          ),
        l = {};
      (o(l, {
        default: () => h,
        formatInput: () => p,
        mask: () => u,
      }),
        (t.exports = c(l)));
      function u(e) {
        e.directive(
          `mask`,
          (t, { value: n, expression: r }, { effect: i, evaluateLater: a, cleanup: o }) => {
            let s = () => r,
              c = ``;
            queueMicrotask(() => {
              if ([`function`, `dynamic`].includes(n)) {
                let n = a(r);
                i(() => {
                  ((s = (r) => {
                    let i;
                    return (
                      e.dontAutoEvaluateFunctions(() => {
                        n(
                          (e) => {
                            i = typeof e == `function` ? e(r) : e;
                          },
                          {
                            scope: {
                              $input: r,
                              $money: m.bind({
                                el: t,
                              }),
                            },
                          },
                        );
                      }),
                      i
                    );
                  }),
                    u(t, !1));
                });
              } else u(t, !1);
              if (t._x_model) {
                t._x_model.get() !== t.value &&
                  ((t._x_model.get() === null && t.value === ``) || t._x_model.set(t.value));
                let e = t._x_forceModelUpdate;
                t._x_forceModelUpdate = (n) => {
                  n = String(n);
                  let r = s(n);
                  (r && r !== `false` && (n = p(r, n)), (c = n), e(n), t._x_model.set(n));
                };
              }
            });
            let l = new AbortController();
            (o(() => {
              l.abort();
            }),
              t.addEventListener(`input`, () => u(t), {
                signal: l.signal,
                capture: !0,
              }),
              t.addEventListener(`blur`, () => u(t, !1), {
                signal: l.signal,
              }));
            function u(e, t = !0) {
              let n = e.value,
                r = s(n);
              if (!r || r === `false`) return !1;
              if (c.length - e.value.length === 1) return (c = e.value);
              let i = () => {
                c = e.value = p(r, n);
              };
              t
                ? d(e, r, () => {
                    i();
                  })
                : i();
            }
          },
        ).before(`model`);
      }
      function d(e, t, n) {
        let r = e.selectionStart,
          i = e.value;
        n();
        let a = p(t, i.slice(0, r)).length;
        e.setSelectionRange(a, a);
      }
      var f = {
        9: /[0-9]/,
        a: /[a-zA-Z]/,
        "*": /[a-zA-Z0-9]/,
      };
      function p(e, t) {
        let n = 0,
          r = 0,
          i = ``;
        for (; n < e.length && r < t.length;) {
          let a = e[n],
            o = t[r];
          a in f ? (f[a].test(o) && ((i += o), n++), r++) : ((i += a), n++, a === t[r] && r++);
        }
        return i;
      }
      function m(e, t = `.`, n, r = 2) {
        if (e === `-`) return `-`;
        if (/^\D+$/.test(e)) return `9`;
        n ??= t === `,` ? `.` : `,`;
        let i = (e, t) => {
            let n = ``,
              r = 0;
            for (let i = e.length - 1; i >= 0; i--)
              e[i] !== t && (r === 3 ? ((n = e[i] + t + n), (r = 0)) : (n = e[i] + n), r++);
            return n;
          },
          a = e.startsWith(`-`) ? `-` : ``,
          o = e.replaceAll(RegExp(`[^0-9\\${t}]`, `g`), ``),
          s = Array.from({
            length: o.split(t)[0].length,
          })
            .fill(`9`)
            .join(``);
        return (
          (s = `${a}${i(s, n)}`),
          r > 0 && e.includes(t) && (s += `${t}` + `9`.repeat(r)),
          queueMicrotask(() => {
            this.el.value.endsWith(t) ||
              (this.el.value[this.el.selectionStart - 1] === t &&
                this.el.setSelectionRange(this.el.selectionStart - 1, this.el.selectionStart - 1));
          }),
          s
        );
      }
      var h = u;
    },
  }),
  Ba = class {
    constructor() {
      this.arrays = {};
    }
    add(e, t) {
      (this.arrays[e] || (this.arrays[e] = []), this.arrays[e].push(t));
    }
    remove(e) {
      this.arrays[e] && delete this.arrays[e];
    }
    get(e) {
      return this.arrays[e] || [];
    }
    each(e, t) {
      return this.get(e).forEach(t);
    }
  },
  Va = class {
    constructor() {
      this.arrays = new WeakMap();
    }
    add(e, t) {
      (this.arrays.has(e) || this.arrays.set(e, []), this.arrays.get(e).push(t));
    }
    remove(e) {
      this.arrays.has(e) && this.arrays.delete(e, []);
    }
    get(e) {
      return this.arrays.has(e) ? this.arrays.get(e) : [];
    }
    each(e, t) {
      return this.get(e).forEach(t);
    }
  };
function Ha(e, t, n = {}, r = !0) {
  e.dispatchEvent(
    new CustomEvent(t, {
      detail: n,
      bubbles: r,
      composed: !0,
      cancelable: !0,
    }),
  );
}
function Ua(e, t, n) {
  return (e.addEventListener(t, n), () => e.removeEventListener(t, n));
}
function Wa(e) {
  return typeof e == `object` && !!e;
}
function Ga(e) {
  return Wa(e) && !Ka(e);
}
function Ka(e) {
  return Array.isArray(e);
}
function qa(e) {
  return typeof e == `function`;
}
function Ja(e) {
  return typeof e != `object` || !e;
}
function Ya(e) {
  return JSON.parse(JSON.stringify(e));
}
function Xa(e, t) {
  return t === `` ? e : t.split(`.`).reduce((e, t) => e?.[t], e);
}
function Za(e, t, n) {
  let r = t.split(`.`);
  if (r.length === 1) return (e[t] = n);
  let i = r.shift(),
    a = r.join(`.`);
  (e[i] === void 0 && (e[i] = {}), Za(e[i], a, n));
}
function Qa(e, t, n = {}, r = ``) {
  if (e === t) return n;
  if (typeof e != typeof t || (Ga(e) && Ka(t)) || (Ka(e) && Ga(t)) || Ja(e) || Ja(t))
    return ((n[r] = t), n);
  let i = Object.keys(e),
    a = Object.keys(t);
  return Ga(e) && i.length === a.length && i.some((e, t) => e !== a[t])
    ? ((n[r] = t), n)
    : (Object.entries(t).forEach(([a, o]) => {
        ((n = {
          ...n,
          ...Qa(e[a], t[a], n, r === `` ? a : `${r}.${a}`),
        }),
          (i = i.filter((e) => e !== a)));
      }),
      i.forEach((e) => {
        n[`${r}.${e}`] = `__rm__`;
      }),
      n);
}
function $a(e) {
  let t = eo(e) ? e[0] : e;
  return (
    eo(e) && e[1],
    Wa(t) &&
      Object.entries(t).forEach(([e, n]) => {
        t[e] = $a(n);
      }),
    t
  );
}
function eo(e) {
  return (
    Array.isArray(e) && e.length === 2 && typeof e[1] == `object` && Object.keys(e[1]).includes(`s`)
  );
}
function to() {
  if (document.querySelector(`meta[name="csrf-token"]`))
    return document.querySelector(`meta[name="csrf-token"]`).getAttribute(`content`);
  if (document.querySelector(`[data-csrf]`))
    return document.querySelector(`[data-csrf]`).getAttribute(`data-csrf`);
  if (window.livewireScriptConfig.csrf ?? !1) return window.livewireScriptConfig.csrf;
  throw `Livewire: No CSRF token detected`;
}
var no;
function ro() {
  if (no) return no;
  if (window.livewireScriptConfig && (window.livewireScriptConfig.nonce ?? !1))
    return ((no = window.livewireScriptConfig.nonce), no);
  let e = document.querySelector(`style[data-livewire-style][nonce]`);
  return e ? ((no = e.nonce), no) : null;
}
function io() {
  return (
    document.querySelector(`[data-update-uri]`)?.getAttribute(`data-update-uri`) ??
    window.livewireScriptConfig.uri ??
    null
  );
}
function ao(e) {
  return !!e.match(/<script>Sfdump\(".+"\)<\/script>/);
}
function oo(e) {
  let t = e.match(/.*<script>Sfdump\(".+"\)<\/script>/s);
  return [t, e.replace(t, ``)];
}
var so = new WeakMap();
function co(e) {
  if (!so.has(e)) {
    let t = new uo(e);
    (so.set(e, t), t.registerListeners());
  }
  return so.get(e);
}
function lo(e, t, n, r) {
  let i = co(n),
    a = () =>
      e.dispatchEvent(
        new CustomEvent(`livewire-upload-start`, {
          bubbles: !0,
          detail: {
            id: n.id,
            property: t,
          },
        }),
      ),
    o = () =>
      e.dispatchEvent(
        new CustomEvent(`livewire-upload-finish`, {
          bubbles: !0,
          detail: {
            id: n.id,
            property: t,
          },
        }),
      ),
    s = () =>
      e.dispatchEvent(
        new CustomEvent(`livewire-upload-error`, {
          bubbles: !0,
          detail: {
            id: n.id,
            property: t,
          },
        }),
      ),
    c = () =>
      e.dispatchEvent(
        new CustomEvent(`livewire-upload-cancel`, {
          bubbles: !0,
          detail: {
            id: n.id,
            property: t,
          },
        }),
      ),
    l = (t) => {
      var n = Math.round((t.loaded * 100) / t.total);
      e.dispatchEvent(
        new CustomEvent(`livewire-upload-progress`, {
          bubbles: !0,
          detail: {
            progress: n,
          },
        }),
      );
    },
    u = (e) => {
      if (e.target.files.length !== 0)
        if ((a(), e.target.multiple)) {
          let n = [`ui-file-upload`].includes(e.target.tagName.toLowerCase());
          i.uploadMultiple(t, e.target.files, o, s, l, c, n);
        } else i.upload(t, e.target.files[0], o, s, l, c);
    };
  (e.addEventListener(`change`, u),
    n.$wire.$watch(t, (t) => {
      e.isConnected &&
        ((t === null || t === ``) && (e.value = ``),
        e.multiple && Array.isArray(t) && t.length === 0 && (e.value = ``));
    }));
  let d = () => {
    e.value = null;
  };
  (e.addEventListener(`click`, d),
    e.addEventListener(`livewire-upload-cancel`, d),
    r(() => {
      (e.removeEventListener(`change`, u), e.removeEventListener(`click`, d));
    }));
}
var uo = class {
    constructor(e) {
      ((this.component = e), (this.uploadBag = new fo()), (this.removeBag = new fo()));
    }
    registerListeners() {
      (this.component.$wire.$on(`upload:generatedSignedUrl`, ({ name: e, url: t }) => {
        (this.component, this.handleSignedUrl(e, t));
      }),
        this.component.$wire.$on(`upload:generatedSignedUrlForS3`, ({ name: e, payload: t }) => {
          (this.component, this.handleS3PreSignedUrl(e, t));
        }),
        this.component.$wire.$on(`upload:finished`, ({ name: e, tmpFilenames: t }) =>
          this.markUploadFinished(e, t),
        ),
        this.component.$wire.$on(`upload:errored`, ({ name: e }) => this.markUploadErrored(e)),
        this.component.$wire.$on(`upload:removed`, ({ name: e, tmpFilename: t }) =>
          this.removeBag.shift(e).finishCallback(t),
        ));
    }
    upload(e, t, n, r, i, a) {
      this.setUpload(e, {
        files: [t],
        multiple: !1,
        finishCallback: n,
        errorCallback: r,
        progressCallback: i,
        cancelledCallback: a,
        append: !1,
      });
    }
    uploadMultiple(e, t, n, r, i, a, o = !1) {
      this.setUpload(e, {
        files: Array.from(t),
        multiple: !0,
        finishCallback: n,
        errorCallback: r,
        progressCallback: i,
        cancelledCallback: a,
        append: o,
      });
    }
    removeUpload(e, t, n) {
      (this.removeBag.push(e, {
        tmpFilename: t,
        finishCallback: n,
      }),
        this.component.$wire.call(`_removeUpload`, e, t));
    }
    setUpload(e, t) {
      (this.uploadBag.add(e, t), this.uploadBag.get(e).length === 1 && this.startUpload(e, t));
    }
    handleSignedUrl(e, t) {
      let n = new FormData();
      Array.from(this.uploadBag.first(e).files).forEach((e) => n.append(`files[]`, e, e.name));
      let r = {
          Accept: `application/json`,
        },
        i = to();
      (i && (r[`X-CSRF-TOKEN`] = i), this.makeRequest(e, n, `post`, t, r, (e) => e.paths));
    }
    handleS3PreSignedUrl(e, t) {
      let n = this.uploadBag.first(e).files[0],
        r = t.headers;
      `Host` in r && delete r.Host;
      let i = t.url;
      this.makeRequest(e, n, `put`, i, r, (e) => [t.path]);
    }
    makeRequest(e, t, n, r, i, a) {
      let o = new XMLHttpRequest();
      (o.open(n, r),
        Object.entries(i).forEach(([e, t]) => {
          o.setRequestHeader(e, t);
        }),
        o.upload.addEventListener(`progress`, (t) => {
          ((t.detail = {}),
            (t.detail.progress = Math.floor((t.loaded * 100) / t.total)),
            this.uploadBag.first(e).progressCallback(t));
        }),
        o.addEventListener(`load`, () => {
          if ((o.status + ``)[0] === `2`) {
            let t = a(o.response && JSON.parse(o.response));
            this.component.$wire.call(
              `_finishUpload`,
              e,
              t,
              this.uploadBag.first(e).multiple,
              this.uploadBag.first(e).append,
            );
            return;
          }
          let t = null;
          (o.status === 422 && (t = o.response),
            this.component.$wire.call(`_uploadErrored`, e, t, this.uploadBag.first(e).multiple));
        }),
        o.addEventListener(`error`, () => {
          this.component.$wire.call(`_uploadErrored`, e, null, this.uploadBag.first(e).multiple);
        }),
        (this.uploadBag.first(e).request = o),
        o.send(t));
    }
    startUpload(e, t) {
      let n = t.files.map((e) => ({
        name: e.name,
        size: e.size,
        type: e.type,
      }));
      (this.component.$wire.call(`_startUpload`, e, n, t.multiple), this.component);
    }
    markUploadFinished(e, t) {
      this.component;
      let n = this.uploadBag.shift(e);
      (n.finishCallback(n.multiple ? t : t[0]),
        this.uploadBag.get(e).length > 0 && this.startUpload(e, this.uploadBag.last(e)));
    }
    markUploadErrored(e) {
      (this.component,
        this.uploadBag.shift(e).errorCallback(),
        this.uploadBag.get(e).length > 0 && this.startUpload(e, this.uploadBag.last(e)));
    }
    cancelUpload(e, t = null) {
      this.component;
      let n = this.uploadBag.first(e);
      n && (n.request && n.request.abort(), this.uploadBag.shift(e).cancelledCallback(), t && t());
    }
  },
  fo = class {
    constructor() {
      this.bag = {};
    }
    add(e, t) {
      (this.bag[e] || (this.bag[e] = []), this.bag[e].push(t));
    }
    push(e, t) {
      this.add(e, t);
    }
    first(e) {
      return this.bag[e] ? this.bag[e][0] : null;
    }
    last(e) {
      return this.bag[e].slice(-1)[0];
    }
    get(e) {
      return this.bag[e];
    }
    shift(e) {
      return this.bag[e].shift();
    }
    call(e, ...t) {
      (this.listeners[e] || []).forEach((e) => {
        e(...t);
      });
    }
    has(e) {
      return Object.keys(this.listeners).includes(e);
    }
  };
function po(e, t, n, r = () => {}, i = () => {}, a = () => {}, o = () => {}) {
  co(e).upload(t, n, r, i, a, o);
}
function mo(e, t, n, r = () => {}, i = () => {}, a = () => {}, o = () => {}, s = !1) {
  co(e).uploadMultiple(t, n, r, i, a, o, s);
}
function ho(e, t, n, r = () => {}, i = () => {}) {
  co(e).removeUpload(t, n, r, i);
}
function go(e, t, n = () => {}) {
  co(e).cancelUpload(t, n);
}
var _o = Q(ja());
function vo(e, t) {
  return (
    (t ||= () => {}),
    (n, r = !1) => {
      let i = r,
        a = n,
        o = e.$wire,
        s = o.get(a);
      return _o.default.interceptor(
        (r, c, l, u, d) => {
          if (s === void 0) {
            console.error(
              `Livewire Entangle Error: Livewire property ['${a}'] cannot be found on component: ['${e.name}']`,
            );
            return;
          }
          let f = _o.default.entangle(
            {
              get() {
                return o.get(n);
              },
              set(e) {
                o.set(n, e, i);
              },
            },
            {
              get() {
                return c();
              },
              set(e) {
                l(e);
              },
            },
          );
          return (t(() => f()), yo(o.get(n)));
        },
        (e) => {
          Object.defineProperty(e, "live", {
            get() {
              return ((i = !0), e);
            },
          });
        },
      )(s);
    }
  );
}
function yo(e) {
  return typeof e == `object` ? JSON.parse(JSON.stringify(e)) : e;
}
var bo = [];
function $(e, t) {
  return (
    bo[e] || (bo[e] = []),
    bo[e].push(t),
    () => {
      bo[e] = bo[e].filter((e) => e !== t);
    }
  );
}
function xo(e, ...t) {
  let n = bo[e] || [],
    r = [];
  for (let e = 0; e < n.length; e++) {
    let i = n[e](...t);
    qa(i) && r.push(i);
  }
  return (e) => Co(r, e);
}
async function So(e, ...t) {
  let n = bo[e] || [],
    r = [];
  for (let e = 0; e < n.length; e++) {
    let i = await n[e](...t);
    qa(i) && r.push(i);
  }
  return (e) => Co(r, e);
}
function Co(e, t) {
  let n = t;
  for (let t = 0; t < e.length; t++) {
    let r = e[t](n);
    r !== void 0 && (n = r);
  }
  return n;
}
function wo(e) {
  let t = document.createElement(`html`);
  ((t.innerHTML = e), t.querySelectorAll(`a`).forEach((e) => e.setAttribute(`target`, `_top`)));
  let n = document.getElementById(`livewire-error`);
  n !== void 0 && n != null
    ? (n.innerHTML = ``)
    : ((n = document.createElement(`dialog`)),
      (n.id = `livewire-error`),
      (n.style.margin = `50px`),
      (n.style.width = `calc(100% - 100px)`),
      (n.style.height = `calc(100% - 100px)`),
      (n.style.borderRadius = `5px`),
      (n.style.padding = `0px`));
  let r = document.createElement(`iframe`);
  ((r.style.backgroundColor = `#17161A`),
    (r.style.borderRadius = `5px`),
    (r.style.width = `100%`),
    (r.style.height = `100%`),
    n.appendChild(r),
    document.body.prepend(n),
    (document.body.style.overflow = `hidden`),
    r.contentWindow.document.open(),
    r.contentWindow.document.write(t.outerHTML),
    r.contentWindow.document.close(),
    n.addEventListener(`click`, () => To(n)),
    n.addEventListener(`close`, () => Eo(n)),
    n.showModal(),
    n.focus(),
    n.blur());
}
function To(e) {
  e.close();
}
function Eo(e) {
  ((e.outerHTML = ``), (document.body.style.overflow = `visible`));
}
var Do = class {
    constructor() {
      this.commits = new Set();
    }
    add(e) {
      this.commits.add(e);
    }
    delete(e) {
      this.commits.delete(e);
    }
    hasCommitFor(e) {
      return !!this.findCommitByComponent(e);
    }
    findCommitByComponent(e) {
      for (let [t, n] of this.commits.entries()) if (n.component === e) return n;
    }
    shouldHoldCommit(e) {
      return !e.isolate;
    }
    empty() {
      return this.commits.size === 0;
    }
    async send() {
      (this.prepare(), await Io(this));
    }
    prepare() {
      this.commits.forEach((e) => e.prepare());
    }
    payload() {
      let e = [],
        t = [],
        n = [];
      return (
        this.commits.forEach((r) => {
          let [i, a, o] = r.toRequestPayload();
          (e.push(i), t.push(a), n.push(o));
        }),
        [e, (e) => t.forEach((t) => t(e.shift())), () => n.forEach((e) => e())]
      );
    }
  },
  Oo = Q(ja()),
  ko = class {
    constructor(e) {
      ((this.component = e),
        (this.isolate = !1),
        (this.calls = []),
        (this.receivers = []),
        (this.resolvers = []));
    }
    addResolver(e) {
      this.resolvers.push(e);
    }
    addCall(e, t, n) {
      this.calls.push({
        path: ``,
        method: e,
        params: t,
        handleReturn(e) {
          n(e);
        },
      });
    }
    prepare() {
      xo(`commit.prepare`, {
        component: this.component,
      });
    }
    getEncodedSnapshotWithLatestChildrenMergedIn() {
      let { snapshotEncoded: e, children: t, snapshot: n } = this.component,
        r = t.map((e) => e.id),
        i = Object.fromEntries(
          Object.entries(n.memo.children).filter(([e, t]) => r.includes(t[1])),
        );
      return e.replace(/"children":\{[^}]*\}/, `"children":${JSON.stringify(i)}`);
    }
    toRequestPayload() {
      let e = Qa(this.component.canonical, this.component.ephemeral),
        t = this.component.mergeQueuedUpdates(e),
        n = {
          snapshot: this.getEncodedSnapshotWithLatestChildrenMergedIn(),
          updates: t,
          calls: this.calls.map((e) => ({
            path: e.path,
            method: e.method,
            params: e.params,
          })),
        },
        r = [],
        i = [],
        a = [],
        o = (e) => r.forEach((t) => t(e)),
        s = () => i.forEach((e) => e()),
        c = () => a.forEach((e) => e()),
        l = xo(`commit`, {
          component: this.component,
          commit: n,
          succeed: (e) => {
            r.push(e);
          },
          fail: (e) => {
            i.push(e);
          },
          respond: (e) => {
            a.push(e);
          },
        });
      return [
        n,
        (e) => {
          let { snapshot: n, effects: r } = e;
          if (
            (c(),
            Oo.default.transaction(() => {
              (this.component.mergeNewSnapshot(n, r, t),
                this.component.processEffects(this.component.effects));
            }),
            r.returns)
          ) {
            let e = r.returns;
            this.calls
              .map(({ handleReturn: e }) => e)
              .forEach((t, n) => {
                t(e[n]);
              });
          }
          (l({
            snapshot: JSON.parse(n),
            effects: r,
          }),
            this.resolvers.forEach((e) => e()),
            o(e));
        },
        () => {
          (c(), s());
        },
      ];
    }
  },
  Ao = class {
    constructor() {
      ((this.commits = new Set()), (this.pools = new Set()));
    }
    add(e) {
      let t = this.findCommitOr(e, () => {
        let t = new ko(e);
        return (this.commits.add(t), t);
      });
      return (
        Mo(t, () => {
          this.findPoolWithComponent(t.component) || this.createAndSendNewPool();
        }),
        t
      );
    }
    findCommitOr(e, t) {
      for (let [t, n] of this.commits.entries()) if (n.component === e) return n;
      return t();
    }
    findPoolWithComponent(e) {
      for (let [t, n] of this.pools.entries()) if (n.hasCommitFor(e)) return n;
    }
    createAndSendNewPool() {
      xo(`commit.pooling`, {
        commits: this.commits,
      });
      let e = this.corraleCommitsIntoPools();
      (xo(`commit.pooled`, {
        pools: e,
      }),
        e.forEach((e) => {
          e.empty() ||
            (this.pools.add(e),
            e.send().then(() => {
              (this.pools.delete(e),
                queueMicrotask(() => {
                  this.sendAnyQueuedCommits();
                }));
            }));
        }));
    }
    corraleCommitsIntoPools() {
      let e = new Set();
      for (let [t, n] of this.commits.entries()) {
        if (this.findPoolWithComponent(n.component)) continue;
        let t = !1;
        if (
          (e.forEach((e) => {
            e.shouldHoldCommit(n) && (e.add(n), (t = !0));
          }),
          !t)
        ) {
          let t = new Do();
          (t.add(n), e.add(t));
        }
        this.commits.delete(n);
      }
      return e;
    }
    sendAnyQueuedCommits() {
      this.commits.size > 0 && this.createAndSendNewPool();
    }
  },
  jo = new WeakMap();
function Mo(e, t) {
  jo.has(e) ||
    jo.set(
      e,
      setTimeout(() => {
        (t(), jo.delete(e));
      }, 5),
    );
}
var No = new Ao();
async function Po(e) {
  let t = No.add(e),
    n = new Promise((e) => {
      t.addResolver(e);
    });
  return ((n.commit = t), n);
}
async function Fo(e, t, n) {
  let r = No.add(e),
    i = new Promise((e) => {
      r.addCall(t, n, (t) => e(t));
    });
  return ((i.commit = r), i);
}
async function Io(e) {
  let [t, n, r] = e.payload(),
    i = {
      method: `POST`,
      body: JSON.stringify({
        _token: to(),
        components: t,
      }),
      headers: {
        "Content-type": `application/json`,
        "X-Livewire": ``,
      },
    },
    a = [],
    o = [],
    s = [],
    c = (e) => a.forEach((t) => t(e)),
    l = (e) => o.forEach((t) => t(e)),
    u = (e) => s.forEach((t) => t(e)),
    d = xo(`request.profile`, i),
    f = io();
  xo(`request`, {
    url: f,
    options: i,
    payload: i.body,
    respond: (e) => s.push(e),
    succeed: (e) => a.push(e),
    fail: (e) => o.push(e),
  });
  let p;
  try {
    p = await fetch(f, i);
  } catch {
    (d({
      content: `{}`,
      failed: !0,
    }),
      r(),
      l({
        status: 503,
        content: null,
        preventDefault: () => {},
      }));
    return;
  }
  let m = {
    status: p.status,
    response: p,
  };
  (u(m), (p = m.response));
  let h = await p.text();
  if (!p.ok) {
    d({
      content: `{}`,
      failed: !0,
    });
    let e = !1;
    return (
      r(),
      l({
        status: p.status,
        content: h,
        preventDefault: () => (e = !0),
      }),
      e ? void 0 : (p.status === 419 && Lo(), Ro(h))
    );
  }
  if ((p.redirected && (window.location.href = p.url), ao(h))) {
    let e;
    (([e, h] = oo(h)),
      wo(e),
      d({
        content: `{}`,
        failed: !0,
      }));
  } else
    d({
      content: h,
      failed: !1,
    });
  let { components: g, assets: _ } = JSON.parse(h);
  (await So(`payload.intercept`, {
    components: g,
    assets: _,
  }),
    await n(g),
    c({
      status: p.status,
      json: JSON.parse(h),
    }));
}
function Lo() {
  confirm(`This page has expired.
Would you like to refresh the page?`) && window.location.reload();
}
function Ro(e) {
  wo(e);
}
var zo = Q(ja()),
  Bo = {},
  Vo;
function Ho(e, t, n = null) {
  Bo[e] = t;
}
function Uo(e) {
  Vo = e;
}
var Wo = {
  on: `$on`,
  el: `$el`,
  id: `$id`,
  js: `$js`,
  get: `$get`,
  set: `$set`,
  call: `$call`,
  hook: `$hook`,
  commit: `$commit`,
  watch: `$watch`,
  entangle: `$entangle`,
  dispatch: `$dispatch`,
  dispatchTo: `$dispatchTo`,
  dispatchSelf: `$dispatchSelf`,
  upload: `$upload`,
  uploadMultiple: `$uploadMultiple`,
  removeUpload: `$removeUpload`,
  cancelUpload: `$cancelUpload`,
};
function Go(e, t) {
  return new Proxy(
    {},
    {
      get(n, r) {
        if (r === `__instance`) return e;
        if (r in Wo) return Ko(e, Wo[r]);
        if (r in Bo) return Ko(e, r);
        if (r in t) return t[r];
        if (![`then`].includes(r)) return qo(e)(r);
      },
      set(e, n, r) {
        return (n in t && (t[n] = r), !0);
      },
    },
  );
}
function Ko(e, t) {
  return Bo[t](e);
}
function qo(e) {
  return Vo(e);
}
(zo.default.magic(`wire`, (e, { cleanup: t }) => {
  let n;
  return new Proxy(
    {},
    {
      get(r, i) {
        if (!n)
          try {
            n = rs(e);
          } catch {
            return () => {};
          }
        return [`$entangle`, `entangle`].includes(i) ? vo(n, t) : n.$wire[i];
      },
      set(t, r, i) {
        if (!n)
          try {
            n = rs(e);
          } catch {
            return !0;
          }
        return ((n.$wire[r] = i), !0);
      },
    },
  );
}),
  Ho(`__instance`, (e) => e),
  Ho(
    `$get`,
    (e) =>
      (t, n = !0) =>
        Xa(n ? e.reactive : e.ephemeral, t),
  ),
  Ho(`$el`, (e) => e.el),
  Ho(`$id`, (e) => e.id),
  Ho(`$js`, (e) => {
    let t = e.addJsAction.bind(e),
      n = e.getJsActions();
    return (
      Object.keys(n).forEach((n) => {
        t[n] = e.getJsAction(n);
      }),
      t
    );
  }),
  Ho(
    `$set`,
    (e) =>
      async (t, n, r = !0) => (
        Za(e.reactive, t, n),
        r ? (e.queueUpdate(t, n), await Po(e)) : Promise.resolve()
      ),
  ),
  Ho(
    `$call`,
    (e) =>
      async (t, ...n) =>
        await e.$wire[t](...n),
  ),
  Ho(
    `$entangle`,
    (e) =>
      (t, n = !1) =>
        vo(e)(t, n),
  ),
  Ho(
    `$toggle`,
    (e) =>
      (t, n = !0) =>
        e.$wire.set(t, !e.$wire.get(t), n),
  ),
  Ho(`$watch`, (e) => (t, n) => {
    let r = zo.default.watch(() => Xa(e.reactive, t), n);
    e.addCleanup(r);
  }),
  Ho(`$refresh`, (e) => e.$wire.$commit),
  Ho(`$commit`, (e) => async () => await Po(e)),
  Ho(
    `$on`,
    (e) =>
      (...t) =>
        ps(e, ...t),
  ),
  Ho(`$hook`, (e) => (t, n) => {
    let r = $(t, ({ component: t, ...r }) => {
      if (t === void 0) return n(r);
      if (t.id === e.id)
        return n({
          component: t,
          ...r,
        });
    });
    return (e.addCleanup(r), r);
  }),
  Ho(
    `$dispatch`,
    (e) =>
      (...t) =>
        ls(e, ...t),
  ),
  Ho(
    `$dispatchSelf`,
    (e) =>
      (...t) =>
        ds(e, ...t),
  ),
  Ho(
    `$dispatchTo`,
    () =>
      (...e) =>
        fs(...e),
  ),
  Ho(
    `$upload`,
    (e) =>
      (...t) =>
        po(e, ...t),
  ),
  Ho(
    `$uploadMultiple`,
    (e) =>
      (...t) =>
        mo(e, ...t),
  ),
  Ho(
    `$removeUpload`,
    (e) =>
      (...t) =>
        ho(e, ...t),
  ),
  Ho(
    `$cancelUpload`,
    (e) =>
      (...t) =>
        go(e, ...t),
  ));
var Jo = new WeakMap();
Ho(`$parent`, (e) => {
  if (Jo.has(e)) return Jo.get(e).$wire;
  let t = e.parent;
  return (Jo.set(e, t), t.$wire);
});
var Yo = new WeakMap();
function Xo(e, t, n) {
  Yo.has(e) || Yo.set(e, {});
  let r = Yo.get(e);
  ((r[t] = n), Yo.set(e, r));
}
Uo((e) => (t) => async (...n) => {
  if ((n.length === 1 && n[0] instanceof Event && (n = []), Yo.has(e))) {
    let r = Yo.get(e);
    if (typeof r[t] == `function`) return r[t](n);
  }
  return await Fo(e, t, n);
});
var Zo = class {
    constructor(e) {
      if (e.__livewire) throw `Component already initialized`;
      if (
        ((e.__livewire = this),
        (this.el = e),
        (this.id = e.getAttribute(`wire:id`)),
        (this.__livewireId = this.id),
        (this.snapshotEncoded = e.getAttribute(`wire:snapshot`)),
        (this.snapshot = JSON.parse(this.snapshotEncoded)),
        !this.snapshot)
      )
        throw `Snapshot missing on Livewire component with id: ` + this.id;
      ((this.name = this.snapshot.memo.name),
        (this.effects = JSON.parse(e.getAttribute(`wire:effects`))),
        (this.originalEffects = Ya(this.effects)),
        (this.canonical = $a(Ya(this.snapshot.data))),
        (this.ephemeral = $a(Ya(this.snapshot.data))),
        (this.reactive = Alpine.reactive(this.ephemeral)),
        (this.queuedUpdates = {}),
        (this.jsActions = {}),
        (this.$wire = Go(this, this.reactive)),
        (this.cleanups = []),
        this.processEffects(this.effects));
    }
    mergeNewSnapshot(e, t, n = {}) {
      let r = JSON.parse(e),
        i = Ya(this.canonical),
        a = Qa(this.applyUpdates(i, n), $a(Ya(r.data)));
      ((this.snapshotEncoded = e),
        (this.snapshot = r),
        (this.effects = t),
        (this.canonical = $a(Ya(r.data))));
      let o = $a(Ya(r.data));
      return (
        Object.entries(a).forEach(([e, t]) => {
          let n = e.split(`.`)[0];
          this.reactive[n] = o[n];
        }),
        a
      );
    }
    queueUpdate(e, t) {
      this.queuedUpdates[e] = t;
    }
    mergeQueuedUpdates(e) {
      return (
        Object.entries(this.queuedUpdates).forEach(([t, n]) => {
          (Object.entries(e).forEach(([t, r]) => {
            t.startsWith(n) && delete e[t];
          }),
            (e[t] = n));
        }),
        (this.queuedUpdates = []),
        e
      );
    }
    applyUpdates(e, t) {
      for (let n in t) Za(e, n, t[n]);
      return e;
    }
    replayUpdate(e, t) {
      let n = {
        ...this.effects,
        html: t,
      };
      (this.mergeNewSnapshot(JSON.stringify(e), n),
        this.processEffects({
          html: t,
        }));
    }
    processEffects(e) {
      (xo(`effects`, this, e),
        xo(`effect`, {
          component: this,
          effects: e,
          cleanup: (e) => this.addCleanup(e),
        }));
    }
    get children() {
      let e = this.snapshot.memo;
      return Object.values(e.children)
        .map((e) => e[1])
        .filter((e) => ts(e))
        .map((e) => ns(e));
    }
    get parent() {
      return rs(this.el.parentElement);
    }
    get isLazy() {
      return this.snapshot.memo.lazyLoaded !== void 0;
    }
    get hasBeenLazyLoaded() {
      return this.snapshot.memo.lazyLoaded === !0;
    }
    inscribeSnapshotAndEffectsOnElement() {
      let e = this.el;
      e.setAttribute(`wire:snapshot`, this.snapshotEncoded);
      let t = this.originalEffects.listeners
        ? {
            listeners: this.originalEffects.listeners,
          }
        : {};
      (this.originalEffects.url && (t.url = this.originalEffects.url),
        this.originalEffects.scripts && (t.scripts = this.originalEffects.scripts),
        e.setAttribute(`wire:effects`, JSON.stringify(t)));
    }
    addJsAction(e, t) {
      this.jsActions[e] = t;
    }
    hasJsAction(e) {
      return this.jsActions[e] !== void 0;
    }
    getJsAction(e) {
      return this.jsActions[e].bind(this.$wire);
    }
    getJsActions() {
      return this.jsActions;
    }
    addCleanup(e) {
      this.cleanups.push(e);
    }
    cleanup() {
      for (delete this.el.__livewire; this.cleanups.length > 0;) this.cleanups.pop()();
    }
  },
  Qo = {};
function $o(e) {
  let t = new Zo(e);
  if (Qo[t.id]) throw `Component already registered`;
  return (
    xo(`component.init`, {
      component: t,
      cleanup: (e) => t.addCleanup(e),
    }),
    (Qo[t.id] = t),
    t
  );
}
function es(e) {
  let t = Qo[e];
  t && (t.cleanup(), delete Qo[e]);
}
function ts(e) {
  return !!Qo[e];
}
function ns(e) {
  let t = Qo[e];
  if (!t) throw `Component not found: ` + e;
  return t;
}
function rs(e, t = !0) {
  let n = Alpine.findClosest(e, (e) => e.__livewire);
  if (!n) {
    if (t) throw `Could not find Livewire component in DOM tree`;
    return;
  }
  return n.__livewire;
}
function is(e) {
  return Object.values(Qo).filter((t) => e == t.name);
}
function as(e) {
  return is(e).map((e) => e.$wire);
}
function os(e) {
  let t = Qo[e];
  return t && t.$wire;
}
function ss() {
  return Object.values(Qo)[0].$wire;
}
function cs() {
  return Object.values(Qo);
}
function ls(e, t, n) {
  hs(e.el, t, n);
}
function us(e, t) {
  hs(window, e, t);
}
function ds(e, t, n) {
  hs(e.el, t, n, !1);
}
function fs(e, t, n) {
  is(e).forEach((e) => {
    hs(e.el, t, n, !1);
  });
}
function ps(e, t, n) {
  e.el.addEventListener(t, (e) => {
    n(e.detail);
  });
}
function ms(e, t) {
  let n = (e) => {
    e.__livewire && t(e.detail);
  };
  return (
    window.addEventListener(e, n),
    () => {
      window.removeEventListener(e, n);
    }
  );
}
function hs(e, t, n, r = !0) {
  typeof n == `string` && (n = [n]);
  let i = new CustomEvent(t, {
    bubbles: r,
    detail: n,
  });
  ((i.__livewire = {
    name: t,
    params: n,
    receivedBy: [],
  }),
    e.dispatchEvent(i));
}
var gs = new Set();
function _s(e) {
  return e.match(RegExp(`wire:`));
}
function vs(e, t) {
  let [n, ...r] = t.replace(RegExp(`wire:`), ``).split(`.`);
  return new ws(n, r, t, e);
}
function ys(e, t) {
  gs.has(e) ||
    (gs.add(e),
    $(`directive.init`, ({ el: n, component: r, directive: i, cleanup: a }) => {
      i.value === e &&
        t({
          el: n,
          directive: i,
          component: r,
          $wire: r.$wire,
          cleanup: a,
        });
    }));
}
function bs(e, t) {
  gs.has(e) ||
    (gs.add(e),
    $(`directive.global.init`, ({ el: n, directive: r, cleanup: i }) => {
      r.value === e &&
        t({
          el: n,
          directive: r,
          cleanup: i,
        });
    }));
}
function xs(e) {
  return new Cs(e);
}
function Ss(e) {
  return gs.has(e);
}
var Cs = class {
    constructor(e) {
      ((this.el = e), (this.directives = this.extractTypeModifiersAndValue()));
    }
    all() {
      return this.directives;
    }
    has(e) {
      return this.directives.map((e) => e.value).includes(e);
    }
    missing(e) {
      return !this.has(e);
    }
    get(e) {
      return this.directives.find((t) => t.value === e);
    }
    extractTypeModifiersAndValue() {
      return Array.from(
        this.el
          .getAttributeNames()
          .filter((e) => _s(e))
          .map((e) => vs(this.el, e)),
      );
    }
  },
  ws = class {
    constructor(e, t, n, r) {
      ((this.rawName = this.raw = n),
        (this.el = r),
        this.eventContext,
        (this.value = e),
        (this.modifiers = t),
        (this.expression = this.el.getAttribute(this.rawName)));
    }
    get method() {
      return this.parseOutMethodsAndParams(this.expression)[0].method;
    }
    get methods() {
      return this.parseOutMethodsAndParams(this.expression);
    }
    get params() {
      return this.parseOutMethodsAndParams(this.expression)[0].params;
    }
    parseOutMethodsAndParams(e) {
      let t = [],
        n = this.splitAndParseMethods(e);
      for (let { method: e, paramString: r } of n) {
        let n = [];
        if (r.length > 0) {
          let e = function () {
            var e = [...arguments];
            return [].concat(e);
          };
          try {
            n = Alpine.evaluate(document, `argumentsToArray(` + r + `)`, {
              scope: {
                argumentsToArray: e,
              },
            });
          } catch (e) {
            (console.warn(`Failed to parse parameters:`, r, e), (n = []));
          }
        }
        t.push({
          method: e,
          params: n,
        });
      }
      return t;
    }
    splitAndParseMethods(e) {
      let t = [],
        n = ``,
        r = 0,
        i = !1,
        a = null,
        o = e.trim();
      for (let e = 0; e < o.length; e++) {
        let s = o[e];
        i
          ? (s === a && o[e - 1] !== `\\` && ((i = !1), (a = null)), (n += s))
          : s === `"` || s === `'`
            ? ((i = !0), (a = s), (n += s))
            : s === `(`
              ? (r++, (n += s))
              : s === `)`
                ? (r--, (n += s))
                : s === `,` && r === 0
                  ? (t.push(this.parseMethodCall(n.trim())), (n = ``))
                  : (n += s);
      }
      return (n.trim().length > 0 && t.push(this.parseMethodCall(n.trim())), t);
    }
    parseMethodCall(e) {
      let t = e.match(/^([^(]+)\(/);
      if (!t)
        return {
          method: e.trim(),
          paramString: ``,
        };
      let n = t[1].trim(),
        r = t[0].length - 1,
        i = e.lastIndexOf(`)`);
      if (i === -1) throw Error(`Missing closing parenthesis for method "${n}"`);
      return {
        method: n,
        paramString: e.slice(r + 1, i).trim(),
      };
    }
  },
  Ts = Q(Ma()),
  Es = Q(Na());
function Ds(e) {
  let t = () => {
    let t, n;
    try {
      n = localStorage;
    } catch (e) {
      (console.error(e),
        console.warn(
          `Alpine: $persist is using temporary storage since localStorage is unavailable.`,
        ));
      let t = new Map();
      n = {
        getItem: t.get.bind(t),
        setItem: t.set.bind(t),
      };
    }
    return e.interceptor(
      (r, i, a, o, s) => {
        let c = t || `_x_${o}`,
          l = Os(c, n) ? ks(c, n) : r;
        return (
          a(l),
          e.effect(() => {
            let e = i();
            (As(c, e, n), a(e));
          }),
          l
        );
      },
      (e) => {
        ((e.as = (n) => ((t = n), e)), (e.using = (t) => ((n = t), e)));
      },
    );
  };
  (Object.defineProperty(e, "$persist", {
    get: () => t(),
  }),
    e.magic(`persist`, t),
    (e.persist = (t, { get: n, set: r }, i = localStorage) => {
      (r(Os(t, i) ? ks(t, i) : n()),
        e.effect(() => {
          let e = n();
          (As(t, e, i), r(e));
        }));
    }));
}
function Os(e, t) {
  return t.getItem(e) !== null;
}
function ks(e, t) {
  let n = t.getItem(e);
  if (n !== void 0) return JSON.parse(n);
}
function As(e, t, n) {
  n.setItem(e, JSON.stringify(t));
}
var js = Ds,
  Ms = Q(Pa()),
  Ns = Q(Fa()),
  Ps = Q(Ia()),
  Fs = class {
    constructor(e, t) {
      ((this.url = e), (this.html = t));
    }
  },
  Is = {
    currentKey: null,
    currentUrl: null,
    keys: [],
    lookup: {},
    limit: 10,
    has(e) {
      return this.lookup[e] !== void 0;
    },
    retrieve(e) {
      let t = this.lookup[e];
      if (t === void 0) throw `No back button cache found for current location: ` + e;
      return t;
    },
    replace(e, t) {
      this.has(e) ? (this.lookup[e] = t) : this.push(e, t);
    },
    push(e, t) {
      this.lookup[e] = t;
      let n = this.keys.indexOf(e);
      (n > -1 && this.keys.splice(n, 1), this.keys.unshift(e), this.trim());
    },
    trim() {
      for (let e of this.keys.splice(this.limit)) delete this.lookup[e];
    },
  },
  Ls = null;
function Rs(e) {
  Ls = e;
}
function zs() {
  Ws(new URL(window.location.href, document.baseURI), document.documentElement.outerHTML);
}
function Bs(e, t) {
  let n = document.documentElement.outerHTML;
  Is.replace(e, new Fs(t, n));
}
function Vs(e, t) {
  let n;
  (e((e) => (n = e)),
    window.addEventListener(`popstate`, (e) => {
      let r = e.state || {},
        i = r.alpine || {};
      if (Ls && (Ls < 200 || Ls >= 300)) return (window.location.href = i.url);
      if (Object.keys(r).length !== 0 && i.snapshotIdx)
        if (Is.has(i.snapshotIdx)) {
          let e = Is.retrieve(i.snapshotIdx);
          t(e.html, e.url, Is.currentUrl, Is.currentKey);
        } else n(i.url);
    }));
}
function Hs(e, t) {
  Us(t, e);
}
function Us(e, t) {
  Gs(`pushState`, e, t);
}
function Ws(e, t) {
  Gs(`replaceState`, e, t);
}
function Gs(e, t, n) {
  let r = t.toString() + `-` + Math.random();
  e === `pushState` ? Is.push(r, new Fs(t, n)) : Is.replace((r = Is.currentKey ?? r), new Fs(t, n));
  let i = history.state || {};
  ((i.alpine ||= {}), (i.alpine.snapshotIdx = r), (i.alpine.url = t.toString()));
  try {
    (history[e](i, JSON.stringify(document.title), t), (Is.currentKey = r), (Is.currentUrl = t));
  } catch (e) {
    (e instanceof DOMException &&
      e.name === `SecurityError` &&
      console.error(
        `Livewire: You can't use wire:navigate with a link to a different root domain: ` + t,
      ),
      console.error(e));
  }
}
function Ks(e, t) {
  let n = (e) => !e.isTrusted,
    r = (e) => e.which > 1 || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey,
    i = (e) => e.which !== 13 || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey;
  (e.addEventListener(`click`, (e) => {
    if (n(e)) {
      (e.preventDefault(), t((e) => e()));
      return;
    }
    r(e) || e.preventDefault();
  }),
    e.addEventListener(`mousedown`, (n) => {
      r(n) ||
        (n.preventDefault(),
        t((t) => {
          let n = (r) => {
            (r.preventDefault(),
              requestAnimationFrame(() => {
                t();
              }),
              e.removeEventListener(`mouseup`, n));
          };
          e.addEventListener(`mouseup`, n);
        }));
    }),
    e.addEventListener(`keydown`, (e) => {
      i(e) || (e.preventDefault(), t((e) => e()));
    }));
}
function qs(e, t = 60, n) {
  e.addEventListener(`mouseenter`, (r) => {
    let i = setTimeout(() => {
        n(r);
      }, t),
      a = () => {
        (clearTimeout(i), e.removeEventListener(`mouseleave`, a));
      };
    e.addEventListener(`mouseleave`, a);
  });
}
function Js(e) {
  return Ys(e.getAttribute(`href`));
}
function Ys(e) {
  return e !== null && new URL(e, document.baseURI);
}
function Xs(e) {
  return e.pathname + e.search + e.hash;
}
function Zs(e, t) {
  Qs(Xs(e), (e, n, r) => {
    (Rs(r), t(e, n));
  });
}
function Qs(e, t) {
  let n = {
    headers: {
      "X-Livewire-Navigate": ``,
    },
  };
  xo(`navigate.request`, {
    url: e,
    options: n,
  });
  let r, i;
  fetch(e, n)
    .then((t) => {
      let n = Ys(e);
      return (
        (r = Ys(t.url)),
        n.pathname + n.search === r.pathname + r.search && (r.hash = n.hash),
        (i = t.status),
        t.text()
      );
    })
    .then((e) => {
      t(e, r, i);
    });
}
var $s = {},
  ec = 3e4;
function tc(e, t) {
  let n = Xs(e);
  $s[n] ||
    (($s[n] = {
      finished: !1,
      html: null,
      whenFinished: () => setTimeout(() => delete $s[n], ec),
    }),
    Qs(n, (e, n, r) => {
      (Rs(r), t(e, n));
    }));
}
function nc(e, t, n) {
  let r = $s[Xs(t)];
  ((r.html = e), (r.finished = !0), (r.finalDestination = n), r.whenFinished());
}
function rc(e, t, n) {
  let r = Xs(e);
  if (!$s[r]) return n();
  if ($s[r].finished) {
    let e = $s[r].html,
      n = $s[r].finalDestination;
    return (delete $s[r], t(e, n));
  } else
    $s[r].whenFinished = () => {
      let e = $s[r].html,
        n = $s[r].finalDestination;
      (delete $s[r], t(e, n));
    };
}
var ic = Q(ja());
function ac(e) {
  ic.default.mutateDom(() => {
    e.querySelectorAll(`[data-teleport-template]`).forEach((e) => e._x_teleport.remove());
  });
}
function oc(e) {
  ic.default.mutateDom(() => {
    e.querySelectorAll(`[data-teleport-target]`).forEach((e) => e.remove());
  });
}
function sc(e) {
  ic.default.walk(e, (e, t) => {
    e._x_teleport && (e._x_teleportPutBack(), t());
  });
}
function cc(e) {
  return e.hasAttribute(`data-teleport-target`);
}
function lc() {
  (document.body.setAttribute(`data-scroll-x`, document.body.scrollLeft),
    document.body.setAttribute(`data-scroll-y`, document.body.scrollTop),
    document.querySelectorAll([`[x-navigate\\:scroll]`, `[wire\\:scroll]`]).forEach((e) => {
      (e.setAttribute(`data-scroll-x`, e.scrollLeft), e.setAttribute(`data-scroll-y`, e.scrollTop));
    }));
}
function uc() {
  let e = (e) => {
    e.hasAttribute(`data-scroll-x`)
      ? (e.scrollTo({
          top: Number(e.getAttribute(`data-scroll-y`)),
          left: Number(e.getAttribute(`data-scroll-x`)),
          behavior: `instant`,
        }),
        e.removeAttribute(`data-scroll-x`),
        e.removeAttribute(`data-scroll-y`))
      : window.scrollTo({
          top: 0,
          left: 0,
          behavior: `instant`,
        });
  };
  queueMicrotask(() => {
    queueMicrotask(() => {
      (e(document.body),
        document.querySelectorAll([`[x-navigate\\:scroll]`, `[wire\\:scroll]`]).forEach(e));
    });
  });
}
var dc = Q(ja()),
  fc = {};
function pc(e) {
  ((fc = {}),
    document.querySelectorAll(`[x-persist]`).forEach((t) => {
      ((fc[t.getAttribute(`x-persist`)] = t),
        e(t),
        dc.default.mutateDom(() => {
          t.remove();
        }));
    }));
}
function mc(e) {
  let t = [];
  (document.querySelectorAll(`[x-persist]`).forEach((n) => {
    let r = fc[n.getAttribute(`x-persist`)];
    r &&
      (t.push(n.getAttribute(`x-persist`)),
      (r._x_wasPersisted = !0),
      e(r, n),
      dc.default.mutateDom(() => {
        n.replaceWith(r);
      }));
  }),
    Object.entries(fc).forEach(([e, n]) => {
      t.includes(e) || dc.default.destroyTree(n);
    }),
    (fc = {}));
}
function hc(e) {
  return e.hasAttribute(`x-persist`);
}
var gc = Q(La());
(gc.default.configure({
  minimum: 0.1,
  trickleSpeed: 200,
  showSpinner: !1,
  parent: `body`,
}),
  xc());
var _c = !1;
function vc() {
  ((_c = !0),
    setTimeout(() => {
      _c && gc.default.start();
    }, 150));
}
function yc() {
  ((_c = !1), gc.default.done());
}
function bc() {
  gc.default.remove();
}
function xc() {
  let e = document.createElement(`style`);
  e.innerHTML = `/* Make clicks pass-through */

    #nprogress {
      pointer-events: none;
    }

    #nprogress .bar {
      background: var(--livewire-progress-bar-color, #29d);

      position: fixed;
      z-index: 1031;
      top: 0;
      left: 0;

      width: 100%;
      height: 2px;
    }

    /* Fancy blur effect */
    #nprogress .peg {
      display: block;
      position: absolute;
      right: 0px;
      width: 100px;
      height: 100%;
      box-shadow: 0 0 10px var(--livewire-progress-bar-color, #29d), 0 0 5px var(--livewire-progress-bar-color, #29d);
      opacity: 1.0;

      -webkit-transform: rotate(3deg) translate(0px, -4px);
          -ms-transform: rotate(3deg) translate(0px, -4px);
              transform: rotate(3deg) translate(0px, -4px);
    }

    /* Remove these to get rid of the spinner */
    #nprogress .spinner {
      display: block;
      position: fixed;
      z-index: 1031;
      top: 15px;
      right: 15px;
    }

    #nprogress .spinner-icon {
      width: 18px;
      height: 18px;
      box-sizing: border-box;

      border: solid 2px transparent;
      border-top-color: var(--livewire-progress-bar-color, #29d);
      border-left-color: var(--livewire-progress-bar-color, #29d);
      border-radius: 50%;

      -webkit-animation: nprogress-spinner 400ms linear infinite;
              animation: nprogress-spinner 400ms linear infinite;
    }

    .nprogress-custom-parent {
      overflow: hidden;
      position: relative;
    }

    .nprogress-custom-parent #nprogress .spinner,
    .nprogress-custom-parent #nprogress .bar {
      position: absolute;
    }

    @-webkit-keyframes nprogress-spinner {
      0%   { -webkit-transform: rotate(0deg); }
      100% { -webkit-transform: rotate(360deg); }
    }
    @keyframes nprogress-spinner {
      0%   { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
    `;
  let t = ro();
  (t && (e.nonce = t), document.head.appendChild(e));
}
function Sc(e) {
  wc() &&
    e.querySelectorAll(`:popover-open`).forEach((e) => {
      e.setAttribute(`data-navigate-popover-open`, ``);
      let t = e.getAnimations();
      ((e._pausedAnimations = t.map((e) => ({
        keyframes: e.effect.getKeyframes(),
        options: {
          duration: e.effect.getTiming().duration,
          easing: e.effect.getTiming().easing,
          fill: e.effect.getTiming().fill,
          iterations: e.effect.getTiming().iterations,
        },
        currentTime: e.currentTime,
        playState: e.playState,
      }))),
        t.forEach((e) => e.pause()));
    });
}
function Cc(e) {
  wc() &&
    e.querySelectorAll(`[data-navigate-popover-open]`).forEach((e) => {
      (e.removeAttribute(`data-navigate-popover-open`),
        queueMicrotask(() => {
          e.isConnected &&
            (e.showPopover(),
            e.getAnimations().forEach((e) => e.finish()),
            e._pausedAnimations &&
              (e._pausedAnimations.forEach(
                ({ keyframes: t, options: n, currentTime: r, now: i, playState: a }) => {
                  let o = e.animate(t, n);
                  o.currentTime = r;
                },
              ),
              delete e._pausedAnimations));
        }));
    });
}
function wc() {
  return typeof document.createElement(`div`).showPopover == `function`;
}
var Tc = [],
  Ec = [`data-csrf`, `nonce`, `aria-hidden`];
function Dc(e, t) {
  let n = new DOMParser().parseFromString(e, `text/html`),
    r = n.documentElement,
    i = document.adoptNode(n.body),
    a = document.adoptNode(n.head);
  Tc = Tc.concat(
    Array.from(document.body.querySelectorAll(`script`)).map((e) => Rc(zc(e.outerHTML, Ec))),
  );
  let o = () => {};
  (kc(r),
    Ac(a).finally(() => {
      o();
    }),
    Oc(i, Tc));
  let s = document.body;
  (document.body.replaceWith(i), Alpine.destroyTree(s), t((e) => (o = e)));
}
function Oc(e, t) {
  e.querySelectorAll(`script`).forEach((e) => {
    if (e.hasAttribute(`data-navigate-once`)) {
      let n = Rc(zc(e.outerHTML, Ec));
      if (t.includes(n)) return;
    }
    e.replaceWith(Mc(e));
  });
}
function kc(e) {
  let t = document.documentElement;
  (Array.from(e.attributes).forEach((e) => {
    let n = e.name,
      r = e.value;
    t.getAttribute(n) !== r && t.setAttribute(n, r);
  }),
    Array.from(t.attributes).forEach((n) => {
      e.hasAttribute(n.name) || t.removeAttribute(n.name);
    }));
}
function Ac(e) {
  let t = Array.from(document.head.children),
    n = t.map((e) => e.outerHTML),
    r = document.createDocumentFragment(),
    i = [],
    a = [];
  for (let o of Array.from(e.children))
    if (Ic(o)) {
      if (n.includes(o.outerHTML)) r.appendChild(o);
      else if ((Nc(o) && Pc(o, t) && setTimeout(() => window.location.reload()), Lc(o)))
        try {
          a.push(jc(Mc(o)));
        } catch {}
      else document.head.appendChild(o);
      i.push(o);
    }
  for (let e of Array.from(document.head.children)) Ic(e) || e.remove();
  for (let t of Array.from(e.children))
    t.tagName.toLowerCase() !== `noscript` && document.head.appendChild(t);
  return Promise.all(a);
}
async function jc(e) {
  return new Promise((t, n) => {
    (e.src ? ((e.onload = () => t()), (e.onerror = () => n())) : t(), document.head.appendChild(e));
  });
}
function Mc(e) {
  let t = document.createElement(`script`);
  ((t.textContent = e.textContent), (t.async = e.async));
  for (let n of e.attributes) t.setAttribute(n.name, n.value);
  return t;
}
function Nc(e) {
  return e.hasAttribute(`data-navigate-track`);
}
function Pc(e, t) {
  let [n, r] = Fc(e);
  return t.some((e) => {
    if (!Nc(e)) return !1;
    let [t, i] = Fc(e);
    if (t === n && r !== i) return !0;
  });
}
function Fc(e) {
  return (Lc(e) ? e.src : e.href).split(`?`);
}
function Ic(e) {
  return (
    (e.tagName.toLowerCase() === `link` && e.getAttribute(`rel`).toLowerCase() === `stylesheet`) ||
    e.tagName.toLowerCase() === `style` ||
    e.tagName.toLowerCase() === `script`
  );
}
function Lc(e) {
  return e.tagName.toLowerCase() === `script`;
}
function Rc(e) {
  return e.split(``).reduce((e, t) => ((e = (e << 5) - e + t.charCodeAt(0)), e & e), 0);
}
function zc(e, t) {
  let n = e;
  return (
    t.forEach((e) => {
      let t = RegExp(`${e}="[^"]*"|${e}='[^']*'`, `g`);
      n = n.replace(t, ``);
    }),
    (n = n.replaceAll(` `, ``)),
    n.trim()
  );
}
var Bc = !0,
  Vc = !0,
  Hc = !0,
  Uc = !1;
function Wc(e) {
  ((e.navigate = (e, n = {}) => {
    let { preserveScroll: r = !1 } = n,
      i = Ys(e);
    qc(`alpine:navigate`, {
      url: i,
      history: !1,
      cached: !1,
    }) ||
      t(i, {
        preserveScroll: r,
      });
  }),
    (e.navigate.disableProgressBar = () => {
      Vc = !1;
    }),
    e.addInitSelector(() => `[${e.prefixed(`navigate`)}]`),
    e.directive(`navigate`, (e, { modifiers: n }) => {
      let r = n.includes(`hover`),
        i = n.includes(`preserve-scroll`);
      (r &&
        qs(e, 60, () => {
          let t = Js(e);
          t &&
            tc(t, (e, n) => {
              nc(e, t, n);
            });
        }),
        Ks(e, (n) => {
          let r = Js(e);
          r &&
            (tc(r, (e, t) => {
              nc(e, r, t);
            }),
            n(() => {
              qc(`alpine:navigate`, {
                url: r,
                history: !1,
                cached: !1,
              }) ||
                t(r, {
                  preserveScroll: i,
                });
            }));
        }));
    }));
  function t(t, { preserveScroll: n = !1, shouldPushToHistoryState: r = !0 }) {
    (Vc && vc(),
      Gc(t, (t, i) => {
        let a = [];
        (qc(`alpine:navigating`, {
          onSwap: (e) => a.push(e),
        }),
          Hc && lc(),
          Xc(),
          zs(),
          Kc(e, (o) => {
            (Bc &&
              pc((e) => {
                (ac(e), Sc(e));
              }),
              r ? Hs(t, i) : Ws(i, t),
              Dc(t, (t) => {
                (oc(document.body),
                  Bc &&
                    mc((e, t) => {
                      (sc(e), Cc(e));
                    }),
                  !n && uc(),
                  a.forEach((e) => e()),
                  t(() => {
                    o(() => {
                      (setTimeout(() => {
                        Uc && Yc();
                      }),
                        Jc(e),
                        qc(`alpine:navigated`),
                        Vc && yc());
                    });
                  }));
              }));
          }));
      }));
  }
  (Vs(
    (e) => {
      e((e) => {
        let n = Ys(e);
        qc(`alpine:navigate`, {
          url: n,
          history: !0,
          cached: !1,
        }) ||
          t(n, {
            shouldPushToHistoryState: !1,
          });
      });
    },
    (t, n, r, i) => {
      if (
        qc(`alpine:navigate`, {
          url: Ys(n),
          history: !0,
          cached: !0,
        })
      )
        return;
      lc();
      let a = [];
      (qc(`alpine:navigating`, {
        onSwap: (e) => a.push(e),
      }),
        Bs(r, i),
        Kc(e, (n) => {
          (Bc &&
            pc((e) => {
              (ac(e), Sc(e));
            }),
            Dc(t, () => {
              (bc(),
                oc(document.body),
                Bc &&
                  mc((e, t) => {
                    (sc(e), Cc(e));
                  }),
                uc(),
                a.forEach((e) => e()),
                n(() => {
                  (Uc && Yc(), Jc(e), qc(`alpine:navigated`));
                }));
            }));
        }));
    },
  ),
    setTimeout(() => {
      qc(`alpine:navigated`);
    }));
}
function Gc(e, t) {
  rc(e, t, () => {
    Zs(e, t);
  });
}
function Kc(e, t) {
  (e.stopObservingMutations(),
    t((t) => {
      (e.startObservingMutations(),
        queueMicrotask(() => {
          t();
        }));
    }));
}
function qc(e, t) {
  let n = new CustomEvent(e, {
    cancelable: !0,
    bubbles: !0,
    detail: t,
  });
  return (document.dispatchEvent(n), n.defaultPrevented);
}
function Jc(e) {
  e.initTree(document.body, void 0, (e, t) => {
    e._x_wasPersisted && t();
  });
}
function Yc() {
  document.querySelector(`[autofocus]`) && document.querySelector(`[autofocus]`).focus();
}
function Xc() {
  Alpine.destroyTree(document.body, function (e, t) {
    Alpine.walk(e, (e, n) => {
      (hc(e) && n(), cc(e) ? n() : t(e, n));
    });
  });
}
function Zc(e) {
  (e.magic(`queryString`, (t, { interceptor: n }) => {
    let r,
      i = !1,
      a = !1;
    return n(
      (t, n, o, s, c) => {
        let { initial: l, replace: u, push: d, pop: f } = Qc(r || s, t, i);
        return (
          o(l),
          a
            ? (e.effect(() => d(n())),
              f(async (e) => {
                (o(e), await Promise.resolve());
              }))
            : e.effect(() => u(n())),
          l
        );
      },
      (e) => {
        ((e.alwaysShow = () => ((i = !0), e)),
          (e.usePush = () => ((a = !0), e)),
          (e.as = (t) => ((r = t), e)));
      },
    );
  }),
    (e.history = {
      track: Qc,
    }));
}
function Qc(e, t, n = !1, r = null) {
  let { has: i, get: a, set: o, remove: s } = nl(),
    c = new URL(window.location.href),
    l = i(c, e),
    u = l ? a(c, e) : t,
    d = JSON.stringify(u),
    f = JSON.stringify(r),
    p = (e) => JSON.stringify(e) === d,
    m = (e) => JSON.stringify(e) === f;
  (n && (c = o(c, e, u)),
    $c(c, e, {
      value: u,
    }));
  let h = !1,
    g = (t, r) => {
      if (h) return;
      let i = new URL(window.location.href);
      ((i = (!n && !l && p(r)) || r === void 0 || (!n && m(r)) ? s(i, e) : o(i, e, r)),
        t(i, e, {
          value: r,
        }));
    };
  return {
    initial: u,
    replace(e) {
      g($c, e);
    },
    push(e) {
      g(el, e);
    },
    pop(t) {
      let n = (n) => {
        !n.state ||
          !n.state.alpine ||
          Object.entries(n.state.alpine).forEach(([n, { value: r }]) => {
            if (n !== e) return;
            h = !0;
            let i = t(r);
            i instanceof Promise ? i.finally(() => (h = !1)) : (h = !1);
          });
      };
      return (
        window.addEventListener(`popstate`, n),
        () => window.removeEventListener(`popstate`, n)
      );
    },
  };
}
function $c(e, t, n) {
  let r = window.history.state || {};
  ((r.alpine ||= {}), (r.alpine[t] = tl(n)));
  try {
    window.history.replaceState(r, ``, e.toString());
  } catch (e) {
    console.error(e);
  }
}
function el(e, t, n) {
  let r = window.history.state || {};
  ((r.alpine ||= {}),
    (r = {
      alpine: {
        ...r.alpine,
        [t]: tl(n),
      },
    }));
  try {
    window.history.pushState(r, ``, e.toString());
  } catch (e) {
    console.error(e);
  }
}
function tl(e) {
  if (e !== void 0) return JSON.parse(JSON.stringify(e));
}
function nl() {
  return {
    has(e, t) {
      let n = e.search;
      if (!n) return !1;
      let r = al(n, t);
      return Object.keys(r).includes(t);
    },
    get(e, t) {
      let n = e.search;
      return n ? al(n, t)[t] : !1;
    },
    set(e, t, n) {
      let r = al(e.search, t);
      return ((r[t] = rl(tl(n))), (e.search = il(r)), e);
    },
    remove(e, t) {
      let n = al(e.search, t);
      return (delete n[t], (e.search = il(n)), e);
    },
  };
}
function rl(e) {
  if (!Wa(e)) return e;
  for (let t in e) e[t] === null ? delete e[t] : (e[t] = rl(e[t]));
  return e;
}
function il(e) {
  let t = (e) => typeof e == `object` && !!e,
    n = (e, r = {}, i = ``) => (
      Object.entries(e).forEach(([e, a]) => {
        let o = i === `` ? e : `${i}[${e}]`;
        a === null
          ? (r[o] = ``)
          : t(a)
            ? (r = {
                ...r,
                ...n(a, r, o),
              })
            : (r[o] = encodeURIComponent(a).replaceAll(`%20`, `+`).replaceAll(`%2C`, `,`));
      }),
      r
    ),
    r = n(e);
  return Object.entries(r)
    .map(([e, t]) => `${e}=${t}`)
    .join(`&`);
}
function al(e, t) {
  if (((e = e.replace(`?`, ``)), e === ``)) return {};
  let n = (e, t, r) => {
      let [i, a, ...o] = e.split(`.`);
      if (!a) return (r[e] = t);
      (r[i] === void 0 && (r[i] = isNaN(a) ? {} : []), n([a, ...o].join(`.`), t, r[i]));
    },
    r = e.split(`&`).map((e) => e.split(`=`)),
    i = Object.create(null);
  return (
    r.forEach(([e, r]) => {
      if (r === void 0) return;
      r = decodeURIComponent(r.replaceAll(`+`, `%20`));
      let a = decodeURIComponent(e);
      a.includes(`[`) && a.startsWith(t)
        ? n(a.replaceAll(`[`, `.`).replaceAll(`]`, ``), r, i)
        : (i[e] = r);
    }),
    i
  );
}
var ol = Q(Ra()),
  sl = Q(za()),
  cl = Q(ja());
function ll() {
  (setTimeout(() => ul()),
    Ha(document, `livewire:init`),
    Ha(document, `livewire:initializing`),
    cl.default.plugin(ol.default),
    cl.default.plugin(Zc),
    cl.default.plugin(Ms.default),
    cl.default.plugin(Ns.default),
    cl.default.plugin(Ts.default),
    cl.default.plugin(Ps.default),
    cl.default.plugin(Es.default),
    cl.default.plugin(js),
    cl.default.plugin(Wc),
    cl.default.plugin(sl.default),
    cl.default.addRootSelector(() => `[wire\\:id]`),
    cl.default.onAttributesAdded((e, t) => {
      if (!Array.from(t).some((e) => _s(e.name))) return;
      let n = rs(e, !1);
      n &&
        t.forEach((t) => {
          if (!_s(t.name)) return;
          let r = vs(e, t.name);
          xo(`directive.init`, {
            el: e,
            component: n,
            directive: r,
            cleanup: (t) => {
              cl.default.onAttributeRemoved(e, r.raw, t);
            },
          });
        });
    }),
    cl.default.interceptInit(
      cl.default.skipDuringClone(
        (e) => {
          if (!Array.from(e.attributes).some((e) => _s(e.name))) return;
          if (e.hasAttribute(`wire:id`) && !e.__livewire && !ts(e.getAttribute(`wire:id`))) {
            let t = $o(e);
            cl.default.onAttributeRemoved(e, `wire:id`, () => {
              es(t.id);
            });
          }
          let t = Array.from(e.getAttributeNames())
            .filter((e) => _s(e))
            .map((t) => vs(e, t));
          t.forEach((t) => {
            xo(`directive.global.init`, {
              el: e,
              directive: t,
              cleanup: (n) => {
                cl.default.onAttributeRemoved(e, t.raw, n);
              },
            });
          });
          let n = rs(e, !1);
          n &&
            (xo(`element.init`, {
              el: e,
              component: n,
            }),
            t.forEach((t) => {
              xo(`directive.init`, {
                el: e,
                component: n,
                directive: t,
                cleanup: (n) => {
                  cl.default.onAttributeRemoved(e, t.raw, n);
                },
              });
            }));
        },
        (e) => {
          Array.from(e.attributes).some((e) => _s(e.name)) &&
            Array.from(e.getAttributeNames())
              .filter((e) => _s(e))
              .map((t) => vs(e, t))
              .forEach((t) => {
                xo(`directive.global.init`, {
                  el: e,
                  directive: t,
                  cleanup: (n) => {
                    cl.default.onAttributeRemoved(e, t.raw, n);
                  },
                });
              });
        },
      ),
    ),
    cl.default.start(),
    setTimeout(() => (window.Livewire.initialRenderIsFinished = !0)),
    Ha(document, `livewire:initialized`));
}
function ul() {
  let e = document.querySelector(`script[data-update-uri][data-csrf]`);
  if (!e) return;
  let t = e.closest(`[wire\\:id]`);
  t &&
    console.warn(
      `Livewire: missing closing tags found. Ensure your template elements contain matching closing tags.`,
      t,
    );
}
var dl = Q(ja());
$(`effect`, ({ component: e, effects: t }) => {
  fl(e, t.listeners || []);
});
function fl(e, t) {
  t.forEach((t) => {
    let n = (n) => {
      (n.__livewire && n.__livewire.receivedBy.push(e),
        e.$wire.call(`__dispatch`, t, n.detail || {}));
    };
    (window.addEventListener(t, n),
      e.addCleanup(() => window.removeEventListener(t, n)),
      e.el.addEventListener(t, (n) => {
        n.__livewire &&
          (n.bubbles ||
            (n.__livewire && n.__livewire.receivedBy.push(e.id),
            e.$wire.call(`__dispatch`, t, n.detail || {})));
      }));
  });
}
var pl = Q(ja()),
  ml = new WeakMap(),
  hl = new Set();
($(`payload.intercept`, async ({ assets: e }) => {
  if (e)
    for (let [t, n] of Object.entries(e))
      await vl(t, async () => {
        await yl(n);
      });
}),
  $(`component.init`, ({ component: e }) => {
    let t = e.snapshot.memo.assets;
    t &&
      t.forEach((e) => {
        hl.has(e) || hl.add(e);
      });
  }),
  $(`effect`, ({ component: e, effects: t }) => {
    let n = t.scripts;
    n &&
      Object.entries(n).forEach(([t, n]) => {
        gl(e, t, () => {
          let t = _l(n);
          pl.default.dontAutoEvaluateFunctions(() => {
            pl.default.evaluate(e.el, t, {
              $wire: e.$wire,
              $js: e.$wire.$js,
            });
          });
        });
      });
  }));
function gl(e, t, n) {
  if (ml.has(e) && ml.get(e).includes(t)) return;
  (n(), ml.has(e) || ml.set(e, []));
  let r = ml.get(e);
  (r.push(t), ml.set(e, r));
}
function _l(e) {
  let t = /<script\b[^>]*>([\s\S]*?)<\/script>/gm.exec(e);
  return t && t[1] ? t[1].trim() : ``;
}
async function vl(e, t) {
  hl.has(e) || (await t(), hl.add(e));
}
async function yl(e) {
  let t = new DOMParser().parseFromString(e, `text/html`),
    n = document.adoptNode(t.head);
  for (let e of n.children)
    try {
      await bl(e);
    } catch {}
}
async function bl(e) {
  return new Promise((t, n) => {
    if (xl(e)) {
      let r = Sl(e);
      (r.src ? ((r.onload = () => t()), (r.onerror = () => n())) : t(),
        document.head.appendChild(r));
    } else (document.head.appendChild(e), t());
  });
}
function xl(e) {
  return e.tagName.toLowerCase() === `script`;
}
function Sl(e) {
  let t = document.createElement(`script`);
  ((t.textContent = e.textContent), (t.async = e.async));
  for (let n of e.attributes) t.setAttribute(n.name, n.value);
  return t;
}
var Cl = Q(ja());
(Cl.default.magic(`js`, (e) => rs(e).$wire.js),
  $(`effect`, ({ component: e, effects: t }) => {
    let n = t.js,
      r = t.xjs;
    (n &&
      Object.entries(n).forEach(([t, n]) => {
        Xo(e, t, () => {
          Cl.default.evaluate(e.el, n);
        });
      }),
      r &&
        r.forEach(({ expression: t, params: n }) => {
          ((n = Object.values(n)),
            Cl.default.evaluate(e.el, t, {
              scope: e.jsActions,
              params: n,
            }));
        }));
  }));
var wl = Q(ja());
function Tl(e, t, n) {
  let r = t.parentElement ? t.parentElement.tagName.toLowerCase() : `div`,
    i = customElements.get(r);
  r = i ? i.name : r;
  let a = document.createElement(r);
  a.innerHTML = n;
  let o;
  try {
    o = rs(t.parentElement);
  } catch {}
  o && (a.__livewire = o);
  let s = a.firstElementChild;
  s.setAttribute(`wire:snapshot`, e.snapshotEncoded);
  let c = {
    ...e.effects,
  };
  (delete c.html,
    s.setAttribute(`wire:effects`, JSON.stringify(c)),
    (s.__livewire = e),
    xo(`morph`, {
      el: t,
      toEl: s,
      component: e,
    }));
  let l = {};
  (t.querySelectorAll(`[wire\\:id]`).forEach((e) => {
    l[e.getAttribute(`wire:id`)] = e;
  }),
    s.querySelectorAll(`[wire\\:id]`).forEach((e) => {
      if (e.hasAttribute(`wire:snapshot`)) return;
      let t = l[e.getAttribute(`wire:id`)];
      t && e.replaceWith(t.cloneNode(!0));
    }),
    wl.default.morph(t, s, {
      updating: (t, n, r, i, a) => {
        if (!El(t)) {
          if (
            (xo(`morph.updating`, {
              el: t,
              toEl: n,
              component: e,
              skip: i,
              childrenOnly: r,
              skipChildren: a,
            }),
            t.__livewire_replace === !0 && (t.innerHTML = n.innerHTML),
            t.__livewire_replace_self === !0)
          )
            return ((t.outerHTML = n.outerHTML), i());
          if (t.__livewire_ignore === !0) return i();
          if ((t.__livewire_ignore_self === !0 && r(), t.__livewire_ignore_children === !0))
            return a();
          if (Dl(t) && t.getAttribute(`wire:id`) !== e.id) return i();
          Dl(t) && (n.__livewire = e);
        }
      },
      updated: (t) => {
        El(t) ||
          xo(`morph.updated`, {
            el: t,
            component: e,
          });
      },
      removing: (t, n) => {
        El(t) ||
          xo(`morph.removing`, {
            el: t,
            component: e,
            skip: n,
          });
      },
      removed: (t) => {
        El(t) ||
          xo(`morph.removed`, {
            el: t,
            component: e,
          });
      },
      adding: (t) => {
        xo(`morph.adding`, {
          el: t,
          component: e,
        });
      },
      added: (e) => {
        El(e) ||
          (rs(e).id,
          xo(`morph.added`, {
            el: e,
          }));
      },
      key: (e) => {
        if (!El(e))
          return e.hasAttribute(`wire:key`)
            ? e.getAttribute(`wire:key`)
            : e.hasAttribute(`wire:id`)
              ? e.getAttribute(`wire:id`)
              : e.id;
      },
      lookahead: !1,
    }),
    xo(`morphed`, {
      el: t,
      component: e,
    }));
}
function El(e) {
  return typeof e.hasAttribute != `function`;
}
function Dl(e) {
  return e.hasAttribute(`wire:id`);
}
($(`effect`, ({ component: e, effects: t }) => {
  let n = t.html;
  n &&
    queueMicrotask(() => {
      queueMicrotask(() => {
        Tl(e, e.el, n);
      });
    });
}),
  $(`effect`, ({ component: e, effects: t }) => {
    queueMicrotask(() => {
      queueMicrotask(() => {
        queueMicrotask(() => {
          Ol(e, t.dispatches || []);
        });
      });
    });
  }));
function Ol(e, t) {
  t.forEach(({ name: t, params: n = {}, self: r = !1, to: i }) => {
    r ? ds(e, t, n) : i ? fs(i, t, n) : ls(e, t, n);
  });
}
var kl = Q(ja()),
  Al = new Ba();
($(`directive.init`, ({ el: e, directive: t, cleanup: n, component: r }) =>
  setTimeout(() => {
    t.value === `submit` &&
      e.addEventListener(`submit`, () => {
        let n = t.expression.startsWith(`$parent`) ? r.parent.id : r.id,
          i = jl(e);
        Al.add(n, i);
      });
  }),
),
  $(`commit`, ({ component: e, respond: t }) => {
    t(() => {
      (Al.each(e.id, (e) => e()), Al.remove(e.id));
    });
  }));
function jl(e) {
  let t = [];
  return (
    kl.default.walk(e, (n, r) => {
      if (e.contains(n)) {
        if (n.hasAttribute(`wire:ignore`)) return r();
        Ml(n) ? t.push(Pl(n)) : Nl(n) && t.push(Fl(n));
      }
    }),
    () => {
      for (; t.length > 0;) t.shift()();
    }
  );
}
function Ml(e) {
  let t = e.tagName.toLowerCase();
  return (
    t === `select` ||
    (t === `button` && e.type === `submit`) ||
    (t === `input` && (e.type === `checkbox` || e.type === `radio`))
  );
}
function Nl(e) {
  return [`input`, `textarea`].includes(e.tagName.toLowerCase());
}
function Pl(e) {
  let t = e.disabled ? () => {} : () => (e.disabled = !1);
  return ((e.disabled = !0), t);
}
function Fl(e) {
  let t = e.readOnly ? () => {} : () => (e.readOnly = !1);
  return ((e.readOnly = !0), t);
}
($(`commit.pooling`, ({ commits: e }) => {
  e.forEach((e) => {
    let t = e.component;
    zl(t, (e) => {
      e.$wire.$commit();
    });
  });
}),
  $(`commit.pooled`, ({ pools: e }) => {
    Il(e).forEach((t) => {
      let n = t.component;
      zl(n, (t) => {
        Ll(e, n, t);
      });
    });
  }));
function Il(e) {
  let t = [];
  return (
    e.forEach((e) => {
      e.commits.forEach((e) => {
        t.push(e);
      });
    }),
    t
  );
}
function Ll(e, t, n) {
  let r = Rl(e, t),
    i = Rl(e, n);
  if (!i) return;
  let a = i.findCommitByComponent(n);
  (i.delete(a),
    r.add(a),
    e.forEach((t) => {
      t.empty() && e.delete(t);
    }));
}
function Rl(e, t) {
  for (let [n, r] of e.entries()) if (r.hasCommitFor(t)) return r;
}
function zl(e, t) {
  Hl(e, (e) => {
    (e.isLazy && !e.hasBeenLazyLoaded) || ((Bl(e) || Vl(e)) && t(e));
  });
}
function Bl(e) {
  return !!e.snapshot.memo.props;
}
function Vl(e) {
  return !!e.snapshot.memo.bindings;
}
function Hl(e, t) {
  e.children.forEach((e) => {
    (t(e), Hl(e, t));
  });
}
$(`commit`, ({ succeed: e }) => {
  e(({ effects: e }) => {
    let t = e.download;
    if (!t) return;
    let n = window.webkitURL || window.URL,
      r = n.createObjectURL(Ul(t.content, t.contentType)),
      i = document.createElement(`a`);
    ((i.style.display = `none`),
      (i.href = r),
      (i.download = t.name),
      document.body.appendChild(i),
      i.click(),
      setTimeout(function () {
        n.revokeObjectURL(r);
      }, 0));
  });
});
function Ul(e, t = ``, n = 512) {
  let r = atob(e),
    i = [];
  t === null && (t = ``);
  for (let e = 0; e < r.length; e += n) {
    let t = r.slice(e, e + n),
      a = Array(t.length);
    for (let e = 0; e < t.length; e++) a[e] = t.charCodeAt(e);
    let o = new Uint8Array(a);
    i.push(o);
  }
  return new Blob(i, {
    type: t,
  });
}
var Wl = new WeakSet(),
  Gl = new WeakSet();
($(`component.init`, ({ component: e }) => {
  let t = e.snapshot.memo;
  t.lazyLoaded !== void 0 &&
    (Gl.add(e), t.lazyIsolated !== void 0 && t.lazyIsolated === !1 && Wl.add(e));
}),
  $(`commit.pooling`, ({ commits: e }) => {
    e.forEach((e) => {
      Gl.has(e.component) &&
        (Wl.has(e.component) ? ((e.isolate = !1), Wl.delete(e.component)) : (e.isolate = !0),
        Gl.delete(e.component));
    });
  }));
var Kl = Q(ja());
$(`effect`, ({ component: e, effects: t, cleanup: n }) => {
  let r = t.url;
  r &&
    Object.entries(r).forEach(([t, r]) => {
      let { name: i, as: a, use: o, alwaysShow: s, except: c } = ql(t, r);
      a ||= i;
      let l = [!1, null, void 0].includes(c) ? Xa(e.ephemeral, i) : c,
        { replace: u, push: d, pop: f } = Qc(a, l, s, c);
      if (o === `replace`) {
        let t = Kl.default.effect(() => {
          u(Xa(e.reactive, i));
        });
        n(() => Kl.default.release(t));
      } else if (o === `push`) {
        let t = $(`commit`, ({ component: t, succeed: n }) => {
            if (e !== t) return;
            let r = Xa(e.canonical, i);
            n(() => {
              let t = Xa(e.canonical, i);
              JSON.stringify(r) !== JSON.stringify(t) && d(t);
            });
          }),
          r = f(async (t) => {
            (await e.$wire.set(i, t),
              document.querySelectorAll(`input`).forEach((e) => {
                e._x_forceModelUpdate && e._x_forceModelUpdate(e._x_model.get());
              }));
          });
        n(() => {
          (t(), r());
        });
      }
    });
});
function ql(e, t) {
  let n = {
    use: `replace`,
    alwaysShow: !1,
  };
  return typeof t == `string`
    ? {
        ...n,
        name: t,
        as: t,
      }
    : {
        ...n,
        name: e,
        as: e,
        ...t,
      };
}
($(`request`, ({ options: e }) => {
  window.Echo && (e.headers[`X-Socket-ID`] = window.Echo.socketId());
}),
  $(`effect`, ({ component: e, effects: t }) => {
    (t.listeners || []).forEach((t) => {
      if (t.startsWith(`echo`)) {
        if (window.Echo === void 0) {
          console.warn(`Laravel Echo cannot be found`);
          return;
        }
        let n = t.split(/(echo:|echo-)|:|,/);
        (n[1] == `echo:` && n.splice(2, 0, `channel`, void 0),
          n[2] == `notification` && n.push(void 0, void 0));
        let [r, i, a, o, s, c, l] = n;
        if ([`channel`, `private`, `encryptedPrivate`].includes(a)) {
          let n = (n) => ds(e, t, [n]);
          (window.Echo[a](s).listen(l, n),
            e.addCleanup(() => {
              window.Echo[a](s).stopListening(l, n);
            }));
        } else
          a == `presence`
            ? [`here`, `joining`, `leaving`].includes(l)
              ? window.Echo.join(s)[l]((n) => {
                  ds(e, t, [n]);
                })
              : (window.Echo.join(s).listen(l, (n) => ds(e, t, [n])),
                e.addCleanup(() => {
                  window.Echo.leaveChannel(s);
                }))
            : a == `notification`
              ? window.Echo.private(s).notification((n) => {
                  ds(e, t, [n]);
                })
              : console.warn(`Echo channel type not yet supported`);
      }
    });
  }));
var Jl = new WeakSet();
($(`component.init`, ({ component: e }) => {
  e.snapshot.memo.isolate === !0 && Jl.add(e);
}),
  $(`commit.pooling`, ({ commits: e }) => {
    e.forEach((e) => {
      Jl.has(e.component) && (e.isolate = !0);
    });
  }),
  Zl() && Alpine.navigate.disableProgressBar(),
  document.addEventListener(`alpine:navigate`, (e) => Yl(`livewire:navigate`, e)),
  document.addEventListener(`alpine:navigating`, (e) => Yl(`livewire:navigating`, e)),
  document.addEventListener(`alpine:navigated`, (e) => Yl(`livewire:navigated`, e)));
function Yl(e, t) {
  let n = new CustomEvent(e, {
    cancelable: !0,
    bubbles: !0,
    detail: t.detail,
  });
  (document.dispatchEvent(n), n.defaultPrevented && t.preventDefault());
}
function Xl(e, t, n) {
  e.redirectUsingNavigate ? Alpine.navigate(t) : n();
}
function Zl() {
  return !!(
    document.querySelector(`[data-no-progress-bar]`) ||
    (window.livewireScriptConfig && window.livewireScriptConfig.progressBar === !1)
  );
}
$(`effect`, ({ effects: e }) => {
  if (!e.redirect) return;
  let t = e.redirect;
  Xl(e, t, () => {
    window.location.href = t;
  });
});
var Ql = Q(ja());
($(`morph.added`, ({ el: e }) => {
  e.__addedByMorph = !0;
}),
  ys(`transition`, ({ el: e, directive: t, component: n, cleanup: r }) => {
    for (let n = 0; n < e.attributes.length; n++)
      if (e.attributes[n].name.startsWith(`wire:show`)) {
        Ql.default.bind(e, {
          [t.rawName.replace(`wire:transition`, `x-transition`)]: t.expression,
        });
        return;
      }
    let i = Ql.default.reactive({
      state: !e.__addedByMorph,
    });
    (Ql.default.bind(e, {
      [t.rawName.replace(`wire:`, `x-`)]: ``,
      "x-show"() {
        return i.state;
      },
    }),
      e.__addedByMorph && setTimeout(() => (i.state = !0)));
    let a = [];
    (a.push(
      $(`morph.removing`, ({ el: e, skip: t }) => {
        (t(),
          e.addEventListener(`transitionend`, () => {
            e.remove();
          }),
          (i.state = !1),
          a.push(
            $(`morph`, ({ component: t }) => {
              t === n && (e.remove(), a.forEach((e) => e()));
            }),
          ));
      }),
    ),
      r(() => a.forEach((e) => e())));
  }));
var $l = new Va();
function eu(e, t) {
  ($l.each(e, (e) => {
    (e.callback(), (e.callback = () => {}));
  }),
    t());
}
var tu = Q(ja());
$(`directive.init`, ({ el: e, directive: t, cleanup: n, component: r }) => {
  if (
    [
      `snapshot`,
      `effects`,
      `model`,
      `init`,
      `loading`,
      `poll`,
      `ignore`,
      `id`,
      `data`,
      `key`,
      `target`,
      `dirty`,
    ].includes(t.value) ||
    Ss(t.value)
  )
    return;
  let i = t.rawName.replace(`wire:`, `x-on:`);
  (t.value === `submit` && !t.modifiers.includes(`prevent`) && (i += `.prevent`),
    n(
      tu.default.bind(e, {
        [i](n) {
          let i = () => {
            eu(r, () => {
              tu.default.evaluate(e, `$wire.` + t.expression, {
                scope: {
                  $event: n,
                },
              });
            });
          };
          e.__livewire_confirm
            ? e.__livewire_confirm(
                () => {
                  i();
                },
                () => {
                  n.stopImmediatePropagation();
                },
              )
            : i();
        },
      }),
    ));
});
var nu = Q(ja());
(nu.default.addInitSelector(() => `[wire\\:navigate]`),
  nu.default.addInitSelector(() => `[wire\\:navigate\\.hover]`),
  nu.default.addInitSelector(() => `[wire\\:navigate\\.preserve-scroll]`),
  nu.default.addInitSelector(() => `[wire\\:navigate\\.preserve-scroll\\.hover]`),
  nu.default.addInitSelector(() => `[wire\\:navigate\\.hover\\.preserve-scroll]`),
  nu.default.interceptInit(
    nu.default.skipDuringClone((e) => {
      e.hasAttribute(`wire:navigate`)
        ? nu.default.bind(e, {
            "x-navigate": !0,
          })
        : e.hasAttribute(`wire:navigate.hover`)
          ? nu.default.bind(e, {
              "x-navigate.hover": !0,
            })
          : e.hasAttribute(`wire:navigate.preserve-scroll`)
            ? nu.default.bind(e, {
                "x-navigate.preserve-scroll": !0,
              })
            : e.hasAttribute(`wire:navigate.preserve-scroll.hover`)
              ? nu.default.bind(e, {
                  "x-navigate.preserve-scroll.hover": !0,
                })
              : e.hasAttribute(`wire:navigate.hover.preserve-scroll`) &&
                nu.default.bind(e, {
                  "x-navigate.hover.preserve-scroll": !0,
                });
    }),
  ),
  document.addEventListener(`alpine:navigating`, () => {
    Livewire.all().forEach((e) => {
      e.inscribeSnapshotAndEffectsOnElement();
    });
  }),
  ys(`confirm`, ({ el: e, directive: t }) => {
    let n = t.expression,
      r = t.modifiers.includes(`prompt`);
    ((n = n.replaceAll(
      `\\n`,
      `
`,
    )),
      n === `` && (n = `Are you sure?`),
      (e.__livewire_confirm = (e, t) => {
        if (r) {
          let [r, i] = n.split(`|`);
          i
            ? prompt(r) === i
              ? e()
              : t()
            : console.warn(`Livewire: Must provide expectation with wire:confirm.prompt`);
        } else confirm(n) ? e() : t();
      }));
  }),
  Q(ja()).default.addInitSelector(() => `[wire\\:current]`));
var ru = new Map();
(document.addEventListener(`livewire:navigated`, () => {
  ru.forEach((e) => e(new URL(window.location.href)));
}),
  bs(`current`, ({ el: e, directive: t, cleanup: n }) => {
    let r = t.expression,
      i = {
        exact: t.modifiers.includes(`exact`),
        strict: t.modifiers.includes(`strict`),
        ignore: t.modifiers.includes(`ignore`),
      };
    if (i.ignore || r.startsWith(`#`) || !e.hasAttribute(`href`)) return;
    let a = e.getAttribute(`href`),
      o = new URL(a, window.location.href),
      s = r.split(` `).filter(String),
      c = (t) => {
        iu(o, t, i)
          ? (e.classList.add(...s), e.setAttribute(`data-current`, ``))
          : (e.classList.remove(...s), e.removeAttribute(`data-current`));
      };
    (c(new URL(window.location.href)), ru.set(e, c), n(() => ru.delete(e)));
  }));
function iu(e, t, n) {
  if (e.hostname !== t.hostname) return !1;
  let r = n.strict ? e.pathname : e.pathname.replace(/\/+$/, ``),
    i = n.strict ? t.pathname : t.pathname.replace(/\/+$/, ``);
  if (n.exact) return r === i;
  let a = r.split(`/`),
    o = i.split(`/`);
  for (let e = 0; e < a.length; e++) if (a[e] !== o[e]) return !1;
  return !0;
}
function au(e, t, n, r = null) {
  if (((n = t.modifiers.includes(`remove`) ? !n : n), t.modifiers.includes(`class`))) {
    let r = t.expression.split(` `).filter(String);
    n ? e.classList.add(...r) : e.classList.remove(...r);
  } else if (t.modifiers.includes(`attr`))
    n ? e.setAttribute(t.expression, !0) : e.removeAttribute(t.expression);
  else {
    let i = r ?? window.getComputedStyle(e, null).getPropertyValue(`display`),
      a =
        [`inline`, `block`, `table`, `flex`, `grid`, `inline-flex`].filter((e) =>
          t.modifiers.includes(e),
        )[0] || `inline-block`;
    ((a = t.modifiers.includes(`remove`) && !n ? i : a), (e.style.display = n ? a : `none`));
  }
}
var ou = new Set(),
  su = new Set();
(window.addEventListener(`offline`, () => ou.forEach((e) => e())),
  window.addEventListener(`online`, () => su.forEach((e) => e())),
  ys(`offline`, ({ el: e, directive: t, cleanup: n }) => {
    let r = () => au(e, t, !0),
      i = () => au(e, t, !1);
    (ou.add(r),
      su.add(i),
      n(() => {
        (ou.delete(r), su.delete(i));
      }));
  }),
  ys(`loading`, ({ el: e, directive: t, component: n, cleanup: r }) => {
    let { targets: i, inverted: a } = fu(e),
      [o, s] = cu(t),
      c = lu(n, i, a, [() => o(() => au(e, t, !0)), () => s(() => au(e, t, !1))]),
      l = uu(n, i, [() => o(() => au(e, t, !0)), () => s(() => au(e, t, !1))]);
    r(() => {
      (c(), l());
    });
  }));
function cu(e) {
  if (!e.modifiers.includes(`delay`) || e.modifiers.includes(`none`))
    return [(e) => e(), (e) => e()];
  let t = 200,
    n = {
      shortest: 50,
      shorter: 100,
      short: 150,
      default: 200,
      long: 300,
      longer: 500,
      longest: 1e3,
    };
  Object.keys(n).some((r) => {
    if (e.modifiers.includes(r)) return ((t = n[r]), !0);
  });
  let r,
    i = !1;
  return [
    (e) => {
      r = setTimeout(() => {
        (e(), (i = !0));
      }, t);
    },
    async (e) => {
      i ? (await e(), (i = !1)) : clearTimeout(r);
    },
  ];
}
function lu(e, t, n, [r, i]) {
  return $(`commit`, ({ component: a, commit: o, respond: s }) => {
    a === e &&
      ((t.length > 0 && du(o, t) === n) ||
        (r(),
        s(() => {
          i();
        })));
  });
}
function uu(e, t, [n, r]) {
  let i = (n) => {
      let { id: r, property: i } = n.detail;
      return r !== e.id || (t.length > 0 && !t.map((e) => e.target).includes(i));
    },
    a = Ua(window, `livewire-upload-start`, (e) => {
      i(e) || n();
    }),
    o = Ua(window, `livewire-upload-finish`, (e) => {
      i(e) || r();
    }),
    s = Ua(window, `livewire-upload-error`, (e) => {
      i(e) || r();
    });
  return () => {
    (a(), o(), s());
  };
}
function du(e, t) {
  let { updates: n, calls: r } = e;
  return t.some(({ target: e, params: t }) => {
    if (t) return r.some(({ method: n, params: r }) => e === n && t === pu(JSON.stringify(r)));
    if (
      Object.keys(n).some((t) => (t.includes(`.`) && t.split(`.`)[0] === e ? !0 : t === e)) ||
      r.map((e) => e.method).includes(e)
    )
      return !0;
  });
}
function fu(e) {
  let t = xs(e),
    n = [],
    r = !1;
  if (t.has(`target`)) {
    let e = t.get(`target`);
    (e.modifiers.includes(`except`) && (r = !0),
      e.methods.forEach(({ method: e, params: t }) => {
        n.push({
          target: e,
          params: t && t.length > 0 ? pu(JSON.stringify(t)) : void 0,
        });
      }));
  } else {
    let e = [`init`, `dirty`, `offline`, `target`, `loading`, `poll`, `ignore`, `key`, `id`];
    t.all()
      .filter((t) => !e.includes(t.value))
      .map((e) => e.expression.split(`(`)[0])
      .forEach((e) =>
        n.push({
          target: e,
        }),
      );
  }
  return {
    targets: n,
    inverted: r,
  };
}
function pu(e) {
  return btoa(encodeURIComponent(e));
}
(ys(`stream`, ({ el: e, directive: t, cleanup: n }) => {
  let { expression: r, modifiers: i } = t;
  n(
    $(`stream`, ({ name: t, content: n, replace: a }) => {
      t === r &&
        (i.includes(`replace`) || a ? (e.innerHTML = n) : e.insertAdjacentHTML(`beforeend`, n));
    }),
  );
}),
  $(`request`, ({ respond: e }) => {
    e((e) => {
      let t = e.response;
      t.headers.has(`X-Livewire-Stream`) &&
        (e.response = {
          ok: !0,
          redirected: !1,
          status: 200,
          async text() {
            let e = await mu(t, (e) => {
              xo(`stream`, e);
            });
            return (ao(e) && (this.ok = !1), e);
          },
        });
    });
  }));
async function mu(e, t) {
  let n = e.body.getReader(),
    r = ``;
  for (;;) {
    let { done: e, value: i } = await n.read(),
      a = new TextDecoder().decode(i),
      [o, s] = hu(r + a);
    if (
      (o.forEach((e) => {
        t(e);
      }),
      (r = s),
      e)
    )
      return r;
  }
}
function hu(e) {
  let t = /({"stream":true.*?"endStream":true})/g,
    n = e.match(t),
    r = [];
  if (n) for (let e = 0; e < n.length; e++) r.push(JSON.parse(n[e]).body);
  return [r, e.replace(t, ``)];
}
(ys(`replace`, ({ el: e, directive: t }) => {
  t.modifiers.includes(`self`) ? (e.__livewire_replace_self = !0) : (e.__livewire_replace = !0);
}),
  ys(`ignore`, ({ el: e, directive: t }) => {
    t.modifiers.includes(`self`)
      ? (e.__livewire_ignore_self = !0)
      : t.modifiers.includes(`children`)
        ? (e.__livewire_ignore_children = !0)
        : (e.__livewire_ignore = !0);
  }));
var gu = Q(ja());
gu.default.interceptInit((e) => {
  e.hasAttribute(`wire:cloak`) && gu.default.mutateDom(() => e.removeAttribute(`wire:cloak`));
});
var _u = new Va();
($(`commit`, ({ component: e, respond: t }) => {
  t(() => {
    setTimeout(() => {
      _u.each(e, (e) => e(!1));
    });
  });
}),
  ys(`dirty`, ({ el: e, directive: t, component: n }) => {
    let r = vu(e),
      i = !1,
      a = e.style.display,
      o = (n) => {
        (au(e, t, n, a), (i = n));
      };
    (_u.add(n, o),
      Alpine.effect(() => {
        let e = !1;
        if (r.length === 0) e = JSON.stringify(n.canonical) !== JSON.stringify(n.reactive);
        else
          for (let t = 0; t < r.length && !e; t++) {
            let i = r[t];
            e = JSON.stringify(Xa(n.canonical, i)) !== JSON.stringify(Xa(n.reactive, i));
          }
        (i !== e && o(e), (i = e));
      }));
  }));
function vu(e) {
  let t = xs(e),
    n = [];
  return (
    t.has(`model`) && n.push(t.get(`model`).expression),
    t.has(`target`) &&
      (n = n.concat(
        t
          .get(`target`)
          .expression.split(`,`)
          .map((e) => e.trim()),
      )),
    n
  );
}
var yu = Q(ja());
ys(`model`, ({ el: e, directive: t, component: n, cleanup: r }) => {
  let { expression: i, modifiers: a } = t;
  if (!i) return console.warn(`Livewire: [wire:model] is missing a value.`, e);
  if (Su(n, i))
    return console.warn(
      `Livewire: [wire:model="` + i + `"] property does not exist on component: [` + n.name + `]`,
      e,
    );
  if (e.type && e.type.toLowerCase() === `file`) return lo(e, i, n, r);
  let o = a.includes(`live`),
    s = a.includes(`lazy`) || a.includes(`change`),
    c = a.includes(`blur`),
    l = a.includes(`debounce`),
    u = i.startsWith(`$parent`) ? () => n.$wire.$parent.$commit() : () => n.$wire.$commit(),
    d = xu(e) && !l && o ? Cu(u, 150) : u;
  yu.default.bind(e, {
    "@change"() {
      s && u();
    },
    "@blur"() {
      c && u();
    },
    [`x-model` + bu(a)]() {
      return {
        get() {
          return Xa(n.$wire, i);
        },
        set(e) {
          (Za(n.$wire, i, e), o && !s && !c && d());
        },
      };
    },
  });
});
function bu(e) {
  return (
    (e = e.filter((e) => ![`lazy`, `defer`].includes(e))),
    e.length === 0 ? `` : `.` + e.join(`.`)
  );
}
function xu(e) {
  return (
    ([`INPUT`, `TEXTAREA`].includes(e.tagName.toUpperCase()) &&
      ![`checkbox`, `radio`].includes(e.type)) ||
    e.tagName.toUpperCase() === `UI-SLIDER`
  );
}
function Su(e, t) {
  if (t.startsWith(`$parent`)) {
    let n = rs(e.el.parentElement, !1);
    return n ? Su(n, t.split(`$parent.`)[1]) : !0;
  }
  let n = t.split(`.`)[0];
  return !Object.keys(e.canonical).includes(n);
}
function Cu(e, t) {
  var n;
  return function () {
    var r = this,
      i = arguments;
    (clearTimeout(n),
      (n = setTimeout(function () {
        ((n = null), e.apply(r, i));
      }, t)));
  };
}
var wu = Q(ja());
ys(`init`, ({ el: e, directive: t }) => {
  let n = t.expression ?? `$refresh`;
  wu.default.evaluate(e, `$wire.${n}`);
});
var Tu = Q(ja());
ys(`poll`, ({ el: e, directive: t }) => {
  let {
    start: n,
    pauseWhile: r,
    throttleWhile: i,
    stopWhen: a,
  } = Du(
    () => {
      Eu(e, t);
    },
    zu(t.modifiers, 2e3),
  );
  (n(),
    i(() => Nu() && Fu(t)),
    r(() => Iu(t) && Lu(e)),
    r(() => Pu(e)),
    r(() => ju()),
    a(() => Ru(e)));
});
function Eu(e, t) {
  Tu.default.evaluate(e, t.expression ? `$wire.` + t.expression : `$wire.$commit()`);
}
function Du(e, t = 2e3) {
  let n = [],
    r = [],
    i = [];
  return {
    start() {
      let a = ku(t, () => {
        if (i.some((e) => e())) return a();
        n.some((e) => e()) || (r.some((e) => e()) && Math.random() < 0.95) || e();
      });
    },
    pauseWhile(e) {
      n.push(e);
    },
    throttleWhile(e) {
      r.push(e);
    },
    stopWhen(e) {
      i.push(e);
    },
  };
}
var Ou = [];
function ku(e, t) {
  if (!Ou[e]) {
    let t = {
      timer: setInterval(() => t.callbacks.forEach((e) => e()), e),
      callbacks: new Set(),
    };
    Ou[e] = t;
  }
  return (
    Ou[e].callbacks.add(t),
    () => {
      (Ou[e].callbacks.delete(t),
        Ou[e].callbacks.size === 0 && (clearInterval(Ou[e].timer), delete Ou[e]));
    }
  );
}
var Au = !1;
(window.addEventListener(`offline`, () => (Au = !0)),
  window.addEventListener(`online`, () => (Au = !1)));
function ju() {
  return Au;
}
var Mu = !1;
document.addEventListener(
  `visibilitychange`,
  () => {
    Mu = document.hidden;
  },
  !1,
);
function Nu() {
  return Mu;
}
function Pu(e) {
  return !xs(e).has(`poll`);
}
function Fu(e) {
  return !e.modifiers.includes(`keep-alive`);
}
function Iu(e) {
  return e.modifiers.includes(`visible`);
}
function Lu(e) {
  let t = e.getBoundingClientRect();
  return !(
    t.top < (window.innerHeight || document.documentElement.clientHeight) &&
    t.left < (window.innerWidth || document.documentElement.clientWidth) &&
    t.bottom > 0 &&
    t.right > 0
  );
}
function Ru(e) {
  return e.isConnected === !1;
}
function zu(e, t) {
  let n,
    r = e.find((e) => e.match(/([0-9]+)ms/)),
    i = e.find((e) => e.match(/([0-9]+)s/));
  return (
    r ? (n = Number(r.replace(`ms`, ``))) : i && (n = Number(i.replace(`s`, ``)) * 1e3),
    n || t
  );
}
var Bu = Q(ja());
Bu.default.interceptInit((e) => {
  for (let t = 0; t < e.attributes.length; t++)
    if (e.attributes[t].name.startsWith(`wire:show`)) {
      let { name: n, value: r } = e.attributes[t],
        i = n.split(`wire:show`)[1],
        a = r.startsWith(`!`) ? `!$wire.` + r.slice(1).trim() : `$wire.` + r.trim();
      Bu.default.bind(e, {
        [`x-show` + i]() {
          return Bu.default.evaluate(e, a);
        },
      });
    }
});
var Vu = Q(ja());
Vu.default.interceptInit((e) => {
  for (let t = 0; t < e.attributes.length; t++)
    if (e.attributes[t].name.startsWith(`wire:text`)) {
      let { name: n, value: r } = e.attributes[t],
        i = n.split(`wire:text`)[1],
        a = r.startsWith(`!`) ? `!$wire.` + r.slice(1).trim() : `$wire.` + r.trim();
      Vu.default.bind(e, {
        [`x-text` + i]() {
          return Vu.default.evaluate(e, a);
        },
      });
    }
});
var Hu = {
    directive: ys,
    dispatchTo: fs,
    start: ll,
    first: ss,
    find: os,
    getByName: as,
    all: cs,
    hook: $,
    trigger: xo,
    triggerAsync: So,
    dispatch: us,
    on: ms,
    get navigate() {
      return dl.default.navigate;
    },
  },
  Uu = (e) => console.warn(`Detected multiple instances of ${e} running`);
(window.Livewire && Uu(`Livewire`),
  window.Alpine && Uu(`Alpine`),
  (window.Livewire = Hu),
  (window.Alpine = dl.default),
  window.livewireScriptConfig === void 0 &&
    ((window.Alpine.__fromLivewire = !0),
    document.addEventListener(`DOMContentLoaded`, () => {
      (window.Alpine.__fromLivewire === void 0 && Uu(`Alpine`), Hu.start());
    })));
var Wu = dl.default,
  Gu = () => {},
  Ku = (e, t = void 0) => (
    typeof e == `function` && (e = e()),
    typeof e == `object` && (e = JSON.stringify(e)),
    t === void 0
      ? window.navigator.clipboard.writeText(e).then(Gu)
      : window.navigator.clipboard
          .write([
            new ClipboardItem({
              [t]: new Blob([e], {
                type: t,
              }),
            }),
          ])
          .then(Gu)
  );
function qu(e) {
  (e.magic(`clipboard`, () => Ku),
    e.directive(
      `clipboard`,
      (e, { modifiers: t, expression: n }, { evaluateLater: r, cleanup: i }) => {
        let a = t.includes(`raw`) ? (e) => e(n) : r(n),
          o = () => a(Ku);
        (e.addEventListener(`click`, o),
          i(() => {
            e.removeEventListener(`click`, o);
          }));
      },
    ));
}
((qu.configure = (e) => (
  e.hasOwnProperty(`onCopy`) && typeof e.onCopy == `function` && (Gu = e.onCopy),
  qu
)),
  Wu.plugin(qu),
  Hu.start());
